var M4 = Object.defineProperty;
var P4 = (e, t, n) => t in e ? M4(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n;
var ss = (e, t, n) => (P4(e, typeof t != "symbol" ? t + "" : t, n), n);
import * as Y from "react";
import Te, { forwardRef as at, useContext as ke, createContext as Yn, useLayoutEffect as Gn, useEffect as oe, useRef as Z, useInsertionEffect as lo, useCallback as Ct, useMemo as $e, createElement as fo, useId as hl, useState as me, cloneElement as Rg, Children as Ou, isValidElement as Pi, useImperativeHandle as R4, Fragment as Bg, useReducer as B4, PureComponent as F4, startTransition as H4 } from "react";
import { jsx as E, jsxs as ue, Fragment as on } from "react/jsx-runtime";
import U, { clsx as $4 } from "clsx";
import { css as B, jsx as W, useTheme as ln, keyframes as po } from "@emotion/react";
import { PAYPAL_THEME as vr } from "@paypalcorp/pp-react-theme";
import { CheckmarkIcon as ml, CloseIcon as Fg, ChevronUpIcon as V4, ChevronDownIcon as j4, DownloadIcon as z4, PlayIcon as U4, RefreshIcon as q4, iconStyles as G4, VerifiedIcon as W4, QuestionIcon as K4 } from "@paypalcorp/pp-react-icons";
import gl, { createPortal as Y4 } from "react-dom";
const Z4 = "fastlane-palette", od = "ppe-palette", Sa = "ppui30-palette", yn = Te.createContext({
  foundationGrid: "regular",
  foundationFont: "default",
  foundationTheme: "regular",
  foundationColor: Sa,
  foundationConfig: {
    mediaFrame: {
      roundedCorners: !0
    }
  }
}), X4 = (e) => {
  switch (e) {
    case "fastlane":
      return {
        foundationTheme: "ppe",
        foundationColor: Z4,
        foundationGrid: "compact",
        foundationFont: "supreme",
        foundationConfig: {
          mediaFrame: {
            roundedCorners: !0
          }
        }
      };
    case "ppe":
      return {
        foundationTheme: "ppe",
        foundationColor: od,
        foundationGrid: "compact",
        foundationFont: "supreme",
        foundationConfig: {
          mediaFrame: {
            roundedCorners: !1
          }
        }
      };
    case "quantumLeapSupreme":
      return {
        foundationTheme: "quantum-leap-supreme",
        foundationColor: od,
        foundationGrid: "compact",
        foundationFont: "supreme",
        foundationConfig: {
          mediaFrame: {
            roundedCorners: !1
          }
        }
      };
    case "quantumLeap":
      return {
        foundationTheme: "quantum-leap",
        foundationColor: Sa,
        foundationGrid: "compact",
        foundationFont: "quantum-leap",
        foundationConfig: {
          mediaFrame: {
            roundedCorners: !0
          }
        }
      };
    case "compact":
      return {
        foundationTheme: "compact",
        foundationColor: Sa,
        foundationGrid: "compact",
        foundationFont: "default",
        foundationConfig: {
          mediaFrame: {
            roundedCorners: !0
          }
        }
      };
    default:
      return {
        foundationTheme: "regular",
        foundationColor: Sa,
        foundationGrid: "regular",
        foundationFont: "default",
        foundationConfig: {
          mediaFrame: {
            roundedCorners: !0
          }
        }
      };
  }
}, Qi = (e) => parseFloat(e), pc = (e, t) => e.reduce(
  (n, r) => ({ ...n, [r]: t }),
  {}
), Q4 = (e, t, n, r) => {
  const u = (r - n) / (t - e), i = -(e * u) + n, a = u * 100, o = `clamp(${n}rem, ${i}rem + ${a}vw, ${r}rem)`, s = `min(max(${n}rem, ${i}rem + ${a}vw), ${r}rem)`;
  return {
    clampValue: o,
    clampValueFallback: s
  };
}, J4 = (e, t, n, r, u) => {
  const i = Qi(e), a = Qi(t), o = Qi(n), s = Qi(r), { clampValue: c, clampValueFallback: l } = Q4(
    i,
    a,
    o,
    s
  ), d = pc(
    u,
    c
  ), f = pc(
    u,
    l
  );
  return {
    ...d,
    [`@supports not (font-size: ${c})`]: f
  };
}, sd = {
  min: "64rem",
  max: "120rem"
}, cd = {
  xs: { minSize: "0.5rem", maxSize: "1.2rem" },
  sm: { minSize: "1rem", maxSize: "2.40rem" },
  md: { minSize: "2rem", maxSize: "4.80rem" },
  lg: { minSize: "3rem", maxSize: "7.20rem" },
  xl: { minSize: "4rem", maxSize: "9.60rem" },
  "2xl": { minSize: "6rem", maxSize: "14.40rem" },
  "3xl": { minSize: "8rem", maxSize: "19.20rem" },
  "4xl": { minSize: "10rem", maxSize: "24.00rem" },
  "5xl": { minSize: "12rem", maxSize: "28.80rem" },
  "6xl": { minSize: "14rem", maxSize: "33.60rem" },
  "7xl": { minSize: "15rem", maxSize: "36.00rem" },
  "8xl": { minSize: "16rem", maxSize: "38.40rem" }
}, ex = {
  "0vw": "none",
  "2vw": "sm",
  "4vw": "md",
  "6vw": "lg",
  "8vw": "xl",
  "12vw": "2xl",
  "16vw": "3xl",
  "20vw": "4xl",
  "24vw": "5xl",
  "28vw": "6xl",
  "30vw": "7xl",
  "32vw": "8xl",
  inherit: "inherit"
}, tx = {
  "0vw": "none",
  "2vw": "xs",
  "4vw": "sm",
  "6vw": "md",
  "8vw": "lg",
  "12vw": "xl",
  "16vw": "2xl",
  "20vw": "3xl",
  "24vw": "4xl",
  "28vw": "5xl",
  "30vw": "6xl",
  "32vw": "7xl",
  inherit: "inherit"
}, nx = {
  none: "none",
  xs: "xs",
  sm: "xs",
  md: "sm",
  lg: "md",
  xl: "lg",
  "2xl": "xl",
  "3xl": "2xl",
  "4xl": "3xl",
  "5xl": "4xl",
  "6xl": "5xl",
  "7xl": "6xl",
  "8xl": "7xl",
  inherit: "inherit"
}, fn = (e) => {
  const t = sd.min, n = sd.max, { minSize: r } = cd[e], { maxSize: u } = cd[e];
  return (i) => J4(
    t,
    n,
    r,
    u,
    i
  );
}, hc = (e) => {
  const t = e === "none" ? 0 : e;
  return (n) => pc(n, t);
}, rx = {
  inherit: hc("inherit"),
  none: hc("none"),
  xs: fn("xs"),
  sm: fn("sm"),
  md: fn("md"),
  lg: fn("lg"),
  xl: fn("xl"),
  "2xl": fn("2xl"),
  "3xl": fn("3xl"),
  "4xl": fn("4xl"),
  "5xl": fn("5xl"),
  "6xl": fn("6xl"),
  "7xl": fn("7xl"),
  "8xl": fn("8xl")
}, ux = ({ key: e, gridTheme: t }) => {
  if (t === "compact") {
    const r = tx[e] ?? nx[e];
    if (r)
      return r;
  }
  return ex[e] ?? e;
}, Lr = (e, t, n) => {
  const r = ux({ key: e, gridTheme: n });
  return (rx[r] || hc(r))(t);
}, ut = {
  sm: "23.4375rem",
  md: "41.0625rem",
  lg: "64rem",
  xl: "91.875rem",
  "2xl": "120rem"
}, nr = {
  xs: "23.375rem",
  sm: "41rem",
  md: "63.9375rem",
  lg: "91.8125rem",
  xl: "119.9375rem"
}, ix = ({
  bottomSpacing: e,
  topSpacing: t,
  verticalSpacing: n,
  theme: r
}) => {
  if (n)
    return Lr(
      n,
      ["paddingTop", "paddingBottom"],
      r
    );
  const u = {};
  return e && Object.assign(
    u,
    Lr(e, ["paddingBottom"], r)
  ), t && Object.assign(
    u,
    Lr(t, ["paddingTop"], r)
  ), u;
}, ax = (e, t) => e.rowsGap === "value" && e.rowsGapValue ? Lr(e.rowsGapValue, ["gridRowGap"], t) : e.rowsGap === "default" ? { gridRowGap: "var(--grid-gap)" } : e.rowsGap === "none" ? { gridRowGap: 0 } : {}, ox = ({
  rowsDefinitions: e,
  rowsMinHeight: t,
  rowsMaxHeight: n
}) => e ? {
  gridTemplateRows: e.join(" "),
  gridAutoRows: `minmax(${t || "50px"}, auto)`
} : t ? {
  gridTemplateRows: `minmax(${t}, auto)`,
  gridAutoRows: `minmax(${t}, auto)`
} : n ? {
  gridTemplateRows: `minmax(auto, ${n})`,
  gridAutoRows: `minmax(auto, ${n})`
} : {}, Vu = ({
  options: e = {},
  breakpoint: t = "sm",
  theme: n
}) => {
  const r = ix({
    bottomSpacing: e.bottomSpacing,
    topSpacing: e.topSpacing,
    verticalSpacing: e.verticalSpacing,
    theme: n
  }), u = ax(e, n), i = ox({
    rowsDefinitions: e.rowsDefinitions,
    rowsMaxHeight: e.rowsMaxHeight,
    rowsMinHeight: e.rowsMinHeight
  }), a = B`
    ${r}
    ${u}
    ${i}
  `;
  return t === "sm" ? a : t === "md" ? B`
      @media only screen and (min-width: ${ut.md}) {
        ${a}
      }
    ` : t === "lg" ? B`
      @media only screen and (min-width: ${ut.lg}) {
        ${a}
      }
    ` : t === "xl" ? B`
      @media only screen and (min-width: ${ut.xl}) {
        ${a}
      }
    ` : B`
    @media only screen and (min-width: ${ut["2xl"]}) {
      ${a}
    }
  `;
};
const sx = "Grid", cx = {
  rowsMinHeight: "50px",
  rowsGap: "default"
}, Hg = at(
  ({
    className: e,
    children: t,
    as: n = "section",
    options: r = {},
    mdOptions: u = {},
    lgOptions: i = {},
    xlOptions: a = {},
    twoXlOptions: o = {},
    ...s
  }, c) => {
    const { foundationGrid: l, foundationTheme: d, foundationColor: f } = ke(yn), p = U(e, "grid", d, f, {
      "grid-compact": l === "compact"
    }), h = Vu({
      options: { ...cx, ...r },
      breakpoint: "sm",
      theme: l
    }), m = Vu({
      options: u,
      breakpoint: "md",
      theme: l
    }), b = Vu({
      options: i,
      breakpoint: "lg",
      theme: l
    }), x = Vu({
      options: a,
      breakpoint: "xl",
      theme: l
    }), y = Vu({
      options: o,
      breakpoint: "2xl",
      theme: l
    });
    return /* @__PURE__ */ W(
      n,
      {
        ref: c,
        css: [
          h,
          m,
          b,
          x,
          y
        ],
        className: p,
        ...s
      },
      t
    );
  }
);
Hg.displayName = sx;
const _n = {
  auto: "auto",
  leftEdge: "left-edge",
  leftOuter: "left-outer",
  leftInner: "left-inner",
  rightInner: "right-inner",
  rightOuter: "right-outer",
  rightEdge: "right-edge"
}, Rt = {
  inner1: "inner-1",
  inner2: "inner-2",
  inner3: "inner-3",
  inner4: "inner-4",
  inner5: "inner-5",
  inner6: "inner-6",
  inner7: "inner-7",
  inner8: "inner-8",
  inner9: "inner-9",
  inner10: "inner-10",
  inner11: "inner-11",
  inner12: "inner-12",
  inner13: "inner-13",
  mid: "mid"
}, $g = {
  [_n.auto]: "auto",
  // The first 3 Column Lines of the Grid
  [_n.leftEdge]: "1",
  [_n.leftOuter]: "2",
  [_n.leftInner]: "3",
  // The Last 3 Column Lines of the Grid
  [_n.rightInner]: "-3",
  [_n.rightOuter]: "-2",
  [_n.rightEdge]: "-1"
}, Vg = {
  [Rt.inner1]: "3",
  [Rt.inner2]: "4",
  [Rt.inner3]: "5",
  [Rt.inner4]: "6",
  [Rt.inner5]: "7",
  // This exact 'mid' Column Line value is specific when having 4 Inner Columns
  [Rt.mid]: "5"
}, lx = {
  ...Vg,
  [Rt.inner6]: "8",
  [Rt.inner7]: "9",
  [Rt.inner8]: "10",
  [Rt.inner9]: "11",
  [Rt.inner10]: "12",
  [Rt.inner11]: "13",
  [Rt.inner12]: "14",
  [Rt.inner13]: "15",
  // This exact 'mid' Column Line value is specific when having 12 Inner Columns
  [Rt.mid]: "9"
}, ld = {
  ...$g,
  ...Vg
}, cs = {
  ...$g,
  ...lx
}, dx = {
  sm: ld,
  md: ld,
  lg: cs,
  xl: cs,
  "2xl": cs
}, fx = ({
  bottomSpacing: e,
  topSpacing: t,
  verticalSpacing: n,
  theme: r
}) => {
  if (n)
    return Lr(
      n,
      ["paddingTop", "paddingBottom"],
      r
    );
  const u = {};
  return e && Object.assign(
    u,
    Lr(e, ["paddingBottom"], r)
  ), t && Object.assign(
    u,
    Lr(t, ["paddingTop"], r)
  ), u;
}, px = ({
  verticalAlign: e
}) => e ? {
  alignSelf: e === "default" ? "auto" : e
} : {}, hx = ({
  rowStart: e,
  rowEnd: t,
  rowSpan: n
}) => {
  const r = {};
  return e && (r.gridRowStart = e), (n || t) && (r.gridRowEnd = n ? `span ${n}` : t), r;
}, mx = ({
  hide: e
}) => e === void 0 ? {} : {
  display: e ? "none" : "block"
}, gx = ({
  columnStart: e,
  columnEnd: t,
  columnSpan: n,
  breakpoint: r
}) => {
  const u = dx[r];
  if (!u)
    return {};
  const i = {};
  return e && (i.gridColumnStart = u[e]), n ? i.gridColumnEnd = `span ${n}` : t && (i.gridColumnEnd = u[t]), i;
}, bx = ({
  zIndex: e
}) => e === void 0 ? {} : {
  zIndex: e
}, ju = ({
  options: e = {},
  breakpoint: t = "sm",
  theme: n
}) => {
  const r = px({
    verticalAlign: e.verticalAlign
  }), u = mx({ hide: e.hide }), i = hx({
    rowStart: e.rowStart,
    rowEnd: e.rowEnd,
    rowSpan: e.rowSpan
  }), a = gx({
    columnStart: e.columnStart,
    columnEnd: e.columnEnd,
    columnSpan: e.columnSpan,
    breakpoint: t
  }), o = fx({
    bottomSpacing: e.bottomSpacing,
    topSpacing: e.topSpacing,
    verticalSpacing: e.verticalSpacing,
    theme: n
  }), s = bx({ zIndex: e.zIndex }), c = B`
    ${r}
    ${u}
    ${i}
    ${a}
    ${o}
    ${s}
  `;
  return t === "sm" ? c : t === "md" ? B`
      @media only screen and (min-width: ${ut.md}) {
        ${c}
      }
    ` : t === "lg" ? B`
      @media only screen and (min-width: ${ut.lg}) {
        ${c}
      }
    ` : t === "xl" ? B`
      @media only screen and (min-width: ${ut.xl}) {
        ${c}
      }
    ` : B`
    @media only screen and (min-width: ${ut["2xl"]}) {
      ${c}
    }
  `;
}, vx = "GridItem", yx = {
  hide: !1,
  rowStart: _n.auto,
  rowEnd: _n.auto,
  columnStart: _n.leftInner,
  columnEnd: _n.rightInner,
  verticalAlign: "default",
  zIndex: 1
}, jg = at(
  ({
    as: e = "div",
    className: t = "",
    options: n = {},
    mdOptions: r = {},
    lgOptions: u = {},
    xlOptions: i = {},
    twoXlOptions: a = {},
    children: o = null,
    ...s
  }, c) => {
    const { foundationGrid: l } = ke(yn), d = U(t, ""), f = ju({
      options: {
        ...yx,
        ...n
      },
      breakpoint: "sm",
      theme: l
    }), p = ju({
      options: r,
      breakpoint: "md",
      theme: l
    }), h = ju({
      options: u,
      breakpoint: "lg",
      theme: l
    }), m = ju({
      options: i,
      breakpoint: "xl",
      theme: l
    }), b = ju({
      options: a,
      breakpoint: "2xl",
      theme: l
    });
    return /* @__PURE__ */ W(
      e,
      {
        ref: c,
        css: [
          f,
          p,
          h,
          m,
          b
        ],
        className: d,
        ...s
      },
      o
    );
  }
);
jg.displayName = vx;
const wu = Yn({
  transformPagePoint: (e) => e,
  isStatic: !1,
  reducedMotion: "never"
}), ho = Yn({}), mo = Yn(null), go = typeof document < "u", Mr = go ? Gn : oe, bl = Yn({ strict: !1 }), mi = (e) => e.replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase(), xx = "framerAppearId", zg = "data-" + mi(xx);
function _x(e, t, n, r) {
  const { visualElement: u } = ke(ho), i = ke(bl), a = ke(mo), o = ke(wu).reducedMotion, s = Z();
  r = r || i.renderer, !s.current && r && (s.current = r(e, {
    visualState: t,
    parent: u,
    props: n,
    presenceContext: a,
    blockInitialAnimation: a ? a.initial === !1 : !1,
    reducedMotionConfig: o
  }));
  const c = s.current;
  lo(() => {
    c && c.update(n, a);
  });
  const l = Z(!!(n[zg] && !window.HandoffComplete));
  return Mr(() => {
    c && (c.render(), l.current && c.animationState && c.animationState.animateChanges());
  }), oe(() => {
    c && (c.updateFeatures(), !l.current && c.animationState && c.animationState.animateChanges(), l.current && (l.current = !1, window.HandoffComplete = !0));
  }), c;
}
function au(e) {
  return e && typeof e == "object" && Object.prototype.hasOwnProperty.call(e, "current");
}
function Sx(e, t, n) {
  return Ct(
    (r) => {
      r && e.mount && e.mount(r), t && (r ? t.mount(r) : t.unmount()), n && (typeof n == "function" ? n(r) : au(n) && (n.current = r));
    },
    /**
     * Only pass a new ref callback to React if we've received a visual element
     * factory. Otherwise we'll be mounting/remounting every time externalRef
     * or other dependencies change.
     */
    [t]
  );
}
function gi(e) {
  return typeof e == "string" || Array.isArray(e);
}
function bo(e) {
  return e !== null && typeof e == "object" && typeof e.start == "function";
}
const vl = [
  "animate",
  "whileInView",
  "whileFocus",
  "whileHover",
  "whileTap",
  "whileDrag",
  "exit"
], yl = ["initial", ...vl];
function vo(e) {
  return bo(e.animate) || yl.some((t) => gi(e[t]));
}
function Ug(e) {
  return !!(vo(e) || e.variants);
}
function Cx(e, t) {
  if (vo(e)) {
    const { initial: n, animate: r } = e;
    return {
      initial: n === !1 || gi(n) ? n : void 0,
      animate: gi(r) ? r : void 0
    };
  }
  return e.inherit !== !1 ? t : {};
}
function Ex(e) {
  const { initial: t, animate: n } = Cx(e, ke(ho));
  return $e(() => ({ initial: t, animate: n }), [dd(t), dd(n)]);
}
function dd(e) {
  return Array.isArray(e) ? e.join(" ") : e;
}
const fd = {
  animation: [
    "animate",
    "variants",
    "whileHover",
    "whileTap",
    "exit",
    "whileInView",
    "whileFocus",
    "whileDrag"
  ],
  exit: ["exit"],
  drag: ["drag", "dragControls"],
  focus: ["whileFocus"],
  hover: ["whileHover", "onHoverStart", "onHoverEnd"],
  tap: ["whileTap", "onTap", "onTapStart", "onTapCancel"],
  pan: ["onPan", "onPanStart", "onPanSessionStart", "onPanEnd"],
  inView: ["whileInView", "onViewportEnter", "onViewportLeave"],
  layout: ["layout", "layoutId"]
}, bi = {};
for (const e in fd)
  bi[e] = {
    isEnabled: (t) => fd[e].some((n) => !!t[n])
  };
function mc(e) {
  for (const t in e)
    bi[t] = {
      ...bi[t],
      ...e[t]
    };
}
const xl = Yn({}), qg = Yn({}), wx = Symbol.for("motionComponentSymbol");
function Tx({ preloadedFeatures: e, createVisualElement: t, useRender: n, useVisualState: r, Component: u }) {
  e && mc(e);
  function i(o, s) {
    let c;
    const l = {
      ...ke(wu),
      ...o,
      layoutId: Ax(o)
    }, { isStatic: d } = l, f = Ex(o), p = r(o, d);
    if (!d && go) {
      f.visualElement = _x(u, p, l, t);
      const h = ke(qg), m = ke(bl).strict;
      f.visualElement && (c = f.visualElement.loadFeatures(
        // Note: Pass the full new combined props to correctly re-render dynamic feature components.
        l,
        m,
        e,
        h
      ));
    }
    return Y.createElement(
      ho.Provider,
      { value: f },
      c && f.visualElement ? Y.createElement(c, { visualElement: f.visualElement, ...l }) : null,
      n(u, o, Sx(p, f.visualElement, s), p, d, f.visualElement)
    );
  }
  const a = at(i);
  return a[wx] = u, a;
}
function Ax({ layoutId: e }) {
  const t = ke(xl).id;
  return t && e !== void 0 ? t + "-" + e : e;
}
function Gg(e) {
  function t(r, u = {}) {
    return Tx(e(r, u));
  }
  if (typeof Proxy > "u")
    return t;
  const n = /* @__PURE__ */ new Map();
  return new Proxy(t, {
    /**
     * Called when `motion` is referenced with a prop: `motion.div`, `motion.input` etc.
     * The prop name is passed through as `key` and we can use that to generate a `motion`
     * DOM component with that name.
     */
    get: (r, u) => (n.has(u) || n.set(u, t(u)), n.get(u))
  });
}
const kx = [
  "animate",
  "circle",
  "defs",
  "desc",
  "ellipse",
  "g",
  "image",
  "line",
  "filter",
  "marker",
  "mask",
  "metadata",
  "path",
  "pattern",
  "polygon",
  "polyline",
  "rect",
  "stop",
  "switch",
  "symbol",
  "svg",
  "text",
  "tspan",
  "use",
  "view"
];
function _l(e) {
  return (
    /**
     * If it's not a string, it's a custom React component. Currently we only support
     * HTML custom React components.
     */
    typeof e != "string" || /**
     * If it contains a dash, the element is a custom HTML webcomponent.
     */
    e.includes("-") ? !1 : (
      /**
       * If it's in our list of lowercase SVG tags, it's an SVG component
       */
      !!(kx.indexOf(e) > -1 || /**
       * If it contains a capital letter, it's an SVG component
       */
      /[A-Z]/.test(e))
    )
  );
}
const Ra = {};
function Lx(e) {
  Object.assign(Ra, e);
}
const Ri = [
  "transformPerspective",
  "x",
  "y",
  "z",
  "translateX",
  "translateY",
  "translateZ",
  "scale",
  "scaleX",
  "scaleY",
  "rotate",
  "rotateX",
  "rotateY",
  "rotateZ",
  "skew",
  "skewX",
  "skewY"
], Wn = new Set(Ri);
function Wg(e, { layout: t, layoutId: n }) {
  return Wn.has(e) || e.startsWith("origin") || (t || n !== void 0) && (!!Ra[e] || e === "opacity");
}
const wt = (e) => !!(e && e.getVelocity), Dx = {
  x: "translateX",
  y: "translateY",
  z: "translateZ",
  transformPerspective: "perspective"
}, Nx = Ri.length;
function Ox(e, { enableHardwareAcceleration: t = !0, allowTransformNone: n = !0 }, r, u) {
  let i = "";
  for (let a = 0; a < Nx; a++) {
    const o = Ri[a];
    if (e[o] !== void 0) {
      const s = Dx[o] || o;
      i += `${s}(${e[o]}) `;
    }
  }
  return t && !e.z && (i += "translateZ(0)"), i = i.trim(), u ? i = u(e, r ? "" : i) : n && r && (i = "none"), i;
}
const Kg = (e) => (t) => typeof t == "string" && t.startsWith(e), Sl = Kg("--"), gc = Kg("var(--"), Ix = /var\s*\(\s*--[\w-]+(\s*,\s*(?:(?:[^)(]|\((?:[^)(]+|\([^)(]*\))*\))*)+)?\s*\)/g, Mx = (e, t) => t && typeof e == "number" ? t.transform(e) : e, ar = (e, t, n) => Math.min(Math.max(n, e), t), Pr = {
  test: (e) => typeof e == "number",
  parse: parseFloat,
  transform: (e) => e
}, ii = {
  ...Pr,
  transform: (e) => ar(0, 1, e)
}, Ji = {
  ...Pr,
  default: 1
}, ai = (e) => Math.round(e * 1e5) / 1e5, yo = /(-)?([\d]*\.?[\d])+/g, Yg = /(#[0-9a-f]{3,8}|(rgb|hsl)a?\((-?[\d\.]+%?[,\s]+){2}(-?[\d\.]+%?)\s*[\,\/]?\s*[\d\.]*%?\))/gi, Px = /^(#[0-9a-f]{3,8}|(rgb|hsl)a?\((-?[\d\.]+%?[,\s]+){2}(-?[\d\.]+%?)\s*[\,\/]?\s*[\d\.]*%?\))$/i;
function Bi(e) {
  return typeof e == "string";
}
const Fi = (e) => ({
  test: (t) => Bi(t) && t.endsWith(e) && t.split(" ").length === 1,
  parse: parseFloat,
  transform: (t) => `${t}${e}`
}), Qn = Fi("deg"), Dn = Fi("%"), be = Fi("px"), Rx = Fi("vh"), Bx = Fi("vw"), pd = {
  ...Dn,
  parse: (e) => Dn.parse(e) / 100,
  transform: (e) => Dn.transform(e * 100)
}, hd = {
  ...Pr,
  transform: Math.round
}, Zg = {
  // Border props
  borderWidth: be,
  borderTopWidth: be,
  borderRightWidth: be,
  borderBottomWidth: be,
  borderLeftWidth: be,
  borderRadius: be,
  radius: be,
  borderTopLeftRadius: be,
  borderTopRightRadius: be,
  borderBottomRightRadius: be,
  borderBottomLeftRadius: be,
  // Positioning props
  width: be,
  maxWidth: be,
  height: be,
  maxHeight: be,
  size: be,
  top: be,
  right: be,
  bottom: be,
  left: be,
  // Spacing props
  padding: be,
  paddingTop: be,
  paddingRight: be,
  paddingBottom: be,
  paddingLeft: be,
  margin: be,
  marginTop: be,
  marginRight: be,
  marginBottom: be,
  marginLeft: be,
  // Transform props
  rotate: Qn,
  rotateX: Qn,
  rotateY: Qn,
  rotateZ: Qn,
  scale: Ji,
  scaleX: Ji,
  scaleY: Ji,
  scaleZ: Ji,
  skew: Qn,
  skewX: Qn,
  skewY: Qn,
  distance: be,
  translateX: be,
  translateY: be,
  translateZ: be,
  x: be,
  y: be,
  z: be,
  perspective: be,
  transformPerspective: be,
  opacity: ii,
  originX: pd,
  originY: pd,
  originZ: be,
  // Misc
  zIndex: hd,
  // SVG
  fillOpacity: ii,
  strokeOpacity: ii,
  numOctaves: hd
};
function Cl(e, t, n, r) {
  const { style: u, vars: i, transform: a, transformOrigin: o } = e;
  let s = !1, c = !1, l = !0;
  for (const d in t) {
    const f = t[d];
    if (Sl(d)) {
      i[d] = f;
      continue;
    }
    const p = Zg[d], h = Mx(f, p);
    if (Wn.has(d)) {
      if (s = !0, a[d] = h, !l)
        continue;
      f !== (p.default || 0) && (l = !1);
    } else
      d.startsWith("origin") ? (c = !0, o[d] = h) : u[d] = h;
  }
  if (t.transform || (s || r ? u.transform = Ox(e.transform, n, l, r) : u.transform && (u.transform = "none")), c) {
    const { originX: d = "50%", originY: f = "50%", originZ: p = 0 } = o;
    u.transformOrigin = `${d} ${f} ${p}`;
  }
}
const El = () => ({
  style: {},
  transform: {},
  transformOrigin: {},
  vars: {}
});
function Xg(e, t, n) {
  for (const r in t)
    !wt(t[r]) && !Wg(r, n) && (e[r] = t[r]);
}
function Fx({ transformTemplate: e }, t, n) {
  return $e(() => {
    const r = El();
    return Cl(r, t, { enableHardwareAcceleration: !n }, e), Object.assign({}, r.vars, r.style);
  }, [t]);
}
function Hx(e, t, n) {
  const r = e.style || {}, u = {};
  return Xg(u, r, e), Object.assign(u, Fx(e, t, n)), e.transformValues ? e.transformValues(u) : u;
}
function $x(e, t, n) {
  const r = {}, u = Hx(e, t, n);
  return e.drag && e.dragListener !== !1 && (r.draggable = !1, u.userSelect = u.WebkitUserSelect = u.WebkitTouchCallout = "none", u.touchAction = e.drag === !0 ? "none" : `pan-${e.drag === "x" ? "y" : "x"}`), e.tabIndex === void 0 && (e.onTap || e.onTapStart || e.whileTap) && (r.tabIndex = 0), r.style = u, r;
}
const Vx = /* @__PURE__ */ new Set([
  "animate",
  "exit",
  "variants",
  "initial",
  "style",
  "values",
  "variants",
  "transition",
  "transformTemplate",
  "transformValues",
  "custom",
  "inherit",
  "onBeforeLayoutMeasure",
  "onAnimationStart",
  "onAnimationComplete",
  "onUpdate",
  "onDragStart",
  "onDrag",
  "onDragEnd",
  "onMeasureDragConstraints",
  "onDirectionLock",
  "onDragTransitionEnd",
  "_dragX",
  "_dragY",
  "onHoverStart",
  "onHoverEnd",
  "onViewportEnter",
  "onViewportLeave",
  "globalTapTarget",
  "ignoreStrict",
  "viewport"
]);
function Ba(e) {
  return e.startsWith("while") || e.startsWith("drag") && e !== "draggable" || e.startsWith("layout") || e.startsWith("onTap") || e.startsWith("onPan") || e.startsWith("onLayout") || Vx.has(e);
}
let Qg = (e) => !Ba(e);
function Jg(e) {
  e && (Qg = (t) => t.startsWith("on") ? !Ba(t) : e(t));
}
try {
  Jg(require("@emotion/is-prop-valid").default);
} catch {
}
function jx(e, t, n) {
  const r = {};
  for (const u in e)
    u === "values" && typeof e.values == "object" || (Qg(u) || n === !0 && Ba(u) || !t && !Ba(u) || // If trying to use native HTML drag events, forward drag listeners
    e.draggable && u.startsWith("onDrag")) && (r[u] = e[u]);
  return r;
}
function md(e, t, n) {
  return typeof e == "string" ? e : be.transform(t + n * e);
}
function zx(e, t, n) {
  const r = md(t, e.x, e.width), u = md(n, e.y, e.height);
  return `${r} ${u}`;
}
const Ux = {
  offset: "stroke-dashoffset",
  array: "stroke-dasharray"
}, qx = {
  offset: "strokeDashoffset",
  array: "strokeDasharray"
};
function Gx(e, t, n = 1, r = 0, u = !0) {
  e.pathLength = 1;
  const i = u ? Ux : qx;
  e[i.offset] = be.transform(-r);
  const a = be.transform(t), o = be.transform(n);
  e[i.array] = `${a} ${o}`;
}
function wl(e, {
  attrX: t,
  attrY: n,
  attrScale: r,
  originX: u,
  originY: i,
  pathLength: a,
  pathSpacing: o = 1,
  pathOffset: s = 0,
  // This is object creation, which we try to avoid per-frame.
  ...c
}, l, d, f) {
  if (Cl(e, c, l, f), d) {
    e.style.viewBox && (e.attrs.viewBox = e.style.viewBox);
    return;
  }
  e.attrs = e.style, e.style = {};
  const { attrs: p, style: h, dimensions: m } = e;
  p.transform && (m && (h.transform = p.transform), delete p.transform), m && (u !== void 0 || i !== void 0 || h.transform) && (h.transformOrigin = zx(m, u !== void 0 ? u : 0.5, i !== void 0 ? i : 0.5)), t !== void 0 && (p.x = t), n !== void 0 && (p.y = n), r !== void 0 && (p.scale = r), a !== void 0 && Gx(p, a, o, s, !1);
}
const eb = () => ({
  ...El(),
  attrs: {}
}), Tl = (e) => typeof e == "string" && e.toLowerCase() === "svg";
function Wx(e, t, n, r) {
  const u = $e(() => {
    const i = eb();
    return wl(i, t, { enableHardwareAcceleration: !1 }, Tl(r), e.transformTemplate), {
      ...i.attrs,
      style: { ...i.style }
    };
  }, [t]);
  if (e.style) {
    const i = {};
    Xg(i, e.style, e), u.style = { ...i, ...u.style };
  }
  return u;
}
function Kx(e = !1) {
  return (n, r, u, { latestValues: i }, a) => {
    const s = (_l(n) ? Wx : $x)(r, i, a, n), l = {
      ...jx(r, typeof n == "string", e),
      ...s,
      ref: u
    }, { children: d } = r, f = $e(() => wt(d) ? d.get() : d, [d]);
    return fo(n, {
      ...l,
      children: f
    });
  };
}
function tb(e, { style: t, vars: n }, r, u) {
  Object.assign(e.style, t, u && u.getProjectionStyles(r));
  for (const i in n)
    e.style.setProperty(i, n[i]);
}
const nb = /* @__PURE__ */ new Set([
  "baseFrequency",
  "diffuseConstant",
  "kernelMatrix",
  "kernelUnitLength",
  "keySplines",
  "keyTimes",
  "limitingConeAngle",
  "markerHeight",
  "markerWidth",
  "numOctaves",
  "targetX",
  "targetY",
  "surfaceScale",
  "specularConstant",
  "specularExponent",
  "stdDeviation",
  "tableValues",
  "viewBox",
  "gradientTransform",
  "pathLength",
  "startOffset",
  "textLength",
  "lengthAdjust"
]);
function rb(e, t, n, r) {
  tb(e, t, void 0, r);
  for (const u in t.attrs)
    e.setAttribute(nb.has(u) ? u : mi(u), t.attrs[u]);
}
function Al(e, t) {
  const { style: n } = e, r = {};
  for (const u in n)
    (wt(n[u]) || t.style && wt(t.style[u]) || Wg(u, e)) && (r[u] = n[u]);
  return r;
}
function ub(e, t) {
  const n = Al(e, t);
  for (const r in e)
    if (wt(e[r]) || wt(t[r])) {
      const u = Ri.indexOf(r) !== -1 ? "attr" + r.charAt(0).toUpperCase() + r.substring(1) : r;
      n[u] = e[r];
    }
  return n;
}
function kl(e, t, n, r = {}, u = {}) {
  return typeof t == "function" && (t = t(n !== void 0 ? n : e.custom, r, u)), typeof t == "string" && (t = e.variants && e.variants[t]), typeof t == "function" && (t = t(n !== void 0 ? n : e.custom, r, u)), t;
}
function On(e) {
  const t = Z(null);
  return t.current === null && (t.current = e()), t.current;
}
const Fa = (e) => Array.isArray(e), Yx = (e) => !!(e && typeof e == "object" && e.mix && e.toValue), Zx = (e) => Fa(e) ? e[e.length - 1] || 0 : e;
function Ca(e) {
  const t = wt(e) ? e.get() : e;
  return Yx(t) ? t.toValue() : t;
}
function Xx({ scrapeMotionValuesFromProps: e, createRenderState: t, onMount: n }, r, u, i) {
  const a = {
    latestValues: Qx(r, u, i, e),
    renderState: t()
  };
  return n && (a.mount = (o) => n(r, o, a)), a;
}
const ib = (e) => (t, n) => {
  const r = ke(ho), u = ke(mo), i = () => Xx(e, t, r, u);
  return n ? i() : On(i);
};
function Qx(e, t, n, r) {
  const u = {}, i = r(e, {});
  for (const f in i)
    u[f] = Ca(i[f]);
  let { initial: a, animate: o } = e;
  const s = vo(e), c = Ug(e);
  t && c && !s && e.inherit !== !1 && (a === void 0 && (a = t.initial), o === void 0 && (o = t.animate));
  let l = n ? n.initial === !1 : !1;
  l = l || a === !1;
  const d = l ? o : a;
  return d && typeof d != "boolean" && !bo(d) && (Array.isArray(d) ? d : [d]).forEach((p) => {
    const h = kl(e, p);
    if (!h)
      return;
    const { transitionEnd: m, transition: b, ...x } = h;
    for (const y in x) {
      let g = x[y];
      if (Array.isArray(g)) {
        const v = l ? g.length - 1 : 0;
        g = g[v];
      }
      g !== null && (u[y] = g);
    }
    for (const y in m)
      u[y] = m[y];
  }), u;
}
const it = (e) => e;
class gd {
  constructor() {
    this.order = [], this.scheduled = /* @__PURE__ */ new Set();
  }
  add(t) {
    if (!this.scheduled.has(t))
      return this.scheduled.add(t), this.order.push(t), !0;
  }
  remove(t) {
    const n = this.order.indexOf(t);
    n !== -1 && (this.order.splice(n, 1), this.scheduled.delete(t));
  }
  clear() {
    this.order.length = 0, this.scheduled.clear();
  }
}
function Jx(e) {
  let t = new gd(), n = new gd(), r = 0, u = !1, i = !1;
  const a = /* @__PURE__ */ new WeakSet(), o = {
    /**
     * Schedule a process to run on the next frame.
     */
    schedule: (s, c = !1, l = !1) => {
      const d = l && u, f = d ? t : n;
      return c && a.add(s), f.add(s) && d && u && (r = t.order.length), s;
    },
    /**
     * Cancel the provided callback from running on the next frame.
     */
    cancel: (s) => {
      n.remove(s), a.delete(s);
    },
    /**
     * Execute all schedule callbacks.
     */
    process: (s) => {
      if (u) {
        i = !0;
        return;
      }
      if (u = !0, [t, n] = [n, t], n.clear(), r = t.order.length, r)
        for (let c = 0; c < r; c++) {
          const l = t.order[c];
          l(s), a.has(l) && (o.schedule(l), e());
        }
      u = !1, i && (i = !1, o.process(s));
    }
  };
  return o;
}
const ea = [
  "prepare",
  "read",
  "update",
  "preRender",
  "render",
  "postRender"
], e8 = 40;
function t8(e, t) {
  let n = !1, r = !0;
  const u = {
    delta: 0,
    timestamp: 0,
    isProcessing: !1
  }, i = ea.reduce((d, f) => (d[f] = Jx(() => n = !0), d), {}), a = (d) => i[d].process(u), o = () => {
    const d = performance.now();
    n = !1, u.delta = r ? 1e3 / 60 : Math.max(Math.min(d - u.timestamp, e8), 1), u.timestamp = d, u.isProcessing = !0, ea.forEach(a), u.isProcessing = !1, n && t && (r = !1, e(o));
  }, s = () => {
    n = !0, r = !0, u.isProcessing || e(o);
  };
  return { schedule: ea.reduce((d, f) => {
    const p = i[f];
    return d[f] = (h, m = !1, b = !1) => (n || s(), p.schedule(h, m, b)), d;
  }, {}), cancel: (d) => ea.forEach((f) => i[f].cancel(d)), state: u, steps: i };
}
const { schedule: He, cancel: bn, state: vt, steps: ls } = t8(typeof requestAnimationFrame < "u" ? requestAnimationFrame : it, !0), n8 = {
  useVisualState: ib({
    scrapeMotionValuesFromProps: ub,
    createRenderState: eb,
    onMount: (e, t, { renderState: n, latestValues: r }) => {
      He.read(() => {
        try {
          n.dimensions = typeof t.getBBox == "function" ? t.getBBox() : t.getBoundingClientRect();
        } catch {
          n.dimensions = {
            x: 0,
            y: 0,
            width: 0,
            height: 0
          };
        }
      }), He.render(() => {
        wl(n, r, { enableHardwareAcceleration: !1 }, Tl(t.tagName), e.transformTemplate), rb(t, n);
      });
    }
  })
}, r8 = {
  useVisualState: ib({
    scrapeMotionValuesFromProps: Al,
    createRenderState: El
  })
};
function ab(e, { forwardMotionProps: t = !1 }, n, r) {
  return {
    ..._l(e) ? n8 : r8,
    preloadedFeatures: n,
    useRender: Kx(t),
    createVisualElement: r,
    Component: e
  };
}
function zn(e, t, n, r = { passive: !0 }) {
  return e.addEventListener(t, n, r), () => e.removeEventListener(t, n);
}
const ob = (e) => e.pointerType === "mouse" ? typeof e.button != "number" || e.button <= 0 : e.isPrimary !== !1;
function xo(e, t = "page") {
  return {
    point: {
      x: e[t + "X"],
      y: e[t + "Y"]
    }
  };
}
const u8 = (e) => (t) => ob(t) && e(t, xo(t));
function Un(e, t, n, r) {
  return zn(e, t, u8(n), r);
}
const i8 = (e, t) => (n) => t(e(n)), ir = (...e) => e.reduce(i8);
function sb(e) {
  let t = null;
  return () => {
    const n = () => {
      t = null;
    };
    return t === null ? (t = e, n) : !1;
  };
}
const bd = sb("dragHorizontal"), vd = sb("dragVertical");
function cb(e) {
  let t = !1;
  if (e === "y")
    t = vd();
  else if (e === "x")
    t = bd();
  else {
    const n = bd(), r = vd();
    n && r ? t = () => {
      n(), r();
    } : (n && n(), r && r());
  }
  return t;
}
function lb() {
  const e = cb(!0);
  return e ? (e(), !1) : !0;
}
class fr {
  constructor(t) {
    this.isMounted = !1, this.node = t;
  }
  update() {
  }
}
function yd(e, t) {
  const n = "pointer" + (t ? "enter" : "leave"), r = "onHover" + (t ? "Start" : "End"), u = (i, a) => {
    if (i.pointerType === "touch" || lb())
      return;
    const o = e.getProps();
    e.animationState && o.whileHover && e.animationState.setActive("whileHover", t), o[r] && He.update(() => o[r](i, a));
  };
  return Un(e.current, n, u, {
    passive: !e.getProps()[r]
  });
}
class a8 extends fr {
  mount() {
    this.unmount = ir(yd(this.node, !0), yd(this.node, !1));
  }
  unmount() {
  }
}
class o8 extends fr {
  constructor() {
    super(...arguments), this.isActive = !1;
  }
  onFocus() {
    let t = !1;
    try {
      t = this.node.current.matches(":focus-visible");
    } catch {
      t = !0;
    }
    !t || !this.node.animationState || (this.node.animationState.setActive("whileFocus", !0), this.isActive = !0);
  }
  onBlur() {
    !this.isActive || !this.node.animationState || (this.node.animationState.setActive("whileFocus", !1), this.isActive = !1);
  }
  mount() {
    this.unmount = ir(zn(this.node.current, "focus", () => this.onFocus()), zn(this.node.current, "blur", () => this.onBlur()));
  }
  unmount() {
  }
}
const db = (e, t) => t ? e === t ? !0 : db(e, t.parentElement) : !1;
function ds(e, t) {
  if (!t)
    return;
  const n = new PointerEvent("pointer" + e);
  t(n, xo(n));
}
class s8 extends fr {
  constructor() {
    super(...arguments), this.removeStartListeners = it, this.removeEndListeners = it, this.removeAccessibleListeners = it, this.startPointerPress = (t, n) => {
      if (this.isPressing)
        return;
      this.removeEndListeners();
      const r = this.node.getProps(), i = Un(window, "pointerup", (o, s) => {
        if (!this.checkPressEnd())
          return;
        const { onTap: c, onTapCancel: l, globalTapTarget: d } = this.node.getProps();
        He.update(() => {
          !d && !db(this.node.current, o.target) ? l && l(o, s) : c && c(o, s);
        });
      }, { passive: !(r.onTap || r.onPointerUp) }), a = Un(window, "pointercancel", (o, s) => this.cancelPress(o, s), { passive: !(r.onTapCancel || r.onPointerCancel) });
      this.removeEndListeners = ir(i, a), this.startPress(t, n);
    }, this.startAccessiblePress = () => {
      const t = (i) => {
        if (i.key !== "Enter" || this.isPressing)
          return;
        const a = (o) => {
          o.key !== "Enter" || !this.checkPressEnd() || ds("up", (s, c) => {
            const { onTap: l } = this.node.getProps();
            l && He.update(() => l(s, c));
          });
        };
        this.removeEndListeners(), this.removeEndListeners = zn(this.node.current, "keyup", a), ds("down", (o, s) => {
          this.startPress(o, s);
        });
      }, n = zn(this.node.current, "keydown", t), r = () => {
        this.isPressing && ds("cancel", (i, a) => this.cancelPress(i, a));
      }, u = zn(this.node.current, "blur", r);
      this.removeAccessibleListeners = ir(n, u);
    };
  }
  startPress(t, n) {
    this.isPressing = !0;
    const { onTapStart: r, whileTap: u } = this.node.getProps();
    u && this.node.animationState && this.node.animationState.setActive("whileTap", !0), r && He.update(() => r(t, n));
  }
  checkPressEnd() {
    return this.removeEndListeners(), this.isPressing = !1, this.node.getProps().whileTap && this.node.animationState && this.node.animationState.setActive("whileTap", !1), !lb();
  }
  cancelPress(t, n) {
    if (!this.checkPressEnd())
      return;
    const { onTapCancel: r } = this.node.getProps();
    r && He.update(() => r(t, n));
  }
  mount() {
    const t = this.node.getProps(), n = Un(t.globalTapTarget ? window : this.node.current, "pointerdown", this.startPointerPress, { passive: !(t.onTapStart || t.onPointerStart) }), r = zn(this.node.current, "focus", this.startAccessiblePress);
    this.removeStartListeners = ir(n, r);
  }
  unmount() {
    this.removeStartListeners(), this.removeEndListeners(), this.removeAccessibleListeners();
  }
}
const bc = /* @__PURE__ */ new WeakMap(), fs = /* @__PURE__ */ new WeakMap(), c8 = (e) => {
  const t = bc.get(e.target);
  t && t(e);
}, l8 = (e) => {
  e.forEach(c8);
};
function d8({ root: e, ...t }) {
  const n = e || document;
  fs.has(n) || fs.set(n, {});
  const r = fs.get(n), u = JSON.stringify(t);
  return r[u] || (r[u] = new IntersectionObserver(l8, { root: e, ...t })), r[u];
}
function f8(e, t, n) {
  const r = d8(t);
  return bc.set(e, n), r.observe(e), () => {
    bc.delete(e), r.unobserve(e);
  };
}
const p8 = {
  some: 0,
  all: 1
};
class h8 extends fr {
  constructor() {
    super(...arguments), this.hasEnteredView = !1, this.isInView = !1;
  }
  startObserver() {
    this.unmount();
    const { viewport: t = {} } = this.node.getProps(), { root: n, margin: r, amount: u = "some", once: i } = t, a = {
      root: n ? n.current : void 0,
      rootMargin: r,
      threshold: typeof u == "number" ? u : p8[u]
    }, o = (s) => {
      const { isIntersecting: c } = s;
      if (this.isInView === c || (this.isInView = c, i && !c && this.hasEnteredView))
        return;
      c && (this.hasEnteredView = !0), this.node.animationState && this.node.animationState.setActive("whileInView", c);
      const { onViewportEnter: l, onViewportLeave: d } = this.node.getProps(), f = c ? l : d;
      f && f(s);
    };
    return f8(this.node.current, a, o);
  }
  mount() {
    this.startObserver();
  }
  update() {
    if (typeof IntersectionObserver > "u")
      return;
    const { props: t, prevProps: n } = this.node;
    ["amount", "margin", "root"].some(m8(t, n)) && this.startObserver();
  }
  unmount() {
  }
}
function m8({ viewport: e = {} }, { viewport: t = {} } = {}) {
  return (n) => e[n] !== t[n];
}
const fb = {
  inView: {
    Feature: h8
  },
  tap: {
    Feature: s8
  },
  focus: {
    Feature: o8
  },
  hover: {
    Feature: a8
  }
};
function pb(e, t) {
  if (!Array.isArray(t))
    return !1;
  const n = t.length;
  if (n !== e.length)
    return !1;
  for (let r = 0; r < n; r++)
    if (t[r] !== e[r])
      return !1;
  return !0;
}
function g8(e) {
  const t = {};
  return e.values.forEach((n, r) => t[r] = n.get()), t;
}
function b8(e) {
  const t = {};
  return e.values.forEach((n, r) => t[r] = n.getVelocity()), t;
}
function _o(e, t, n) {
  const r = e.getProps();
  return kl(r, t, n !== void 0 ? n : r.custom, g8(e), b8(e));
}
let hb = it, So = it;
const qn = (e) => e * 1e3, En = (e) => e / 1e3, v8 = {
  current: !1
}, mb = (e) => Array.isArray(e) && typeof e[0] == "number";
function gb(e) {
  return !!(!e || typeof e == "string" && bb[e] || mb(e) || Array.isArray(e) && e.every(gb));
}
const ti = ([e, t, n, r]) => `cubic-bezier(${e}, ${t}, ${n}, ${r})`, bb = {
  linear: "linear",
  ease: "ease",
  easeIn: "ease-in",
  easeOut: "ease-out",
  easeInOut: "ease-in-out",
  circIn: ti([0, 0.65, 0.55, 1]),
  circOut: ti([0.55, 0, 1, 0.45]),
  backIn: ti([0.31, 0.01, 0.66, -0.59]),
  backOut: ti([0.33, 1.53, 0.69, 0.99])
};
function vb(e) {
  if (e)
    return mb(e) ? ti(e) : Array.isArray(e) ? e.map(vb) : bb[e];
}
function y8(e, t, n, { delay: r = 0, duration: u, repeat: i = 0, repeatType: a = "loop", ease: o, times: s } = {}) {
  const c = { [t]: n };
  s && (c.offset = s);
  const l = vb(o);
  return Array.isArray(l) && (c.easing = l), e.animate(c, {
    delay: r,
    duration: u,
    easing: Array.isArray(l) ? "linear" : l,
    fill: "both",
    iterations: i + 1,
    direction: a === "reverse" ? "alternate" : "normal"
  });
}
function x8(e, { repeat: t, repeatType: n = "loop" }) {
  const r = t && n !== "loop" && t % 2 === 1 ? 0 : e.length - 1;
  return e[r];
}
const yb = (e, t, n) => (((1 - 3 * n + 3 * t) * e + (3 * n - 6 * t)) * e + 3 * t) * e, _8 = 1e-7, S8 = 12;
function C8(e, t, n, r, u) {
  let i, a, o = 0;
  do
    a = t + (n - t) / 2, i = yb(a, r, u) - e, i > 0 ? n = a : t = a;
  while (Math.abs(i) > _8 && ++o < S8);
  return a;
}
function Hi(e, t, n, r) {
  if (e === t && n === r)
    return it;
  const u = (i) => C8(i, 0, 1, e, n);
  return (i) => i === 0 || i === 1 ? i : yb(u(i), t, r);
}
const E8 = Hi(0.42, 0, 1, 1), w8 = Hi(0, 0, 0.58, 1), xb = Hi(0.42, 0, 0.58, 1), _b = (e) => Array.isArray(e) && typeof e[0] != "number", Sb = (e) => (t) => t <= 0.5 ? e(2 * t) / 2 : (2 - e(2 * (1 - t))) / 2, Cb = (e) => (t) => 1 - e(1 - t), Ll = (e) => 1 - Math.sin(Math.acos(e)), Eb = Cb(Ll), T8 = Sb(Ll), wb = Hi(0.33, 1.53, 0.69, 0.99), Dl = Cb(wb), A8 = Sb(Dl), k8 = (e) => (e *= 2) < 1 ? 0.5 * Dl(e) : 0.5 * (2 - Math.pow(2, -10 * (e - 1))), L8 = {
  linear: it,
  easeIn: E8,
  easeInOut: xb,
  easeOut: w8,
  circIn: Ll,
  circInOut: T8,
  circOut: Eb,
  backIn: Dl,
  backInOut: A8,
  backOut: wb,
  anticipate: k8
}, xd = (e) => {
  if (Array.isArray(e)) {
    So(e.length === 4);
    const [t, n, r, u] = e;
    return Hi(t, n, r, u);
  } else if (typeof e == "string")
    return L8[e];
  return e;
}, Nl = (e, t) => (n) => !!(Bi(n) && Px.test(n) && n.startsWith(e) || t && Object.prototype.hasOwnProperty.call(n, t)), Tb = (e, t, n) => (r) => {
  if (!Bi(r))
    return r;
  const [u, i, a, o] = r.match(yo);
  return {
    [e]: parseFloat(u),
    [t]: parseFloat(i),
    [n]: parseFloat(a),
    alpha: o !== void 0 ? parseFloat(o) : 1
  };
}, D8 = (e) => ar(0, 255, e), ps = {
  ...Pr,
  transform: (e) => Math.round(D8(e))
}, Tr = {
  test: Nl("rgb", "red"),
  parse: Tb("red", "green", "blue"),
  transform: ({ red: e, green: t, blue: n, alpha: r = 1 }) => "rgba(" + ps.transform(e) + ", " + ps.transform(t) + ", " + ps.transform(n) + ", " + ai(ii.transform(r)) + ")"
};
function N8(e) {
  let t = "", n = "", r = "", u = "";
  return e.length > 5 ? (t = e.substring(1, 3), n = e.substring(3, 5), r = e.substring(5, 7), u = e.substring(7, 9)) : (t = e.substring(1, 2), n = e.substring(2, 3), r = e.substring(3, 4), u = e.substring(4, 5), t += t, n += n, r += r, u += u), {
    red: parseInt(t, 16),
    green: parseInt(n, 16),
    blue: parseInt(r, 16),
    alpha: u ? parseInt(u, 16) / 255 : 1
  };
}
const vc = {
  test: Nl("#"),
  parse: N8,
  transform: Tr.transform
}, ou = {
  test: Nl("hsl", "hue"),
  parse: Tb("hue", "saturation", "lightness"),
  transform: ({ hue: e, saturation: t, lightness: n, alpha: r = 1 }) => "hsla(" + Math.round(e) + ", " + Dn.transform(ai(t)) + ", " + Dn.transform(ai(n)) + ", " + ai(ii.transform(r)) + ")"
}, Pt = {
  test: (e) => Tr.test(e) || vc.test(e) || ou.test(e),
  parse: (e) => Tr.test(e) ? Tr.parse(e) : ou.test(e) ? ou.parse(e) : vc.parse(e),
  transform: (e) => Bi(e) ? e : e.hasOwnProperty("red") ? Tr.transform(e) : ou.transform(e)
}, tt = (e, t, n) => -n * e + n * t + e;
function hs(e, t, n) {
  return n < 0 && (n += 1), n > 1 && (n -= 1), n < 1 / 6 ? e + (t - e) * 6 * n : n < 1 / 2 ? t : n < 2 / 3 ? e + (t - e) * (2 / 3 - n) * 6 : e;
}
function O8({ hue: e, saturation: t, lightness: n, alpha: r }) {
  e /= 360, t /= 100, n /= 100;
  let u = 0, i = 0, a = 0;
  if (!t)
    u = i = a = n;
  else {
    const o = n < 0.5 ? n * (1 + t) : n + t - n * t, s = 2 * n - o;
    u = hs(s, o, e + 1 / 3), i = hs(s, o, e), a = hs(s, o, e - 1 / 3);
  }
  return {
    red: Math.round(u * 255),
    green: Math.round(i * 255),
    blue: Math.round(a * 255),
    alpha: r
  };
}
const ms = (e, t, n) => {
  const r = e * e;
  return Math.sqrt(Math.max(0, n * (t * t - r) + r));
}, I8 = [vc, Tr, ou], M8 = (e) => I8.find((t) => t.test(e));
function _d(e) {
  const t = M8(e);
  let n = t.parse(e);
  return t === ou && (n = O8(n)), n;
}
const Ab = (e, t) => {
  const n = _d(e), r = _d(t), u = { ...n };
  return (i) => (u.red = ms(n.red, r.red, i), u.green = ms(n.green, r.green, i), u.blue = ms(n.blue, r.blue, i), u.alpha = tt(n.alpha, r.alpha, i), Tr.transform(u));
};
function P8(e) {
  var t, n;
  return isNaN(e) && Bi(e) && (((t = e.match(yo)) === null || t === void 0 ? void 0 : t.length) || 0) + (((n = e.match(Yg)) === null || n === void 0 ? void 0 : n.length) || 0) > 0;
}
const kb = {
  regex: Ix,
  countKey: "Vars",
  token: "${v}",
  parse: it
}, Lb = {
  regex: Yg,
  countKey: "Colors",
  token: "${c}",
  parse: Pt.parse
}, Db = {
  regex: yo,
  countKey: "Numbers",
  token: "${n}",
  parse: Pr.parse
};
function gs(e, { regex: t, countKey: n, token: r, parse: u }) {
  const i = e.tokenised.match(t);
  i && (e["num" + n] = i.length, e.tokenised = e.tokenised.replace(t, r), e.values.push(...i.map(u)));
}
function Ha(e) {
  const t = e.toString(), n = {
    value: t,
    tokenised: t,
    values: [],
    numVars: 0,
    numColors: 0,
    numNumbers: 0
  };
  return n.value.includes("var(--") && gs(n, kb), gs(n, Lb), gs(n, Db), n;
}
function Nb(e) {
  return Ha(e).values;
}
function Ob(e) {
  const { values: t, numColors: n, numVars: r, tokenised: u } = Ha(e), i = t.length;
  return (a) => {
    let o = u;
    for (let s = 0; s < i; s++)
      s < r ? o = o.replace(kb.token, a[s]) : s < r + n ? o = o.replace(Lb.token, Pt.transform(a[s])) : o = o.replace(Db.token, ai(a[s]));
    return o;
  };
}
const R8 = (e) => typeof e == "number" ? 0 : e;
function B8(e) {
  const t = Nb(e);
  return Ob(e)(t.map(R8));
}
const or = {
  test: P8,
  parse: Nb,
  createTransformer: Ob,
  getAnimatableNone: B8
}, Ib = (e, t) => (n) => `${n > 0 ? t : e}`;
function Mb(e, t) {
  return typeof e == "number" ? (n) => tt(e, t, n) : Pt.test(e) ? Ab(e, t) : e.startsWith("var(") ? Ib(e, t) : Rb(e, t);
}
const Pb = (e, t) => {
  const n = [...e], r = n.length, u = e.map((i, a) => Mb(i, t[a]));
  return (i) => {
    for (let a = 0; a < r; a++)
      n[a] = u[a](i);
    return n;
  };
}, F8 = (e, t) => {
  const n = { ...e, ...t }, r = {};
  for (const u in n)
    e[u] !== void 0 && t[u] !== void 0 && (r[u] = Mb(e[u], t[u]));
  return (u) => {
    for (const i in r)
      n[i] = r[i](u);
    return n;
  };
}, Rb = (e, t) => {
  const n = or.createTransformer(t), r = Ha(e), u = Ha(t);
  return r.numVars === u.numVars && r.numColors === u.numColors && r.numNumbers >= u.numNumbers ? ir(Pb(r.values, u.values), n) : Ib(e, t);
}, Dr = (e, t, n) => {
  const r = t - e;
  return r === 0 ? 1 : (n - e) / r;
}, Sd = (e, t) => (n) => tt(e, t, n);
function H8(e) {
  return typeof e == "number" ? Sd : typeof e == "string" ? Pt.test(e) ? Ab : Rb : Array.isArray(e) ? Pb : typeof e == "object" ? F8 : Sd;
}
function $8(e, t, n) {
  const r = [], u = n || H8(e[0]), i = e.length - 1;
  for (let a = 0; a < i; a++) {
    let o = u(e[a], e[a + 1]);
    if (t) {
      const s = Array.isArray(t) ? t[a] || it : t;
      o = ir(s, o);
    }
    r.push(o);
  }
  return r;
}
function Co(e, t, { clamp: n = !0, ease: r, mixer: u } = {}) {
  const i = e.length;
  if (So(i === t.length), i === 1)
    return () => t[0];
  e[0] > e[i - 1] && (e = [...e].reverse(), t = [...t].reverse());
  const a = $8(t, r, u), o = a.length, s = (c) => {
    let l = 0;
    if (o > 1)
      for (; l < e.length - 2 && !(c < e[l + 1]); l++)
        ;
    const d = Dr(e[l], e[l + 1], c);
    return a[l](d);
  };
  return n ? (c) => s(ar(e[0], e[i - 1], c)) : s;
}
function Bb(e, t) {
  const n = e[e.length - 1];
  for (let r = 1; r <= t; r++) {
    const u = Dr(0, t, r);
    e.push(tt(n, 1, u));
  }
}
function Ol(e) {
  const t = [0];
  return Bb(t, e.length - 1), t;
}
function V8(e, t) {
  return e.map((n) => n * t);
}
function j8(e, t) {
  return e.map(() => t || xb).splice(0, e.length - 1);
}
function $a({ duration: e = 300, keyframes: t, times: n, ease: r = "easeInOut" }) {
  const u = _b(r) ? r.map(xd) : xd(r), i = {
    done: !1,
    value: t[0]
  }, a = V8(
    // Only use the provided offsets if they're the correct length
    // TODO Maybe we should warn here if there's a length mismatch
    n && n.length === t.length ? n : Ol(t),
    e
  ), o = Co(a, t, {
    ease: Array.isArray(u) ? u : j8(t, u)
  });
  return {
    calculatedDuration: e,
    next: (s) => (i.value = o(s), i.done = s >= e, i)
  };
}
function Il(e, t) {
  return t ? e * (1e3 / t) : 0;
}
const z8 = 5;
function Fb(e, t, n) {
  const r = Math.max(t - z8, 0);
  return Il(n - e(r), t - r);
}
const bs = 1e-3, U8 = 0.01, Cd = 10, q8 = 0.05, G8 = 1;
function W8({ duration: e = 800, bounce: t = 0.25, velocity: n = 0, mass: r = 1 }) {
  let u, i;
  hb(e <= qn(Cd));
  let a = 1 - t;
  a = ar(q8, G8, a), e = ar(U8, Cd, En(e)), a < 1 ? (u = (c) => {
    const l = c * a, d = l * e, f = l - n, p = yc(c, a), h = Math.exp(-d);
    return bs - f / p * h;
  }, i = (c) => {
    const d = c * a * e, f = d * n + n, p = Math.pow(a, 2) * Math.pow(c, 2) * e, h = Math.exp(-d), m = yc(Math.pow(c, 2), a);
    return (-u(c) + bs > 0 ? -1 : 1) * ((f - p) * h) / m;
  }) : (u = (c) => {
    const l = Math.exp(-c * e), d = (c - n) * e + 1;
    return -bs + l * d;
  }, i = (c) => {
    const l = Math.exp(-c * e), d = (n - c) * (e * e);
    return l * d;
  });
  const o = 5 / e, s = Y8(u, i, o);
  if (e = qn(e), isNaN(s))
    return {
      stiffness: 100,
      damping: 10,
      duration: e
    };
  {
    const c = Math.pow(s, 2) * r;
    return {
      stiffness: c,
      damping: a * 2 * Math.sqrt(r * c),
      duration: e
    };
  }
}
const K8 = 12;
function Y8(e, t, n) {
  let r = n;
  for (let u = 1; u < K8; u++)
    r = r - e(r) / t(r);
  return r;
}
function yc(e, t) {
  return e * Math.sqrt(1 - t * t);
}
const Z8 = ["duration", "bounce"], X8 = ["stiffness", "damping", "mass"];
function Ed(e, t) {
  return t.some((n) => e[n] !== void 0);
}
function Q8(e) {
  let t = {
    velocity: 0,
    stiffness: 100,
    damping: 10,
    mass: 1,
    isResolvedFromDuration: !1,
    ...e
  };
  if (!Ed(e, X8) && Ed(e, Z8)) {
    const n = W8(e);
    t = {
      ...t,
      ...n,
      mass: 1
    }, t.isResolvedFromDuration = !0;
  }
  return t;
}
function Ml({ keyframes: e, restDelta: t, restSpeed: n, ...r }) {
  const u = e[0], i = e[e.length - 1], a = { done: !1, value: u }, { stiffness: o, damping: s, mass: c, duration: l, velocity: d, isResolvedFromDuration: f } = Q8({
    ...r,
    velocity: -En(r.velocity || 0)
  }), p = d || 0, h = s / (2 * Math.sqrt(o * c)), m = i - u, b = En(Math.sqrt(o / c)), x = Math.abs(m) < 5;
  n || (n = x ? 0.01 : 2), t || (t = x ? 5e-3 : 0.5);
  let y;
  if (h < 1) {
    const g = yc(b, h);
    y = (v) => {
      const S = Math.exp(-h * b * v);
      return i - S * ((p + h * b * m) / g * Math.sin(g * v) + m * Math.cos(g * v));
    };
  } else if (h === 1)
    y = (g) => i - Math.exp(-b * g) * (m + (p + b * m) * g);
  else {
    const g = b * Math.sqrt(h * h - 1);
    y = (v) => {
      const S = Math.exp(-h * b * v), _ = Math.min(g * v, 300);
      return i - S * ((p + h * b * m) * Math.sinh(_) + g * m * Math.cosh(_)) / g;
    };
  }
  return {
    calculatedDuration: f && l || null,
    next: (g) => {
      const v = y(g);
      if (f)
        a.done = g >= l;
      else {
        let S = p;
        g !== 0 && (h < 1 ? S = Fb(y, g, v) : S = 0);
        const _ = Math.abs(S) <= n, A = Math.abs(i - v) <= t;
        a.done = _ && A;
      }
      return a.value = a.done ? i : v, a;
    }
  };
}
function wd({ keyframes: e, velocity: t = 0, power: n = 0.8, timeConstant: r = 325, bounceDamping: u = 10, bounceStiffness: i = 500, modifyTarget: a, min: o, max: s, restDelta: c = 0.5, restSpeed: l }) {
  const d = e[0], f = {
    done: !1,
    value: d
  }, p = (k) => o !== void 0 && k < o || s !== void 0 && k > s, h = (k) => o === void 0 ? s : s === void 0 || Math.abs(o - k) < Math.abs(s - k) ? o : s;
  let m = n * t;
  const b = d + m, x = a === void 0 ? b : a(b);
  x !== b && (m = x - d);
  const y = (k) => -m * Math.exp(-k / r), g = (k) => x + y(k), v = (k) => {
    const T = y(k), L = g(k);
    f.done = Math.abs(T) <= c, f.value = f.done ? x : L;
  };
  let S, _;
  const A = (k) => {
    p(f.value) && (S = k, _ = Ml({
      keyframes: [f.value, h(f.value)],
      velocity: Fb(g, k, f.value),
      damping: u,
      stiffness: i,
      restDelta: c,
      restSpeed: l
    }));
  };
  return A(0), {
    calculatedDuration: null,
    next: (k) => {
      let T = !1;
      return !_ && S === void 0 && (T = !0, v(k), A(k)), S !== void 0 && k > S ? _.next(k - S) : (!T && v(k), f);
    }
  };
}
const J8 = (e) => {
  const t = ({ timestamp: n }) => e(n);
  return {
    start: () => He.update(t, !0),
    stop: () => bn(t),
    /**
     * If we're processing this frame we can use the
     * framelocked timestamp to keep things in sync.
     */
    now: () => vt.isProcessing ? vt.timestamp : performance.now()
  };
}, xc = 2e4;
function _c(e) {
  let t = 0;
  const n = 50;
  let r = e.next(t);
  for (; !r.done && t < xc; )
    t += n, r = e.next(t);
  return t >= xc ? 1 / 0 : t;
}
const e_ = {
  decay: wd,
  inertia: wd,
  tween: $a,
  keyframes: $a,
  spring: Ml
};
function vi({ autoplay: e = !0, delay: t = 0, driver: n = J8, keyframes: r, type: u = "keyframes", repeat: i = 0, repeatDelay: a = 0, repeatType: o = "loop", onPlay: s, onStop: c, onComplete: l, onUpdate: d, ...f }) {
  let p = 1, h = !1, m, b;
  const x = () => {
    b = new Promise((C) => {
      m = C;
    });
  };
  x();
  let y;
  const g = e_[u] || $a;
  let v;
  g !== $a && typeof r[0] != "number" && (v = Co([0, 100], r, {
    clamp: !1
  }), r = [0, 100]);
  const S = g({ ...f, keyframes: r });
  let _;
  o === "mirror" && (_ = g({
    ...f,
    keyframes: [...r].reverse(),
    velocity: -(f.velocity || 0)
  }));
  let A = "idle", k = null, T = null, L = null;
  S.calculatedDuration === null && i && (S.calculatedDuration = _c(S));
  const { calculatedDuration: w } = S;
  let D = 1 / 0, N = 1 / 0;
  w !== null && (D = w + a, N = D * (i + 1) - a);
  let O = 0;
  const H = (C) => {
    if (T === null)
      return;
    p > 0 && (T = Math.min(T, C)), p < 0 && (T = Math.min(C - N / p, T)), k !== null ? O = k : O = Math.round(C - T) * p;
    const R = O - t * (p >= 0 ? 1 : -1), V = p >= 0 ? R < 0 : R > N;
    O = Math.max(R, 0), A === "finished" && k === null && (O = N);
    let I = O, G = S;
    if (i) {
      const X = Math.min(O, N) / D;
      let ne = Math.floor(X), fe = X % 1;
      !fe && X >= 1 && (fe = 1), fe === 1 && ne--, ne = Math.min(ne, i + 1), !!(ne % 2) && (o === "reverse" ? (fe = 1 - fe, a && (fe -= a / D)) : o === "mirror" && (G = _)), I = ar(0, 1, fe) * D;
    }
    const K = V ? { done: !1, value: r[0] } : G.next(I);
    v && (K.value = v(K.value));
    let { done: Q } = K;
    !V && w !== null && (Q = p >= 0 ? O >= N : O <= 0);
    const ae = k === null && (A === "finished" || A === "running" && Q);
    return d && d(K.value), ae && z(), K;
  }, $ = () => {
    y && y.stop(), y = void 0;
  }, j = () => {
    A = "idle", $(), m(), x(), T = L = null;
  }, z = () => {
    A = "finished", l && l(), $(), m();
  }, M = () => {
    if (h)
      return;
    y || (y = n(H));
    const C = y.now();
    s && s(), k !== null ? T = C - k : (!T || A === "finished") && (T = C), A === "finished" && x(), L = T, k = null, A = "running", y.start();
  };
  e && M();
  const P = {
    then(C, R) {
      return b.then(C, R);
    },
    get time() {
      return En(O);
    },
    set time(C) {
      C = qn(C), O = C, k !== null || !y || p === 0 ? k = C : T = y.now() - C / p;
    },
    get duration() {
      const C = S.calculatedDuration === null ? _c(S) : S.calculatedDuration;
      return En(C);
    },
    get speed() {
      return p;
    },
    set speed(C) {
      C === p || !y || (p = C, P.time = En(O));
    },
    get state() {
      return A;
    },
    play: M,
    pause: () => {
      A = "paused", k = O;
    },
    stop: () => {
      h = !0, A !== "idle" && (A = "idle", c && c(), j());
    },
    cancel: () => {
      L !== null && H(L), j();
    },
    complete: () => {
      A = "finished";
    },
    sample: (C) => (T = 0, H(C))
  };
  return P;
}
function Hb(e) {
  let t;
  return () => (t === void 0 && (t = e()), t);
}
const t_ = Hb(() => Object.hasOwnProperty.call(Element.prototype, "animate")), n_ = /* @__PURE__ */ new Set([
  "opacity",
  "clipPath",
  "filter",
  "transform",
  "backgroundColor"
]), ta = 10, r_ = 2e4, u_ = (e, t) => t.type === "spring" || e === "backgroundColor" || !gb(t.ease);
function i_(e, t, { onUpdate: n, onComplete: r, ...u }) {
  if (!(t_() && n_.has(t) && !u.repeatDelay && u.repeatType !== "mirror" && u.damping !== 0 && u.type !== "inertia"))
    return !1;
  let a = !1, o, s, c = !1;
  const l = () => {
    s = new Promise((g) => {
      o = g;
    });
  };
  l();
  let { keyframes: d, duration: f = 300, ease: p, times: h } = u;
  if (u_(t, u)) {
    const g = vi({
      ...u,
      repeat: 0,
      delay: 0
    });
    let v = { done: !1, value: d[0] };
    const S = [];
    let _ = 0;
    for (; !v.done && _ < r_; )
      v = g.sample(_), S.push(v.value), _ += ta;
    h = void 0, d = S, f = _ - ta, p = "linear";
  }
  const m = y8(e.owner.current, t, d, {
    ...u,
    duration: f,
    /**
     * This function is currently not called if ease is provided
     * as a function so the cast is safe.
     *
     * However it would be possible for a future refinement to port
     * in easing pregeneration from Motion One for browsers that
     * support the upcoming `linear()` easing function.
     */
    ease: p,
    times: h
  }), b = () => {
    c = !1, m.cancel();
  }, x = () => {
    c = !0, He.update(b), o(), l();
  };
  return m.onfinish = () => {
    c || (e.set(x8(d, u)), r && r(), x());
  }, {
    then(g, v) {
      return s.then(g, v);
    },
    attachTimeline(g) {
      return m.timeline = g, m.onfinish = null, it;
    },
    get time() {
      return En(m.currentTime || 0);
    },
    set time(g) {
      m.currentTime = qn(g);
    },
    get speed() {
      return m.playbackRate;
    },
    set speed(g) {
      m.playbackRate = g;
    },
    get duration() {
      return En(f);
    },
    play: () => {
      a || (m.play(), bn(b));
    },
    pause: () => m.pause(),
    stop: () => {
      if (a = !0, m.playState === "idle")
        return;
      const { currentTime: g } = m;
      if (g) {
        const v = vi({
          ...u,
          autoplay: !1
        });
        e.setWithVelocity(v.sample(g - ta).value, v.sample(g).value, ta);
      }
      x();
    },
    complete: () => {
      c || m.finish();
    },
    cancel: x
  };
}
function a_({ keyframes: e, delay: t, onUpdate: n, onComplete: r }) {
  const u = () => (n && n(e[e.length - 1]), r && r(), {
    time: 0,
    speed: 1,
    duration: 0,
    play: it,
    pause: it,
    stop: it,
    then: (i) => (i(), Promise.resolve()),
    cancel: it,
    complete: it
  });
  return t ? vi({
    keyframes: [0, 1],
    duration: 0,
    delay: t,
    onComplete: u
  }) : u();
}
const o_ = {
  type: "spring",
  stiffness: 500,
  damping: 25,
  restSpeed: 10
}, s_ = (e) => ({
  type: "spring",
  stiffness: 550,
  damping: e === 0 ? 2 * Math.sqrt(550) : 30,
  restSpeed: 10
}), c_ = {
  type: "keyframes",
  duration: 0.8
}, l_ = {
  type: "keyframes",
  ease: [0.25, 0.1, 0.35, 1],
  duration: 0.3
}, d_ = (e, { keyframes: t }) => t.length > 2 ? c_ : Wn.has(e) ? e.startsWith("scale") ? s_(t[1]) : o_ : l_, Sc = (e, t) => e === "zIndex" ? !1 : !!(typeof t == "number" || Array.isArray(t) || typeof t == "string" && // It's animatable if we have a string
(or.test(t) || t === "0") && // And it contains numbers and/or colors
!t.startsWith("url(")), f_ = /* @__PURE__ */ new Set(["brightness", "contrast", "saturate", "opacity"]);
function p_(e) {
  const [t, n] = e.slice(0, -1).split("(");
  if (t === "drop-shadow")
    return e;
  const [r] = n.match(yo) || [];
  if (!r)
    return e;
  const u = n.replace(r, "");
  let i = f_.has(t) ? 1 : 0;
  return r !== n && (i *= 100), t + "(" + i + u + ")";
}
const h_ = /([a-z-]*)\(.*?\)/g, Cc = {
  ...or,
  getAnimatableNone: (e) => {
    const t = e.match(h_);
    return t ? t.map(p_).join(" ") : e;
  }
}, m_ = {
  ...Zg,
  // Color props
  color: Pt,
  backgroundColor: Pt,
  outlineColor: Pt,
  fill: Pt,
  stroke: Pt,
  // Border props
  borderColor: Pt,
  borderTopColor: Pt,
  borderRightColor: Pt,
  borderBottomColor: Pt,
  borderLeftColor: Pt,
  filter: Cc,
  WebkitFilter: Cc
}, Pl = (e) => m_[e];
function $b(e, t) {
  let n = Pl(e);
  return n !== Cc && (n = or), n.getAnimatableNone ? n.getAnimatableNone(t) : void 0;
}
const Vb = (e) => /^0[^.\s]+$/.test(e);
function g_(e) {
  if (typeof e == "number")
    return e === 0;
  if (e !== null)
    return e === "none" || e === "0" || Vb(e);
}
function b_(e, t, n, r) {
  const u = Sc(t, n);
  let i;
  Array.isArray(n) ? i = [...n] : i = [null, n];
  const a = r.from !== void 0 ? r.from : e.get();
  let o;
  const s = [];
  for (let c = 0; c < i.length; c++)
    i[c] === null && (i[c] = c === 0 ? a : i[c - 1]), g_(i[c]) && s.push(c), typeof i[c] == "string" && i[c] !== "none" && i[c] !== "0" && (o = i[c]);
  if (u && s.length && o)
    for (let c = 0; c < s.length; c++) {
      const l = s[c];
      i[l] = $b(t, o);
    }
  return i;
}
function v_({ when: e, delay: t, delayChildren: n, staggerChildren: r, staggerDirection: u, repeat: i, repeatType: a, repeatDelay: o, from: s, elapsed: c, ...l }) {
  return !!Object.keys(l).length;
}
function Rl(e, t) {
  return e[t] || e.default || e;
}
const y_ = {
  skipAnimations: !1
}, Bl = (e, t, n, r = {}) => (u) => {
  const i = Rl(r, e) || {}, a = i.delay || r.delay || 0;
  let { elapsed: o = 0 } = r;
  o = o - qn(a);
  const s = b_(t, e, n, i), c = s[0], l = s[s.length - 1], d = Sc(e, c), f = Sc(e, l);
  let p = {
    keyframes: s,
    velocity: t.getVelocity(),
    ease: "easeOut",
    ...i,
    delay: -o,
    onUpdate: (h) => {
      t.set(h), i.onUpdate && i.onUpdate(h);
    },
    onComplete: () => {
      u(), i.onComplete && i.onComplete();
    }
  };
  if (v_(i) || (p = {
    ...p,
    ...d_(e, p)
  }), p.duration && (p.duration = qn(p.duration)), p.repeatDelay && (p.repeatDelay = qn(p.repeatDelay)), !d || !f || v8.current || i.type === !1 || y_.skipAnimations)
    return a_(p);
  if (
    /**
     * If this is a handoff animation, the optimised animation will be running via
     * WAAPI. Therefore, this animation must be JS to ensure it runs "under" the
     * optimised animation.
     */
    !r.isHandoff && t.owner && t.owner.current instanceof HTMLElement && /**
     * If we're outputting values to onUpdate then we can't use WAAPI as there's
     * no way to read the value from WAAPI every frame.
     */
    !t.owner.getProps().onUpdate
  ) {
    const h = i_(t, e, p);
    if (h)
      return h;
  }
  return vi(p);
};
function Va(e) {
  return !!(wt(e) && e.add);
}
const jb = (e) => /^\-?\d*\.?\d+$/.test(e);
function Eo(e, t) {
  e.indexOf(t) === -1 && e.push(t);
}
function Tu(e, t) {
  const n = e.indexOf(t);
  n > -1 && e.splice(n, 1);
}
class Fl {
  constructor() {
    this.subscriptions = [];
  }
  add(t) {
    return Eo(this.subscriptions, t), () => Tu(this.subscriptions, t);
  }
  notify(t, n, r) {
    const u = this.subscriptions.length;
    if (u)
      if (u === 1)
        this.subscriptions[0](t, n, r);
      else
        for (let i = 0; i < u; i++) {
          const a = this.subscriptions[i];
          a && a(t, n, r);
        }
  }
  getSize() {
    return this.subscriptions.length;
  }
  clear() {
    this.subscriptions.length = 0;
  }
}
const x_ = (e) => !isNaN(parseFloat(e)), oi = {
  current: void 0
};
class zb {
  /**
   * @param init - The initiating value
   * @param config - Optional configuration options
   *
   * -  `transformer`: A function to transform incoming values with.
   *
   * @internal
   */
  constructor(t, n = {}) {
    this.version = "10.18.0", this.timeDelta = 0, this.lastUpdated = 0, this.canTrackVelocity = !1, this.events = {}, this.updateAndNotify = (r, u = !0) => {
      this.prev = this.current, this.current = r;
      const { delta: i, timestamp: a } = vt;
      this.lastUpdated !== a && (this.timeDelta = i, this.lastUpdated = a, He.postRender(this.scheduleVelocityCheck)), this.prev !== this.current && this.events.change && this.events.change.notify(this.current), this.events.velocityChange && this.events.velocityChange.notify(this.getVelocity()), u && this.events.renderRequest && this.events.renderRequest.notify(this.current);
    }, this.scheduleVelocityCheck = () => He.postRender(this.velocityCheck), this.velocityCheck = ({ timestamp: r }) => {
      r !== this.lastUpdated && (this.prev = this.current, this.events.velocityChange && this.events.velocityChange.notify(this.getVelocity()));
    }, this.hasAnimated = !1, this.prev = this.current = t, this.canTrackVelocity = x_(this.current), this.owner = n.owner;
  }
  /**
   * Adds a function that will be notified when the `MotionValue` is updated.
   *
   * It returns a function that, when called, will cancel the subscription.
   *
   * When calling `onChange` inside a React component, it should be wrapped with the
   * `useEffect` hook. As it returns an unsubscribe function, this should be returned
   * from the `useEffect` function to ensure you don't add duplicate subscribers..
   *
   * ```jsx
   * export const MyComponent = () => {
   *   const x = useMotionValue(0)
   *   const y = useMotionValue(0)
   *   const opacity = useMotionValue(1)
   *
   *   useEffect(() => {
   *     function updateOpacity() {
   *       const maxXY = Math.max(x.get(), y.get())
   *       const newOpacity = transform(maxXY, [0, 100], [1, 0])
   *       opacity.set(newOpacity)
   *     }
   *
   *     const unsubscribeX = x.on("change", updateOpacity)
   *     const unsubscribeY = y.on("change", updateOpacity)
   *
   *     return () => {
   *       unsubscribeX()
   *       unsubscribeY()
   *     }
   *   }, [])
   *
   *   return <motion.div style={{ x }} />
   * }
   * ```
   *
   * @param subscriber - A function that receives the latest value.
   * @returns A function that, when called, will cancel this subscription.
   *
   * @deprecated
   */
  onChange(t) {
    return this.on("change", t);
  }
  on(t, n) {
    this.events[t] || (this.events[t] = new Fl());
    const r = this.events[t].add(n);
    return t === "change" ? () => {
      r(), He.read(() => {
        this.events.change.getSize() || this.stop();
      });
    } : r;
  }
  clearListeners() {
    for (const t in this.events)
      this.events[t].clear();
  }
  /**
   * Attaches a passive effect to the `MotionValue`.
   *
   * @internal
   */
  attach(t, n) {
    this.passiveEffect = t, this.stopPassiveEffect = n;
  }
  /**
   * Sets the state of the `MotionValue`.
   *
   * @remarks
   *
   * ```jsx
   * const x = useMotionValue(0)
   * x.set(10)
   * ```
   *
   * @param latest - Latest value to set.
   * @param render - Whether to notify render subscribers. Defaults to `true`
   *
   * @public
   */
  set(t, n = !0) {
    !n || !this.passiveEffect ? this.updateAndNotify(t, n) : this.passiveEffect(t, this.updateAndNotify);
  }
  setWithVelocity(t, n, r) {
    this.set(n), this.prev = t, this.timeDelta = r;
  }
  /**
   * Set the state of the `MotionValue`, stopping any active animations,
   * effects, and resets velocity to `0`.
   */
  jump(t) {
    this.updateAndNotify(t), this.prev = t, this.stop(), this.stopPassiveEffect && this.stopPassiveEffect();
  }
  /**
   * Returns the latest state of `MotionValue`
   *
   * @returns - The latest state of `MotionValue`
   *
   * @public
   */
  get() {
    return oi.current && oi.current.push(this), this.current;
  }
  /**
   * @public
   */
  getPrevious() {
    return this.prev;
  }
  /**
   * Returns the latest velocity of `MotionValue`
   *
   * @returns - The latest velocity of `MotionValue`. Returns `0` if the state is non-numerical.
   *
   * @public
   */
  getVelocity() {
    return this.canTrackVelocity ? (
      // These casts could be avoided if parseFloat would be typed better
      Il(parseFloat(this.current) - parseFloat(this.prev), this.timeDelta)
    ) : 0;
  }
  /**
   * Registers a new animation to control this `MotionValue`. Only one
   * animation can drive a `MotionValue` at one time.
   *
   * ```jsx
   * value.start()
   * ```
   *
   * @param animation - A function that starts the provided animation
   *
   * @internal
   */
  start(t) {
    return this.stop(), new Promise((n) => {
      this.hasAnimated = !0, this.animation = t(n), this.events.animationStart && this.events.animationStart.notify();
    }).then(() => {
      this.events.animationComplete && this.events.animationComplete.notify(), this.clearAnimation();
    });
  }
  /**
   * Stop the currently active animation.
   *
   * @public
   */
  stop() {
    this.animation && (this.animation.stop(), this.events.animationCancel && this.events.animationCancel.notify()), this.clearAnimation();
  }
  /**
   * Returns `true` if this value is currently animating.
   *
   * @public
   */
  isAnimating() {
    return !!this.animation;
  }
  clearAnimation() {
    delete this.animation;
  }
  /**
   * Destroy and clean up subscribers to this `MotionValue`.
   *
   * The `MotionValue` hooks like `useMotionValue` and `useTransform` automatically
   * handle the lifecycle of the returned `MotionValue`, so this method is only necessary if you've manually
   * created a `MotionValue` via the `motionValue` function.
   *
   * @public
   */
  destroy() {
    this.clearListeners(), this.stop(), this.stopPassiveEffect && this.stopPassiveEffect();
  }
}
function mn(e, t) {
  return new zb(e, t);
}
const Ub = (e) => (t) => t.test(e), __ = {
  test: (e) => e === "auto",
  parse: (e) => e
}, qb = [Pr, be, Dn, Qn, Bx, Rx, __], zu = (e) => qb.find(Ub(e)), S_ = [...qb, Pt, or], C_ = (e) => S_.find(Ub(e));
function E_(e, t, n) {
  e.hasValue(t) ? e.getValue(t).set(n) : e.addValue(t, mn(n));
}
function Hl(e, t) {
  const n = _o(e, t);
  let { transitionEnd: r = {}, transition: u = {}, ...i } = n ? e.makeTargetAnimatable(n, !1) : {};
  i = { ...i, ...r };
  for (const a in i) {
    const o = Zx(i[a]);
    E_(e, a, o);
  }
}
function Ec(e, t) {
  [...t].reverse().forEach((r) => {
    const u = e.getVariant(r);
    u && Hl(e, u), e.variantChildren && e.variantChildren.forEach((i) => {
      Ec(i, t);
    });
  });
}
function w_(e, t) {
  if (Array.isArray(t))
    return Ec(e, t);
  if (typeof t == "string")
    return Ec(e, [t]);
  Hl(e, t);
}
function T_(e, t, n) {
  var r, u;
  const i = Object.keys(t).filter((o) => !e.hasValue(o)), a = i.length;
  if (a)
    for (let o = 0; o < a; o++) {
      const s = i[o], c = t[s];
      let l = null;
      Array.isArray(c) && (l = c[0]), l === null && (l = (u = (r = n[s]) !== null && r !== void 0 ? r : e.readValue(s)) !== null && u !== void 0 ? u : t[s]), l != null && (typeof l == "string" && (jb(l) || Vb(l)) ? l = parseFloat(l) : !C_(l) && or.test(c) && (l = $b(s, c)), e.addValue(s, mn(l, { owner: e })), n[s] === void 0 && (n[s] = l), l !== null && e.setBaseTarget(s, l));
    }
}
function A_(e, t) {
  return t ? (t[e] || t.default || t).from : void 0;
}
function k_(e, t, n) {
  const r = {};
  for (const u in e) {
    const i = A_(u, t);
    if (i !== void 0)
      r[u] = i;
    else {
      const a = n.getValue(u);
      a && (r[u] = a.get());
    }
  }
  return r;
}
function L_({ protectedKeys: e, needsAnimating: t }, n) {
  const r = e.hasOwnProperty(n) && t[n] !== !0;
  return t[n] = !1, r;
}
function D_(e, t) {
  const n = e.get();
  if (Array.isArray(t)) {
    for (let r = 0; r < t.length; r++)
      if (t[r] !== n)
        return !0;
  } else
    return n !== t;
}
function $l(e, t, { delay: n = 0, transitionOverride: r, type: u } = {}) {
  let { transition: i = e.getDefaultTransition(), transitionEnd: a, ...o } = e.makeTargetAnimatable(t);
  const s = e.getValue("willChange");
  r && (i = r);
  const c = [], l = u && e.animationState && e.animationState.getState()[u];
  for (const d in o) {
    const f = e.getValue(d), p = o[d];
    if (!f || p === void 0 || l && L_(l, d))
      continue;
    const h = {
      delay: n,
      elapsed: 0,
      ...Rl(i || {}, d)
    };
    if (window.HandoffAppearAnimations) {
      const x = e.getProps()[zg];
      if (x) {
        const y = window.HandoffAppearAnimations(x, d, f, He);
        y !== null && (h.elapsed = y, h.isHandoff = !0);
      }
    }
    let m = !h.isHandoff && !D_(f, p);
    if (h.type === "spring" && (f.getVelocity() || h.velocity) && (m = !1), f.animation && (m = !1), m)
      continue;
    f.start(Bl(d, f, p, e.shouldReduceMotion && Wn.has(d) ? { type: !1 } : h));
    const b = f.animation;
    Va(s) && (s.add(d), b.then(() => s.remove(d))), c.push(b);
  }
  return a && Promise.all(c).then(() => {
    a && Hl(e, a);
  }), c;
}
function wc(e, t, n = {}) {
  const r = _o(e, t, n.custom);
  let { transition: u = e.getDefaultTransition() || {} } = r || {};
  n.transitionOverride && (u = n.transitionOverride);
  const i = r ? () => Promise.all($l(e, r, n)) : () => Promise.resolve(), a = e.variantChildren && e.variantChildren.size ? (s = 0) => {
    const { delayChildren: c = 0, staggerChildren: l, staggerDirection: d } = u;
    return N_(e, t, c + s, l, d, n);
  } : () => Promise.resolve(), { when: o } = u;
  if (o) {
    const [s, c] = o === "beforeChildren" ? [i, a] : [a, i];
    return s().then(() => c());
  } else
    return Promise.all([i(), a(n.delay)]);
}
function N_(e, t, n = 0, r = 0, u = 1, i) {
  const a = [], o = (e.variantChildren.size - 1) * r, s = u === 1 ? (c = 0) => c * r : (c = 0) => o - c * r;
  return Array.from(e.variantChildren).sort(O_).forEach((c, l) => {
    c.notify("AnimationStart", t), a.push(wc(c, t, {
      ...i,
      delay: n + s(l)
    }).then(() => c.notify("AnimationComplete", t)));
  }), Promise.all(a);
}
function O_(e, t) {
  return e.sortNodePosition(t);
}
function Gb(e, t, n = {}) {
  e.notify("AnimationStart", t);
  let r;
  if (Array.isArray(t)) {
    const u = t.map((i) => wc(e, i, n));
    r = Promise.all(u);
  } else if (typeof t == "string")
    r = wc(e, t, n);
  else {
    const u = typeof t == "function" ? _o(e, t, n.custom) : t;
    r = Promise.all($l(e, u, n));
  }
  return r.then(() => e.notify("AnimationComplete", t));
}
const I_ = [...vl].reverse(), M_ = vl.length;
function P_(e) {
  return (t) => Promise.all(t.map(({ animation: n, options: r }) => Gb(e, n, r)));
}
function R_(e) {
  let t = P_(e);
  const n = F_();
  let r = !0;
  const u = (s, c) => {
    const l = _o(e, c);
    if (l) {
      const { transition: d, transitionEnd: f, ...p } = l;
      s = { ...s, ...p, ...f };
    }
    return s;
  };
  function i(s) {
    t = s(e);
  }
  function a(s, c) {
    const l = e.getProps(), d = e.getVariantContext(!0) || {}, f = [], p = /* @__PURE__ */ new Set();
    let h = {}, m = 1 / 0;
    for (let x = 0; x < M_; x++) {
      const y = I_[x], g = n[y], v = l[y] !== void 0 ? l[y] : d[y], S = gi(v), _ = y === c ? g.isActive : null;
      _ === !1 && (m = x);
      let A = v === d[y] && v !== l[y] && S;
      if (A && r && e.manuallyAnimateOnMount && (A = !1), g.protectedKeys = { ...h }, // If it isn't active and hasn't *just* been set as inactive
      !g.isActive && _ === null || // If we didn't and don't have any defined prop for this animation type
      !v && !g.prevProp || // Or if the prop doesn't define an animation
      bo(v) || typeof v == "boolean")
        continue;
      let T = B_(g.prevProp, v) || // If we're making this variant active, we want to always make it active
      y === c && g.isActive && !A && S || // If we removed a higher-priority variant (i is in reverse order)
      x > m && S, L = !1;
      const w = Array.isArray(v) ? v : [v];
      let D = w.reduce(u, {});
      _ === !1 && (D = {});
      const { prevResolvedValues: N = {} } = g, O = {
        ...N,
        ...D
      }, H = ($) => {
        T = !0, p.has($) && (L = !0, p.delete($)), g.needsAnimating[$] = !0;
      };
      for (const $ in O) {
        const j = D[$], z = N[$];
        if (h.hasOwnProperty($))
          continue;
        let M = !1;
        Fa(j) && Fa(z) ? M = !pb(j, z) : M = j !== z, M ? j !== void 0 ? H($) : p.add($) : j !== void 0 && p.has($) ? H($) : g.protectedKeys[$] = !0;
      }
      g.prevProp = v, g.prevResolvedValues = D, g.isActive && (h = { ...h, ...D }), r && e.blockInitialAnimation && (T = !1), T && (!A || L) && f.push(...w.map(($) => ({
        animation: $,
        options: { type: y, ...s }
      })));
    }
    if (p.size) {
      const x = {};
      p.forEach((y) => {
        const g = e.getBaseTarget(y);
        g !== void 0 && (x[y] = g);
      }), f.push({ animation: x });
    }
    let b = !!f.length;
    return r && (l.initial === !1 || l.initial === l.animate) && !e.manuallyAnimateOnMount && (b = !1), r = !1, b ? t(f) : Promise.resolve();
  }
  function o(s, c, l) {
    var d;
    if (n[s].isActive === c)
      return Promise.resolve();
    (d = e.variantChildren) === null || d === void 0 || d.forEach((p) => {
      var h;
      return (h = p.animationState) === null || h === void 0 ? void 0 : h.setActive(s, c);
    }), n[s].isActive = c;
    const f = a(l, s);
    for (const p in n)
      n[p].protectedKeys = {};
    return f;
  }
  return {
    animateChanges: a,
    setActive: o,
    setAnimateFunction: i,
    getState: () => n
  };
}
function B_(e, t) {
  return typeof t == "string" ? t !== e : Array.isArray(t) ? !pb(t, e) : !1;
}
function yr(e = !1) {
  return {
    isActive: e,
    protectedKeys: {},
    needsAnimating: {},
    prevResolvedValues: {}
  };
}
function F_() {
  return {
    animate: yr(!0),
    whileInView: yr(),
    whileHover: yr(),
    whileTap: yr(),
    whileDrag: yr(),
    whileFocus: yr(),
    exit: yr()
  };
}
class H_ extends fr {
  /**
   * We dynamically generate the AnimationState manager as it contains a reference
   * to the underlying animation library. We only want to load that if we load this,
   * so people can optionally code split it out using the `m` component.
   */
  constructor(t) {
    super(t), t.animationState || (t.animationState = R_(t));
  }
  updateAnimationControlsSubscription() {
    const { animate: t } = this.node.getProps();
    this.unmount(), bo(t) && (this.unmount = t.subscribe(this.node));
  }
  /**
   * Subscribe any provided AnimationControls to the component's VisualElement
   */
  mount() {
    this.updateAnimationControlsSubscription();
  }
  update() {
    const { animate: t } = this.node.getProps(), { animate: n } = this.node.prevProps || {};
    t !== n && this.updateAnimationControlsSubscription();
  }
  unmount() {
  }
}
let $_ = 0;
class V_ extends fr {
  constructor() {
    super(...arguments), this.id = $_++;
  }
  update() {
    if (!this.node.presenceContext)
      return;
    const { isPresent: t, onExitComplete: n, custom: r } = this.node.presenceContext, { isPresent: u } = this.node.prevPresenceContext || {};
    if (!this.node.animationState || t === u)
      return;
    const i = this.node.animationState.setActive("exit", !t, { custom: r ?? this.node.getProps().custom });
    n && !t && i.then(() => n(this.id));
  }
  mount() {
    const { register: t } = this.node.presenceContext || {};
    t && (this.unmount = t(this.id));
  }
  unmount() {
  }
}
const Wb = {
  animation: {
    Feature: H_
  },
  exit: {
    Feature: V_
  }
}, Td = (e, t) => Math.abs(e - t);
function j_(e, t) {
  const n = Td(e.x, t.x), r = Td(e.y, t.y);
  return Math.sqrt(n ** 2 + r ** 2);
}
class Kb {
  constructor(t, n, { transformPagePoint: r, contextWindow: u, dragSnapToOrigin: i = !1 } = {}) {
    if (this.startEvent = null, this.lastMoveEvent = null, this.lastMoveEventInfo = null, this.handlers = {}, this.contextWindow = window, this.updatePoint = () => {
      if (!(this.lastMoveEvent && this.lastMoveEventInfo))
        return;
      const d = ys(this.lastMoveEventInfo, this.history), f = this.startEvent !== null, p = j_(d.offset, { x: 0, y: 0 }) >= 3;
      if (!f && !p)
        return;
      const { point: h } = d, { timestamp: m } = vt;
      this.history.push({ ...h, timestamp: m });
      const { onStart: b, onMove: x } = this.handlers;
      f || (b && b(this.lastMoveEvent, d), this.startEvent = this.lastMoveEvent), x && x(this.lastMoveEvent, d);
    }, this.handlePointerMove = (d, f) => {
      this.lastMoveEvent = d, this.lastMoveEventInfo = vs(f, this.transformPagePoint), He.update(this.updatePoint, !0);
    }, this.handlePointerUp = (d, f) => {
      this.end();
      const { onEnd: p, onSessionEnd: h, resumeAnimation: m } = this.handlers;
      if (this.dragSnapToOrigin && m && m(), !(this.lastMoveEvent && this.lastMoveEventInfo))
        return;
      const b = ys(d.type === "pointercancel" ? this.lastMoveEventInfo : vs(f, this.transformPagePoint), this.history);
      this.startEvent && p && p(d, b), h && h(d, b);
    }, !ob(t))
      return;
    this.dragSnapToOrigin = i, this.handlers = n, this.transformPagePoint = r, this.contextWindow = u || window;
    const a = xo(t), o = vs(a, this.transformPagePoint), { point: s } = o, { timestamp: c } = vt;
    this.history = [{ ...s, timestamp: c }];
    const { onSessionStart: l } = n;
    l && l(t, ys(o, this.history)), this.removeListeners = ir(Un(this.contextWindow, "pointermove", this.handlePointerMove), Un(this.contextWindow, "pointerup", this.handlePointerUp), Un(this.contextWindow, "pointercancel", this.handlePointerUp));
  }
  updateHandlers(t) {
    this.handlers = t;
  }
  end() {
    this.removeListeners && this.removeListeners(), bn(this.updatePoint);
  }
}
function vs(e, t) {
  return t ? { point: t(e.point) } : e;
}
function Ad(e, t) {
  return { x: e.x - t.x, y: e.y - t.y };
}
function ys({ point: e }, t) {
  return {
    point: e,
    delta: Ad(e, Yb(t)),
    offset: Ad(e, z_(t)),
    velocity: U_(t, 0.1)
  };
}
function z_(e) {
  return e[0];
}
function Yb(e) {
  return e[e.length - 1];
}
function U_(e, t) {
  if (e.length < 2)
    return { x: 0, y: 0 };
  let n = e.length - 1, r = null;
  const u = Yb(e);
  for (; n >= 0 && (r = e[n], !(u.timestamp - r.timestamp > qn(t))); )
    n--;
  if (!r)
    return { x: 0, y: 0 };
  const i = En(u.timestamp - r.timestamp);
  if (i === 0)
    return { x: 0, y: 0 };
  const a = {
    x: (u.x - r.x) / i,
    y: (u.y - r.y) / i
  };
  return a.x === 1 / 0 && (a.x = 0), a.y === 1 / 0 && (a.y = 0), a;
}
function sn(e) {
  return e.max - e.min;
}
function Tc(e, t = 0, n = 0.01) {
  return Math.abs(e - t) <= n;
}
function kd(e, t, n, r = 0.5) {
  e.origin = r, e.originPoint = tt(t.min, t.max, e.origin), e.scale = sn(n) / sn(t), (Tc(e.scale, 1, 1e-4) || isNaN(e.scale)) && (e.scale = 1), e.translate = tt(n.min, n.max, e.origin) - e.originPoint, (Tc(e.translate) || isNaN(e.translate)) && (e.translate = 0);
}
function si(e, t, n, r) {
  kd(e.x, t.x, n.x, r ? r.originX : void 0), kd(e.y, t.y, n.y, r ? r.originY : void 0);
}
function Ld(e, t, n) {
  e.min = n.min + t.min, e.max = e.min + sn(t);
}
function q_(e, t, n) {
  Ld(e.x, t.x, n.x), Ld(e.y, t.y, n.y);
}
function Dd(e, t, n) {
  e.min = t.min - n.min, e.max = e.min + sn(t);
}
function ci(e, t, n) {
  Dd(e.x, t.x, n.x), Dd(e.y, t.y, n.y);
}
function G_(e, { min: t, max: n }, r) {
  return t !== void 0 && e < t ? e = r ? tt(t, e, r.min) : Math.max(e, t) : n !== void 0 && e > n && (e = r ? tt(n, e, r.max) : Math.min(e, n)), e;
}
function Nd(e, t, n) {
  return {
    min: t !== void 0 ? e.min + t : void 0,
    max: n !== void 0 ? e.max + n - (e.max - e.min) : void 0
  };
}
function W_(e, { top: t, left: n, bottom: r, right: u }) {
  return {
    x: Nd(e.x, n, u),
    y: Nd(e.y, t, r)
  };
}
function Od(e, t) {
  let n = t.min - e.min, r = t.max - e.max;
  return t.max - t.min < e.max - e.min && ([n, r] = [r, n]), { min: n, max: r };
}
function K_(e, t) {
  return {
    x: Od(e.x, t.x),
    y: Od(e.y, t.y)
  };
}
function Y_(e, t) {
  let n = 0.5;
  const r = sn(e), u = sn(t);
  return u > r ? n = Dr(t.min, t.max - r, e.min) : r > u && (n = Dr(e.min, e.max - u, t.min)), ar(0, 1, n);
}
function Z_(e, t) {
  const n = {};
  return t.min !== void 0 && (n.min = t.min - e.min), t.max !== void 0 && (n.max = t.max - e.min), n;
}
const Ac = 0.35;
function X_(e = Ac) {
  return e === !1 ? e = 0 : e === !0 && (e = Ac), {
    x: Id(e, "left", "right"),
    y: Id(e, "top", "bottom")
  };
}
function Id(e, t, n) {
  return {
    min: Md(e, t),
    max: Md(e, n)
  };
}
function Md(e, t) {
  return typeof e == "number" ? e : e[t] || 0;
}
const Pd = () => ({
  translate: 0,
  scale: 1,
  origin: 0,
  originPoint: 0
}), su = () => ({
  x: Pd(),
  y: Pd()
}), Rd = () => ({ min: 0, max: 0 }), pt = () => ({
  x: Rd(),
  y: Rd()
});
function hn(e) {
  return [e("x"), e("y")];
}
function Zb({ top: e, left: t, right: n, bottom: r }) {
  return {
    x: { min: t, max: n },
    y: { min: e, max: r }
  };
}
function Q_({ x: e, y: t }) {
  return { top: t.min, right: e.max, bottom: t.max, left: e.min };
}
function J_(e, t) {
  if (!t)
    return e;
  const n = t({ x: e.left, y: e.top }), r = t({ x: e.right, y: e.bottom });
  return {
    top: n.y,
    left: n.x,
    bottom: r.y,
    right: r.x
  };
}
function xs(e) {
  return e === void 0 || e === 1;
}
function kc({ scale: e, scaleX: t, scaleY: n }) {
  return !xs(e) || !xs(t) || !xs(n);
}
function xr(e) {
  return kc(e) || Xb(e) || e.z || e.rotate || e.rotateX || e.rotateY;
}
function Xb(e) {
  return Bd(e.x) || Bd(e.y);
}
function Bd(e) {
  return e && e !== "0%";
}
function ja(e, t, n) {
  const r = e - n, u = t * r;
  return n + u;
}
function Fd(e, t, n, r, u) {
  return u !== void 0 && (e = ja(e, u, r)), ja(e, n, r) + t;
}
function Lc(e, t = 0, n = 1, r, u) {
  e.min = Fd(e.min, t, n, r, u), e.max = Fd(e.max, t, n, r, u);
}
function Qb(e, { x: t, y: n }) {
  Lc(e.x, t.translate, t.scale, t.originPoint), Lc(e.y, n.translate, n.scale, n.originPoint);
}
function eS(e, t, n, r = !1) {
  const u = n.length;
  if (!u)
    return;
  t.x = t.y = 1;
  let i, a;
  for (let o = 0; o < u; o++) {
    i = n[o], a = i.projectionDelta;
    const s = i.instance;
    s && s.style && s.style.display === "contents" || (r && i.options.layoutScroll && i.scroll && i !== i.root && cu(e, {
      x: -i.scroll.offset.x,
      y: -i.scroll.offset.y
    }), a && (t.x *= a.x.scale, t.y *= a.y.scale, Qb(e, a)), r && xr(i.latestValues) && cu(e, i.latestValues));
  }
  t.x = Hd(t.x), t.y = Hd(t.y);
}
function Hd(e) {
  return Number.isInteger(e) || e > 1.0000000000001 || e < 0.999999999999 ? e : 1;
}
function er(e, t) {
  e.min = e.min + t, e.max = e.max + t;
}
function $d(e, t, [n, r, u]) {
  const i = t[u] !== void 0 ? t[u] : 0.5, a = tt(e.min, e.max, i);
  Lc(e, t[n], t[r], a, t.scale);
}
const tS = ["x", "scaleX", "originX"], nS = ["y", "scaleY", "originY"];
function cu(e, t) {
  $d(e.x, t, tS), $d(e.y, t, nS);
}
function Jb(e, t) {
  return Zb(J_(e.getBoundingClientRect(), t));
}
function rS(e, t, n) {
  const r = Jb(e, n), { scroll: u } = t;
  return u && (er(r.x, u.offset.x), er(r.y, u.offset.y)), r;
}
const e2 = ({ current: e }) => e ? e.ownerDocument.defaultView : null, uS = /* @__PURE__ */ new WeakMap();
class iS {
  constructor(t) {
    this.openGlobalLock = null, this.isDragging = !1, this.currentDirection = null, this.originPoint = { x: 0, y: 0 }, this.constraints = !1, this.hasMutatedConstraints = !1, this.elastic = pt(), this.visualElement = t;
  }
  start(t, { snapToCursor: n = !1 } = {}) {
    const { presenceContext: r } = this.visualElement;
    if (r && r.isPresent === !1)
      return;
    const u = (l) => {
      const { dragSnapToOrigin: d } = this.getProps();
      d ? this.pauseAnimation() : this.stopAnimation(), n && this.snapToCursor(xo(l, "page").point);
    }, i = (l, d) => {
      const { drag: f, dragPropagation: p, onDragStart: h } = this.getProps();
      if (f && !p && (this.openGlobalLock && this.openGlobalLock(), this.openGlobalLock = cb(f), !this.openGlobalLock))
        return;
      this.isDragging = !0, this.currentDirection = null, this.resolveConstraints(), this.visualElement.projection && (this.visualElement.projection.isAnimationBlocked = !0, this.visualElement.projection.target = void 0), hn((b) => {
        let x = this.getAxisMotionValue(b).get() || 0;
        if (Dn.test(x)) {
          const { projection: y } = this.visualElement;
          if (y && y.layout) {
            const g = y.layout.layoutBox[b];
            g && (x = sn(g) * (parseFloat(x) / 100));
          }
        }
        this.originPoint[b] = x;
      }), h && He.update(() => h(l, d), !1, !0);
      const { animationState: m } = this.visualElement;
      m && m.setActive("whileDrag", !0);
    }, a = (l, d) => {
      const { dragPropagation: f, dragDirectionLock: p, onDirectionLock: h, onDrag: m } = this.getProps();
      if (!f && !this.openGlobalLock)
        return;
      const { offset: b } = d;
      if (p && this.currentDirection === null) {
        this.currentDirection = aS(b), this.currentDirection !== null && h && h(this.currentDirection);
        return;
      }
      this.updateAxis("x", d.point, b), this.updateAxis("y", d.point, b), this.visualElement.render(), m && m(l, d);
    }, o = (l, d) => this.stop(l, d), s = () => hn((l) => {
      var d;
      return this.getAnimationState(l) === "paused" && ((d = this.getAxisMotionValue(l).animation) === null || d === void 0 ? void 0 : d.play());
    }), { dragSnapToOrigin: c } = this.getProps();
    this.panSession = new Kb(t, {
      onSessionStart: u,
      onStart: i,
      onMove: a,
      onSessionEnd: o,
      resumeAnimation: s
    }, {
      transformPagePoint: this.visualElement.getTransformPagePoint(),
      dragSnapToOrigin: c,
      contextWindow: e2(this.visualElement)
    });
  }
  stop(t, n) {
    const r = this.isDragging;
    if (this.cancel(), !r)
      return;
    const { velocity: u } = n;
    this.startAnimation(u);
    const { onDragEnd: i } = this.getProps();
    i && He.update(() => i(t, n));
  }
  cancel() {
    this.isDragging = !1;
    const { projection: t, animationState: n } = this.visualElement;
    t && (t.isAnimationBlocked = !1), this.panSession && this.panSession.end(), this.panSession = void 0;
    const { dragPropagation: r } = this.getProps();
    !r && this.openGlobalLock && (this.openGlobalLock(), this.openGlobalLock = null), n && n.setActive("whileDrag", !1);
  }
  updateAxis(t, n, r) {
    const { drag: u } = this.getProps();
    if (!r || !na(t, u, this.currentDirection))
      return;
    const i = this.getAxisMotionValue(t);
    let a = this.originPoint[t] + r[t];
    this.constraints && this.constraints[t] && (a = G_(a, this.constraints[t], this.elastic[t])), i.set(a);
  }
  resolveConstraints() {
    var t;
    const { dragConstraints: n, dragElastic: r } = this.getProps(), u = this.visualElement.projection && !this.visualElement.projection.layout ? this.visualElement.projection.measure(!1) : (t = this.visualElement.projection) === null || t === void 0 ? void 0 : t.layout, i = this.constraints;
    n && au(n) ? this.constraints || (this.constraints = this.resolveRefConstraints()) : n && u ? this.constraints = W_(u.layoutBox, n) : this.constraints = !1, this.elastic = X_(r), i !== this.constraints && u && this.constraints && !this.hasMutatedConstraints && hn((a) => {
      this.getAxisMotionValue(a) && (this.constraints[a] = Z_(u.layoutBox[a], this.constraints[a]));
    });
  }
  resolveRefConstraints() {
    const { dragConstraints: t, onMeasureDragConstraints: n } = this.getProps();
    if (!t || !au(t))
      return !1;
    const r = t.current, { projection: u } = this.visualElement;
    if (!u || !u.layout)
      return !1;
    const i = rS(r, u.root, this.visualElement.getTransformPagePoint());
    let a = K_(u.layout.layoutBox, i);
    if (n) {
      const o = n(Q_(a));
      this.hasMutatedConstraints = !!o, o && (a = Zb(o));
    }
    return a;
  }
  startAnimation(t) {
    const { drag: n, dragMomentum: r, dragElastic: u, dragTransition: i, dragSnapToOrigin: a, onDragTransitionEnd: o } = this.getProps(), s = this.constraints || {}, c = hn((l) => {
      if (!na(l, n, this.currentDirection))
        return;
      let d = s && s[l] || {};
      a && (d = { min: 0, max: 0 });
      const f = u ? 200 : 1e6, p = u ? 40 : 1e7, h = {
        type: "inertia",
        velocity: r ? t[l] : 0,
        bounceStiffness: f,
        bounceDamping: p,
        timeConstant: 750,
        restDelta: 1,
        restSpeed: 10,
        ...i,
        ...d
      };
      return this.startAxisValueAnimation(l, h);
    });
    return Promise.all(c).then(o);
  }
  startAxisValueAnimation(t, n) {
    const r = this.getAxisMotionValue(t);
    return r.start(Bl(t, r, 0, n));
  }
  stopAnimation() {
    hn((t) => this.getAxisMotionValue(t).stop());
  }
  pauseAnimation() {
    hn((t) => {
      var n;
      return (n = this.getAxisMotionValue(t).animation) === null || n === void 0 ? void 0 : n.pause();
    });
  }
  getAnimationState(t) {
    var n;
    return (n = this.getAxisMotionValue(t).animation) === null || n === void 0 ? void 0 : n.state;
  }
  /**
   * Drag works differently depending on which props are provided.
   *
   * - If _dragX and _dragY are provided, we output the gesture delta directly to those motion values.
   * - Otherwise, we apply the delta to the x/y motion values.
   */
  getAxisMotionValue(t) {
    const n = "_drag" + t.toUpperCase(), r = this.visualElement.getProps(), u = r[n];
    return u || this.visualElement.getValue(t, (r.initial ? r.initial[t] : void 0) || 0);
  }
  snapToCursor(t) {
    hn((n) => {
      const { drag: r } = this.getProps();
      if (!na(n, r, this.currentDirection))
        return;
      const { projection: u } = this.visualElement, i = this.getAxisMotionValue(n);
      if (u && u.layout) {
        const { min: a, max: o } = u.layout.layoutBox[n];
        i.set(t[n] - tt(a, o, 0.5));
      }
    });
  }
  /**
   * When the viewport resizes we want to check if the measured constraints
   * have changed and, if so, reposition the element within those new constraints
   * relative to where it was before the resize.
   */
  scalePositionWithinConstraints() {
    if (!this.visualElement.current)
      return;
    const { drag: t, dragConstraints: n } = this.getProps(), { projection: r } = this.visualElement;
    if (!au(n) || !r || !this.constraints)
      return;
    this.stopAnimation();
    const u = { x: 0, y: 0 };
    hn((a) => {
      const o = this.getAxisMotionValue(a);
      if (o) {
        const s = o.get();
        u[a] = Y_({ min: s, max: s }, this.constraints[a]);
      }
    });
    const { transformTemplate: i } = this.visualElement.getProps();
    this.visualElement.current.style.transform = i ? i({}, "") : "none", r.root && r.root.updateScroll(), r.updateLayout(), this.resolveConstraints(), hn((a) => {
      if (!na(a, t, null))
        return;
      const o = this.getAxisMotionValue(a), { min: s, max: c } = this.constraints[a];
      o.set(tt(s, c, u[a]));
    });
  }
  addListeners() {
    if (!this.visualElement.current)
      return;
    uS.set(this.visualElement, this);
    const t = this.visualElement.current, n = Un(t, "pointerdown", (s) => {
      const { drag: c, dragListener: l = !0 } = this.getProps();
      c && l && this.start(s);
    }), r = () => {
      const { dragConstraints: s } = this.getProps();
      au(s) && (this.constraints = this.resolveRefConstraints());
    }, { projection: u } = this.visualElement, i = u.addEventListener("measure", r);
    u && !u.layout && (u.root && u.root.updateScroll(), u.updateLayout()), r();
    const a = zn(window, "resize", () => this.scalePositionWithinConstraints()), o = u.addEventListener("didUpdate", ({ delta: s, hasLayoutChanged: c }) => {
      this.isDragging && c && (hn((l) => {
        const d = this.getAxisMotionValue(l);
        d && (this.originPoint[l] += s[l].translate, d.set(d.get() + s[l].translate));
      }), this.visualElement.render());
    });
    return () => {
      a(), n(), i(), o && o();
    };
  }
  getProps() {
    const t = this.visualElement.getProps(), { drag: n = !1, dragDirectionLock: r = !1, dragPropagation: u = !1, dragConstraints: i = !1, dragElastic: a = Ac, dragMomentum: o = !0 } = t;
    return {
      ...t,
      drag: n,
      dragDirectionLock: r,
      dragPropagation: u,
      dragConstraints: i,
      dragElastic: a,
      dragMomentum: o
    };
  }
}
function na(e, t, n) {
  return (t === !0 || t === e) && (n === null || n === e);
}
function aS(e, t = 10) {
  let n = null;
  return Math.abs(e.y) > t ? n = "y" : Math.abs(e.x) > t && (n = "x"), n;
}
class oS extends fr {
  constructor(t) {
    super(t), this.removeGroupControls = it, this.removeListeners = it, this.controls = new iS(t);
  }
  mount() {
    const { dragControls: t } = this.node.getProps();
    t && (this.removeGroupControls = t.subscribe(this.controls)), this.removeListeners = this.controls.addListeners() || it;
  }
  unmount() {
    this.removeGroupControls(), this.removeListeners();
  }
}
const Vd = (e) => (t, n) => {
  e && He.update(() => e(t, n));
};
class sS extends fr {
  constructor() {
    super(...arguments), this.removePointerDownListener = it;
  }
  onPointerDown(t) {
    this.session = new Kb(t, this.createPanHandlers(), {
      transformPagePoint: this.node.getTransformPagePoint(),
      contextWindow: e2(this.node)
    });
  }
  createPanHandlers() {
    const { onPanSessionStart: t, onPanStart: n, onPan: r, onPanEnd: u } = this.node.getProps();
    return {
      onSessionStart: Vd(t),
      onStart: Vd(n),
      onMove: r,
      onEnd: (i, a) => {
        delete this.session, u && He.update(() => u(i, a));
      }
    };
  }
  mount() {
    this.removePointerDownListener = Un(this.node.current, "pointerdown", (t) => this.onPointerDown(t));
  }
  update() {
    this.session && this.session.updateHandlers(this.createPanHandlers());
  }
  unmount() {
    this.removePointerDownListener(), this.session && this.session.end();
  }
}
function cS() {
  const e = ke(mo);
  if (e === null)
    return [!0, null];
  const { isPresent: t, onExitComplete: n, register: r } = e, u = hl();
  return oe(() => r(u), []), !t && n ? [!1, () => n && n(u)] : [!0];
}
const Ea = {
  /**
   * Global flag as to whether the tree has animated since the last time
   * we resized the window
   */
  hasAnimatedSinceResize: !0,
  /**
   * We set this to true once, on the first update. Any nodes added to the tree beyond that
   * update will be given a `data-projection-id` attribute.
   */
  hasEverUpdated: !1
};
function jd(e, t) {
  return t.max === t.min ? 0 : e / (t.max - t.min) * 100;
}
const Uu = {
  correct: (e, t) => {
    if (!t.target)
      return e;
    if (typeof e == "string")
      if (be.test(e))
        e = parseFloat(e);
      else
        return e;
    const n = jd(e, t.target.x), r = jd(e, t.target.y);
    return `${n}% ${r}%`;
  }
}, lS = {
  correct: (e, { treeScale: t, projectionDelta: n }) => {
    const r = e, u = or.parse(e);
    if (u.length > 5)
      return r;
    const i = or.createTransformer(e), a = typeof u[0] != "number" ? 1 : 0, o = n.x.scale * t.x, s = n.y.scale * t.y;
    u[0 + a] /= o, u[1 + a] /= s;
    const c = tt(o, s, 0.5);
    return typeof u[2 + a] == "number" && (u[2 + a] /= c), typeof u[3 + a] == "number" && (u[3 + a] /= c), i(u);
  }
};
class dS extends Te.Component {
  /**
   * This only mounts projection nodes for components that
   * need measuring, we might want to do it for all components
   * in order to incorporate transforms
   */
  componentDidMount() {
    const { visualElement: t, layoutGroup: n, switchLayoutGroup: r, layoutId: u } = this.props, { projection: i } = t;
    Lx(fS), i && (n.group && n.group.add(i), r && r.register && u && r.register(i), i.root.didUpdate(), i.addEventListener("animationComplete", () => {
      this.safeToRemove();
    }), i.setOptions({
      ...i.options,
      onExitComplete: () => this.safeToRemove()
    })), Ea.hasEverUpdated = !0;
  }
  getSnapshotBeforeUpdate(t) {
    const { layoutDependency: n, visualElement: r, drag: u, isPresent: i } = this.props, a = r.projection;
    return a && (a.isPresent = i, u || t.layoutDependency !== n || n === void 0 ? a.willUpdate() : this.safeToRemove(), t.isPresent !== i && (i ? a.promote() : a.relegate() || He.postRender(() => {
      const o = a.getStack();
      (!o || !o.members.length) && this.safeToRemove();
    }))), null;
  }
  componentDidUpdate() {
    const { projection: t } = this.props.visualElement;
    t && (t.root.didUpdate(), queueMicrotask(() => {
      !t.currentAnimation && t.isLead() && this.safeToRemove();
    }));
  }
  componentWillUnmount() {
    const { visualElement: t, layoutGroup: n, switchLayoutGroup: r } = this.props, { projection: u } = t;
    u && (u.scheduleCheckAfterUnmount(), n && n.group && n.group.remove(u), r && r.deregister && r.deregister(u));
  }
  safeToRemove() {
    const { safeToRemove: t } = this.props;
    t && t();
  }
  render() {
    return null;
  }
}
function t2(e) {
  const [t, n] = cS(), r = ke(xl);
  return Te.createElement(dS, { ...e, layoutGroup: r, switchLayoutGroup: ke(qg), isPresent: t, safeToRemove: n });
}
const fS = {
  borderRadius: {
    ...Uu,
    applyTo: [
      "borderTopLeftRadius",
      "borderTopRightRadius",
      "borderBottomLeftRadius",
      "borderBottomRightRadius"
    ]
  },
  borderTopLeftRadius: Uu,
  borderTopRightRadius: Uu,
  borderBottomLeftRadius: Uu,
  borderBottomRightRadius: Uu,
  boxShadow: lS
}, n2 = ["TopLeft", "TopRight", "BottomLeft", "BottomRight"], pS = n2.length, zd = (e) => typeof e == "string" ? parseFloat(e) : e, Ud = (e) => typeof e == "number" || be.test(e);
function hS(e, t, n, r, u, i) {
  u ? (e.opacity = tt(
    0,
    // TODO Reinstate this if only child
    n.opacity !== void 0 ? n.opacity : 1,
    mS(r)
  ), e.opacityExit = tt(t.opacity !== void 0 ? t.opacity : 1, 0, gS(r))) : i && (e.opacity = tt(t.opacity !== void 0 ? t.opacity : 1, n.opacity !== void 0 ? n.opacity : 1, r));
  for (let a = 0; a < pS; a++) {
    const o = `border${n2[a]}Radius`;
    let s = qd(t, o), c = qd(n, o);
    if (s === void 0 && c === void 0)
      continue;
    s || (s = 0), c || (c = 0), s === 0 || c === 0 || Ud(s) === Ud(c) ? (e[o] = Math.max(tt(zd(s), zd(c), r), 0), (Dn.test(c) || Dn.test(s)) && (e[o] += "%")) : e[o] = c;
  }
  (t.rotate || n.rotate) && (e.rotate = tt(t.rotate || 0, n.rotate || 0, r));
}
function qd(e, t) {
  return e[t] !== void 0 ? e[t] : e.borderRadius;
}
const mS = r2(0, 0.5, Eb), gS = r2(0.5, 0.95, it);
function r2(e, t, n) {
  return (r) => r < e ? 0 : r > t ? 1 : n(Dr(e, t, r));
}
function Gd(e, t) {
  e.min = t.min, e.max = t.max;
}
function pn(e, t) {
  Gd(e.x, t.x), Gd(e.y, t.y);
}
function Wd(e, t, n, r, u) {
  return e -= t, e = ja(e, 1 / n, r), u !== void 0 && (e = ja(e, 1 / u, r)), e;
}
function bS(e, t = 0, n = 1, r = 0.5, u, i = e, a = e) {
  if (Dn.test(t) && (t = parseFloat(t), t = tt(a.min, a.max, t / 100) - a.min), typeof t != "number")
    return;
  let o = tt(i.min, i.max, r);
  e === i && (o -= t), e.min = Wd(e.min, t, n, o, u), e.max = Wd(e.max, t, n, o, u);
}
function Kd(e, t, [n, r, u], i, a) {
  bS(e, t[n], t[r], t[u], t.scale, i, a);
}
const vS = ["x", "scaleX", "originX"], yS = ["y", "scaleY", "originY"];
function Yd(e, t, n, r) {
  Kd(e.x, t, vS, n ? n.x : void 0, r ? r.x : void 0), Kd(e.y, t, yS, n ? n.y : void 0, r ? r.y : void 0);
}
function Zd(e) {
  return e.translate === 0 && e.scale === 1;
}
function u2(e) {
  return Zd(e.x) && Zd(e.y);
}
function xS(e, t) {
  return e.x.min === t.x.min && e.x.max === t.x.max && e.y.min === t.y.min && e.y.max === t.y.max;
}
function i2(e, t) {
  return Math.round(e.x.min) === Math.round(t.x.min) && Math.round(e.x.max) === Math.round(t.x.max) && Math.round(e.y.min) === Math.round(t.y.min) && Math.round(e.y.max) === Math.round(t.y.max);
}
function Xd(e) {
  return sn(e.x) / sn(e.y);
}
class _S {
  constructor() {
    this.members = [];
  }
  add(t) {
    Eo(this.members, t), t.scheduleRender();
  }
  remove(t) {
    if (Tu(this.members, t), t === this.prevLead && (this.prevLead = void 0), t === this.lead) {
      const n = this.members[this.members.length - 1];
      n && this.promote(n);
    }
  }
  relegate(t) {
    const n = this.members.findIndex((u) => t === u);
    if (n === 0)
      return !1;
    let r;
    for (let u = n; u >= 0; u--) {
      const i = this.members[u];
      if (i.isPresent !== !1) {
        r = i;
        break;
      }
    }
    return r ? (this.promote(r), !0) : !1;
  }
  promote(t, n) {
    const r = this.lead;
    if (t !== r && (this.prevLead = r, this.lead = t, t.show(), r)) {
      r.instance && r.scheduleRender(), t.scheduleRender(), t.resumeFrom = r, n && (t.resumeFrom.preserveOpacity = !0), r.snapshot && (t.snapshot = r.snapshot, t.snapshot.latestValues = r.animationValues || r.latestValues), t.root && t.root.isUpdating && (t.isLayoutDirty = !0);
      const { crossfade: u } = t.options;
      u === !1 && r.hide();
    }
  }
  exitAnimationComplete() {
    this.members.forEach((t) => {
      const { options: n, resumingFrom: r } = t;
      n.onExitComplete && n.onExitComplete(), r && r.options.onExitComplete && r.options.onExitComplete();
    });
  }
  scheduleRender() {
    this.members.forEach((t) => {
      t.instance && t.scheduleRender(!1);
    });
  }
  /**
   * Clear any leads that have been removed this render to prevent them from being
   * used in future animations and to prevent memory leaks
   */
  removeLeadSnapshot() {
    this.lead && this.lead.snapshot && (this.lead.snapshot = void 0);
  }
}
function Qd(e, t, n) {
  let r = "";
  const u = e.x.translate / t.x, i = e.y.translate / t.y;
  if ((u || i) && (r = `translate3d(${u}px, ${i}px, 0) `), (t.x !== 1 || t.y !== 1) && (r += `scale(${1 / t.x}, ${1 / t.y}) `), n) {
    const { rotate: s, rotateX: c, rotateY: l } = n;
    s && (r += `rotate(${s}deg) `), c && (r += `rotateX(${c}deg) `), l && (r += `rotateY(${l}deg) `);
  }
  const a = e.x.scale * t.x, o = e.y.scale * t.y;
  return (a !== 1 || o !== 1) && (r += `scale(${a}, ${o})`), r || "none";
}
const SS = (e, t) => e.depth - t.depth;
class CS {
  constructor() {
    this.children = [], this.isDirty = !1;
  }
  add(t) {
    Eo(this.children, t), this.isDirty = !0;
  }
  remove(t) {
    Tu(this.children, t), this.isDirty = !0;
  }
  forEach(t) {
    this.isDirty && this.children.sort(SS), this.isDirty = !1, this.children.forEach(t);
  }
}
function ES(e, t) {
  const n = performance.now(), r = ({ timestamp: u }) => {
    const i = u - n;
    i >= t && (bn(r), e(i - t));
  };
  return He.read(r, !0), () => bn(r);
}
function wS(e) {
  window.MotionDebug && window.MotionDebug.record(e);
}
function a2(e) {
  return e instanceof SVGElement && e.tagName !== "svg";
}
function Vl(e, t, n) {
  const r = wt(e) ? e : mn(e);
  return r.start(Bl("", r, t, n)), r.animation;
}
const Jd = ["", "X", "Y", "Z"], TS = { visibility: "hidden" }, ef = 1e3;
let AS = 0;
const _r = {
  type: "projectionFrame",
  totalNodes: 0,
  resolvedTargetDeltas: 0,
  recalculatedProjection: 0
};
function o2({ attachResizeListener: e, defaultParent: t, measureScroll: n, checkIsScrollRoot: r, resetTransform: u }) {
  return class {
    constructor(a = {}, o = t == null ? void 0 : t()) {
      this.id = AS++, this.animationId = 0, this.children = /* @__PURE__ */ new Set(), this.options = {}, this.isTreeAnimating = !1, this.isAnimationBlocked = !1, this.isLayoutDirty = !1, this.isProjectionDirty = !1, this.isSharedProjectionDirty = !1, this.isTransformDirty = !1, this.updateManuallyBlocked = !1, this.updateBlockedByResize = !1, this.isUpdating = !1, this.isSVG = !1, this.needsReset = !1, this.shouldResetTransform = !1, this.treeScale = { x: 1, y: 1 }, this.eventHandlers = /* @__PURE__ */ new Map(), this.hasTreeAnimated = !1, this.updateScheduled = !1, this.projectionUpdateScheduled = !1, this.checkUpdateFailed = () => {
        this.isUpdating && (this.isUpdating = !1, this.clearAllSnapshots());
      }, this.updateProjection = () => {
        this.projectionUpdateScheduled = !1, _r.totalNodes = _r.resolvedTargetDeltas = _r.recalculatedProjection = 0, this.nodes.forEach(DS), this.nodes.forEach(PS), this.nodes.forEach(RS), this.nodes.forEach(NS), wS(_r);
      }, this.hasProjected = !1, this.isVisible = !0, this.animationProgress = 0, this.sharedNodes = /* @__PURE__ */ new Map(), this.latestValues = a, this.root = o ? o.root || o : this, this.path = o ? [...o.path, o] : [], this.parent = o, this.depth = o ? o.depth + 1 : 0;
      for (let s = 0; s < this.path.length; s++)
        this.path[s].shouldResetTransform = !0;
      this.root === this && (this.nodes = new CS());
    }
    addEventListener(a, o) {
      return this.eventHandlers.has(a) || this.eventHandlers.set(a, new Fl()), this.eventHandlers.get(a).add(o);
    }
    notifyListeners(a, ...o) {
      const s = this.eventHandlers.get(a);
      s && s.notify(...o);
    }
    hasListeners(a) {
      return this.eventHandlers.has(a);
    }
    /**
     * Lifecycles
     */
    mount(a, o = this.root.hasTreeAnimated) {
      if (this.instance)
        return;
      this.isSVG = a2(a), this.instance = a;
      const { layoutId: s, layout: c, visualElement: l } = this.options;
      if (l && !l.current && l.mount(a), this.root.nodes.add(this), this.parent && this.parent.children.add(this), o && (c || s) && (this.isLayoutDirty = !0), e) {
        let d;
        const f = () => this.root.updateBlockedByResize = !1;
        e(a, () => {
          this.root.updateBlockedByResize = !0, d && d(), d = ES(f, 250), Ea.hasAnimatedSinceResize && (Ea.hasAnimatedSinceResize = !1, this.nodes.forEach(nf));
        });
      }
      s && this.root.registerSharedNode(s, this), this.options.animate !== !1 && l && (s || c) && this.addEventListener("didUpdate", ({ delta: d, hasLayoutChanged: f, hasRelativeTargetChanged: p, layout: h }) => {
        if (this.isTreeAnimationBlocked()) {
          this.target = void 0, this.relativeTarget = void 0;
          return;
        }
        const m = this.options.transition || l.getDefaultTransition() || VS, { onLayoutAnimationStart: b, onLayoutAnimationComplete: x } = l.getProps(), y = !this.targetLayout || !i2(this.targetLayout, h) || p, g = !f && p;
        if (this.options.layoutRoot || this.resumeFrom && this.resumeFrom.instance || g || f && (y || !this.currentAnimation)) {
          this.resumeFrom && (this.resumingFrom = this.resumeFrom, this.resumingFrom.resumingFrom = void 0), this.setAnimationOrigin(d, g);
          const v = {
            ...Rl(m, "layout"),
            onPlay: b,
            onComplete: x
          };
          (l.shouldReduceMotion || this.options.layoutRoot) && (v.delay = 0, v.type = !1), this.startAnimation(v);
        } else
          f || nf(this), this.isLead() && this.options.onExitComplete && this.options.onExitComplete();
        this.targetLayout = h;
      });
    }
    unmount() {
      this.options.layoutId && this.willUpdate(), this.root.nodes.remove(this);
      const a = this.getStack();
      a && a.remove(this), this.parent && this.parent.children.delete(this), this.instance = void 0, bn(this.updateProjection);
    }
    // only on the root
    blockUpdate() {
      this.updateManuallyBlocked = !0;
    }
    unblockUpdate() {
      this.updateManuallyBlocked = !1;
    }
    isUpdateBlocked() {
      return this.updateManuallyBlocked || this.updateBlockedByResize;
    }
    isTreeAnimationBlocked() {
      return this.isAnimationBlocked || this.parent && this.parent.isTreeAnimationBlocked() || !1;
    }
    // Note: currently only running on root node
    startUpdate() {
      this.isUpdateBlocked() || (this.isUpdating = !0, this.nodes && this.nodes.forEach(BS), this.animationId++);
    }
    getTransformTemplate() {
      const { visualElement: a } = this.options;
      return a && a.getProps().transformTemplate;
    }
    willUpdate(a = !0) {
      if (this.root.hasTreeAnimated = !0, this.root.isUpdateBlocked()) {
        this.options.onExitComplete && this.options.onExitComplete();
        return;
      }
      if (!this.root.isUpdating && this.root.startUpdate(), this.isLayoutDirty)
        return;
      this.isLayoutDirty = !0;
      for (let l = 0; l < this.path.length; l++) {
        const d = this.path[l];
        d.shouldResetTransform = !0, d.updateScroll("snapshot"), d.options.layoutRoot && d.willUpdate(!1);
      }
      const { layoutId: o, layout: s } = this.options;
      if (o === void 0 && !s)
        return;
      const c = this.getTransformTemplate();
      this.prevTransformTemplateValue = c ? c(this.latestValues, "") : void 0, this.updateSnapshot(), a && this.notifyListeners("willUpdate");
    }
    update() {
      if (this.updateScheduled = !1, this.isUpdateBlocked()) {
        this.unblockUpdate(), this.clearAllSnapshots(), this.nodes.forEach(tf);
        return;
      }
      this.isUpdating || this.nodes.forEach(IS), this.isUpdating = !1, this.nodes.forEach(MS), this.nodes.forEach(kS), this.nodes.forEach(LS), this.clearAllSnapshots();
      const o = performance.now();
      vt.delta = ar(0, 1e3 / 60, o - vt.timestamp), vt.timestamp = o, vt.isProcessing = !0, ls.update.process(vt), ls.preRender.process(vt), ls.render.process(vt), vt.isProcessing = !1;
    }
    didUpdate() {
      this.updateScheduled || (this.updateScheduled = !0, queueMicrotask(() => this.update()));
    }
    clearAllSnapshots() {
      this.nodes.forEach(OS), this.sharedNodes.forEach(FS);
    }
    scheduleUpdateProjection() {
      this.projectionUpdateScheduled || (this.projectionUpdateScheduled = !0, He.preRender(this.updateProjection, !1, !0));
    }
    scheduleCheckAfterUnmount() {
      He.postRender(() => {
        this.isLayoutDirty ? this.root.didUpdate() : this.root.checkUpdateFailed();
      });
    }
    /**
     * Update measurements
     */
    updateSnapshot() {
      this.snapshot || !this.instance || (this.snapshot = this.measure());
    }
    updateLayout() {
      if (!this.instance || (this.updateScroll(), !(this.options.alwaysMeasureLayout && this.isLead()) && !this.isLayoutDirty))
        return;
      if (this.resumeFrom && !this.resumeFrom.instance)
        for (let s = 0; s < this.path.length; s++)
          this.path[s].updateScroll();
      const a = this.layout;
      this.layout = this.measure(!1), this.layoutCorrected = pt(), this.isLayoutDirty = !1, this.projectionDelta = void 0, this.notifyListeners("measure", this.layout.layoutBox);
      const { visualElement: o } = this.options;
      o && o.notify("LayoutMeasure", this.layout.layoutBox, a ? a.layoutBox : void 0);
    }
    updateScroll(a = "measure") {
      let o = !!(this.options.layoutScroll && this.instance);
      this.scroll && this.scroll.animationId === this.root.animationId && this.scroll.phase === a && (o = !1), o && (this.scroll = {
        animationId: this.root.animationId,
        phase: a,
        isRoot: r(this.instance),
        offset: n(this.instance)
      });
    }
    resetTransform() {
      if (!u)
        return;
      const a = this.isLayoutDirty || this.shouldResetTransform, o = this.projectionDelta && !u2(this.projectionDelta), s = this.getTransformTemplate(), c = s ? s(this.latestValues, "") : void 0, l = c !== this.prevTransformTemplateValue;
      a && (o || xr(this.latestValues) || l) && (u(this.instance, c), this.shouldResetTransform = !1, this.scheduleRender());
    }
    measure(a = !0) {
      const o = this.measurePageBox();
      let s = this.removeElementScroll(o);
      return a && (s = this.removeTransform(s)), jS(s), {
        animationId: this.root.animationId,
        measuredBox: o,
        layoutBox: s,
        latestValues: {},
        source: this.id
      };
    }
    measurePageBox() {
      const { visualElement: a } = this.options;
      if (!a)
        return pt();
      const o = a.measureViewportBox(), { scroll: s } = this.root;
      return s && (er(o.x, s.offset.x), er(o.y, s.offset.y)), o;
    }
    removeElementScroll(a) {
      const o = pt();
      pn(o, a);
      for (let s = 0; s < this.path.length; s++) {
        const c = this.path[s], { scroll: l, options: d } = c;
        if (c !== this.root && l && d.layoutScroll) {
          if (l.isRoot) {
            pn(o, a);
            const { scroll: f } = this.root;
            f && (er(o.x, -f.offset.x), er(o.y, -f.offset.y));
          }
          er(o.x, l.offset.x), er(o.y, l.offset.y);
        }
      }
      return o;
    }
    applyTransform(a, o = !1) {
      const s = pt();
      pn(s, a);
      for (let c = 0; c < this.path.length; c++) {
        const l = this.path[c];
        !o && l.options.layoutScroll && l.scroll && l !== l.root && cu(s, {
          x: -l.scroll.offset.x,
          y: -l.scroll.offset.y
        }), xr(l.latestValues) && cu(s, l.latestValues);
      }
      return xr(this.latestValues) && cu(s, this.latestValues), s;
    }
    removeTransform(a) {
      const o = pt();
      pn(o, a);
      for (let s = 0; s < this.path.length; s++) {
        const c = this.path[s];
        if (!c.instance || !xr(c.latestValues))
          continue;
        kc(c.latestValues) && c.updateSnapshot();
        const l = pt(), d = c.measurePageBox();
        pn(l, d), Yd(o, c.latestValues, c.snapshot ? c.snapshot.layoutBox : void 0, l);
      }
      return xr(this.latestValues) && Yd(o, this.latestValues), o;
    }
    setTargetDelta(a) {
      this.targetDelta = a, this.root.scheduleUpdateProjection(), this.isProjectionDirty = !0;
    }
    setOptions(a) {
      this.options = {
        ...this.options,
        ...a,
        crossfade: a.crossfade !== void 0 ? a.crossfade : !0
      };
    }
    clearMeasurements() {
      this.scroll = void 0, this.layout = void 0, this.snapshot = void 0, this.prevTransformTemplateValue = void 0, this.targetDelta = void 0, this.target = void 0, this.isLayoutDirty = !1;
    }
    forceRelativeParentToResolveTarget() {
      this.relativeParent && this.relativeParent.resolvedRelativeTargetAt !== vt.timestamp && this.relativeParent.resolveTargetDelta(!0);
    }
    resolveTargetDelta(a = !1) {
      var o;
      const s = this.getLead();
      this.isProjectionDirty || (this.isProjectionDirty = s.isProjectionDirty), this.isTransformDirty || (this.isTransformDirty = s.isTransformDirty), this.isSharedProjectionDirty || (this.isSharedProjectionDirty = s.isSharedProjectionDirty);
      const c = !!this.resumingFrom || this !== s;
      if (!(a || c && this.isSharedProjectionDirty || this.isProjectionDirty || !((o = this.parent) === null || o === void 0) && o.isProjectionDirty || this.attemptToResolveRelativeTarget))
        return;
      const { layout: d, layoutId: f } = this.options;
      if (!(!this.layout || !(d || f))) {
        if (this.resolvedRelativeTargetAt = vt.timestamp, !this.targetDelta && !this.relativeTarget) {
          const p = this.getClosestProjectingParent();
          p && p.layout && this.animationProgress !== 1 ? (this.relativeParent = p, this.forceRelativeParentToResolveTarget(), this.relativeTarget = pt(), this.relativeTargetOrigin = pt(), ci(this.relativeTargetOrigin, this.layout.layoutBox, p.layout.layoutBox), pn(this.relativeTarget, this.relativeTargetOrigin)) : this.relativeParent = this.relativeTarget = void 0;
        }
        if (!(!this.relativeTarget && !this.targetDelta)) {
          if (this.target || (this.target = pt(), this.targetWithTransforms = pt()), this.relativeTarget && this.relativeTargetOrigin && this.relativeParent && this.relativeParent.target ? (this.forceRelativeParentToResolveTarget(), q_(this.target, this.relativeTarget, this.relativeParent.target)) : this.targetDelta ? (this.resumingFrom ? this.target = this.applyTransform(this.layout.layoutBox) : pn(this.target, this.layout.layoutBox), Qb(this.target, this.targetDelta)) : pn(this.target, this.layout.layoutBox), this.attemptToResolveRelativeTarget) {
            this.attemptToResolveRelativeTarget = !1;
            const p = this.getClosestProjectingParent();
            p && !!p.resumingFrom == !!this.resumingFrom && !p.options.layoutScroll && p.target && this.animationProgress !== 1 ? (this.relativeParent = p, this.forceRelativeParentToResolveTarget(), this.relativeTarget = pt(), this.relativeTargetOrigin = pt(), ci(this.relativeTargetOrigin, this.target, p.target), pn(this.relativeTarget, this.relativeTargetOrigin)) : this.relativeParent = this.relativeTarget = void 0;
          }
          _r.resolvedTargetDeltas++;
        }
      }
    }
    getClosestProjectingParent() {
      if (!(!this.parent || kc(this.parent.latestValues) || Xb(this.parent.latestValues)))
        return this.parent.isProjecting() ? this.parent : this.parent.getClosestProjectingParent();
    }
    isProjecting() {
      return !!((this.relativeTarget || this.targetDelta || this.options.layoutRoot) && this.layout);
    }
    calcProjection() {
      var a;
      const o = this.getLead(), s = !!this.resumingFrom || this !== o;
      let c = !0;
      if ((this.isProjectionDirty || !((a = this.parent) === null || a === void 0) && a.isProjectionDirty) && (c = !1), s && (this.isSharedProjectionDirty || this.isTransformDirty) && (c = !1), this.resolvedRelativeTargetAt === vt.timestamp && (c = !1), c)
        return;
      const { layout: l, layoutId: d } = this.options;
      if (this.isTreeAnimating = !!(this.parent && this.parent.isTreeAnimating || this.currentAnimation || this.pendingAnimation), this.isTreeAnimating || (this.targetDelta = this.relativeTarget = void 0), !this.layout || !(l || d))
        return;
      pn(this.layoutCorrected, this.layout.layoutBox);
      const f = this.treeScale.x, p = this.treeScale.y;
      eS(this.layoutCorrected, this.treeScale, this.path, s), o.layout && !o.target && (this.treeScale.x !== 1 || this.treeScale.y !== 1) && (o.target = o.layout.layoutBox);
      const { target: h } = o;
      if (!h) {
        this.projectionTransform && (this.projectionDelta = su(), this.projectionTransform = "none", this.scheduleRender());
        return;
      }
      this.projectionDelta || (this.projectionDelta = su(), this.projectionDeltaWithTransform = su());
      const m = this.projectionTransform;
      si(this.projectionDelta, this.layoutCorrected, h, this.latestValues), this.projectionTransform = Qd(this.projectionDelta, this.treeScale), (this.projectionTransform !== m || this.treeScale.x !== f || this.treeScale.y !== p) && (this.hasProjected = !0, this.scheduleRender(), this.notifyListeners("projectionUpdate", h)), _r.recalculatedProjection++;
    }
    hide() {
      this.isVisible = !1;
    }
    show() {
      this.isVisible = !0;
    }
    scheduleRender(a = !0) {
      if (this.options.scheduleRender && this.options.scheduleRender(), a) {
        const o = this.getStack();
        o && o.scheduleRender();
      }
      this.resumingFrom && !this.resumingFrom.instance && (this.resumingFrom = void 0);
    }
    setAnimationOrigin(a, o = !1) {
      const s = this.snapshot, c = s ? s.latestValues : {}, l = { ...this.latestValues }, d = su();
      (!this.relativeParent || !this.relativeParent.options.layoutRoot) && (this.relativeTarget = this.relativeTargetOrigin = void 0), this.attemptToResolveRelativeTarget = !o;
      const f = pt(), p = s ? s.source : void 0, h = this.layout ? this.layout.source : void 0, m = p !== h, b = this.getStack(), x = !b || b.members.length <= 1, y = !!(m && !x && this.options.crossfade === !0 && !this.path.some($S));
      this.animationProgress = 0;
      let g;
      this.mixTargetDelta = (v) => {
        const S = v / 1e3;
        rf(d.x, a.x, S), rf(d.y, a.y, S), this.setTargetDelta(d), this.relativeTarget && this.relativeTargetOrigin && this.layout && this.relativeParent && this.relativeParent.layout && (ci(f, this.layout.layoutBox, this.relativeParent.layout.layoutBox), HS(this.relativeTarget, this.relativeTargetOrigin, f, S), g && xS(this.relativeTarget, g) && (this.isProjectionDirty = !1), g || (g = pt()), pn(g, this.relativeTarget)), m && (this.animationValues = l, hS(l, c, this.latestValues, S, y, x)), this.root.scheduleUpdateProjection(), this.scheduleRender(), this.animationProgress = S;
      }, this.mixTargetDelta(this.options.layoutRoot ? 1e3 : 0);
    }
    startAnimation(a) {
      this.notifyListeners("animationStart"), this.currentAnimation && this.currentAnimation.stop(), this.resumingFrom && this.resumingFrom.currentAnimation && this.resumingFrom.currentAnimation.stop(), this.pendingAnimation && (bn(this.pendingAnimation), this.pendingAnimation = void 0), this.pendingAnimation = He.update(() => {
        Ea.hasAnimatedSinceResize = !0, this.currentAnimation = Vl(0, ef, {
          ...a,
          onUpdate: (o) => {
            this.mixTargetDelta(o), a.onUpdate && a.onUpdate(o);
          },
          onComplete: () => {
            a.onComplete && a.onComplete(), this.completeAnimation();
          }
        }), this.resumingFrom && (this.resumingFrom.currentAnimation = this.currentAnimation), this.pendingAnimation = void 0;
      });
    }
    completeAnimation() {
      this.resumingFrom && (this.resumingFrom.currentAnimation = void 0, this.resumingFrom.preserveOpacity = void 0);
      const a = this.getStack();
      a && a.exitAnimationComplete(), this.resumingFrom = this.currentAnimation = this.animationValues = void 0, this.notifyListeners("animationComplete");
    }
    finishAnimation() {
      this.currentAnimation && (this.mixTargetDelta && this.mixTargetDelta(ef), this.currentAnimation.stop()), this.completeAnimation();
    }
    applyTransformsToTarget() {
      const a = this.getLead();
      let { targetWithTransforms: o, target: s, layout: c, latestValues: l } = a;
      if (!(!o || !s || !c)) {
        if (this !== a && this.layout && c && s2(this.options.animationType, this.layout.layoutBox, c.layoutBox)) {
          s = this.target || pt();
          const d = sn(this.layout.layoutBox.x);
          s.x.min = a.target.x.min, s.x.max = s.x.min + d;
          const f = sn(this.layout.layoutBox.y);
          s.y.min = a.target.y.min, s.y.max = s.y.min + f;
        }
        pn(o, s), cu(o, l), si(this.projectionDeltaWithTransform, this.layoutCorrected, o, l);
      }
    }
    registerSharedNode(a, o) {
      this.sharedNodes.has(a) || this.sharedNodes.set(a, new _S()), this.sharedNodes.get(a).add(o);
      const c = o.options.initialPromotionConfig;
      o.promote({
        transition: c ? c.transition : void 0,
        preserveFollowOpacity: c && c.shouldPreserveFollowOpacity ? c.shouldPreserveFollowOpacity(o) : void 0
      });
    }
    isLead() {
      const a = this.getStack();
      return a ? a.lead === this : !0;
    }
    getLead() {
      var a;
      const { layoutId: o } = this.options;
      return o ? ((a = this.getStack()) === null || a === void 0 ? void 0 : a.lead) || this : this;
    }
    getPrevLead() {
      var a;
      const { layoutId: o } = this.options;
      return o ? (a = this.getStack()) === null || a === void 0 ? void 0 : a.prevLead : void 0;
    }
    getStack() {
      const { layoutId: a } = this.options;
      if (a)
        return this.root.sharedNodes.get(a);
    }
    promote({ needsReset: a, transition: o, preserveFollowOpacity: s } = {}) {
      const c = this.getStack();
      c && c.promote(this, s), a && (this.projectionDelta = void 0, this.needsReset = !0), o && this.setOptions({ transition: o });
    }
    relegate() {
      const a = this.getStack();
      return a ? a.relegate(this) : !1;
    }
    resetRotation() {
      const { visualElement: a } = this.options;
      if (!a)
        return;
      let o = !1;
      const { latestValues: s } = a;
      if ((s.rotate || s.rotateX || s.rotateY || s.rotateZ) && (o = !0), !o)
        return;
      const c = {};
      for (let l = 0; l < Jd.length; l++) {
        const d = "rotate" + Jd[l];
        s[d] && (c[d] = s[d], a.setStaticValue(d, 0));
      }
      a.render();
      for (const l in c)
        a.setStaticValue(l, c[l]);
      a.scheduleRender();
    }
    getProjectionStyles(a) {
      var o, s;
      if (!this.instance || this.isSVG)
        return;
      if (!this.isVisible)
        return TS;
      const c = {
        visibility: ""
      }, l = this.getTransformTemplate();
      if (this.needsReset)
        return this.needsReset = !1, c.opacity = "", c.pointerEvents = Ca(a == null ? void 0 : a.pointerEvents) || "", c.transform = l ? l(this.latestValues, "") : "none", c;
      const d = this.getLead();
      if (!this.projectionDelta || !this.layout || !d.target) {
        const m = {};
        return this.options.layoutId && (m.opacity = this.latestValues.opacity !== void 0 ? this.latestValues.opacity : 1, m.pointerEvents = Ca(a == null ? void 0 : a.pointerEvents) || ""), this.hasProjected && !xr(this.latestValues) && (m.transform = l ? l({}, "") : "none", this.hasProjected = !1), m;
      }
      const f = d.animationValues || d.latestValues;
      this.applyTransformsToTarget(), c.transform = Qd(this.projectionDeltaWithTransform, this.treeScale, f), l && (c.transform = l(f, c.transform));
      const { x: p, y: h } = this.projectionDelta;
      c.transformOrigin = `${p.origin * 100}% ${h.origin * 100}% 0`, d.animationValues ? c.opacity = d === this ? (s = (o = f.opacity) !== null && o !== void 0 ? o : this.latestValues.opacity) !== null && s !== void 0 ? s : 1 : this.preserveOpacity ? this.latestValues.opacity : f.opacityExit : c.opacity = d === this ? f.opacity !== void 0 ? f.opacity : "" : f.opacityExit !== void 0 ? f.opacityExit : 0;
      for (const m in Ra) {
        if (f[m] === void 0)
          continue;
        const { correct: b, applyTo: x } = Ra[m], y = c.transform === "none" ? f[m] : b(f[m], d);
        if (x) {
          const g = x.length;
          for (let v = 0; v < g; v++)
            c[x[v]] = y;
        } else
          c[m] = y;
      }
      return this.options.layoutId && (c.pointerEvents = d === this ? Ca(a == null ? void 0 : a.pointerEvents) || "" : "none"), c;
    }
    clearSnapshot() {
      this.resumeFrom = this.snapshot = void 0;
    }
    // Only run on root
    resetTree() {
      this.root.nodes.forEach((a) => {
        var o;
        return (o = a.currentAnimation) === null || o === void 0 ? void 0 : o.stop();
      }), this.root.nodes.forEach(tf), this.root.sharedNodes.clear();
    }
  };
}
function kS(e) {
  e.updateLayout();
}
function LS(e) {
  var t;
  const n = ((t = e.resumeFrom) === null || t === void 0 ? void 0 : t.snapshot) || e.snapshot;
  if (e.isLead() && e.layout && n && e.hasListeners("didUpdate")) {
    const { layoutBox: r, measuredBox: u } = e.layout, { animationType: i } = e.options, a = n.source !== e.layout.source;
    i === "size" ? hn((d) => {
      const f = a ? n.measuredBox[d] : n.layoutBox[d], p = sn(f);
      f.min = r[d].min, f.max = f.min + p;
    }) : s2(i, n.layoutBox, r) && hn((d) => {
      const f = a ? n.measuredBox[d] : n.layoutBox[d], p = sn(r[d]);
      f.max = f.min + p, e.relativeTarget && !e.currentAnimation && (e.isProjectionDirty = !0, e.relativeTarget[d].max = e.relativeTarget[d].min + p);
    });
    const o = su();
    si(o, r, n.layoutBox);
    const s = su();
    a ? si(s, e.applyTransform(u, !0), n.measuredBox) : si(s, r, n.layoutBox);
    const c = !u2(o);
    let l = !1;
    if (!e.resumeFrom) {
      const d = e.getClosestProjectingParent();
      if (d && !d.resumeFrom) {
        const { snapshot: f, layout: p } = d;
        if (f && p) {
          const h = pt();
          ci(h, n.layoutBox, f.layoutBox);
          const m = pt();
          ci(m, r, p.layoutBox), i2(h, m) || (l = !0), d.options.layoutRoot && (e.relativeTarget = m, e.relativeTargetOrigin = h, e.relativeParent = d);
        }
      }
    }
    e.notifyListeners("didUpdate", {
      layout: r,
      snapshot: n,
      delta: s,
      layoutDelta: o,
      hasLayoutChanged: c,
      hasRelativeTargetChanged: l
    });
  } else if (e.isLead()) {
    const { onExitComplete: r } = e.options;
    r && r();
  }
  e.options.transition = void 0;
}
function DS(e) {
  _r.totalNodes++, e.parent && (e.isProjecting() || (e.isProjectionDirty = e.parent.isProjectionDirty), e.isSharedProjectionDirty || (e.isSharedProjectionDirty = !!(e.isProjectionDirty || e.parent.isProjectionDirty || e.parent.isSharedProjectionDirty)), e.isTransformDirty || (e.isTransformDirty = e.parent.isTransformDirty));
}
function NS(e) {
  e.isProjectionDirty = e.isSharedProjectionDirty = e.isTransformDirty = !1;
}
function OS(e) {
  e.clearSnapshot();
}
function tf(e) {
  e.clearMeasurements();
}
function IS(e) {
  e.isLayoutDirty = !1;
}
function MS(e) {
  const { visualElement: t } = e.options;
  t && t.getProps().onBeforeLayoutMeasure && t.notify("BeforeLayoutMeasure"), e.resetTransform();
}
function nf(e) {
  e.finishAnimation(), e.targetDelta = e.relativeTarget = e.target = void 0, e.isProjectionDirty = !0;
}
function PS(e) {
  e.resolveTargetDelta();
}
function RS(e) {
  e.calcProjection();
}
function BS(e) {
  e.resetRotation();
}
function FS(e) {
  e.removeLeadSnapshot();
}
function rf(e, t, n) {
  e.translate = tt(t.translate, 0, n), e.scale = tt(t.scale, 1, n), e.origin = t.origin, e.originPoint = t.originPoint;
}
function uf(e, t, n, r) {
  e.min = tt(t.min, n.min, r), e.max = tt(t.max, n.max, r);
}
function HS(e, t, n, r) {
  uf(e.x, t.x, n.x, r), uf(e.y, t.y, n.y, r);
}
function $S(e) {
  return e.animationValues && e.animationValues.opacityExit !== void 0;
}
const VS = {
  duration: 0.45,
  ease: [0.4, 0, 0.1, 1]
}, af = (e) => typeof navigator < "u" && navigator.userAgent.toLowerCase().includes(e), of = af("applewebkit/") && !af("chrome/") ? Math.round : it;
function sf(e) {
  e.min = of(e.min), e.max = of(e.max);
}
function jS(e) {
  sf(e.x), sf(e.y);
}
function s2(e, t, n) {
  return e === "position" || e === "preserve-aspect" && !Tc(Xd(t), Xd(n), 0.2);
}
const zS = o2({
  attachResizeListener: (e, t) => zn(e, "resize", t),
  measureScroll: () => ({
    x: document.documentElement.scrollLeft || document.body.scrollLeft,
    y: document.documentElement.scrollTop || document.body.scrollTop
  }),
  checkIsScrollRoot: () => !0
}), _s = {
  current: void 0
}, c2 = o2({
  measureScroll: (e) => ({
    x: e.scrollLeft,
    y: e.scrollTop
  }),
  defaultParent: () => {
    if (!_s.current) {
      const e = new zS({});
      e.mount(window), e.setOptions({ layoutScroll: !0 }), _s.current = e;
    }
    return _s.current;
  },
  resetTransform: (e, t) => {
    e.style.transform = t !== void 0 ? t : "none";
  },
  checkIsScrollRoot: (e) => window.getComputedStyle(e).position === "fixed"
}), l2 = {
  pan: {
    Feature: sS
  },
  drag: {
    Feature: oS,
    ProjectionNode: c2,
    MeasureLayout: t2
  }
}, US = /var\((--[a-zA-Z0-9-_]+),? ?([a-zA-Z0-9 ()%#.,-]+)?\)/;
function qS(e) {
  const t = US.exec(e);
  if (!t)
    return [,];
  const [, n, r] = t;
  return [n, r];
}
function Dc(e, t, n = 1) {
  const [r, u] = qS(e);
  if (!r)
    return;
  const i = window.getComputedStyle(t).getPropertyValue(r);
  if (i) {
    const a = i.trim();
    return jb(a) ? parseFloat(a) : a;
  } else
    return gc(u) ? Dc(u, t, n + 1) : u;
}
function GS(e, { ...t }, n) {
  const r = e.current;
  if (!(r instanceof Element))
    return { target: t, transitionEnd: n };
  n && (n = { ...n }), e.values.forEach((u) => {
    const i = u.get();
    if (!gc(i))
      return;
    const a = Dc(i, r);
    a && u.set(a);
  });
  for (const u in t) {
    const i = t[u];
    if (!gc(i))
      continue;
    const a = Dc(i, r);
    a && (t[u] = a, n || (n = {}), n[u] === void 0 && (n[u] = i));
  }
  return { target: t, transitionEnd: n };
}
const WS = /* @__PURE__ */ new Set([
  "width",
  "height",
  "top",
  "left",
  "right",
  "bottom",
  "x",
  "y",
  "translateX",
  "translateY"
]), d2 = (e) => WS.has(e), KS = (e) => Object.keys(e).some(d2), cf = (e) => e === Pr || e === be, lf = (e, t) => parseFloat(e.split(", ")[t]), df = (e, t) => (n, { transform: r }) => {
  if (r === "none" || !r)
    return 0;
  const u = r.match(/^matrix3d\((.+)\)$/);
  if (u)
    return lf(u[1], t);
  {
    const i = r.match(/^matrix\((.+)\)$/);
    return i ? lf(i[1], e) : 0;
  }
}, YS = /* @__PURE__ */ new Set(["x", "y", "z"]), ZS = Ri.filter((e) => !YS.has(e));
function XS(e) {
  const t = [];
  return ZS.forEach((n) => {
    const r = e.getValue(n);
    r !== void 0 && (t.push([n, r.get()]), r.set(n.startsWith("scale") ? 1 : 0));
  }), t.length && e.render(), t;
}
const Au = {
  // Dimensions
  width: ({ x: e }, { paddingLeft: t = "0", paddingRight: n = "0" }) => e.max - e.min - parseFloat(t) - parseFloat(n),
  height: ({ y: e }, { paddingTop: t = "0", paddingBottom: n = "0" }) => e.max - e.min - parseFloat(t) - parseFloat(n),
  top: (e, { top: t }) => parseFloat(t),
  left: (e, { left: t }) => parseFloat(t),
  bottom: ({ y: e }, { top: t }) => parseFloat(t) + (e.max - e.min),
  right: ({ x: e }, { left: t }) => parseFloat(t) + (e.max - e.min),
  // Transform
  x: df(4, 13),
  y: df(5, 14)
};
Au.translateX = Au.x;
Au.translateY = Au.y;
const QS = (e, t, n) => {
  const r = t.measureViewportBox(), u = t.current, i = getComputedStyle(u), { display: a } = i, o = {};
  a === "none" && t.setStaticValue("display", e.display || "block"), n.forEach((c) => {
    o[c] = Au[c](r, i);
  }), t.render();
  const s = t.measureViewportBox();
  return n.forEach((c) => {
    const l = t.getValue(c);
    l && l.jump(o[c]), e[c] = Au[c](s, i);
  }), e;
}, JS = (e, t, n = {}, r = {}) => {
  t = { ...t }, r = { ...r };
  const u = Object.keys(t).filter(d2);
  let i = [], a = !1;
  const o = [];
  if (u.forEach((s) => {
    const c = e.getValue(s);
    if (!e.hasValue(s))
      return;
    let l = n[s], d = zu(l);
    const f = t[s];
    let p;
    if (Fa(f)) {
      const h = f.length, m = f[0] === null ? 1 : 0;
      l = f[m], d = zu(l);
      for (let b = m; b < h && f[b] !== null; b++)
        p ? So(zu(f[b]) === p) : p = zu(f[b]);
    } else
      p = zu(f);
    if (d !== p)
      if (cf(d) && cf(p)) {
        const h = c.get();
        typeof h == "string" && c.set(parseFloat(h)), typeof f == "string" ? t[s] = parseFloat(f) : Array.isArray(f) && p === be && (t[s] = f.map(parseFloat));
      } else
        d != null && d.transform && (p != null && p.transform) && (l === 0 || f === 0) ? l === 0 ? c.set(p.transform(l)) : t[s] = d.transform(f) : (a || (i = XS(e), a = !0), o.push(s), r[s] = r[s] !== void 0 ? r[s] : t[s], c.jump(f));
  }), o.length) {
    const s = o.indexOf("height") >= 0 ? window.pageYOffset : null, c = QS(t, e, o);
    return i.length && i.forEach(([l, d]) => {
      e.getValue(l).set(d);
    }), e.render(), go && s !== null && window.scrollTo({ top: s }), { target: c, transitionEnd: r };
  } else
    return { target: t, transitionEnd: r };
};
function e5(e, t, n, r) {
  return KS(t) ? JS(e, t, n, r) : { target: t, transitionEnd: r };
}
const t5 = (e, t, n, r) => {
  const u = GS(e, t, r);
  return t = u.target, r = u.transitionEnd, e5(e, t, n, r);
}, za = { current: null }, jl = { current: !1 };
function f2() {
  if (jl.current = !0, !!go)
    if (window.matchMedia) {
      const e = window.matchMedia("(prefers-reduced-motion)"), t = () => za.current = e.matches;
      e.addListener(t), t();
    } else
      za.current = !1;
}
function n5(e, t, n) {
  const { willChange: r } = t;
  for (const u in t) {
    const i = t[u], a = n[u];
    if (wt(i))
      e.addValue(u, i), Va(r) && r.add(u);
    else if (wt(a))
      e.addValue(u, mn(i, { owner: e })), Va(r) && r.remove(u);
    else if (a !== i)
      if (e.hasValue(u)) {
        const o = e.getValue(u);
        !o.hasAnimated && o.set(i);
      } else {
        const o = e.getStaticValue(u);
        e.addValue(u, mn(o !== void 0 ? o : i, { owner: e }));
      }
  }
  for (const u in n)
    t[u] === void 0 && e.removeValue(u);
  return t;
}
const yi = /* @__PURE__ */ new WeakMap(), p2 = Object.keys(bi), r5 = p2.length, ff = [
  "AnimationStart",
  "AnimationComplete",
  "Update",
  "BeforeLayoutMeasure",
  "LayoutMeasure",
  "LayoutAnimationStart",
  "LayoutAnimationComplete"
], u5 = yl.length;
class i5 {
  constructor({ parent: t, props: n, presenceContext: r, reducedMotionConfig: u, visualState: i }, a = {}) {
    this.current = null, this.children = /* @__PURE__ */ new Set(), this.isVariantNode = !1, this.isControllingVariants = !1, this.shouldReduceMotion = null, this.values = /* @__PURE__ */ new Map(), this.features = {}, this.valueSubscriptions = /* @__PURE__ */ new Map(), this.prevMotionValues = {}, this.events = {}, this.propEventSubscriptions = {}, this.notifyUpdate = () => this.notify("Update", this.latestValues), this.render = () => {
      this.current && (this.triggerBuild(), this.renderInstance(this.current, this.renderState, this.props.style, this.projection));
    }, this.scheduleRender = () => He.render(this.render, !1, !0);
    const { latestValues: o, renderState: s } = i;
    this.latestValues = o, this.baseTarget = { ...o }, this.initialValues = n.initial ? { ...o } : {}, this.renderState = s, this.parent = t, this.props = n, this.presenceContext = r, this.depth = t ? t.depth + 1 : 0, this.reducedMotionConfig = u, this.options = a, this.isControllingVariants = vo(n), this.isVariantNode = Ug(n), this.isVariantNode && (this.variantChildren = /* @__PURE__ */ new Set()), this.manuallyAnimateOnMount = !!(t && t.current);
    const { willChange: c, ...l } = this.scrapeMotionValuesFromProps(n, {});
    for (const d in l) {
      const f = l[d];
      o[d] !== void 0 && wt(f) && (f.set(o[d], !1), Va(c) && c.add(d));
    }
  }
  /**
   * This method takes React props and returns found MotionValues. For example, HTML
   * MotionValues will be found within the style prop, whereas for Three.js within attribute arrays.
   *
   * This isn't an abstract method as it needs calling in the constructor, but it is
   * intended to be one.
   */
  scrapeMotionValuesFromProps(t, n) {
    return {};
  }
  mount(t) {
    this.current = t, yi.set(t, this), this.projection && !this.projection.instance && this.projection.mount(t), this.parent && this.isVariantNode && !this.isControllingVariants && (this.removeFromVariantTree = this.parent.addVariantChild(this)), this.values.forEach((n, r) => this.bindToMotionValue(r, n)), jl.current || f2(), this.shouldReduceMotion = this.reducedMotionConfig === "never" ? !1 : this.reducedMotionConfig === "always" ? !0 : za.current, this.parent && this.parent.children.add(this), this.update(this.props, this.presenceContext);
  }
  unmount() {
    yi.delete(this.current), this.projection && this.projection.unmount(), bn(this.notifyUpdate), bn(this.render), this.valueSubscriptions.forEach((t) => t()), this.removeFromVariantTree && this.removeFromVariantTree(), this.parent && this.parent.children.delete(this);
    for (const t in this.events)
      this.events[t].clear();
    for (const t in this.features)
      this.features[t].unmount();
    this.current = null;
  }
  bindToMotionValue(t, n) {
    const r = Wn.has(t), u = n.on("change", (a) => {
      this.latestValues[t] = a, this.props.onUpdate && He.update(this.notifyUpdate, !1, !0), r && this.projection && (this.projection.isTransformDirty = !0);
    }), i = n.on("renderRequest", this.scheduleRender);
    this.valueSubscriptions.set(t, () => {
      u(), i();
    });
  }
  sortNodePosition(t) {
    return !this.current || !this.sortInstanceNodePosition || this.type !== t.type ? 0 : this.sortInstanceNodePosition(this.current, t.current);
  }
  loadFeatures({ children: t, ...n }, r, u, i) {
    let a, o;
    for (let s = 0; s < r5; s++) {
      const c = p2[s], { isEnabled: l, Feature: d, ProjectionNode: f, MeasureLayout: p } = bi[c];
      f && (a = f), l(n) && (!this.features[c] && d && (this.features[c] = new d(this)), p && (o = p));
    }
    if ((this.type === "html" || this.type === "svg") && !this.projection && a) {
      this.projection = new a(this.latestValues, this.parent && this.parent.projection);
      const { layoutId: s, layout: c, drag: l, dragConstraints: d, layoutScroll: f, layoutRoot: p } = n;
      this.projection.setOptions({
        layoutId: s,
        layout: c,
        alwaysMeasureLayout: !!l || d && au(d),
        visualElement: this,
        scheduleRender: () => this.scheduleRender(),
        /**
         * TODO: Update options in an effect. This could be tricky as it'll be too late
         * to update by the time layout animations run.
         * We also need to fix this safeToRemove by linking it up to the one returned by usePresence,
         * ensuring it gets called if there's no potential layout animations.
         *
         */
        animationType: typeof c == "string" ? c : "both",
        initialPromotionConfig: i,
        layoutScroll: f,
        layoutRoot: p
      });
    }
    return o;
  }
  updateFeatures() {
    for (const t in this.features) {
      const n = this.features[t];
      n.isMounted ? n.update() : (n.mount(), n.isMounted = !0);
    }
  }
  triggerBuild() {
    this.build(this.renderState, this.latestValues, this.options, this.props);
  }
  /**
   * Measure the current viewport box with or without transforms.
   * Only measures axis-aligned boxes, rotate and skew must be manually
   * removed with a re-render to work.
   */
  measureViewportBox() {
    return this.current ? this.measureInstanceViewportBox(this.current, this.props) : pt();
  }
  getStaticValue(t) {
    return this.latestValues[t];
  }
  setStaticValue(t, n) {
    this.latestValues[t] = n;
  }
  /**
   * Make a target animatable by Popmotion. For instance, if we're
   * trying to animate width from 100px to 100vw we need to measure 100vw
   * in pixels to determine what we really need to animate to. This is also
   * pluggable to support Framer's custom value types like Color,
   * and CSS variables.
   */
  makeTargetAnimatable(t, n = !0) {
    return this.makeTargetAnimatableFromInstance(t, this.props, n);
  }
  /**
   * Update the provided props. Ensure any newly-added motion values are
   * added to our map, old ones removed, and listeners updated.
   */
  update(t, n) {
    (t.transformTemplate || this.props.transformTemplate) && this.scheduleRender(), this.prevProps = this.props, this.props = t, this.prevPresenceContext = this.presenceContext, this.presenceContext = n;
    for (let r = 0; r < ff.length; r++) {
      const u = ff[r];
      this.propEventSubscriptions[u] && (this.propEventSubscriptions[u](), delete this.propEventSubscriptions[u]);
      const i = t["on" + u];
      i && (this.propEventSubscriptions[u] = this.on(u, i));
    }
    this.prevMotionValues = n5(this, this.scrapeMotionValuesFromProps(t, this.prevProps), this.prevMotionValues), this.handleChildMotionValue && this.handleChildMotionValue();
  }
  getProps() {
    return this.props;
  }
  /**
   * Returns the variant definition with a given name.
   */
  getVariant(t) {
    return this.props.variants ? this.props.variants[t] : void 0;
  }
  /**
   * Returns the defined default transition on this component.
   */
  getDefaultTransition() {
    return this.props.transition;
  }
  getTransformPagePoint() {
    return this.props.transformPagePoint;
  }
  getClosestVariantNode() {
    return this.isVariantNode ? this : this.parent ? this.parent.getClosestVariantNode() : void 0;
  }
  getVariantContext(t = !1) {
    if (t)
      return this.parent ? this.parent.getVariantContext() : void 0;
    if (!this.isControllingVariants) {
      const r = this.parent ? this.parent.getVariantContext() || {} : {};
      return this.props.initial !== void 0 && (r.initial = this.props.initial), r;
    }
    const n = {};
    for (let r = 0; r < u5; r++) {
      const u = yl[r], i = this.props[u];
      (gi(i) || i === !1) && (n[u] = i);
    }
    return n;
  }
  /**
   * Add a child visual element to our set of children.
   */
  addVariantChild(t) {
    const n = this.getClosestVariantNode();
    if (n)
      return n.variantChildren && n.variantChildren.add(t), () => n.variantChildren.delete(t);
  }
  /**
   * Add a motion value and bind it to this visual element.
   */
  addValue(t, n) {
    n !== this.values.get(t) && (this.removeValue(t), this.bindToMotionValue(t, n)), this.values.set(t, n), this.latestValues[t] = n.get();
  }
  /**
   * Remove a motion value and unbind any active subscriptions.
   */
  removeValue(t) {
    this.values.delete(t);
    const n = this.valueSubscriptions.get(t);
    n && (n(), this.valueSubscriptions.delete(t)), delete this.latestValues[t], this.removeValueFromRenderState(t, this.renderState);
  }
  /**
   * Check whether we have a motion value for this key
   */
  hasValue(t) {
    return this.values.has(t);
  }
  getValue(t, n) {
    if (this.props.values && this.props.values[t])
      return this.props.values[t];
    let r = this.values.get(t);
    return r === void 0 && n !== void 0 && (r = mn(n, { owner: this }), this.addValue(t, r)), r;
  }
  /**
   * If we're trying to animate to a previously unencountered value,
   * we need to check for it in our state and as a last resort read it
   * directly from the instance (which might have performance implications).
   */
  readValue(t) {
    var n;
    return this.latestValues[t] !== void 0 || !this.current ? this.latestValues[t] : (n = this.getBaseTargetFromProps(this.props, t)) !== null && n !== void 0 ? n : this.readValueFromInstance(this.current, t, this.options);
  }
  /**
   * Set the base target to later animate back to. This is currently
   * only hydrated on creation and when we first read a value.
   */
  setBaseTarget(t, n) {
    this.baseTarget[t] = n;
  }
  /**
   * Find the base target for a value thats been removed from all animation
   * props.
   */
  getBaseTarget(t) {
    var n;
    const { initial: r } = this.props, u = typeof r == "string" || typeof r == "object" ? (n = kl(this.props, r)) === null || n === void 0 ? void 0 : n[t] : void 0;
    if (r && u !== void 0)
      return u;
    const i = this.getBaseTargetFromProps(this.props, t);
    return i !== void 0 && !wt(i) ? i : this.initialValues[t] !== void 0 && u === void 0 ? void 0 : this.baseTarget[t];
  }
  on(t, n) {
    return this.events[t] || (this.events[t] = new Fl()), this.events[t].add(n);
  }
  notify(t, ...n) {
    this.events[t] && this.events[t].notify(...n);
  }
}
class h2 extends i5 {
  sortInstanceNodePosition(t, n) {
    return t.compareDocumentPosition(n) & 2 ? 1 : -1;
  }
  getBaseTargetFromProps(t, n) {
    return t.style ? t.style[n] : void 0;
  }
  removeValueFromRenderState(t, { vars: n, style: r }) {
    delete n[t], delete r[t];
  }
  makeTargetAnimatableFromInstance({ transition: t, transitionEnd: n, ...r }, { transformValues: u }, i) {
    let a = k_(r, t || {}, this);
    if (u && (n && (n = u(n)), r && (r = u(r)), a && (a = u(a))), i) {
      T_(this, r, a);
      const o = t5(this, r, a, n);
      n = o.transitionEnd, r = o.target;
    }
    return {
      transition: t,
      transitionEnd: n,
      ...r
    };
  }
}
function a5(e) {
  return window.getComputedStyle(e);
}
class m2 extends h2 {
  constructor() {
    super(...arguments), this.type = "html";
  }
  readValueFromInstance(t, n) {
    if (Wn.has(n)) {
      const r = Pl(n);
      return r && r.default || 0;
    } else {
      const r = a5(t), u = (Sl(n) ? r.getPropertyValue(n) : r[n]) || 0;
      return typeof u == "string" ? u.trim() : u;
    }
  }
  measureInstanceViewportBox(t, { transformPagePoint: n }) {
    return Jb(t, n);
  }
  build(t, n, r, u) {
    Cl(t, n, r, u.transformTemplate);
  }
  scrapeMotionValuesFromProps(t, n) {
    return Al(t, n);
  }
  handleChildMotionValue() {
    this.childSubscription && (this.childSubscription(), delete this.childSubscription);
    const { children: t } = this.props;
    wt(t) && (this.childSubscription = t.on("change", (n) => {
      this.current && (this.current.textContent = `${n}`);
    }));
  }
  renderInstance(t, n, r, u) {
    tb(t, n, r, u);
  }
}
class g2 extends h2 {
  constructor() {
    super(...arguments), this.type = "svg", this.isSVGTag = !1;
  }
  getBaseTargetFromProps(t, n) {
    return t[n];
  }
  readValueFromInstance(t, n) {
    if (Wn.has(n)) {
      const r = Pl(n);
      return r && r.default || 0;
    }
    return n = nb.has(n) ? n : mi(n), t.getAttribute(n);
  }
  measureInstanceViewportBox() {
    return pt();
  }
  scrapeMotionValuesFromProps(t, n) {
    return ub(t, n);
  }
  build(t, n, r, u) {
    wl(t, n, r, this.isSVGTag, u.transformTemplate);
  }
  renderInstance(t, n, r, u) {
    rb(t, n, r, u);
  }
  mount(t) {
    this.isSVGTag = Tl(t.tagName), super.mount(t);
  }
}
const b2 = (e, t) => _l(e) ? new g2(t, { enableHardwareAcceleration: !1 }) : new m2(t, { enableHardwareAcceleration: !0 }), v2 = {
  layout: {
    ProjectionNode: c2,
    MeasureLayout: t2
  }
}, o5 = {
  ...Wb,
  ...fb,
  ...l2,
  ...v2
}, _H = /* @__PURE__ */ Gg((e, t) => ab(e, t, o5, b2)), Rr = Gg(ab);
function y2() {
  const e = Z(!1);
  return Mr(() => (e.current = !0, () => {
    e.current = !1;
  }), []), e;
}
function s5() {
  const e = y2(), [t, n] = me(0), r = Ct(() => {
    e.current && n(t + 1);
  }, [t]);
  return [Ct(() => He.postRender(r), [r]), t];
}
class c5 extends Y.Component {
  getSnapshotBeforeUpdate(t) {
    const n = this.props.childRef.current;
    if (n && t.isPresent && !this.props.isPresent) {
      const r = this.props.sizeRef.current;
      r.height = n.offsetHeight || 0, r.width = n.offsetWidth || 0, r.top = n.offsetTop, r.left = n.offsetLeft;
    }
    return null;
  }
  /**
   * Required with getSnapshotBeforeUpdate to stop React complaining.
   */
  componentDidUpdate() {
  }
  render() {
    return this.props.children;
  }
}
function l5({ children: e, isPresent: t }) {
  const n = hl(), r = Z(null), u = Z({
    width: 0,
    height: 0,
    top: 0,
    left: 0
  });
  return lo(() => {
    const { width: i, height: a, top: o, left: s } = u.current;
    if (t || !r.current || !i || !a)
      return;
    r.current.dataset.motionPopId = n;
    const c = document.createElement("style");
    return document.head.appendChild(c), c.sheet && c.sheet.insertRule(`
          [data-motion-pop-id="${n}"] {
            position: absolute !important;
            width: ${i}px !important;
            height: ${a}px !important;
            top: ${o}px !important;
            left: ${s}px !important;
          }
        `), () => {
      document.head.removeChild(c);
    };
  }, [t]), Y.createElement(c5, { isPresent: t, childRef: r, sizeRef: u }, Y.cloneElement(e, { ref: r }));
}
const Ss = ({ children: e, initial: t, isPresent: n, onExitComplete: r, custom: u, presenceAffectsLayout: i, mode: a }) => {
  const o = On(d5), s = hl(), c = $e(
    () => ({
      id: s,
      initial: t,
      isPresent: n,
      custom: u,
      onExitComplete: (l) => {
        o.set(l, !0);
        for (const d of o.values())
          if (!d)
            return;
        r && r();
      },
      register: (l) => (o.set(l, !1), () => o.delete(l))
    }),
    /**
     * If the presence of a child affects the layout of the components around it,
     * we want to make a new context value to ensure they get re-rendered
     * so they can detect that layout change.
     */
    i ? void 0 : [n]
  );
  return $e(() => {
    o.forEach((l, d) => o.set(d, !1));
  }, [n]), Y.useEffect(() => {
    !n && !o.size && r && r();
  }, [n]), a === "popLayout" && (e = Y.createElement(l5, { isPresent: n }, e)), Y.createElement(mo.Provider, { value: c }, e);
};
function d5() {
  return /* @__PURE__ */ new Map();
}
function x2(e) {
  return oe(() => () => e(), []);
}
const Sr = (e) => e.key || "";
function f5(e, t) {
  e.forEach((n) => {
    const r = Sr(n);
    t.set(r, n);
  });
}
function p5(e) {
  const t = [];
  return Ou.forEach(e, (n) => {
    Pi(n) && t.push(n);
  }), t;
}
const SH = ({ children: e, custom: t, initial: n = !0, onExitComplete: r, exitBeforeEnter: u, presenceAffectsLayout: i = !0, mode: a = "sync" }) => {
  const o = ke(xl).forceRender || s5()[0], s = y2(), c = p5(e);
  let l = c;
  const d = Z(/* @__PURE__ */ new Map()).current, f = Z(l), p = Z(/* @__PURE__ */ new Map()).current, h = Z(!0);
  if (Mr(() => {
    h.current = !1, f5(c, p), f.current = l;
  }), x2(() => {
    h.current = !0, p.clear(), d.clear();
  }), h.current)
    return Y.createElement(Y.Fragment, null, l.map((y) => Y.createElement(Ss, { key: Sr(y), isPresent: !0, initial: n ? void 0 : !1, presenceAffectsLayout: i, mode: a }, y)));
  l = [...l];
  const m = f.current.map(Sr), b = c.map(Sr), x = m.length;
  for (let y = 0; y < x; y++) {
    const g = m[y];
    b.indexOf(g) === -1 && !d.has(g) && d.set(g, void 0);
  }
  return a === "wait" && d.size && (l = []), d.forEach((y, g) => {
    if (b.indexOf(g) !== -1)
      return;
    const v = p.get(g);
    if (!v)
      return;
    const S = m.indexOf(g);
    let _ = y;
    if (!_) {
      const A = () => {
        d.delete(g);
        const k = Array.from(p.keys()).filter((T) => !b.includes(T));
        if (k.forEach((T) => p.delete(T)), f.current = c.filter((T) => {
          const L = Sr(T);
          return (
            // filter out the node exiting
            L === g || // filter out the leftover children
            k.includes(L)
          );
        }), !d.size) {
          if (s.current === !1)
            return;
          o(), r && r();
        }
      };
      _ = Y.createElement(Ss, { key: Sr(v), isPresent: !1, onExitComplete: A, custom: t, presenceAffectsLayout: i, mode: a }, v), d.set(g, _);
    }
    l.splice(S, 0, _);
  }), l = l.map((y) => {
    const g = y.key;
    return d.has(g) ? y : Y.createElement(Ss, { key: Sr(y), isPresent: !0, presenceAffectsLayout: i, mode: a }, y);
  }), Y.createElement(Y.Fragment, null, d.size ? l : l.map((y) => Rg(y)));
};
function CH({ children: e, isValidProp: t, ...n }) {
  t && Jg(t), n = { ...ke(wu), ...n }, n.isStatic = On(() => n.isStatic);
  const r = $e(() => n, [JSON.stringify(n.transition), n.transformPagePoint, n.reducedMotion]);
  return Y.createElement(wu.Provider, { value: r }, e);
}
function $i({ children: e, features: t, strict: n = !1 }) {
  const [, r] = me(!Cs(t)), u = Z(void 0);
  if (!Cs(t)) {
    const { renderer: i, ...a } = t;
    u.current = i, mc(a);
  }
  return oe(() => {
    Cs(t) && t().then(({ renderer: i, ...a }) => {
      mc(a), u.current = i, r(!0);
    });
  }, []), Y.createElement(bl.Provider, { value: { renderer: u.current, strict: n } }, e);
}
function Cs(e) {
  return typeof e == "function";
}
function sr(e) {
  const t = On(() => mn(e)), { isStatic: n } = ke(wu);
  if (n) {
    const [, r] = me(e);
    oe(() => t.on("change", r), []);
  }
  return t;
}
const h5 = (e) => e && typeof e == "object" && e.mix, m5 = (e) => h5(e) ? e.mix : void 0;
function g5(...e) {
  const t = !Array.isArray(e[0]), n = t ? 0 : -1, r = e[0 + n], u = e[1 + n], i = e[2 + n], a = e[3 + n], o = Co(u, i, {
    mixer: m5(i[0]),
    ...a
  });
  return t ? o(r) : o;
}
function _2(e, t) {
  const n = sr(t()), r = () => n.set(t());
  return r(), Mr(() => {
    const u = () => He.update(r, !1, !0), i = e.map((a) => a.on("change", u));
    return () => {
      i.forEach((a) => a()), bn(r);
    };
  }), n;
}
function b5(e) {
  oi.current = [], e();
  const t = _2(oi.current, e);
  return oi.current = void 0, t;
}
function Ua(e, t, n, r) {
  if (typeof e == "function")
    return b5(e);
  const u = typeof t == "function" ? t : g5(t, n, r);
  return Array.isArray(e) ? pf(e, u) : pf([e], ([i]) => u(i));
}
function pf(e, t) {
  const n = On(() => []);
  return _2(e, () => {
    n.length = 0;
    const r = e.length;
    for (let u = 0; u < r; u++)
      n[u] = e[u].get();
    return t(n);
  });
}
const Iu = {
  renderer: b2,
  ...Wb,
  ...fb
}, EH = {
  ...Iu,
  ...l2,
  ...v2
};
function v5(e, t = {}) {
  const { isStatic: n } = ke(wu), r = Z(null), u = sr(wt(e) ? e.get() : e), i = () => {
    r.current && r.current.stop();
  };
  return lo(() => u.attach((a, o) => {
    if (n)
      return o(a);
    if (i(), r.current = vi({
      keyframes: [u.get(), a],
      velocity: u.getVelocity(),
      type: "spring",
      restDelta: 1e-3,
      restSpeed: 0.01,
      ...t,
      onUpdate: o
    }), !vt.isProcessing) {
      const s = performance.now() - vt.timestamp;
      s < 30 && (r.current.time = En(s));
    }
    return u.get();
  }, i), [JSON.stringify(t)]), Mr(() => {
    if (wt(e))
      return e.on("change", (a) => u.set(parseFloat(a)));
  }, [u]), u;
}
function xi(e, t, n) {
  lo(() => e.on(t, n), [e, t, n]);
}
function wo(e, t, n) {
  var r;
  if (typeof e == "string") {
    let u = document;
    t && (So(!!t.current), u = t.current), n ? ((r = n[e]) !== null && r !== void 0 || (n[e] = u.querySelectorAll(e)), e = n[e]) : e = u.querySelectorAll(e);
  } else
    e instanceof Element && (e = [e]);
  return Array.from(e || []);
}
const wa = /* @__PURE__ */ new WeakMap();
let Jn;
function y5(e, t) {
  if (t) {
    const { inlineSize: n, blockSize: r } = t[0];
    return { width: n, height: r };
  } else
    return e instanceof SVGElement && "getBBox" in e ? e.getBBox() : {
      width: e.offsetWidth,
      height: e.offsetHeight
    };
}
function x5({ target: e, contentRect: t, borderBoxSize: n }) {
  var r;
  (r = wa.get(e)) === null || r === void 0 || r.forEach((u) => {
    u({
      target: e,
      contentSize: t,
      get size() {
        return y5(e, n);
      }
    });
  });
}
function _5(e) {
  e.forEach(x5);
}
function S5() {
  typeof ResizeObserver > "u" || (Jn = new ResizeObserver(_5));
}
function C5(e, t) {
  Jn || S5();
  const n = wo(e);
  return n.forEach((r) => {
    let u = wa.get(r);
    u || (u = /* @__PURE__ */ new Set(), wa.set(r, u)), u.add(t), Jn == null || Jn.observe(r);
  }), () => {
    n.forEach((r) => {
      const u = wa.get(r);
      u == null || u.delete(t), u != null && u.size || Jn == null || Jn.unobserve(r);
    });
  };
}
const Ta = /* @__PURE__ */ new Set();
let li;
function E5() {
  li = () => {
    const e = {
      width: window.innerWidth,
      height: window.innerHeight
    }, t = {
      target: window,
      size: e,
      contentSize: e
    };
    Ta.forEach((n) => n(t));
  }, window.addEventListener("resize", li);
}
function w5(e) {
  return Ta.add(e), li || E5(), () => {
    Ta.delete(e), !Ta.size && li && (li = void 0);
  };
}
function T5(e, t) {
  return typeof e == "function" ? w5(e) : C5(e, t);
}
const A5 = 50, hf = () => ({
  current: 0,
  offset: [],
  progress: 0,
  scrollLength: 0,
  targetOffset: 0,
  targetLength: 0,
  containerLength: 0,
  velocity: 0
}), k5 = () => ({
  time: 0,
  x: hf(),
  y: hf()
}), L5 = {
  x: {
    length: "Width",
    position: "Left"
  },
  y: {
    length: "Height",
    position: "Top"
  }
};
function mf(e, t, n, r) {
  const u = n[t], { length: i, position: a } = L5[t], o = u.current, s = n.time;
  u.current = e["scroll" + a], u.scrollLength = e["scroll" + i] - e["client" + i], u.offset.length = 0, u.offset[0] = 0, u.offset[1] = u.scrollLength, u.progress = Dr(0, u.scrollLength, u.current);
  const c = r - s;
  u.velocity = c > A5 ? 0 : Il(u.current - o, c);
}
function D5(e, t, n) {
  mf(e, "x", t, n), mf(e, "y", t, n), t.time = n;
}
function N5(e, t) {
  const n = { x: 0, y: 0 };
  let r = e;
  for (; r && r !== t; )
    if (r instanceof HTMLElement)
      n.x += r.offsetLeft, n.y += r.offsetTop, r = r.offsetParent;
    else if (r.tagName === "svg") {
      const u = r.getBoundingClientRect();
      r = r.parentElement;
      const i = r.getBoundingClientRect();
      n.x += u.left - i.left, n.y += u.top - i.top;
    } else if (r instanceof SVGGraphicsElement) {
      const { x: u, y: i } = r.getBBox();
      n.x += u, n.y += i;
      let a = null, o = r.parentNode;
      for (; !a; )
        o.tagName === "svg" && (a = o), o = r.parentNode;
      r = a;
    } else
      break;
  return n;
}
const O5 = {
  Enter: [
    [0, 1],
    [1, 1]
  ],
  Exit: [
    [0, 0],
    [1, 0]
  ],
  Any: [
    [1, 0],
    [0, 1]
  ],
  All: [
    [0, 0],
    [1, 1]
  ]
}, Nc = {
  start: 0,
  center: 0.5,
  end: 1
};
function gf(e, t, n = 0) {
  let r = 0;
  if (Nc[e] !== void 0 && (e = Nc[e]), typeof e == "string") {
    const u = parseFloat(e);
    e.endsWith("px") ? r = u : e.endsWith("%") ? e = u / 100 : e.endsWith("vw") ? r = u / 100 * document.documentElement.clientWidth : e.endsWith("vh") ? r = u / 100 * document.documentElement.clientHeight : e = u;
  }
  return typeof e == "number" && (r = t * e), n + r;
}
const I5 = [0, 0];
function M5(e, t, n, r) {
  let u = Array.isArray(e) ? e : I5, i = 0, a = 0;
  return typeof e == "number" ? u = [e, e] : typeof e == "string" && (e = e.trim(), e.includes(" ") ? u = e.split(" ") : u = [e, Nc[e] ? e : "0"]), i = gf(u[0], n, r), a = gf(u[1], t), i - a;
}
const P5 = { x: 0, y: 0 };
function R5(e) {
  return "getBBox" in e && e.tagName !== "svg" ? e.getBBox() : { width: e.clientWidth, height: e.clientHeight };
}
function B5(e, t, n) {
  let { offset: r = O5.All } = n;
  const { target: u = e, axis: i = "y" } = n, a = i === "y" ? "height" : "width", o = u !== e ? N5(u, e) : P5, s = u === e ? { width: e.scrollWidth, height: e.scrollHeight } : R5(u), c = {
    width: e.clientWidth,
    height: e.clientHeight
  };
  t[i].offset.length = 0;
  let l = !t[i].interpolate;
  const d = r.length;
  for (let f = 0; f < d; f++) {
    const p = M5(r[f], c[a], s[a], o[i]);
    !l && p !== t[i].interpolatorOffsets[f] && (l = !0), t[i].offset[f] = p;
  }
  l && (t[i].interpolate = Co(t[i].offset, Ol(r)), t[i].interpolatorOffsets = [...t[i].offset]), t[i].progress = t[i].interpolate(t[i].current);
}
function F5(e, t = e, n) {
  if (n.x.targetOffset = 0, n.y.targetOffset = 0, t !== e) {
    let r = t;
    for (; r && r !== e; )
      n.x.targetOffset += r.offsetLeft, n.y.targetOffset += r.offsetTop, r = r.offsetParent;
  }
  n.x.targetLength = t === e ? t.scrollWidth : t.clientWidth, n.y.targetLength = t === e ? t.scrollHeight : t.clientHeight, n.x.containerLength = e.clientWidth, n.y.containerLength = e.clientHeight;
}
function H5(e, t, n, r = {}) {
  return {
    measure: () => F5(e, r.target, n),
    update: (u) => {
      D5(e, n, u), (r.offset || r.target) && B5(e, n, r);
    },
    notify: () => t(n)
  };
}
const qu = /* @__PURE__ */ new WeakMap(), bf = /* @__PURE__ */ new WeakMap(), Es = /* @__PURE__ */ new WeakMap(), vf = (e) => e === document.documentElement ? window : e;
function $5(e, { container: t = document.documentElement, ...n } = {}) {
  let r = Es.get(t);
  r || (r = /* @__PURE__ */ new Set(), Es.set(t, r));
  const u = k5(), i = H5(t, e, u, n);
  if (r.add(i), !qu.has(t)) {
    const o = () => {
      for (const f of r)
        f.measure();
    }, s = () => {
      for (const f of r)
        f.update(vt.timestamp);
    }, c = () => {
      for (const f of r)
        f.notify();
    }, l = () => {
      He.read(o, !1, !0), He.read(s, !1, !0), He.update(c, !1, !0);
    };
    qu.set(t, l);
    const d = vf(t);
    window.addEventListener("resize", l, { passive: !0 }), t !== document.documentElement && bf.set(t, T5(t, l)), d.addEventListener("scroll", l, { passive: !0 });
  }
  const a = qu.get(t);
  return He.read(a, !1, !0), () => {
    var o;
    bn(a);
    const s = Es.get(t);
    if (!s || (s.delete(i), s.size))
      return;
    const c = qu.get(t);
    qu.delete(t), c && (vf(t).removeEventListener("scroll", c), (o = bf.get(t)) === null || o === void 0 || o(), window.removeEventListener("resize", c));
  };
}
function yf(e, t) {
  hb(!!(!t || t.current));
}
const V5 = () => ({
  scrollX: mn(0),
  scrollY: mn(0),
  scrollXProgress: mn(0),
  scrollYProgress: mn(0)
});
function qa({ container: e, target: t, layoutEffect: n = !0, ...r } = {}) {
  const u = On(V5);
  return (n ? Mr : oe)(() => (yf("target", t), yf("container", e), $5(({ x: a, y: o }) => {
    u.scrollX.set(a.current), u.scrollXProgress.set(a.progress), u.scrollY.set(o.current), u.scrollYProgress.set(o.progress);
  }, {
    ...r,
    container: (e == null ? void 0 : e.current) || void 0,
    target: (t == null ? void 0 : t.current) || void 0
  })), [e, t, JSON.stringify(r.offset)]), u;
}
class j5 extends zb {
  constructor() {
    super(...arguments), this.members = [], this.transforms = /* @__PURE__ */ new Set();
  }
  add(t) {
    let n;
    Wn.has(t) ? (this.transforms.add(t), n = "transform") : !t.startsWith("origin") && !Sl(t) && t !== "willChange" && (n = mi(t)), n && (Eo(this.members, n), this.update());
  }
  remove(t) {
    Wn.has(t) ? (this.transforms.delete(t), this.transforms.size || Tu(this.members, "transform")) : Tu(this.members, mi(t)), this.update();
  }
  update() {
    this.set(this.members.length ? this.members.join(", ") : "auto");
  }
}
function wH() {
  return On(() => new j5("auto"));
}
function S2() {
  !jl.current && f2();
  const [e] = me(za.current);
  return e;
}
function z5(e) {
  e.values.forEach((t) => t.stop());
}
function U5() {
  const e = /* @__PURE__ */ new Set(), t = {
    subscribe(n) {
      return e.add(n), () => void e.delete(n);
    },
    start(n, r) {
      const u = [];
      return e.forEach((i) => {
        u.push(Gb(i, n, {
          transitionOverride: r
        }));
      }), Promise.all(u);
    },
    set(n) {
      return e.forEach((r) => {
        w_(r, n);
      });
    },
    stop() {
      e.forEach((n) => {
        z5(n);
      });
    },
    mount() {
      return () => {
        t.stop();
      };
    }
  };
  return t;
}
function q5(e, t) {
  let n;
  const r = () => {
    const { currentTime: u } = t, a = (u === null ? 0 : u.value) / 100;
    n !== a && e(a), n = a;
  };
  return He.update(r, !0), () => bn(r);
}
const G5 = Hb(() => window.ScrollTimeline !== void 0);
class C2 {
  constructor(t) {
    this.animations = t.filter(Boolean);
  }
  then(t, n) {
    return Promise.all(this.animations).then(t).catch(n);
  }
  /**
   * TODO: Filter out cancelled or stopped animations before returning
   */
  getAll(t) {
    return this.animations[0][t];
  }
  setAll(t, n) {
    for (let r = 0; r < this.animations.length; r++)
      this.animations[r][t] = n;
  }
  attachTimeline(t) {
    const n = this.animations.map((r) => {
      if (G5() && r.attachTimeline)
        r.attachTimeline(t);
      else
        return r.pause(), q5((u) => {
          r.time = r.duration * u;
        }, t);
    });
    return () => {
      n.forEach((r, u) => {
        r && r(), this.animations[u].stop();
      });
    };
  }
  get time() {
    return this.getAll("time");
  }
  set time(t) {
    this.setAll("time", t);
  }
  get speed() {
    return this.getAll("speed");
  }
  set speed(t) {
    this.setAll("speed", t);
  }
  get duration() {
    let t = 0;
    for (let n = 0; n < this.animations.length; n++)
      t = Math.max(t, this.animations[n].duration);
    return t;
  }
  runAll(t) {
    this.animations.forEach((n) => n[t]());
  }
  play() {
    this.runAll("play");
  }
  pause() {
    this.runAll("pause");
  }
  stop() {
    this.runAll("stop");
  }
  cancel() {
    this.runAll("cancel");
  }
  complete() {
    this.runAll("complete");
  }
}
function W5(e) {
  return typeof e == "object" && !Array.isArray(e);
}
function K5(e) {
  const t = {
    presenceContext: null,
    props: {},
    visualState: {
      renderState: {
        transform: {},
        transformOrigin: {},
        style: {},
        vars: {},
        attrs: {}
      },
      latestValues: {}
    }
  }, n = a2(e) ? new g2(t, {
    enableHardwareAcceleration: !1
  }) : new m2(t, {
    enableHardwareAcceleration: !0
  });
  n.mount(e), yi.set(e, n);
}
function Y5(e, t = 100) {
  const n = Ml({ keyframes: [0, t], ...e }), r = Math.min(_c(n), xc);
  return {
    type: "keyframes",
    ease: (u) => n.next(r * u).value / t,
    duration: En(r)
  };
}
function xf(e, t, n, r) {
  var u;
  return typeof t == "number" ? t : t.startsWith("-") || t.startsWith("+") ? Math.max(0, e + parseFloat(t)) : t === "<" ? n : (u = r.get(t)) !== null && u !== void 0 ? u : e;
}
const Z5 = (e, t, n) => {
  const r = t - e;
  return ((n - e) % r + r) % r + e;
};
function X5(e, t) {
  return _b(e) ? e[Z5(0, e.length, t)] : e;
}
function Q5(e, t, n) {
  for (let r = 0; r < e.length; r++) {
    const u = e[r];
    u.at > t && u.at < n && (Tu(e, u), r--);
  }
}
function J5(e, t, n, r, u, i) {
  Q5(e, u, i);
  for (let a = 0; a < t.length; a++)
    e.push({
      value: t[a],
      at: tt(u, i, r[a]),
      easing: X5(n, a)
    });
}
function eC(e, t) {
  return e.at === t.at ? e.value === null ? 1 : t.value === null ? -1 : 0 : e.at - t.at;
}
const tC = "easeInOut";
function nC(e, { defaultTransition: t = {}, ...n } = {}, r) {
  const u = t.duration || 0.3, i = /* @__PURE__ */ new Map(), a = /* @__PURE__ */ new Map(), o = {}, s = /* @__PURE__ */ new Map();
  let c = 0, l = 0, d = 0;
  for (let f = 0; f < e.length; f++) {
    const p = e[f];
    if (typeof p == "string") {
      s.set(p, l);
      continue;
    } else if (!Array.isArray(p)) {
      s.set(p.name, xf(l, p.at, c, s));
      continue;
    }
    let [h, m, b = {}] = p;
    b.at !== void 0 && (l = xf(l, b.at, c, s));
    let x = 0;
    const y = (g, v, S, _ = 0, A = 0) => {
      const k = rC(g), { delay: T = 0, times: L = Ol(k), type: w = "keyframes", ...D } = v;
      let { ease: N = t.ease || "easeOut", duration: O } = v;
      const H = typeof T == "function" ? T(_, A) : T, $ = k.length;
      if ($ <= 2 && w === "spring") {
        let P = 100;
        if ($ === 2 && aC(k)) {
          const V = k[1] - k[0];
          P = Math.abs(V);
        }
        const C = { ...D };
        O !== void 0 && (C.duration = qn(O));
        const R = Y5(C, P);
        N = R.ease, O = R.duration;
      }
      O ?? (O = u);
      const j = l + H, z = j + O;
      L.length === 1 && L[0] === 0 && (L[1] = 1);
      const M = L.length - k.length;
      M > 0 && Bb(L, M), k.length === 1 && k.unshift(null), J5(S, k, N, L, j, z), x = Math.max(H + O, x), d = Math.max(z, d);
    };
    if (wt(h)) {
      const g = _f(h, a);
      y(m, b, Sf("default", g));
    } else {
      const g = wo(h, r, o), v = g.length;
      for (let S = 0; S < v; S++) {
        m = m, b = b;
        const _ = g[S], A = _f(_, a);
        for (const k in m)
          y(m[k], uC(b, k), Sf(k, A), S, v);
      }
    }
    c = l, l += x;
  }
  return a.forEach((f, p) => {
    for (const h in f) {
      const m = f[h];
      m.sort(eC);
      const b = [], x = [], y = [];
      for (let v = 0; v < m.length; v++) {
        const { at: S, value: _, easing: A } = m[v];
        b.push(_), x.push(Dr(0, d, S)), y.push(A || "easeOut");
      }
      x[0] !== 0 && (x.unshift(0), b.unshift(b[0]), y.unshift(tC)), x[x.length - 1] !== 1 && (x.push(1), b.push(null)), i.has(p) || i.set(p, {
        keyframes: {},
        transition: {}
      });
      const g = i.get(p);
      g.keyframes[h] = b, g.transition[h] = {
        ...t,
        duration: d,
        ease: y,
        times: x,
        ...n
      };
    }
  }), i;
}
function _f(e, t) {
  return !t.has(e) && t.set(e, {}), t.get(e);
}
function Sf(e, t) {
  return t[e] || (t[e] = []), t[e];
}
function rC(e) {
  return Array.isArray(e) ? e : [e];
}
function uC(e, t) {
  return e[t] ? { ...e, ...e[t] } : { ...e };
}
const iC = (e) => typeof e == "number", aC = (e) => e.every(iC);
function E2(e, t, n, r) {
  const u = wo(e, r), i = u.length, a = [];
  for (let o = 0; o < i; o++) {
    const s = u[o];
    yi.has(s) || K5(s);
    const c = yi.get(s), l = { ...n };
    typeof l.delay == "function" && (l.delay = l.delay(o, i)), a.push(...$l(c, { ...t, transition: l }, {}));
  }
  return new C2(a);
}
const oC = (e) => Array.isArray(e) && Array.isArray(e[0]);
function sC(e, t, n) {
  const r = [];
  return nC(e, t, n).forEach(({ keyframes: i, transition: a }, o) => {
    let s;
    wt(o) ? s = Vl(o, i.default, a.default) : s = E2(o, i, a), r.push(s);
  }), new C2(r);
}
const cC = (e) => {
  function t(n, r, u) {
    let i;
    return oC(n) ? i = sC(n, r, e) : W5(r) ? i = E2(n, r, u, e) : i = Vl(n, r, u), e && e.animations.push(i), i;
  }
  return t;
};
function TH() {
  const e = On(() => ({
    current: null,
    animations: []
  })), t = On(() => cC(e));
  return x2(() => {
    e.animations.forEach((n) => n.stop());
  }), [e, t];
}
function AH() {
  const e = On(U5);
  return Mr(e.mount, []), e;
}
const lC = {
  some: 0,
  all: 1
};
function dC(e, t, { root: n, margin: r, amount: u = "some" } = {}) {
  const i = wo(e), a = /* @__PURE__ */ new WeakMap(), o = (c) => {
    c.forEach((l) => {
      const d = a.get(l.target);
      if (l.isIntersecting !== !!d)
        if (l.isIntersecting) {
          const f = t(l);
          typeof f == "function" ? a.set(l.target, f) : s.unobserve(l.target);
        } else
          d && (d(l), a.delete(l.target));
    });
  }, s = new IntersectionObserver(o, {
    root: n,
    rootMargin: r,
    threshold: typeof u == "number" ? u : lC[u]
  });
  return i.forEach((c) => s.observe(c)), () => s.disconnect();
}
function w2(e, { root: t, margin: n, amount: r, once: u = !1 } = {}) {
  const [i, a] = me(!1);
  return oe(() => {
    if (!e.current || u && i)
      return;
    const o = () => (a(!0), u ? void 0 : () => a(!1)), s = {
      root: t && t.current || void 0,
      margin: n,
      amount: r
    };
    return dC(e.current, o, s);
  }, [t, e, n, u, r]), i;
}
var ee = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function T2(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
function fC(e) {
  if (e.__esModule)
    return e;
  var t = e.default;
  if (typeof t == "function") {
    var n = function r() {
      return this instanceof r ? Reflect.construct(t, arguments, this.constructor) : t.apply(this, arguments);
    };
    n.prototype = t.prototype;
  } else
    n = {};
  return Object.defineProperty(n, "__esModule", { value: !0 }), Object.keys(e).forEach(function(r) {
    var u = Object.getOwnPropertyDescriptor(e, r);
    Object.defineProperty(n, r, u.get ? u : {
      enumerable: !0,
      get: function() {
        return e[r];
      }
    });
  }), n;
}
var Ze = {}, Br = {};
Object.defineProperty(Br, "__esModule", { value: !0 });
Br.BLOCKS = void 0;
var Cf;
(function(e) {
  e.DOCUMENT = "document", e.PARAGRAPH = "paragraph", e.HEADING_1 = "heading-1", e.HEADING_2 = "heading-2", e.HEADING_3 = "heading-3", e.HEADING_4 = "heading-4", e.HEADING_5 = "heading-5", e.HEADING_6 = "heading-6", e.OL_LIST = "ordered-list", e.UL_LIST = "unordered-list", e.LIST_ITEM = "list-item", e.HR = "hr", e.QUOTE = "blockquote", e.EMBEDDED_ENTRY = "embedded-entry-block", e.EMBEDDED_ASSET = "embedded-asset-block", e.EMBEDDED_RESOURCE = "embedded-resource-block", e.TABLE = "table", e.TABLE_ROW = "table-row", e.TABLE_CELL = "table-cell", e.TABLE_HEADER_CELL = "table-header-cell";
})(Cf || (Br.BLOCKS = Cf = {}));
var Mu = {};
Object.defineProperty(Mu, "__esModule", { value: !0 });
Mu.INLINES = void 0;
var Ef;
(function(e) {
  e.ASSET_HYPERLINK = "asset-hyperlink", e.EMBEDDED_ENTRY = "embedded-entry-inline", e.EMBEDDED_RESOURCE = "embedded-resource-inline", e.ENTRY_HYPERLINK = "entry-hyperlink", e.HYPERLINK = "hyperlink", e.RESOURCE_HYPERLINK = "resource-hyperlink";
})(Ef || (Mu.INLINES = Ef = {}));
var Vi = {};
Object.defineProperty(Vi, "__esModule", { value: !0 });
Vi.MARKS = void 0;
var wf;
(function(e) {
  e.BOLD = "bold", e.ITALIC = "italic", e.UNDERLINE = "underline", e.CODE = "code", e.SUPERSCRIPT = "superscript", e.SUBSCRIPT = "subscript", e.STRIKETHROUGH = "strikethrough";
})(wf || (Vi.MARKS = wf = {}));
var A2 = {};
(function(e) {
  var t = ee && ee.__spreadArray || function(a, o, s) {
    if (s || arguments.length === 2)
      for (var c = 0, l = o.length, d; c < l; c++)
        (d || !(c in o)) && (d || (d = Array.prototype.slice.call(o, 0, c)), d[c] = o[c]);
    return a.concat(d || Array.prototype.slice.call(o));
  }, n;
  Object.defineProperty(e, "__esModule", { value: !0 }), e.V1_MARKS = e.V1_NODE_TYPES = e.TEXT_CONTAINERS = e.HEADINGS = e.CONTAINERS = e.VOID_BLOCKS = e.TABLE_BLOCKS = e.LIST_ITEM_BLOCKS = e.TOP_LEVEL_BLOCKS = void 0;
  var r = Br, u = Mu, i = Vi;
  e.TOP_LEVEL_BLOCKS = [
    r.BLOCKS.PARAGRAPH,
    r.BLOCKS.HEADING_1,
    r.BLOCKS.HEADING_2,
    r.BLOCKS.HEADING_3,
    r.BLOCKS.HEADING_4,
    r.BLOCKS.HEADING_5,
    r.BLOCKS.HEADING_6,
    r.BLOCKS.OL_LIST,
    r.BLOCKS.UL_LIST,
    r.BLOCKS.HR,
    r.BLOCKS.QUOTE,
    r.BLOCKS.EMBEDDED_ENTRY,
    r.BLOCKS.EMBEDDED_ASSET,
    r.BLOCKS.EMBEDDED_RESOURCE,
    r.BLOCKS.TABLE
  ], e.LIST_ITEM_BLOCKS = [
    r.BLOCKS.PARAGRAPH,
    r.BLOCKS.HEADING_1,
    r.BLOCKS.HEADING_2,
    r.BLOCKS.HEADING_3,
    r.BLOCKS.HEADING_4,
    r.BLOCKS.HEADING_5,
    r.BLOCKS.HEADING_6,
    r.BLOCKS.OL_LIST,
    r.BLOCKS.UL_LIST,
    r.BLOCKS.HR,
    r.BLOCKS.QUOTE,
    r.BLOCKS.EMBEDDED_ENTRY,
    r.BLOCKS.EMBEDDED_ASSET,
    r.BLOCKS.EMBEDDED_RESOURCE
  ], e.TABLE_BLOCKS = [
    r.BLOCKS.TABLE,
    r.BLOCKS.TABLE_ROW,
    r.BLOCKS.TABLE_CELL,
    r.BLOCKS.TABLE_HEADER_CELL
  ], e.VOID_BLOCKS = [
    r.BLOCKS.HR,
    r.BLOCKS.EMBEDDED_ENTRY,
    r.BLOCKS.EMBEDDED_ASSET,
    r.BLOCKS.EMBEDDED_RESOURCE
  ], e.CONTAINERS = (n = {}, n[r.BLOCKS.OL_LIST] = [r.BLOCKS.LIST_ITEM], n[r.BLOCKS.UL_LIST] = [r.BLOCKS.LIST_ITEM], n[r.BLOCKS.LIST_ITEM] = e.LIST_ITEM_BLOCKS, n[r.BLOCKS.QUOTE] = [r.BLOCKS.PARAGRAPH], n[r.BLOCKS.TABLE] = [r.BLOCKS.TABLE_ROW], n[r.BLOCKS.TABLE_ROW] = [r.BLOCKS.TABLE_CELL, r.BLOCKS.TABLE_HEADER_CELL], n[r.BLOCKS.TABLE_CELL] = [r.BLOCKS.PARAGRAPH, r.BLOCKS.UL_LIST, r.BLOCKS.OL_LIST], n[r.BLOCKS.TABLE_HEADER_CELL] = [r.BLOCKS.PARAGRAPH], n), e.HEADINGS = [
    r.BLOCKS.HEADING_1,
    r.BLOCKS.HEADING_2,
    r.BLOCKS.HEADING_3,
    r.BLOCKS.HEADING_4,
    r.BLOCKS.HEADING_5,
    r.BLOCKS.HEADING_6
  ], e.TEXT_CONTAINERS = t([r.BLOCKS.PARAGRAPH], e.HEADINGS, !0), e.V1_NODE_TYPES = [
    r.BLOCKS.DOCUMENT,
    r.BLOCKS.PARAGRAPH,
    r.BLOCKS.HEADING_1,
    r.BLOCKS.HEADING_2,
    r.BLOCKS.HEADING_3,
    r.BLOCKS.HEADING_4,
    r.BLOCKS.HEADING_5,
    r.BLOCKS.HEADING_6,
    r.BLOCKS.OL_LIST,
    r.BLOCKS.UL_LIST,
    r.BLOCKS.LIST_ITEM,
    r.BLOCKS.HR,
    r.BLOCKS.QUOTE,
    r.BLOCKS.EMBEDDED_ENTRY,
    r.BLOCKS.EMBEDDED_ASSET,
    u.INLINES.HYPERLINK,
    u.INLINES.ENTRY_HYPERLINK,
    u.INLINES.ASSET_HYPERLINK,
    u.INLINES.EMBEDDED_ENTRY,
    "text"
  ], e.V1_MARKS = [i.MARKS.BOLD, i.MARKS.CODE, i.MARKS.ITALIC, i.MARKS.UNDERLINE];
})(A2);
var k2 = {};
Object.defineProperty(k2, "__esModule", { value: !0 });
var L2 = {};
Object.defineProperty(L2, "__esModule", { value: !0 });
var To = {};
Object.defineProperty(To, "__esModule", { value: !0 });
To.EMPTY_DOCUMENT = void 0;
var Tf = Br;
To.EMPTY_DOCUMENT = {
  nodeType: Tf.BLOCKS.DOCUMENT,
  data: {},
  content: [
    {
      nodeType: Tf.BLOCKS.PARAGRAPH,
      data: {},
      content: [
        {
          nodeType: "text",
          value: "",
          marks: [],
          data: {}
        }
      ]
    }
  ]
};
var ji = {};
Object.defineProperty(ji, "__esModule", { value: !0 });
ji.isInline = mC;
ji.isBlock = gC;
ji.isText = bC;
var pC = Br, hC = Mu;
function D2(e, t) {
  for (var n = 0, r = Object.keys(e); n < r.length; n++) {
    var u = r[n];
    if (t === e[u])
      return !0;
  }
  return !1;
}
function mC(e) {
  return D2(hC.INLINES, e.nodeType);
}
function gC(e) {
  return D2(pC.BLOCKS, e.nodeType);
}
function bC(e) {
  return e.nodeType === "text";
}
function vC(e) {
  throw new Error('Could not dynamically require "' + e + '". Please configure the dynamicRequireTargets or/and ignoreDynamicRequires option of @rollup/plugin-commonjs appropriately for this require call to work.');
}
var zl = {};
Object.defineProperty(zl, "__esModule", { value: !0 });
zl.getSchemaWithNodeType = yC;
function yC(e) {
  try {
    return vC("./generated/".concat(e, ".json"));
  } catch {
    throw new Error('Schema for nodeType "'.concat(e, '" was not found.'));
  }
}
(function(e) {
  var t = ee && ee.__createBinding || (Object.create ? function(d, f, p, h) {
    h === void 0 && (h = p);
    var m = Object.getOwnPropertyDescriptor(f, p);
    (!m || ("get" in m ? !f.__esModule : m.writable || m.configurable)) && (m = { enumerable: !0, get: function() {
      return f[p];
    } }), Object.defineProperty(d, h, m);
  } : function(d, f, p, h) {
    h === void 0 && (h = p), d[h] = f[p];
  }), n = ee && ee.__setModuleDefault || (Object.create ? function(d, f) {
    Object.defineProperty(d, "default", { enumerable: !0, value: f });
  } : function(d, f) {
    d.default = f;
  }), r = ee && ee.__exportStar || function(d, f) {
    for (var p in d)
      p !== "default" && !Object.prototype.hasOwnProperty.call(f, p) && t(f, d, p);
  }, u = ee && ee.__importStar || function(d) {
    if (d && d.__esModule)
      return d;
    var f = {};
    if (d != null)
      for (var p in d)
        p !== "default" && Object.prototype.hasOwnProperty.call(d, p) && t(f, d, p);
    return n(f, d), f;
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.getSchemaWithNodeType = e.helpers = e.EMPTY_DOCUMENT = e.MARKS = e.INLINES = e.BLOCKS = void 0;
  var i = Br;
  Object.defineProperty(e, "BLOCKS", { enumerable: !0, get: function() {
    return i.BLOCKS;
  } });
  var a = Mu;
  Object.defineProperty(e, "INLINES", { enumerable: !0, get: function() {
    return a.INLINES;
  } });
  var o = Vi;
  Object.defineProperty(e, "MARKS", { enumerable: !0, get: function() {
    return o.MARKS;
  } }), r(A2, e), r(k2, e), r(L2, e);
  var s = To;
  Object.defineProperty(e, "EMPTY_DOCUMENT", { enumerable: !0, get: function() {
    return s.EMPTY_DOCUMENT;
  } });
  var c = u(ji);
  e.helpers = c;
  var l = zl;
  Object.defineProperty(e, "getSchemaWithNodeType", { enumerable: !0, get: function() {
    return l.getSchemaWithNodeType;
  } });
})(Ze);
const xC = /* @__PURE__ */ T2(Ze);
var Oc = /* @__PURE__ */ new Map(), ra = /* @__PURE__ */ new WeakMap(), Af = 0, _C = void 0;
function SC(e) {
  return e ? (ra.has(e) || (Af += 1, ra.set(e, Af.toString())), ra.get(e)) : "0";
}
function CC(e) {
  return Object.keys(e).sort().filter(function(t) {
    return e[t] !== void 0;
  }).map(function(t) {
    return t + "_" + (t === "root" ? SC(e.root) : e[t]);
  }).toString();
}
function EC(e) {
  var t = CC(e), n = Oc.get(t);
  if (!n) {
    var r = /* @__PURE__ */ new Map(), u, i = new IntersectionObserver(function(a) {
      a.forEach(function(o) {
        var s, c = o.isIntersecting && u.some(function(l) {
          return o.intersectionRatio >= l;
        });
        e.trackVisibility && typeof o.isVisible > "u" && (o.isVisible = c), (s = r.get(o.target)) == null || s.forEach(function(l) {
          l(c, o);
        });
      });
    }, e);
    u = i.thresholds || (Array.isArray(e.threshold) ? e.threshold : [e.threshold || 0]), n = {
      id: t,
      observer: i,
      elements: r
    }, Oc.set(t, n);
  }
  return n;
}
function wC(e, t, n, r) {
  if (n === void 0 && (n = {}), r === void 0 && (r = _C), typeof window.IntersectionObserver > "u" && r !== void 0) {
    var u = e.getBoundingClientRect();
    return t(r, {
      isIntersecting: r,
      target: e,
      intersectionRatio: typeof n.threshold == "number" ? n.threshold : 0,
      time: 0,
      boundingClientRect: u,
      intersectionRect: u,
      rootBounds: u
    }), function() {
    };
  }
  var i = EC(n), a = i.id, o = i.observer, s = i.elements, c = s.get(e) || [];
  return s.has(e) || s.set(e, c), c.push(t), o.observe(e), function() {
    c.splice(c.indexOf(t), 1), c.length === 0 && (s.delete(e), o.unobserve(e)), s.size === 0 && (o.disconnect(), Oc.delete(a));
  };
}
function zi(e) {
  var t = e === void 0 ? {} : e, n = t.threshold, r = t.delay, u = t.trackVisibility, i = t.rootMargin, a = t.root, o = t.triggerOnce, s = t.skip, c = t.initialInView, l = t.fallbackInView, d = Y.useRef(), f = Y.useState({
    inView: !!c
  }), p = f[0], h = f[1], m = Y.useCallback(
    function(x) {
      d.current !== void 0 && (d.current(), d.current = void 0), !s && x && (d.current = wC(x, function(y, g) {
        h({
          inView: y,
          entry: g
        }), g.isIntersecting && o && d.current && (d.current(), d.current = void 0);
      }, {
        root: a,
        rootMargin: i,
        threshold: n,
        // @ts-ignore
        trackVisibility: u,
        // @ts-ignore
        delay: r
      }, l));
    },
    // We break the rule here, because we aren't including the actual `threshold` variable
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
      // If the threshold is an array, convert it to a string so it won't change between renders.
      // eslint-disable-next-line react-hooks/exhaustive-deps
      Array.isArray(n) ? n.toString() : n,
      a,
      i,
      o,
      s,
      u,
      l,
      r
    ]
  );
  oe(function() {
    !d.current && p.entry && !o && !s && h({
      inView: !!c
    });
  });
  var b = [m, p.inView, p.entry];
  return b.ref = b[0], b.inView = b[1], b.entry = b[2], b;
}
const TC = /([\p{Ll}\d])(\p{Lu})/gu, AC = /(\p{Lu})([\p{Lu}][\p{Ll}])/gu, kC = /(\d)\p{Ll}|(\p{L})\d/u, LC = /[^\p{L}\d]+/giu, kf = "$1\0$2", Lf = "";
function N2(e) {
  let t = e.trim();
  t = t.replace(TC, kf).replace(AC, kf), t = t.replace(LC, "\0");
  let n = 0, r = t.length;
  for (; t.charAt(n) === "\0"; )
    n++;
  if (n === r)
    return [];
  for (; t.charAt(r - 1) === "\0"; )
    r--;
  return t.slice(n, r).split(/\0/g);
}
function DC(e) {
  const t = N2(e);
  for (let n = 0; n < t.length; n++) {
    const r = t[n], u = kC.exec(r);
    if (u) {
      const i = u.index + (u[1] ?? u[2]).length;
      t.splice(n, 1, r.slice(0, i), r.slice(i));
    }
  }
  return t;
}
function NC(e, t) {
  const [n, r, u] = I2(e, t);
  return n + r.map(O2(t == null ? void 0 : t.locale)).join((t == null ? void 0 : t.delimiter) ?? " ") + u;
}
function kH(e, t) {
  const [n, r, u] = I2(e, t), i = O2(t == null ? void 0 : t.locale), a = OC(t == null ? void 0 : t.locale);
  return n + r.map(IC(i, a)).join((t == null ? void 0 : t.delimiter) ?? " ") + u;
}
function Cn(e, t) {
  return NC(e, { delimiter: "-", ...t });
}
function O2(e) {
  return e === !1 ? (t) => t.toLowerCase() : (t) => t.toLocaleLowerCase(e);
}
function OC(e) {
  return e === !1 ? (t) => t.toUpperCase() : (t) => t.toLocaleUpperCase(e);
}
function IC(e, t) {
  return (n) => `${t(n[0])}${e(n.slice(1))}`;
}
function I2(e, t = {}) {
  const n = t.split ?? (t.separateNumbers ? DC : N2), r = t.prefixCharacters ?? Lf, u = t.suffixCharacters ?? Lf;
  let i = 0, a = e.length;
  for (; i < e.length; ) {
    const o = e.charAt(i);
    if (!r.includes(o))
      break;
    i++;
  }
  for (; a > i; ) {
    const o = a - 1, s = e.charAt(o);
    if (!u.includes(s))
      break;
    a = o;
  }
  return [
    e.slice(0, i),
    n(e.slice(i, a)),
    e.slice(a)
  ];
}
var MC = Object.defineProperty, PC = (e, t, n) => t in e ? MC(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n, Df = (e, t, n) => (PC(e, typeof t != "symbol" ? t + "" : t, n), n), ua;
function M2(e) {
  return ua = ua || document.createElement("textarea"), ua.innerHTML = "&" + e + ";", ua.value;
}
var RC = Object.prototype.hasOwnProperty;
function BC(e, t) {
  return e ? RC.call(e, t) : !1;
}
function P2(e) {
  var t = [].slice.call(arguments, 1);
  return t.forEach(function(n) {
    if (n) {
      if (typeof n != "object")
        throw new TypeError(n + "must be object");
      Object.keys(n).forEach(function(r) {
        e[r] = n[r];
      });
    }
  }), e;
}
var FC = /\\([\\!"#$%&'()*+,.\/:;<=>?@[\]^_`{|}~-])/g;
function _i(e) {
  return e.indexOf("\\") < 0 ? e : e.replace(FC, "$1");
}
function R2(e) {
  return !(e >= 55296 && e <= 57343 || e >= 64976 && e <= 65007 || (e & 65535) === 65535 || (e & 65535) === 65534 || e >= 0 && e <= 8 || e === 11 || e >= 14 && e <= 31 || e >= 127 && e <= 159 || e > 1114111);
}
function Ic(e) {
  if (e > 65535) {
    e -= 65536;
    var t = 55296 + (e >> 10), n = 56320 + (e & 1023);
    return String.fromCharCode(t, n);
  }
  return String.fromCharCode(e);
}
var HC = /&([a-z#][a-z0-9]{1,31});/gi, $C = /^#((?:x[a-f0-9]{1,8}|[0-9]{1,8}))/i;
function VC(e, t) {
  var n = 0, r = M2(t);
  return t !== r ? r : t.charCodeAt(0) === 35 && $C.test(t) && (n = t[1].toLowerCase() === "x" ? parseInt(t.slice(2), 16) : parseInt(t.slice(1), 10), R2(n)) ? Ic(n) : e;
}
function Nr(e) {
  return e.indexOf("&") < 0 ? e : e.replace(HC, VC);
}
var jC = /[&<>"]/, zC = /[&<>"]/g, UC = {
  "&": "&amp;",
  "<": "&lt;",
  ">": "&gt;",
  '"': "&quot;"
};
function qC(e) {
  return UC[e];
}
function Xt(e) {
  return jC.test(e) ? e.replace(zC, qC) : e;
}
var ie = {};
ie.blockquote_open = function() {
  return `<blockquote>
`;
};
ie.blockquote_close = function(e, t) {
  return "</blockquote>" + Fr(e, t);
};
ie.code = function(e, t) {
  return e[t].block ? "<pre><code>" + Xt(e[t].content) + "</code></pre>" + Fr(e, t) : "<code>" + Xt(e[t].content) + "</code>";
};
ie.fence = function(e, t, n, r, u) {
  var i = e[t], a = "", o = n.langPrefix, s = "", c, l, d;
  if (i.params) {
    if (c = i.params.split(/\s+/g), l = c.join(" "), BC(u.rules.fence_custom, c[0]))
      return u.rules.fence_custom[c[0]](e, t, n, r, u);
    s = Xt(Nr(_i(l))), a = ' class="' + o + s + '"';
  }
  return n.highlight ? d = n.highlight.apply(n.highlight, [i.content].concat(c)) || Xt(i.content) : d = Xt(i.content), "<pre><code" + a + ">" + d + "</code></pre>" + Fr(e, t);
};
ie.fence_custom = {};
ie.heading_open = function(e, t) {
  return "<h" + e[t].hLevel + ">";
};
ie.heading_close = function(e, t) {
  return "</h" + e[t].hLevel + `>
`;
};
ie.hr = function(e, t, n) {
  return (n.xhtmlOut ? "<hr />" : "<hr>") + Fr(e, t);
};
ie.bullet_list_open = function() {
  return `<ul>
`;
};
ie.bullet_list_close = function(e, t) {
  return "</ul>" + Fr(e, t);
};
ie.list_item_open = function() {
  return "<li>";
};
ie.list_item_close = function() {
  return `</li>
`;
};
ie.ordered_list_open = function(e, t) {
  var n = e[t], r = n.order > 1 ? ' start="' + n.order + '"' : "";
  return "<ol" + r + `>
`;
};
ie.ordered_list_close = function(e, t) {
  return "</ol>" + Fr(e, t);
};
ie.paragraph_open = function(e, t) {
  return e[t].tight ? "" : "<p>";
};
ie.paragraph_close = function(e, t) {
  var n = !(e[t].tight && t && e[t - 1].type === "inline" && !e[t - 1].content);
  return (e[t].tight ? "" : "</p>") + (n ? Fr(e, t) : "");
};
ie.link_open = function(e, t, n) {
  var r = e[t].title ? ' title="' + Xt(Nr(e[t].title)) + '"' : "", u = n.linkTarget ? ' target="' + n.linkTarget + '"' : "";
  return '<a href="' + Xt(e[t].href) + '"' + r + u + ">";
};
ie.link_close = function() {
  return "</a>";
};
ie.image = function(e, t, n) {
  var r = ' src="' + Xt(e[t].src) + '"', u = e[t].title ? ' title="' + Xt(Nr(e[t].title)) + '"' : "", i = ' alt="' + (e[t].alt ? Xt(Nr(_i(e[t].alt))) : "") + '"', a = n.xhtmlOut ? " /" : "";
  return "<img" + r + i + u + a + ">";
};
ie.table_open = function() {
  return `<table>
`;
};
ie.table_close = function() {
  return `</table>
`;
};
ie.thead_open = function() {
  return `<thead>
`;
};
ie.thead_close = function() {
  return `</thead>
`;
};
ie.tbody_open = function() {
  return `<tbody>
`;
};
ie.tbody_close = function() {
  return `</tbody>
`;
};
ie.tr_open = function() {
  return "<tr>";
};
ie.tr_close = function() {
  return `</tr>
`;
};
ie.th_open = function(e, t) {
  var n = e[t];
  return "<th" + (n.align ? ' style="text-align:' + n.align + '"' : "") + ">";
};
ie.th_close = function() {
  return "</th>";
};
ie.td_open = function(e, t) {
  var n = e[t];
  return "<td" + (n.align ? ' style="text-align:' + n.align + '"' : "") + ">";
};
ie.td_close = function() {
  return "</td>";
};
ie.strong_open = function() {
  return "<strong>";
};
ie.strong_close = function() {
  return "</strong>";
};
ie.em_open = function() {
  return "<em>";
};
ie.em_close = function() {
  return "</em>";
};
ie.del_open = function() {
  return "<del>";
};
ie.del_close = function() {
  return "</del>";
};
ie.ins_open = function() {
  return "<ins>";
};
ie.ins_close = function() {
  return "</ins>";
};
ie.mark_open = function() {
  return "<mark>";
};
ie.mark_close = function() {
  return "</mark>";
};
ie.sub = function(e, t) {
  return "<sub>" + Xt(e[t].content) + "</sub>";
};
ie.sup = function(e, t) {
  return "<sup>" + Xt(e[t].content) + "</sup>";
};
ie.hardbreak = function(e, t, n) {
  return n.xhtmlOut ? `<br />
` : `<br>
`;
};
ie.softbreak = function(e, t, n) {
  return n.breaks ? n.xhtmlOut ? `<br />
` : `<br>
` : `
`;
};
ie.text = function(e, t) {
  return Xt(e[t].content);
};
ie.htmlblock = function(e, t) {
  return e[t].content;
};
ie.htmltag = function(e, t) {
  return e[t].content;
};
ie.abbr_open = function(e, t) {
  return '<abbr title="' + Xt(Nr(e[t].title)) + '">';
};
ie.abbr_close = function() {
  return "</abbr>";
};
ie.footnote_ref = function(e, t) {
  var n = Number(e[t].id + 1).toString(), r = "fnref" + n;
  return e[t].subId > 0 && (r += ":" + e[t].subId), '<sup class="footnote-ref"><a href="#fn' + n + '" id="' + r + '">[' + n + "]</a></sup>";
};
ie.footnote_block_open = function(e, t, n) {
  var r = n.xhtmlOut ? `<hr class="footnotes-sep" />
` : `<hr class="footnotes-sep">
`;
  return r + `<section class="footnotes">
<ol class="footnotes-list">
`;
};
ie.footnote_block_close = function() {
  return `</ol>
</section>
`;
};
ie.footnote_open = function(e, t) {
  var n = Number(e[t].id + 1).toString();
  return '<li id="fn' + n + '"  class="footnote-item">';
};
ie.footnote_close = function() {
  return `</li>
`;
};
ie.footnote_anchor = function(e, t) {
  var n = Number(e[t].id + 1).toString(), r = "fnref" + n;
  return e[t].subId > 0 && (r += ":" + e[t].subId), ' <a href="#' + r + '" class="footnote-backref">↩</a>';
};
ie.dl_open = function() {
  return `<dl>
`;
};
ie.dt_open = function() {
  return "<dt>";
};
ie.dd_open = function() {
  return "<dd>";
};
ie.dl_close = function() {
  return `</dl>
`;
};
ie.dt_close = function() {
  return `</dt>
`;
};
ie.dd_close = function() {
  return `</dd>
`;
};
function B2(e, t) {
  return ++t >= e.length - 2 ? t : e[t].type === "paragraph_open" && e[t].tight && e[t + 1].type === "inline" && e[t + 1].content.length === 0 && e[t + 2].type === "paragraph_close" && e[t + 2].tight ? B2(e, t + 2) : t;
}
var Fr = ie.getBreak = function(e, t) {
  return t = B2(e, t), t < e.length && e[t].type === "list_item_close" ? "" : `
`;
};
function Ul() {
  this.rules = P2({}, ie), this.getBreak = ie.getBreak;
}
Ul.prototype.renderInline = function(e, t, n) {
  for (var r = this.rules, u = e.length, i = 0, a = ""; u--; )
    a += r[e[i].type](e, i++, t, n, this);
  return a;
};
Ul.prototype.render = function(e, t, n) {
  for (var r = this.rules, u = e.length, i = -1, a = ""; ++i < u; )
    e[i].type === "inline" ? a += this.renderInline(e[i].children, t, n) : a += r[e[i].type](e, i, t, n, this);
  return a;
};
function dn() {
  this.__rules__ = [], this.__cache__ = null;
}
dn.prototype.__find__ = function(e) {
  for (var t = this.__rules__.length, n = -1; t--; )
    if (this.__rules__[++n].name === e)
      return n;
  return -1;
};
dn.prototype.__compile__ = function() {
  var e = this, t = [""];
  e.__rules__.forEach(function(n) {
    n.enabled && n.alt.forEach(function(r) {
      t.indexOf(r) < 0 && t.push(r);
    });
  }), e.__cache__ = {}, t.forEach(function(n) {
    e.__cache__[n] = [], e.__rules__.forEach(function(r) {
      r.enabled && (n && r.alt.indexOf(n) < 0 || e.__cache__[n].push(r.fn));
    });
  });
};
dn.prototype.at = function(e, t, n) {
  var r = this.__find__(e), u = n || {};
  if (r === -1)
    throw new Error("Parser rule not found: " + e);
  this.__rules__[r].fn = t, this.__rules__[r].alt = u.alt || [], this.__cache__ = null;
};
dn.prototype.before = function(e, t, n, r) {
  var u = this.__find__(e), i = r || {};
  if (u === -1)
    throw new Error("Parser rule not found: " + e);
  this.__rules__.splice(u, 0, {
    name: t,
    enabled: !0,
    fn: n,
    alt: i.alt || []
  }), this.__cache__ = null;
};
dn.prototype.after = function(e, t, n, r) {
  var u = this.__find__(e), i = r || {};
  if (u === -1)
    throw new Error("Parser rule not found: " + e);
  this.__rules__.splice(u + 1, 0, {
    name: t,
    enabled: !0,
    fn: n,
    alt: i.alt || []
  }), this.__cache__ = null;
};
dn.prototype.push = function(e, t, n) {
  var r = n || {};
  this.__rules__.push({
    name: e,
    enabled: !0,
    fn: t,
    alt: r.alt || []
  }), this.__cache__ = null;
};
dn.prototype.enable = function(e, t) {
  e = Array.isArray(e) ? e : [e], t && this.__rules__.forEach(function(n) {
    n.enabled = !1;
  }), e.forEach(function(n) {
    var r = this.__find__(n);
    if (r < 0)
      throw new Error("Rules manager: invalid rule name " + n);
    this.__rules__[r].enabled = !0;
  }, this), this.__cache__ = null;
};
dn.prototype.disable = function(e) {
  e = Array.isArray(e) ? e : [e], e.forEach(function(t) {
    var n = this.__find__(t);
    if (n < 0)
      throw new Error("Rules manager: invalid rule name " + t);
    this.__rules__[n].enabled = !1;
  }, this), this.__cache__ = null;
};
dn.prototype.getRules = function(e) {
  return this.__cache__ === null && this.__compile__(), this.__cache__[e] || [];
};
function GC(e) {
  e.inlineMode ? e.tokens.push({
    type: "inline",
    content: e.src.replace(/\n/g, " ").trim(),
    level: 0,
    lines: [0, 1],
    children: []
  }) : e.block.parse(e.src, e.options, e.env, e.tokens);
}
function Hr(e, t, n, r, u) {
  this.src = e, this.env = r, this.options = n, this.parser = t, this.tokens = u, this.pos = 0, this.posMax = this.src.length, this.level = 0, this.pending = "", this.pendingLevel = 0, this.cache = [], this.isInLabel = !1, this.linkLevel = 0, this.linkContent = "", this.labelUnmatchedScopes = 0;
}
Hr.prototype.pushPending = function() {
  this.tokens.push({
    type: "text",
    content: this.pending,
    level: this.pendingLevel
  }), this.pending = "";
};
Hr.prototype.push = function(e) {
  this.pending && this.pushPending(), this.tokens.push(e), this.pendingLevel = this.level;
};
Hr.prototype.cacheSet = function(e, t) {
  for (var n = this.cache.length; n <= e; n++)
    this.cache.push(0);
  this.cache[e] = t;
};
Hr.prototype.cacheGet = function(e) {
  return e < this.cache.length ? this.cache[e] : 0;
};
function Si(e, t) {
  var n, r, u, i = -1, a = e.posMax, o = e.pos, s = e.isInLabel;
  if (e.isInLabel)
    return -1;
  if (e.labelUnmatchedScopes)
    return e.labelUnmatchedScopes--, -1;
  for (e.pos = t + 1, e.isInLabel = !0, n = 1; e.pos < a; ) {
    if (u = e.src.charCodeAt(e.pos), u === 91)
      n++;
    else if (u === 93 && (n--, n === 0)) {
      r = !0;
      break;
    }
    e.parser.skipToken(e);
  }
  return r ? (i = e.pos, e.labelUnmatchedScopes = 0) : e.labelUnmatchedScopes = n - 1, e.pos = o, e.isInLabel = s, i;
}
function WC(e, t, n, r) {
  var u, i, a, o, s, c;
  if (e.charCodeAt(0) !== 42 || e.charCodeAt(1) !== 91 || e.indexOf("]:") === -1 || (u = new Hr(e, t, n, r, []), i = Si(u, 1), i < 0 || e.charCodeAt(i + 1) !== 58))
    return -1;
  for (o = u.posMax, a = i + 2; a < o && u.src.charCodeAt(a) !== 10; a++)
    ;
  return s = e.slice(2, i), c = e.slice(i + 2, a).trim(), c.length === 0 ? -1 : (r.abbreviations || (r.abbreviations = {}), typeof r.abbreviations[":" + s] > "u" && (r.abbreviations[":" + s] = c), a);
}
function KC(e) {
  var t = e.tokens, n, r, u, i;
  if (!e.inlineMode) {
    for (n = 1, r = t.length - 1; n < r; n++)
      if (t[n - 1].type === "paragraph_open" && t[n].type === "inline" && t[n + 1].type === "paragraph_close") {
        for (u = t[n].content; u.length && (i = WC(u, e.inline, e.options, e.env), !(i < 0)); )
          u = u.slice(i).trim();
        t[n].content = u, u.length || (t[n - 1].tight = !0, t[n + 1].tight = !0);
      }
  }
}
function Mc(e) {
  var t = Nr(e);
  try {
    t = decodeURI(t);
  } catch {
  }
  return encodeURI(t);
}
function F2(e, t) {
  var n, r, u, i = t, a = e.posMax;
  if (e.src.charCodeAt(t) === 60) {
    for (t++; t < a; ) {
      if (n = e.src.charCodeAt(t), n === 10)
        return !1;
      if (n === 62)
        return u = Mc(_i(e.src.slice(i + 1, t))), e.parser.validateLink(u) ? (e.pos = t + 1, e.linkContent = u, !0) : !1;
      if (n === 92 && t + 1 < a) {
        t += 2;
        continue;
      }
      t++;
    }
    return !1;
  }
  for (r = 0; t < a && (n = e.src.charCodeAt(t), !(n === 32 || n < 32 || n === 127)); ) {
    if (n === 92 && t + 1 < a) {
      t += 2;
      continue;
    }
    if (n === 40 && (r++, r > 1) || n === 41 && (r--, r < 0))
      break;
    t++;
  }
  return i === t || (u = _i(e.src.slice(i, t)), !e.parser.validateLink(u)) ? !1 : (e.linkContent = u, e.pos = t, !0);
}
function H2(e, t) {
  var n, r = t, u = e.posMax, i = e.src.charCodeAt(t);
  if (i !== 34 && i !== 39 && i !== 40)
    return !1;
  for (t++, i === 40 && (i = 41); t < u; ) {
    if (n = e.src.charCodeAt(t), n === i)
      return e.pos = t + 1, e.linkContent = _i(e.src.slice(r + 1, t)), !0;
    if (n === 92 && t + 1 < u) {
      t += 2;
      continue;
    }
    t++;
  }
  return !1;
}
function $2(e) {
  return e.trim().replace(/\s+/g, " ").toUpperCase();
}
function YC(e, t, n, r) {
  var u, i, a, o, s, c, l, d, f;
  if (e.charCodeAt(0) !== 91 || e.indexOf("]:") === -1 || (u = new Hr(e, t, n, r, []), i = Si(u, 0), i < 0 || e.charCodeAt(i + 1) !== 58))
    return -1;
  for (o = u.posMax, a = i + 2; a < o && (s = u.src.charCodeAt(a), !(s !== 32 && s !== 10)); a++)
    ;
  if (!F2(u, a))
    return -1;
  for (l = u.linkContent, a = u.pos, c = a, a = a + 1; a < o && (s = u.src.charCodeAt(a), !(s !== 32 && s !== 10)); a++)
    ;
  for (a < o && c !== a && H2(u, a) ? (d = u.linkContent, a = u.pos) : (d = "", a = c); a < o && u.src.charCodeAt(a) === 32; )
    a++;
  return a < o && u.src.charCodeAt(a) !== 10 ? -1 : (f = $2(e.slice(1, i)), typeof r.references[f] > "u" && (r.references[f] = { title: d, href: l }), a);
}
function ZC(e) {
  var t = e.tokens, n, r, u, i;
  if (e.env.references = e.env.references || {}, !e.inlineMode) {
    for (n = 1, r = t.length - 1; n < r; n++)
      if (t[n].type === "inline" && t[n - 1].type === "paragraph_open" && t[n + 1].type === "paragraph_close") {
        for (u = t[n].content; u.length && (i = YC(u, e.inline, e.options, e.env), !(i < 0)); )
          u = u.slice(i).trim();
        t[n].content = u, u.length || (t[n - 1].tight = !0, t[n + 1].tight = !0);
      }
  }
}
function XC(e) {
  var t = e.tokens, n, r, u;
  for (r = 0, u = t.length; r < u; r++)
    n = t[r], n.type === "inline" && e.inline.parse(n.content, e.options, e.env, n.children);
}
function QC(e) {
  var t, n, r, u, i, a, o, s, c, l = 0, d = !1, f = {};
  if (e.env.footnotes && (e.tokens = e.tokens.filter(function(p) {
    return p.type === "footnote_reference_open" ? (d = !0, s = [], c = p.label, !1) : p.type === "footnote_reference_close" ? (d = !1, f[":" + c] = s, !1) : (d && s.push(p), !d);
  }), !!e.env.footnotes.list)) {
    for (a = e.env.footnotes.list, e.tokens.push({
      type: "footnote_block_open",
      level: l++
    }), t = 0, n = a.length; t < n; t++) {
      for (e.tokens.push({
        type: "footnote_open",
        id: t,
        level: l++
      }), a[t].tokens ? (o = [], o.push({
        type: "paragraph_open",
        tight: !1,
        level: l++
      }), o.push({
        type: "inline",
        content: "",
        level: l,
        children: a[t].tokens
      }), o.push({
        type: "paragraph_close",
        tight: !1,
        level: --l
      })) : a[t].label && (o = f[":" + a[t].label]), e.tokens = e.tokens.concat(o), e.tokens[e.tokens.length - 1].type === "paragraph_close" ? i = e.tokens.pop() : i = null, u = a[t].count > 0 ? a[t].count : 1, r = 0; r < u; r++)
        e.tokens.push({
          type: "footnote_anchor",
          id: t,
          subId: r,
          level: l
        });
      i && e.tokens.push(i), e.tokens.push({
        type: "footnote_close",
        level: --l
      });
    }
    e.tokens.push({
      type: "footnote_block_close",
      level: --l
    });
  }
}
var Nf = ` 
()[]'".,!?-`;
function ws(e) {
  return e.replace(/([-()\[\]{}+?*.$\^|,:#<!\\])/g, "\\$1");
}
function JC(e) {
  var t, n, r, u, i, a, o, s, c, l, d, f, p = e.tokens;
  if (e.env.abbreviations) {
    for (e.env.abbrRegExp || (f = "(^|[" + Nf.split("").map(ws).join("") + "])(" + Object.keys(e.env.abbreviations).map(function(h) {
      return h.substr(1);
    }).sort(function(h, m) {
      return m.length - h.length;
    }).map(ws).join("|") + ")($|[" + Nf.split("").map(ws).join("") + "])", e.env.abbrRegExp = new RegExp(f, "g")), l = e.env.abbrRegExp, n = 0, r = p.length; n < r; n++)
      if (p[n].type === "inline") {
        for (u = p[n].children, t = u.length - 1; t >= 0; t--)
          if (i = u[t], i.type === "text") {
            for (s = 0, a = i.content, l.lastIndex = 0, c = i.level, o = []; d = l.exec(a); )
              l.lastIndex > s && o.push({
                type: "text",
                content: a.slice(s, d.index + d[1].length),
                level: c
              }), o.push({
                type: "abbr_open",
                title: e.env.abbreviations[":" + d[2]],
                level: c++
              }), o.push({
                type: "text",
                content: d[2],
                level: c
              }), o.push({
                type: "abbr_close",
                level: --c
              }), s = l.lastIndex - d[3].length;
            o.length && (s < a.length && o.push({
              type: "text",
              content: a.slice(s),
              level: c
            }), p[n].children = u = [].concat(u.slice(0, t), o, u.slice(t + 1)));
          }
      }
  }
}
var eE = /\+-|\.\.|\?\?\?\?|!!!!|,,|--/, tE = /\((c|tm|r|p)\)/ig, nE = {
  c: "©",
  r: "®",
  p: "§",
  tm: "™"
};
function rE(e) {
  return e.indexOf("(") < 0 ? e : e.replace(tE, function(t, n) {
    return nE[n.toLowerCase()];
  });
}
function uE(e) {
  var t, n, r, u, i;
  if (e.options.typographer) {
    for (i = e.tokens.length - 1; i >= 0; i--)
      if (e.tokens[i].type === "inline")
        for (u = e.tokens[i].children, t = u.length - 1; t >= 0; t--)
          n = u[t], n.type === "text" && (r = n.content, r = rE(r), eE.test(r) && (r = r.replace(/\+-/g, "±").replace(/\.{2,}/g, "…").replace(/([?!])…/g, "$1..").replace(/([?!]){4,}/g, "$1$1$1").replace(/,{2,}/g, ",").replace(/(^|[^-])---([^-]|$)/mg, "$1—$2").replace(/(^|\s)--(\s|$)/mg, "$1–$2").replace(/(^|[^-\s])--([^-\s]|$)/mg, "$1–$2")), n.content = r);
  }
}
var iE = /['"]/, Of = /['"]/g, aE = /[-\s()\[\]]/, If = "’";
function Mf(e, t) {
  return t < 0 || t >= e.length ? !1 : !aE.test(e[t]);
}
function Wr(e, t, n) {
  return e.substr(0, t) + n + e.substr(t + 1);
}
function oE(e) {
  var t, n, r, u, i, a, o, s, c, l, d, f, p, h, m, b, x;
  if (e.options.typographer) {
    for (x = [], m = e.tokens.length - 1; m >= 0; m--)
      if (e.tokens[m].type === "inline") {
        for (b = e.tokens[m].children, x.length = 0, t = 0; t < b.length; t++)
          if (n = b[t], !(n.type !== "text" || iE.test(n.text))) {
            for (o = b[t].level, p = x.length - 1; p >= 0 && !(x[p].level <= o); p--)
              ;
            x.length = p + 1, r = n.content, i = 0, a = r.length;
            e:
              for (; i < a && (Of.lastIndex = i, u = Of.exec(r), !!u); ) {
                if (s = !Mf(r, u.index - 1), i = u.index + 1, h = u[0] === "'", c = !Mf(r, i), !c && !s) {
                  h && (n.content = Wr(n.content, u.index, If));
                  continue;
                }
                if (d = !c, f = !s, f) {
                  for (p = x.length - 1; p >= 0 && (l = x[p], !(x[p].level < o)); p--)
                    if (l.single === h && x[p].level === o) {
                      l = x[p], h ? (b[l.token].content = Wr(b[l.token].content, l.pos, e.options.quotes[2]), n.content = Wr(n.content, u.index, e.options.quotes[3])) : (b[l.token].content = Wr(b[l.token].content, l.pos, e.options.quotes[0]), n.content = Wr(n.content, u.index, e.options.quotes[1])), x.length = p;
                      continue e;
                    }
                }
                d ? x.push({
                  token: t,
                  pos: u.index,
                  single: h,
                  level: o
                }) : f && h && (n.content = Wr(n.content, u.index, If));
              }
          }
      }
  }
}
var Ts = [
  ["block", GC],
  ["abbr", KC],
  ["references", ZC],
  ["inline", XC],
  ["footnote_tail", QC],
  ["abbr2", JC],
  ["replacements", uE],
  ["smartquotes", oE]
];
function V2() {
  this.options = {}, this.ruler = new dn();
  for (var e = 0; e < Ts.length; e++)
    this.ruler.push(Ts[e][0], Ts[e][1]);
}
V2.prototype.process = function(e) {
  var t, n, r;
  for (r = this.ruler.getRules(""), t = 0, n = r.length; t < n; t++)
    r[t](e);
};
function $r(e, t, n, r, u) {
  var i, a, o, s, c, l, d;
  for (this.src = e, this.parser = t, this.options = n, this.env = r, this.tokens = u, this.bMarks = [], this.eMarks = [], this.tShift = [], this.blkIndent = 0, this.line = 0, this.lineMax = 0, this.tight = !1, this.parentType = "root", this.ddIndent = -1, this.level = 0, this.result = "", a = this.src, l = 0, d = !1, o = s = l = 0, c = a.length; s < c; s++) {
    if (i = a.charCodeAt(s), !d)
      if (i === 32) {
        l++;
        continue;
      } else
        d = !0;
    (i === 10 || s === c - 1) && (i !== 10 && s++, this.bMarks.push(o), this.eMarks.push(s), this.tShift.push(l), d = !1, l = 0, o = s + 1);
  }
  this.bMarks.push(a.length), this.eMarks.push(a.length), this.tShift.push(0), this.lineMax = this.bMarks.length - 1;
}
$r.prototype.isEmpty = function(e) {
  return this.bMarks[e] + this.tShift[e] >= this.eMarks[e];
};
$r.prototype.skipEmptyLines = function(e) {
  for (var t = this.lineMax; e < t && !(this.bMarks[e] + this.tShift[e] < this.eMarks[e]); e++)
    ;
  return e;
};
$r.prototype.skipSpaces = function(e) {
  for (var t = this.src.length; e < t && this.src.charCodeAt(e) === 32; e++)
    ;
  return e;
};
$r.prototype.skipChars = function(e, t) {
  for (var n = this.src.length; e < n && this.src.charCodeAt(e) === t; e++)
    ;
  return e;
};
$r.prototype.skipCharsBack = function(e, t, n) {
  if (e <= n)
    return e;
  for (; e > n; )
    if (t !== this.src.charCodeAt(--e))
      return e + 1;
  return e;
};
$r.prototype.getLines = function(e, t, n, r) {
  var u, i, a, o, s, c = e;
  if (e >= t)
    return "";
  if (c + 1 === t)
    return i = this.bMarks[c] + Math.min(this.tShift[c], n), a = r ? this.eMarks[c] + 1 : this.eMarks[c], this.src.slice(i, a);
  for (o = new Array(t - e), u = 0; c < t; c++, u++)
    s = this.tShift[c], s > n && (s = n), s < 0 && (s = 0), i = this.bMarks[c] + s, c + 1 < t || r ? a = this.eMarks[c] + 1 : a = this.eMarks[c], o[u] = this.src.slice(i, a);
  return o.join("");
};
function sE(e, t, n) {
  var r, u;
  if (e.tShift[t] - e.blkIndent < 4)
    return !1;
  for (u = r = t + 1; r < n; ) {
    if (e.isEmpty(r)) {
      r++;
      continue;
    }
    if (e.tShift[r] - e.blkIndent >= 4) {
      r++, u = r;
      continue;
    }
    break;
  }
  return e.line = r, e.tokens.push({
    type: "code",
    content: e.getLines(t, u, 4 + e.blkIndent, !0),
    block: !0,
    lines: [t, e.line],
    level: e.level
  }), !0;
}
function cE(e, t, n, r) {
  var u, i, a, o, s, c = !1, l = e.bMarks[t] + e.tShift[t], d = e.eMarks[t];
  if (l + 3 > d || (u = e.src.charCodeAt(l), u !== 126 && u !== 96) || (s = l, l = e.skipChars(l, u), i = l - s, i < 3) || (a = e.src.slice(l, d).trim(), a.indexOf("`") >= 0))
    return !1;
  if (r)
    return !0;
  for (o = t; o++, !(o >= n || (l = s = e.bMarks[o] + e.tShift[o], d = e.eMarks[o], l < d && e.tShift[o] < e.blkIndent)); )
    if (e.src.charCodeAt(l) === u && !(e.tShift[o] - e.blkIndent >= 4) && (l = e.skipChars(l, u), !(l - s < i) && (l = e.skipSpaces(l), !(l < d)))) {
      c = !0;
      break;
    }
  return i = e.tShift[t], e.line = o + (c ? 1 : 0), e.tokens.push({
    type: "fence",
    params: a,
    content: e.getLines(t + 1, o, i, !0),
    lines: [t, e.line],
    level: e.level
  }), !0;
}
function lE(e, t, n, r) {
  var u, i, a, o, s, c, l, d, f, p, h, m = e.bMarks[t] + e.tShift[t], b = e.eMarks[t];
  if (m > b || e.src.charCodeAt(m++) !== 62 || e.level >= e.options.maxNesting)
    return !1;
  if (r)
    return !0;
  for (e.src.charCodeAt(m) === 32 && m++, s = e.blkIndent, e.blkIndent = 0, o = [e.bMarks[t]], e.bMarks[t] = m, m = m < b ? e.skipSpaces(m) : m, i = m >= b, a = [e.tShift[t]], e.tShift[t] = m - e.bMarks[t], d = e.parser.ruler.getRules("blockquote"), u = t + 1; u < n && (m = e.bMarks[u] + e.tShift[u], b = e.eMarks[u], !(m >= b)); u++) {
    if (e.src.charCodeAt(m++) === 62) {
      e.src.charCodeAt(m) === 32 && m++, o.push(e.bMarks[u]), e.bMarks[u] = m, m = m < b ? e.skipSpaces(m) : m, i = m >= b, a.push(e.tShift[u]), e.tShift[u] = m - e.bMarks[u];
      continue;
    }
    if (i)
      break;
    for (h = !1, f = 0, p = d.length; f < p; f++)
      if (d[f](e, u, n, !0)) {
        h = !0;
        break;
      }
    if (h)
      break;
    o.push(e.bMarks[u]), a.push(e.tShift[u]), e.tShift[u] = -1337;
  }
  for (c = e.parentType, e.parentType = "blockquote", e.tokens.push({
    type: "blockquote_open",
    lines: l = [t, 0],
    level: e.level++
  }), e.parser.tokenize(e, t, u), e.tokens.push({
    type: "blockquote_close",
    level: --e.level
  }), e.parentType = c, l[1] = e.line, f = 0; f < a.length; f++)
    e.bMarks[f + t] = o[f], e.tShift[f + t] = a[f];
  return e.blkIndent = s, !0;
}
function dE(e, t, n, r) {
  var u, i, a, o = e.bMarks[t], s = e.eMarks[t];
  if (o += e.tShift[t], o > s || (u = e.src.charCodeAt(o++), u !== 42 && u !== 45 && u !== 95))
    return !1;
  for (i = 1; o < s; ) {
    if (a = e.src.charCodeAt(o++), a !== u && a !== 32)
      return !1;
    a === u && i++;
  }
  return i < 3 ? !1 : (r || (e.line = t + 1, e.tokens.push({
    type: "hr",
    lines: [t, e.line],
    level: e.level
  })), !0);
}
function Pf(e, t) {
  var n, r, u;
  return r = e.bMarks[t] + e.tShift[t], u = e.eMarks[t], r >= u || (n = e.src.charCodeAt(r++), n !== 42 && n !== 45 && n !== 43) || r < u && e.src.charCodeAt(r) !== 32 ? -1 : r;
}
function Rf(e, t) {
  var n, r = e.bMarks[t] + e.tShift[t], u = e.eMarks[t];
  if (r + 1 >= u || (n = e.src.charCodeAt(r++), n < 48 || n > 57))
    return -1;
  for (; ; ) {
    if (r >= u)
      return -1;
    if (n = e.src.charCodeAt(r++), !(n >= 48 && n <= 57)) {
      if (n === 41 || n === 46)
        break;
      return -1;
    }
  }
  return r < u && e.src.charCodeAt(r) !== 32 ? -1 : r;
}
function fE(e, t) {
  var n, r, u = e.level + 2;
  for (n = t + 2, r = e.tokens.length - 2; n < r; n++)
    e.tokens[n].level === u && e.tokens[n].type === "paragraph_open" && (e.tokens[n + 2].tight = !0, e.tokens[n].tight = !0, n += 2);
}
function pE(e, t, n, r) {
  var u, i, a, o, s, c, l, d, f, p, h, m, b, x, y, g, v, S, _ = !0, A, k, T, L;
  if ((d = Rf(e, t)) >= 0)
    b = !0;
  else if ((d = Pf(e, t)) >= 0)
    b = !1;
  else
    return !1;
  if (e.level >= e.options.maxNesting)
    return !1;
  if (m = e.src.charCodeAt(d - 1), r)
    return !0;
  for (y = e.tokens.length, b ? (l = e.bMarks[t] + e.tShift[t], h = Number(e.src.substr(l, d - l - 1)), e.tokens.push({
    type: "ordered_list_open",
    order: h,
    lines: v = [t, 0],
    level: e.level++
  })) : e.tokens.push({
    type: "bullet_list_open",
    lines: v = [t, 0],
    level: e.level++
  }), u = t, g = !1, A = e.parser.ruler.getRules("list"); u < n && (x = e.skipSpaces(d), f = e.eMarks[u], x >= f ? p = 1 : p = x - d, p > 4 && (p = 1), p < 1 && (p = 1), i = d - e.bMarks[u] + p, e.tokens.push({
    type: "list_item_open",
    lines: S = [t, 0],
    level: e.level++
  }), o = e.blkIndent, s = e.tight, a = e.tShift[t], c = e.parentType, e.tShift[t] = x - e.bMarks[t], e.blkIndent = i, e.tight = !0, e.parentType = "list", e.parser.tokenize(e, t, n, !0), (!e.tight || g) && (_ = !1), g = e.line - t > 1 && e.isEmpty(e.line - 1), e.blkIndent = o, e.tShift[t] = a, e.tight = s, e.parentType = c, e.tokens.push({
    type: "list_item_close",
    level: --e.level
  }), u = t = e.line, S[1] = u, x = e.bMarks[t], !(u >= n || e.isEmpty(u) || e.tShift[u] < e.blkIndent)); ) {
    for (L = !1, k = 0, T = A.length; k < T; k++)
      if (A[k](e, u, n, !0)) {
        L = !0;
        break;
      }
    if (L)
      break;
    if (b) {
      if (d = Rf(e, u), d < 0)
        break;
    } else if (d = Pf(e, u), d < 0)
      break;
    if (m !== e.src.charCodeAt(d - 1))
      break;
  }
  return e.tokens.push({
    type: b ? "ordered_list_close" : "bullet_list_close",
    level: --e.level
  }), v[1] = u, e.line = u, _ && fE(e, y), !0;
}
function hE(e, t, n, r) {
  var u, i, a, o, s, c = e.bMarks[t] + e.tShift[t], l = e.eMarks[t];
  if (c + 4 > l || e.src.charCodeAt(c) !== 91 || e.src.charCodeAt(c + 1) !== 94 || e.level >= e.options.maxNesting)
    return !1;
  for (o = c + 2; o < l; o++) {
    if (e.src.charCodeAt(o) === 32)
      return !1;
    if (e.src.charCodeAt(o) === 93)
      break;
  }
  return o === c + 2 || o + 1 >= l || e.src.charCodeAt(++o) !== 58 ? !1 : (r || (o++, e.env.footnotes || (e.env.footnotes = {}), e.env.footnotes.refs || (e.env.footnotes.refs = {}), s = e.src.slice(c + 2, o - 2), e.env.footnotes.refs[":" + s] = -1, e.tokens.push({
    type: "footnote_reference_open",
    label: s,
    level: e.level++
  }), u = e.bMarks[t], i = e.tShift[t], a = e.parentType, e.tShift[t] = e.skipSpaces(o) - o, e.bMarks[t] = o, e.blkIndent += 4, e.parentType = "footnote", e.tShift[t] < e.blkIndent && (e.tShift[t] += e.blkIndent, e.bMarks[t] -= e.blkIndent), e.parser.tokenize(e, t, n, !0), e.parentType = a, e.blkIndent -= 4, e.tShift[t] = i, e.bMarks[t] = u, e.tokens.push({
    type: "footnote_reference_close",
    level: --e.level
  })), !0);
}
function mE(e, t, n, r) {
  var u, i, a, o = e.bMarks[t] + e.tShift[t], s = e.eMarks[t];
  if (o >= s || (u = e.src.charCodeAt(o), u !== 35 || o >= s))
    return !1;
  for (i = 1, u = e.src.charCodeAt(++o); u === 35 && o < s && i <= 6; )
    i++, u = e.src.charCodeAt(++o);
  return i > 6 || o < s && u !== 32 ? !1 : (r || (s = e.skipCharsBack(s, 32, o), a = e.skipCharsBack(s, 35, o), a > o && e.src.charCodeAt(a - 1) === 32 && (s = a), e.line = t + 1, e.tokens.push({
    type: "heading_open",
    hLevel: i,
    lines: [t, e.line],
    level: e.level
  }), o < s && e.tokens.push({
    type: "inline",
    content: e.src.slice(o, s).trim(),
    level: e.level + 1,
    lines: [t, e.line],
    children: []
  }), e.tokens.push({ type: "heading_close", hLevel: i, level: e.level })), !0);
}
function gE(e, t, n) {
  var r, u, i, a = t + 1;
  return a >= n || e.tShift[a] < e.blkIndent || e.tShift[a] - e.blkIndent > 3 || (u = e.bMarks[a] + e.tShift[a], i = e.eMarks[a], u >= i) || (r = e.src.charCodeAt(u), r !== 45 && r !== 61) || (u = e.skipChars(u, r), u = e.skipSpaces(u), u < i) ? !1 : (u = e.bMarks[t] + e.tShift[t], e.line = a + 1, e.tokens.push({
    type: "heading_open",
    hLevel: r === 61 ? 1 : 2,
    lines: [t, e.line],
    level: e.level
  }), e.tokens.push({
    type: "inline",
    content: e.src.slice(u, e.eMarks[t]).trim(),
    level: e.level + 1,
    lines: [t, e.line - 1],
    children: []
  }), e.tokens.push({
    type: "heading_close",
    hLevel: r === 61 ? 1 : 2,
    level: e.level
  }), !0);
}
var j2 = {};
[
  "article",
  "aside",
  "button",
  "blockquote",
  "body",
  "canvas",
  "caption",
  "col",
  "colgroup",
  "dd",
  "div",
  "dl",
  "dt",
  "embed",
  "fieldset",
  "figcaption",
  "figure",
  "footer",
  "form",
  "h1",
  "h2",
  "h3",
  "h4",
  "h5",
  "h6",
  "header",
  "hgroup",
  "hr",
  "iframe",
  "li",
  "map",
  "object",
  "ol",
  "output",
  "p",
  "pre",
  "progress",
  "script",
  "section",
  "style",
  "table",
  "tbody",
  "td",
  "textarea",
  "tfoot",
  "th",
  "tr",
  "thead",
  "ul",
  "video"
].forEach(function(e) {
  j2[e] = !0;
});
var bE = /^<([a-zA-Z]{1,15})[\s\/>]/, vE = /^<\/([a-zA-Z]{1,15})[\s>]/;
function yE(e) {
  var t = e | 32;
  return t >= 97 && t <= 122;
}
function xE(e, t, n, r) {
  var u, i, a, o = e.bMarks[t], s = e.eMarks[t], c = e.tShift[t];
  if (o += c, !e.options.html || c > 3 || o + 2 >= s || e.src.charCodeAt(o) !== 60)
    return !1;
  if (u = e.src.charCodeAt(o + 1), u === 33 || u === 63) {
    if (r)
      return !0;
  } else if (u === 47 || yE(u)) {
    if (u === 47) {
      if (i = e.src.slice(o, s).match(vE), !i)
        return !1;
    } else if (i = e.src.slice(o, s).match(bE), !i)
      return !1;
    if (j2[i[1].toLowerCase()] !== !0)
      return !1;
    if (r)
      return !0;
  } else
    return !1;
  for (a = t + 1; a < e.lineMax && !e.isEmpty(a); )
    a++;
  return e.line = a, e.tokens.push({
    type: "htmlblock",
    level: e.level,
    lines: [t, e.line],
    content: e.getLines(t, a, 0, !0)
  }), !0;
}
function As(e, t) {
  var n = e.bMarks[t] + e.blkIndent, r = e.eMarks[t];
  return e.src.substr(n, r - n);
}
function _E(e, t, n, r) {
  var u, i, a, o, s, c, l, d, f, p, h;
  if (t + 2 > n || (s = t + 1, e.tShift[s] < e.blkIndent) || (a = e.bMarks[s] + e.tShift[s], a >= e.eMarks[s]) || (u = e.src.charCodeAt(a), u !== 124 && u !== 45 && u !== 58) || (i = As(e, t + 1), !/^[-:| ]+$/.test(i)) || (c = i.split("|"), c <= 2))
    return !1;
  for (d = [], o = 0; o < c.length; o++) {
    if (f = c[o].trim(), !f) {
      if (o === 0 || o === c.length - 1)
        continue;
      return !1;
    }
    if (!/^:?-+:?$/.test(f))
      return !1;
    f.charCodeAt(f.length - 1) === 58 ? d.push(f.charCodeAt(0) === 58 ? "center" : "right") : f.charCodeAt(0) === 58 ? d.push("left") : d.push("");
  }
  if (i = As(e, t).trim(), i.indexOf("|") === -1 || (c = i.replace(/^\||\|$/g, "").split("|"), d.length !== c.length))
    return !1;
  if (r)
    return !0;
  for (e.tokens.push({
    type: "table_open",
    lines: p = [t, 0],
    level: e.level++
  }), e.tokens.push({
    type: "thead_open",
    lines: [t, t + 1],
    level: e.level++
  }), e.tokens.push({
    type: "tr_open",
    lines: [t, t + 1],
    level: e.level++
  }), o = 0; o < c.length; o++)
    e.tokens.push({
      type: "th_open",
      align: d[o],
      lines: [t, t + 1],
      level: e.level++
    }), e.tokens.push({
      type: "inline",
      content: c[o].trim(),
      lines: [t, t + 1],
      level: e.level,
      children: []
    }), e.tokens.push({ type: "th_close", level: --e.level });
  for (e.tokens.push({ type: "tr_close", level: --e.level }), e.tokens.push({ type: "thead_close", level: --e.level }), e.tokens.push({
    type: "tbody_open",
    lines: h = [t + 2, 0],
    level: e.level++
  }), s = t + 2; s < n && !(e.tShift[s] < e.blkIndent || (i = As(e, s).trim(), i.indexOf("|") === -1)); s++) {
    for (c = i.replace(/^\||\|$/g, "").split("|"), e.tokens.push({ type: "tr_open", level: e.level++ }), o = 0; o < c.length; o++)
      e.tokens.push({ type: "td_open", align: d[o], level: e.level++ }), l = c[o].substring(
        c[o].charCodeAt(0) === 124 ? 1 : 0,
        c[o].charCodeAt(c[o].length - 1) === 124 ? c[o].length - 1 : c[o].length
      ).trim(), e.tokens.push({
        type: "inline",
        content: l,
        level: e.level,
        children: []
      }), e.tokens.push({ type: "td_close", level: --e.level });
    e.tokens.push({ type: "tr_close", level: --e.level });
  }
  return e.tokens.push({ type: "tbody_close", level: --e.level }), e.tokens.push({ type: "table_close", level: --e.level }), p[1] = h[1] = s, e.line = s, !0;
}
function ia(e, t) {
  var n, r, u = e.bMarks[t] + e.tShift[t], i = e.eMarks[t];
  return u >= i || (r = e.src.charCodeAt(u++), r !== 126 && r !== 58) || (n = e.skipSpaces(u), u === n) || n >= i ? -1 : n;
}
function SE(e, t) {
  var n, r, u = e.level + 2;
  for (n = t + 2, r = e.tokens.length - 2; n < r; n++)
    e.tokens[n].level === u && e.tokens[n].type === "paragraph_open" && (e.tokens[n + 2].tight = !0, e.tokens[n].tight = !0, n += 2);
}
function CE(e, t, n, r) {
  var u, i, a, o, s, c, l, d, f, p, h, m, b, x;
  if (r)
    return e.ddIndent < 0 ? !1 : ia(e, t) >= 0;
  if (l = t + 1, e.isEmpty(l) && ++l > n || e.tShift[l] < e.blkIndent || (u = ia(e, l), u < 0) || e.level >= e.options.maxNesting)
    return !1;
  c = e.tokens.length, e.tokens.push({
    type: "dl_open",
    lines: s = [t, 0],
    level: e.level++
  }), a = t, i = l;
  e:
    for (; ; ) {
      for (x = !0, b = !1, e.tokens.push({
        type: "dt_open",
        lines: [a, a],
        level: e.level++
      }), e.tokens.push({
        type: "inline",
        content: e.getLines(a, a + 1, e.blkIndent, !1).trim(),
        level: e.level + 1,
        lines: [a, a],
        children: []
      }), e.tokens.push({
        type: "dt_close",
        level: --e.level
      }); ; ) {
        if (e.tokens.push({
          type: "dd_open",
          lines: o = [l, 0],
          level: e.level++
        }), m = e.tight, f = e.ddIndent, d = e.blkIndent, h = e.tShift[i], p = e.parentType, e.blkIndent = e.ddIndent = e.tShift[i] + 2, e.tShift[i] = u - e.bMarks[i], e.tight = !0, e.parentType = "deflist", e.parser.tokenize(e, i, n, !0), (!e.tight || b) && (x = !1), b = e.line - i > 1 && e.isEmpty(e.line - 1), e.tShift[i] = h, e.tight = m, e.parentType = p, e.blkIndent = d, e.ddIndent = f, e.tokens.push({
          type: "dd_close",
          level: --e.level
        }), o[1] = l = e.line, l >= n || e.tShift[l] < e.blkIndent)
          break e;
        if (u = ia(e, l), u < 0)
          break;
        i = l;
      }
      if (l >= n || (a = l, e.isEmpty(a)) || e.tShift[a] < e.blkIndent || (i = a + 1, i >= n) || (e.isEmpty(i) && i++, i >= n) || e.tShift[i] < e.blkIndent || (u = ia(e, i), u < 0))
        break;
    }
  return e.tokens.push({
    type: "dl_close",
    level: --e.level
  }), s[1] = l, e.line = l, x && SE(e, c), !0;
}
function EE(e, t) {
  var n, r, u, i, a, o = t + 1, s;
  if (n = e.lineMax, o < n && !e.isEmpty(o)) {
    for (s = e.parser.ruler.getRules("paragraph"); o < n && !e.isEmpty(o); o++)
      if (!(e.tShift[o] - e.blkIndent > 3)) {
        for (u = !1, i = 0, a = s.length; i < a; i++)
          if (s[i](e, o, n, !0)) {
            u = !0;
            break;
          }
        if (u)
          break;
      }
  }
  return r = e.getLines(t, o, e.blkIndent, !1).trim(), e.line = o, r.length && (e.tokens.push({
    type: "paragraph_open",
    tight: !1,
    lines: [t, e.line],
    level: e.level
  }), e.tokens.push({
    type: "inline",
    content: r,
    level: e.level + 1,
    lines: [t, e.line],
    children: []
  }), e.tokens.push({
    type: "paragraph_close",
    tight: !1,
    level: e.level
  })), !0;
}
var aa = [
  ["code", sE],
  ["fences", cE, ["paragraph", "blockquote", "list"]],
  ["blockquote", lE, ["paragraph", "blockquote", "list"]],
  ["hr", dE, ["paragraph", "blockquote", "list"]],
  ["list", pE, ["paragraph", "blockquote"]],
  ["footnote", hE, ["paragraph"]],
  ["heading", mE, ["paragraph", "blockquote"]],
  ["lheading", gE],
  ["htmlblock", xE, ["paragraph", "blockquote"]],
  ["table", _E, ["paragraph"]],
  ["deflist", CE, ["paragraph"]],
  ["paragraph", EE]
];
function ql() {
  this.ruler = new dn();
  for (var e = 0; e < aa.length; e++)
    this.ruler.push(aa[e][0], aa[e][1], {
      alt: (aa[e][2] || []).slice()
    });
}
ql.prototype.tokenize = function(e, t, n) {
  for (var r = this.ruler.getRules(""), u = r.length, i = t, a = !1, o, s; i < n && (e.line = i = e.skipEmptyLines(i), !(i >= n || e.tShift[i] < e.blkIndent)); ) {
    for (s = 0; s < u && (o = r[s](e, i, n, !1), !o); s++)
      ;
    if (e.tight = !a, e.isEmpty(e.line - 1) && (a = !0), i = e.line, i < n && e.isEmpty(i)) {
      if (a = !0, i++, i < n && e.parentType === "list" && e.isEmpty(i))
        break;
      e.line = i;
    }
  }
};
var wE = /[\n\t]/g, TE = /\r[\n\u0085]|[\u2424\u2028\u0085]/g, AE = /\u00a0/g;
ql.prototype.parse = function(e, t, n, r) {
  var u, i = 0, a = 0;
  if (!e)
    return [];
  e = e.replace(AE, " "), e = e.replace(TE, `
`), e.indexOf("	") >= 0 && (e = e.replace(wE, function(o, s) {
    var c;
    return e.charCodeAt(s) === 10 ? (i = s + 1, a = 0, o) : (c = "    ".slice((s - i - a) % 4), a = s - i + 1, c);
  })), u = new $r(e, this, t, n, r), this.tokenize(u, u.line, u.lineMax);
};
function kE(e) {
  switch (e) {
    case 10:
    case 92:
    case 96:
    case 42:
    case 95:
    case 94:
    case 91:
    case 93:
    case 33:
    case 38:
    case 60:
    case 62:
    case 123:
    case 125:
    case 36:
    case 37:
    case 64:
    case 126:
    case 43:
    case 61:
    case 58:
      return !0;
    default:
      return !1;
  }
}
function LE(e, t) {
  for (var n = e.pos; n < e.posMax && !kE(e.src.charCodeAt(n)); )
    n++;
  return n === e.pos ? !1 : (t || (e.pending += e.src.slice(e.pos, n)), e.pos = n, !0);
}
function DE(e, t) {
  var n, r, u = e.pos;
  if (e.src.charCodeAt(u) !== 10)
    return !1;
  if (n = e.pending.length - 1, r = e.posMax, !t)
    if (n >= 0 && e.pending.charCodeAt(n) === 32)
      if (n >= 1 && e.pending.charCodeAt(n - 1) === 32) {
        for (var i = n - 2; i >= 0; i--)
          if (e.pending.charCodeAt(i) !== 32) {
            e.pending = e.pending.substring(0, i + 1);
            break;
          }
        e.push({
          type: "hardbreak",
          level: e.level
        });
      } else
        e.pending = e.pending.slice(0, -1), e.push({
          type: "softbreak",
          level: e.level
        });
    else
      e.push({
        type: "softbreak",
        level: e.level
      });
  for (u++; u < r && e.src.charCodeAt(u) === 32; )
    u++;
  return e.pos = u, !0;
}
var Gl = [];
for (var Bf = 0; Bf < 256; Bf++)
  Gl.push(0);
"\\!\"#$%&'()*+,./:;<=>?@[]^_`{|}~-".split("").forEach(function(e) {
  Gl[e.charCodeAt(0)] = 1;
});
function NE(e, t) {
  var n, r = e.pos, u = e.posMax;
  if (e.src.charCodeAt(r) !== 92)
    return !1;
  if (r++, r < u) {
    if (n = e.src.charCodeAt(r), n < 256 && Gl[n] !== 0)
      return t || (e.pending += e.src[r]), e.pos += 2, !0;
    if (n === 10) {
      for (t || e.push({
        type: "hardbreak",
        level: e.level
      }), r++; r < u && e.src.charCodeAt(r) === 32; )
        r++;
      return e.pos = r, !0;
    }
  }
  return t || (e.pending += "\\"), e.pos++, !0;
}
function OE(e, t) {
  var n, r, u, i, a, o = e.pos, s = e.src.charCodeAt(o);
  if (s !== 96)
    return !1;
  for (n = o, o++, r = e.posMax; o < r && e.src.charCodeAt(o) === 96; )
    o++;
  for (u = e.src.slice(n, o), i = a = o; (i = e.src.indexOf("`", a)) !== -1; ) {
    for (a = i + 1; a < r && e.src.charCodeAt(a) === 96; )
      a++;
    if (a - i === u.length)
      return t || e.push({
        type: "code",
        content: e.src.slice(o, i).replace(/[ \n]+/g, " ").trim(),
        block: !1,
        level: e.level
      }), e.pos = a, !0;
  }
  return t || (e.pending += u), e.pos += u.length, !0;
}
function IE(e, t) {
  var n, r, u, i = e.posMax, a = e.pos, o, s;
  if (e.src.charCodeAt(a) !== 126 || t || a + 4 >= i || e.src.charCodeAt(a + 1) !== 126 || e.level >= e.options.maxNesting || (o = a > 0 ? e.src.charCodeAt(a - 1) : -1, s = e.src.charCodeAt(a + 2), o === 126) || s === 126 || s === 32 || s === 10)
    return !1;
  for (r = a + 2; r < i && e.src.charCodeAt(r) === 126; )
    r++;
  if (r > a + 3)
    return e.pos += r - a, t || (e.pending += e.src.slice(a, r)), !0;
  for (e.pos = a + 2, u = 1; e.pos + 1 < i; ) {
    if (e.src.charCodeAt(e.pos) === 126 && e.src.charCodeAt(e.pos + 1) === 126 && (o = e.src.charCodeAt(e.pos - 1), s = e.pos + 2 < i ? e.src.charCodeAt(e.pos + 2) : -1, s !== 126 && o !== 126 && (o !== 32 && o !== 10 ? u-- : s !== 32 && s !== 10 && u++, u <= 0))) {
      n = !0;
      break;
    }
    e.parser.skipToken(e);
  }
  return n ? (e.posMax = e.pos, e.pos = a + 2, t || (e.push({ type: "del_open", level: e.level++ }), e.parser.tokenize(e), e.push({ type: "del_close", level: --e.level })), e.pos = e.posMax + 2, e.posMax = i, !0) : (e.pos = a, !1);
}
function ME(e, t) {
  var n, r, u, i = e.posMax, a = e.pos, o, s;
  if (e.src.charCodeAt(a) !== 43 || t || a + 4 >= i || e.src.charCodeAt(a + 1) !== 43 || e.level >= e.options.maxNesting || (o = a > 0 ? e.src.charCodeAt(a - 1) : -1, s = e.src.charCodeAt(a + 2), o === 43) || s === 43 || s === 32 || s === 10)
    return !1;
  for (r = a + 2; r < i && e.src.charCodeAt(r) === 43; )
    r++;
  if (r !== a + 2)
    return e.pos += r - a, t || (e.pending += e.src.slice(a, r)), !0;
  for (e.pos = a + 2, u = 1; e.pos + 1 < i; ) {
    if (e.src.charCodeAt(e.pos) === 43 && e.src.charCodeAt(e.pos + 1) === 43 && (o = e.src.charCodeAt(e.pos - 1), s = e.pos + 2 < i ? e.src.charCodeAt(e.pos + 2) : -1, s !== 43 && o !== 43 && (o !== 32 && o !== 10 ? u-- : s !== 32 && s !== 10 && u++, u <= 0))) {
      n = !0;
      break;
    }
    e.parser.skipToken(e);
  }
  return n ? (e.posMax = e.pos, e.pos = a + 2, t || (e.push({ type: "ins_open", level: e.level++ }), e.parser.tokenize(e), e.push({ type: "ins_close", level: --e.level })), e.pos = e.posMax + 2, e.posMax = i, !0) : (e.pos = a, !1);
}
function PE(e, t) {
  var n, r, u, i = e.posMax, a = e.pos, o, s;
  if (e.src.charCodeAt(a) !== 61 || t || a + 4 >= i || e.src.charCodeAt(a + 1) !== 61 || e.level >= e.options.maxNesting || (o = a > 0 ? e.src.charCodeAt(a - 1) : -1, s = e.src.charCodeAt(a + 2), o === 61) || s === 61 || s === 32 || s === 10)
    return !1;
  for (r = a + 2; r < i && e.src.charCodeAt(r) === 61; )
    r++;
  if (r !== a + 2)
    return e.pos += r - a, t || (e.pending += e.src.slice(a, r)), !0;
  for (e.pos = a + 2, u = 1; e.pos + 1 < i; ) {
    if (e.src.charCodeAt(e.pos) === 61 && e.src.charCodeAt(e.pos + 1) === 61 && (o = e.src.charCodeAt(e.pos - 1), s = e.pos + 2 < i ? e.src.charCodeAt(e.pos + 2) : -1, s !== 61 && o !== 61 && (o !== 32 && o !== 10 ? u-- : s !== 32 && s !== 10 && u++, u <= 0))) {
      n = !0;
      break;
    }
    e.parser.skipToken(e);
  }
  return n ? (e.posMax = e.pos, e.pos = a + 2, t || (e.push({ type: "mark_open", level: e.level++ }), e.parser.tokenize(e), e.push({ type: "mark_close", level: --e.level })), e.pos = e.posMax + 2, e.posMax = i, !0) : (e.pos = a, !1);
}
function Ff(e) {
  return e >= 48 && e <= 57 || e >= 65 && e <= 90 || e >= 97 && e <= 122;
}
function Hf(e, t) {
  var n = t, r, u, i, a = !0, o = !0, s = e.posMax, c = e.src.charCodeAt(t);
  for (r = t > 0 ? e.src.charCodeAt(t - 1) : -1; n < s && e.src.charCodeAt(n) === c; )
    n++;
  return n >= s && (a = !1), i = n - t, i >= 4 ? a = o = !1 : (u = n < s ? e.src.charCodeAt(n) : -1, (u === 32 || u === 10) && (a = !1), (r === 32 || r === 10) && (o = !1), c === 95 && (Ff(r) && (a = !1), Ff(u) && (o = !1))), {
    can_open: a,
    can_close: o,
    delims: i
  };
}
function RE(e, t) {
  var n, r, u, i, a, o, s, c = e.posMax, l = e.pos, d = e.src.charCodeAt(l);
  if (d !== 95 && d !== 42 || t)
    return !1;
  if (s = Hf(e, l), n = s.delims, !s.can_open)
    return e.pos += n, t || (e.pending += e.src.slice(l, e.pos)), !0;
  if (e.level >= e.options.maxNesting)
    return !1;
  for (e.pos = l + n, o = [n]; e.pos < c; ) {
    if (e.src.charCodeAt(e.pos) === d) {
      if (s = Hf(e, e.pos), r = s.delims, s.can_close) {
        for (i = o.pop(), a = r; i !== a; ) {
          if (a < i) {
            o.push(i - a);
            break;
          }
          if (a -= i, o.length === 0)
            break;
          e.pos += i, i = o.pop();
        }
        if (o.length === 0) {
          n = i, u = !0;
          break;
        }
        e.pos += r;
        continue;
      }
      s.can_open && o.push(r), e.pos += r;
      continue;
    }
    e.parser.skipToken(e);
  }
  return u ? (e.posMax = e.pos, e.pos = l + n, t || ((n === 2 || n === 3) && e.push({ type: "strong_open", level: e.level++ }), (n === 1 || n === 3) && e.push({ type: "em_open", level: e.level++ }), e.parser.tokenize(e), (n === 1 || n === 3) && e.push({ type: "em_close", level: --e.level }), (n === 2 || n === 3) && e.push({ type: "strong_close", level: --e.level })), e.pos = e.posMax + n, e.posMax = c, !0) : (e.pos = l, !1);
}
var BE = /\\([ \\!"#$%&'()*+,.\/:;<=>?@[\]^_`{|}~-])/g;
function FE(e, t) {
  var n, r, u = e.posMax, i = e.pos;
  if (e.src.charCodeAt(i) !== 126 || t || i + 2 >= u || e.level >= e.options.maxNesting)
    return !1;
  for (e.pos = i + 1; e.pos < u; ) {
    if (e.src.charCodeAt(e.pos) === 126) {
      n = !0;
      break;
    }
    e.parser.skipToken(e);
  }
  return !n || i + 1 === e.pos || (r = e.src.slice(i + 1, e.pos), r.match(/(^|[^\\])(\\\\)*\s/)) ? (e.pos = i, !1) : (e.posMax = e.pos, e.pos = i + 1, t || e.push({
    type: "sub",
    level: e.level,
    content: r.replace(BE, "$1")
  }), e.pos = e.posMax + 1, e.posMax = u, !0);
}
var HE = /\\([ \\!"#$%&'()*+,.\/:;<=>?@[\]^_`{|}~-])/g;
function $E(e, t) {
  var n, r, u = e.posMax, i = e.pos;
  if (e.src.charCodeAt(i) !== 94 || t || i + 2 >= u || e.level >= e.options.maxNesting)
    return !1;
  for (e.pos = i + 1; e.pos < u; ) {
    if (e.src.charCodeAt(e.pos) === 94) {
      n = !0;
      break;
    }
    e.parser.skipToken(e);
  }
  return !n || i + 1 === e.pos || (r = e.src.slice(i + 1, e.pos), r.match(/(^|[^\\])(\\\\)*\s/)) ? (e.pos = i, !1) : (e.posMax = e.pos, e.pos = i + 1, t || e.push({
    type: "sup",
    level: e.level,
    content: r.replace(HE, "$1")
  }), e.pos = e.posMax + 1, e.posMax = u, !0);
}
function VE(e, t) {
  var n, r, u, i, a, o, s, c, l = !1, d = e.pos, f = e.posMax, p = e.pos, h = e.src.charCodeAt(p);
  if (h === 33 && (l = !0, h = e.src.charCodeAt(++p)), h !== 91 || e.level >= e.options.maxNesting || (n = p + 1, r = Si(e, p), r < 0))
    return !1;
  if (o = r + 1, o < f && e.src.charCodeAt(o) === 40) {
    for (o++; o < f && (c = e.src.charCodeAt(o), !(c !== 32 && c !== 10)); o++)
      ;
    if (o >= f)
      return !1;
    for (p = o, F2(e, o) ? (i = e.linkContent, o = e.pos) : i = "", p = o; o < f && (c = e.src.charCodeAt(o), !(c !== 32 && c !== 10)); o++)
      ;
    if (o < f && p !== o && H2(e, o))
      for (a = e.linkContent, o = e.pos; o < f && (c = e.src.charCodeAt(o), !(c !== 32 && c !== 10)); o++)
        ;
    else
      a = "";
    if (o >= f || e.src.charCodeAt(o) !== 41)
      return e.pos = d, !1;
    o++;
  } else {
    if (e.linkLevel > 0)
      return !1;
    for (; o < f && (c = e.src.charCodeAt(o), !(c !== 32 && c !== 10)); o++)
      ;
    if (o < f && e.src.charCodeAt(o) === 91 && (p = o + 1, o = Si(e, o), o >= 0 ? u = e.src.slice(p, o++) : o = p - 1), u || (typeof u > "u" && (o = r + 1), u = e.src.slice(n, r)), s = e.env.references[$2(u)], !s)
      return e.pos = d, !1;
    i = s.href, a = s.title;
  }
  return t || (e.pos = n, e.posMax = r, l ? e.push({
    type: "image",
    src: i,
    title: a,
    alt: e.src.substr(n, r - n),
    level: e.level
  }) : (e.push({
    type: "link_open",
    href: i,
    title: a,
    level: e.level++
  }), e.linkLevel++, e.parser.tokenize(e), e.linkLevel--, e.push({ type: "link_close", level: --e.level }))), e.pos = o, e.posMax = f, !0;
}
function jE(e, t) {
  var n, r, u, i, a = e.posMax, o = e.pos;
  return o + 2 >= a || e.src.charCodeAt(o) !== 94 || e.src.charCodeAt(o + 1) !== 91 || e.level >= e.options.maxNesting || (n = o + 2, r = Si(e, o + 1), r < 0) ? !1 : (t || (e.env.footnotes || (e.env.footnotes = {}), e.env.footnotes.list || (e.env.footnotes.list = []), u = e.env.footnotes.list.length, e.pos = n, e.posMax = r, e.push({
    type: "footnote_ref",
    id: u,
    level: e.level
  }), e.linkLevel++, i = e.tokens.length, e.parser.tokenize(e), e.env.footnotes.list[u] = { tokens: e.tokens.splice(i) }, e.linkLevel--), e.pos = r + 1, e.posMax = a, !0);
}
function zE(e, t) {
  var n, r, u, i, a = e.posMax, o = e.pos;
  if (o + 3 > a || !e.env.footnotes || !e.env.footnotes.refs || e.src.charCodeAt(o) !== 91 || e.src.charCodeAt(o + 1) !== 94 || e.level >= e.options.maxNesting)
    return !1;
  for (r = o + 2; r < a; r++) {
    if (e.src.charCodeAt(r) === 32 || e.src.charCodeAt(r) === 10)
      return !1;
    if (e.src.charCodeAt(r) === 93)
      break;
  }
  return r === o + 2 || r >= a || (r++, n = e.src.slice(o + 2, r - 1), typeof e.env.footnotes.refs[":" + n] > "u") ? !1 : (t || (e.env.footnotes.list || (e.env.footnotes.list = []), e.env.footnotes.refs[":" + n] < 0 ? (u = e.env.footnotes.list.length, e.env.footnotes.list[u] = { label: n, count: 0 }, e.env.footnotes.refs[":" + n] = u) : u = e.env.footnotes.refs[":" + n], i = e.env.footnotes.list[u].count, e.env.footnotes.list[u].count++, e.push({
    type: "footnote_ref",
    id: u,
    subId: i,
    level: e.level
  })), e.pos = r, e.posMax = a, !0);
}
var UE = [
  "coap",
  "doi",
  "javascript",
  "aaa",
  "aaas",
  "about",
  "acap",
  "cap",
  "cid",
  "crid",
  "data",
  "dav",
  "dict",
  "dns",
  "file",
  "ftp",
  "geo",
  "go",
  "gopher",
  "h323",
  "http",
  "https",
  "iax",
  "icap",
  "im",
  "imap",
  "info",
  "ipp",
  "iris",
  "iris.beep",
  "iris.xpc",
  "iris.xpcs",
  "iris.lwz",
  "ldap",
  "mailto",
  "mid",
  "msrp",
  "msrps",
  "mtqp",
  "mupdate",
  "news",
  "nfs",
  "ni",
  "nih",
  "nntp",
  "opaquelocktoken",
  "pop",
  "pres",
  "rtsp",
  "service",
  "session",
  "shttp",
  "sieve",
  "sip",
  "sips",
  "sms",
  "snmp",
  "soap.beep",
  "soap.beeps",
  "tag",
  "tel",
  "telnet",
  "tftp",
  "thismessage",
  "tn3270",
  "tip",
  "tv",
  "urn",
  "vemmi",
  "ws",
  "wss",
  "xcon",
  "xcon-userid",
  "xmlrpc.beep",
  "xmlrpc.beeps",
  "xmpp",
  "z39.50r",
  "z39.50s",
  "adiumxtra",
  "afp",
  "afs",
  "aim",
  "apt",
  "attachment",
  "aw",
  "beshare",
  "bitcoin",
  "bolo",
  "callto",
  "chrome",
  "chrome-extension",
  "com-eventbrite-attendee",
  "content",
  "cvs",
  "dlna-playsingle",
  "dlna-playcontainer",
  "dtn",
  "dvb",
  "ed2k",
  "facetime",
  "feed",
  "finger",
  "fish",
  "gg",
  "git",
  "gizmoproject",
  "gtalk",
  "hcp",
  "icon",
  "ipn",
  "irc",
  "irc6",
  "ircs",
  "itms",
  "jar",
  "jms",
  "keyparc",
  "lastfm",
  "ldaps",
  "magnet",
  "maps",
  "market",
  "message",
  "mms",
  "ms-help",
  "msnim",
  "mumble",
  "mvn",
  "notes",
  "oid",
  "palm",
  "paparazzi",
  "platform",
  "proxy",
  "psyc",
  "query",
  "res",
  "resource",
  "rmi",
  "rsync",
  "rtmp",
  "secondlife",
  "sftp",
  "sgn",
  "skype",
  "smb",
  "soldat",
  "spotify",
  "ssh",
  "steam",
  "svn",
  "teamspeak",
  "things",
  "udp",
  "unreal",
  "ut2004",
  "ventrilo",
  "view-source",
  "webcal",
  "wtai",
  "wyciwyg",
  "xfire",
  "xri",
  "ymsgr"
], qE = /^<([a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*)>/, GE = /^<([a-zA-Z.\-]{1,25}):([^<>\x00-\x20]*)>/;
function WE(e, t) {
  var n, r, u, i, a, o = e.pos;
  return e.src.charCodeAt(o) !== 60 || (n = e.src.slice(o), n.indexOf(">") < 0) ? !1 : (r = n.match(GE), r ? UE.indexOf(r[1].toLowerCase()) < 0 || (i = r[0].slice(1, -1), a = Mc(i), !e.parser.validateLink(i)) ? !1 : (t || (e.push({
    type: "link_open",
    href: a,
    level: e.level
  }), e.push({
    type: "text",
    content: i,
    level: e.level + 1
  }), e.push({ type: "link_close", level: e.level })), e.pos += r[0].length, !0) : (u = n.match(qE), u ? (i = u[0].slice(1, -1), a = Mc("mailto:" + i), e.parser.validateLink(a) ? (t || (e.push({
    type: "link_open",
    href: a,
    level: e.level
  }), e.push({
    type: "text",
    content: i,
    level: e.level + 1
  }), e.push({ type: "link_close", level: e.level })), e.pos += u[0].length, !0) : !1) : !1));
}
function Ao(e, t) {
  return e = e.source, t = t || "", function n(r, u) {
    return r ? (u = u.source || u, e = e.replace(r, u), n) : new RegExp(e, t);
  };
}
var KE = /[a-zA-Z_:][a-zA-Z0-9:._-]*/, YE = /[^"'=<>`\x00-\x20]+/, ZE = /'[^']*'/, XE = /"[^"]*"/, QE = Ao(/(?:unquoted|single_quoted|double_quoted)/)("unquoted", YE)("single_quoted", ZE)("double_quoted", XE)(), JE = Ao(/(?:\s+attr_name(?:\s*=\s*attr_value)?)/)("attr_name", KE)("attr_value", QE)(), ew = Ao(/<[A-Za-z][A-Za-z0-9]*attribute*\s*\/?>/)("attribute", JE)(), tw = /<\/[A-Za-z][A-Za-z0-9]*\s*>/, nw = /<!---->|<!--(?:-?[^>-])(?:-?[^-])*-->/, rw = /<[?].*?[?]>/, uw = /<![A-Z]+\s+[^>]*>/, iw = /<!\[CDATA\[[\s\S]*?\]\]>/, aw = Ao(/^(?:open_tag|close_tag|comment|processing|declaration|cdata)/)("open_tag", ew)("close_tag", tw)("comment", nw)("processing", rw)("declaration", uw)("cdata", iw)();
function ow(e) {
  var t = e | 32;
  return t >= 97 && t <= 122;
}
function sw(e, t) {
  var n, r, u, i = e.pos;
  return !e.options.html || (u = e.posMax, e.src.charCodeAt(i) !== 60 || i + 2 >= u) || (n = e.src.charCodeAt(i + 1), n !== 33 && n !== 63 && n !== 47 && !ow(n)) || (r = e.src.slice(i).match(aw), !r) ? !1 : (t || e.push({
    type: "htmltag",
    content: e.src.slice(i, i + r[0].length),
    level: e.level
  }), e.pos += r[0].length, !0);
}
var cw = /^&#((?:x[a-f0-9]{1,8}|[0-9]{1,8}));/i, lw = /^&([a-z][a-z0-9]{1,31});/i;
function dw(e, t) {
  var n, r, u, i = e.pos, a = e.posMax;
  if (e.src.charCodeAt(i) !== 38)
    return !1;
  if (i + 1 < a) {
    if (n = e.src.charCodeAt(i + 1), n === 35) {
      if (u = e.src.slice(i).match(cw), u)
        return t || (r = u[1][0].toLowerCase() === "x" ? parseInt(u[1].slice(1), 16) : parseInt(u[1], 10), e.pending += R2(r) ? Ic(r) : Ic(65533)), e.pos += u[0].length, !0;
    } else if (u = e.src.slice(i).match(lw), u) {
      var o = M2(u[1]);
      if (u[1] !== o)
        return t || (e.pending += o), e.pos += u[0].length, !0;
    }
  }
  return t || (e.pending += "&"), e.pos++, !0;
}
var ks = [
  ["text", LE],
  ["newline", DE],
  ["escape", NE],
  ["backticks", OE],
  ["del", IE],
  ["ins", ME],
  ["mark", PE],
  ["emphasis", RE],
  ["sub", FE],
  ["sup", $E],
  ["links", VE],
  ["footnote_inline", jE],
  ["footnote_ref", zE],
  ["autolink", WE],
  ["htmltag", sw],
  ["entity", dw]
];
function ko() {
  this.ruler = new dn();
  for (var e = 0; e < ks.length; e++)
    this.ruler.push(ks[e][0], ks[e][1]);
  this.validateLink = fw;
}
ko.prototype.skipToken = function(e) {
  var t = this.ruler.getRules(""), n = t.length, r = e.pos, u, i;
  if ((i = e.cacheGet(r)) > 0) {
    e.pos = i;
    return;
  }
  for (u = 0; u < n; u++)
    if (t[u](e, !0)) {
      e.cacheSet(r, e.pos);
      return;
    }
  e.pos++, e.cacheSet(r, e.pos);
};
ko.prototype.tokenize = function(e) {
  for (var t = this.ruler.getRules(""), n = t.length, r = e.posMax, u, i; e.pos < r; ) {
    for (i = 0; i < n && (u = t[i](e, !1), !u); i++)
      ;
    if (u) {
      if (e.pos >= r)
        break;
      continue;
    }
    e.pending += e.src[e.pos++];
  }
  e.pending && e.pushPending();
};
ko.prototype.parse = function(e, t, n, r) {
  var u = new Hr(e, this, t, n, r);
  this.tokenize(u);
};
function fw(e) {
  var t = ["vbscript", "javascript", "file", "data"], n = e.trim().toLowerCase();
  return n = Nr(n), !(n.indexOf(":") !== -1 && t.indexOf(n.split(":")[0]) !== -1);
}
var pw = {
  options: {
    html: !1,
    // Enable HTML tags in source
    xhtmlOut: !1,
    // Use '/' to close single tags (<br />)
    breaks: !1,
    // Convert '\n' in paragraphs into <br>
    langPrefix: "language-",
    // CSS language prefix for fenced blocks
    linkTarget: "",
    // set target to open link in
    // Enable some language-neutral replacements + quotes beautification
    typographer: !1,
    // Double + single quotes replacement pairs, when typographer enabled,
    // and smartquotes on. Set doubles to '«»' for Russian, '„“' for German.
    quotes: "“”‘’",
    // Highlighter function. Should return escaped HTML,
    // or '' if input not changed
    //
    // function (/*str, lang*/) { return ''; }
    //
    highlight: null,
    maxNesting: 20
    // Internal protection, recursion limit
  },
  components: {
    core: {
      rules: [
        "block",
        "inline",
        "references",
        "replacements",
        "smartquotes",
        "references",
        "abbr2",
        "footnote_tail"
      ]
    },
    block: {
      rules: [
        "blockquote",
        "code",
        "fences",
        "footnote",
        "heading",
        "hr",
        "htmlblock",
        "lheading",
        "list",
        "paragraph",
        "table"
      ]
    },
    inline: {
      rules: [
        "autolink",
        "backticks",
        "del",
        "emphasis",
        "entity",
        "escape",
        "footnote_ref",
        "htmltag",
        "links",
        "newline",
        "text"
      ]
    }
  }
}, hw = {
  options: {
    html: !1,
    // Enable HTML tags in source
    xhtmlOut: !1,
    // Use '/' to close single tags (<br />)
    breaks: !1,
    // Convert '\n' in paragraphs into <br>
    langPrefix: "language-",
    // CSS language prefix for fenced blocks
    linkTarget: "",
    // set target to open link in
    // Enable some language-neutral replacements + quotes beautification
    typographer: !1,
    // Double + single quotes replacement pairs, when typographer enabled,
    // and smartquotes on. Set doubles to '«»' for Russian, '„“' for German.
    quotes: "“”‘’",
    // Highlighter function. Should return escaped HTML,
    // or '' if input not changed
    //
    // function (/*str, lang*/) { return ''; }
    //
    highlight: null,
    maxNesting: 20
    // Internal protection, recursion limit
  },
  components: {
    // Don't restrict core/block/inline rules
    core: {},
    block: {},
    inline: {}
  }
}, mw = {
  options: {
    html: !0,
    // Enable HTML tags in source
    xhtmlOut: !0,
    // Use '/' to close single tags (<br />)
    breaks: !1,
    // Convert '\n' in paragraphs into <br>
    langPrefix: "language-",
    // CSS language prefix for fenced blocks
    linkTarget: "",
    // set target to open link in
    // Enable some language-neutral replacements + quotes beautification
    typographer: !1,
    // Double + single quotes replacement pairs, when typographer enabled,
    // and smartquotes on. Set doubles to '«»' for Russian, '„“' for German.
    quotes: "“”‘’",
    // Highlighter function. Should return escaped HTML,
    // or '' if input not changed
    //
    // function (/*str, lang*/) { return ''; }
    //
    highlight: null,
    maxNesting: 20
    // Internal protection, recursion limit
  },
  components: {
    core: {
      rules: [
        "block",
        "inline",
        "references",
        "abbr2"
      ]
    },
    block: {
      rules: [
        "blockquote",
        "code",
        "fences",
        "heading",
        "hr",
        "htmlblock",
        "lheading",
        "list",
        "paragraph"
      ]
    },
    inline: {
      rules: [
        "autolink",
        "backticks",
        "emphasis",
        "entity",
        "escape",
        "htmltag",
        "links",
        "newline",
        "text"
      ]
    }
  }
}, gw = {
  default: pw,
  full: hw,
  commonmark: mw
};
function z2(e, t, n) {
  this.src = t, this.env = n, this.options = e.options, this.tokens = [], this.inlineMode = !1, this.inline = e.inline, this.block = e.block, this.renderer = e.renderer, this.typographer = e.typographer;
}
function pr(e, t) {
  typeof e != "string" && (t = e, e = "default"), t && t.linkify != null && console.warn(
    `linkify option is removed. Use linkify plugin instead:

import Remarkable from 'remarkable';
import linkify from 'remarkable/linkify';
new Remarkable().use(linkify)
`
  ), this.inline = new ko(), this.block = new ql(), this.core = new V2(), this.renderer = new Ul(), this.ruler = new dn(), this.options = {}, this.configure(gw[e]), this.set(t || {});
}
pr.prototype.set = function(e) {
  P2(this.options, e);
};
pr.prototype.configure = function(e) {
  var t = this;
  if (!e)
    throw new Error("Wrong `remarkable` preset, check name/content");
  e.options && t.set(e.options), e.components && Object.keys(e.components).forEach(function(n) {
    e.components[n].rules && t[n].ruler.enable(e.components[n].rules, !0);
  });
};
pr.prototype.use = function(e, t) {
  return e(this, t), this;
};
pr.prototype.parse = function(e, t) {
  var n = new z2(this, e, t);
  return this.core.process(n), n.tokens;
};
pr.prototype.render = function(e, t) {
  return t = t || {}, this.renderer.render(this.parse(e, t), this.options, t);
};
pr.prototype.parseInline = function(e, t) {
  var n = new z2(this, e, t);
  return n.inlineMode = !0, this.core.process(n), n.tokens;
};
pr.prototype.renderInline = function(e, t) {
  return t = t || {}, this.renderer.render(this.parseInline(e, t), this.options, t);
};
const $f = (e, t) => (n, r) => {
  const u = n.posMax;
  let i = n.pos;
  if (r || n.src.charAt(i) !== e || i + 2 >= u || n.src.indexOf(e, i + 1) === -1)
    return !1;
  for (n.pos = i + 1; n.pos < u; ) {
    if (n.src.charAt(n.pos) === e) {
      if (!r) {
        const a = n.src.slice(i + 1, n.pos);
        n.push({ type: `${t}_open`, level: n.level++ }), n.push({ type: "text", content: a, level: n.level }), n.push({ type: `${t}_close`, level: --n.level });
      }
      return n.pos++, !0;
    }
    n.pos++;
  }
  return !1;
}, bw = (e) => {
  e.inline.ruler.before("emphasis", "superscript", $f("^", "sup"), {}), e.renderer.rules.sup_open = () => "<sup>", e.renderer.rules.sup_close = () => "</sup>", e.inline.ruler.before("emphasis", "subscript", $f("~", "sub"), {}), e.renderer.rules.sub_open = () => "<sub>", e.renderer.rules.sub_close = () => "</sub>";
};
function vw(e, t) {
  e.renderer.rules.paragraph_open = () => {
    if (!t)
      return "";
    const { typeToRender: n, props: { className: r } = {} } = t, u = r ? `class="${r}"` : "";
    return typeof n == "string" ? u ? `<${n} ${u}>` : `<${n}>` : "";
  }, e.renderer.rules.paragraph_close = () => {
    if (!t)
      return "";
    const { typeToRender: n } = t;
    return n ? `</${n}>` : "";
  };
}
const yw = (e) => Object.entries(e).reduce((t, [n, r]) => (typeof r != "function" && (t[n] = r), t), {}), Pc = (e) => {
  const t = yw(e), n = Object.entries(t);
  return n.length === 0 ? "" : n.reduce((r, [u, i = !0]) => {
    if (i === null)
      return r;
    let a = String(i);
    return u === "data-pa-click" && (a = a.replace(/"/g, "&quot;")), r + ` ${u}="${a}"`;
  }, "");
};
function xw(e, t = {}) {
  const { processAnchorTagAttributes: n, ...r } = t;
  e.renderer.rules.link_open = (u, i) => {
    const a = u[i], { href: o, title: s } = a, c = u[i + 1] || {}, { content: l } = c;
    if (o === "data-nosnippet")
      return '<span data-nosnippet="true">';
    if (typeof n == "function") {
      const { className: d, ...f } = n(r, o, l, s);
      return d && (f.class = d), `<a${Pc(f)}>`;
    }
    return `<a${Pc({ href: o })}>`;
  }, e.renderer.rules.link_close = (u, i) => u[i - 2].href === "data-nosnippet" ? "</span>" : "</a>";
}
const _w = (e) => {
  let t = 0;
  for (; t < e.length && e[t] === " "; )
    t++;
  if (t === e.length)
    return { startSpaces: e, endSpaces: "", trimmedText: "" };
  let n = e.length - 1;
  for (; n >= 0 && e[n] === " "; )
    n--;
  const r = e.substring(0, t), u = e.substring(n + 1), i = e.substring(t, n + 1);
  return { startSpaces: r, endSpaces: u, trimmedText: i };
}, Sw = (e, t) => {
  if (!e && !t.start && !t.end)
    return "";
  const { start: n, end: r } = t;
  if (/^<([a-z]+)(?:\s[^>]*)?>/.test(e)) {
    const u = e.indexOf(">"), i = e.lastIndexOf("<");
    if (i !== 0) {
      const a = e.slice(0, u + 1), o = e.slice(i), s = e.slice(u + 1, i);
      return `${a}${n}${s}${r}${o}`;
    }
  }
  return `${n}${e}${r}`;
}, Cw = /^\s*[*\-+#>]+\s*$/, Ci = "[[SPLIT-SEPARATOR]]", Ew = /\n{2,}/g, U2 = " ", q2 = "[[NBSP]]", ww = (e) => e.replaceAll(q2, U2), G2 = (e, t) => t ? e.replaceAll(Ew, Ci) : e, Tw = (e, t) => {
  const n = e.replaceAll(U2, q2);
  return G2(n, t);
}, Aw = (e) => e.replace(/&amp;|&gt;|&lt;|&#39;|&apos;/g, (t) => {
  switch (t) {
    case "&amp;":
      return "&";
    case "&gt;":
      return ">";
    case "&lt;":
      return "<";
    case "&#39;":
    case "&apos;":
      return "'";
    default:
      return t;
  }
}), Wl = ({
  content: e,
  contentRenderingInformation: t,
  trimTrailingSpaces: n = !1,
  useNewLinePlaceholder: r = !1
}) => {
  if (!e)
    return "";
  const u = Cw.test(e), i = e.length < 3 || !n && e.trim().length === 0;
  if (u || i)
    return G2(e, r);
  const a = new pr({
    html: !0
    // We do this so we can enable HTML tags in our source
  });
  a.use(bw).use(vw, t == null ? void 0 : t.p).use(xw, t == null ? void 0 : t.a);
  let o = "";
  const s = Tw(e, r);
  if (n) {
    const l = s.trim();
    o = a.render(l);
  } else {
    const { startSpaces: l, endSpaces: d, trimmedText: f } = _w(s), p = f.length !== s.length, h = a.render(f);
    o = p ? Sw(h, { start: l, end: d }) : h;
  }
  const c = Aw(o);
  return ww(c);
}, kw = ({
  content: e,
  contentRenderingInformation: t,
  trimTrailingSpaces: n = !1,
  customWrapper: r = "div",
  props: u = {}
}) => {
  if (!e || typeof e != "string")
    return /* @__PURE__ */ E(on, {});
  const i = Wl({
    content: e,
    trimTrailingSpaces: n,
    contentRenderingInformation: t
  });
  return /* @__PURE__ */ E(
    r,
    {
      ...u,
      dangerouslySetInnerHTML: { __html: i }
    }
  );
};
var Re = Te, Ae = xC, lu = function() {
  return lu = Object.assign || function(e) {
    for (var t, n = 1, r = arguments.length; n < r; n++) {
      t = arguments[n];
      for (var u in t)
        Object.prototype.hasOwnProperty.call(t, u) && (e[u] = t[u]);
    }
    return e;
  }, lu.apply(this, arguments);
};
function Lw(e, t) {
  return Re.isValidElement(e) && e.key === null ? Re.cloneElement(e, { key: t }) : e;
}
function Dw(e, t) {
  return e.map(function(n, r) {
    return Lw(W2(n, t), r);
  });
}
function W2(e, t) {
  var n = t.renderNode, r = t.renderMark, u = t.renderText, i = t.preserveWhitespace;
  if (Ae.helpers.isText(e)) {
    var a = u ? u(e.value) : e.value;
    if (i && !u) {
      a = a.replace(/ {2,}/g, function(l) {
        return " ".repeat(l.length);
      });
      var o = a.split(`
`), s = [];
      o.forEach(function(l, d) {
        s.push(l), d !== o.length - 1 && s.push(Re.createElement("br", null));
      }), a = s;
    }
    return e.marks.reduce(function(l, d) {
      return r[d.type] ? r[d.type](l) : l;
    }, a);
  } else {
    var c = Dw(e.content, t);
    return !e.nodeType || !n[e.nodeType] ? Re.createElement(Re.Fragment, null, c) : n[e.nodeType](e, c);
  }
}
var We, Fn, Nw = (We = {}, We[Ae.BLOCKS.DOCUMENT] = function(e, t) {
  return t;
}, We[Ae.BLOCKS.PARAGRAPH] = function(e, t) {
  return Re.createElement("p", null, t);
}, We[Ae.BLOCKS.HEADING_1] = function(e, t) {
  return Re.createElement("h1", null, t);
}, We[Ae.BLOCKS.HEADING_2] = function(e, t) {
  return Re.createElement("h2", null, t);
}, We[Ae.BLOCKS.HEADING_3] = function(e, t) {
  return Re.createElement("h3", null, t);
}, We[Ae.BLOCKS.HEADING_4] = function(e, t) {
  return Re.createElement("h4", null, t);
}, We[Ae.BLOCKS.HEADING_5] = function(e, t) {
  return Re.createElement("h5", null, t);
}, We[Ae.BLOCKS.HEADING_6] = function(e, t) {
  return Re.createElement("h6", null, t);
}, We[Ae.BLOCKS.EMBEDDED_ENTRY] = function(e, t) {
  return Re.createElement("div", null, t);
}, We[Ae.BLOCKS.EMBEDDED_RESOURCE] = function(e, t) {
  return Re.createElement("div", null, t);
}, We[Ae.BLOCKS.UL_LIST] = function(e, t) {
  return Re.createElement("ul", null, t);
}, We[Ae.BLOCKS.OL_LIST] = function(e, t) {
  return Re.createElement("ol", null, t);
}, We[Ae.BLOCKS.LIST_ITEM] = function(e, t) {
  return Re.createElement("li", null, t);
}, We[Ae.BLOCKS.QUOTE] = function(e, t) {
  return Re.createElement("blockquote", null, t);
}, We[Ae.BLOCKS.HR] = function() {
  return Re.createElement("hr", null);
}, We[Ae.BLOCKS.TABLE] = function(e, t) {
  return Re.createElement(
    "table",
    null,
    Re.createElement("tbody", null, t)
  );
}, We[Ae.BLOCKS.TABLE_ROW] = function(e, t) {
  return Re.createElement("tr", null, t);
}, We[Ae.BLOCKS.TABLE_HEADER_CELL] = function(e, t) {
  return Re.createElement("th", null, t);
}, We[Ae.BLOCKS.TABLE_CELL] = function(e, t) {
  return Re.createElement("td", null, t);
}, We[Ae.INLINES.ASSET_HYPERLINK] = function(e) {
  return Ls(Ae.INLINES.ASSET_HYPERLINK, e);
}, We[Ae.INLINES.ENTRY_HYPERLINK] = function(e) {
  return Ls(Ae.INLINES.ENTRY_HYPERLINK, e);
}, We[Ae.INLINES.RESOURCE_HYPERLINK] = function(e) {
  return Vf(Ae.INLINES.RESOURCE_HYPERLINK, e);
}, We[Ae.INLINES.EMBEDDED_ENTRY] = function(e) {
  return Ls(Ae.INLINES.EMBEDDED_ENTRY, e);
}, We[Ae.INLINES.EMBEDDED_RESOURCE] = function(e, t) {
  return Vf(Ae.INLINES.EMBEDDED_RESOURCE, e);
}, We[Ae.INLINES.HYPERLINK] = function(e, t) {
  return Re.createElement("a", { href: e.data.uri }, t);
}, We), Ow = (Fn = {}, Fn[Ae.MARKS.BOLD] = function(e) {
  return Re.createElement("b", null, e);
}, Fn[Ae.MARKS.ITALIC] = function(e) {
  return Re.createElement("i", null, e);
}, Fn[Ae.MARKS.UNDERLINE] = function(e) {
  return Re.createElement("u", null, e);
}, Fn[Ae.MARKS.CODE] = function(e) {
  return Re.createElement("code", null, e);
}, Fn[Ae.MARKS.SUPERSCRIPT] = function(e) {
  return Re.createElement("sup", null, e);
}, Fn[Ae.MARKS.SUBSCRIPT] = function(e) {
  return Re.createElement("sub", null, e);
}, Fn[Ae.MARKS.STRIKETHROUGH] = function(e) {
  return Re.createElement("s", null, e);
}, Fn);
function Ls(e, t) {
  return Re.createElement(
    "span",
    { key: t.data.target.sys.id },
    "type: ",
    t.nodeType,
    " id: ",
    t.data.target.sys.id
  );
}
function Vf(e, t) {
  return Re.createElement(
    "span",
    { key: t.data.target.sys.urn },
    "type: ",
    t.nodeType,
    " urn: ",
    t.data.target.sys.urn
  );
}
function Iw(e, t) {
  return t === void 0 && (t = {}), e ? W2(e, {
    renderNode: lu(lu({}, Nw), t.renderNode),
    renderMark: lu(lu({}, Ow), t.renderMark),
    renderText: t.renderText,
    preserveWhitespace: t.preserveWhitespace
  }) : null;
}
var Mw = Iw;
const Pw = ({
  childArray: e
}) => {
  const t = [];
  let n = [];
  return e.forEach((r, u) => {
    const i = typeof r == "string" && r.includes(Ci), a = u === e.length - 1;
    i ? r.split(Ci).forEach((o, s) => {
      o === "" && n.length > 0 ? (t.push(n), n = []) : (n.length > 0 && s !== 0 && (t.push(n), n = []), o !== "" && n.push(o));
    }) : n.push(r), a && n.length > 0 && t.push(n);
  }), t;
}, Rc = ({
  typeToRender: e,
  htmlContent: t,
  enableNewLineSplit: n = !1,
  props: r = {}
}) => t ? (n && t.includes(Ci) ? t.split(Ci).filter(Boolean) : [t]).map((u) => fo(e ?? "p", {
  ...r,
  dangerouslySetInnerHTML: {
    __html: u
  }
})) : null, Rw = ({
  childArray: e,
  typeToRender: t,
  props: n = {}
}) => Pw({ childArray: e }).map((r) => {
  if (r.length === 1 && typeof r[0] == "string")
    return Rc({
      typeToRender: t,
      htmlContent: r[0],
      props: n
    });
  const u = Ou.map(r, (i) => typeof i == "string" ? Rc({
    typeToRender: "span",
    htmlContent: i,
    props: {}
  }) : i);
  return fo(t, n, u);
}), Bw = ({
  childArray: e,
  typeToRender: t,
  props: n = {}
}) => {
  let r = e[0];
  if (e.length > 1) {
    const u = e.join("");
    r = Wl({
      content: u,
      contentRenderingInformation: {}
    });
  }
  return Rc({
    typeToRender: t,
    htmlContent: r,
    props: n,
    enableNewLineSplit: !0
  });
}, Fw = ({ props: e = {}, typeToRender: t } = {}) => (n, r) => {
  const u = t ?? "p", i = Ou.toArray(r);
  return i.every(
    (a) => typeof a == "string"
  ) ? Bw({
    typeToRender: u,
    childArray: i,
    props: e
  }) : Rw({
    childArray: i,
    typeToRender: u,
    props: e
  });
}, K2 = (e) => {
  let t = "";
  return Ou.forEach(e, (n) => {
    typeof n == "string" || typeof n == "number" ? t += n : n !== null && typeof n == "object" && "props" in n && (t += K2(n.props.children));
  }), t;
}, Hw = (e) => (t, n) => {
  if (!n)
    return /* @__PURE__ */ E(on, {});
  if (t === "data-nosnippet")
    return /* @__PURE__ */ E("span", { "data-nosnippet": "true", children: n });
  const {
    processAnchorTagAttributes: r,
    ...u
  } = e || {}, i = K2(n);
  let a = {
    href: t
  };
  return typeof r == "function" && (a = r(
    u,
    t,
    i
  )), fo("a", a, n);
};
var Y2 = /* @__PURE__ */ ((e) => (e.cvDataPoint = "cvDataPoint", e.cvPricingToken = "cvPricingToken", e.cvAmplitudeLink = "cvAmplitudeLink", e))(Y2 || {});
const Ds = {
  cvDataPoint: "datapoint",
  cvPricingToken: "feeDataKey",
  cvAmplitudeLink: [
    "text",
    "url",
    "clickEventName",
    "target"
    /* target */
  ]
}, $w = ({ text: e, url: t, clickEventName: n, target: r }, u) => {
  if (!t)
    return "";
  let i = {
    href: t
  };
  const { processAnchorTagAttributes: a, ...o } = u || {};
  if (typeof a == "function") {
    const { className: s, ...c } = a(
      {
        ...o,
        // Custom click event name to be considered for our `data-pa-click` attribute
        clickEvent: n
      },
      t,
      e
    );
    i = {
      ...c,
      class: s
    };
  }
  return r && (i.target = r), `<a${Pc(i)}>${e}</a>`;
}, Z2 = (e, t) => t ? e.data.target.fields[t] ?? "" : "", Vw = (e, t, n) => {
  switch (e) {
    case Y2.cvAmplitudeLink:
      return $w(t, n);
    default:
      return "";
  }
}, jw = (e, t) => {
  const n = {};
  return t.forEach((r) => {
    const u = Z2(e, r);
    n[r] = u;
  }), n;
}, zw = (e, t) => {
  var n, r, u, i, a;
  const o = (a = (i = (u = (r = (n = e == null ? void 0 : e.data) == null ? void 0 : n.target) == null ? void 0 : r.sys) == null ? void 0 : u.contentType) == null ? void 0 : i.sys) == null ? void 0 : a.id;
  if (!o)
    return "";
  if (Array.isArray(Ds[o])) {
    const c = Ds[o], l = jw(e, c);
    return Vw(o, l, t);
  }
  const s = Ds[o];
  return Z2(e, s);
}, Uw = (e = {}) => (t) => {
  const n = zw(t, e);
  return typeof n == "string" ? n : "";
}, qw = (e, t) => {
  const n = Fw(e == null ? void 0 : e.p), r = Uw(e == null ? void 0 : e.a), u = {
    [Ze.INLINES.EMBEDDED_ENTRY]: r,
    // This is the reference to the default implementation of Hyperlink's RenderNode fn:
    // https://github.com/contentful/rich-text/blob/c6b5fe1e2c0b127026346da8df48684aeffc5147/packages/rich-text-react-renderer/src/index.tsx#L38
    [Ze.INLINES.HYPERLINK]: (i, a) => Hw(e == null ? void 0 : e.a)(
      i.data.uri,
      a
    ),
    [Ze.BLOCKS.PARAGRAPH]: n,
    [Ze.BLOCKS.LIST_ITEM]: (i, a) => {
      const o = Ou.toArray(a)[0].props, { children: s, dangerouslySetInnerHTML: c } = o;
      if (typeof (t == null ? void 0 : t.li) == "function") {
        const l = {
          children: s,
          dangerouslySetInnerHTML: c
        };
        return t.li(i, l);
      }
      return /* @__PURE__ */ E("li", { dangerouslySetInnerHTML: c, children: s });
    }
  };
  return typeof (t == null ? void 0 : t.a) == "function" && (u[Ze.INLINES.HYPERLINK] = (i, a) => {
    var o;
    return (o = t.a) == null ? void 0 : o.call(t, i, { children: a });
  }), typeof (t == null ? void 0 : t.ol) == "function" && (u[Ze.BLOCKS.OL_LIST] = (i, a) => {
    var o;
    return (o = t.ol) == null ? void 0 : o.call(t, i, { children: a });
  }), typeof (t == null ? void 0 : t.ul) == "function" && (u[Ze.BLOCKS.UL_LIST] = (i, a) => {
    var o;
    return (o = t.ul) == null ? void 0 : o.call(t, i, { children: a });
  }), u;
}, Gw = (e) => {
  const t = (r) => (u) => typeof u == "string" && u.trim().length === 0 ? u : r(u), n = {
    [Ze.MARKS.BOLD]: t((r) => /* @__PURE__ */ E("b", { children: r })),
    [Ze.MARKS.ITALIC]: t((r) => /* @__PURE__ */ E("i", { children: r })),
    [Ze.MARKS.UNDERLINE]: t((r) => /* @__PURE__ */ E("u", { children: r })),
    [Ze.MARKS.CODE]: t((r) => /* @__PURE__ */ E("code", { children: r })),
    [Ze.MARKS.SUPERSCRIPT]: t((r) => /* @__PURE__ */ E("sup", { children: r })),
    [Ze.MARKS.SUBSCRIPT]: t((r) => /* @__PURE__ */ E("sub", { children: r })),
    [Ze.MARKS.STRIKETHROUGH]: t((r) => /* @__PURE__ */ E("s", { children: r }))
  };
  return typeof (e == null ? void 0 : e.b) == "function" && (n[Ze.MARKS.BOLD] = e.b), typeof (e == null ? void 0 : e.i) == "function" && (n[Ze.MARKS.ITALIC] = e.i), typeof (e == null ? void 0 : e.u) == "function" && (n[Ze.MARKS.UNDERLINE] = e.u), n;
}, Ww = ({
  content: e,
  htmlOverrides: t,
  contentRenderingInformation: n
}) => Mw(e, {
  renderNode: qw(
    n,
    t
  ),
  renderMark: Gw(t),
  renderText: (r) => typeof (t == null ? void 0 : t.text) == "function" ? t.text(r) : Wl({
    content: r,
    useNewLinePlaceholder: !0,
    contentRenderingInformation: {
      a: n == null ? void 0 : n.a
      // Not providing paragraph rendering info since that's handled by
      // BLOCKS.PARAGRAPH node render function above
    }
  })
}), X2 = Te.createContext({
  baseURI: "",
  pageSegment: "",
  initialViewport: "lg"
}), Kw = "KitUtilsProvider", Q2 = ({
  children: e,
  value: t
}) => /* @__PURE__ */ E(X2.Provider, { value: t, children: e }), Kl = () => ke(X2);
Q2.displayName = Kw;
const jf = ({ as: e, className: t, customWrapper: n }) => {
  const r = {};
  let u = e || "p";
  return typeof n == "function" && (u = n, e && (r.as = e)), t && (r.className = t), {
    typeToRender: u,
    props: r
  };
}, Yw = (e = "") => e.replace(/\s/g, "").toLocaleLowerCase(), Ns = (e, t) => {
  const n = Yw(t);
  return `${e}_${n}_clicked`;
}, Zw = (e, t, n) => `${e}-Link-${n}-${t}`, Xw = (e, t, n) => `${e}-Button-${n}-${t}`, Qw = (e, t, n, r) => r ? `${e}-${n || "cta"}-${r}` : `${e}-${n || "cta"}-${t}`, Jw = ({
  componentName: e = "",
  linkSection: t = "Paragraph",
  linkText: n = "",
  linkType: r = "Primary",
  ariaLabel: u = "",
  clickEvent: i,
  mid: a
}, o = "ppcom", s = "CTA") => {
  const c = {};
  switch (a && (c.mid = a), s) {
    case "CTA": {
      const l = i ?? "Button_CTA";
      c.link = Qw(e, n, r, u), c.event_name = Ns(o, l);
      break;
    }
    case "Link": {
      const l = i ?? "Text_Link";
      c.link = Zw(e, n, t), c.event_name = Ns(o, l);
      break;
    }
    default: {
      const l = i ?? "Button";
      c.link = Xw(e, n, t), c.event_name = Ns(o, l);
      break;
    }
  }
  return JSON.stringify(c);
}, eT = (e) => e.charAt(0) === "/", tT = (e, t, n) => {
  const r = [
    /\/bizsignup(\/?)/,
    /\/brc(\/?)/,
    /\/business(\/?)/,
    /\/digital-wallet(\/?)/,
    /\/security(\/?)/,
    /\/enterprise(\/?)/,
    /\/for-you(\/?)/,
    /\/non-profit(\/?)/,
    /\/smarthelp(\/?)/,
    /\/fastlane(\/?)/,
    /webapps\/mpp/
  ];
  let u = t;
  return n && r.some((i) => i.test(e)) && (u += `/${n.toLowerCase()}`), u += e, u;
}, nT = (e, t = "", n = "") => eT(e) && t ? tT(e, t, n) : e, J2 = "_self", Bc = "_blank", rT = [J2, Bc], uT = ["paypal.com", "pypl.com", "paypal-corp.com", "concertocard.com/application/paypal"], iT = (e) => e.startsWith("#") || e.startsWith("/") ? !0 : uT.some((t) => e.includes(t)), aT = ({ target: e = "", href: t = "#", ...n }, r, u) => {
  const i = {
    ...n,
    href: nT(t, r, u),
    target: e
  };
  return e && rT.includes(e) || (i.target = iT(t) ? J2 : Bc), i.target === Bc && (i.rel = "noopener noreferrer"), i;
}, oT = (e, t, n = "", r = "") => {
  const {
    analyticsCompName: u = "",
    analyticsTextSection: i = "Paragraph",
    className: a,
    kitUtilsContext: o,
    // This is only provided when we resolve our anchor tag out of a cvAmplitudeLink token
    clickEvent: s
  } = e || {}, { pageSegment: c = "", locality: l, baseURI: d = "" } = o || {}, f = {
    href: t,
    // Only adding this attribute when provided
    ...r && { title: r }
  }, p = aT(f, d, l == null ? void 0 : l.country), h = Jw(
    {
      linkText: n,
      componentName: u,
      linkSection: i,
      clickEvent: s
    },
    c,
    "Link"
  );
  return {
    ...p,
    className: U("html-text-renderer-link", a),
    "data-pa-click": h
  };
}, sT = "ContentRenderer", ev = ({
  content: e,
  as: t,
  className: n,
  customWrapper: r,
  htmlOverrides: u,
  analyticsCompName: i,
  analyticsTextSection: a = "Paragraph",
  processAnchorTagAttributes: o = oT
}) => {
  const s = Kl();
  if (!e)
    return /* @__PURE__ */ E(on, {});
  const c = {
    analyticsCompName: i,
    analyticsTextSection: a,
    className: n,
    processAnchorTagAttributes: o,
    kitUtilsContext: s
  };
  if (typeof e == "object")
    return Ww({
      content: e,
      contentRenderingInformation: {
        a: c,
        p: jf({
          as: t,
          className: n,
          customWrapper: r
        })
      },
      htmlOverrides: u
    });
  const { typeToRender: l, props: d } = jf({
    as: t,
    className: n,
    customWrapper: r
  });
  return /* @__PURE__ */ E(
    kw,
    {
      content: e,
      contentRenderingInformation: {
        a: c
        // We don't pass any paragraph ('p') rendering information since we
        //  don't want to add any any wrapping tag for our paragraph elements
      },
      customWrapper: l,
      props: d
    }
  );
};
ev.displayName = sT;
let Pu = class {
  constructor(t, n) {
    Df(this, "componentName"), Df(this, "styles"), this.componentName = Cn(t), this.styles = n;
  }
  getFinalClassName(t) {
    return this.styles ? this.styles[t] || `_${t}_` : t;
  }
  /**
   * @returns The formatted class name of the component
   &&
   *  @example
   *  classNameGen.getElementClassName();
   *  // "hero"
   *
   *  @example
   *  classNameGen.getElementClassName();
   *  // "_hero_1xr4a_1" -> When CSS Module `styles` object was used.
   *
   */
  getComponentClassName() {
    return this.getFinalClassName(this.componentName);
  }
  /**
   * @param elementName - The name of the element you want to style
   * @returns A formatted class name base on the provided element name
   *
   *  @example
   *  classNameGen.getElementClassName('content-col');
   *  // "hero-content-col"
   *
   *  @example
   *  classNameGen.getElementClassName('content-col');
   *  // "_hero-content-col_1xr4a_1" -> When CSS Module `styles` object was used.
   */
  getElementClassName(t) {
    const n = Cn(t), r = `${this.componentName}-${n}`;
    return this.getFinalClassName(r);
  }
  /**
   * @param propsKey - The name of your component prop
   * @param propsValue - The value of your component prop
   * @returns A formatted class name based on the provided prop value
   *
   *  @example
   *  classNameGen.getPropsValueClassName('itemsAlignment', 'Vertical-Center');
   *  // "hero-items-alignment-vertical-center"
   *
   *  @example
   *  classNameGen.getPropsValueClassName('itemsAlignment', 'Vertical-Center');
   *  // "_hero-items-alignment-vertical-center_1xr4a_1" -> When CSS Module `styles` object was used.
   */
  getPropsValueClassName(t, n) {
    const r = Cn(t), u = typeof n == "string", i = typeof n == "boolean", a = u || i;
    let o = "";
    if (!a)
      o = `${this.componentName}-${r}`;
    else if (i)
      o = n ? `${this.componentName}-${r}` : `${this.componentName}-no-${r}`;
    else {
      const s = Cn(n);
      o = `${this.componentName}-${r}-${s}`;
    }
    return this.getFinalClassName(o);
  }
};
const cT = {
  "0.25rem": "fixed-xs",
  "0.375rem": "fixed-sm",
  "0.5rem": "fixed-md",
  "0.75rem": "fixed-lg",
  "1rem": "fixed-xl",
  "1.5rem": "fixed-2xl",
  "2rem": "fixed-3xl",
  "3rem": "fixed-4xl",
  "4.5rem": "fixed-5xl"
}, lT = {
  "2vw": "fluid-sm",
  "4vw": "fluid-md",
  "6vw": "fluid-lg",
  "8vw": "fluid-xl",
  "12vw": "fluid-2xl",
  "16vw": "fluid-3xl"
}, dT = {
  ...cT,
  ...lT,
  none: "0"
}, tv = {
  bottomSpacing: "pb",
  topSpacing: "pt"
}, Ei = ({
  optionValue: e
}) => dT[e], nv = {
  bottomSpacing: {
    transformType: "direct",
    transformFunction: Ei
  },
  topSpacing: {
    transformType: "direct",
    transformFunction: Ei
  }
}, fT = (e, t) => t === "sm" ? e : e.map((n) => `${t}:${n}`), rv = ({
  gridSystemOptionPrefixMap: e,
  gridSystemOptionValueTransformMap: t
}) => {
  const n = ({
    gridSystemOptions: r,
    breakpoint: u
  }) => {
    const i = [];
    return Object.entries(r).forEach(([a, o]) => {
      const s = e[a], c = t[a];
      if (!s || !c)
        return;
      const { transformType: l, transformFunction: d } = c, f = d(l === "direct" ? {
        optionValue: o
      } : {
        optionValue: o,
        options: r,
        breakpoint: u
      });
      f && i.push(
        `${s}-${f}`
      );
    }), i;
  };
  return {
    getGridSystemResponsiveClasses: (r) => r.reduce(
      (u, i) => {
        const { options: a, breakpoint: o } = i, s = n({
          gridSystemOptions: a,
          breakpoint: o
        });
        return s.length && u.push(
          ...fT(s, o)
        ), u;
      },
      []
    )
  };
}, pT = {
  ...tv,
  bottomMargin: "mb",
  topMargin: "mt",
  rowsGap: "gap"
}, hT = ({ optionValue: e, options: t = {} }) => {
  if (e === "default")
    return "default";
  const n = t.rowsGapValue || "none";
  return Ei({ optionValue: n });
}, mT = {
  ...nv,
  bottomMargin: {
    transformType: "direct",
    transformFunction: Ei
  },
  topMargin: {
    transformType: "direct",
    transformFunction: Ei
  },
  rowsGap: {
    transformType: "custom",
    transformFunction: hT
  }
}, { getGridSystemResponsiveClasses: gT } = (
  // @ts-expect-error - We need to fix this error
  rv({
    gridSystemOptionPrefixMap: pT,
    gridSystemOptionValueTransformMap: mT
  })
), bT = "_grid_a3awa_4", vT = {
  grid: bT
}, uv = "Grid", yT = new Pu(uv, vT), xT = at(
  ({
    className: e,
    children: t,
    as: n = "section",
    options: r = {},
    mdOptions: u = {},
    lgOptions: i = {},
    xlOptions: a = {},
    twoXlOptions: o = {},
    ...s
  }, c) => {
    const l = gT([
      { options: r, breakpoint: "sm" },
      { options: u, breakpoint: "md" },
      { options: i, breakpoint: "lg" },
      { options: a, breakpoint: "xl" },
      { options: o, breakpoint: "2xl" }
    ]), d = U(
      e,
      yT.getComponentClassName(),
      l
    );
    return /* @__PURE__ */ E(n, { ref: c, className: d, ...s, children: t });
  }
);
xT.displayName = uv;
const iv = {
  auto: "auto",
  /* The first 3 Column Lines of the Grid */
  "left-edge": "l-edge",
  // 1
  "left-outer": "l-outer",
  // 2
  "left-inner": "l-inner",
  // 3
  /* The Last 3 Column Lines of the Grid */
  "right-inner": "r-inner",
  // -3
  "right-outer": "r-outer",
  // -2
  "right-edge": "r-edge"
  // -1
}, av = {
  "inner-1": "3",
  "inner-2": "4",
  "inner-3": "5",
  "inner-4": "6",
  "inner-5": "7"
}, _T = {
  ...av,
  "inner-6": "8",
  "inner-7": "9",
  "inner-8": "10",
  "inner-9": "11",
  "inner-10": "12",
  "inner-11": "13",
  "inner-12": "14",
  "inner-13": "15"
}, zf = {
  ...iv,
  ...av
}, Os = {
  ...iv,
  ..._T
}, ST = {
  sm: zf,
  md: zf,
  lg: Os,
  xl: Os,
  "2xl": Os
}, CT = {
  ...tv,
  rowStart: "row-start",
  rowEnd: "row-end",
  verticalAlign: "align",
  columnStart: "col-start",
  columnEnd: "col-end",
  display: "d",
  zIndex: "z"
}, Gu = ({
  optionValue: e
}) => {
  if (typeof e == "string")
    return e;
  if (typeof e == "number")
    return String(e);
}, Uf = ({ optionValue: e, breakpoint: t }) => {
  const n = ST[t];
  if (n)
    return n[e];
}, ET = {
  ...nv,
  rowStart: {
    transformType: "direct",
    transformFunction: Gu
  },
  rowEnd: {
    transformType: "direct",
    transformFunction: Gu
  },
  verticalAlign: {
    transformType: "direct",
    transformFunction: Gu
  },
  columnStart: {
    transformType: "custom",
    transformFunction: Uf
  },
  columnEnd: {
    transformType: "custom",
    transformFunction: Uf
  },
  display: {
    transformType: "direct",
    transformFunction: Gu
  },
  zIndex: {
    transformType: "direct",
    transformFunction: Gu
  }
}, { getGridSystemResponsiveClasses: wT } = rv({
  gridSystemOptionPrefixMap: CT,
  gridSystemOptionValueTransformMap: ET
}), TT = {
  "grid-item": "_grid-item_u5yv6_1"
}, ov = "GridItem", AT = new Pu(ov, TT), kT = at(
  ({
    as: e = "div",
    className: t = "",
    options: n = {},
    mdOptions: r = {},
    lgOptions: u = {},
    xlOptions: i = {},
    twoXlOptions: a = {},
    children: o = null,
    ...s
  }, c) => {
    const l = wT([
      {
        options: n,
        breakpoint: "sm"
      },
      { options: r, breakpoint: "md" },
      { options: u, breakpoint: "lg" },
      { options: i, breakpoint: "xl" },
      { options: a, breakpoint: "2xl" }
    ]), d = U(
      t,
      AT.getComponentClassName(),
      l
    );
    return /* @__PURE__ */ E(e, { ref: c, className: d, ...s, children: o });
  }
);
kT.displayName = ov;
const LT = {
  minHeight: "18.75rem",
  minWidth: "auto"
}, DT = ({
  rootMargin: e = "700px 0px"
}) => ({
  rootMargin: e,
  triggerOnce: !0,
  threshold: 0
}), NT = ({
  children: e,
  className: t,
  containerDimensions: n = LT,
  rootRef: r,
  rootMargin: u
}) => {
  const { inView: i, ref: a } = zi(
    DT({ rootMargin: u })
  ), o = Ct(
    (s) => {
      const c = r && "current" in r;
      typeof r == "function" ? r(s) : c && (r.current = s), a(s);
    },
    [a, r]
  );
  return /* @__PURE__ */ E("div", { ref: o, className: t, style: n, children: i && e });
};
var sv = /* @__PURE__ */ ((e) => (e.enterprise = "enterprise", e.ppcom = "ppcom", e.smb = "smb", e))(sv || {});
const OT = (e = "", t = "", n = "", r = "Started", u = sv.ppcom) => {
  const i = {
    event_name: `${u}_${t}_${r.toLowerCase()}`,
    link: `${e}-${t}-${r}-${n}`
  };
  return JSON.stringify(i);
}, IT = {
  "media-control-wrapper": "_media-control-wrapper_yows9_1",
  "media-control-wrapper-outline": "_media-control-wrapper-outline_yows9_16",
  "media-control-wrapper-inverse": "_media-control-wrapper-inverse_yows9_19",
  "media-control-wrapper-size-small": "_media-control-wrapper-size-small_yows9_22",
  "media-control-play-svg-small": "_media-control-play-svg-small_yows9_23",
  "media-control-wrapper-size-large": "_media-control-wrapper-size-large_yows9_27",
  "media-control-play-svg-large": "_media-control-play-svg-large_yows9_28",
  "media-control-wrapper-size-x-large": "_media-control-wrapper-size-x-large_yows9_32",
  "media-control-play-svg-x-large": "_media-control-play-svg-x-large_yows9_33",
  "media-control-play-svg": "_media-control-play-svg_yows9_23",
  "media-control-circle": "_media-control-circle_yows9_40",
  "media-control-circle-inverse": "_media-control-circle-inverse_yows9_43",
  "media-control-triangle-inverse": "_media-control-triangle-inverse_yows9_55",
  "media-control-play-svg-outline-inverse": "_media-control-play-svg-outline-inverse_yows9_58",
  "media-control-play-svg-outline": "_media-control-play-svg-outline_yows9_58"
}, cv = "MediaControl", st = new Pu(cv, IT), lv = at(
  ({
    className: e,
    playing: t,
    size: n = "Large",
    inverse: r = !1,
    outline: u = !1,
    videoId: i = "",
    analyticsCompName: a,
    analyticsVideoText: o = "video",
    playAriaLabel: s = "Play video",
    pauseAriaLabel: c = "Pause video",
    hasAriaPopup: l = !1,
    mediaClick: d
  }, f) => {
    const { pageSegment: p } = Kl(), h = t ? c : s, m = t ? "Started" : "Stopped", b = r && u, x = OT(
      a ? `${a}-media` : "media",
      o,
      i,
      m,
      p
    ), y = U(
      e,
      st.getComponentClassName(),
      st.getElementClassName("wrapper"),
      {
        [st.getElementClassName("wrapper-inverse")]: r,
        [st.getElementClassName("wrapper-outline")]: u
      },
      st.getPropsValueClassName("wrapperSize", n)
    ), g = () => {
      const A = U(
        st.getElementClassName("play-svg"),
        st.getPropsValueClassName("playSvg", n)
      ), k = U(st.getElementClassName("circle"), {
        [st.getElementClassName("circle-inverse")]: r
      }), T = U({
        [st.getElementClassName("triangle-inverse")]: r
      });
      return /* @__PURE__ */ ue(
        "svg",
        {
          className: A,
          viewBox: "0 0 80 81",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg",
          children: [
            /* @__PURE__ */ E(
              "path",
              {
                className: k,
                d: "M0 40.5122C0 18.4208 17.9086 0.512207 40 0.512207V0.512207C62.0914 0.512207 80 18.4208 80 40.5122V40.5122C80 62.6036 62.0914 80.5122 40 80.5122V80.5122C17.9086 80.5122 0 62.6036 0 40.5122V40.5122Z",
                fill: "#003087"
              }
            ),
            /* @__PURE__ */ E(
              "path",
              {
                className: T,
                d: "M29.3164 50.4622V32.1643C29.3164 28.8916 32.9162 26.8965 35.6914 28.631L50.3297 37.7799C52.9409 39.4119 52.9409 43.2146 50.3297 44.8466L35.6914 53.9955C32.9162 55.73 29.3164 53.7349 29.3164 50.4622Z",
                fill: "white"
              }
            )
          ]
        }
      );
    }, v = () => {
      const A = U(
        st.getElementClassName("play-svg"),
        st.getPropsValueClassName("playSvg", n)
      ), k = U(st.getElementClassName("circle"), {
        [st.getElementClassName("circle-inverse")]: r
      }), T = U({
        [st.getElementClassName("triangle-inverse")]: r
      });
      return /* @__PURE__ */ ue(
        "svg",
        {
          className: A,
          viewBox: "0 0 80 81",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg",
          children: [
            /* @__PURE__ */ E(
              "path",
              {
                className: k,
                d: "M0 40.5122C0 18.4208 17.9086 0.512207 40 0.512207C62.0914 0.512207 80 18.4208 80 40.5122C80 62.6036 62.0914 80.5122 40 80.5122C17.9086 80.5122 0 62.6036 0 40.5122Z",
                fill: "#003087"
              }
            ),
            /* @__PURE__ */ E(
              "path",
              {
                className: T,
                d: "M35.191 27.9797H35.5115C37.0161 27.9797 38.2359 29.1073 38.2359 30.4983V52.1279C38.2359 53.5188 37.0161 54.6464 35.5115 54.6464H35.191C33.6864 54.6464 32.4666 53.5188 32.4666 52.1279V30.4983C32.4666 29.1073 33.6864 27.9797 35.191 27.9797ZM46.0884 27.9797H46.4089C47.9136 27.9797 49.1333 29.1073 49.1333 30.4983V52.1279C49.1333 53.5188 47.9136 54.6464 46.4089 54.6464H46.0884C44.5838 54.6464 43.3641 53.5188 43.3641 52.1279V30.4983C43.3641 29.1073 44.5838 27.9797 46.0884 27.9797Z",
                fill: "white"
              }
            )
          ]
        }
      );
    }, S = t ? (() => {
      const A = U(
        st.getElementClassName("play-svg-outline"),
        {
          [st.getElementClassName("play-svg-outline-inverse")]: b
        },
        st.getPropsValueClassName("playSvg", n)
      );
      return /* @__PURE__ */ ue(
        "svg",
        {
          className: A,
          viewBox: "0 0 80 80",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg",
          children: [
            /* @__PURE__ */ E(
              "path",
              {
                d: "M35.191 27.4675H35.5115C37.0161 27.4675 38.2359 28.5951 38.2359 29.986V51.6157C38.2359 53.0066 37.0161 54.1342 35.5115 54.1342H35.191C33.6864 54.1342 32.4666 53.0066 32.4666 51.6157V29.986C32.4666 28.5951 33.6864 27.4675 35.191 27.4675ZM46.0884 27.4675H46.4089C47.9136 27.4675 49.1333 28.5951 49.1333 29.986V51.6157C49.1333 53.0066 47.9136 54.1342 46.4089 54.1342H46.0884C44.5838 54.1342 43.3641 53.0066 43.3641 51.6157V29.986C43.3641 28.5951 44.5838 27.4675 46.0884 27.4675Z",
                fill: "#001435"
              }
            ),
            /* @__PURE__ */ E(
              "path",
              {
                d: "M40 78C19.0132 78 2 60.9868 2 40H-2C-2 63.196 16.804 82 40 82V78ZM78 40C78 60.9868 60.9868 78 40 78V82C63.196 82 82 63.196 82 40H78ZM40 2C60.9868 2 78 19.0132 78 40H82C82 16.804 63.196 -2 40 -2V2ZM40 -2C16.804 -2 -2 16.804 -2 40H2C2 19.0132 19.0132 2 40 2V-2Z",
                fill: "#001435"
              }
            )
          ]
        }
      );
    })() : (() => {
      const A = U(
        st.getElementClassName("play-svg-outline"),
        {
          [st.getElementClassName("play-svg-outline-inverse")]: b
        },
        st.getPropsValueClassName("playSvg", n)
      );
      return /* @__PURE__ */ ue(
        "svg",
        {
          className: A,
          viewBox: "0 0 80 80",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg",
          children: [
            /* @__PURE__ */ E(
              "path",
              {
                d: "M40 78C19.0132 78 2 60.9868 2 40H-2C-2 63.196 16.804 82 40 82V78ZM78 40C78 60.9868 60.9868 78 40 78V82C63.196 82 82 63.196 82 40H78ZM40 2C60.9868 2 78 19.0132 78 40H82C82 16.804 63.196 -2 40 -2V2ZM40 -2C16.804 -2 -2 16.804 -2 40H2C2 19.0132 19.0132 2 40 2V-2Z",
                fill: "#001435"
              }
            ),
            /* @__PURE__ */ E(
              "path",
              {
                d: "M29.3164 49.95V31.6521C29.3164 28.3794 32.9162 26.3843 35.6914 28.1188L50.3297 37.2677C52.9409 38.8997 52.9409 42.7024 50.3297 44.3344L35.6914 53.4833C32.9162 55.2178 29.3164 53.2227 29.3164 49.95Z",
                fill: "#001435"
              }
            )
          ]
        }
      );
    })(), _ = t ? v() : g();
    return /* @__PURE__ */ E(
      "button",
      {
        ref: f,
        "aria-label": h,
        "aria-haspopup": l,
        type: "button",
        "data-pa-click": a && x,
        className: y,
        onClick: d,
        children: u ? S : _
      }
    );
  }
);
lv.displayName = cv;
const MT = () => {
  const [e, t] = me(!1), n = S2();
  return oe(() => {
    n !== null && t(n);
  }, [n]), e;
}, PT = (e = []) => e.map(({ src: t, type: n }) => /* @__PURE__ */ E("source", { src: t, type: n }, t)), RT = (e) => {
  var t;
  const n = (t = e[0]) == null ? void 0 : t.src;
  return n == null ? void 0 : n.substring(n.lastIndexOf("/") + 1).replace(/\..+$/, "");
}, BT = ({
  videoRef: e,
  setInlineVideoPlaying: t,
  setIsVideoDurationAvailable: n
}) => {
  const r = () => {
    e.current && (n(!1), t(!1), e.current.currentTime = 0, e.current.load());
  }, u = (d) => {
    e.current && (e.current.currentTime = d);
  }, i = () => {
    var d;
    return ((d = e.current) == null ? void 0 : d.currentTime) ?? 0;
  }, a = () => {
    var d;
    return ((d = e.current) == null ? void 0 : d.duration) ?? 0;
  }, o = () => {
    var d;
    return ((d = e.current) == null ? void 0 : d.readyState) ?? 0;
  }, s = () => {
    var d;
    return ((d = e.current) == null ? void 0 : d.seeking) ?? !1;
  }, c = async () => {
    e.current && (await e.current.play(), t(!0));
  }, l = () => {
    e.current && (e.current.pause(), t(!1));
  };
  return {
    playVideo: c,
    pauseVideo: l,
    setCurrentTime: u,
    getCurrentTime: i,
    getDuration: a,
    getReadyState: o,
    getIsSeeking: s,
    loadVideoAndResetState: r,
    handleInlineVideoState: (d) => {
      d === "play" ? c() : l();
    }
  };
}, FT = () => {
  if (typeof window > "u" || typeof window.navigator > "u")
    return !1;
  const { userAgent: e } = navigator, t = e.toLowerCase(), n = t.indexOf("safari") > -1, r = t.indexOf("chrome") > -1, u = /iPad|iPhone|iPod/i.test(e);
  return (n || u) && !r;
}, HT = () => {
  if (typeof window > "u" || typeof window.navigator > "u")
    return !1;
  const { userAgent: e } = navigator;
  return /firefox/i.test(e);
}, $T = ({
  autoPlay: e,
  forwardedVideoRef: t,
  isViewportTypeMismatch: n,
  hasMultipleVideoSources: r
}) => {
  const u = Z(null), i = Z(!1), a = Z(!1), o = MT(), [s, c] = me(!1), [l, d] = me(!1), f = u == null ? void 0 : u.current, p = (f == null ? void 0 : f.duration) || 0, h = p && p > 5, {
    playVideo: m,
    pauseVideo: b,
    setCurrentTime: x,
    getCurrentTime: y,
    getDuration: g,
    getReadyState: v,
    getIsSeeking: S,
    loadVideoAndResetState: _,
    handleInlineVideoState: A
  } = BT({
    videoRef: u,
    setInlineVideoPlaying: d,
    setIsVideoDurationAvailable: c
  });
  R4(
    t,
    () => ({
      playVideo: m,
      pauseVideo: b,
      setCurrentTime: x,
      getCurrentTime: y,
      getDuration: g,
      getReadyState: v,
      getIsSeeking: S
    }),
    [s]
  );
  const k = () => {
    a.current && !e && (m(), a.current = !1);
  }, T = Ct((L) => {
    L !== null && (u.current = L, L.duration && c(!0));
  }, []);
  return oe(() => {
    if (!i.current) {
      if (n === null)
        return;
      i.current = !0;
    }
    r && !FT() && _();
  }, [n, r]), oe(() => {
    s && (o && h || !e ? b() : m());
  }, [s, e]), {
    videoRef: u,
    videoLoadRef: T,
    isLargeDuration: h,
    handleInlineVideoState: A,
    inlineVideoPlaying: l,
    setInlineVideoPlaying: d,
    isVideoDurationAvailable: s,
    setIsVideoDurationAvailable: c,
    onVideoFullyLoaded: k
  };
}, Wu = {
  sm: "23.4375rem",
  md: "41.0625rem",
  lg: "64rem",
  xl: "91.875rem",
  "2xl": "120rem"
}, Ku = {
  xs: "23.375rem",
  sm: "41rem",
  md: "63.9375rem",
  lg: "91.8125rem",
  xl: "119.9375rem"
}, VT = ({
  mediaQueryTypeKeys: e,
  mediaQueryMap: t,
  setViewportTypeObj: n
}) => e.map((r) => [t[r], (u) => {
  u.matches && n((i) => ({
    ...i,
    viewportType: r
  }));
}]), jT = () => {
  const { initialViewport: e } = Kl(), [t, n] = me({
    viewportType: e || "sm",
    isViewportTypeMismatch: null
  });
  return oe(() => {
    const r = {
      xs: window.matchMedia(`(max-width: ${Ku.xs})`),
      sm: window.matchMedia(
        `(min-width: ${Wu.sm}) and (max-width: ${Ku.sm})`
      ),
      md: window.matchMedia(
        `(min-width: ${Wu.md}) and (max-width: ${Ku.md})`
      ),
      lg: window.matchMedia(
        `(min-width: ${Wu.lg}) and (max-width: ${Ku.lg})`
      ),
      xl: window.matchMedia(
        `(min-width: ${Wu.xl}) and (max-width: ${Ku.xl})`
      ),
      "2xl": window.matchMedia(`(min-width: ${Wu["2xl"]})`)
    }, u = Object.keys(r), i = VT({
      mediaQueryTypeKeys: u,
      mediaQueryMap: r,
      setViewportTypeObj: n
    });
    i.forEach(([s, c]) => {
      s.addEventListener ? s.addEventListener("change", c) : s.addListener(c);
    });
    const a = u.find((s) => r[s].matches), o = t.viewportType !== a;
    return n({
      viewportType: a || "sm",
      isViewportTypeMismatch: o
    }), () => {
      i.forEach(([s, c]) => {
        s.removeEventListener ? s.removeEventListener("change", c) : s.removeListener(c);
      });
    };
  }, []), t;
}, zT = (e) => {
  const t = [...e];
  if (HT()) {
    const n = t.findIndex(
      (r) => r.type === "video/webm"
    );
    if (n !== -1) {
      const r = t[n];
      t.splice(n, 1), t.unshift(r);
    }
  }
  return t;
}, UT = ({
  viewportType: e,
  baseVideoCollection: t,
  tabletVideoCollection: n,
  desktopVideoCollection: r,
  imageUrlBase: u,
  imageUrlTablet: i,
  imageUrlDesktop: a,
  altText: o
}) => {
  let s = [], c = "", l = "";
  if (!(n || t || r))
    return {
      videoSourceCollection: s,
      videoName: c
    };
  const d = ["xs", "sm"].includes(e), f = e === "md", p = (m) => m ?? "";
  d ? (s = t ?? [], l = p(u)) : f ? (s = n ?? t ?? [], l = p(i ?? u)) : (s = r ?? n ?? t ?? [], l = p(
    a ?? i ?? u
  )), c = RT(s);
  const h = zT(
    s
  );
  return {
    altTextLabel: o,
    videoSourceCollection: h.map((m) => ({
      ...m,
      src: `${m.src}#t=0.01`
    })),
    videoName: c,
    posterImageUrl: l
  };
}, qT = ({
  baseVideoCollection: e,
  tabletVideoCollection: t,
  desktopVideoCollection: n,
  imageUrlBase: r,
  imageUrlTablet: u,
  imageUrlDesktop: i,
  altText: a
}) => {
  const { viewportType: o, isViewportTypeMismatch: s } = jT();
  return {
    ...$e(
      () => UT({
        viewportType: o,
        baseVideoCollection: e,
        tabletVideoCollection: t,
        desktopVideoCollection: n,
        imageUrlBase: r,
        imageUrlTablet: u,
        imageUrlDesktop: i,
        altText: a
      }),
      [o]
    ),
    viewportType: o,
    isViewportTypeMismatch: s
  };
}, GT = {
  "inline-video": "_inline-video_8520u_1"
}, dv = "InlineVideo", WT = new Pu(dv, GT), fv = at(
  ({
    className: e,
    onEnded: t,
    onPlaying: n,
    onLoadedMetadata: r,
    onCanPlayThrough: u,
    autoPlay: i = !1,
    loop: a = !0,
    posterImageUrl: o,
    ariaLabel: s,
    quality: c = 75,
    disableRemotePlayback: l = !0,
    children: d,
    preload: f,
    ...p
  }, h) => {
    const m = U(e, WT.getComponentClassName()), b = {};
    return s && (b["aria-label"] = s), o && (b.poster = `${o}?quality=${c}`), /* @__PURE__ */ ue(
      "video",
      {
        className: m,
        playsInline: !0,
        muted: !0,
        onEnded: t,
        onPlaying: n,
        onLoadedMetadata: r,
        disableRemotePlayback: l,
        disablePictureInPicture: !0,
        ref: h,
        autoPlay: i,
        loop: a,
        preload: f,
        ...b,
        ...p,
        children: [
          d,
          /* @__PURE__ */ E("track", { kind: "captions" })
        ]
      }
    );
  }
);
fv.displayName = dv;
const KT = {
  "inline-video-overlay": "_inline-video-overlay_1slkw_1"
}, pv = "InlineVideoOverlay", YT = new Pu(pv, KT), hv = ({
  className: e
}) => {
  const t = U(e, YT.getComponentClassName());
  return /* @__PURE__ */ E("div", { className: t });
};
hv.displayName = pv;
const ZT = {
  "video-frame": "_video-frame_7p40v_1",
  "video-frame-rounded-corners": "_video-frame-rounded-corners_7p40v_4",
  "video-frame-wrapper": "_video-frame-wrapper_7p40v_4",
  "video-frame-hide": "_video-frame-hide_7p40v_24",
  "video-frame-show": "_video-frame-show_7p40v_27",
  "video-frame-controls-container": "_video-frame-controls-container_7p40v_30",
  "video-frame-video-duration": "_video-frame-video-duration_7p40v_33",
  "video-frame-wrapper-media-control-disable": "_video-frame-wrapper-media-control-disable_7p40v_53",
  "video-frame-main-controls-container": "_video-frame-main-controls-container_7p40v_72",
  "video-frame-body-text": "_video-frame-body-text_7p40v_84",
  "video-frame-button-text-inverse": "_video-frame-button-text-inverse_7p40v_89",
  "video-frame-youtube-video": "_video-frame-youtube-video_7p40v_92",
  "video-frame-video-md": "_video-frame-video-md_7p40v_102",
  "video-frame-video-base": "_video-frame-video-base_7p40v_106",
  "video-cursor-pointer": "_video-cursor-pointer_7p40v_135"
}, mv = "VideoFrame", du = new Pu(mv, ZT), qf = at(
  ({
    baseVideoCollection: e,
    // Mobile Video
    tabletVideoCollection: t,
    // Tablet Video
    desktopVideoCollection: n,
    // Desktop Video
    mediaControl: r,
    imageUrlDesktop: u,
    imageUrlTablet: i,
    imageUrlBase: a,
    altText: o,
    autoPlay: s = !1,
    loop: c = !1,
    inverse: l = !1,
    buttonStyle: d = "Outline",
    overlay: f = !1,
    imageServerKnobs: p = {},
    analyticsCompName: h,
    disableRemotePlayback: m = !0,
    disableMediaControl: b = !1,
    onLoadedMetadata: x,
    onPlaying: y,
    preload: g = "auto"
  }, v) => {
    var S;
    const _ = !!(t != null && t.length) || !!(n != null && n.length), {
      videoName: A,
      videoSourceCollection: k,
      altTextLabel: T,
      posterImageUrl: L,
      isViewportTypeMismatch: w
    } = qT({
      baseVideoCollection: e,
      tabletVideoCollection: t,
      desktopVideoCollection: n,
      imageUrlBase: a,
      imageUrlDesktop: u,
      imageUrlTablet: i,
      altText: o
    }), {
      videoLoadRef: D,
      inlineVideoPlaying: N,
      setInlineVideoPlaying: O,
      isLargeDuration: H,
      handleInlineVideoState: $,
      setIsVideoDurationAvailable: j
    } = $T({
      autoPlay: s,
      forwardedVideoRef: v,
      isViewportTypeMismatch: w,
      hasMultipleVideoSources: _
    }), z = !!n || !!t || !!e, { quality: M = 50 } = p, P = U(
      du.getElementClassName("controls-container"),
      {
        [du.getElementClassName("video-duration")]: H
      }
    ), C = $e(() => PT(k), [(S = k[0]) == null ? void 0 : S.src]);
    return /* @__PURE__ */ ue(
      "div",
      {
        className: U(
          du.getElementClassName("wrapper"),
          du.getPropsValueClassName(
            "wrapperMediaControlDisable",
            b
          )
        ),
        onClick: () => {
          $(N ? "pause" : "play");
        },
        role: "none",
        children: [
          f && /* @__PURE__ */ E(hv, {}),
          z && /* @__PURE__ */ E(
            fv,
            {
              ref: D,
              onEnded: () => O(!1),
              onPlaying: () => {
                O(!0), typeof y == "function" && y();
              },
              onLoadedMetadata: () => {
                j(!0), typeof x == "function" && x();
              },
              autoPlay: !1,
              posterImageUrl: L,
              loop: c,
              ariaLabel: T,
              disableRemotePlayback: m,
              preload: g,
              children: C
            }
          ),
          !z && /* @__PURE__ */ E(
            "img",
            {
              alt: T,
              src: L && `${L}?quality=${M}`
            }
          ),
          z && !b && /* @__PURE__ */ E("div", { className: P, children: /* @__PURE__ */ E(
            lv,
            {
              mediaClick: (R) => {
                R.stopPropagation(), $(N ? "pause" : "play");
              },
              videoId: A,
              size: "Small",
              inverse: l,
              playing: N,
              outline: d === "Outline",
              playAriaLabel: r == null ? void 0 : r.playAriaLabel,
              pauseAriaLabel: r == null ? void 0 : r.pauseAriaLabel,
              analyticsCompName: h
            }
          ) })
        ]
      }
    );
  }
), XT = at(
  ({
    loading: e = "lazy",
    dimensions: t = {
      minHeight: "auto",
      minWidth: "auto"
    },
    lazyLoadProps: n = {},
    className: r,
    roundedCorners: u = !1,
    ...i
  }, a) => {
    const o = U(
      r,
      du.getComponentClassName(),
      du.getPropsValueClassName("roundedCorners", u)
    );
    return e === "lazy" ? /* @__PURE__ */ E(
      NT,
      {
        className: o,
        containerDimensions: t,
        ...n,
        children: /* @__PURE__ */ E(qf, { ...i, ref: a })
      }
    ) : /* @__PURE__ */ E("div", { className: o, children: /* @__PURE__ */ E(qf, { ...i, ref: a }) });
  }
);
XT.displayName = mv;
const QT = () => {
  const e = Te.createContext({
    // @ts-expect-error - Setting "cmsEngineContext" as empty object to avoid runtime issues if <ComponentLibProvider> isn't present
    cmsEngineContext: {},
    componentKitContext: {}
  });
  return {
    useComponentKitContext: () => {
      const { componentKitContext: t } = ke(e);
      return t;
    },
    useCmsEngineContext: () => {
      const { cmsEngineContext: t } = ke(e);
      return t;
    },
    ComponentLibProvider: ({ children: t, ...n }) => /* @__PURE__ */ E(e.Provider, { value: n, children: t })
  };
}, { useComponentKitContext: DH, useCmsEngineContext: nt, ComponentLibProvider: JT } = QT(), NH = "Placement", Yl = Te.createContext({
  isAboveTheFold: !1
}), OH = ({
  children: e,
  ...t
}) => /* @__PURE__ */ E(Yl.Provider, { value: t, children: e }), hr = () => {
  const {
    environment: { reduceMotion: e = !1 } = {}
  } = nt(), [t, n] = me(
    e
  ), r = S2();
  return oe(() => {
    r !== null && n(e || r);
  }, [e, r]), t;
}, e9 = {
  xs: 0,
  sm: 1,
  md: 2,
  lg: 3,
  xl: 4
}, t9 = {
  Functional: {
    ease: [0.22, 1, 0.36, 1],
    multiplier: {
      stagger: 0.055,
      // seconds
      duration: 0.1,
      // seconds
      relativeMove: 5,
      fixedMove: 0.5,
      dropMove: 0.5,
      scale: 0.1,
      appear: 0.15
    }
  },
  Expressive: {
    ease: [0.22, 1, 0.36, 1],
    multiplier: {
      stagger: 0.075,
      // seconds
      duration: 0.15,
      // seconds
      relativeMove: 10,
      fixedMove: 0.75,
      dropMove: 0.75,
      scale: 0.15,
      appear: 0.15
    }
  }
}, oa = {
  opacity: 0,
  x: 0.75,
  y: 0.75,
  scale: 1
}, Kr = {
  opacity: [0, 1, 1, 1],
  x: 0,
  y: 0,
  scale: 1
}, n9 = {
  opacity: 1,
  x: 0,
  y: 0,
  scale: 1
}, Yu = 0.2, Zu = 0.65, r9 = {
  Functional: {
    fixedMove: {
      transition: {
        duration: Yu
        // seconds
      },
      initial: oa,
      animate: Kr
    },
    relativeMove: {
      transition: {
        duration: Yu
        // seconds
      },
      initial: { opacity: 0, x: 0.1, y: 0.1, scale: 1 },
      animate: Kr
    },
    dropMove: {
      transition: {
        duration: Yu
        // seconds
      },
      initial: { opacity: 0, x: 0.2, y: 0.2, scale: 1 },
      animate: Kr
    },
    // Scale and Appear values need to be discussed with JOHN -- these are placeholder values only =>TO BE ADDED
    scale: {
      transition: {
        duration: Yu
        // seconds
      },
      initial: { opacity: 0, x: 1, y: 1, scale: 1.1 },
      animate: { opacity: [0, 1, 1, 1], x: 1, y: 1, scale: 1 }
    },
    appear: {
      transition: {
        duration: Yu
        // seconds
      },
      initial: { opacity: 0, x: 0.2, y: 0.2, scale: 1 },
      animate: { opacity: [0, 1, 1, 1], x: 0, y: 1, scale: 1 }
    }
  },
  Expressive: {
    fixedMove: {
      transition: {
        duration: Zu
        // seconds
      },
      initial: oa,
      animate: Kr
    },
    relativeMove: {
      transition: {
        duration: Zu
        // seconds
      },
      initial: { opacity: 0, x: 0.15, y: 0.15, scale: 1 },
      animate: Kr
    },
    dropMove: {
      transition: {
        duration: Zu
        // seconds
      },
      initial: oa,
      animate: { opacity: [0, 1, 1, 1], x: 0, y: 0, scale: 1 }
    },
    // Scale and Appear values need to be discussed with JOHN -- these are placeholder values only TO BE ADDED
    scale: {
      transition: {
        duration: Zu
        // seconds
      },
      initial: { opacity: 0, x: 1, y: 1, scale: 1.1 },
      animate: { opacity: [0, 1, 1, 1], x: 1, y: 1, scale: 1 }
    },
    appear: {
      transition: {
        duration: Zu
        // seconds
      },
      initial: oa,
      animate: Kr
    }
  }
}, u9 = {
  moveUp: { type: "fixedMove", direction: "up" },
  moveDown: { type: "fixedMove", direction: "down" },
  moveLeft: { type: "fixedMove", direction: "left" },
  moveRight: { type: "fixedMove", direction: "right" },
  relativeMoveUp: { type: "relativeMove", direction: "up" },
  relativeMoveDown: { type: "relativeMove", direction: "down" },
  relativeMoveLeft: { type: "relativeMove", direction: "left" },
  relativeMoveRight: { type: "relativeMove", direction: "right" },
  dropMoveUpLeft: { type: "dropMove", direction: "up-left" },
  dropMoveUpRight: { type: "dropMove", direction: "up-right" },
  dropMoveDownLeft: { type: "dropMove", direction: "down-left" },
  dropMoveDownRight: { type: "dropMove", direction: "down-right" },
  scaleUp: { type: "scale", direction: "ScaleUp" },
  scaleDown: { type: "scale", direction: "ScaleDown" },
  appear: { type: "appear", direction: void 0 }
}, Lt = {
  baseValues: r9,
  constants: t9,
  motionIntensity: e9,
  motionTypePresets: u9,
  reducedMotionVariant: n9
}, i9 = (e, t, n, r, u = !1) => {
  const i = Lt.baseValues[e][t].initial.x, a = Lt.baseValues[e][t].initial.scale, o = Lt.motionIntensity[r], s = Lt.constants[e].multiplier[t], c = i + o * s, l = a + o * s, d = !!["left", "right"].some(
    (A) => n == null ? void 0 : n.includes(A)
  ), f = !!["up", "down"].some(
    (A) => n == null ? void 0 : n.includes(A)
  ), p = {
    left: "right",
    right: "left",
    "up-left": "up-right",
    "up-right": "up-left",
    "down-left": "down-right",
    "down-right": "down-left"
  }, m = d && u ? ((A) => p[A])(n) : n, b = t === "relativeMove" ? "%" : "rem", x = m != null && m.includes("right") ? -1 : 1, y = m != null && m.includes("down") ? -1 : 1, g = m != null && m.includes("Up") ? 1 - (l - 1) : l, v = d ? x * c : 0, S = f ? y * c : 0;
  return {
    opacity: Lt.baseValues[e][t].initial.opacity,
    x: `${v}${b}`,
    y: `${S}${b}`,
    scale: t === "scale" ? g : 1
  };
}, a9 = (e, t, n) => {
  const r = Lt.baseValues[e][t].transition.duration, u = Lt.constants[e].multiplier.duration, i = Lt.motionIntensity[n];
  let a = r + u * i;
  return t.includes("scale") && (a *= 2), {
    duration: a,
    ease: Lt.constants[e].ease
  };
}, o9 = {
  opacity: [0, 1, 1],
  x: 0,
  y: 0,
  scale: 1
}, s9 = (e, t, n) => ({
  ...o9,
  scale: Lt.baseValues[e][t].animate.scale,
  transition: a9(e, t, n)
}), c9 = (e, t, n, r) => {
  const { type: u, direction: i } = Lt.motionTypePresets[t], a = i9(
    e,
    u,
    i,
    n,
    r
  ), o = s9(e, u, n);
  return { initial: a, animate: o };
}, l9 = (e, t = !1) => ({
  // When animation is not preferred container still gets a subtle animation
  initial: Lt.baseValues.Expressive.dropMove.initial,
  animate: {
    ...Lt.baseValues.Expressive.dropMove.animate,
    transition: t ? e : void 0
  }
}), d9 = () => ({
  initial: Lt.reducedMotionVariant,
  animate: Lt.reducedMotionVariant
}), ni = {
  margin: "0px",
  threshold: 0,
  triggerOnce: !1
}, sa = {
  motionFeel: "Expressive",
  motionTypePreset: "moveUp",
  motionIntensity: "md",
  scrollTriggerOptions: ni
}, f9 = {
  orchestration: { staggerChildren: 1 }
}, Vr = ({
  isMotionChild: e = void 0,
  isMotionContainer: t = void 0,
  as: n,
  rootRef: r,
  children: u,
  className: i,
  isAnimated: a = !0,
  motionOptions: o,
  ...s
}) => {
  const { isAboveTheFold: c } = ke(Yl), l = Rr[n ?? "div"], { environment: { isRTL: d = !1 } = {} } = nt(), f = hr(), p = a && !f && !c, h = () => {
    if (!p)
      return d9();
    if (t === !0) {
      const { orchestration: _ } = o || f9;
      return l9(
        _,
        p
      );
    }
    const {
      motionFeel: g = sa.motionFeel,
      motionTypePreset: v = sa.motionTypePreset,
      motionIntensity: S = sa.motionIntensity
    } = o || sa;
    return c9(
      g,
      v,
      S,
      d
    );
  }, m = () => {
    const g = e;
    return p ? {
      initial: g ? void 0 : "initial",
      whileInView: g ? void 0 : "animate"
    } : {
      initial: g ? void 0 : "animate",
      animate: g ? void 0 : "animate"
    };
  }, {
    margin: b = ni.margin,
    threshold: x = ni.threshold,
    triggerOnce: y = ni.triggerOnce
  } = (o == null ? void 0 : o.scrollTriggerOptions) || ni;
  return /* @__PURE__ */ E($i, { features: Iu, strict: !0, children: /* @__PURE__ */ E(
    l,
    {
      ref: r,
      className: i,
      viewport: { margin: b, amount: x, once: y },
      variants: h(),
      ...m(),
      ...s,
      children: u
    }
  ) });
}, Fc = {
  motionFeel: "Expressive",
  motionIntensity: "md",
  motionTypePreset: "appear",
  scrollTriggerOptions: {
    triggerOnce: !0
  }
}, gv = {
  motionFeel: "Expressive",
  motionIntensity: "md",
  motionTypePreset: "moveUp",
  scrollTriggerOptions: {
    triggerOnce: !0
  }
}, IH = {
  motionTypePreset: "scaleDown",
  motionIntensity: "xs",
  scrollTriggerOptions: {
    triggerOnce: !0
  }
}, p9 = {
  motionIntensity: "xs",
  motionTypePreset: "dropMoveUpLeft",
  scrollTriggerOptions: {
    triggerOnce: !0
  }
};
class ye {
  constructor(t, n) {
    ss(this, "componentName");
    ss(this, "styles");
    this.componentName = Cn(t), this.styles = n;
  }
  getFinalClassName(t) {
    return this.styles ? this.styles[t] || `_${t}_` : t;
  }
  /**
   * @returns The formatted class name of the component
   &&
   *  @example
   *  classNameGen.getElementClassName();
   *  // "hero"
   *
   *  @example
   *  classNameGen.getElementClassName();
   *  // "_hero_1xr4a_1" -> When CSS Module `styles` object was used.
   *
   */
  getComponentClassName() {
    return this.getFinalClassName(this.componentName);
  }
  /**
   * @param elementName - The name of the element you want to style
   * @returns A formatted class name base on the provided element name
   *
   *  @example
   *  classNameGen.getElementClassName('content-col');
   *  // "hero-content-col"
   *
   *  @example
   *  classNameGen.getElementClassName('content-col');
   *  // "_hero-content-col_1xr4a_1" -> When CSS Module `styles` object was used.
   */
  getElementClassName(t) {
    const n = Cn(t), r = `${this.componentName}-${n}`;
    return this.getFinalClassName(r);
  }
  /**
   * @param propsKey - The name of your component prop
   * @param propsValue - The value of your component prop
   * @returns A formatted class name based on the provided prop value
   *
   *  @example
   *  classNameGen.getPropsValueClassName('itemsAlignment', 'Vertical-Center');
   *  // "hero-items-alignment-vertical-center"
   *
   *  @example
   *  classNameGen.getPropsValueClassName('itemsAlignment', 'Vertical-Center');
   *  // "_hero-items-alignment-vertical-center_1xr4a_1" -> When CSS Module `styles` object was used.
   */
  getPropsValueClassName(t, n) {
    const r = Cn(t), u = typeof n == "string", i = typeof n == "boolean", a = u || i;
    let o = "";
    if (!a)
      o = `${this.componentName}-${r}`;
    else if (i)
      o = n ? `${this.componentName}-${r}` : `${this.componentName}-no-${r}`;
    else {
      const s = Cn(n);
      o = `${this.componentName}-${r}-${s}`;
    }
    return this.getFinalClassName(o);
  }
}
class Or {
  /**
   * @param themeName - The name of the theme you want to style
   * @returns A formatted class name based on the provided theme value
   *
   *  @example
   *  themeNameGen.getThemeClassName('blue 700');
   *  // "blue-700-plate"
   */
  static getThemeClassName(t) {
    return `${Cn(t)}-plate`;
  }
}
const bv = "BodyText", h9 = new ye(bv), m9 = {
  Caption: "Caption",
  Body: "Body",
  "Body Small": "Body Small",
  "Body Large": "Body Large",
  "Body X Large": "Body X Large",
  "Body 2X Large": "Body 2X Large"
}, g9 = {
  "Caption Bold": "Caption Bold",
  "Body Bold": "Body Bold",
  "Body Small Bold": "Body Small Bold",
  "Body Large Bold": "Body Large Bold",
  "Body X Large Bold": "Body X Large Bold",
  "Body 2X Large Bold": "Body 2X Large Bold"
}, b9 = {
  ...m9,
  ...g9
}, Qt = ({
  as: e = "p",
  size: t = "Body",
  className: n,
  children: r,
  ...u
}) => {
  const i = h9.getPropsValueClassName("size", t), a = U(n, i);
  return Te.createElement(e, { className: a, ...u }, r);
};
Qt.displayName = bv;
var vv = {};
(function(e) {
  var t = function() {
    return t = Object.assign || function(R) {
      for (var V, I = 1, G = arguments.length; I < G; I++) {
        V = arguments[I];
        for (var K in V)
          Object.prototype.hasOwnProperty.call(V, K) && (R[K] = V[K]);
      }
      return R;
    }, t.apply(this, arguments);
  }, n = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof ee < "u" ? ee : typeof self < "u" ? self : {};
  function r(C) {
    return C && C.__esModule && Object.prototype.hasOwnProperty.call(C, "default") ? C.default : C;
  }
  /*!
   * escape-html
   * Copyright(c) 2012-2013 TJ Holowaychuk
   * Copyright(c) 2015 Andreas Lubbe
   * Copyright(c) 2015 Tiancheng "Timothy" Gu
   * MIT Licensed
   */
  var u = /["'&<>]/, i = a;
  function a(C) {
    var R = "" + C, V = u.exec(R);
    if (!V)
      return R;
    var I, G = "", K = 0, Q = 0;
    for (K = V.index; K < R.length; K++) {
      switch (R.charCodeAt(K)) {
        case 34:
          I = "&quot;";
          break;
        case 38:
          I = "&amp;";
          break;
        case 39:
          I = "&#39;";
          break;
        case 60:
          I = "&lt;";
          break;
        case 62:
          I = "&gt;";
          break;
        default:
          continue;
      }
      Q !== K && (G += R.substring(Q, K)), Q = K + 1, G += I;
    }
    return Q !== K ? G + R.substring(Q, K) : G;
  }
  var o = /* @__PURE__ */ r(i), s = {}, c = {};
  Object.defineProperty(c, "__esModule", { value: !0 }), c.BLOCKS = void 0;
  var l;
  (function(C) {
    C.DOCUMENT = "document", C.PARAGRAPH = "paragraph", C.HEADING_1 = "heading-1", C.HEADING_2 = "heading-2", C.HEADING_3 = "heading-3", C.HEADING_4 = "heading-4", C.HEADING_5 = "heading-5", C.HEADING_6 = "heading-6", C.OL_LIST = "ordered-list", C.UL_LIST = "unordered-list", C.LIST_ITEM = "list-item", C.HR = "hr", C.QUOTE = "blockquote", C.EMBEDDED_ENTRY = "embedded-entry-block", C.EMBEDDED_ASSET = "embedded-asset-block", C.EMBEDDED_RESOURCE = "embedded-resource-block", C.TABLE = "table", C.TABLE_ROW = "table-row", C.TABLE_CELL = "table-cell", C.TABLE_HEADER_CELL = "table-header-cell";
  })(l || (c.BLOCKS = l = {}));
  var d = {};
  Object.defineProperty(d, "__esModule", { value: !0 }), d.INLINES = void 0;
  var f;
  (function(C) {
    C.HYPERLINK = "hyperlink", C.ENTRY_HYPERLINK = "entry-hyperlink", C.ASSET_HYPERLINK = "asset-hyperlink", C.RESOURCE_HYPERLINK = "resource-hyperlink", C.EMBEDDED_ENTRY = "embedded-entry-inline", C.EMBEDDED_RESOURCE = "embedded-resource-inline";
  })(f || (d.INLINES = f = {}));
  var p = {};
  Object.defineProperty(p, "__esModule", { value: !0 }), p.MARKS = void 0;
  var h;
  (function(C) {
    C.BOLD = "bold", C.ITALIC = "italic", C.UNDERLINE = "underline", C.CODE = "code", C.SUPERSCRIPT = "superscript", C.SUBSCRIPT = "subscript";
  })(h || (p.MARKS = h = {}));
  var m = {};
  (function(C) {
    var R = n && n.__spreadArray || function(Q, ae, X) {
      if (X || arguments.length === 2)
        for (var ne = 0, fe = ae.length, he; ne < fe; ne++)
          (he || !(ne in ae)) && (he || (he = Array.prototype.slice.call(ae, 0, ne)), he[ne] = ae[ne]);
      return Q.concat(he || Array.prototype.slice.call(ae));
    }, V;
    Object.defineProperty(C, "__esModule", { value: !0 }), C.V1_MARKS = C.V1_NODE_TYPES = C.TEXT_CONTAINERS = C.HEADINGS = C.CONTAINERS = C.VOID_BLOCKS = C.TABLE_BLOCKS = C.LIST_ITEM_BLOCKS = C.TOP_LEVEL_BLOCKS = void 0;
    var I = c, G = d, K = p;
    C.TOP_LEVEL_BLOCKS = [
      I.BLOCKS.PARAGRAPH,
      I.BLOCKS.HEADING_1,
      I.BLOCKS.HEADING_2,
      I.BLOCKS.HEADING_3,
      I.BLOCKS.HEADING_4,
      I.BLOCKS.HEADING_5,
      I.BLOCKS.HEADING_6,
      I.BLOCKS.OL_LIST,
      I.BLOCKS.UL_LIST,
      I.BLOCKS.HR,
      I.BLOCKS.QUOTE,
      I.BLOCKS.EMBEDDED_ENTRY,
      I.BLOCKS.EMBEDDED_ASSET,
      I.BLOCKS.EMBEDDED_RESOURCE,
      I.BLOCKS.TABLE
    ], C.LIST_ITEM_BLOCKS = [
      I.BLOCKS.PARAGRAPH,
      I.BLOCKS.HEADING_1,
      I.BLOCKS.HEADING_2,
      I.BLOCKS.HEADING_3,
      I.BLOCKS.HEADING_4,
      I.BLOCKS.HEADING_5,
      I.BLOCKS.HEADING_6,
      I.BLOCKS.OL_LIST,
      I.BLOCKS.UL_LIST,
      I.BLOCKS.HR,
      I.BLOCKS.QUOTE,
      I.BLOCKS.EMBEDDED_ENTRY,
      I.BLOCKS.EMBEDDED_ASSET,
      I.BLOCKS.EMBEDDED_RESOURCE
    ], C.TABLE_BLOCKS = [
      I.BLOCKS.TABLE,
      I.BLOCKS.TABLE_ROW,
      I.BLOCKS.TABLE_CELL,
      I.BLOCKS.TABLE_HEADER_CELL
    ], C.VOID_BLOCKS = [
      I.BLOCKS.HR,
      I.BLOCKS.EMBEDDED_ENTRY,
      I.BLOCKS.EMBEDDED_ASSET,
      I.BLOCKS.EMBEDDED_RESOURCE
    ], C.CONTAINERS = (V = {}, V[I.BLOCKS.OL_LIST] = [I.BLOCKS.LIST_ITEM], V[I.BLOCKS.UL_LIST] = [I.BLOCKS.LIST_ITEM], V[I.BLOCKS.LIST_ITEM] = C.LIST_ITEM_BLOCKS, V[I.BLOCKS.QUOTE] = [I.BLOCKS.PARAGRAPH], V[I.BLOCKS.TABLE] = [I.BLOCKS.TABLE_ROW], V[I.BLOCKS.TABLE_ROW] = [I.BLOCKS.TABLE_CELL, I.BLOCKS.TABLE_HEADER_CELL], V[I.BLOCKS.TABLE_CELL] = [I.BLOCKS.PARAGRAPH], V[I.BLOCKS.TABLE_HEADER_CELL] = [I.BLOCKS.PARAGRAPH], V), C.HEADINGS = [
      I.BLOCKS.HEADING_1,
      I.BLOCKS.HEADING_2,
      I.BLOCKS.HEADING_3,
      I.BLOCKS.HEADING_4,
      I.BLOCKS.HEADING_5,
      I.BLOCKS.HEADING_6
    ], C.TEXT_CONTAINERS = R([I.BLOCKS.PARAGRAPH], C.HEADINGS, !0), C.V1_NODE_TYPES = [
      I.BLOCKS.DOCUMENT,
      I.BLOCKS.PARAGRAPH,
      I.BLOCKS.HEADING_1,
      I.BLOCKS.HEADING_2,
      I.BLOCKS.HEADING_3,
      I.BLOCKS.HEADING_4,
      I.BLOCKS.HEADING_5,
      I.BLOCKS.HEADING_6,
      I.BLOCKS.OL_LIST,
      I.BLOCKS.UL_LIST,
      I.BLOCKS.LIST_ITEM,
      I.BLOCKS.HR,
      I.BLOCKS.QUOTE,
      I.BLOCKS.EMBEDDED_ENTRY,
      I.BLOCKS.EMBEDDED_ASSET,
      G.INLINES.HYPERLINK,
      G.INLINES.ENTRY_HYPERLINK,
      G.INLINES.ASSET_HYPERLINK,
      G.INLINES.EMBEDDED_ENTRY,
      "text"
    ], C.V1_MARKS = [K.MARKS.BOLD, K.MARKS.CODE, K.MARKS.ITALIC, K.MARKS.UNDERLINE];
  })(m);
  var b = {};
  Object.defineProperty(b, "__esModule", { value: !0 });
  var x = {};
  Object.defineProperty(x, "__esModule", { value: !0 });
  var y = {};
  Object.defineProperty(y, "__esModule", { value: !0 }), y.EMPTY_DOCUMENT = void 0;
  var g = c;
  y.EMPTY_DOCUMENT = {
    nodeType: g.BLOCKS.DOCUMENT,
    data: {},
    content: [
      {
        nodeType: g.BLOCKS.PARAGRAPH,
        data: {},
        content: [
          {
            nodeType: "text",
            value: "",
            marks: [],
            data: {}
          }
        ]
      }
    ]
  };
  var v = {};
  Object.defineProperty(v, "__esModule", { value: !0 }), v.isText = v.isBlock = v.isInline = void 0;
  var S = c, _ = d;
  function A(C, R) {
    for (var V = 0, I = Object.keys(C); V < I.length; V++) {
      var G = I[V];
      if (R === C[G])
        return !0;
    }
    return !1;
  }
  function k(C) {
    return A(_.INLINES, C.nodeType);
  }
  v.isInline = k;
  function T(C) {
    return A(S.BLOCKS, C.nodeType);
  }
  v.isBlock = T;
  function L(C) {
    return C.nodeType === "text";
  }
  v.isText = L, function(C) {
    var R = n && n.__createBinding || (Object.create ? function(fe, he, xe, re) {
      re === void 0 && (re = xe);
      var Se = Object.getOwnPropertyDescriptor(he, xe);
      (!Se || ("get" in Se ? !he.__esModule : Se.writable || Se.configurable)) && (Se = { enumerable: !0, get: function() {
        return he[xe];
      } }), Object.defineProperty(fe, re, Se);
    } : function(fe, he, xe, re) {
      re === void 0 && (re = xe), fe[re] = he[xe];
    }), V = n && n.__setModuleDefault || (Object.create ? function(fe, he) {
      Object.defineProperty(fe, "default", { enumerable: !0, value: he });
    } : function(fe, he) {
      fe.default = he;
    }), I = n && n.__exportStar || function(fe, he) {
      for (var xe in fe)
        xe !== "default" && !Object.prototype.hasOwnProperty.call(he, xe) && R(he, fe, xe);
    }, G = n && n.__importStar || function(fe) {
      if (fe && fe.__esModule)
        return fe;
      var he = {};
      if (fe != null)
        for (var xe in fe)
          xe !== "default" && Object.prototype.hasOwnProperty.call(fe, xe) && R(he, fe, xe);
      return V(he, fe), he;
    };
    Object.defineProperty(C, "__esModule", { value: !0 }), C.helpers = C.EMPTY_DOCUMENT = C.MARKS = C.INLINES = C.BLOCKS = void 0;
    var K = c;
    Object.defineProperty(C, "BLOCKS", { enumerable: !0, get: function() {
      return K.BLOCKS;
    } });
    var Q = d;
    Object.defineProperty(C, "INLINES", { enumerable: !0, get: function() {
      return Q.INLINES;
    } });
    var ae = p;
    Object.defineProperty(C, "MARKS", { enumerable: !0, get: function() {
      return ae.MARKS;
    } }), I(m, C), I(b, C), I(x, C);
    var X = y;
    Object.defineProperty(C, "EMPTY_DOCUMENT", { enumerable: !0, get: function() {
      return X.EMPTY_DOCUMENT;
    } });
    var ne = G(v);
    C.helpers = ne;
  }(s);
  var w, D, N = function(C) {
    return '"'.concat(C.replace(/"/g, "&quot;"), '"');
  }, O = (w = {}, w[s.BLOCKS.PARAGRAPH] = function(C, R) {
    return "<p>".concat(R(C.content), "</p>");
  }, w[s.BLOCKS.HEADING_1] = function(C, R) {
    return "<h1>".concat(R(C.content), "</h1>");
  }, w[s.BLOCKS.HEADING_2] = function(C, R) {
    return "<h2>".concat(R(C.content), "</h2>");
  }, w[s.BLOCKS.HEADING_3] = function(C, R) {
    return "<h3>".concat(R(C.content), "</h3>");
  }, w[s.BLOCKS.HEADING_4] = function(C, R) {
    return "<h4>".concat(R(C.content), "</h4>");
  }, w[s.BLOCKS.HEADING_5] = function(C, R) {
    return "<h5>".concat(R(C.content), "</h5>");
  }, w[s.BLOCKS.HEADING_6] = function(C, R) {
    return "<h6>".concat(R(C.content), "</h6>");
  }, w[s.BLOCKS.EMBEDDED_ENTRY] = function(C, R) {
    return "<div>".concat(R(C.content), "</div>");
  }, w[s.BLOCKS.EMBEDDED_RESOURCE] = function(C, R) {
    return "<div>".concat(R(C.content), "</div>");
  }, w[s.BLOCKS.UL_LIST] = function(C, R) {
    return "<ul>".concat(R(C.content), "</ul>");
  }, w[s.BLOCKS.OL_LIST] = function(C, R) {
    return "<ol>".concat(R(C.content), "</ol>");
  }, w[s.BLOCKS.LIST_ITEM] = function(C, R) {
    return "<li>".concat(R(C.content), "</li>");
  }, w[s.BLOCKS.QUOTE] = function(C, R) {
    return "<blockquote>".concat(R(C.content), "</blockquote>");
  }, w[s.BLOCKS.HR] = function() {
    return "<hr/>";
  }, w[s.BLOCKS.TABLE] = function(C, R) {
    return "<table>".concat(R(C.content), "</table>");
  }, w[s.BLOCKS.TABLE_ROW] = function(C, R) {
    return "<tr>".concat(R(C.content), "</tr>");
  }, w[s.BLOCKS.TABLE_HEADER_CELL] = function(C, R) {
    return "<th>".concat(R(C.content), "</th>");
  }, w[s.BLOCKS.TABLE_CELL] = function(C, R) {
    return "<td>".concat(R(C.content), "</td>");
  }, w[s.INLINES.ASSET_HYPERLINK] = function(C) {
    return $(s.INLINES.ASSET_HYPERLINK, C);
  }, w[s.INLINES.ENTRY_HYPERLINK] = function(C) {
    return $(s.INLINES.ENTRY_HYPERLINK, C);
  }, w[s.INLINES.RESOURCE_HYPERLINK] = function(C) {
    return j(s.INLINES.RESOURCE_HYPERLINK, C);
  }, w[s.INLINES.EMBEDDED_ENTRY] = function(C) {
    return $(s.INLINES.EMBEDDED_ENTRY, C);
  }, w[s.INLINES.EMBEDDED_RESOURCE] = function(C) {
    return j(s.INLINES.EMBEDDED_RESOURCE, C);
  }, w[s.INLINES.HYPERLINK] = function(C, R) {
    var V = typeof C.data.uri == "string" ? C.data.uri : "";
    return "<a href=".concat(N(V), ">").concat(R(C.content), "</a>");
  }, w), H = (D = {}, D[s.MARKS.BOLD] = function(C) {
    return "<b>".concat(C, "</b>");
  }, D[s.MARKS.ITALIC] = function(C) {
    return "<i>".concat(C, "</i>");
  }, D[s.MARKS.UNDERLINE] = function(C) {
    return "<u>".concat(C, "</u>");
  }, D[s.MARKS.CODE] = function(C) {
    return "<code>".concat(C, "</code>");
  }, D[s.MARKS.SUPERSCRIPT] = function(C) {
    return "<sup>".concat(C, "</sup>");
  }, D[s.MARKS.SUBSCRIPT] = function(C) {
    return "<sub>".concat(C, "</sub>");
  }, D), $ = function(C, R) {
    return "<span>type: ".concat(o(C), " id: ").concat(o(R.data.target.sys.id), "</span>");
  }, j = function(C, R) {
    return "<span>type: ".concat(o(C), " urn: ").concat(o(R.data.target.sys.urn), "</span>");
  };
  function z(C, R) {
    return R === void 0 && (R = {}), !C || !C.content ? "" : M(C.content, {
      renderNode: t(t({}, O), R.renderNode),
      renderMark: t(t({}, H), R.renderMark),
      preserveWhitespace: R.preserveWhitespace
    });
  }
  function M(C, R) {
    var V = R.renderNode, I = R.renderMark, G = R.preserveWhitespace;
    return C.map(function(K) {
      return P(K, { renderNode: V, renderMark: I, preserveWhitespace: G });
    }).join("");
  }
  function P(C, R) {
    var V = R.renderNode, I = R.renderMark, G = R.preserveWhitespace;
    if (s.helpers.isText(C)) {
      var K = o(C.value);
      return G && (K = K.replace(/\n/g, "<br/>").replace(/ {2,}/g, function(ae) {
        return "&nbsp;".repeat(ae.length);
      })), C.marks.length > 0 ? C.marks.reduce(function(ae, X) {
        return I[X.type] ? I[X.type](ae) : ae;
      }, K) : K;
    } else {
      var Q = function(ae) {
        return M(ae, { renderMark: I, renderNode: V, preserveWhitespace: G });
      };
      return !C.nodeType || !V[C.nodeType] ? "" : V[C.nodeType](C, Q);
    }
  }
  e.documentToHtmlString = z;
})(vv);
const Gf = {};
function v9(e) {
  let t = Gf[e];
  if (t)
    return t;
  t = Gf[e] = [];
  for (let n = 0; n < 128; n++) {
    const r = String.fromCharCode(n);
    t.push(r);
  }
  for (let n = 0; n < e.length; n++) {
    const r = e.charCodeAt(n);
    t[r] = "%" + ("0" + r.toString(16).toUpperCase()).slice(-2);
  }
  return t;
}
function ku(e, t) {
  typeof t != "string" && (t = ku.defaultChars);
  const n = v9(t);
  return e.replace(/(%[a-f0-9]{2})+/gi, function(r) {
    let u = "";
    for (let i = 0, a = r.length; i < a; i += 3) {
      const o = parseInt(r.slice(i + 1, i + 3), 16);
      if (o < 128) {
        u += n[o];
        continue;
      }
      if ((o & 224) === 192 && i + 3 < a) {
        const s = parseInt(r.slice(i + 4, i + 6), 16);
        if ((s & 192) === 128) {
          const c = o << 6 & 1984 | s & 63;
          c < 128 ? u += "��" : u += String.fromCharCode(c), i += 3;
          continue;
        }
      }
      if ((o & 240) === 224 && i + 6 < a) {
        const s = parseInt(r.slice(i + 4, i + 6), 16), c = parseInt(r.slice(i + 7, i + 9), 16);
        if ((s & 192) === 128 && (c & 192) === 128) {
          const l = o << 12 & 61440 | s << 6 & 4032 | c & 63;
          l < 2048 || l >= 55296 && l <= 57343 ? u += "���" : u += String.fromCharCode(l), i += 6;
          continue;
        }
      }
      if ((o & 248) === 240 && i + 9 < a) {
        const s = parseInt(r.slice(i + 4, i + 6), 16), c = parseInt(r.slice(i + 7, i + 9), 16), l = parseInt(r.slice(i + 10, i + 12), 16);
        if ((s & 192) === 128 && (c & 192) === 128 && (l & 192) === 128) {
          let d = o << 18 & 1835008 | s << 12 & 258048 | c << 6 & 4032 | l & 63;
          d < 65536 || d > 1114111 ? u += "����" : (d -= 65536, u += String.fromCharCode(55296 + (d >> 10), 56320 + (d & 1023))), i += 9;
          continue;
        }
      }
      u += "�";
    }
    return u;
  });
}
ku.defaultChars = ";/?:@&=+$,#";
ku.componentChars = "";
const Wf = {};
function y9(e) {
  let t = Wf[e];
  if (t)
    return t;
  t = Wf[e] = [];
  for (let n = 0; n < 128; n++) {
    const r = String.fromCharCode(n);
    /^[0-9a-z]$/i.test(r) ? t.push(r) : t.push("%" + ("0" + n.toString(16).toUpperCase()).slice(-2));
  }
  for (let n = 0; n < e.length; n++)
    t[e.charCodeAt(n)] = e[n];
  return t;
}
function Ui(e, t, n) {
  typeof t != "string" && (n = t, t = Ui.defaultChars), typeof n > "u" && (n = !0);
  const r = y9(t);
  let u = "";
  for (let i = 0, a = e.length; i < a; i++) {
    const o = e.charCodeAt(i);
    if (n && o === 37 && i + 2 < a && /^[0-9a-f]{2}$/i.test(e.slice(i + 1, i + 3))) {
      u += e.slice(i, i + 3), i += 2;
      continue;
    }
    if (o < 128) {
      u += r[o];
      continue;
    }
    if (o >= 55296 && o <= 57343) {
      if (o >= 55296 && o <= 56319 && i + 1 < a) {
        const s = e.charCodeAt(i + 1);
        if (s >= 56320 && s <= 57343) {
          u += encodeURIComponent(e[i] + e[i + 1]), i++;
          continue;
        }
      }
      u += "%EF%BF%BD";
      continue;
    }
    u += encodeURIComponent(e[i]);
  }
  return u;
}
Ui.defaultChars = ";/?:@&=+$,-_.!~*'()#";
Ui.componentChars = "-_.!~*'()";
function Zl(e) {
  let t = "";
  return t += e.protocol || "", t += e.slashes ? "//" : "", t += e.auth ? e.auth + "@" : "", e.hostname && e.hostname.indexOf(":") !== -1 ? t += "[" + e.hostname + "]" : t += e.hostname || "", t += e.port ? ":" + e.port : "", t += e.pathname || "", t += e.search || "", t += e.hash || "", t;
}
function Ga() {
  this.protocol = null, this.slashes = null, this.auth = null, this.port = null, this.hostname = null, this.hash = null, this.search = null, this.pathname = null;
}
const x9 = /^([a-z0-9.+-]+:)/i, _9 = /:[0-9]*$/, S9 = /^(\/\/?(?!\/)[^\?\s]*)(\?[^\s]*)?$/, C9 = ["<", ">", '"', "`", " ", "\r", `
`, "	"], E9 = ["{", "}", "|", "\\", "^", "`"].concat(C9), w9 = ["'"].concat(E9), Kf = ["%", "/", "?", ";", "#"].concat(w9), Yf = ["/", "?", "#"], T9 = 255, Zf = /^[+a-z0-9A-Z_-]{0,63}$/, A9 = /^([+a-z0-9A-Z_-]{0,63})(.*)$/, Xf = {
  javascript: !0,
  "javascript:": !0
}, Qf = {
  http: !0,
  https: !0,
  ftp: !0,
  gopher: !0,
  file: !0,
  "http:": !0,
  "https:": !0,
  "ftp:": !0,
  "gopher:": !0,
  "file:": !0
};
function Xl(e, t) {
  if (e && e instanceof Ga)
    return e;
  const n = new Ga();
  return n.parse(e, t), n;
}
Ga.prototype.parse = function(e, t) {
  let n, r, u, i = e;
  if (i = i.trim(), !t && e.split("#").length === 1) {
    const c = S9.exec(i);
    if (c)
      return this.pathname = c[1], c[2] && (this.search = c[2]), this;
  }
  let a = x9.exec(i);
  if (a && (a = a[0], n = a.toLowerCase(), this.protocol = a, i = i.substr(a.length)), (t || a || i.match(/^\/\/[^@\/]+@[^@\/]+/)) && (u = i.substr(0, 2) === "//", u && !(a && Xf[a]) && (i = i.substr(2), this.slashes = !0)), !Xf[a] && (u || a && !Qf[a])) {
    let c = -1;
    for (let h = 0; h < Yf.length; h++)
      r = i.indexOf(Yf[h]), r !== -1 && (c === -1 || r < c) && (c = r);
    let l, d;
    c === -1 ? d = i.lastIndexOf("@") : d = i.lastIndexOf("@", c), d !== -1 && (l = i.slice(0, d), i = i.slice(d + 1), this.auth = l), c = -1;
    for (let h = 0; h < Kf.length; h++)
      r = i.indexOf(Kf[h]), r !== -1 && (c === -1 || r < c) && (c = r);
    c === -1 && (c = i.length), i[c - 1] === ":" && c--;
    const f = i.slice(0, c);
    i = i.slice(c), this.parseHost(f), this.hostname = this.hostname || "";
    const p = this.hostname[0] === "[" && this.hostname[this.hostname.length - 1] === "]";
    if (!p) {
      const h = this.hostname.split(/\./);
      for (let m = 0, b = h.length; m < b; m++) {
        const x = h[m];
        if (x && !x.match(Zf)) {
          let y = "";
          for (let g = 0, v = x.length; g < v; g++)
            x.charCodeAt(g) > 127 ? y += "x" : y += x[g];
          if (!y.match(Zf)) {
            const g = h.slice(0, m), v = h.slice(m + 1), S = x.match(A9);
            S && (g.push(S[1]), v.unshift(S[2])), v.length && (i = v.join(".") + i), this.hostname = g.join(".");
            break;
          }
        }
      }
    }
    this.hostname.length > T9 && (this.hostname = ""), p && (this.hostname = this.hostname.substr(1, this.hostname.length - 2));
  }
  const o = i.indexOf("#");
  o !== -1 && (this.hash = i.substr(o), i = i.slice(0, o));
  const s = i.indexOf("?");
  return s !== -1 && (this.search = i.substr(s), i = i.slice(0, s)), i && (this.pathname = i), Qf[n] && this.hostname && !this.pathname && (this.pathname = ""), this;
};
Ga.prototype.parseHost = function(e) {
  let t = _9.exec(e);
  t && (t = t[0], t !== ":" && (this.port = t.substr(1)), e = e.substr(0, e.length - t.length)), e && (this.hostname = e);
};
const k9 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  decode: ku,
  encode: Ui,
  format: Zl,
  parse: Xl
}, Symbol.toStringTag, { value: "Module" })), yv = /[\0-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF]/, xv = /[\0-\x1F\x7F-\x9F]/, L9 = /[\xAD\u0600-\u0605\u061C\u06DD\u070F\u0890\u0891\u08E2\u180E\u200B-\u200F\u202A-\u202E\u2060-\u2064\u2066-\u206F\uFEFF\uFFF9-\uFFFB]|\uD804[\uDCBD\uDCCD]|\uD80D[\uDC30-\uDC3F]|\uD82F[\uDCA0-\uDCA3]|\uD834[\uDD73-\uDD7A]|\uDB40[\uDC01\uDC20-\uDC7F]/, Ql = /[!-#%-\*,-\/:;\?@\[-\]_\{\}\xA1\xA7\xAB\xB6\xB7\xBB\xBF\u037E\u0387\u055A-\u055F\u0589\u058A\u05BE\u05C0\u05C3\u05C6\u05F3\u05F4\u0609\u060A\u060C\u060D\u061B\u061D-\u061F\u066A-\u066D\u06D4\u0700-\u070D\u07F7-\u07F9\u0830-\u083E\u085E\u0964\u0965\u0970\u09FD\u0A76\u0AF0\u0C77\u0C84\u0DF4\u0E4F\u0E5A\u0E5B\u0F04-\u0F12\u0F14\u0F3A-\u0F3D\u0F85\u0FD0-\u0FD4\u0FD9\u0FDA\u104A-\u104F\u10FB\u1360-\u1368\u1400\u166E\u169B\u169C\u16EB-\u16ED\u1735\u1736\u17D4-\u17D6\u17D8-\u17DA\u1800-\u180A\u1944\u1945\u1A1E\u1A1F\u1AA0-\u1AA6\u1AA8-\u1AAD\u1B5A-\u1B60\u1B7D\u1B7E\u1BFC-\u1BFF\u1C3B-\u1C3F\u1C7E\u1C7F\u1CC0-\u1CC7\u1CD3\u2010-\u2027\u2030-\u2043\u2045-\u2051\u2053-\u205E\u207D\u207E\u208D\u208E\u2308-\u230B\u2329\u232A\u2768-\u2775\u27C5\u27C6\u27E6-\u27EF\u2983-\u2998\u29D8-\u29DB\u29FC\u29FD\u2CF9-\u2CFC\u2CFE\u2CFF\u2D70\u2E00-\u2E2E\u2E30-\u2E4F\u2E52-\u2E5D\u3001-\u3003\u3008-\u3011\u3014-\u301F\u3030\u303D\u30A0\u30FB\uA4FE\uA4FF\uA60D-\uA60F\uA673\uA67E\uA6F2-\uA6F7\uA874-\uA877\uA8CE\uA8CF\uA8F8-\uA8FA\uA8FC\uA92E\uA92F\uA95F\uA9C1-\uA9CD\uA9DE\uA9DF\uAA5C-\uAA5F\uAADE\uAADF\uAAF0\uAAF1\uABEB\uFD3E\uFD3F\uFE10-\uFE19\uFE30-\uFE52\uFE54-\uFE61\uFE63\uFE68\uFE6A\uFE6B\uFF01-\uFF03\uFF05-\uFF0A\uFF0C-\uFF0F\uFF1A\uFF1B\uFF1F\uFF20\uFF3B-\uFF3D\uFF3F\uFF5B\uFF5D\uFF5F-\uFF65]|\uD800[\uDD00-\uDD02\uDF9F\uDFD0]|\uD801\uDD6F|\uD802[\uDC57\uDD1F\uDD3F\uDE50-\uDE58\uDE7F\uDEF0-\uDEF6\uDF39-\uDF3F\uDF99-\uDF9C]|\uD803[\uDEAD\uDF55-\uDF59\uDF86-\uDF89]|\uD804[\uDC47-\uDC4D\uDCBB\uDCBC\uDCBE-\uDCC1\uDD40-\uDD43\uDD74\uDD75\uDDC5-\uDDC8\uDDCD\uDDDB\uDDDD-\uDDDF\uDE38-\uDE3D\uDEA9]|\uD805[\uDC4B-\uDC4F\uDC5A\uDC5B\uDC5D\uDCC6\uDDC1-\uDDD7\uDE41-\uDE43\uDE60-\uDE6C\uDEB9\uDF3C-\uDF3E]|\uD806[\uDC3B\uDD44-\uDD46\uDDE2\uDE3F-\uDE46\uDE9A-\uDE9C\uDE9E-\uDEA2\uDF00-\uDF09]|\uD807[\uDC41-\uDC45\uDC70\uDC71\uDEF7\uDEF8\uDF43-\uDF4F\uDFFF]|\uD809[\uDC70-\uDC74]|\uD80B[\uDFF1\uDFF2]|\uD81A[\uDE6E\uDE6F\uDEF5\uDF37-\uDF3B\uDF44]|\uD81B[\uDE97-\uDE9A\uDFE2]|\uD82F\uDC9F|\uD836[\uDE87-\uDE8B]|\uD83A[\uDD5E\uDD5F]/, _v = /[\$\+<->\^`\|~\xA2-\xA6\xA8\xA9\xAC\xAE-\xB1\xB4\xB8\xD7\xF7\u02C2-\u02C5\u02D2-\u02DF\u02E5-\u02EB\u02ED\u02EF-\u02FF\u0375\u0384\u0385\u03F6\u0482\u058D-\u058F\u0606-\u0608\u060B\u060E\u060F\u06DE\u06E9\u06FD\u06FE\u07F6\u07FE\u07FF\u0888\u09F2\u09F3\u09FA\u09FB\u0AF1\u0B70\u0BF3-\u0BFA\u0C7F\u0D4F\u0D79\u0E3F\u0F01-\u0F03\u0F13\u0F15-\u0F17\u0F1A-\u0F1F\u0F34\u0F36\u0F38\u0FBE-\u0FC5\u0FC7-\u0FCC\u0FCE\u0FCF\u0FD5-\u0FD8\u109E\u109F\u1390-\u1399\u166D\u17DB\u1940\u19DE-\u19FF\u1B61-\u1B6A\u1B74-\u1B7C\u1FBD\u1FBF-\u1FC1\u1FCD-\u1FCF\u1FDD-\u1FDF\u1FED-\u1FEF\u1FFD\u1FFE\u2044\u2052\u207A-\u207C\u208A-\u208C\u20A0-\u20C0\u2100\u2101\u2103-\u2106\u2108\u2109\u2114\u2116-\u2118\u211E-\u2123\u2125\u2127\u2129\u212E\u213A\u213B\u2140-\u2144\u214A-\u214D\u214F\u218A\u218B\u2190-\u2307\u230C-\u2328\u232B-\u2426\u2440-\u244A\u249C-\u24E9\u2500-\u2767\u2794-\u27C4\u27C7-\u27E5\u27F0-\u2982\u2999-\u29D7\u29DC-\u29FB\u29FE-\u2B73\u2B76-\u2B95\u2B97-\u2BFF\u2CE5-\u2CEA\u2E50\u2E51\u2E80-\u2E99\u2E9B-\u2EF3\u2F00-\u2FD5\u2FF0-\u2FFF\u3004\u3012\u3013\u3020\u3036\u3037\u303E\u303F\u309B\u309C\u3190\u3191\u3196-\u319F\u31C0-\u31E3\u31EF\u3200-\u321E\u322A-\u3247\u3250\u3260-\u327F\u328A-\u32B0\u32C0-\u33FF\u4DC0-\u4DFF\uA490-\uA4C6\uA700-\uA716\uA720\uA721\uA789\uA78A\uA828-\uA82B\uA836-\uA839\uAA77-\uAA79\uAB5B\uAB6A\uAB6B\uFB29\uFBB2-\uFBC2\uFD40-\uFD4F\uFDCF\uFDFC-\uFDFF\uFE62\uFE64-\uFE66\uFE69\uFF04\uFF0B\uFF1C-\uFF1E\uFF3E\uFF40\uFF5C\uFF5E\uFFE0-\uFFE6\uFFE8-\uFFEE\uFFFC\uFFFD]|\uD800[\uDD37-\uDD3F\uDD79-\uDD89\uDD8C-\uDD8E\uDD90-\uDD9C\uDDA0\uDDD0-\uDDFC]|\uD802[\uDC77\uDC78\uDEC8]|\uD805\uDF3F|\uD807[\uDFD5-\uDFF1]|\uD81A[\uDF3C-\uDF3F\uDF45]|\uD82F\uDC9C|\uD833[\uDF50-\uDFC3]|\uD834[\uDC00-\uDCF5\uDD00-\uDD26\uDD29-\uDD64\uDD6A-\uDD6C\uDD83\uDD84\uDD8C-\uDDA9\uDDAE-\uDDEA\uDE00-\uDE41\uDE45\uDF00-\uDF56]|\uD835[\uDEC1\uDEDB\uDEFB\uDF15\uDF35\uDF4F\uDF6F\uDF89\uDFA9\uDFC3]|\uD836[\uDC00-\uDDFF\uDE37-\uDE3A\uDE6D-\uDE74\uDE76-\uDE83\uDE85\uDE86]|\uD838[\uDD4F\uDEFF]|\uD83B[\uDCAC\uDCB0\uDD2E\uDEF0\uDEF1]|\uD83C[\uDC00-\uDC2B\uDC30-\uDC93\uDCA0-\uDCAE\uDCB1-\uDCBF\uDCC1-\uDCCF\uDCD1-\uDCF5\uDD0D-\uDDAD\uDDE6-\uDE02\uDE10-\uDE3B\uDE40-\uDE48\uDE50\uDE51\uDE60-\uDE65\uDF00-\uDFFF]|\uD83D[\uDC00-\uDED7\uDEDC-\uDEEC\uDEF0-\uDEFC\uDF00-\uDF76\uDF7B-\uDFD9\uDFE0-\uDFEB\uDFF0]|\uD83E[\uDC00-\uDC0B\uDC10-\uDC47\uDC50-\uDC59\uDC60-\uDC87\uDC90-\uDCAD\uDCB0\uDCB1\uDD00-\uDE53\uDE60-\uDE6D\uDE70-\uDE7C\uDE80-\uDE88\uDE90-\uDEBD\uDEBF-\uDEC5\uDECE-\uDEDB\uDEE0-\uDEE8\uDEF0-\uDEF8\uDF00-\uDF92\uDF94-\uDFCA]/, Sv = /[ \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000]/, D9 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Any: yv,
  Cc: xv,
  Cf: L9,
  P: Ql,
  S: _v,
  Z: Sv
}, Symbol.toStringTag, { value: "Module" })), N9 = new Uint16Array(
  // prettier-ignore
  'ᵁ<Õıʊҝջאٵ۞ޢߖࠏ੊ઑඡ๭༉༦჊ረዡᐕᒝᓃᓟᔥ\0\0\0\0\0\0ᕫᛍᦍᰒᷝ὾⁠↰⊍⏀⏻⑂⠤⤒ⴈ⹈⿎〖㊺㘹㞬㣾㨨㩱㫠㬮ࠀEMabcfglmnoprstu\\bfms¦³¹ÈÏlig耻Æ䃆P耻&䀦cute耻Á䃁reve;䄂Āiyx}rc耻Â䃂;䐐r;쀀𝔄rave耻À䃀pha;䎑acr;䄀d;橓Āgp¡on;䄄f;쀀𝔸plyFunction;恡ing耻Å䃅Ācs¾Ãr;쀀𝒜ign;扔ilde耻Ã䃃ml耻Ä䃄ЀaceforsuåûþėĜĢħĪĀcrêòkslash;或Ŷöø;櫧ed;挆y;䐑ƀcrtąċĔause;戵noullis;愬a;䎒r;쀀𝔅pf;쀀𝔹eve;䋘còēmpeq;扎܀HOacdefhilorsuōőŖƀƞƢƵƷƺǜȕɳɸɾcy;䐧PY耻©䂩ƀcpyŝŢźute;䄆Ā;iŧŨ拒talDifferentialD;慅leys;愭ȀaeioƉƎƔƘron;䄌dil耻Ç䃇rc;䄈nint;戰ot;䄊ĀdnƧƭilla;䂸terDot;䂷òſi;䎧rcleȀDMPTǇǋǑǖot;抙inus;抖lus;投imes;抗oĀcsǢǸkwiseContourIntegral;戲eCurlyĀDQȃȏoubleQuote;思uote;怙ȀlnpuȞȨɇɕonĀ;eȥȦ户;橴ƀgitȯȶȺruent;扡nt;戯ourIntegral;戮ĀfrɌɎ;愂oduct;成nterClockwiseContourIntegral;戳oss;樯cr;쀀𝒞pĀ;Cʄʅ拓ap;才րDJSZacefiosʠʬʰʴʸˋ˗ˡ˦̳ҍĀ;oŹʥtrahd;椑cy;䐂cy;䐅cy;䐏ƀgrsʿ˄ˇger;怡r;憡hv;櫤Āayː˕ron;䄎;䐔lĀ;t˝˞戇a;䎔r;쀀𝔇Āaf˫̧Ācm˰̢riticalȀADGT̖̜̀̆cute;䂴oŴ̋̍;䋙bleAcute;䋝rave;䁠ilde;䋜ond;拄ferentialD;慆Ѱ̽\0\0\0͔͂\0Ѕf;쀀𝔻ƀ;DE͈͉͍䂨ot;惜qual;扐blèCDLRUVͣͲ΂ϏϢϸontourIntegraìȹoɴ͹\0\0ͻ»͉nArrow;懓Āeo·ΤftƀARTΐΖΡrrow;懐ightArrow;懔eåˊngĀLRΫτeftĀARγιrrow;柸ightArrow;柺ightArrow;柹ightĀATϘϞrrow;懒ee;抨pɁϩ\0\0ϯrrow;懑ownArrow;懕erticalBar;戥ǹABLRTaВЪаўѿͼrrowƀ;BUНОТ憓ar;椓pArrow;懵reve;䌑eft˒к\0ц\0ѐightVector;楐eeVector;楞ectorĀ;Bљњ憽ar;楖ightǔѧ\0ѱeeVector;楟ectorĀ;BѺѻ懁ar;楗eeĀ;A҆҇护rrow;憧ĀctҒҗr;쀀𝒟rok;䄐ࠀNTacdfglmopqstuxҽӀӄӋӞӢӧӮӵԡԯԶՒ՝ՠեG;䅊H耻Ð䃐cute耻É䃉ƀaiyӒӗӜron;䄚rc耻Ê䃊;䐭ot;䄖r;쀀𝔈rave耻È䃈ement;戈ĀapӺӾcr;䄒tyɓԆ\0\0ԒmallSquare;旻erySmallSquare;斫ĀgpԦԪon;䄘f;쀀𝔼silon;䎕uĀaiԼՉlĀ;TՂՃ橵ilde;扂librium;懌Āci՗՚r;愰m;橳a;䎗ml耻Ë䃋Āipժկsts;戃onentialE;慇ʀcfiosօֈ֍ֲ׌y;䐤r;쀀𝔉lledɓ֗\0\0֣mallSquare;旼erySmallSquare;斪Ͱֺ\0ֿ\0\0ׄf;쀀𝔽All;戀riertrf;愱cò׋؀JTabcdfgorstר׬ׯ׺؀ؒؖ؛؝أ٬ٲcy;䐃耻>䀾mmaĀ;d׷׸䎓;䏜reve;䄞ƀeiy؇،ؐdil;䄢rc;䄜;䐓ot;䄠r;쀀𝔊;拙pf;쀀𝔾eater̀EFGLSTصلَٖٛ٦qualĀ;Lؾؿ扥ess;招ullEqual;执reater;檢ess;扷lantEqual;橾ilde;扳cr;쀀𝒢;扫ЀAacfiosuڅڋږڛڞڪھۊRDcy;䐪Āctڐڔek;䋇;䁞irc;䄤r;愌lbertSpace;愋ǰگ\0ڲf;愍izontalLine;攀Āctۃۅòکrok;䄦mpńېۘownHumðįqual;扏܀EJOacdfgmnostuۺ۾܃܇܎ܚܞܡܨ݄ݸދޏޕcy;䐕lig;䄲cy;䐁cute耻Í䃍Āiyܓܘrc耻Î䃎;䐘ot;䄰r;愑rave耻Ì䃌ƀ;apܠܯܿĀcgܴܷr;䄪inaryI;慈lieóϝǴ݉\0ݢĀ;eݍݎ戬Āgrݓݘral;戫section;拂isibleĀCTݬݲomma;恣imes;恢ƀgptݿރވon;䄮f;쀀𝕀a;䎙cr;愐ilde;䄨ǫޚ\0ޞcy;䐆l耻Ï䃏ʀcfosuެ޷޼߂ߐĀiyޱ޵rc;䄴;䐙r;쀀𝔍pf;쀀𝕁ǣ߇\0ߌr;쀀𝒥rcy;䐈kcy;䐄΀HJacfosߤߨ߽߬߱ࠂࠈcy;䐥cy;䐌ppa;䎚Āey߶߻dil;䄶;䐚r;쀀𝔎pf;쀀𝕂cr;쀀𝒦րJTaceflmostࠥࠩࠬࡐࡣ঳সে্਷ੇcy;䐉耻<䀼ʀcmnpr࠷࠼ࡁࡄࡍute;䄹bda;䎛g;柪lacetrf;愒r;憞ƀaeyࡗ࡜ࡡron;䄽dil;䄻;䐛Āfsࡨ॰tԀACDFRTUVarࡾࢩࢱࣦ࣠ࣼयज़ΐ४Ānrࢃ࢏gleBracket;柨rowƀ;BR࢙࢚࢞憐ar;懤ightArrow;懆eiling;挈oǵࢷ\0ࣃbleBracket;柦nǔࣈ\0࣒eeVector;楡ectorĀ;Bࣛࣜ懃ar;楙loor;挊ightĀAV࣯ࣵrrow;憔ector;楎Āerँगeƀ;AVउऊऐ抣rrow;憤ector;楚iangleƀ;BEतथऩ抲ar;槏qual;抴pƀDTVषूौownVector;楑eeVector;楠ectorĀ;Bॖॗ憿ar;楘ectorĀ;B॥०憼ar;楒ightáΜs̀EFGLSTॾঋকঝঢভqualGreater;拚ullEqual;扦reater;扶ess;檡lantEqual;橽ilde;扲r;쀀𝔏Ā;eঽা拘ftarrow;懚idot;䄿ƀnpw৔ਖਛgȀLRlr৞৷ਂਐeftĀAR০৬rrow;柵ightArrow;柷ightArrow;柶eftĀarγਊightáοightáϊf;쀀𝕃erĀLRਢਬeftArrow;憙ightArrow;憘ƀchtਾੀੂòࡌ;憰rok;䅁;扪Ѐacefiosuਗ਼੝੠੷੼અઋ઎p;椅y;䐜Ādl੥੯iumSpace;恟lintrf;愳r;쀀𝔐nusPlus;戓pf;쀀𝕄cò੶;䎜ҀJacefostuણધભીଔଙඑ඗ඞcy;䐊cute;䅃ƀaey઴હાron;䅇dil;䅅;䐝ƀgswે૰଎ativeƀMTV૓૟૨ediumSpace;怋hiĀcn૦૘ë૙eryThiî૙tedĀGL૸ଆreaterGreateòٳessLesóੈLine;䀊r;쀀𝔑ȀBnptଢନଷ଺reak;恠BreakingSpace;䂠f;愕ڀ;CDEGHLNPRSTV୕ୖ୪୼஡௫ఄ౞಄ದ೘ൡඅ櫬Āou୛୤ngruent;扢pCap;扭oubleVerticalBar;戦ƀlqxஃஊ஛ement;戉ualĀ;Tஒஓ扠ilde;쀀≂̸ists;戄reater΀;EFGLSTஶஷ஽௉௓௘௥扯qual;扱ullEqual;쀀≧̸reater;쀀≫̸ess;批lantEqual;쀀⩾̸ilde;扵umpń௲௽ownHump;쀀≎̸qual;쀀≏̸eĀfsఊధtTriangleƀ;BEచఛడ拪ar;쀀⧏̸qual;括s̀;EGLSTవశ఼ౄోౘ扮qual;扰reater;扸ess;쀀≪̸lantEqual;쀀⩽̸ilde;扴estedĀGL౨౹reaterGreater;쀀⪢̸essLess;쀀⪡̸recedesƀ;ESಒಓಛ技qual;쀀⪯̸lantEqual;拠ĀeiಫಹverseElement;戌ghtTriangleƀ;BEೋೌ೒拫ar;쀀⧐̸qual;拭ĀquೝഌuareSuĀbp೨೹setĀ;E೰ೳ쀀⊏̸qual;拢ersetĀ;Eഃആ쀀⊐̸qual;拣ƀbcpഓതൎsetĀ;Eഛഞ쀀⊂⃒qual;抈ceedsȀ;ESTലള഻െ抁qual;쀀⪰̸lantEqual;拡ilde;쀀≿̸ersetĀ;E൘൛쀀⊃⃒qual;抉ildeȀ;EFT൮൯൵ൿ扁qual;扄ullEqual;扇ilde;扉erticalBar;戤cr;쀀𝒩ilde耻Ñ䃑;䎝܀Eacdfgmoprstuvලෂ෉෕ෛ෠෧෼ขภยา฿ไlig;䅒cute耻Ó䃓Āiy෎ීrc耻Ô䃔;䐞blac;䅐r;쀀𝔒rave耻Ò䃒ƀaei෮ෲ෶cr;䅌ga;䎩cron;䎟pf;쀀𝕆enCurlyĀDQฎบoubleQuote;怜uote;怘;橔Āclวฬr;쀀𝒪ash耻Ø䃘iŬื฼de耻Õ䃕es;樷ml耻Ö䃖erĀBP๋๠Āar๐๓r;怾acĀek๚๜;揞et;掴arenthesis;揜Ҁacfhilors๿ງຊຏຒດຝະ໼rtialD;戂y;䐟r;쀀𝔓i;䎦;䎠usMinus;䂱Āipຢອncareplanåڝf;愙Ȁ;eio຺ູ໠໤檻cedesȀ;EST່້໏໚扺qual;檯lantEqual;扼ilde;找me;怳Ādp໩໮uct;戏ortionĀ;aȥ໹l;戝Āci༁༆r;쀀𝒫;䎨ȀUfos༑༖༛༟OT耻"䀢r;쀀𝔔pf;愚cr;쀀𝒬؀BEacefhiorsu༾གྷཇའཱིྦྷྪྭ႖ႩႴႾarr;椐G耻®䂮ƀcnrཎནབute;䅔g;柫rĀ;tཛྷཝ憠l;椖ƀaeyཧཬཱron;䅘dil;䅖;䐠Ā;vླྀཹ愜erseĀEUྂྙĀlq྇ྎement;戋uilibrium;懋pEquilibrium;楯r»ཹo;䎡ghtЀACDFTUVa࿁࿫࿳ဢဨၛႇϘĀnr࿆࿒gleBracket;柩rowƀ;BL࿜࿝࿡憒ar;懥eftArrow;懄eiling;按oǵ࿹\0စbleBracket;柧nǔည\0နeeVector;楝ectorĀ;Bဝသ懂ar;楕loor;挋Āerိ၃eƀ;AVဵံြ抢rrow;憦ector;楛iangleƀ;BEၐၑၕ抳ar;槐qual;抵pƀDTVၣၮၸownVector;楏eeVector;楜ectorĀ;Bႂႃ憾ar;楔ectorĀ;B႑႒懀ar;楓Āpuႛ႞f;愝ndImplies;楰ightarrow;懛ĀchႹႼr;愛;憱leDelayed;槴ڀHOacfhimoqstuფჱჷჽᄙᄞᅑᅖᅡᅧᆵᆻᆿĀCcჩხHcy;䐩y;䐨FTcy;䐬cute;䅚ʀ;aeiyᄈᄉᄎᄓᄗ檼ron;䅠dil;䅞rc;䅜;䐡r;쀀𝔖ortȀDLRUᄪᄴᄾᅉownArrow»ОeftArrow»࢚ightArrow»࿝pArrow;憑gma;䎣allCircle;战pf;쀀𝕊ɲᅭ\0\0ᅰt;戚areȀ;ISUᅻᅼᆉᆯ斡ntersection;抓uĀbpᆏᆞsetĀ;Eᆗᆘ抏qual;抑ersetĀ;Eᆨᆩ抐qual;抒nion;抔cr;쀀𝒮ar;拆ȀbcmpᇈᇛሉላĀ;sᇍᇎ拐etĀ;Eᇍᇕqual;抆ĀchᇠህeedsȀ;ESTᇭᇮᇴᇿ扻qual;檰lantEqual;扽ilde;承Tháྌ;我ƀ;esሒሓሣ拑rsetĀ;Eሜም抃qual;抇et»ሓրHRSacfhiorsሾቄ቉ቕ቞ቱቶኟዂወዑORN耻Þ䃞ADE;愢ĀHc቎ቒcy;䐋y;䐦Ābuቚቜ;䀉;䎤ƀaeyብቪቯron;䅤dil;䅢;䐢r;쀀𝔗Āeiቻ኉ǲኀ\0ኇefore;戴a;䎘Ācn኎ኘkSpace;쀀  Space;怉ldeȀ;EFTካኬኲኼ戼qual;扃ullEqual;扅ilde;扈pf;쀀𝕋ipleDot;惛Āctዖዛr;쀀𝒯rok;䅦ૡዷጎጚጦ\0ጬጱ\0\0\0\0\0ጸጽ፷ᎅ\0᏿ᐄᐊᐐĀcrዻጁute耻Ú䃚rĀ;oጇገ憟cir;楉rǣጓ\0጖y;䐎ve;䅬Āiyጞጣrc耻Û䃛;䐣blac;䅰r;쀀𝔘rave耻Ù䃙acr;䅪Ādiፁ፩erĀBPፈ፝Āarፍፐr;䁟acĀekፗፙ;揟et;掵arenthesis;揝onĀ;P፰፱拃lus;抎Āgp፻፿on;䅲f;쀀𝕌ЀADETadps᎕ᎮᎸᏄϨᏒᏗᏳrrowƀ;BDᅐᎠᎤar;椒ownArrow;懅ownArrow;憕quilibrium;楮eeĀ;AᏋᏌ报rrow;憥ownáϳerĀLRᏞᏨeftArrow;憖ightArrow;憗iĀ;lᏹᏺ䏒on;䎥ing;䅮cr;쀀𝒰ilde;䅨ml耻Ü䃜ҀDbcdefosvᐧᐬᐰᐳᐾᒅᒊᒐᒖash;披ar;櫫y;䐒ashĀ;lᐻᐼ抩;櫦Āerᑃᑅ;拁ƀbtyᑌᑐᑺar;怖Ā;iᑏᑕcalȀBLSTᑡᑥᑪᑴar;戣ine;䁼eparator;杘ilde;所ThinSpace;怊r;쀀𝔙pf;쀀𝕍cr;쀀𝒱dash;抪ʀcefosᒧᒬᒱᒶᒼirc;䅴dge;拀r;쀀𝔚pf;쀀𝕎cr;쀀𝒲Ȁfiosᓋᓐᓒᓘr;쀀𝔛;䎞pf;쀀𝕏cr;쀀𝒳ҀAIUacfosuᓱᓵᓹᓽᔄᔏᔔᔚᔠcy;䐯cy;䐇cy;䐮cute耻Ý䃝Āiyᔉᔍrc;䅶;䐫r;쀀𝔜pf;쀀𝕐cr;쀀𝒴ml;䅸ЀHacdefosᔵᔹᔿᕋᕏᕝᕠᕤcy;䐖cute;䅹Āayᕄᕉron;䅽;䐗ot;䅻ǲᕔ\0ᕛoWidtè૙a;䎖r;愨pf;愤cr;쀀𝒵௡ᖃᖊᖐ\0ᖰᖶᖿ\0\0\0\0ᗆᗛᗫᙟ᙭\0ᚕ᚛ᚲᚹ\0ᚾcute耻á䃡reve;䄃̀;Ediuyᖜᖝᖡᖣᖨᖭ戾;쀀∾̳;房rc耻â䃢te肻´̆;䐰lig耻æ䃦Ā;r²ᖺ;쀀𝔞rave耻à䃠ĀepᗊᗖĀfpᗏᗔsym;愵èᗓha;䎱ĀapᗟcĀclᗤᗧr;䄁g;樿ɤᗰ\0\0ᘊʀ;adsvᗺᗻᗿᘁᘇ戧nd;橕;橜lope;橘;橚΀;elmrszᘘᘙᘛᘞᘿᙏᙙ戠;榤e»ᘙsdĀ;aᘥᘦ戡ѡᘰᘲᘴᘶᘸᘺᘼᘾ;榨;榩;榪;榫;榬;榭;榮;榯tĀ;vᙅᙆ戟bĀ;dᙌᙍ抾;榝Āptᙔᙗh;戢»¹arr;捼Āgpᙣᙧon;䄅f;쀀𝕒΀;Eaeiop዁ᙻᙽᚂᚄᚇᚊ;橰cir;橯;扊d;手s;䀧roxĀ;e዁ᚒñᚃing耻å䃥ƀctyᚡᚦᚨr;쀀𝒶;䀪mpĀ;e዁ᚯñʈilde耻ã䃣ml耻ä䃤Āciᛂᛈoninôɲnt;樑ࠀNabcdefiklnoprsu᛭ᛱᜰ᜼ᝃᝈ᝸᝽០៦ᠹᡐᜍ᤽᥈ᥰot;櫭Ācrᛶ᜞kȀcepsᜀᜅᜍᜓong;扌psilon;䏶rime;怵imĀ;e᜚᜛戽q;拍Ŷᜢᜦee;抽edĀ;gᜬᜭ挅e»ᜭrkĀ;t፜᜷brk;掶Āoyᜁᝁ;䐱quo;怞ʀcmprtᝓ᝛ᝡᝤᝨausĀ;eĊĉptyv;榰séᜌnoõēƀahwᝯ᝱ᝳ;䎲;愶een;扬r;쀀𝔟g΀costuvwឍឝឳេ៕៛៞ƀaiuបពរðݠrc;旯p»፱ƀdptឤឨឭot;樀lus;樁imes;樂ɱឹ\0\0ើcup;樆ar;昅riangleĀdu៍្own;施p;斳plus;樄eåᑄåᒭarow;植ƀako៭ᠦᠵĀcn៲ᠣkƀlst៺֫᠂ozenge;槫riangleȀ;dlr᠒᠓᠘᠝斴own;斾eft;旂ight;斸k;搣Ʊᠫ\0ᠳƲᠯ\0ᠱ;斒;斑4;斓ck;斈ĀeoᠾᡍĀ;qᡃᡆ쀀=⃥uiv;쀀≡⃥t;挐Ȁptwxᡙᡞᡧᡬf;쀀𝕓Ā;tᏋᡣom»Ꮜtie;拈؀DHUVbdhmptuvᢅᢖᢪᢻᣗᣛᣬ᣿ᤅᤊᤐᤡȀLRlrᢎᢐᢒᢔ;敗;敔;敖;敓ʀ;DUduᢡᢢᢤᢦᢨ敐;敦;敩;敤;敧ȀLRlrᢳᢵᢷᢹ;敝;敚;敜;教΀;HLRhlrᣊᣋᣍᣏᣑᣓᣕ救;敬;散;敠;敫;敢;敟ox;槉ȀLRlrᣤᣦᣨᣪ;敕;敒;攐;攌ʀ;DUduڽ᣷᣹᣻᣽;敥;敨;攬;攴inus;抟lus;択imes;抠ȀLRlrᤙᤛᤝ᤟;敛;敘;攘;攔΀;HLRhlrᤰᤱᤳᤵᤷ᤻᤹攂;敪;敡;敞;攼;攤;攜Āevģ᥂bar耻¦䂦Ȁceioᥑᥖᥚᥠr;쀀𝒷mi;恏mĀ;e᜚᜜lƀ;bhᥨᥩᥫ䁜;槅sub;柈Ŭᥴ᥾lĀ;e᥹᥺怢t»᥺pƀ;Eeįᦅᦇ;檮Ā;qۜۛೡᦧ\0᧨ᨑᨕᨲ\0ᨷᩐ\0\0᪴\0\0᫁\0\0ᬡᬮ᭍᭒\0᯽\0ᰌƀcpr᦭ᦲ᧝ute;䄇̀;abcdsᦿᧀᧄ᧊᧕᧙戩nd;橄rcup;橉Āau᧏᧒p;橋p;橇ot;橀;쀀∩︀Āeo᧢᧥t;恁îړȀaeiu᧰᧻ᨁᨅǰ᧵\0᧸s;橍on;䄍dil耻ç䃧rc;䄉psĀ;sᨌᨍ橌m;橐ot;䄋ƀdmnᨛᨠᨦil肻¸ƭptyv;榲t脀¢;eᨭᨮ䂢räƲr;쀀𝔠ƀceiᨽᩀᩍy;䑇ckĀ;mᩇᩈ朓ark»ᩈ;䏇r΀;Ecefms᩟᩠ᩢᩫ᪤᪪᪮旋;槃ƀ;elᩩᩪᩭ䋆q;扗eɡᩴ\0\0᪈rrowĀlr᩼᪁eft;憺ight;憻ʀRSacd᪒᪔᪖᪚᪟»ཇ;擈st;抛irc;抚ash;抝nint;樐id;櫯cir;槂ubsĀ;u᪻᪼晣it»᪼ˬ᫇᫔᫺\0ᬊonĀ;eᫍᫎ䀺Ā;qÇÆɭ᫙\0\0᫢aĀ;t᫞᫟䀬;䁀ƀ;fl᫨᫩᫫戁îᅠeĀmx᫱᫶ent»᫩eóɍǧ᫾\0ᬇĀ;dኻᬂot;橭nôɆƀfryᬐᬔᬗ;쀀𝕔oäɔ脀©;sŕᬝr;愗Āaoᬥᬩrr;憵ss;朗Ācuᬲᬷr;쀀𝒸Ābpᬼ᭄Ā;eᭁᭂ櫏;櫑Ā;eᭉᭊ櫐;櫒dot;拯΀delprvw᭠᭬᭷ᮂᮬᯔ᯹arrĀlr᭨᭪;椸;椵ɰ᭲\0\0᭵r;拞c;拟arrĀ;p᭿ᮀ憶;椽̀;bcdosᮏᮐᮖᮡᮥᮨ截rcap;橈Āauᮛᮞp;橆p;橊ot;抍r;橅;쀀∪︀Ȁalrv᮵ᮿᯞᯣrrĀ;mᮼᮽ憷;椼yƀevwᯇᯔᯘqɰᯎ\0\0ᯒreã᭳uã᭵ee;拎edge;拏en耻¤䂤earrowĀlrᯮ᯳eft»ᮀight»ᮽeäᯝĀciᰁᰇoninôǷnt;戱lcty;挭ঀAHabcdefhijlorstuwz᰸᰻᰿ᱝᱩᱵᲊᲞᲬᲷ᳻᳿ᴍᵻᶑᶫᶻ᷆᷍rò΁ar;楥Ȁglrs᱈ᱍ᱒᱔ger;怠eth;愸òᄳhĀ;vᱚᱛ怐»ऊūᱡᱧarow;椏aã̕Āayᱮᱳron;䄏;䐴ƀ;ao̲ᱼᲄĀgrʿᲁr;懊tseq;橷ƀglmᲑᲔᲘ耻°䂰ta;䎴ptyv;榱ĀirᲣᲨsht;楿;쀀𝔡arĀlrᲳᲵ»ࣜ»သʀaegsv᳂͸᳖᳜᳠mƀ;oș᳊᳔ndĀ;ș᳑uit;晦amma;䏝in;拲ƀ;io᳧᳨᳸䃷de脀÷;o᳧ᳰntimes;拇nø᳷cy;䑒cɯᴆ\0\0ᴊrn;挞op;挍ʀlptuwᴘᴝᴢᵉᵕlar;䀤f;쀀𝕕ʀ;emps̋ᴭᴷᴽᵂqĀ;d͒ᴳot;扑inus;戸lus;戔quare;抡blebarwedgåúnƀadhᄮᵝᵧownarrowóᲃarpoonĀlrᵲᵶefôᲴighôᲶŢᵿᶅkaro÷གɯᶊ\0\0ᶎrn;挟op;挌ƀcotᶘᶣᶦĀryᶝᶡ;쀀𝒹;䑕l;槶rok;䄑Ādrᶰᶴot;拱iĀ;fᶺ᠖斿Āah᷀᷃ròЩaòྦangle;榦Āci᷒ᷕy;䑟grarr;柿ऀDacdefglmnopqrstuxḁḉḙḸոḼṉṡṾấắẽỡἪἷὄ὎὚ĀDoḆᴴoôᲉĀcsḎḔute耻é䃩ter;橮ȀaioyḢḧḱḶron;䄛rĀ;cḭḮ扖耻ê䃪lon;払;䑍ot;䄗ĀDrṁṅot;扒;쀀𝔢ƀ;rsṐṑṗ檚ave耻è䃨Ā;dṜṝ檖ot;檘Ȁ;ilsṪṫṲṴ檙nters;揧;愓Ā;dṹṺ檕ot;檗ƀapsẅẉẗcr;䄓tyƀ;svẒẓẕ戅et»ẓpĀ1;ẝẤĳạả;怄;怅怃ĀgsẪẬ;䅋p;怂ĀgpẴẸon;䄙f;쀀𝕖ƀalsỄỎỒrĀ;sỊị拕l;槣us;橱iƀ;lvỚớở䎵on»ớ;䏵ȀcsuvỪỳἋἣĀioữḱrc»Ḯɩỹ\0\0ỻíՈantĀglἂἆtr»ṝess»Ṻƀaeiἒ἖Ἒls;䀽st;扟vĀ;DȵἠD;橸parsl;槥ĀDaἯἳot;打rr;楱ƀcdiἾὁỸr;愯oô͒ĀahὉὋ;䎷耻ð䃰Āmrὓὗl耻ë䃫o;悬ƀcipὡὤὧl;䀡sôծĀeoὬὴctatioîՙnentialåչৡᾒ\0ᾞ\0ᾡᾧ\0\0ῆῌ\0ΐ\0ῦῪ \0 ⁚llingdotseñṄy;䑄male;晀ƀilrᾭᾳ῁lig;耀ﬃɩᾹ\0\0᾽g;耀ﬀig;耀ﬄ;쀀𝔣lig;耀ﬁlig;쀀fjƀaltῙ῜ῡt;晭ig;耀ﬂns;斱of;䆒ǰ΅\0ῳf;쀀𝕗ĀakֿῷĀ;vῼ´拔;櫙artint;樍Āao‌⁕Ācs‑⁒α‚‰‸⁅⁈\0⁐β•‥‧‪‬\0‮耻½䂽;慓耻¼䂼;慕;慙;慛Ƴ‴\0‶;慔;慖ʴ‾⁁\0\0⁃耻¾䂾;慗;慜5;慘ƶ⁌\0⁎;慚;慝8;慞l;恄wn;挢cr;쀀𝒻ࢀEabcdefgijlnorstv₂₉₟₥₰₴⃰⃵⃺⃿℃ℒℸ̗ℾ⅒↞Ā;lٍ₇;檌ƀcmpₐₕ₝ute;䇵maĀ;dₜ᳚䎳;檆reve;䄟Āiy₪₮rc;䄝;䐳ot;䄡Ȁ;lqsؾق₽⃉ƀ;qsؾٌ⃄lanô٥Ȁ;cdl٥⃒⃥⃕c;檩otĀ;o⃜⃝檀Ā;l⃢⃣檂;檄Ā;e⃪⃭쀀⋛︀s;檔r;쀀𝔤Ā;gٳ؛mel;愷cy;䑓Ȁ;Eajٚℌℎℐ;檒;檥;檤ȀEaesℛℝ℩ℴ;扩pĀ;p℣ℤ檊rox»ℤĀ;q℮ℯ檈Ā;q℮ℛim;拧pf;쀀𝕘Āci⅃ⅆr;愊mƀ;el٫ⅎ⅐;檎;檐茀>;cdlqr׮ⅠⅪⅮⅳⅹĀciⅥⅧ;檧r;橺ot;拗Par;榕uest;橼ʀadelsↄⅪ←ٖ↛ǰ↉\0↎proø₞r;楸qĀlqؿ↖lesó₈ií٫Āen↣↭rtneqq;쀀≩︀Å↪ԀAabcefkosy⇄⇇⇱⇵⇺∘∝∯≨≽ròΠȀilmr⇐⇔⇗⇛rsðᒄf»․ilôکĀdr⇠⇤cy;䑊ƀ;cwࣴ⇫⇯ir;楈;憭ar;意irc;䄥ƀalr∁∎∓rtsĀ;u∉∊晥it»∊lip;怦con;抹r;쀀𝔥sĀew∣∩arow;椥arow;椦ʀamopr∺∾≃≞≣rr;懿tht;戻kĀlr≉≓eftarrow;憩ightarrow;憪f;쀀𝕙bar;怕ƀclt≯≴≸r;쀀𝒽asè⇴rok;䄧Ābp⊂⊇ull;恃hen»ᱛૡ⊣\0⊪\0⊸⋅⋎\0⋕⋳\0\0⋸⌢⍧⍢⍿\0⎆⎪⎴cute耻í䃭ƀ;iyݱ⊰⊵rc耻î䃮;䐸Ācx⊼⊿y;䐵cl耻¡䂡ĀfrΟ⋉;쀀𝔦rave耻ì䃬Ȁ;inoܾ⋝⋩⋮Āin⋢⋦nt;樌t;戭fin;槜ta;愩lig;䄳ƀaop⋾⌚⌝ƀcgt⌅⌈⌗r;䄫ƀelpܟ⌏⌓inåގarôܠh;䄱f;抷ed;䆵ʀ;cfotӴ⌬⌱⌽⍁are;愅inĀ;t⌸⌹戞ie;槝doô⌙ʀ;celpݗ⍌⍐⍛⍡al;抺Āgr⍕⍙eróᕣã⍍arhk;樗rod;樼Ȁcgpt⍯⍲⍶⍻y;䑑on;䄯f;쀀𝕚a;䎹uest耻¿䂿Āci⎊⎏r;쀀𝒾nʀ;EdsvӴ⎛⎝⎡ӳ;拹ot;拵Ā;v⎦⎧拴;拳Ā;iݷ⎮lde;䄩ǫ⎸\0⎼cy;䑖l耻ï䃯̀cfmosu⏌⏗⏜⏡⏧⏵Āiy⏑⏕rc;䄵;䐹r;쀀𝔧ath;䈷pf;쀀𝕛ǣ⏬\0⏱r;쀀𝒿rcy;䑘kcy;䑔Ѐacfghjos␋␖␢␧␭␱␵␻ppaĀ;v␓␔䎺;䏰Āey␛␠dil;䄷;䐺r;쀀𝔨reen;䄸cy;䑅cy;䑜pf;쀀𝕜cr;쀀𝓀஀ABEHabcdefghjlmnoprstuv⑰⒁⒆⒍⒑┎┽╚▀♎♞♥♹♽⚚⚲⛘❝❨➋⟀⠁⠒ƀart⑷⑺⑼rò৆òΕail;椛arr;椎Ā;gঔ⒋;檋ar;楢ॣ⒥\0⒪\0⒱\0\0\0\0\0⒵Ⓔ\0ⓆⓈⓍ\0⓹ute;䄺mptyv;榴raîࡌbda;䎻gƀ;dlࢎⓁⓃ;榑åࢎ;檅uo耻«䂫rЀ;bfhlpst࢙ⓞⓦⓩ⓫⓮⓱⓵Ā;f࢝ⓣs;椟s;椝ë≒p;憫l;椹im;楳l;憢ƀ;ae⓿─┄檫il;椙Ā;s┉┊檭;쀀⪭︀ƀabr┕┙┝rr;椌rk;杲Āak┢┬cĀek┨┪;䁻;䁛Āes┱┳;榋lĀdu┹┻;榏;榍Ȁaeuy╆╋╖╘ron;䄾Ādi═╔il;䄼ìࢰâ┩;䐻Ȁcqrs╣╦╭╽a;椶uoĀ;rนᝆĀdu╲╷har;楧shar;楋h;憲ʀ;fgqs▋▌উ◳◿扤tʀahlrt▘▤▷◂◨rrowĀ;t࢙□aé⓶arpoonĀdu▯▴own»њp»०eftarrows;懇ightƀahs◍◖◞rrowĀ;sࣴࢧarpoonó྘quigarro÷⇰hreetimes;拋ƀ;qs▋ও◺lanôবʀ;cdgsব☊☍☝☨c;檨otĀ;o☔☕橿Ā;r☚☛檁;檃Ā;e☢☥쀀⋚︀s;檓ʀadegs☳☹☽♉♋pproøⓆot;拖qĀgq♃♅ôউgtò⒌ôছiíলƀilr♕࣡♚sht;楼;쀀𝔩Ā;Eজ♣;檑š♩♶rĀdu▲♮Ā;l॥♳;楪lk;斄cy;䑙ʀ;achtੈ⚈⚋⚑⚖rò◁orneòᴈard;楫ri;旺Āio⚟⚤dot;䅀ustĀ;a⚬⚭掰che»⚭ȀEaes⚻⚽⛉⛔;扨pĀ;p⛃⛄檉rox»⛄Ā;q⛎⛏檇Ā;q⛎⚻im;拦Ѐabnoptwz⛩⛴⛷✚✯❁❇❐Ānr⛮⛱g;柬r;懽rëࣁgƀlmr⛿✍✔eftĀar০✇ightá৲apsto;柼ightá৽parrowĀlr✥✩efô⓭ight;憬ƀafl✶✹✽r;榅;쀀𝕝us;樭imes;樴š❋❏st;戗áፎƀ;ef❗❘᠀旊nge»❘arĀ;l❤❥䀨t;榓ʀachmt❳❶❼➅➇ròࢨorneòᶌarĀ;d྘➃;業;怎ri;抿̀achiqt➘➝ੀ➢➮➻quo;怹r;쀀𝓁mƀ;egল➪➬;檍;檏Ābu┪➳oĀ;rฟ➹;怚rok;䅂萀<;cdhilqrࠫ⟒☹⟜⟠⟥⟪⟰Āci⟗⟙;檦r;橹reå◲mes;拉arr;楶uest;橻ĀPi⟵⟹ar;榖ƀ;ef⠀भ᠛旃rĀdu⠇⠍shar;楊har;楦Āen⠗⠡rtneqq;쀀≨︀Å⠞܀Dacdefhilnopsu⡀⡅⢂⢎⢓⢠⢥⢨⣚⣢⣤ઃ⣳⤂Dot;戺Ȁclpr⡎⡒⡣⡽r耻¯䂯Āet⡗⡙;時Ā;e⡞⡟朠se»⡟Ā;sျ⡨toȀ;dluျ⡳⡷⡻owîҌefôएðᏑker;斮Āoy⢇⢌mma;権;䐼ash;怔asuredangle»ᘦr;쀀𝔪o;愧ƀcdn⢯⢴⣉ro耻µ䂵Ȁ;acdᑤ⢽⣀⣄sôᚧir;櫰ot肻·Ƶusƀ;bd⣒ᤃ⣓戒Ā;uᴼ⣘;横ţ⣞⣡p;櫛ò−ðઁĀdp⣩⣮els;抧f;쀀𝕞Āct⣸⣽r;쀀𝓂pos»ᖝƀ;lm⤉⤊⤍䎼timap;抸ఀGLRVabcdefghijlmoprstuvw⥂⥓⥾⦉⦘⧚⧩⨕⨚⩘⩝⪃⪕⪤⪨⬄⬇⭄⭿⮮ⰴⱧⱼ⳩Āgt⥇⥋;쀀⋙̸Ā;v⥐௏쀀≫⃒ƀelt⥚⥲⥶ftĀar⥡⥧rrow;懍ightarrow;懎;쀀⋘̸Ā;v⥻ే쀀≪⃒ightarrow;懏ĀDd⦎⦓ash;抯ash;抮ʀbcnpt⦣⦧⦬⦱⧌la»˞ute;䅄g;쀀∠⃒ʀ;Eiop඄⦼⧀⧅⧈;쀀⩰̸d;쀀≋̸s;䅉roø඄urĀ;a⧓⧔普lĀ;s⧓ସǳ⧟\0⧣p肻 ଷmpĀ;e௹ఀʀaeouy⧴⧾⨃⨐⨓ǰ⧹\0⧻;橃on;䅈dil;䅆ngĀ;dൾ⨊ot;쀀⩭̸p;橂;䐽ash;怓΀;Aadqsxஒ⨩⨭⨻⩁⩅⩐rr;懗rĀhr⨳⨶k;椤Ā;oᏲᏰot;쀀≐̸uiöୣĀei⩊⩎ar;椨í஘istĀ;s஠டr;쀀𝔫ȀEest௅⩦⩹⩼ƀ;qs஼⩭௡ƀ;qs஼௅⩴lanô௢ií௪Ā;rஶ⪁»ஷƀAap⪊⪍⪑rò⥱rr;憮ar;櫲ƀ;svྍ⪜ྌĀ;d⪡⪢拼;拺cy;䑚΀AEadest⪷⪺⪾⫂⫅⫶⫹rò⥦;쀀≦̸rr;憚r;急Ȁ;fqs఻⫎⫣⫯tĀar⫔⫙rro÷⫁ightarro÷⪐ƀ;qs఻⪺⫪lanôౕĀ;sౕ⫴»శiíౝĀ;rవ⫾iĀ;eచథiäඐĀpt⬌⬑f;쀀𝕟膀¬;in⬙⬚⬶䂬nȀ;Edvஉ⬤⬨⬮;쀀⋹̸ot;쀀⋵̸ǡஉ⬳⬵;拷;拶iĀ;vಸ⬼ǡಸ⭁⭃;拾;拽ƀaor⭋⭣⭩rȀ;ast୻⭕⭚⭟lleì୻l;쀀⫽⃥;쀀∂̸lint;樔ƀ;ceಒ⭰⭳uåಥĀ;cಘ⭸Ā;eಒ⭽ñಘȀAait⮈⮋⮝⮧rò⦈rrƀ;cw⮔⮕⮙憛;쀀⤳̸;쀀↝̸ghtarrow»⮕riĀ;eೋೖ΀chimpqu⮽⯍⯙⬄୸⯤⯯Ȁ;cerല⯆ഷ⯉uå൅;쀀𝓃ortɭ⬅\0\0⯖ará⭖mĀ;e൮⯟Ā;q൴൳suĀbp⯫⯭å೸åഋƀbcp⯶ⰑⰙȀ;Ees⯿ⰀഢⰄ抄;쀀⫅̸etĀ;eഛⰋqĀ;qണⰀcĀ;eലⰗñസȀ;EesⰢⰣൟⰧ抅;쀀⫆̸etĀ;e൘ⰮqĀ;qൠⰣȀgilrⰽⰿⱅⱇìௗlde耻ñ䃱çృiangleĀlrⱒⱜeftĀ;eచⱚñదightĀ;eೋⱥñ೗Ā;mⱬⱭ䎽ƀ;esⱴⱵⱹ䀣ro;愖p;怇ҀDHadgilrsⲏⲔⲙⲞⲣⲰⲶⳓⳣash;抭arr;椄p;쀀≍⃒ash;抬ĀetⲨⲬ;쀀≥⃒;쀀>⃒nfin;槞ƀAetⲽⳁⳅrr;椂;쀀≤⃒Ā;rⳊⳍ쀀<⃒ie;쀀⊴⃒ĀAtⳘⳜrr;椃rie;쀀⊵⃒im;쀀∼⃒ƀAan⳰⳴ⴂrr;懖rĀhr⳺⳽k;椣Ā;oᏧᏥear;椧ቓ᪕\0\0\0\0\0\0\0\0\0\0\0\0\0ⴭ\0ⴸⵈⵠⵥ⵲ⶄᬇ\0\0ⶍⶫ\0ⷈⷎ\0ⷜ⸙⸫⸾⹃Ācsⴱ᪗ute耻ó䃳ĀiyⴼⵅrĀ;c᪞ⵂ耻ô䃴;䐾ʀabios᪠ⵒⵗǈⵚlac;䅑v;樸old;榼lig;䅓Ācr⵩⵭ir;榿;쀀𝔬ͯ⵹\0\0⵼\0ⶂn;䋛ave耻ò䃲;槁Ābmⶈ෴ar;榵Ȁacitⶕ⶘ⶥⶨrò᪀Āir⶝ⶠr;榾oss;榻nå๒;槀ƀaeiⶱⶵⶹcr;䅍ga;䏉ƀcdnⷀⷅǍron;䎿;榶pf;쀀𝕠ƀaelⷔ⷗ǒr;榷rp;榹΀;adiosvⷪⷫⷮ⸈⸍⸐⸖戨rò᪆Ȁ;efmⷷⷸ⸂⸅橝rĀ;oⷾⷿ愴f»ⷿ耻ª䂪耻º䂺gof;抶r;橖lope;橗;橛ƀclo⸟⸡⸧ò⸁ash耻ø䃸l;折iŬⸯ⸴de耻õ䃵esĀ;aǛ⸺s;樶ml耻ö䃶bar;挽ૡ⹞\0⹽\0⺀⺝\0⺢⺹\0\0⻋ຜ\0⼓\0\0⼫⾼\0⿈rȀ;astЃ⹧⹲຅脀¶;l⹭⹮䂶leìЃɩ⹸\0\0⹻m;櫳;櫽y;䐿rʀcimpt⺋⺏⺓ᡥ⺗nt;䀥od;䀮il;怰enk;怱r;쀀𝔭ƀimo⺨⺰⺴Ā;v⺭⺮䏆;䏕maô੶ne;明ƀ;tv⺿⻀⻈䏀chfork»´;䏖Āau⻏⻟nĀck⻕⻝kĀ;h⇴⻛;愎ö⇴sҀ;abcdemst⻳⻴ᤈ⻹⻽⼄⼆⼊⼎䀫cir;樣ir;樢Āouᵀ⼂;樥;橲n肻±ຝim;樦wo;樧ƀipu⼙⼠⼥ntint;樕f;쀀𝕡nd耻£䂣Ԁ;Eaceinosu່⼿⽁⽄⽇⾁⾉⾒⽾⾶;檳p;檷uå໙Ā;c໎⽌̀;acens່⽙⽟⽦⽨⽾pproø⽃urlyeñ໙ñ໎ƀaes⽯⽶⽺pprox;檹qq;檵im;拨iíໟmeĀ;s⾈ຮ怲ƀEas⽸⾐⽺ð⽵ƀdfp໬⾙⾯ƀals⾠⾥⾪lar;挮ine;挒urf;挓Ā;t໻⾴ï໻rel;抰Āci⿀⿅r;쀀𝓅;䏈ncsp;怈̀fiopsu⿚⋢⿟⿥⿫⿱r;쀀𝔮pf;쀀𝕢rime;恗cr;쀀𝓆ƀaeo⿸〉〓tĀei⿾々rnionóڰnt;樖stĀ;e【】䀿ñἙô༔઀ABHabcdefhilmnoprstux぀けさすムㄎㄫㅇㅢㅲㆎ㈆㈕㈤㈩㉘㉮㉲㊐㊰㊷ƀartぇおがròႳòϝail;検aròᱥar;楤΀cdenqrtとふへみわゔヌĀeuねぱ;쀀∽̱te;䅕iãᅮmptyv;榳gȀ;del࿑らるろ;榒;榥å࿑uo耻»䂻rր;abcfhlpstw࿜ガクシスゼゾダッデナp;極Ā;f࿠ゴs;椠;椳s;椞ë≝ð✮l;楅im;楴l;憣;憝Āaiパフil;椚oĀ;nホボ戶aló༞ƀabrョリヮrò៥rk;杳ĀakンヽcĀekヹ・;䁽;䁝Āes㄂㄄;榌lĀduㄊㄌ;榎;榐Ȁaeuyㄗㄜㄧㄩron;䅙Ādiㄡㄥil;䅗ì࿲âヺ;䑀Ȁclqsㄴㄷㄽㅄa;椷dhar;楩uoĀ;rȎȍh;憳ƀacgㅎㅟངlȀ;ipsླྀㅘㅛႜnåႻarôྩt;断ƀilrㅩဣㅮsht;楽;쀀𝔯ĀaoㅷㆆrĀduㅽㅿ»ѻĀ;l႑ㆄ;楬Ā;vㆋㆌ䏁;䏱ƀgns㆕ㇹㇼht̀ahlrstㆤㆰ㇂㇘㇤㇮rrowĀ;t࿜ㆭaéトarpoonĀduㆻㆿowîㅾp»႒eftĀah㇊㇐rrowó࿪arpoonóՑightarrows;應quigarro÷ニhreetimes;拌g;䋚ingdotseñἲƀahm㈍㈐㈓rò࿪aòՑ;怏oustĀ;a㈞㈟掱che»㈟mid;櫮Ȁabpt㈲㈽㉀㉒Ānr㈷㈺g;柭r;懾rëဃƀafl㉇㉊㉎r;榆;쀀𝕣us;樮imes;樵Āap㉝㉧rĀ;g㉣㉤䀩t;榔olint;樒arò㇣Ȁachq㉻㊀Ⴜ㊅quo;怺r;쀀𝓇Ābu・㊊oĀ;rȔȓƀhir㊗㊛㊠reåㇸmes;拊iȀ;efl㊪ၙᠡ㊫方tri;槎luhar;楨;愞ൡ㋕㋛㋟㌬㌸㍱\0㍺㎤\0\0㏬㏰\0㐨㑈㑚㒭㒱㓊㓱\0㘖\0\0㘳cute;䅛quï➺Ԁ;Eaceinpsyᇭ㋳㋵㋿㌂㌋㌏㌟㌦㌩;檴ǰ㋺\0㋼;檸on;䅡uåᇾĀ;dᇳ㌇il;䅟rc;䅝ƀEas㌖㌘㌛;檶p;檺im;择olint;樓iíሄ;䑁otƀ;be㌴ᵇ㌵担;橦΀Aacmstx㍆㍊㍗㍛㍞㍣㍭rr;懘rĀhr㍐㍒ë∨Ā;oਸ਼਴t耻§䂧i;䀻war;椩mĀin㍩ðnuóñt;朶rĀ;o㍶⁕쀀𝔰Ȁacoy㎂㎆㎑㎠rp;景Āhy㎋㎏cy;䑉;䑈rtɭ㎙\0\0㎜iäᑤaraì⹯耻­䂭Āgm㎨㎴maƀ;fv㎱㎲㎲䏃;䏂Ѐ;deglnprካ㏅㏉㏎㏖㏞㏡㏦ot;橪Ā;q኱ኰĀ;E㏓㏔檞;檠Ā;E㏛㏜檝;檟e;扆lus;樤arr;楲aròᄽȀaeit㏸㐈㐏㐗Āls㏽㐄lsetmé㍪hp;樳parsl;槤Ādlᑣ㐔e;挣Ā;e㐜㐝檪Ā;s㐢㐣檬;쀀⪬︀ƀflp㐮㐳㑂tcy;䑌Ā;b㐸㐹䀯Ā;a㐾㐿槄r;挿f;쀀𝕤aĀdr㑍ЂesĀ;u㑔㑕晠it»㑕ƀcsu㑠㑹㒟Āau㑥㑯pĀ;sᆈ㑫;쀀⊓︀pĀ;sᆴ㑵;쀀⊔︀uĀbp㑿㒏ƀ;esᆗᆜ㒆etĀ;eᆗ㒍ñᆝƀ;esᆨᆭ㒖etĀ;eᆨ㒝ñᆮƀ;afᅻ㒦ְrť㒫ֱ»ᅼaròᅈȀcemt㒹㒾㓂㓅r;쀀𝓈tmîñiì㐕aræᆾĀar㓎㓕rĀ;f㓔ឿ昆Āan㓚㓭ightĀep㓣㓪psiloîỠhé⺯s»⡒ʀbcmnp㓻㕞ሉ㖋㖎Ҁ;Edemnprs㔎㔏㔑㔕㔞㔣㔬㔱㔶抂;櫅ot;檽Ā;dᇚ㔚ot;櫃ult;櫁ĀEe㔨㔪;櫋;把lus;檿arr;楹ƀeiu㔽㕒㕕tƀ;en㔎㕅㕋qĀ;qᇚ㔏eqĀ;q㔫㔨m;櫇Ābp㕚㕜;櫕;櫓c̀;acensᇭ㕬㕲㕹㕻㌦pproø㋺urlyeñᇾñᇳƀaes㖂㖈㌛pproø㌚qñ㌗g;晪ڀ123;Edehlmnps㖩㖬㖯ሜ㖲㖴㗀㗉㗕㗚㗟㗨㗭耻¹䂹耻²䂲耻³䂳;櫆Āos㖹㖼t;檾ub;櫘Ā;dሢ㗅ot;櫄sĀou㗏㗒l;柉b;櫗arr;楻ult;櫂ĀEe㗤㗦;櫌;抋lus;櫀ƀeiu㗴㘉㘌tƀ;enሜ㗼㘂qĀ;qሢ㖲eqĀ;q㗧㗤m;櫈Ābp㘑㘓;櫔;櫖ƀAan㘜㘠㘭rr;懙rĀhr㘦㘨ë∮Ā;oਫ਩war;椪lig耻ß䃟௡㙑㙝㙠ዎ㙳㙹\0㙾㛂\0\0\0\0\0㛛㜃\0㜉㝬\0\0\0㞇ɲ㙖\0\0㙛get;挖;䏄rë๟ƀaey㙦㙫㙰ron;䅥dil;䅣;䑂lrec;挕r;쀀𝔱Ȁeiko㚆㚝㚵㚼ǲ㚋\0㚑eĀ4fኄኁaƀ;sv㚘㚙㚛䎸ym;䏑Ācn㚢㚲kĀas㚨㚮pproø዁im»ኬsðኞĀas㚺㚮ð዁rn耻þ䃾Ǭ̟㛆⋧es膀×;bd㛏㛐㛘䃗Ā;aᤏ㛕r;樱;樰ƀeps㛡㛣㜀á⩍Ȁ;bcf҆㛬㛰㛴ot;挶ir;櫱Ā;o㛹㛼쀀𝕥rk;櫚á㍢rime;怴ƀaip㜏㜒㝤dåቈ΀adempst㜡㝍㝀㝑㝗㝜㝟ngleʀ;dlqr㜰㜱㜶㝀㝂斵own»ᶻeftĀ;e⠀㜾ñम;扜ightĀ;e㊪㝋ñၚot;旬inus;樺lus;樹b;槍ime;樻ezium;揢ƀcht㝲㝽㞁Āry㝷㝻;쀀𝓉;䑆cy;䑛rok;䅧Āio㞋㞎xô᝷headĀlr㞗㞠eftarro÷ࡏightarrow»ཝऀAHabcdfghlmoprstuw㟐㟓㟗㟤㟰㟼㠎㠜㠣㠴㡑㡝㡫㢩㣌㣒㣪㣶ròϭar;楣Ācr㟜㟢ute耻ú䃺òᅐrǣ㟪\0㟭y;䑞ve;䅭Āiy㟵㟺rc耻û䃻;䑃ƀabh㠃㠆㠋ròᎭlac;䅱aòᏃĀir㠓㠘sht;楾;쀀𝔲rave耻ù䃹š㠧㠱rĀlr㠬㠮»ॗ»ႃlk;斀Āct㠹㡍ɯ㠿\0\0㡊rnĀ;e㡅㡆挜r»㡆op;挏ri;旸Āal㡖㡚cr;䅫肻¨͉Āgp㡢㡦on;䅳f;쀀𝕦̀adhlsuᅋ㡸㡽፲㢑㢠ownáᎳarpoonĀlr㢈㢌efô㠭ighô㠯iƀ;hl㢙㢚㢜䏅»ᏺon»㢚parrows;懈ƀcit㢰㣄㣈ɯ㢶\0\0㣁rnĀ;e㢼㢽挝r»㢽op;挎ng;䅯ri;旹cr;쀀𝓊ƀdir㣙㣝㣢ot;拰lde;䅩iĀ;f㜰㣨»᠓Āam㣯㣲rò㢨l耻ü䃼angle;榧ހABDacdeflnoprsz㤜㤟㤩㤭㦵㦸㦽㧟㧤㧨㧳㧹㧽㨁㨠ròϷarĀ;v㤦㤧櫨;櫩asèϡĀnr㤲㤷grt;榜΀eknprst㓣㥆㥋㥒㥝㥤㦖appá␕othinçẖƀhir㓫⻈㥙opô⾵Ā;hᎷ㥢ïㆍĀiu㥩㥭gmá㎳Ābp㥲㦄setneqĀ;q㥽㦀쀀⊊︀;쀀⫋︀setneqĀ;q㦏㦒쀀⊋︀;쀀⫌︀Āhr㦛㦟etá㚜iangleĀlr㦪㦯eft»थight»ၑy;䐲ash»ံƀelr㧄㧒㧗ƀ;beⷪ㧋㧏ar;抻q;扚lip;拮Ābt㧜ᑨaòᑩr;쀀𝔳tré㦮suĀbp㧯㧱»ജ»൙pf;쀀𝕧roð໻tré㦴Ācu㨆㨋r;쀀𝓋Ābp㨐㨘nĀEe㦀㨖»㥾nĀEe㦒㨞»㦐igzag;榚΀cefoprs㨶㨻㩖㩛㩔㩡㩪irc;䅵Ādi㩀㩑Ābg㩅㩉ar;機eĀ;qᗺ㩏;扙erp;愘r;쀀𝔴pf;쀀𝕨Ā;eᑹ㩦atèᑹcr;쀀𝓌ૣណ㪇\0㪋\0㪐㪛\0\0㪝㪨㪫㪯\0\0㫃㫎\0㫘ៜ៟tré៑r;쀀𝔵ĀAa㪔㪗ròσrò৶;䎾ĀAa㪡㪤ròθrò৫að✓is;拻ƀdptឤ㪵㪾Āfl㪺ឩ;쀀𝕩imåឲĀAa㫇㫊ròώròਁĀcq㫒ីr;쀀𝓍Āpt៖㫜ré។Ѐacefiosu㫰㫽㬈㬌㬑㬕㬛㬡cĀuy㫶㫻te耻ý䃽;䑏Āiy㬂㬆rc;䅷;䑋n耻¥䂥r;쀀𝔶cy;䑗pf;쀀𝕪cr;쀀𝓎Ācm㬦㬩y;䑎l耻ÿ䃿Ԁacdefhiosw㭂㭈㭔㭘㭤㭩㭭㭴㭺㮀cute;䅺Āay㭍㭒ron;䅾;䐷ot;䅼Āet㭝㭡træᕟa;䎶r;쀀𝔷cy;䐶grarr;懝pf;쀀𝕫cr;쀀𝓏Ājn㮅㮇;怍j;怌'.split("").map((e) => e.charCodeAt(0))
), O9 = new Uint16Array(
  // prettier-ignore
  "Ȁaglq	\x1Bɭ\0\0p;䀦os;䀧t;䀾t;䀼uot;䀢".split("").map((e) => e.charCodeAt(0))
);
var Is;
const I9 = /* @__PURE__ */ new Map([
  [0, 65533],
  // C1 Unicode control character reference replacements
  [128, 8364],
  [130, 8218],
  [131, 402],
  [132, 8222],
  [133, 8230],
  [134, 8224],
  [135, 8225],
  [136, 710],
  [137, 8240],
  [138, 352],
  [139, 8249],
  [140, 338],
  [142, 381],
  [145, 8216],
  [146, 8217],
  [147, 8220],
  [148, 8221],
  [149, 8226],
  [150, 8211],
  [151, 8212],
  [152, 732],
  [153, 8482],
  [154, 353],
  [155, 8250],
  [156, 339],
  [158, 382],
  [159, 376]
]), M9 = (
  // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition, node/no-unsupported-features/es-builtins
  (Is = String.fromCodePoint) !== null && Is !== void 0 ? Is : function(e) {
    let t = "";
    return e > 65535 && (e -= 65536, t += String.fromCharCode(e >>> 10 & 1023 | 55296), e = 56320 | e & 1023), t += String.fromCharCode(e), t;
  }
);
function P9(e) {
  var t;
  return e >= 55296 && e <= 57343 || e > 1114111 ? 65533 : (t = I9.get(e)) !== null && t !== void 0 ? t : e;
}
var Et;
(function(e) {
  e[e.NUM = 35] = "NUM", e[e.SEMI = 59] = "SEMI", e[e.EQUALS = 61] = "EQUALS", e[e.ZERO = 48] = "ZERO", e[e.NINE = 57] = "NINE", e[e.LOWER_A = 97] = "LOWER_A", e[e.LOWER_F = 102] = "LOWER_F", e[e.LOWER_X = 120] = "LOWER_X", e[e.LOWER_Z = 122] = "LOWER_Z", e[e.UPPER_A = 65] = "UPPER_A", e[e.UPPER_F = 70] = "UPPER_F", e[e.UPPER_Z = 90] = "UPPER_Z";
})(Et || (Et = {}));
const R9 = 32;
var rr;
(function(e) {
  e[e.VALUE_LENGTH = 49152] = "VALUE_LENGTH", e[e.BRANCH_LENGTH = 16256] = "BRANCH_LENGTH", e[e.JUMP_TABLE = 127] = "JUMP_TABLE";
})(rr || (rr = {}));
function Hc(e) {
  return e >= Et.ZERO && e <= Et.NINE;
}
function B9(e) {
  return e >= Et.UPPER_A && e <= Et.UPPER_F || e >= Et.LOWER_A && e <= Et.LOWER_F;
}
function F9(e) {
  return e >= Et.UPPER_A && e <= Et.UPPER_Z || e >= Et.LOWER_A && e <= Et.LOWER_Z || Hc(e);
}
function H9(e) {
  return e === Et.EQUALS || F9(e);
}
var _t;
(function(e) {
  e[e.EntityStart = 0] = "EntityStart", e[e.NumericStart = 1] = "NumericStart", e[e.NumericDecimal = 2] = "NumericDecimal", e[e.NumericHex = 3] = "NumericHex", e[e.NamedEntity = 4] = "NamedEntity";
})(_t || (_t = {}));
var nn;
(function(e) {
  e[e.Legacy = 0] = "Legacy", e[e.Strict = 1] = "Strict", e[e.Attribute = 2] = "Attribute";
})(nn || (nn = {}));
class Cv {
  constructor(t, n, r) {
    this.decodeTree = t, this.emitCodePoint = n, this.errors = r, this.state = _t.EntityStart, this.consumed = 1, this.result = 0, this.treeIndex = 0, this.excess = 1, this.decodeMode = nn.Strict;
  }
  /** Resets the instance to make it reusable. */
  startEntity(t) {
    this.decodeMode = t, this.state = _t.EntityStart, this.result = 0, this.treeIndex = 0, this.excess = 1, this.consumed = 1;
  }
  /**
   * Write an entity to the decoder. This can be called multiple times with partial entities.
   * If the entity is incomplete, the decoder will return -1.
   *
   * Mirrors the implementation of `getDecoder`, but with the ability to stop decoding if the
   * entity is incomplete, and resume when the next string is written.
   *
   * @param string The string containing the entity (or a continuation of the entity).
   * @param offset The offset at which the entity begins. Should be 0 if this is not the first call.
   * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
   */
  write(t, n) {
    switch (this.state) {
      case _t.EntityStart:
        return t.charCodeAt(n) === Et.NUM ? (this.state = _t.NumericStart, this.consumed += 1, this.stateNumericStart(t, n + 1)) : (this.state = _t.NamedEntity, this.stateNamedEntity(t, n));
      case _t.NumericStart:
        return this.stateNumericStart(t, n);
      case _t.NumericDecimal:
        return this.stateNumericDecimal(t, n);
      case _t.NumericHex:
        return this.stateNumericHex(t, n);
      case _t.NamedEntity:
        return this.stateNamedEntity(t, n);
    }
  }
  /**
   * Switches between the numeric decimal and hexadecimal states.
   *
   * Equivalent to the `Numeric character reference state` in the HTML spec.
   *
   * @param str The string containing the entity (or a continuation of the entity).
   * @param offset The current offset.
   * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
   */
  stateNumericStart(t, n) {
    return n >= t.length ? -1 : (t.charCodeAt(n) | R9) === Et.LOWER_X ? (this.state = _t.NumericHex, this.consumed += 1, this.stateNumericHex(t, n + 1)) : (this.state = _t.NumericDecimal, this.stateNumericDecimal(t, n));
  }
  addToNumericResult(t, n, r, u) {
    if (n !== r) {
      const i = r - n;
      this.result = this.result * Math.pow(u, i) + parseInt(t.substr(n, i), u), this.consumed += i;
    }
  }
  /**
   * Parses a hexadecimal numeric entity.
   *
   * Equivalent to the `Hexademical character reference state` in the HTML spec.
   *
   * @param str The string containing the entity (or a continuation of the entity).
   * @param offset The current offset.
   * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
   */
  stateNumericHex(t, n) {
    const r = n;
    for (; n < t.length; ) {
      const u = t.charCodeAt(n);
      if (Hc(u) || B9(u))
        n += 1;
      else
        return this.addToNumericResult(t, r, n, 16), this.emitNumericEntity(u, 3);
    }
    return this.addToNumericResult(t, r, n, 16), -1;
  }
  /**
   * Parses a decimal numeric entity.
   *
   * Equivalent to the `Decimal character reference state` in the HTML spec.
   *
   * @param str The string containing the entity (or a continuation of the entity).
   * @param offset The current offset.
   * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
   */
  stateNumericDecimal(t, n) {
    const r = n;
    for (; n < t.length; ) {
      const u = t.charCodeAt(n);
      if (Hc(u))
        n += 1;
      else
        return this.addToNumericResult(t, r, n, 10), this.emitNumericEntity(u, 2);
    }
    return this.addToNumericResult(t, r, n, 10), -1;
  }
  /**
   * Validate and emit a numeric entity.
   *
   * Implements the logic from the `Hexademical character reference start
   * state` and `Numeric character reference end state` in the HTML spec.
   *
   * @param lastCp The last code point of the entity. Used to see if the
   *               entity was terminated with a semicolon.
   * @param expectedLength The minimum number of characters that should be
   *                       consumed. Used to validate that at least one digit
   *                       was consumed.
   * @returns The number of characters that were consumed.
   */
  emitNumericEntity(t, n) {
    var r;
    if (this.consumed <= n)
      return (r = this.errors) === null || r === void 0 || r.absenceOfDigitsInNumericCharacterReference(this.consumed), 0;
    if (t === Et.SEMI)
      this.consumed += 1;
    else if (this.decodeMode === nn.Strict)
      return 0;
    return this.emitCodePoint(P9(this.result), this.consumed), this.errors && (t !== Et.SEMI && this.errors.missingSemicolonAfterCharacterReference(), this.errors.validateNumericCharacterReference(this.result)), this.consumed;
  }
  /**
   * Parses a named entity.
   *
   * Equivalent to the `Named character reference state` in the HTML spec.
   *
   * @param str The string containing the entity (or a continuation of the entity).
   * @param offset The current offset.
   * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
   */
  stateNamedEntity(t, n) {
    const { decodeTree: r } = this;
    let u = r[this.treeIndex], i = (u & rr.VALUE_LENGTH) >> 14;
    for (; n < t.length; n++, this.excess++) {
      const a = t.charCodeAt(n);
      if (this.treeIndex = $9(r, u, this.treeIndex + Math.max(1, i), a), this.treeIndex < 0)
        return this.result === 0 || // If we are parsing an attribute
        this.decodeMode === nn.Attribute && // We shouldn't have consumed any characters after the entity,
        (i === 0 || // And there should be no invalid characters.
        H9(a)) ? 0 : this.emitNotTerminatedNamedEntity();
      if (u = r[this.treeIndex], i = (u & rr.VALUE_LENGTH) >> 14, i !== 0) {
        if (a === Et.SEMI)
          return this.emitNamedEntityData(this.treeIndex, i, this.consumed + this.excess);
        this.decodeMode !== nn.Strict && (this.result = this.treeIndex, this.consumed += this.excess, this.excess = 0);
      }
    }
    return -1;
  }
  /**
   * Emit a named entity that was not terminated with a semicolon.
   *
   * @returns The number of characters consumed.
   */
  emitNotTerminatedNamedEntity() {
    var t;
    const { result: n, decodeTree: r } = this, u = (r[n] & rr.VALUE_LENGTH) >> 14;
    return this.emitNamedEntityData(n, u, this.consumed), (t = this.errors) === null || t === void 0 || t.missingSemicolonAfterCharacterReference(), this.consumed;
  }
  /**
   * Emit a named entity.
   *
   * @param result The index of the entity in the decode tree.
   * @param valueLength The number of bytes in the entity.
   * @param consumed The number of characters consumed.
   *
   * @returns The number of characters consumed.
   */
  emitNamedEntityData(t, n, r) {
    const { decodeTree: u } = this;
    return this.emitCodePoint(n === 1 ? u[t] & ~rr.VALUE_LENGTH : u[t + 1], r), n === 3 && this.emitCodePoint(u[t + 2], r), r;
  }
  /**
   * Signal to the parser that the end of the input was reached.
   *
   * Remaining data will be emitted and relevant errors will be produced.
   *
   * @returns The number of characters consumed.
   */
  end() {
    var t;
    switch (this.state) {
      case _t.NamedEntity:
        return this.result !== 0 && (this.decodeMode !== nn.Attribute || this.result === this.treeIndex) ? this.emitNotTerminatedNamedEntity() : 0;
      case _t.NumericDecimal:
        return this.emitNumericEntity(0, 2);
      case _t.NumericHex:
        return this.emitNumericEntity(0, 3);
      case _t.NumericStart:
        return (t = this.errors) === null || t === void 0 || t.absenceOfDigitsInNumericCharacterReference(this.consumed), 0;
      case _t.EntityStart:
        return 0;
    }
  }
}
function Ev(e) {
  let t = "";
  const n = new Cv(e, (r) => t += M9(r));
  return function(u, i) {
    let a = 0, o = 0;
    for (; (o = u.indexOf("&", o)) >= 0; ) {
      t += u.slice(a, o), n.startEntity(i);
      const c = n.write(
        u,
        // Skip the "&"
        o + 1
      );
      if (c < 0) {
        a = o + n.end();
        break;
      }
      a = o + c, o = c === 0 ? a + 1 : a;
    }
    const s = t + u.slice(a);
    return t = "", s;
  };
}
function $9(e, t, n, r) {
  const u = (t & rr.BRANCH_LENGTH) >> 7, i = t & rr.JUMP_TABLE;
  if (u === 0)
    return i !== 0 && r === i ? n : -1;
  if (i) {
    const s = r - i;
    return s < 0 || s >= u ? -1 : e[n + s] - 1;
  }
  let a = n, o = a + u - 1;
  for (; a <= o; ) {
    const s = a + o >>> 1, c = e[s];
    if (c < r)
      a = s + 1;
    else if (c > r)
      o = s - 1;
    else
      return e[s + u];
  }
  return -1;
}
const Jl = Ev(N9), V9 = Ev(O9);
function gu(e, t = nn.Legacy) {
  return Jl(e, t);
}
function j9(e) {
  return Jl(e, nn.Attribute);
}
function Ms(e) {
  return Jl(e, nn.Strict);
}
function $c(e) {
  return V9(e, nn.Strict);
}
function ca(e) {
  for (let t = 1; t < e.length; t++)
    e[t][0] += e[t - 1][0] + 1;
  return e;
}
const z9 = new Map(/* @__PURE__ */ ca([[9, "&Tab;"], [0, "&NewLine;"], [22, "&excl;"], [0, "&quot;"], [0, "&num;"], [0, "&dollar;"], [0, "&percnt;"], [0, "&amp;"], [0, "&apos;"], [0, "&lpar;"], [0, "&rpar;"], [0, "&ast;"], [0, "&plus;"], [0, "&comma;"], [1, "&period;"], [0, "&sol;"], [10, "&colon;"], [0, "&semi;"], [0, { v: "&lt;", n: 8402, o: "&nvlt;" }], [0, { v: "&equals;", n: 8421, o: "&bne;" }], [0, { v: "&gt;", n: 8402, o: "&nvgt;" }], [0, "&quest;"], [0, "&commat;"], [26, "&lbrack;"], [0, "&bsol;"], [0, "&rbrack;"], [0, "&Hat;"], [0, "&lowbar;"], [0, "&DiacriticalGrave;"], [5, { n: 106, o: "&fjlig;" }], [20, "&lbrace;"], [0, "&verbar;"], [0, "&rbrace;"], [34, "&nbsp;"], [0, "&iexcl;"], [0, "&cent;"], [0, "&pound;"], [0, "&curren;"], [0, "&yen;"], [0, "&brvbar;"], [0, "&sect;"], [0, "&die;"], [0, "&copy;"], [0, "&ordf;"], [0, "&laquo;"], [0, "&not;"], [0, "&shy;"], [0, "&circledR;"], [0, "&macr;"], [0, "&deg;"], [0, "&PlusMinus;"], [0, "&sup2;"], [0, "&sup3;"], [0, "&acute;"], [0, "&micro;"], [0, "&para;"], [0, "&centerdot;"], [0, "&cedil;"], [0, "&sup1;"], [0, "&ordm;"], [0, "&raquo;"], [0, "&frac14;"], [0, "&frac12;"], [0, "&frac34;"], [0, "&iquest;"], [0, "&Agrave;"], [0, "&Aacute;"], [0, "&Acirc;"], [0, "&Atilde;"], [0, "&Auml;"], [0, "&angst;"], [0, "&AElig;"], [0, "&Ccedil;"], [0, "&Egrave;"], [0, "&Eacute;"], [0, "&Ecirc;"], [0, "&Euml;"], [0, "&Igrave;"], [0, "&Iacute;"], [0, "&Icirc;"], [0, "&Iuml;"], [0, "&ETH;"], [0, "&Ntilde;"], [0, "&Ograve;"], [0, "&Oacute;"], [0, "&Ocirc;"], [0, "&Otilde;"], [0, "&Ouml;"], [0, "&times;"], [0, "&Oslash;"], [0, "&Ugrave;"], [0, "&Uacute;"], [0, "&Ucirc;"], [0, "&Uuml;"], [0, "&Yacute;"], [0, "&THORN;"], [0, "&szlig;"], [0, "&agrave;"], [0, "&aacute;"], [0, "&acirc;"], [0, "&atilde;"], [0, "&auml;"], [0, "&aring;"], [0, "&aelig;"], [0, "&ccedil;"], [0, "&egrave;"], [0, "&eacute;"], [0, "&ecirc;"], [0, "&euml;"], [0, "&igrave;"], [0, "&iacute;"], [0, "&icirc;"], [0, "&iuml;"], [0, "&eth;"], [0, "&ntilde;"], [0, "&ograve;"], [0, "&oacute;"], [0, "&ocirc;"], [0, "&otilde;"], [0, "&ouml;"], [0, "&div;"], [0, "&oslash;"], [0, "&ugrave;"], [0, "&uacute;"], [0, "&ucirc;"], [0, "&uuml;"], [0, "&yacute;"], [0, "&thorn;"], [0, "&yuml;"], [0, "&Amacr;"], [0, "&amacr;"], [0, "&Abreve;"], [0, "&abreve;"], [0, "&Aogon;"], [0, "&aogon;"], [0, "&Cacute;"], [0, "&cacute;"], [0, "&Ccirc;"], [0, "&ccirc;"], [0, "&Cdot;"], [0, "&cdot;"], [0, "&Ccaron;"], [0, "&ccaron;"], [0, "&Dcaron;"], [0, "&dcaron;"], [0, "&Dstrok;"], [0, "&dstrok;"], [0, "&Emacr;"], [0, "&emacr;"], [2, "&Edot;"], [0, "&edot;"], [0, "&Eogon;"], [0, "&eogon;"], [0, "&Ecaron;"], [0, "&ecaron;"], [0, "&Gcirc;"], [0, "&gcirc;"], [0, "&Gbreve;"], [0, "&gbreve;"], [0, "&Gdot;"], [0, "&gdot;"], [0, "&Gcedil;"], [1, "&Hcirc;"], [0, "&hcirc;"], [0, "&Hstrok;"], [0, "&hstrok;"], [0, "&Itilde;"], [0, "&itilde;"], [0, "&Imacr;"], [0, "&imacr;"], [2, "&Iogon;"], [0, "&iogon;"], [0, "&Idot;"], [0, "&imath;"], [0, "&IJlig;"], [0, "&ijlig;"], [0, "&Jcirc;"], [0, "&jcirc;"], [0, "&Kcedil;"], [0, "&kcedil;"], [0, "&kgreen;"], [0, "&Lacute;"], [0, "&lacute;"], [0, "&Lcedil;"], [0, "&lcedil;"], [0, "&Lcaron;"], [0, "&lcaron;"], [0, "&Lmidot;"], [0, "&lmidot;"], [0, "&Lstrok;"], [0, "&lstrok;"], [0, "&Nacute;"], [0, "&nacute;"], [0, "&Ncedil;"], [0, "&ncedil;"], [0, "&Ncaron;"], [0, "&ncaron;"], [0, "&napos;"], [0, "&ENG;"], [0, "&eng;"], [0, "&Omacr;"], [0, "&omacr;"], [2, "&Odblac;"], [0, "&odblac;"], [0, "&OElig;"], [0, "&oelig;"], [0, "&Racute;"], [0, "&racute;"], [0, "&Rcedil;"], [0, "&rcedil;"], [0, "&Rcaron;"], [0, "&rcaron;"], [0, "&Sacute;"], [0, "&sacute;"], [0, "&Scirc;"], [0, "&scirc;"], [0, "&Scedil;"], [0, "&scedil;"], [0, "&Scaron;"], [0, "&scaron;"], [0, "&Tcedil;"], [0, "&tcedil;"], [0, "&Tcaron;"], [0, "&tcaron;"], [0, "&Tstrok;"], [0, "&tstrok;"], [0, "&Utilde;"], [0, "&utilde;"], [0, "&Umacr;"], [0, "&umacr;"], [0, "&Ubreve;"], [0, "&ubreve;"], [0, "&Uring;"], [0, "&uring;"], [0, "&Udblac;"], [0, "&udblac;"], [0, "&Uogon;"], [0, "&uogon;"], [0, "&Wcirc;"], [0, "&wcirc;"], [0, "&Ycirc;"], [0, "&ycirc;"], [0, "&Yuml;"], [0, "&Zacute;"], [0, "&zacute;"], [0, "&Zdot;"], [0, "&zdot;"], [0, "&Zcaron;"], [0, "&zcaron;"], [19, "&fnof;"], [34, "&imped;"], [63, "&gacute;"], [65, "&jmath;"], [142, "&circ;"], [0, "&caron;"], [16, "&breve;"], [0, "&DiacriticalDot;"], [0, "&ring;"], [0, "&ogon;"], [0, "&DiacriticalTilde;"], [0, "&dblac;"], [51, "&DownBreve;"], [127, "&Alpha;"], [0, "&Beta;"], [0, "&Gamma;"], [0, "&Delta;"], [0, "&Epsilon;"], [0, "&Zeta;"], [0, "&Eta;"], [0, "&Theta;"], [0, "&Iota;"], [0, "&Kappa;"], [0, "&Lambda;"], [0, "&Mu;"], [0, "&Nu;"], [0, "&Xi;"], [0, "&Omicron;"], [0, "&Pi;"], [0, "&Rho;"], [1, "&Sigma;"], [0, "&Tau;"], [0, "&Upsilon;"], [0, "&Phi;"], [0, "&Chi;"], [0, "&Psi;"], [0, "&ohm;"], [7, "&alpha;"], [0, "&beta;"], [0, "&gamma;"], [0, "&delta;"], [0, "&epsi;"], [0, "&zeta;"], [0, "&eta;"], [0, "&theta;"], [0, "&iota;"], [0, "&kappa;"], [0, "&lambda;"], [0, "&mu;"], [0, "&nu;"], [0, "&xi;"], [0, "&omicron;"], [0, "&pi;"], [0, "&rho;"], [0, "&sigmaf;"], [0, "&sigma;"], [0, "&tau;"], [0, "&upsi;"], [0, "&phi;"], [0, "&chi;"], [0, "&psi;"], [0, "&omega;"], [7, "&thetasym;"], [0, "&Upsi;"], [2, "&phiv;"], [0, "&piv;"], [5, "&Gammad;"], [0, "&digamma;"], [18, "&kappav;"], [0, "&rhov;"], [3, "&epsiv;"], [0, "&backepsilon;"], [10, "&IOcy;"], [0, "&DJcy;"], [0, "&GJcy;"], [0, "&Jukcy;"], [0, "&DScy;"], [0, "&Iukcy;"], [0, "&YIcy;"], [0, "&Jsercy;"], [0, "&LJcy;"], [0, "&NJcy;"], [0, "&TSHcy;"], [0, "&KJcy;"], [1, "&Ubrcy;"], [0, "&DZcy;"], [0, "&Acy;"], [0, "&Bcy;"], [0, "&Vcy;"], [0, "&Gcy;"], [0, "&Dcy;"], [0, "&IEcy;"], [0, "&ZHcy;"], [0, "&Zcy;"], [0, "&Icy;"], [0, "&Jcy;"], [0, "&Kcy;"], [0, "&Lcy;"], [0, "&Mcy;"], [0, "&Ncy;"], [0, "&Ocy;"], [0, "&Pcy;"], [0, "&Rcy;"], [0, "&Scy;"], [0, "&Tcy;"], [0, "&Ucy;"], [0, "&Fcy;"], [0, "&KHcy;"], [0, "&TScy;"], [0, "&CHcy;"], [0, "&SHcy;"], [0, "&SHCHcy;"], [0, "&HARDcy;"], [0, "&Ycy;"], [0, "&SOFTcy;"], [0, "&Ecy;"], [0, "&YUcy;"], [0, "&YAcy;"], [0, "&acy;"], [0, "&bcy;"], [0, "&vcy;"], [0, "&gcy;"], [0, "&dcy;"], [0, "&iecy;"], [0, "&zhcy;"], [0, "&zcy;"], [0, "&icy;"], [0, "&jcy;"], [0, "&kcy;"], [0, "&lcy;"], [0, "&mcy;"], [0, "&ncy;"], [0, "&ocy;"], [0, "&pcy;"], [0, "&rcy;"], [0, "&scy;"], [0, "&tcy;"], [0, "&ucy;"], [0, "&fcy;"], [0, "&khcy;"], [0, "&tscy;"], [0, "&chcy;"], [0, "&shcy;"], [0, "&shchcy;"], [0, "&hardcy;"], [0, "&ycy;"], [0, "&softcy;"], [0, "&ecy;"], [0, "&yucy;"], [0, "&yacy;"], [1, "&iocy;"], [0, "&djcy;"], [0, "&gjcy;"], [0, "&jukcy;"], [0, "&dscy;"], [0, "&iukcy;"], [0, "&yicy;"], [0, "&jsercy;"], [0, "&ljcy;"], [0, "&njcy;"], [0, "&tshcy;"], [0, "&kjcy;"], [1, "&ubrcy;"], [0, "&dzcy;"], [7074, "&ensp;"], [0, "&emsp;"], [0, "&emsp13;"], [0, "&emsp14;"], [1, "&numsp;"], [0, "&puncsp;"], [0, "&ThinSpace;"], [0, "&hairsp;"], [0, "&NegativeMediumSpace;"], [0, "&zwnj;"], [0, "&zwj;"], [0, "&lrm;"], [0, "&rlm;"], [0, "&dash;"], [2, "&ndash;"], [0, "&mdash;"], [0, "&horbar;"], [0, "&Verbar;"], [1, "&lsquo;"], [0, "&CloseCurlyQuote;"], [0, "&lsquor;"], [1, "&ldquo;"], [0, "&CloseCurlyDoubleQuote;"], [0, "&bdquo;"], [1, "&dagger;"], [0, "&Dagger;"], [0, "&bull;"], [2, "&nldr;"], [0, "&hellip;"], [9, "&permil;"], [0, "&pertenk;"], [0, "&prime;"], [0, "&Prime;"], [0, "&tprime;"], [0, "&backprime;"], [3, "&lsaquo;"], [0, "&rsaquo;"], [3, "&oline;"], [2, "&caret;"], [1, "&hybull;"], [0, "&frasl;"], [10, "&bsemi;"], [7, "&qprime;"], [7, { v: "&MediumSpace;", n: 8202, o: "&ThickSpace;" }], [0, "&NoBreak;"], [0, "&af;"], [0, "&InvisibleTimes;"], [0, "&ic;"], [72, "&euro;"], [46, "&tdot;"], [0, "&DotDot;"], [37, "&complexes;"], [2, "&incare;"], [4, "&gscr;"], [0, "&hamilt;"], [0, "&Hfr;"], [0, "&Hopf;"], [0, "&planckh;"], [0, "&hbar;"], [0, "&imagline;"], [0, "&Ifr;"], [0, "&lagran;"], [0, "&ell;"], [1, "&naturals;"], [0, "&numero;"], [0, "&copysr;"], [0, "&weierp;"], [0, "&Popf;"], [0, "&Qopf;"], [0, "&realine;"], [0, "&real;"], [0, "&reals;"], [0, "&rx;"], [3, "&trade;"], [1, "&integers;"], [2, "&mho;"], [0, "&zeetrf;"], [0, "&iiota;"], [2, "&bernou;"], [0, "&Cayleys;"], [1, "&escr;"], [0, "&Escr;"], [0, "&Fouriertrf;"], [1, "&Mellintrf;"], [0, "&order;"], [0, "&alefsym;"], [0, "&beth;"], [0, "&gimel;"], [0, "&daleth;"], [12, "&CapitalDifferentialD;"], [0, "&dd;"], [0, "&ee;"], [0, "&ii;"], [10, "&frac13;"], [0, "&frac23;"], [0, "&frac15;"], [0, "&frac25;"], [0, "&frac35;"], [0, "&frac45;"], [0, "&frac16;"], [0, "&frac56;"], [0, "&frac18;"], [0, "&frac38;"], [0, "&frac58;"], [0, "&frac78;"], [49, "&larr;"], [0, "&ShortUpArrow;"], [0, "&rarr;"], [0, "&darr;"], [0, "&harr;"], [0, "&updownarrow;"], [0, "&nwarr;"], [0, "&nearr;"], [0, "&LowerRightArrow;"], [0, "&LowerLeftArrow;"], [0, "&nlarr;"], [0, "&nrarr;"], [1, { v: "&rarrw;", n: 824, o: "&nrarrw;" }], [0, "&Larr;"], [0, "&Uarr;"], [0, "&Rarr;"], [0, "&Darr;"], [0, "&larrtl;"], [0, "&rarrtl;"], [0, "&LeftTeeArrow;"], [0, "&mapstoup;"], [0, "&map;"], [0, "&DownTeeArrow;"], [1, "&hookleftarrow;"], [0, "&hookrightarrow;"], [0, "&larrlp;"], [0, "&looparrowright;"], [0, "&harrw;"], [0, "&nharr;"], [1, "&lsh;"], [0, "&rsh;"], [0, "&ldsh;"], [0, "&rdsh;"], [1, "&crarr;"], [0, "&cularr;"], [0, "&curarr;"], [2, "&circlearrowleft;"], [0, "&circlearrowright;"], [0, "&leftharpoonup;"], [0, "&DownLeftVector;"], [0, "&RightUpVector;"], [0, "&LeftUpVector;"], [0, "&rharu;"], [0, "&DownRightVector;"], [0, "&dharr;"], [0, "&dharl;"], [0, "&RightArrowLeftArrow;"], [0, "&udarr;"], [0, "&LeftArrowRightArrow;"], [0, "&leftleftarrows;"], [0, "&upuparrows;"], [0, "&rightrightarrows;"], [0, "&ddarr;"], [0, "&leftrightharpoons;"], [0, "&Equilibrium;"], [0, "&nlArr;"], [0, "&nhArr;"], [0, "&nrArr;"], [0, "&DoubleLeftArrow;"], [0, "&DoubleUpArrow;"], [0, "&DoubleRightArrow;"], [0, "&dArr;"], [0, "&DoubleLeftRightArrow;"], [0, "&DoubleUpDownArrow;"], [0, "&nwArr;"], [0, "&neArr;"], [0, "&seArr;"], [0, "&swArr;"], [0, "&lAarr;"], [0, "&rAarr;"], [1, "&zigrarr;"], [6, "&larrb;"], [0, "&rarrb;"], [15, "&DownArrowUpArrow;"], [7, "&loarr;"], [0, "&roarr;"], [0, "&hoarr;"], [0, "&forall;"], [0, "&comp;"], [0, { v: "&part;", n: 824, o: "&npart;" }], [0, "&exist;"], [0, "&nexist;"], [0, "&empty;"], [1, "&Del;"], [0, "&Element;"], [0, "&NotElement;"], [1, "&ni;"], [0, "&notni;"], [2, "&prod;"], [0, "&coprod;"], [0, "&sum;"], [0, "&minus;"], [0, "&MinusPlus;"], [0, "&dotplus;"], [1, "&Backslash;"], [0, "&lowast;"], [0, "&compfn;"], [1, "&radic;"], [2, "&prop;"], [0, "&infin;"], [0, "&angrt;"], [0, { v: "&ang;", n: 8402, o: "&nang;" }], [0, "&angmsd;"], [0, "&angsph;"], [0, "&mid;"], [0, "&nmid;"], [0, "&DoubleVerticalBar;"], [0, "&NotDoubleVerticalBar;"], [0, "&and;"], [0, "&or;"], [0, { v: "&cap;", n: 65024, o: "&caps;" }], [0, { v: "&cup;", n: 65024, o: "&cups;" }], [0, "&int;"], [0, "&Int;"], [0, "&iiint;"], [0, "&conint;"], [0, "&Conint;"], [0, "&Cconint;"], [0, "&cwint;"], [0, "&ClockwiseContourIntegral;"], [0, "&awconint;"], [0, "&there4;"], [0, "&becaus;"], [0, "&ratio;"], [0, "&Colon;"], [0, "&dotminus;"], [1, "&mDDot;"], [0, "&homtht;"], [0, { v: "&sim;", n: 8402, o: "&nvsim;" }], [0, { v: "&backsim;", n: 817, o: "&race;" }], [0, { v: "&ac;", n: 819, o: "&acE;" }], [0, "&acd;"], [0, "&VerticalTilde;"], [0, "&NotTilde;"], [0, { v: "&eqsim;", n: 824, o: "&nesim;" }], [0, "&sime;"], [0, "&NotTildeEqual;"], [0, "&cong;"], [0, "&simne;"], [0, "&ncong;"], [0, "&ap;"], [0, "&nap;"], [0, "&ape;"], [0, { v: "&apid;", n: 824, o: "&napid;" }], [0, "&backcong;"], [0, { v: "&asympeq;", n: 8402, o: "&nvap;" }], [0, { v: "&bump;", n: 824, o: "&nbump;" }], [0, { v: "&bumpe;", n: 824, o: "&nbumpe;" }], [0, { v: "&doteq;", n: 824, o: "&nedot;" }], [0, "&doteqdot;"], [0, "&efDot;"], [0, "&erDot;"], [0, "&Assign;"], [0, "&ecolon;"], [0, "&ecir;"], [0, "&circeq;"], [1, "&wedgeq;"], [0, "&veeeq;"], [1, "&triangleq;"], [2, "&equest;"], [0, "&ne;"], [0, { v: "&Congruent;", n: 8421, o: "&bnequiv;" }], [0, "&nequiv;"], [1, { v: "&le;", n: 8402, o: "&nvle;" }], [0, { v: "&ge;", n: 8402, o: "&nvge;" }], [0, { v: "&lE;", n: 824, o: "&nlE;" }], [0, { v: "&gE;", n: 824, o: "&ngE;" }], [0, { v: "&lnE;", n: 65024, o: "&lvertneqq;" }], [0, { v: "&gnE;", n: 65024, o: "&gvertneqq;" }], [0, { v: "&ll;", n: new Map(/* @__PURE__ */ ca([[824, "&nLtv;"], [7577, "&nLt;"]])) }], [0, { v: "&gg;", n: new Map(/* @__PURE__ */ ca([[824, "&nGtv;"], [7577, "&nGt;"]])) }], [0, "&between;"], [0, "&NotCupCap;"], [0, "&nless;"], [0, "&ngt;"], [0, "&nle;"], [0, "&nge;"], [0, "&lesssim;"], [0, "&GreaterTilde;"], [0, "&nlsim;"], [0, "&ngsim;"], [0, "&LessGreater;"], [0, "&gl;"], [0, "&NotLessGreater;"], [0, "&NotGreaterLess;"], [0, "&pr;"], [0, "&sc;"], [0, "&prcue;"], [0, "&sccue;"], [0, "&PrecedesTilde;"], [0, { v: "&scsim;", n: 824, o: "&NotSucceedsTilde;" }], [0, "&NotPrecedes;"], [0, "&NotSucceeds;"], [0, { v: "&sub;", n: 8402, o: "&NotSubset;" }], [0, { v: "&sup;", n: 8402, o: "&NotSuperset;" }], [0, "&nsub;"], [0, "&nsup;"], [0, "&sube;"], [0, "&supe;"], [0, "&NotSubsetEqual;"], [0, "&NotSupersetEqual;"], [0, { v: "&subne;", n: 65024, o: "&varsubsetneq;" }], [0, { v: "&supne;", n: 65024, o: "&varsupsetneq;" }], [1, "&cupdot;"], [0, "&UnionPlus;"], [0, { v: "&sqsub;", n: 824, o: "&NotSquareSubset;" }], [0, { v: "&sqsup;", n: 824, o: "&NotSquareSuperset;" }], [0, "&sqsube;"], [0, "&sqsupe;"], [0, { v: "&sqcap;", n: 65024, o: "&sqcaps;" }], [0, { v: "&sqcup;", n: 65024, o: "&sqcups;" }], [0, "&CirclePlus;"], [0, "&CircleMinus;"], [0, "&CircleTimes;"], [0, "&osol;"], [0, "&CircleDot;"], [0, "&circledcirc;"], [0, "&circledast;"], [1, "&circleddash;"], [0, "&boxplus;"], [0, "&boxminus;"], [0, "&boxtimes;"], [0, "&dotsquare;"], [0, "&RightTee;"], [0, "&dashv;"], [0, "&DownTee;"], [0, "&bot;"], [1, "&models;"], [0, "&DoubleRightTee;"], [0, "&Vdash;"], [0, "&Vvdash;"], [0, "&VDash;"], [0, "&nvdash;"], [0, "&nvDash;"], [0, "&nVdash;"], [0, "&nVDash;"], [0, "&prurel;"], [1, "&LeftTriangle;"], [0, "&RightTriangle;"], [0, { v: "&LeftTriangleEqual;", n: 8402, o: "&nvltrie;" }], [0, { v: "&RightTriangleEqual;", n: 8402, o: "&nvrtrie;" }], [0, "&origof;"], [0, "&imof;"], [0, "&multimap;"], [0, "&hercon;"], [0, "&intcal;"], [0, "&veebar;"], [1, "&barvee;"], [0, "&angrtvb;"], [0, "&lrtri;"], [0, "&bigwedge;"], [0, "&bigvee;"], [0, "&bigcap;"], [0, "&bigcup;"], [0, "&diam;"], [0, "&sdot;"], [0, "&sstarf;"], [0, "&divideontimes;"], [0, "&bowtie;"], [0, "&ltimes;"], [0, "&rtimes;"], [0, "&leftthreetimes;"], [0, "&rightthreetimes;"], [0, "&backsimeq;"], [0, "&curlyvee;"], [0, "&curlywedge;"], [0, "&Sub;"], [0, "&Sup;"], [0, "&Cap;"], [0, "&Cup;"], [0, "&fork;"], [0, "&epar;"], [0, "&lessdot;"], [0, "&gtdot;"], [0, { v: "&Ll;", n: 824, o: "&nLl;" }], [0, { v: "&Gg;", n: 824, o: "&nGg;" }], [0, { v: "&leg;", n: 65024, o: "&lesg;" }], [0, { v: "&gel;", n: 65024, o: "&gesl;" }], [2, "&cuepr;"], [0, "&cuesc;"], [0, "&NotPrecedesSlantEqual;"], [0, "&NotSucceedsSlantEqual;"], [0, "&NotSquareSubsetEqual;"], [0, "&NotSquareSupersetEqual;"], [2, "&lnsim;"], [0, "&gnsim;"], [0, "&precnsim;"], [0, "&scnsim;"], [0, "&nltri;"], [0, "&NotRightTriangle;"], [0, "&nltrie;"], [0, "&NotRightTriangleEqual;"], [0, "&vellip;"], [0, "&ctdot;"], [0, "&utdot;"], [0, "&dtdot;"], [0, "&disin;"], [0, "&isinsv;"], [0, "&isins;"], [0, { v: "&isindot;", n: 824, o: "&notindot;" }], [0, "&notinvc;"], [0, "&notinvb;"], [1, { v: "&isinE;", n: 824, o: "&notinE;" }], [0, "&nisd;"], [0, "&xnis;"], [0, "&nis;"], [0, "&notnivc;"], [0, "&notnivb;"], [6, "&barwed;"], [0, "&Barwed;"], [1, "&lceil;"], [0, "&rceil;"], [0, "&LeftFloor;"], [0, "&rfloor;"], [0, "&drcrop;"], [0, "&dlcrop;"], [0, "&urcrop;"], [0, "&ulcrop;"], [0, "&bnot;"], [1, "&profline;"], [0, "&profsurf;"], [1, "&telrec;"], [0, "&target;"], [5, "&ulcorn;"], [0, "&urcorn;"], [0, "&dlcorn;"], [0, "&drcorn;"], [2, "&frown;"], [0, "&smile;"], [9, "&cylcty;"], [0, "&profalar;"], [7, "&topbot;"], [6, "&ovbar;"], [1, "&solbar;"], [60, "&angzarr;"], [51, "&lmoustache;"], [0, "&rmoustache;"], [2, "&OverBracket;"], [0, "&bbrk;"], [0, "&bbrktbrk;"], [37, "&OverParenthesis;"], [0, "&UnderParenthesis;"], [0, "&OverBrace;"], [0, "&UnderBrace;"], [2, "&trpezium;"], [4, "&elinters;"], [59, "&blank;"], [164, "&circledS;"], [55, "&boxh;"], [1, "&boxv;"], [9, "&boxdr;"], [3, "&boxdl;"], [3, "&boxur;"], [3, "&boxul;"], [3, "&boxvr;"], [7, "&boxvl;"], [7, "&boxhd;"], [7, "&boxhu;"], [7, "&boxvh;"], [19, "&boxH;"], [0, "&boxV;"], [0, "&boxdR;"], [0, "&boxDr;"], [0, "&boxDR;"], [0, "&boxdL;"], [0, "&boxDl;"], [0, "&boxDL;"], [0, "&boxuR;"], [0, "&boxUr;"], [0, "&boxUR;"], [0, "&boxuL;"], [0, "&boxUl;"], [0, "&boxUL;"], [0, "&boxvR;"], [0, "&boxVr;"], [0, "&boxVR;"], [0, "&boxvL;"], [0, "&boxVl;"], [0, "&boxVL;"], [0, "&boxHd;"], [0, "&boxhD;"], [0, "&boxHD;"], [0, "&boxHu;"], [0, "&boxhU;"], [0, "&boxHU;"], [0, "&boxvH;"], [0, "&boxVh;"], [0, "&boxVH;"], [19, "&uhblk;"], [3, "&lhblk;"], [3, "&block;"], [8, "&blk14;"], [0, "&blk12;"], [0, "&blk34;"], [13, "&square;"], [8, "&blacksquare;"], [0, "&EmptyVerySmallSquare;"], [1, "&rect;"], [0, "&marker;"], [2, "&fltns;"], [1, "&bigtriangleup;"], [0, "&blacktriangle;"], [0, "&triangle;"], [2, "&blacktriangleright;"], [0, "&rtri;"], [3, "&bigtriangledown;"], [0, "&blacktriangledown;"], [0, "&dtri;"], [2, "&blacktriangleleft;"], [0, "&ltri;"], [6, "&loz;"], [0, "&cir;"], [32, "&tridot;"], [2, "&bigcirc;"], [8, "&ultri;"], [0, "&urtri;"], [0, "&lltri;"], [0, "&EmptySmallSquare;"], [0, "&FilledSmallSquare;"], [8, "&bigstar;"], [0, "&star;"], [7, "&phone;"], [49, "&female;"], [1, "&male;"], [29, "&spades;"], [2, "&clubs;"], [1, "&hearts;"], [0, "&diamondsuit;"], [3, "&sung;"], [2, "&flat;"], [0, "&natural;"], [0, "&sharp;"], [163, "&check;"], [3, "&cross;"], [8, "&malt;"], [21, "&sext;"], [33, "&VerticalSeparator;"], [25, "&lbbrk;"], [0, "&rbbrk;"], [84, "&bsolhsub;"], [0, "&suphsol;"], [28, "&LeftDoubleBracket;"], [0, "&RightDoubleBracket;"], [0, "&lang;"], [0, "&rang;"], [0, "&Lang;"], [0, "&Rang;"], [0, "&loang;"], [0, "&roang;"], [7, "&longleftarrow;"], [0, "&longrightarrow;"], [0, "&longleftrightarrow;"], [0, "&DoubleLongLeftArrow;"], [0, "&DoubleLongRightArrow;"], [0, "&DoubleLongLeftRightArrow;"], [1, "&longmapsto;"], [2, "&dzigrarr;"], [258, "&nvlArr;"], [0, "&nvrArr;"], [0, "&nvHarr;"], [0, "&Map;"], [6, "&lbarr;"], [0, "&bkarow;"], [0, "&lBarr;"], [0, "&dbkarow;"], [0, "&drbkarow;"], [0, "&DDotrahd;"], [0, "&UpArrowBar;"], [0, "&DownArrowBar;"], [2, "&Rarrtl;"], [2, "&latail;"], [0, "&ratail;"], [0, "&lAtail;"], [0, "&rAtail;"], [0, "&larrfs;"], [0, "&rarrfs;"], [0, "&larrbfs;"], [0, "&rarrbfs;"], [2, "&nwarhk;"], [0, "&nearhk;"], [0, "&hksearow;"], [0, "&hkswarow;"], [0, "&nwnear;"], [0, "&nesear;"], [0, "&seswar;"], [0, "&swnwar;"], [8, { v: "&rarrc;", n: 824, o: "&nrarrc;" }], [1, "&cudarrr;"], [0, "&ldca;"], [0, "&rdca;"], [0, "&cudarrl;"], [0, "&larrpl;"], [2, "&curarrm;"], [0, "&cularrp;"], [7, "&rarrpl;"], [2, "&harrcir;"], [0, "&Uarrocir;"], [0, "&lurdshar;"], [0, "&ldrushar;"], [2, "&LeftRightVector;"], [0, "&RightUpDownVector;"], [0, "&DownLeftRightVector;"], [0, "&LeftUpDownVector;"], [0, "&LeftVectorBar;"], [0, "&RightVectorBar;"], [0, "&RightUpVectorBar;"], [0, "&RightDownVectorBar;"], [0, "&DownLeftVectorBar;"], [0, "&DownRightVectorBar;"], [0, "&LeftUpVectorBar;"], [0, "&LeftDownVectorBar;"], [0, "&LeftTeeVector;"], [0, "&RightTeeVector;"], [0, "&RightUpTeeVector;"], [0, "&RightDownTeeVector;"], [0, "&DownLeftTeeVector;"], [0, "&DownRightTeeVector;"], [0, "&LeftUpTeeVector;"], [0, "&LeftDownTeeVector;"], [0, "&lHar;"], [0, "&uHar;"], [0, "&rHar;"], [0, "&dHar;"], [0, "&luruhar;"], [0, "&ldrdhar;"], [0, "&ruluhar;"], [0, "&rdldhar;"], [0, "&lharul;"], [0, "&llhard;"], [0, "&rharul;"], [0, "&lrhard;"], [0, "&udhar;"], [0, "&duhar;"], [0, "&RoundImplies;"], [0, "&erarr;"], [0, "&simrarr;"], [0, "&larrsim;"], [0, "&rarrsim;"], [0, "&rarrap;"], [0, "&ltlarr;"], [1, "&gtrarr;"], [0, "&subrarr;"], [1, "&suplarr;"], [0, "&lfisht;"], [0, "&rfisht;"], [0, "&ufisht;"], [0, "&dfisht;"], [5, "&lopar;"], [0, "&ropar;"], [4, "&lbrke;"], [0, "&rbrke;"], [0, "&lbrkslu;"], [0, "&rbrksld;"], [0, "&lbrksld;"], [0, "&rbrkslu;"], [0, "&langd;"], [0, "&rangd;"], [0, "&lparlt;"], [0, "&rpargt;"], [0, "&gtlPar;"], [0, "&ltrPar;"], [3, "&vzigzag;"], [1, "&vangrt;"], [0, "&angrtvbd;"], [6, "&ange;"], [0, "&range;"], [0, "&dwangle;"], [0, "&uwangle;"], [0, "&angmsdaa;"], [0, "&angmsdab;"], [0, "&angmsdac;"], [0, "&angmsdad;"], [0, "&angmsdae;"], [0, "&angmsdaf;"], [0, "&angmsdag;"], [0, "&angmsdah;"], [0, "&bemptyv;"], [0, "&demptyv;"], [0, "&cemptyv;"], [0, "&raemptyv;"], [0, "&laemptyv;"], [0, "&ohbar;"], [0, "&omid;"], [0, "&opar;"], [1, "&operp;"], [1, "&olcross;"], [0, "&odsold;"], [1, "&olcir;"], [0, "&ofcir;"], [0, "&olt;"], [0, "&ogt;"], [0, "&cirscir;"], [0, "&cirE;"], [0, "&solb;"], [0, "&bsolb;"], [3, "&boxbox;"], [3, "&trisb;"], [0, "&rtriltri;"], [0, { v: "&LeftTriangleBar;", n: 824, o: "&NotLeftTriangleBar;" }], [0, { v: "&RightTriangleBar;", n: 824, o: "&NotRightTriangleBar;" }], [11, "&iinfin;"], [0, "&infintie;"], [0, "&nvinfin;"], [4, "&eparsl;"], [0, "&smeparsl;"], [0, "&eqvparsl;"], [5, "&blacklozenge;"], [8, "&RuleDelayed;"], [1, "&dsol;"], [9, "&bigodot;"], [0, "&bigoplus;"], [0, "&bigotimes;"], [1, "&biguplus;"], [1, "&bigsqcup;"], [5, "&iiiint;"], [0, "&fpartint;"], [2, "&cirfnint;"], [0, "&awint;"], [0, "&rppolint;"], [0, "&scpolint;"], [0, "&npolint;"], [0, "&pointint;"], [0, "&quatint;"], [0, "&intlarhk;"], [10, "&pluscir;"], [0, "&plusacir;"], [0, "&simplus;"], [0, "&plusdu;"], [0, "&plussim;"], [0, "&plustwo;"], [1, "&mcomma;"], [0, "&minusdu;"], [2, "&loplus;"], [0, "&roplus;"], [0, "&Cross;"], [0, "&timesd;"], [0, "&timesbar;"], [1, "&smashp;"], [0, "&lotimes;"], [0, "&rotimes;"], [0, "&otimesas;"], [0, "&Otimes;"], [0, "&odiv;"], [0, "&triplus;"], [0, "&triminus;"], [0, "&tritime;"], [0, "&intprod;"], [2, "&amalg;"], [0, "&capdot;"], [1, "&ncup;"], [0, "&ncap;"], [0, "&capand;"], [0, "&cupor;"], [0, "&cupcap;"], [0, "&capcup;"], [0, "&cupbrcap;"], [0, "&capbrcup;"], [0, "&cupcup;"], [0, "&capcap;"], [0, "&ccups;"], [0, "&ccaps;"], [2, "&ccupssm;"], [2, "&And;"], [0, "&Or;"], [0, "&andand;"], [0, "&oror;"], [0, "&orslope;"], [0, "&andslope;"], [1, "&andv;"], [0, "&orv;"], [0, "&andd;"], [0, "&ord;"], [1, "&wedbar;"], [6, "&sdote;"], [3, "&simdot;"], [2, { v: "&congdot;", n: 824, o: "&ncongdot;" }], [0, "&easter;"], [0, "&apacir;"], [0, { v: "&apE;", n: 824, o: "&napE;" }], [0, "&eplus;"], [0, "&pluse;"], [0, "&Esim;"], [0, "&Colone;"], [0, "&Equal;"], [1, "&ddotseq;"], [0, "&equivDD;"], [0, "&ltcir;"], [0, "&gtcir;"], [0, "&ltquest;"], [0, "&gtquest;"], [0, { v: "&leqslant;", n: 824, o: "&nleqslant;" }], [0, { v: "&geqslant;", n: 824, o: "&ngeqslant;" }], [0, "&lesdot;"], [0, "&gesdot;"], [0, "&lesdoto;"], [0, "&gesdoto;"], [0, "&lesdotor;"], [0, "&gesdotol;"], [0, "&lap;"], [0, "&gap;"], [0, "&lne;"], [0, "&gne;"], [0, "&lnap;"], [0, "&gnap;"], [0, "&lEg;"], [0, "&gEl;"], [0, "&lsime;"], [0, "&gsime;"], [0, "&lsimg;"], [0, "&gsiml;"], [0, "&lgE;"], [0, "&glE;"], [0, "&lesges;"], [0, "&gesles;"], [0, "&els;"], [0, "&egs;"], [0, "&elsdot;"], [0, "&egsdot;"], [0, "&el;"], [0, "&eg;"], [2, "&siml;"], [0, "&simg;"], [0, "&simlE;"], [0, "&simgE;"], [0, { v: "&LessLess;", n: 824, o: "&NotNestedLessLess;" }], [0, { v: "&GreaterGreater;", n: 824, o: "&NotNestedGreaterGreater;" }], [1, "&glj;"], [0, "&gla;"], [0, "&ltcc;"], [0, "&gtcc;"], [0, "&lescc;"], [0, "&gescc;"], [0, "&smt;"], [0, "&lat;"], [0, { v: "&smte;", n: 65024, o: "&smtes;" }], [0, { v: "&late;", n: 65024, o: "&lates;" }], [0, "&bumpE;"], [0, { v: "&PrecedesEqual;", n: 824, o: "&NotPrecedesEqual;" }], [0, { v: "&sce;", n: 824, o: "&NotSucceedsEqual;" }], [2, "&prE;"], [0, "&scE;"], [0, "&precneqq;"], [0, "&scnE;"], [0, "&prap;"], [0, "&scap;"], [0, "&precnapprox;"], [0, "&scnap;"], [0, "&Pr;"], [0, "&Sc;"], [0, "&subdot;"], [0, "&supdot;"], [0, "&subplus;"], [0, "&supplus;"], [0, "&submult;"], [0, "&supmult;"], [0, "&subedot;"], [0, "&supedot;"], [0, { v: "&subE;", n: 824, o: "&nsubE;" }], [0, { v: "&supE;", n: 824, o: "&nsupE;" }], [0, "&subsim;"], [0, "&supsim;"], [2, { v: "&subnE;", n: 65024, o: "&varsubsetneqq;" }], [0, { v: "&supnE;", n: 65024, o: "&varsupsetneqq;" }], [2, "&csub;"], [0, "&csup;"], [0, "&csube;"], [0, "&csupe;"], [0, "&subsup;"], [0, "&supsub;"], [0, "&subsub;"], [0, "&supsup;"], [0, "&suphsub;"], [0, "&supdsub;"], [0, "&forkv;"], [0, "&topfork;"], [0, "&mlcp;"], [8, "&Dashv;"], [1, "&Vdashl;"], [0, "&Barv;"], [0, "&vBar;"], [0, "&vBarv;"], [1, "&Vbar;"], [0, "&Not;"], [0, "&bNot;"], [0, "&rnmid;"], [0, "&cirmid;"], [0, "&midcir;"], [0, "&topcir;"], [0, "&nhpar;"], [0, "&parsim;"], [9, { v: "&parsl;", n: 8421, o: "&nparsl;" }], [44343, { n: new Map(/* @__PURE__ */ ca([[56476, "&Ascr;"], [1, "&Cscr;"], [0, "&Dscr;"], [2, "&Gscr;"], [2, "&Jscr;"], [0, "&Kscr;"], [2, "&Nscr;"], [0, "&Oscr;"], [0, "&Pscr;"], [0, "&Qscr;"], [1, "&Sscr;"], [0, "&Tscr;"], [0, "&Uscr;"], [0, "&Vscr;"], [0, "&Wscr;"], [0, "&Xscr;"], [0, "&Yscr;"], [0, "&Zscr;"], [0, "&ascr;"], [0, "&bscr;"], [0, "&cscr;"], [0, "&dscr;"], [1, "&fscr;"], [1, "&hscr;"], [0, "&iscr;"], [0, "&jscr;"], [0, "&kscr;"], [0, "&lscr;"], [0, "&mscr;"], [0, "&nscr;"], [1, "&pscr;"], [0, "&qscr;"], [0, "&rscr;"], [0, "&sscr;"], [0, "&tscr;"], [0, "&uscr;"], [0, "&vscr;"], [0, "&wscr;"], [0, "&xscr;"], [0, "&yscr;"], [0, "&zscr;"], [52, "&Afr;"], [0, "&Bfr;"], [1, "&Dfr;"], [0, "&Efr;"], [0, "&Ffr;"], [0, "&Gfr;"], [2, "&Jfr;"], [0, "&Kfr;"], [0, "&Lfr;"], [0, "&Mfr;"], [0, "&Nfr;"], [0, "&Ofr;"], [0, "&Pfr;"], [0, "&Qfr;"], [1, "&Sfr;"], [0, "&Tfr;"], [0, "&Ufr;"], [0, "&Vfr;"], [0, "&Wfr;"], [0, "&Xfr;"], [0, "&Yfr;"], [1, "&afr;"], [0, "&bfr;"], [0, "&cfr;"], [0, "&dfr;"], [0, "&efr;"], [0, "&ffr;"], [0, "&gfr;"], [0, "&hfr;"], [0, "&ifr;"], [0, "&jfr;"], [0, "&kfr;"], [0, "&lfr;"], [0, "&mfr;"], [0, "&nfr;"], [0, "&ofr;"], [0, "&pfr;"], [0, "&qfr;"], [0, "&rfr;"], [0, "&sfr;"], [0, "&tfr;"], [0, "&ufr;"], [0, "&vfr;"], [0, "&wfr;"], [0, "&xfr;"], [0, "&yfr;"], [0, "&zfr;"], [0, "&Aopf;"], [0, "&Bopf;"], [1, "&Dopf;"], [0, "&Eopf;"], [0, "&Fopf;"], [0, "&Gopf;"], [1, "&Iopf;"], [0, "&Jopf;"], [0, "&Kopf;"], [0, "&Lopf;"], [0, "&Mopf;"], [1, "&Oopf;"], [3, "&Sopf;"], [0, "&Topf;"], [0, "&Uopf;"], [0, "&Vopf;"], [0, "&Wopf;"], [0, "&Xopf;"], [0, "&Yopf;"], [1, "&aopf;"], [0, "&bopf;"], [0, "&copf;"], [0, "&dopf;"], [0, "&eopf;"], [0, "&fopf;"], [0, "&gopf;"], [0, "&hopf;"], [0, "&iopf;"], [0, "&jopf;"], [0, "&kopf;"], [0, "&lopf;"], [0, "&mopf;"], [0, "&nopf;"], [0, "&oopf;"], [0, "&popf;"], [0, "&qopf;"], [0, "&ropf;"], [0, "&sopf;"], [0, "&topf;"], [0, "&uopf;"], [0, "&vopf;"], [0, "&wopf;"], [0, "&xopf;"], [0, "&yopf;"], [0, "&zopf;"]])) }], [8906, "&fflig;"], [0, "&filig;"], [0, "&fllig;"], [0, "&ffilig;"], [0, "&ffllig;"]])), Vc = /["&'<>$\x80-\uFFFF]/g, wv = /* @__PURE__ */ new Map([
  [34, "&quot;"],
  [38, "&amp;"],
  [39, "&apos;"],
  [60, "&lt;"],
  [62, "&gt;"]
]), Tv = (
  // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
  String.prototype.codePointAt != null ? (e, t) => e.codePointAt(t) : (
    // http://mathiasbynens.be/notes/javascript-encoding#surrogate-formulae
    (e, t) => (e.charCodeAt(t) & 64512) === 55296 ? (e.charCodeAt(t) - 55296) * 1024 + e.charCodeAt(t + 1) - 56320 + 65536 : e.charCodeAt(t)
  )
);
function e0(e) {
  let t = "", n = 0, r;
  for (; (r = Vc.exec(e)) !== null; ) {
    const u = r.index, i = e.charCodeAt(u), a = wv.get(i);
    a !== void 0 ? (t += e.substring(n, u) + a, n = u + 1) : (t += `${e.substring(n, u)}&#x${Tv(e, u).toString(16)};`, n = Vc.lastIndex += +((i & 64512) === 55296));
  }
  return t + e.substr(n);
}
const U9 = e0;
function t0(e, t) {
  return function(r) {
    let u, i = 0, a = "";
    for (; u = e.exec(r); )
      i !== u.index && (a += r.substring(i, u.index)), a += t.get(u[0].charCodeAt(0)), i = u.index + 1;
    return a + r.substring(i);
  };
}
const Av = t0(/[&<>'"]/g, wv), kv = t0(/["&\u00A0]/g, /* @__PURE__ */ new Map([
  [34, "&quot;"],
  [38, "&amp;"],
  [160, "&nbsp;"]
])), Lv = t0(/[&<>\u00A0]/g, /* @__PURE__ */ new Map([
  [38, "&amp;"],
  [60, "&lt;"],
  [62, "&gt;"],
  [160, "&nbsp;"]
])), q9 = /[\t\n!-,./:-@[-`\f{-}$\x80-\uFFFF]/g;
function Aa(e) {
  return Nv(q9, e);
}
function Dv(e) {
  return Nv(Vc, e);
}
function Nv(e, t) {
  let n = "", r = 0, u;
  for (; (u = e.exec(t)) !== null; ) {
    const i = u.index;
    n += t.substring(r, i);
    const a = t.charCodeAt(i);
    let o = z9.get(a);
    if (typeof o == "object") {
      if (i + 1 < t.length) {
        const s = t.charCodeAt(i + 1), c = typeof o.n == "number" ? o.n === s ? o.o : void 0 : o.n.get(s);
        if (c !== void 0) {
          n += c, r = e.lastIndex += 1;
          continue;
        }
      }
      o = o.v;
    }
    if (o !== void 0)
      n += o, r = i + 1;
    else {
      const s = Tv(t, i);
      n += `&#x${s.toString(16)};`, r = e.lastIndex += +(s !== a);
    }
  }
  return n + t.substr(r);
}
var cr;
(function(e) {
  e[e.XML = 0] = "XML", e[e.HTML = 1] = "HTML";
})(cr || (cr = {}));
var Ar;
(function(e) {
  e[e.UTF8 = 0] = "UTF8", e[e.ASCII = 1] = "ASCII", e[e.Extensive = 2] = "Extensive", e[e.Attribute = 3] = "Attribute", e[e.Text = 4] = "Text";
})(Ar || (Ar = {}));
function Ov(e, t = cr.XML) {
  if ((typeof t == "number" ? t : t.level) === cr.HTML) {
    const r = typeof t == "object" ? t.mode : void 0;
    return gu(e, r);
  }
  return $c(e);
}
function G9(e, t = cr.XML) {
  var n;
  const r = typeof t == "number" ? { level: t } : t;
  return (n = r.mode) !== null && n !== void 0 || (r.mode = nn.Strict), Ov(e, r);
}
function W9(e, t = cr.XML) {
  const n = typeof t == "number" ? { level: t } : t;
  return n.mode === Ar.UTF8 ? Av(e) : n.mode === Ar.Attribute ? kv(e) : n.mode === Ar.Text ? Lv(e) : n.level === cr.HTML ? n.mode === Ar.ASCII ? Dv(e) : Aa(e) : e0(e);
}
const K9 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  get DecodingMode() {
    return nn;
  },
  get EncodingMode() {
    return Ar;
  },
  EntityDecoder: Cv,
  get EntityLevel() {
    return cr;
  },
  decode: Ov,
  decodeHTML: gu,
  decodeHTML4: gu,
  decodeHTML4Strict: Ms,
  decodeHTML5: gu,
  decodeHTML5Strict: Ms,
  decodeHTMLAttribute: j9,
  decodeHTMLStrict: Ms,
  decodeStrict: G9,
  decodeXML: $c,
  decodeXMLStrict: $c,
  encode: W9,
  encodeHTML: Aa,
  encodeHTML4: Aa,
  encodeHTML5: Aa,
  encodeNonAsciiHTML: Dv,
  encodeXML: e0,
  escape: U9,
  escapeAttribute: kv,
  escapeText: Lv,
  escapeUTF8: Av
}, Symbol.toStringTag, { value: "Module" }));
function Y9(e) {
  return Object.prototype.toString.call(e);
}
function n0(e) {
  return Y9(e) === "[object String]";
}
const Z9 = Object.prototype.hasOwnProperty;
function X9(e, t) {
  return Z9.call(e, t);
}
function Lo(e) {
  return Array.prototype.slice.call(arguments, 1).forEach(function(n) {
    if (n) {
      if (typeof n != "object")
        throw new TypeError(n + "must be object");
      Object.keys(n).forEach(function(r) {
        e[r] = n[r];
      });
    }
  }), e;
}
function Iv(e, t, n) {
  return [].concat(e.slice(0, t), n, e.slice(t + 1));
}
function r0(e) {
  return !(e >= 55296 && e <= 57343 || e >= 64976 && e <= 65007 || (e & 65535) === 65535 || (e & 65535) === 65534 || e >= 0 && e <= 8 || e === 11 || e >= 14 && e <= 31 || e >= 127 && e <= 159 || e > 1114111);
}
function Wa(e) {
  if (e > 65535) {
    e -= 65536;
    const t = 55296 + (e >> 10), n = 56320 + (e & 1023);
    return String.fromCharCode(t, n);
  }
  return String.fromCharCode(e);
}
const Mv = /\\([!"#$%&'()*+,\-./:;<=>?@[\\\]^_`{|}~])/g, Q9 = /&([a-z#][a-z0-9]{1,31});/gi, J9 = new RegExp(Mv.source + "|" + Q9.source, "gi"), eA = /^#((?:x[a-f0-9]{1,8}|[0-9]{1,8}))$/i;
function tA(e, t) {
  if (t.charCodeAt(0) === 35 && eA.test(t)) {
    const r = t[1].toLowerCase() === "x" ? parseInt(t.slice(2), 16) : parseInt(t.slice(1), 10);
    return r0(r) ? Wa(r) : e;
  }
  const n = gu(e);
  return n !== e ? n : e;
}
function nA(e) {
  return e.indexOf("\\") < 0 ? e : e.replace(Mv, "$1");
}
function Lu(e) {
  return e.indexOf("\\") < 0 && e.indexOf("&") < 0 ? e : e.replace(J9, function(t, n, r) {
    return n || tA(t, r);
  });
}
const rA = /[&<>"]/, uA = /[&<>"]/g, iA = {
  "&": "&amp;",
  "<": "&lt;",
  ">": "&gt;",
  '"': "&quot;"
};
function aA(e) {
  return iA[e];
}
function lr(e) {
  return rA.test(e) ? e.replace(uA, aA) : e;
}
const oA = /[.?*+^$[\]\\(){}|-]/g;
function sA(e) {
  return e.replace(oA, "\\$&");
}
function Xe(e) {
  switch (e) {
    case 9:
    case 32:
      return !0;
  }
  return !1;
}
function wi(e) {
  if (e >= 8192 && e <= 8202)
    return !0;
  switch (e) {
    case 9:
    case 10:
    case 11:
    case 12:
    case 13:
    case 32:
    case 160:
    case 5760:
    case 8239:
    case 8287:
    case 12288:
      return !0;
  }
  return !1;
}
function Ti(e) {
  return Ql.test(e) || _v.test(e);
}
function Ai(e) {
  switch (e) {
    case 33:
    case 34:
    case 35:
    case 36:
    case 37:
    case 38:
    case 39:
    case 40:
    case 41:
    case 42:
    case 43:
    case 44:
    case 45:
    case 46:
    case 47:
    case 58:
    case 59:
    case 60:
    case 61:
    case 62:
    case 63:
    case 64:
    case 91:
    case 92:
    case 93:
    case 94:
    case 95:
    case 96:
    case 123:
    case 124:
    case 125:
    case 126:
      return !0;
    default:
      return !1;
  }
}
function Do(e) {
  return e = e.trim().replace(/\s+/g, " "), "ẞ".toLowerCase() === "Ṿ" && (e = e.replace(/ẞ/g, "ß")), e.toLowerCase().toUpperCase();
}
const cA = { mdurl: k9, ucmicro: D9 }, lA = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  arrayReplaceAt: Iv,
  assign: Lo,
  escapeHtml: lr,
  escapeRE: sA,
  fromCodePoint: Wa,
  has: X9,
  isMdAsciiPunct: Ai,
  isPunctChar: Ti,
  isSpace: Xe,
  isString: n0,
  isValidEntityCode: r0,
  isWhiteSpace: wi,
  lib: cA,
  normalizeReference: Do,
  unescapeAll: Lu,
  unescapeMd: nA
}, Symbol.toStringTag, { value: "Module" }));
function dA(e, t, n) {
  let r, u, i, a;
  const o = e.posMax, s = e.pos;
  for (e.pos = t + 1, r = 1; e.pos < o; ) {
    if (i = e.src.charCodeAt(e.pos), i === 93 && (r--, r === 0)) {
      u = !0;
      break;
    }
    if (a = e.pos, e.md.inline.skipToken(e), i === 91) {
      if (a === e.pos - 1)
        r++;
      else if (n)
        return e.pos = s, -1;
    }
  }
  let c = -1;
  return u && (c = e.pos), e.pos = s, c;
}
function fA(e, t, n) {
  let r, u = t;
  const i = {
    ok: !1,
    pos: 0,
    str: ""
  };
  if (e.charCodeAt(u) === 60) {
    for (u++; u < n; ) {
      if (r = e.charCodeAt(u), r === 10 || r === 60)
        return i;
      if (r === 62)
        return i.pos = u + 1, i.str = Lu(e.slice(t + 1, u)), i.ok = !0, i;
      if (r === 92 && u + 1 < n) {
        u += 2;
        continue;
      }
      u++;
    }
    return i;
  }
  let a = 0;
  for (; u < n && (r = e.charCodeAt(u), !(r === 32 || r < 32 || r === 127)); ) {
    if (r === 92 && u + 1 < n) {
      if (e.charCodeAt(u + 1) === 32)
        break;
      u += 2;
      continue;
    }
    if (r === 40 && (a++, a > 32))
      return i;
    if (r === 41) {
      if (a === 0)
        break;
      a--;
    }
    u++;
  }
  return t === u || a !== 0 || (i.str = Lu(e.slice(t, u)), i.pos = u, i.ok = !0), i;
}
function pA(e, t, n, r) {
  let u, i = t;
  const a = {
    // if `true`, this is a valid link title
    ok: !1,
    // if `true`, this link can be continued on the next line
    can_continue: !1,
    // if `ok`, it's the position of the first character after the closing marker
    pos: 0,
    // if `ok`, it's the unescaped title
    str: "",
    // expected closing marker character code
    marker: 0
  };
  if (r)
    a.str = r.str, a.marker = r.marker;
  else {
    if (i >= n)
      return a;
    let o = e.charCodeAt(i);
    if (o !== 34 && o !== 39 && o !== 40)
      return a;
    t++, i++, o === 40 && (o = 41), a.marker = o;
  }
  for (; i < n; ) {
    if (u = e.charCodeAt(i), u === a.marker)
      return a.pos = i + 1, a.str += Lu(e.slice(t, i)), a.ok = !0, a;
    if (u === 40 && a.marker === 41)
      return a;
    u === 92 && i + 1 < n && i++, i++;
  }
  return a.can_continue = !0, a.str += Lu(e.slice(t, i)), a;
}
const hA = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  parseLinkDestination: fA,
  parseLinkLabel: dA,
  parseLinkTitle: pA
}, Symbol.toStringTag, { value: "Module" })), In = {};
In.code_inline = function(e, t, n, r, u) {
  const i = e[t];
  return "<code" + u.renderAttrs(i) + ">" + lr(i.content) + "</code>";
};
In.code_block = function(e, t, n, r, u) {
  const i = e[t];
  return "<pre" + u.renderAttrs(i) + "><code>" + lr(e[t].content) + `</code></pre>
`;
};
In.fence = function(e, t, n, r, u) {
  const i = e[t], a = i.info ? Lu(i.info).trim() : "";
  let o = "", s = "";
  if (a) {
    const l = a.split(/(\s+)/g);
    o = l[0], s = l.slice(2).join("");
  }
  let c;
  if (n.highlight ? c = n.highlight(i.content, o, s) || lr(i.content) : c = lr(i.content), c.indexOf("<pre") === 0)
    return c + `
`;
  if (a) {
    const l = i.attrIndex("class"), d = i.attrs ? i.attrs.slice() : [];
    l < 0 ? d.push(["class", n.langPrefix + o]) : (d[l] = d[l].slice(), d[l][1] += " " + n.langPrefix + o);
    const f = {
      attrs: d
    };
    return `<pre><code${u.renderAttrs(f)}>${c}</code></pre>
`;
  }
  return `<pre><code${u.renderAttrs(i)}>${c}</code></pre>
`;
};
In.image = function(e, t, n, r, u) {
  const i = e[t];
  return i.attrs[i.attrIndex("alt")][1] = u.renderInlineAsText(i.children, n, r), u.renderToken(e, t, n);
};
In.hardbreak = function(e, t, n) {
  return n.xhtmlOut ? `<br />
` : `<br>
`;
};
In.softbreak = function(e, t, n) {
  return n.breaks ? n.xhtmlOut ? `<br />
` : `<br>
` : `
`;
};
In.text = function(e, t) {
  return lr(e[t].content);
};
In.html_block = function(e, t) {
  return e[t].content;
};
In.html_inline = function(e, t) {
  return e[t].content;
};
function Ru() {
  this.rules = Lo({}, In);
}
Ru.prototype.renderAttrs = function(t) {
  let n, r, u;
  if (!t.attrs)
    return "";
  for (u = "", n = 0, r = t.attrs.length; n < r; n++)
    u += " " + lr(t.attrs[n][0]) + '="' + lr(t.attrs[n][1]) + '"';
  return u;
};
Ru.prototype.renderToken = function(t, n, r) {
  const u = t[n];
  let i = "";
  if (u.hidden)
    return "";
  u.block && u.nesting !== -1 && n && t[n - 1].hidden && (i += `
`), i += (u.nesting === -1 ? "</" : "<") + u.tag, i += this.renderAttrs(u), u.nesting === 0 && r.xhtmlOut && (i += " /");
  let a = !1;
  if (u.block && (a = !0, u.nesting === 1 && n + 1 < t.length)) {
    const o = t[n + 1];
    (o.type === "inline" || o.hidden || o.nesting === -1 && o.tag === u.tag) && (a = !1);
  }
  return i += a ? `>
` : ">", i;
};
Ru.prototype.renderInline = function(e, t, n) {
  let r = "";
  const u = this.rules;
  for (let i = 0, a = e.length; i < a; i++) {
    const o = e[i].type;
    typeof u[o] < "u" ? r += u[o](e, i, t, n, this) : r += this.renderToken(e, i, t);
  }
  return r;
};
Ru.prototype.renderInlineAsText = function(e, t, n) {
  let r = "";
  for (let u = 0, i = e.length; u < i; u++)
    switch (e[u].type) {
      case "text":
        r += e[u].content;
        break;
      case "image":
        r += this.renderInlineAsText(e[u].children, t, n);
        break;
      case "html_inline":
      case "html_block":
        r += e[u].content;
        break;
      case "softbreak":
      case "hardbreak":
        r += `
`;
        break;
    }
  return r;
};
Ru.prototype.render = function(e, t, n) {
  let r = "";
  const u = this.rules;
  for (let i = 0, a = e.length; i < a; i++) {
    const o = e[i].type;
    o === "inline" ? r += this.renderInline(e[i].children, t, n) : typeof u[o] < "u" ? r += u[o](e, i, t, n, this) : r += this.renderToken(e, i, t, n);
  }
  return r;
};
function tn() {
  this.__rules__ = [], this.__cache__ = null;
}
tn.prototype.__find__ = function(e) {
  for (let t = 0; t < this.__rules__.length; t++)
    if (this.__rules__[t].name === e)
      return t;
  return -1;
};
tn.prototype.__compile__ = function() {
  const e = this, t = [""];
  e.__rules__.forEach(function(n) {
    n.enabled && n.alt.forEach(function(r) {
      t.indexOf(r) < 0 && t.push(r);
    });
  }), e.__cache__ = {}, t.forEach(function(n) {
    e.__cache__[n] = [], e.__rules__.forEach(function(r) {
      r.enabled && (n && r.alt.indexOf(n) < 0 || e.__cache__[n].push(r.fn));
    });
  });
};
tn.prototype.at = function(e, t, n) {
  const r = this.__find__(e), u = n || {};
  if (r === -1)
    throw new Error("Parser rule not found: " + e);
  this.__rules__[r].fn = t, this.__rules__[r].alt = u.alt || [], this.__cache__ = null;
};
tn.prototype.before = function(e, t, n, r) {
  const u = this.__find__(e), i = r || {};
  if (u === -1)
    throw new Error("Parser rule not found: " + e);
  this.__rules__.splice(u, 0, {
    name: t,
    enabled: !0,
    fn: n,
    alt: i.alt || []
  }), this.__cache__ = null;
};
tn.prototype.after = function(e, t, n, r) {
  const u = this.__find__(e), i = r || {};
  if (u === -1)
    throw new Error("Parser rule not found: " + e);
  this.__rules__.splice(u + 1, 0, {
    name: t,
    enabled: !0,
    fn: n,
    alt: i.alt || []
  }), this.__cache__ = null;
};
tn.prototype.push = function(e, t, n) {
  const r = n || {};
  this.__rules__.push({
    name: e,
    enabled: !0,
    fn: t,
    alt: r.alt || []
  }), this.__cache__ = null;
};
tn.prototype.enable = function(e, t) {
  Array.isArray(e) || (e = [e]);
  const n = [];
  return e.forEach(function(r) {
    const u = this.__find__(r);
    if (u < 0) {
      if (t)
        return;
      throw new Error("Rules manager: invalid rule name " + r);
    }
    this.__rules__[u].enabled = !0, n.push(r);
  }, this), this.__cache__ = null, n;
};
tn.prototype.enableOnly = function(e, t) {
  Array.isArray(e) || (e = [e]), this.__rules__.forEach(function(n) {
    n.enabled = !1;
  }), this.enable(e, t);
};
tn.prototype.disable = function(e, t) {
  Array.isArray(e) || (e = [e]);
  const n = [];
  return e.forEach(function(r) {
    const u = this.__find__(r);
    if (u < 0) {
      if (t)
        return;
      throw new Error("Rules manager: invalid rule name " + r);
    }
    this.__rules__[u].enabled = !1, n.push(r);
  }, this), this.__cache__ = null, n;
};
tn.prototype.getRules = function(e) {
  return this.__cache__ === null && this.__compile__(), this.__cache__[e] || [];
};
function wn(e, t, n) {
  this.type = e, this.tag = t, this.attrs = null, this.map = null, this.nesting = n, this.level = 0, this.children = null, this.content = "", this.markup = "", this.info = "", this.meta = null, this.block = !1, this.hidden = !1;
}
wn.prototype.attrIndex = function(t) {
  if (!this.attrs)
    return -1;
  const n = this.attrs;
  for (let r = 0, u = n.length; r < u; r++)
    if (n[r][0] === t)
      return r;
  return -1;
};
wn.prototype.attrPush = function(t) {
  this.attrs ? this.attrs.push(t) : this.attrs = [t];
};
wn.prototype.attrSet = function(t, n) {
  const r = this.attrIndex(t), u = [t, n];
  r < 0 ? this.attrPush(u) : this.attrs[r] = u;
};
wn.prototype.attrGet = function(t) {
  const n = this.attrIndex(t);
  let r = null;
  return n >= 0 && (r = this.attrs[n][1]), r;
};
wn.prototype.attrJoin = function(t, n) {
  const r = this.attrIndex(t);
  r < 0 ? this.attrPush([t, n]) : this.attrs[r][1] = this.attrs[r][1] + " " + n;
};
function Pv(e, t, n) {
  this.src = e, this.env = n, this.tokens = [], this.inlineMode = !1, this.md = t;
}
Pv.prototype.Token = wn;
const mA = /\r\n?|\n/g, gA = /\0/g;
function bA(e) {
  let t;
  t = e.src.replace(mA, `
`), t = t.replace(gA, "�"), e.src = t;
}
function vA(e) {
  let t;
  e.inlineMode ? (t = new e.Token("inline", "", 0), t.content = e.src, t.map = [0, 1], t.children = [], e.tokens.push(t)) : e.md.block.parse(e.src, e.md, e.env, e.tokens);
}
function yA(e) {
  const t = e.tokens;
  for (let n = 0, r = t.length; n < r; n++) {
    const u = t[n];
    u.type === "inline" && e.md.inline.parse(u.content, e.md, e.env, u.children);
  }
}
function xA(e) {
  return /^<a[>\s]/i.test(e);
}
function _A(e) {
  return /^<\/a\s*>/i.test(e);
}
function SA(e) {
  const t = e.tokens;
  if (e.md.options.linkify)
    for (let n = 0, r = t.length; n < r; n++) {
      if (t[n].type !== "inline" || !e.md.linkify.pretest(t[n].content))
        continue;
      let u = t[n].children, i = 0;
      for (let a = u.length - 1; a >= 0; a--) {
        const o = u[a];
        if (o.type === "link_close") {
          for (a--; u[a].level !== o.level && u[a].type !== "link_open"; )
            a--;
          continue;
        }
        if (o.type === "html_inline" && (xA(o.content) && i > 0 && i--, _A(o.content) && i++), !(i > 0) && o.type === "text" && e.md.linkify.test(o.content)) {
          const s = o.content;
          let c = e.md.linkify.match(s);
          const l = [];
          let d = o.level, f = 0;
          c.length > 0 && c[0].index === 0 && a > 0 && u[a - 1].type === "text_special" && (c = c.slice(1));
          for (let p = 0; p < c.length; p++) {
            const h = c[p].url, m = e.md.normalizeLink(h);
            if (!e.md.validateLink(m))
              continue;
            let b = c[p].text;
            c[p].schema ? c[p].schema === "mailto:" && !/^mailto:/i.test(b) ? b = e.md.normalizeLinkText("mailto:" + b).replace(/^mailto:/, "") : b = e.md.normalizeLinkText(b) : b = e.md.normalizeLinkText("http://" + b).replace(/^http:\/\//, "");
            const x = c[p].index;
            if (x > f) {
              const S = new e.Token("text", "", 0);
              S.content = s.slice(f, x), S.level = d, l.push(S);
            }
            const y = new e.Token("link_open", "a", 1);
            y.attrs = [["href", m]], y.level = d++, y.markup = "linkify", y.info = "auto", l.push(y);
            const g = new e.Token("text", "", 0);
            g.content = b, g.level = d, l.push(g);
            const v = new e.Token("link_close", "a", -1);
            v.level = --d, v.markup = "linkify", v.info = "auto", l.push(v), f = c[p].lastIndex;
          }
          if (f < s.length) {
            const p = new e.Token("text", "", 0);
            p.content = s.slice(f), p.level = d, l.push(p);
          }
          t[n].children = u = Iv(u, a, l);
        }
      }
    }
}
const Rv = /\+-|\.\.|\?\?\?\?|!!!!|,,|--/, CA = /\((c|tm|r)\)/i, EA = /\((c|tm|r)\)/ig, wA = {
  c: "©",
  r: "®",
  tm: "™"
};
function TA(e, t) {
  return wA[t.toLowerCase()];
}
function AA(e) {
  let t = 0;
  for (let n = e.length - 1; n >= 0; n--) {
    const r = e[n];
    r.type === "text" && !t && (r.content = r.content.replace(EA, TA)), r.type === "link_open" && r.info === "auto" && t--, r.type === "link_close" && r.info === "auto" && t++;
  }
}
function kA(e) {
  let t = 0;
  for (let n = e.length - 1; n >= 0; n--) {
    const r = e[n];
    r.type === "text" && !t && Rv.test(r.content) && (r.content = r.content.replace(/\+-/g, "±").replace(/\.{2,}/g, "…").replace(/([?!])…/g, "$1..").replace(/([?!]){4,}/g, "$1$1$1").replace(/,{2,}/g, ",").replace(/(^|[^-])---(?=[^-]|$)/mg, "$1—").replace(/(^|\s)--(?=\s|$)/mg, "$1–").replace(/(^|[^-\s])--(?=[^-\s]|$)/mg, "$1–")), r.type === "link_open" && r.info === "auto" && t--, r.type === "link_close" && r.info === "auto" && t++;
  }
}
function LA(e) {
  let t;
  if (e.md.options.typographer)
    for (t = e.tokens.length - 1; t >= 0; t--)
      e.tokens[t].type === "inline" && (CA.test(e.tokens[t].content) && AA(e.tokens[t].children), Rv.test(e.tokens[t].content) && kA(e.tokens[t].children));
}
const DA = /['"]/, Jf = /['"]/g, ep = "’";
function la(e, t, n) {
  return e.slice(0, t) + n + e.slice(t + 1);
}
function NA(e, t) {
  let n;
  const r = [];
  for (let u = 0; u < e.length; u++) {
    const i = e[u], a = e[u].level;
    for (n = r.length - 1; n >= 0 && !(r[n].level <= a); n--)
      ;
    if (r.length = n + 1, i.type !== "text")
      continue;
    let o = i.content, s = 0, c = o.length;
    e:
      for (; s < c; ) {
        Jf.lastIndex = s;
        const l = Jf.exec(o);
        if (!l)
          break;
        let d = !0, f = !0;
        s = l.index + 1;
        const p = l[0] === "'";
        let h = 32;
        if (l.index - 1 >= 0)
          h = o.charCodeAt(l.index - 1);
        else
          for (n = u - 1; n >= 0 && !(e[n].type === "softbreak" || e[n].type === "hardbreak"); n--)
            if (e[n].content) {
              h = e[n].content.charCodeAt(e[n].content.length - 1);
              break;
            }
        let m = 32;
        if (s < c)
          m = o.charCodeAt(s);
        else
          for (n = u + 1; n < e.length && !(e[n].type === "softbreak" || e[n].type === "hardbreak"); n++)
            if (e[n].content) {
              m = e[n].content.charCodeAt(0);
              break;
            }
        const b = Ai(h) || Ti(String.fromCharCode(h)), x = Ai(m) || Ti(String.fromCharCode(m)), y = wi(h), g = wi(m);
        if (g ? d = !1 : x && (y || b || (d = !1)), y ? f = !1 : b && (g || x || (f = !1)), m === 34 && l[0] === '"' && h >= 48 && h <= 57 && (f = d = !1), d && f && (d = b, f = x), !d && !f) {
          p && (i.content = la(i.content, l.index, ep));
          continue;
        }
        if (f)
          for (n = r.length - 1; n >= 0; n--) {
            let v = r[n];
            if (r[n].level < a)
              break;
            if (v.single === p && r[n].level === a) {
              v = r[n];
              let S, _;
              p ? (S = t.md.options.quotes[2], _ = t.md.options.quotes[3]) : (S = t.md.options.quotes[0], _ = t.md.options.quotes[1]), i.content = la(i.content, l.index, _), e[v.token].content = la(
                e[v.token].content,
                v.pos,
                S
              ), s += _.length - 1, v.token === u && (s += S.length - 1), o = i.content, c = o.length, r.length = n;
              continue e;
            }
          }
        d ? r.push({
          token: u,
          pos: l.index,
          single: p,
          level: a
        }) : f && p && (i.content = la(i.content, l.index, ep));
      }
  }
}
function OA(e) {
  if (e.md.options.typographer)
    for (let t = e.tokens.length - 1; t >= 0; t--)
      e.tokens[t].type !== "inline" || !DA.test(e.tokens[t].content) || NA(e.tokens[t].children, e);
}
function IA(e) {
  let t, n;
  const r = e.tokens, u = r.length;
  for (let i = 0; i < u; i++) {
    if (r[i].type !== "inline")
      continue;
    const a = r[i].children, o = a.length;
    for (t = 0; t < o; t++)
      a[t].type === "text_special" && (a[t].type = "text");
    for (t = n = 0; t < o; t++)
      a[t].type === "text" && t + 1 < o && a[t + 1].type === "text" ? a[t + 1].content = a[t].content + a[t + 1].content : (t !== n && (a[n] = a[t]), n++);
    t !== n && (a.length = n);
  }
}
const Ps = [
  ["normalize", bA],
  ["block", vA],
  ["inline", yA],
  ["linkify", SA],
  ["replacements", LA],
  ["smartquotes", OA],
  // `text_join` finds `text_special` tokens (for escape sequences)
  // and joins them with the rest of the text
  ["text_join", IA]
];
function u0() {
  this.ruler = new tn();
  for (let e = 0; e < Ps.length; e++)
    this.ruler.push(Ps[e][0], Ps[e][1]);
}
u0.prototype.process = function(e) {
  const t = this.ruler.getRules("");
  for (let n = 0, r = t.length; n < r; n++)
    t[n](e);
};
u0.prototype.State = Pv;
function Mn(e, t, n, r) {
  this.src = e, this.md = t, this.env = n, this.tokens = r, this.bMarks = [], this.eMarks = [], this.tShift = [], this.sCount = [], this.bsCount = [], this.blkIndent = 0, this.line = 0, this.lineMax = 0, this.tight = !1, this.ddIndent = -1, this.listIndent = -1, this.parentType = "root", this.level = 0;
  const u = this.src;
  for (let i = 0, a = 0, o = 0, s = 0, c = u.length, l = !1; a < c; a++) {
    const d = u.charCodeAt(a);
    if (!l)
      if (Xe(d)) {
        o++, d === 9 ? s += 4 - s % 4 : s++;
        continue;
      } else
        l = !0;
    (d === 10 || a === c - 1) && (d !== 10 && a++, this.bMarks.push(i), this.eMarks.push(a), this.tShift.push(o), this.sCount.push(s), this.bsCount.push(0), l = !1, o = 0, s = 0, i = a + 1);
  }
  this.bMarks.push(u.length), this.eMarks.push(u.length), this.tShift.push(0), this.sCount.push(0), this.bsCount.push(0), this.lineMax = this.bMarks.length - 1;
}
Mn.prototype.push = function(e, t, n) {
  const r = new wn(e, t, n);
  return r.block = !0, n < 0 && this.level--, r.level = this.level, n > 0 && this.level++, this.tokens.push(r), r;
};
Mn.prototype.isEmpty = function(t) {
  return this.bMarks[t] + this.tShift[t] >= this.eMarks[t];
};
Mn.prototype.skipEmptyLines = function(t) {
  for (let n = this.lineMax; t < n && !(this.bMarks[t] + this.tShift[t] < this.eMarks[t]); t++)
    ;
  return t;
};
Mn.prototype.skipSpaces = function(t) {
  for (let n = this.src.length; t < n; t++) {
    const r = this.src.charCodeAt(t);
    if (!Xe(r))
      break;
  }
  return t;
};
Mn.prototype.skipSpacesBack = function(t, n) {
  if (t <= n)
    return t;
  for (; t > n; )
    if (!Xe(this.src.charCodeAt(--t)))
      return t + 1;
  return t;
};
Mn.prototype.skipChars = function(t, n) {
  for (let r = this.src.length; t < r && this.src.charCodeAt(t) === n; t++)
    ;
  return t;
};
Mn.prototype.skipCharsBack = function(t, n, r) {
  if (t <= r)
    return t;
  for (; t > r; )
    if (n !== this.src.charCodeAt(--t))
      return t + 1;
  return t;
};
Mn.prototype.getLines = function(t, n, r, u) {
  if (t >= n)
    return "";
  const i = new Array(n - t);
  for (let a = 0, o = t; o < n; o++, a++) {
    let s = 0;
    const c = this.bMarks[o];
    let l = c, d;
    for (o + 1 < n || u ? d = this.eMarks[o] + 1 : d = this.eMarks[o]; l < d && s < r; ) {
      const f = this.src.charCodeAt(l);
      if (Xe(f))
        f === 9 ? s += 4 - (s + this.bsCount[o]) % 4 : s++;
      else if (l - c < this.tShift[o])
        s++;
      else
        break;
      l++;
    }
    s > r ? i[a] = new Array(s - r + 1).join(" ") + this.src.slice(l, d) : i[a] = this.src.slice(l, d);
  }
  return i.join("");
};
Mn.prototype.Token = wn;
const MA = 65536;
function Rs(e, t) {
  const n = e.bMarks[t] + e.tShift[t], r = e.eMarks[t];
  return e.src.slice(n, r);
}
function tp(e) {
  const t = [], n = e.length;
  let r = 0, u = e.charCodeAt(r), i = !1, a = 0, o = "";
  for (; r < n; )
    u === 124 && (i ? (o += e.substring(a, r - 1), a = r) : (t.push(o + e.substring(a, r)), o = "", a = r + 1)), i = u === 92, r++, u = e.charCodeAt(r);
  return t.push(o + e.substring(a)), t;
}
function PA(e, t, n, r) {
  if (t + 2 > n)
    return !1;
  let u = t + 1;
  if (e.sCount[u] < e.blkIndent || e.sCount[u] - e.blkIndent >= 4)
    return !1;
  let i = e.bMarks[u] + e.tShift[u];
  if (i >= e.eMarks[u])
    return !1;
  const a = e.src.charCodeAt(i++);
  if (a !== 124 && a !== 45 && a !== 58 || i >= e.eMarks[u])
    return !1;
  const o = e.src.charCodeAt(i++);
  if (o !== 124 && o !== 45 && o !== 58 && !Xe(o) || a === 45 && Xe(o))
    return !1;
  for (; i < e.eMarks[u]; ) {
    const v = e.src.charCodeAt(i);
    if (v !== 124 && v !== 45 && v !== 58 && !Xe(v))
      return !1;
    i++;
  }
  let s = Rs(e, t + 1), c = s.split("|");
  const l = [];
  for (let v = 0; v < c.length; v++) {
    const S = c[v].trim();
    if (!S) {
      if (v === 0 || v === c.length - 1)
        continue;
      return !1;
    }
    if (!/^:?-+:?$/.test(S))
      return !1;
    S.charCodeAt(S.length - 1) === 58 ? l.push(S.charCodeAt(0) === 58 ? "center" : "right") : S.charCodeAt(0) === 58 ? l.push("left") : l.push("");
  }
  if (s = Rs(e, t).trim(), s.indexOf("|") === -1 || e.sCount[t] - e.blkIndent >= 4)
    return !1;
  c = tp(s), c.length && c[0] === "" && c.shift(), c.length && c[c.length - 1] === "" && c.pop();
  const d = c.length;
  if (d === 0 || d !== l.length)
    return !1;
  if (r)
    return !0;
  const f = e.parentType;
  e.parentType = "table";
  const p = e.md.block.ruler.getRules("blockquote"), h = e.push("table_open", "table", 1), m = [t, 0];
  h.map = m;
  const b = e.push("thead_open", "thead", 1);
  b.map = [t, t + 1];
  const x = e.push("tr_open", "tr", 1);
  x.map = [t, t + 1];
  for (let v = 0; v < c.length; v++) {
    const S = e.push("th_open", "th", 1);
    l[v] && (S.attrs = [["style", "text-align:" + l[v]]]);
    const _ = e.push("inline", "", 0);
    _.content = c[v].trim(), _.children = [], e.push("th_close", "th", -1);
  }
  e.push("tr_close", "tr", -1), e.push("thead_close", "thead", -1);
  let y, g = 0;
  for (u = t + 2; u < n && !(e.sCount[u] < e.blkIndent); u++) {
    let v = !1;
    for (let _ = 0, A = p.length; _ < A; _++)
      if (p[_](e, u, n, !0)) {
        v = !0;
        break;
      }
    if (v || (s = Rs(e, u).trim(), !s) || e.sCount[u] - e.blkIndent >= 4 || (c = tp(s), c.length && c[0] === "" && c.shift(), c.length && c[c.length - 1] === "" && c.pop(), g += d - c.length, g > MA))
      break;
    if (u === t + 2) {
      const _ = e.push("tbody_open", "tbody", 1);
      _.map = y = [t + 2, 0];
    }
    const S = e.push("tr_open", "tr", 1);
    S.map = [u, u + 1];
    for (let _ = 0; _ < d; _++) {
      const A = e.push("td_open", "td", 1);
      l[_] && (A.attrs = [["style", "text-align:" + l[_]]]);
      const k = e.push("inline", "", 0);
      k.content = c[_] ? c[_].trim() : "", k.children = [], e.push("td_close", "td", -1);
    }
    e.push("tr_close", "tr", -1);
  }
  return y && (e.push("tbody_close", "tbody", -1), y[1] = u), e.push("table_close", "table", -1), m[1] = u, e.parentType = f, e.line = u, !0;
}
function RA(e, t, n) {
  if (e.sCount[t] - e.blkIndent < 4)
    return !1;
  let r = t + 1, u = r;
  for (; r < n; ) {
    if (e.isEmpty(r)) {
      r++;
      continue;
    }
    if (e.sCount[r] - e.blkIndent >= 4) {
      r++, u = r;
      continue;
    }
    break;
  }
  e.line = u;
  const i = e.push("code_block", "code", 0);
  return i.content = e.getLines(t, u, 4 + e.blkIndent, !1) + `
`, i.map = [t, e.line], !0;
}
function BA(e, t, n, r) {
  let u = e.bMarks[t] + e.tShift[t], i = e.eMarks[t];
  if (e.sCount[t] - e.blkIndent >= 4 || u + 3 > i)
    return !1;
  const a = e.src.charCodeAt(u);
  if (a !== 126 && a !== 96)
    return !1;
  let o = u;
  u = e.skipChars(u, a);
  let s = u - o;
  if (s < 3)
    return !1;
  const c = e.src.slice(o, u), l = e.src.slice(u, i);
  if (a === 96 && l.indexOf(String.fromCharCode(a)) >= 0)
    return !1;
  if (r)
    return !0;
  let d = t, f = !1;
  for (; d++, !(d >= n || (u = o = e.bMarks[d] + e.tShift[d], i = e.eMarks[d], u < i && e.sCount[d] < e.blkIndent)); )
    if (e.src.charCodeAt(u) === a && !(e.sCount[d] - e.blkIndent >= 4) && (u = e.skipChars(u, a), !(u - o < s) && (u = e.skipSpaces(u), !(u < i)))) {
      f = !0;
      break;
    }
  s = e.sCount[t], e.line = d + (f ? 1 : 0);
  const p = e.push("fence", "code", 0);
  return p.info = l, p.content = e.getLines(t + 1, d, s, !0), p.markup = c, p.map = [t, e.line], !0;
}
function FA(e, t, n, r) {
  let u = e.bMarks[t] + e.tShift[t], i = e.eMarks[t];
  const a = e.lineMax;
  if (e.sCount[t] - e.blkIndent >= 4 || e.src.charCodeAt(u) !== 62)
    return !1;
  if (r)
    return !0;
  const o = [], s = [], c = [], l = [], d = e.md.block.ruler.getRules("blockquote"), f = e.parentType;
  e.parentType = "blockquote";
  let p = !1, h;
  for (h = t; h < n; h++) {
    const g = e.sCount[h] < e.blkIndent;
    if (u = e.bMarks[h] + e.tShift[h], i = e.eMarks[h], u >= i)
      break;
    if (e.src.charCodeAt(u++) === 62 && !g) {
      let S = e.sCount[h] + 1, _, A;
      e.src.charCodeAt(u) === 32 ? (u++, S++, A = !1, _ = !0) : e.src.charCodeAt(u) === 9 ? (_ = !0, (e.bsCount[h] + S) % 4 === 3 ? (u++, S++, A = !1) : A = !0) : _ = !1;
      let k = S;
      for (o.push(e.bMarks[h]), e.bMarks[h] = u; u < i; ) {
        const T = e.src.charCodeAt(u);
        if (Xe(T))
          T === 9 ? k += 4 - (k + e.bsCount[h] + (A ? 1 : 0)) % 4 : k++;
        else
          break;
        u++;
      }
      p = u >= i, s.push(e.bsCount[h]), e.bsCount[h] = e.sCount[h] + 1 + (_ ? 1 : 0), c.push(e.sCount[h]), e.sCount[h] = k - S, l.push(e.tShift[h]), e.tShift[h] = u - e.bMarks[h];
      continue;
    }
    if (p)
      break;
    let v = !1;
    for (let S = 0, _ = d.length; S < _; S++)
      if (d[S](e, h, n, !0)) {
        v = !0;
        break;
      }
    if (v) {
      e.lineMax = h, e.blkIndent !== 0 && (o.push(e.bMarks[h]), s.push(e.bsCount[h]), l.push(e.tShift[h]), c.push(e.sCount[h]), e.sCount[h] -= e.blkIndent);
      break;
    }
    o.push(e.bMarks[h]), s.push(e.bsCount[h]), l.push(e.tShift[h]), c.push(e.sCount[h]), e.sCount[h] = -1;
  }
  const m = e.blkIndent;
  e.blkIndent = 0;
  const b = e.push("blockquote_open", "blockquote", 1);
  b.markup = ">";
  const x = [t, 0];
  b.map = x, e.md.block.tokenize(e, t, h);
  const y = e.push("blockquote_close", "blockquote", -1);
  y.markup = ">", e.lineMax = a, e.parentType = f, x[1] = e.line;
  for (let g = 0; g < l.length; g++)
    e.bMarks[g + t] = o[g], e.tShift[g + t] = l[g], e.sCount[g + t] = c[g], e.bsCount[g + t] = s[g];
  return e.blkIndent = m, !0;
}
function HA(e, t, n, r) {
  const u = e.eMarks[t];
  if (e.sCount[t] - e.blkIndent >= 4)
    return !1;
  let i = e.bMarks[t] + e.tShift[t];
  const a = e.src.charCodeAt(i++);
  if (a !== 42 && a !== 45 && a !== 95)
    return !1;
  let o = 1;
  for (; i < u; ) {
    const c = e.src.charCodeAt(i++);
    if (c !== a && !Xe(c))
      return !1;
    c === a && o++;
  }
  if (o < 3)
    return !1;
  if (r)
    return !0;
  e.line = t + 1;
  const s = e.push("hr", "hr", 0);
  return s.map = [t, e.line], s.markup = Array(o + 1).join(String.fromCharCode(a)), !0;
}
function np(e, t) {
  const n = e.eMarks[t];
  let r = e.bMarks[t] + e.tShift[t];
  const u = e.src.charCodeAt(r++);
  if (u !== 42 && u !== 45 && u !== 43)
    return -1;
  if (r < n) {
    const i = e.src.charCodeAt(r);
    if (!Xe(i))
      return -1;
  }
  return r;
}
function rp(e, t) {
  const n = e.bMarks[t] + e.tShift[t], r = e.eMarks[t];
  let u = n;
  if (u + 1 >= r)
    return -1;
  let i = e.src.charCodeAt(u++);
  if (i < 48 || i > 57)
    return -1;
  for (; ; ) {
    if (u >= r)
      return -1;
    if (i = e.src.charCodeAt(u++), i >= 48 && i <= 57) {
      if (u - n >= 10)
        return -1;
      continue;
    }
    if (i === 41 || i === 46)
      break;
    return -1;
  }
  return u < r && (i = e.src.charCodeAt(u), !Xe(i)) ? -1 : u;
}
function $A(e, t) {
  const n = e.level + 2;
  for (let r = t + 2, u = e.tokens.length - 2; r < u; r++)
    e.tokens[r].level === n && e.tokens[r].type === "paragraph_open" && (e.tokens[r + 2].hidden = !0, e.tokens[r].hidden = !0, r += 2);
}
function VA(e, t, n, r) {
  let u, i, a, o, s = t, c = !0;
  if (e.sCount[s] - e.blkIndent >= 4 || e.listIndent >= 0 && e.sCount[s] - e.listIndent >= 4 && e.sCount[s] < e.blkIndent)
    return !1;
  let l = !1;
  r && e.parentType === "paragraph" && e.sCount[s] >= e.blkIndent && (l = !0);
  let d, f, p;
  if ((p = rp(e, s)) >= 0) {
    if (d = !0, a = e.bMarks[s] + e.tShift[s], f = Number(e.src.slice(a, p - 1)), l && f !== 1)
      return !1;
  } else if ((p = np(e, s)) >= 0)
    d = !1;
  else
    return !1;
  if (l && e.skipSpaces(p) >= e.eMarks[s])
    return !1;
  if (r)
    return !0;
  const h = e.src.charCodeAt(p - 1), m = e.tokens.length;
  d ? (o = e.push("ordered_list_open", "ol", 1), f !== 1 && (o.attrs = [["start", f]])) : o = e.push("bullet_list_open", "ul", 1);
  const b = [s, 0];
  o.map = b, o.markup = String.fromCharCode(h);
  let x = !1;
  const y = e.md.block.ruler.getRules("list"), g = e.parentType;
  for (e.parentType = "list"; s < n; ) {
    i = p, u = e.eMarks[s];
    const v = e.sCount[s] + p - (e.bMarks[s] + e.tShift[s]);
    let S = v;
    for (; i < u; ) {
      const H = e.src.charCodeAt(i);
      if (H === 9)
        S += 4 - (S + e.bsCount[s]) % 4;
      else if (H === 32)
        S++;
      else
        break;
      i++;
    }
    const _ = i;
    let A;
    _ >= u ? A = 1 : A = S - v, A > 4 && (A = 1);
    const k = v + A;
    o = e.push("list_item_open", "li", 1), o.markup = String.fromCharCode(h);
    const T = [s, 0];
    o.map = T, d && (o.info = e.src.slice(a, p - 1));
    const L = e.tight, w = e.tShift[s], D = e.sCount[s], N = e.listIndent;
    if (e.listIndent = e.blkIndent, e.blkIndent = k, e.tight = !0, e.tShift[s] = _ - e.bMarks[s], e.sCount[s] = S, _ >= u && e.isEmpty(s + 1) ? e.line = Math.min(e.line + 2, n) : e.md.block.tokenize(e, s, n, !0), (!e.tight || x) && (c = !1), x = e.line - s > 1 && e.isEmpty(e.line - 1), e.blkIndent = e.listIndent, e.listIndent = N, e.tShift[s] = w, e.sCount[s] = D, e.tight = L, o = e.push("list_item_close", "li", -1), o.markup = String.fromCharCode(h), s = e.line, T[1] = s, s >= n || e.sCount[s] < e.blkIndent || e.sCount[s] - e.blkIndent >= 4)
      break;
    let O = !1;
    for (let H = 0, $ = y.length; H < $; H++)
      if (y[H](e, s, n, !0)) {
        O = !0;
        break;
      }
    if (O)
      break;
    if (d) {
      if (p = rp(e, s), p < 0)
        break;
      a = e.bMarks[s] + e.tShift[s];
    } else if (p = np(e, s), p < 0)
      break;
    if (h !== e.src.charCodeAt(p - 1))
      break;
  }
  return d ? o = e.push("ordered_list_close", "ol", -1) : o = e.push("bullet_list_close", "ul", -1), o.markup = String.fromCharCode(h), b[1] = s, e.line = s, e.parentType = g, c && $A(e, m), !0;
}
function jA(e, t, n, r) {
  let u = e.bMarks[t] + e.tShift[t], i = e.eMarks[t], a = t + 1;
  if (e.sCount[t] - e.blkIndent >= 4 || e.src.charCodeAt(u) !== 91)
    return !1;
  function o(y) {
    const g = e.lineMax;
    if (y >= g || e.isEmpty(y))
      return null;
    let v = !1;
    if (e.sCount[y] - e.blkIndent > 3 && (v = !0), e.sCount[y] < 0 && (v = !0), !v) {
      const A = e.md.block.ruler.getRules("reference"), k = e.parentType;
      e.parentType = "reference";
      let T = !1;
      for (let L = 0, w = A.length; L < w; L++)
        if (A[L](e, y, g, !0)) {
          T = !0;
          break;
        }
      if (e.parentType = k, T)
        return null;
    }
    const S = e.bMarks[y] + e.tShift[y], _ = e.eMarks[y];
    return e.src.slice(S, _ + 1);
  }
  let s = e.src.slice(u, i + 1);
  i = s.length;
  let c = -1;
  for (u = 1; u < i; u++) {
    const y = s.charCodeAt(u);
    if (y === 91)
      return !1;
    if (y === 93) {
      c = u;
      break;
    } else if (y === 10) {
      const g = o(a);
      g !== null && (s += g, i = s.length, a++);
    } else if (y === 92 && (u++, u < i && s.charCodeAt(u) === 10)) {
      const g = o(a);
      g !== null && (s += g, i = s.length, a++);
    }
  }
  if (c < 0 || s.charCodeAt(c + 1) !== 58)
    return !1;
  for (u = c + 2; u < i; u++) {
    const y = s.charCodeAt(u);
    if (y === 10) {
      const g = o(a);
      g !== null && (s += g, i = s.length, a++);
    } else if (!Xe(y))
      break;
  }
  const l = e.md.helpers.parseLinkDestination(s, u, i);
  if (!l.ok)
    return !1;
  const d = e.md.normalizeLink(l.str);
  if (!e.md.validateLink(d))
    return !1;
  u = l.pos;
  const f = u, p = a, h = u;
  for (; u < i; u++) {
    const y = s.charCodeAt(u);
    if (y === 10) {
      const g = o(a);
      g !== null && (s += g, i = s.length, a++);
    } else if (!Xe(y))
      break;
  }
  let m = e.md.helpers.parseLinkTitle(s, u, i);
  for (; m.can_continue; ) {
    const y = o(a);
    if (y === null)
      break;
    s += y, u = i, i = s.length, a++, m = e.md.helpers.parseLinkTitle(s, u, i, m);
  }
  let b;
  for (u < i && h !== u && m.ok ? (b = m.str, u = m.pos) : (b = "", u = f, a = p); u < i; ) {
    const y = s.charCodeAt(u);
    if (!Xe(y))
      break;
    u++;
  }
  if (u < i && s.charCodeAt(u) !== 10 && b)
    for (b = "", u = f, a = p; u < i; ) {
      const y = s.charCodeAt(u);
      if (!Xe(y))
        break;
      u++;
    }
  if (u < i && s.charCodeAt(u) !== 10)
    return !1;
  const x = Do(s.slice(1, c));
  return x ? (r || (typeof e.env.references > "u" && (e.env.references = {}), typeof e.env.references[x] > "u" && (e.env.references[x] = { title: b, href: d }), e.line = a), !0) : !1;
}
const zA = [
  "address",
  "article",
  "aside",
  "base",
  "basefont",
  "blockquote",
  "body",
  "caption",
  "center",
  "col",
  "colgroup",
  "dd",
  "details",
  "dialog",
  "dir",
  "div",
  "dl",
  "dt",
  "fieldset",
  "figcaption",
  "figure",
  "footer",
  "form",
  "frame",
  "frameset",
  "h1",
  "h2",
  "h3",
  "h4",
  "h5",
  "h6",
  "head",
  "header",
  "hr",
  "html",
  "iframe",
  "legend",
  "li",
  "link",
  "main",
  "menu",
  "menuitem",
  "nav",
  "noframes",
  "ol",
  "optgroup",
  "option",
  "p",
  "param",
  "search",
  "section",
  "summary",
  "table",
  "tbody",
  "td",
  "tfoot",
  "th",
  "thead",
  "title",
  "tr",
  "track",
  "ul"
], UA = "[a-zA-Z_:][a-zA-Z0-9:._-]*", qA = "[^\"'=<>`\\x00-\\x20]+", GA = "'[^']*'", WA = '"[^"]*"', KA = "(?:" + qA + "|" + GA + "|" + WA + ")", YA = "(?:\\s+" + UA + "(?:\\s*=\\s*" + KA + ")?)", Bv = "<[A-Za-z][A-Za-z0-9\\-]*" + YA + "*\\s*\\/?>", Fv = "<\\/[A-Za-z][A-Za-z0-9\\-]*\\s*>", ZA = "<!---?>|<!--(?:[^-]|-[^-]|--[^>])*-->", XA = "<[?][\\s\\S]*?[?]>", QA = "<![A-Za-z][^>]*>", JA = "<!\\[CDATA\\[[\\s\\S]*?\\]\\]>", e7 = new RegExp("^(?:" + Bv + "|" + Fv + "|" + ZA + "|" + XA + "|" + QA + "|" + JA + ")"), t7 = new RegExp("^(?:" + Bv + "|" + Fv + ")"), Yr = [
  [/^<(script|pre|style|textarea)(?=(\s|>|$))/i, /<\/(script|pre|style|textarea)>/i, !0],
  [/^<!--/, /-->/, !0],
  [/^<\?/, /\?>/, !0],
  [/^<![A-Z]/, />/, !0],
  [/^<!\[CDATA\[/, /\]\]>/, !0],
  [new RegExp("^</?(" + zA.join("|") + ")(?=(\\s|/?>|$))", "i"), /^$/, !0],
  [new RegExp(t7.source + "\\s*$"), /^$/, !1]
];
function n7(e, t, n, r) {
  let u = e.bMarks[t] + e.tShift[t], i = e.eMarks[t];
  if (e.sCount[t] - e.blkIndent >= 4 || !e.md.options.html || e.src.charCodeAt(u) !== 60)
    return !1;
  let a = e.src.slice(u, i), o = 0;
  for (; o < Yr.length && !Yr[o][0].test(a); o++)
    ;
  if (o === Yr.length)
    return !1;
  if (r)
    return Yr[o][2];
  let s = t + 1;
  if (!Yr[o][1].test(a)) {
    for (; s < n && !(e.sCount[s] < e.blkIndent); s++)
      if (u = e.bMarks[s] + e.tShift[s], i = e.eMarks[s], a = e.src.slice(u, i), Yr[o][1].test(a)) {
        a.length !== 0 && s++;
        break;
      }
  }
  e.line = s;
  const c = e.push("html_block", "", 0);
  return c.map = [t, s], c.content = e.getLines(t, s, e.blkIndent, !0), !0;
}
function r7(e, t, n, r) {
  let u = e.bMarks[t] + e.tShift[t], i = e.eMarks[t];
  if (e.sCount[t] - e.blkIndent >= 4)
    return !1;
  let a = e.src.charCodeAt(u);
  if (a !== 35 || u >= i)
    return !1;
  let o = 1;
  for (a = e.src.charCodeAt(++u); a === 35 && u < i && o <= 6; )
    o++, a = e.src.charCodeAt(++u);
  if (o > 6 || u < i && !Xe(a))
    return !1;
  if (r)
    return !0;
  i = e.skipSpacesBack(i, u);
  const s = e.skipCharsBack(i, 35, u);
  s > u && Xe(e.src.charCodeAt(s - 1)) && (i = s), e.line = t + 1;
  const c = e.push("heading_open", "h" + String(o), 1);
  c.markup = "########".slice(0, o), c.map = [t, e.line];
  const l = e.push("inline", "", 0);
  l.content = e.src.slice(u, i).trim(), l.map = [t, e.line], l.children = [];
  const d = e.push("heading_close", "h" + String(o), -1);
  return d.markup = "########".slice(0, o), !0;
}
function u7(e, t, n) {
  const r = e.md.block.ruler.getRules("paragraph");
  if (e.sCount[t] - e.blkIndent >= 4)
    return !1;
  const u = e.parentType;
  e.parentType = "paragraph";
  let i = 0, a, o = t + 1;
  for (; o < n && !e.isEmpty(o); o++) {
    if (e.sCount[o] - e.blkIndent > 3)
      continue;
    if (e.sCount[o] >= e.blkIndent) {
      let p = e.bMarks[o] + e.tShift[o];
      const h = e.eMarks[o];
      if (p < h && (a = e.src.charCodeAt(p), (a === 45 || a === 61) && (p = e.skipChars(p, a), p = e.skipSpaces(p), p >= h))) {
        i = a === 61 ? 1 : 2;
        break;
      }
    }
    if (e.sCount[o] < 0)
      continue;
    let f = !1;
    for (let p = 0, h = r.length; p < h; p++)
      if (r[p](e, o, n, !0)) {
        f = !0;
        break;
      }
    if (f)
      break;
  }
  if (!i)
    return !1;
  const s = e.getLines(t, o, e.blkIndent, !1).trim();
  e.line = o + 1;
  const c = e.push("heading_open", "h" + String(i), 1);
  c.markup = String.fromCharCode(a), c.map = [t, e.line];
  const l = e.push("inline", "", 0);
  l.content = s, l.map = [t, e.line - 1], l.children = [];
  const d = e.push("heading_close", "h" + String(i), -1);
  return d.markup = String.fromCharCode(a), e.parentType = u, !0;
}
function i7(e, t, n) {
  const r = e.md.block.ruler.getRules("paragraph"), u = e.parentType;
  let i = t + 1;
  for (e.parentType = "paragraph"; i < n && !e.isEmpty(i); i++) {
    if (e.sCount[i] - e.blkIndent > 3 || e.sCount[i] < 0)
      continue;
    let c = !1;
    for (let l = 0, d = r.length; l < d; l++)
      if (r[l](e, i, n, !0)) {
        c = !0;
        break;
      }
    if (c)
      break;
  }
  const a = e.getLines(t, i, e.blkIndent, !1).trim();
  e.line = i;
  const o = e.push("paragraph_open", "p", 1);
  o.map = [t, e.line];
  const s = e.push("inline", "", 0);
  return s.content = a, s.map = [t, e.line], s.children = [], e.push("paragraph_close", "p", -1), e.parentType = u, !0;
}
const da = [
  // First 2 params - rule name & source. Secondary array - list of rules,
  // which can be terminated by this one.
  ["table", PA, ["paragraph", "reference"]],
  ["code", RA],
  ["fence", BA, ["paragraph", "reference", "blockquote", "list"]],
  ["blockquote", FA, ["paragraph", "reference", "blockquote", "list"]],
  ["hr", HA, ["paragraph", "reference", "blockquote", "list"]],
  ["list", VA, ["paragraph", "reference", "blockquote"]],
  ["reference", jA],
  ["html_block", n7, ["paragraph", "reference", "blockquote"]],
  ["heading", r7, ["paragraph", "reference", "blockquote"]],
  ["lheading", u7],
  ["paragraph", i7]
];
function No() {
  this.ruler = new tn();
  for (let e = 0; e < da.length; e++)
    this.ruler.push(da[e][0], da[e][1], { alt: (da[e][2] || []).slice() });
}
No.prototype.tokenize = function(e, t, n) {
  const r = this.ruler.getRules(""), u = r.length, i = e.md.options.maxNesting;
  let a = t, o = !1;
  for (; a < n && (e.line = a = e.skipEmptyLines(a), !(a >= n || e.sCount[a] < e.blkIndent)); ) {
    if (e.level >= i) {
      e.line = n;
      break;
    }
    const s = e.line;
    let c = !1;
    for (let l = 0; l < u; l++)
      if (c = r[l](e, a, n, !1), c) {
        if (s >= e.line)
          throw new Error("block rule didn't increment state.line");
        break;
      }
    if (!c)
      throw new Error("none of the block rules matched");
    e.tight = !o, e.isEmpty(e.line - 1) && (o = !0), a = e.line, a < n && e.isEmpty(a) && (o = !0, a++, e.line = a);
  }
};
No.prototype.parse = function(e, t, n, r) {
  if (!e)
    return;
  const u = new this.State(e, t, n, r);
  this.tokenize(u, u.line, u.lineMax);
};
No.prototype.State = Mn;
function qi(e, t, n, r) {
  this.src = e, this.env = n, this.md = t, this.tokens = r, this.tokens_meta = Array(r.length), this.pos = 0, this.posMax = this.src.length, this.level = 0, this.pending = "", this.pendingLevel = 0, this.cache = {}, this.delimiters = [], this._prev_delimiters = [], this.backticks = {}, this.backticksScanned = !1, this.linkLevel = 0;
}
qi.prototype.pushPending = function() {
  const e = new wn("text", "", 0);
  return e.content = this.pending, e.level = this.pendingLevel, this.tokens.push(e), this.pending = "", e;
};
qi.prototype.push = function(e, t, n) {
  this.pending && this.pushPending();
  const r = new wn(e, t, n);
  let u = null;
  return n < 0 && (this.level--, this.delimiters = this._prev_delimiters.pop()), r.level = this.level, n > 0 && (this.level++, this._prev_delimiters.push(this.delimiters), this.delimiters = [], u = { delimiters: this.delimiters }), this.pendingLevel = this.level, this.tokens.push(r), this.tokens_meta.push(u), r;
};
qi.prototype.scanDelims = function(e, t) {
  const n = this.posMax, r = this.src.charCodeAt(e), u = e > 0 ? this.src.charCodeAt(e - 1) : 32;
  let i = e;
  for (; i < n && this.src.charCodeAt(i) === r; )
    i++;
  const a = i - e, o = i < n ? this.src.charCodeAt(i) : 32, s = Ai(u) || Ti(String.fromCharCode(u)), c = Ai(o) || Ti(String.fromCharCode(o)), l = wi(u), d = wi(o), f = !d && (!c || l || s), p = !l && (!s || d || c);
  return { can_open: f && (t || !p || s), can_close: p && (t || !f || c), length: a };
};
qi.prototype.Token = wn;
function a7(e) {
  switch (e) {
    case 10:
    case 33:
    case 35:
    case 36:
    case 37:
    case 38:
    case 42:
    case 43:
    case 45:
    case 58:
    case 60:
    case 61:
    case 62:
    case 64:
    case 91:
    case 92:
    case 93:
    case 94:
    case 95:
    case 96:
    case 123:
    case 125:
    case 126:
      return !0;
    default:
      return !1;
  }
}
function o7(e, t) {
  let n = e.pos;
  for (; n < e.posMax && !a7(e.src.charCodeAt(n)); )
    n++;
  return n === e.pos ? !1 : (t || (e.pending += e.src.slice(e.pos, n)), e.pos = n, !0);
}
const s7 = /(?:^|[^a-z0-9.+-])([a-z][a-z0-9.+-]*)$/i;
function c7(e, t) {
  if (!e.md.options.linkify || e.linkLevel > 0)
    return !1;
  const n = e.pos, r = e.posMax;
  if (n + 3 > r || e.src.charCodeAt(n) !== 58 || e.src.charCodeAt(n + 1) !== 47 || e.src.charCodeAt(n + 2) !== 47)
    return !1;
  const u = e.pending.match(s7);
  if (!u)
    return !1;
  const i = u[1], a = e.md.linkify.matchAtStart(e.src.slice(n - i.length));
  if (!a)
    return !1;
  let o = a.url;
  if (o.length <= i.length)
    return !1;
  o = o.replace(/\*+$/, "");
  const s = e.md.normalizeLink(o);
  if (!e.md.validateLink(s))
    return !1;
  if (!t) {
    e.pending = e.pending.slice(0, -i.length);
    const c = e.push("link_open", "a", 1);
    c.attrs = [["href", s]], c.markup = "linkify", c.info = "auto";
    const l = e.push("text", "", 0);
    l.content = e.md.normalizeLinkText(o);
    const d = e.push("link_close", "a", -1);
    d.markup = "linkify", d.info = "auto";
  }
  return e.pos += o.length - i.length, !0;
}
function l7(e, t) {
  let n = e.pos;
  if (e.src.charCodeAt(n) !== 10)
    return !1;
  const r = e.pending.length - 1, u = e.posMax;
  if (!t)
    if (r >= 0 && e.pending.charCodeAt(r) === 32)
      if (r >= 1 && e.pending.charCodeAt(r - 1) === 32) {
        let i = r - 1;
        for (; i >= 1 && e.pending.charCodeAt(i - 1) === 32; )
          i--;
        e.pending = e.pending.slice(0, i), e.push("hardbreak", "br", 0);
      } else
        e.pending = e.pending.slice(0, -1), e.push("softbreak", "br", 0);
    else
      e.push("softbreak", "br", 0);
  for (n++; n < u && Xe(e.src.charCodeAt(n)); )
    n++;
  return e.pos = n, !0;
}
const i0 = [];
for (let e = 0; e < 256; e++)
  i0.push(0);
"\\!\"#$%&'()*+,./:;<=>?@[]^_`{|}~-".split("").forEach(function(e) {
  i0[e.charCodeAt(0)] = 1;
});
function d7(e, t) {
  let n = e.pos;
  const r = e.posMax;
  if (e.src.charCodeAt(n) !== 92 || (n++, n >= r))
    return !1;
  let u = e.src.charCodeAt(n);
  if (u === 10) {
    for (t || e.push("hardbreak", "br", 0), n++; n < r && (u = e.src.charCodeAt(n), !!Xe(u)); )
      n++;
    return e.pos = n, !0;
  }
  let i = e.src[n];
  if (u >= 55296 && u <= 56319 && n + 1 < r) {
    const o = e.src.charCodeAt(n + 1);
    o >= 56320 && o <= 57343 && (i += e.src[n + 1], n++);
  }
  const a = "\\" + i;
  if (!t) {
    const o = e.push("text_special", "", 0);
    u < 256 && i0[u] !== 0 ? o.content = i : o.content = a, o.markup = a, o.info = "escape";
  }
  return e.pos = n + 1, !0;
}
function f7(e, t) {
  let n = e.pos;
  if (e.src.charCodeAt(n) !== 96)
    return !1;
  const u = n;
  n++;
  const i = e.posMax;
  for (; n < i && e.src.charCodeAt(n) === 96; )
    n++;
  const a = e.src.slice(u, n), o = a.length;
  if (e.backticksScanned && (e.backticks[o] || 0) <= u)
    return t || (e.pending += a), e.pos += o, !0;
  let s = n, c;
  for (; (c = e.src.indexOf("`", s)) !== -1; ) {
    for (s = c + 1; s < i && e.src.charCodeAt(s) === 96; )
      s++;
    const l = s - c;
    if (l === o) {
      if (!t) {
        const d = e.push("code_inline", "code", 0);
        d.markup = a, d.content = e.src.slice(n, c).replace(/\n/g, " ").replace(/^ (.+) $/, "$1");
      }
      return e.pos = s, !0;
    }
    e.backticks[l] = c;
  }
  return e.backticksScanned = !0, t || (e.pending += a), e.pos += o, !0;
}
function p7(e, t) {
  const n = e.pos, r = e.src.charCodeAt(n);
  if (t || r !== 126)
    return !1;
  const u = e.scanDelims(e.pos, !0);
  let i = u.length;
  const a = String.fromCharCode(r);
  if (i < 2)
    return !1;
  let o;
  i % 2 && (o = e.push("text", "", 0), o.content = a, i--);
  for (let s = 0; s < i; s += 2)
    o = e.push("text", "", 0), o.content = a + a, e.delimiters.push({
      marker: r,
      length: 0,
      // disable "rule of 3" length checks meant for emphasis
      token: e.tokens.length - 1,
      end: -1,
      open: u.can_open,
      close: u.can_close
    });
  return e.pos += u.length, !0;
}
function up(e, t) {
  let n;
  const r = [], u = t.length;
  for (let i = 0; i < u; i++) {
    const a = t[i];
    if (a.marker !== 126 || a.end === -1)
      continue;
    const o = t[a.end];
    n = e.tokens[a.token], n.type = "s_open", n.tag = "s", n.nesting = 1, n.markup = "~~", n.content = "", n = e.tokens[o.token], n.type = "s_close", n.tag = "s", n.nesting = -1, n.markup = "~~", n.content = "", e.tokens[o.token - 1].type === "text" && e.tokens[o.token - 1].content === "~" && r.push(o.token - 1);
  }
  for (; r.length; ) {
    const i = r.pop();
    let a = i + 1;
    for (; a < e.tokens.length && e.tokens[a].type === "s_close"; )
      a++;
    a--, i !== a && (n = e.tokens[a], e.tokens[a] = e.tokens[i], e.tokens[i] = n);
  }
}
function h7(e) {
  const t = e.tokens_meta, n = e.tokens_meta.length;
  up(e, e.delimiters);
  for (let r = 0; r < n; r++)
    t[r] && t[r].delimiters && up(e, t[r].delimiters);
}
const Hv = {
  tokenize: p7,
  postProcess: h7
};
function m7(e, t) {
  const n = e.pos, r = e.src.charCodeAt(n);
  if (t || r !== 95 && r !== 42)
    return !1;
  const u = e.scanDelims(e.pos, r === 42);
  for (let i = 0; i < u.length; i++) {
    const a = e.push("text", "", 0);
    a.content = String.fromCharCode(r), e.delimiters.push({
      // Char code of the starting marker (number).
      //
      marker: r,
      // Total length of these series of delimiters.
      //
      length: u.length,
      // A position of the token this delimiter corresponds to.
      //
      token: e.tokens.length - 1,
      // If this delimiter is matched as a valid opener, `end` will be
      // equal to its position, otherwise it's `-1`.
      //
      end: -1,
      // Boolean flags that determine if this delimiter could open or close
      // an emphasis.
      //
      open: u.can_open,
      close: u.can_close
    });
  }
  return e.pos += u.length, !0;
}
function ip(e, t) {
  const n = t.length;
  for (let r = n - 1; r >= 0; r--) {
    const u = t[r];
    if (u.marker !== 95 && u.marker !== 42 || u.end === -1)
      continue;
    const i = t[u.end], a = r > 0 && t[r - 1].end === u.end + 1 && // check that first two markers match and adjacent
    t[r - 1].marker === u.marker && t[r - 1].token === u.token - 1 && // check that last two markers are adjacent (we can safely assume they match)
    t[u.end + 1].token === i.token + 1, o = String.fromCharCode(u.marker), s = e.tokens[u.token];
    s.type = a ? "strong_open" : "em_open", s.tag = a ? "strong" : "em", s.nesting = 1, s.markup = a ? o + o : o, s.content = "";
    const c = e.tokens[i.token];
    c.type = a ? "strong_close" : "em_close", c.tag = a ? "strong" : "em", c.nesting = -1, c.markup = a ? o + o : o, c.content = "", a && (e.tokens[t[r - 1].token].content = "", e.tokens[t[u.end + 1].token].content = "", r--);
  }
}
function g7(e) {
  const t = e.tokens_meta, n = e.tokens_meta.length;
  ip(e, e.delimiters);
  for (let r = 0; r < n; r++)
    t[r] && t[r].delimiters && ip(e, t[r].delimiters);
}
const $v = {
  tokenize: m7,
  postProcess: g7
};
function b7(e, t) {
  let n, r, u, i, a = "", o = "", s = e.pos, c = !0;
  if (e.src.charCodeAt(e.pos) !== 91)
    return !1;
  const l = e.pos, d = e.posMax, f = e.pos + 1, p = e.md.helpers.parseLinkLabel(e, e.pos, !0);
  if (p < 0)
    return !1;
  let h = p + 1;
  if (h < d && e.src.charCodeAt(h) === 40) {
    for (c = !1, h++; h < d && (n = e.src.charCodeAt(h), !(!Xe(n) && n !== 10)); h++)
      ;
    if (h >= d)
      return !1;
    if (s = h, u = e.md.helpers.parseLinkDestination(e.src, h, e.posMax), u.ok) {
      for (a = e.md.normalizeLink(u.str), e.md.validateLink(a) ? h = u.pos : a = "", s = h; h < d && (n = e.src.charCodeAt(h), !(!Xe(n) && n !== 10)); h++)
        ;
      if (u = e.md.helpers.parseLinkTitle(e.src, h, e.posMax), h < d && s !== h && u.ok)
        for (o = u.str, h = u.pos; h < d && (n = e.src.charCodeAt(h), !(!Xe(n) && n !== 10)); h++)
          ;
    }
    (h >= d || e.src.charCodeAt(h) !== 41) && (c = !0), h++;
  }
  if (c) {
    if (typeof e.env.references > "u")
      return !1;
    if (h < d && e.src.charCodeAt(h) === 91 ? (s = h + 1, h = e.md.helpers.parseLinkLabel(e, h), h >= 0 ? r = e.src.slice(s, h++) : h = p + 1) : h = p + 1, r || (r = e.src.slice(f, p)), i = e.env.references[Do(r)], !i)
      return e.pos = l, !1;
    a = i.href, o = i.title;
  }
  if (!t) {
    e.pos = f, e.posMax = p;
    const m = e.push("link_open", "a", 1), b = [["href", a]];
    m.attrs = b, o && b.push(["title", o]), e.linkLevel++, e.md.inline.tokenize(e), e.linkLevel--, e.push("link_close", "a", -1);
  }
  return e.pos = h, e.posMax = d, !0;
}
function v7(e, t) {
  let n, r, u, i, a, o, s, c, l = "";
  const d = e.pos, f = e.posMax;
  if (e.src.charCodeAt(e.pos) !== 33 || e.src.charCodeAt(e.pos + 1) !== 91)
    return !1;
  const p = e.pos + 2, h = e.md.helpers.parseLinkLabel(e, e.pos + 1, !1);
  if (h < 0)
    return !1;
  if (i = h + 1, i < f && e.src.charCodeAt(i) === 40) {
    for (i++; i < f && (n = e.src.charCodeAt(i), !(!Xe(n) && n !== 10)); i++)
      ;
    if (i >= f)
      return !1;
    for (c = i, o = e.md.helpers.parseLinkDestination(e.src, i, e.posMax), o.ok && (l = e.md.normalizeLink(o.str), e.md.validateLink(l) ? i = o.pos : l = ""), c = i; i < f && (n = e.src.charCodeAt(i), !(!Xe(n) && n !== 10)); i++)
      ;
    if (o = e.md.helpers.parseLinkTitle(e.src, i, e.posMax), i < f && c !== i && o.ok)
      for (s = o.str, i = o.pos; i < f && (n = e.src.charCodeAt(i), !(!Xe(n) && n !== 10)); i++)
        ;
    else
      s = "";
    if (i >= f || e.src.charCodeAt(i) !== 41)
      return e.pos = d, !1;
    i++;
  } else {
    if (typeof e.env.references > "u")
      return !1;
    if (i < f && e.src.charCodeAt(i) === 91 ? (c = i + 1, i = e.md.helpers.parseLinkLabel(e, i), i >= 0 ? u = e.src.slice(c, i++) : i = h + 1) : i = h + 1, u || (u = e.src.slice(p, h)), a = e.env.references[Do(u)], !a)
      return e.pos = d, !1;
    l = a.href, s = a.title;
  }
  if (!t) {
    r = e.src.slice(p, h);
    const m = [];
    e.md.inline.parse(
      r,
      e.md,
      e.env,
      m
    );
    const b = e.push("image", "img", 0), x = [["src", l], ["alt", ""]];
    b.attrs = x, b.children = m, b.content = r, s && x.push(["title", s]);
  }
  return e.pos = i, e.posMax = f, !0;
}
const y7 = /^([a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*)$/, x7 = /^([a-zA-Z][a-zA-Z0-9+.-]{1,31}):([^<>\x00-\x20]*)$/;
function _7(e, t) {
  let n = e.pos;
  if (e.src.charCodeAt(n) !== 60)
    return !1;
  const r = e.pos, u = e.posMax;
  for (; ; ) {
    if (++n >= u)
      return !1;
    const a = e.src.charCodeAt(n);
    if (a === 60)
      return !1;
    if (a === 62)
      break;
  }
  const i = e.src.slice(r + 1, n);
  if (x7.test(i)) {
    const a = e.md.normalizeLink(i);
    if (!e.md.validateLink(a))
      return !1;
    if (!t) {
      const o = e.push("link_open", "a", 1);
      o.attrs = [["href", a]], o.markup = "autolink", o.info = "auto";
      const s = e.push("text", "", 0);
      s.content = e.md.normalizeLinkText(i);
      const c = e.push("link_close", "a", -1);
      c.markup = "autolink", c.info = "auto";
    }
    return e.pos += i.length + 2, !0;
  }
  if (y7.test(i)) {
    const a = e.md.normalizeLink("mailto:" + i);
    if (!e.md.validateLink(a))
      return !1;
    if (!t) {
      const o = e.push("link_open", "a", 1);
      o.attrs = [["href", a]], o.markup = "autolink", o.info = "auto";
      const s = e.push("text", "", 0);
      s.content = e.md.normalizeLinkText(i);
      const c = e.push("link_close", "a", -1);
      c.markup = "autolink", c.info = "auto";
    }
    return e.pos += i.length + 2, !0;
  }
  return !1;
}
function S7(e) {
  return /^<a[>\s]/i.test(e);
}
function C7(e) {
  return /^<\/a\s*>/i.test(e);
}
function E7(e) {
  const t = e | 32;
  return t >= 97 && t <= 122;
}
function w7(e, t) {
  if (!e.md.options.html)
    return !1;
  const n = e.posMax, r = e.pos;
  if (e.src.charCodeAt(r) !== 60 || r + 2 >= n)
    return !1;
  const u = e.src.charCodeAt(r + 1);
  if (u !== 33 && u !== 63 && u !== 47 && !E7(u))
    return !1;
  const i = e.src.slice(r).match(e7);
  if (!i)
    return !1;
  if (!t) {
    const a = e.push("html_inline", "", 0);
    a.content = i[0], S7(a.content) && e.linkLevel++, C7(a.content) && e.linkLevel--;
  }
  return e.pos += i[0].length, !0;
}
const T7 = /^&#((?:x[a-f0-9]{1,6}|[0-9]{1,7}));/i, A7 = /^&([a-z][a-z0-9]{1,31});/i;
function k7(e, t) {
  const n = e.pos, r = e.posMax;
  if (e.src.charCodeAt(n) !== 38 || n + 1 >= r)
    return !1;
  if (e.src.charCodeAt(n + 1) === 35) {
    const i = e.src.slice(n).match(T7);
    if (i) {
      if (!t) {
        const a = i[1][0].toLowerCase() === "x" ? parseInt(i[1].slice(1), 16) : parseInt(i[1], 10), o = e.push("text_special", "", 0);
        o.content = r0(a) ? Wa(a) : Wa(65533), o.markup = i[0], o.info = "entity";
      }
      return e.pos += i[0].length, !0;
    }
  } else {
    const i = e.src.slice(n).match(A7);
    if (i) {
      const a = gu(i[0]);
      if (a !== i[0]) {
        if (!t) {
          const o = e.push("text_special", "", 0);
          o.content = a, o.markup = i[0], o.info = "entity";
        }
        return e.pos += i[0].length, !0;
      }
    }
  }
  return !1;
}
function ap(e) {
  const t = {}, n = e.length;
  if (!n)
    return;
  let r = 0, u = -2;
  const i = [];
  for (let a = 0; a < n; a++) {
    const o = e[a];
    if (i.push(0), (e[r].marker !== o.marker || u !== o.token - 1) && (r = a), u = o.token, o.length = o.length || 0, !o.close)
      continue;
    t.hasOwnProperty(o.marker) || (t[o.marker] = [-1, -1, -1, -1, -1, -1]);
    const s = t[o.marker][(o.open ? 3 : 0) + o.length % 3];
    let c = r - i[r] - 1, l = c;
    for (; c > s; c -= i[c] + 1) {
      const d = e[c];
      if (d.marker === o.marker && d.open && d.end < 0) {
        let f = !1;
        if ((d.close || o.open) && (d.length + o.length) % 3 === 0 && (d.length % 3 !== 0 || o.length % 3 !== 0) && (f = !0), !f) {
          const p = c > 0 && !e[c - 1].open ? i[c - 1] + 1 : 0;
          i[a] = a - c + p, i[c] = p, o.open = !1, d.end = a, d.close = !1, l = -1, u = -2;
          break;
        }
      }
    }
    l !== -1 && (t[o.marker][(o.open ? 3 : 0) + (o.length || 0) % 3] = l);
  }
}
function L7(e) {
  const t = e.tokens_meta, n = e.tokens_meta.length;
  ap(e.delimiters);
  for (let r = 0; r < n; r++)
    t[r] && t[r].delimiters && ap(t[r].delimiters);
}
function D7(e) {
  let t, n, r = 0;
  const u = e.tokens, i = e.tokens.length;
  for (t = n = 0; t < i; t++)
    u[t].nesting < 0 && r--, u[t].level = r, u[t].nesting > 0 && r++, u[t].type === "text" && t + 1 < i && u[t + 1].type === "text" ? u[t + 1].content = u[t].content + u[t + 1].content : (t !== n && (u[n] = u[t]), n++);
  t !== n && (u.length = n);
}
const Bs = [
  ["text", o7],
  ["linkify", c7],
  ["newline", l7],
  ["escape", d7],
  ["backticks", f7],
  ["strikethrough", Hv.tokenize],
  ["emphasis", $v.tokenize],
  ["link", b7],
  ["image", v7],
  ["autolink", _7],
  ["html_inline", w7],
  ["entity", k7]
], Fs = [
  ["balance_pairs", L7],
  ["strikethrough", Hv.postProcess],
  ["emphasis", $v.postProcess],
  // rules for pairs separate '**' into its own text tokens, which may be left unused,
  // rule below merges unused segments back with the rest of the text
  ["fragments_join", D7]
];
function Gi() {
  this.ruler = new tn();
  for (let e = 0; e < Bs.length; e++)
    this.ruler.push(Bs[e][0], Bs[e][1]);
  this.ruler2 = new tn();
  for (let e = 0; e < Fs.length; e++)
    this.ruler2.push(Fs[e][0], Fs[e][1]);
}
Gi.prototype.skipToken = function(e) {
  const t = e.pos, n = this.ruler.getRules(""), r = n.length, u = e.md.options.maxNesting, i = e.cache;
  if (typeof i[t] < "u") {
    e.pos = i[t];
    return;
  }
  let a = !1;
  if (e.level < u) {
    for (let o = 0; o < r; o++)
      if (e.level++, a = n[o](e, !0), e.level--, a) {
        if (t >= e.pos)
          throw new Error("inline rule didn't increment state.pos");
        break;
      }
  } else
    e.pos = e.posMax;
  a || e.pos++, i[t] = e.pos;
};
Gi.prototype.tokenize = function(e) {
  const t = this.ruler.getRules(""), n = t.length, r = e.posMax, u = e.md.options.maxNesting;
  for (; e.pos < r; ) {
    const i = e.pos;
    let a = !1;
    if (e.level < u) {
      for (let o = 0; o < n; o++)
        if (a = t[o](e, !1), a) {
          if (i >= e.pos)
            throw new Error("inline rule didn't increment state.pos");
          break;
        }
    }
    if (a) {
      if (e.pos >= r)
        break;
      continue;
    }
    e.pending += e.src[e.pos++];
  }
  e.pending && e.pushPending();
};
Gi.prototype.parse = function(e, t, n, r) {
  const u = new this.State(e, t, n, r);
  this.tokenize(u);
  const i = this.ruler2.getRules(""), a = i.length;
  for (let o = 0; o < a; o++)
    i[o](u);
};
Gi.prototype.State = qi;
function N7(e) {
  const t = {};
  e = e || {}, t.src_Any = yv.source, t.src_Cc = xv.source, t.src_Z = Sv.source, t.src_P = Ql.source, t.src_ZPCc = [t.src_Z, t.src_P, t.src_Cc].join("|"), t.src_ZCc = [t.src_Z, t.src_Cc].join("|");
  const n = "[><｜]";
  return t.src_pseudo_letter = "(?:(?!" + n + "|" + t.src_ZPCc + ")" + t.src_Any + ")", t.src_ip4 = "(?:(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\\.){3}(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)", t.src_auth = "(?:(?:(?!" + t.src_ZCc + "|[@/\\[\\]()]).)+@)?", t.src_port = "(?::(?:6(?:[0-4]\\d{3}|5(?:[0-4]\\d{2}|5(?:[0-2]\\d|3[0-5])))|[1-5]?\\d{1,4}))?", t.src_host_terminator = "(?=$|" + n + "|" + t.src_ZPCc + ")(?!" + (e["---"] ? "-(?!--)|" : "-|") + "_|:\\d|\\.-|\\.(?!$|" + t.src_ZPCc + "))", t.src_path = "(?:[/?#](?:(?!" + t.src_ZCc + "|" + n + `|[()[\\]{}.,"'?!\\-;]).|\\[(?:(?!` + t.src_ZCc + "|\\]).)*\\]|\\((?:(?!" + t.src_ZCc + "|[)]).)*\\)|\\{(?:(?!" + t.src_ZCc + '|[}]).)*\\}|\\"(?:(?!' + t.src_ZCc + `|["]).)+\\"|\\'(?:(?!` + t.src_ZCc + "|[']).)+\\'|\\'(?=" + t.src_pseudo_letter + "|[-])|\\.{2,}[a-zA-Z0-9%/&]|\\.(?!" + t.src_ZCc + "|[.]|$)|" + (e["---"] ? "\\-(?!--(?:[^-]|$))(?:-*)|" : "\\-+|") + // allow `,,,` in paths
  ",(?!" + t.src_ZCc + "|$)|;(?!" + t.src_ZCc + "|$)|\\!+(?!" + t.src_ZCc + "|[!]|$)|\\?(?!" + t.src_ZCc + "|[?]|$))+|\\/)?", t.src_email_name = '[\\-;:&=\\+\\$,\\.a-zA-Z0-9_][\\-;:&=\\+\\$,\\"\\.a-zA-Z0-9_]*', t.src_xn = "xn--[a-z0-9\\-]{1,59}", t.src_domain_root = // Allow letters & digits (http://test1)
  "(?:" + t.src_xn + "|" + t.src_pseudo_letter + "{1,63})", t.src_domain = "(?:" + t.src_xn + "|(?:" + t.src_pseudo_letter + ")|(?:" + t.src_pseudo_letter + "(?:-|" + t.src_pseudo_letter + "){0,61}" + t.src_pseudo_letter + "))", t.src_host = "(?:(?:(?:(?:" + t.src_domain + ")\\.)*" + t.src_domain + "))", t.tpl_host_fuzzy = "(?:" + t.src_ip4 + "|(?:(?:(?:" + t.src_domain + ")\\.)+(?:%TLDS%)))", t.tpl_host_no_ip_fuzzy = "(?:(?:(?:" + t.src_domain + ")\\.)+(?:%TLDS%))", t.src_host_strict = t.src_host + t.src_host_terminator, t.tpl_host_fuzzy_strict = t.tpl_host_fuzzy + t.src_host_terminator, t.src_host_port_strict = t.src_host + t.src_port + t.src_host_terminator, t.tpl_host_port_fuzzy_strict = t.tpl_host_fuzzy + t.src_port + t.src_host_terminator, t.tpl_host_port_no_ip_fuzzy_strict = t.tpl_host_no_ip_fuzzy + t.src_port + t.src_host_terminator, t.tpl_host_fuzzy_test = "localhost|www\\.|\\.\\d{1,3}\\.|(?:\\.(?:%TLDS%)(?:" + t.src_ZPCc + "|>|$))", t.tpl_email_fuzzy = "(^|" + n + '|"|\\(|' + t.src_ZCc + ")(" + t.src_email_name + "@" + t.tpl_host_fuzzy_strict + ")", t.tpl_link_fuzzy = // Fuzzy link can't be prepended with .:/\- and non punctuation.
  // but can start with > (markdown blockquote)
  "(^|(?![.:/\\-_@])(?:[$+<=>^`|｜]|" + t.src_ZPCc + "))((?![$+<=>^`|｜])" + t.tpl_host_port_fuzzy_strict + t.src_path + ")", t.tpl_link_no_ip_fuzzy = // Fuzzy link can't be prepended with .:/\- and non punctuation.
  // but can start with > (markdown blockquote)
  "(^|(?![.:/\\-_@])(?:[$+<=>^`|｜]|" + t.src_ZPCc + "))((?![$+<=>^`|｜])" + t.tpl_host_port_no_ip_fuzzy_strict + t.src_path + ")", t;
}
function jc(e) {
  return Array.prototype.slice.call(arguments, 1).forEach(function(n) {
    n && Object.keys(n).forEach(function(r) {
      e[r] = n[r];
    });
  }), e;
}
function Oo(e) {
  return Object.prototype.toString.call(e);
}
function O7(e) {
  return Oo(e) === "[object String]";
}
function I7(e) {
  return Oo(e) === "[object Object]";
}
function M7(e) {
  return Oo(e) === "[object RegExp]";
}
function op(e) {
  return Oo(e) === "[object Function]";
}
function P7(e) {
  return e.replace(/[.?*+^$[\]\\(){}|-]/g, "\\$&");
}
const Vv = {
  fuzzyLink: !0,
  fuzzyEmail: !0,
  fuzzyIP: !1
};
function R7(e) {
  return Object.keys(e || {}).reduce(function(t, n) {
    return t || Vv.hasOwnProperty(n);
  }, !1);
}
const B7 = {
  "http:": {
    validate: function(e, t, n) {
      const r = e.slice(t);
      return n.re.http || (n.re.http = new RegExp(
        "^\\/\\/" + n.re.src_auth + n.re.src_host_port_strict + n.re.src_path,
        "i"
      )), n.re.http.test(r) ? r.match(n.re.http)[0].length : 0;
    }
  },
  "https:": "http:",
  "ftp:": "http:",
  "//": {
    validate: function(e, t, n) {
      const r = e.slice(t);
      return n.re.no_http || (n.re.no_http = new RegExp(
        "^" + n.re.src_auth + // Don't allow single-level domains, because of false positives like '//test'
        // with code comments
        "(?:localhost|(?:(?:" + n.re.src_domain + ")\\.)+" + n.re.src_domain_root + ")" + n.re.src_port + n.re.src_host_terminator + n.re.src_path,
        "i"
      )), n.re.no_http.test(r) ? t >= 3 && e[t - 3] === ":" || t >= 3 && e[t - 3] === "/" ? 0 : r.match(n.re.no_http)[0].length : 0;
    }
  },
  "mailto:": {
    validate: function(e, t, n) {
      const r = e.slice(t);
      return n.re.mailto || (n.re.mailto = new RegExp(
        "^" + n.re.src_email_name + "@" + n.re.src_host_strict,
        "i"
      )), n.re.mailto.test(r) ? r.match(n.re.mailto)[0].length : 0;
    }
  }
}, F7 = "a[cdefgilmnoqrstuwxz]|b[abdefghijmnorstvwyz]|c[acdfghiklmnoruvwxyz]|d[ejkmoz]|e[cegrstu]|f[ijkmor]|g[abdefghilmnpqrstuwy]|h[kmnrtu]|i[delmnoqrst]|j[emop]|k[eghimnprwyz]|l[abcikrstuvy]|m[acdeghklmnopqrstuvwxyz]|n[acefgilopruz]|om|p[aefghklmnrstwy]|qa|r[eosuw]|s[abcdeghijklmnortuvxyz]|t[cdfghjklmnortvwz]|u[agksyz]|v[aceginu]|w[fs]|y[et]|z[amw]", H7 = "biz|com|edu|gov|net|org|pro|web|xxx|aero|asia|coop|info|museum|name|shop|рф".split("|");
function $7(e) {
  e.__index__ = -1, e.__text_cache__ = "";
}
function V7(e) {
  return function(t, n) {
    const r = t.slice(n);
    return e.test(r) ? r.match(e)[0].length : 0;
  };
}
function sp() {
  return function(e, t) {
    t.normalize(e);
  };
}
function Ka(e) {
  const t = e.re = N7(e.__opts__), n = e.__tlds__.slice();
  e.onCompile(), e.__tlds_replaced__ || n.push(F7), n.push(t.src_xn), t.src_tlds = n.join("|");
  function r(o) {
    return o.replace("%TLDS%", t.src_tlds);
  }
  t.email_fuzzy = RegExp(r(t.tpl_email_fuzzy), "i"), t.link_fuzzy = RegExp(r(t.tpl_link_fuzzy), "i"), t.link_no_ip_fuzzy = RegExp(r(t.tpl_link_no_ip_fuzzy), "i"), t.host_fuzzy_test = RegExp(r(t.tpl_host_fuzzy_test), "i");
  const u = [];
  e.__compiled__ = {};
  function i(o, s) {
    throw new Error('(LinkifyIt) Invalid schema "' + o + '": ' + s);
  }
  Object.keys(e.__schemas__).forEach(function(o) {
    const s = e.__schemas__[o];
    if (s === null)
      return;
    const c = { validate: null, link: null };
    if (e.__compiled__[o] = c, I7(s)) {
      M7(s.validate) ? c.validate = V7(s.validate) : op(s.validate) ? c.validate = s.validate : i(o, s), op(s.normalize) ? c.normalize = s.normalize : s.normalize ? i(o, s) : c.normalize = sp();
      return;
    }
    if (O7(s)) {
      u.push(o);
      return;
    }
    i(o, s);
  }), u.forEach(function(o) {
    e.__compiled__[e.__schemas__[o]] && (e.__compiled__[o].validate = e.__compiled__[e.__schemas__[o]].validate, e.__compiled__[o].normalize = e.__compiled__[e.__schemas__[o]].normalize);
  }), e.__compiled__[""] = { validate: null, normalize: sp() };
  const a = Object.keys(e.__compiled__).filter(function(o) {
    return o.length > 0 && e.__compiled__[o];
  }).map(P7).join("|");
  e.re.schema_test = RegExp("(^|(?!_)(?:[><｜]|" + t.src_ZPCc + "))(" + a + ")", "i"), e.re.schema_search = RegExp("(^|(?!_)(?:[><｜]|" + t.src_ZPCc + "))(" + a + ")", "ig"), e.re.schema_at_start = RegExp("^" + e.re.schema_search.source, "i"), e.re.pretest = RegExp(
    "(" + e.re.schema_test.source + ")|(" + e.re.host_fuzzy_test.source + ")|@",
    "i"
  ), $7(e);
}
function j7(e, t) {
  const n = e.__index__, r = e.__last_index__, u = e.__text_cache__.slice(n, r);
  this.schema = e.__schema__.toLowerCase(), this.index = n + t, this.lastIndex = r + t, this.raw = u, this.text = u, this.url = u;
}
function zc(e, t) {
  const n = new j7(e, t);
  return e.__compiled__[n.schema].normalize(n, e), n;
}
function cn(e, t) {
  if (!(this instanceof cn))
    return new cn(e, t);
  t || R7(e) && (t = e, e = {}), this.__opts__ = jc({}, Vv, t), this.__index__ = -1, this.__last_index__ = -1, this.__schema__ = "", this.__text_cache__ = "", this.__schemas__ = jc({}, B7, e), this.__compiled__ = {}, this.__tlds__ = H7, this.__tlds_replaced__ = !1, this.re = {}, Ka(this);
}
cn.prototype.add = function(t, n) {
  return this.__schemas__[t] = n, Ka(this), this;
};
cn.prototype.set = function(t) {
  return this.__opts__ = jc(this.__opts__, t), this;
};
cn.prototype.test = function(t) {
  if (this.__text_cache__ = t, this.__index__ = -1, !t.length)
    return !1;
  let n, r, u, i, a, o, s, c, l;
  if (this.re.schema_test.test(t)) {
    for (s = this.re.schema_search, s.lastIndex = 0; (n = s.exec(t)) !== null; )
      if (i = this.testSchemaAt(t, n[2], s.lastIndex), i) {
        this.__schema__ = n[2], this.__index__ = n.index + n[1].length, this.__last_index__ = n.index + n[0].length + i;
        break;
      }
  }
  return this.__opts__.fuzzyLink && this.__compiled__["http:"] && (c = t.search(this.re.host_fuzzy_test), c >= 0 && (this.__index__ < 0 || c < this.__index__) && (r = t.match(this.__opts__.fuzzyIP ? this.re.link_fuzzy : this.re.link_no_ip_fuzzy)) !== null && (a = r.index + r[1].length, (this.__index__ < 0 || a < this.__index__) && (this.__schema__ = "", this.__index__ = a, this.__last_index__ = r.index + r[0].length))), this.__opts__.fuzzyEmail && this.__compiled__["mailto:"] && (l = t.indexOf("@"), l >= 0 && (u = t.match(this.re.email_fuzzy)) !== null && (a = u.index + u[1].length, o = u.index + u[0].length, (this.__index__ < 0 || a < this.__index__ || a === this.__index__ && o > this.__last_index__) && (this.__schema__ = "mailto:", this.__index__ = a, this.__last_index__ = o))), this.__index__ >= 0;
};
cn.prototype.pretest = function(t) {
  return this.re.pretest.test(t);
};
cn.prototype.testSchemaAt = function(t, n, r) {
  return this.__compiled__[n.toLowerCase()] ? this.__compiled__[n.toLowerCase()].validate(t, r, this) : 0;
};
cn.prototype.match = function(t) {
  const n = [];
  let r = 0;
  this.__index__ >= 0 && this.__text_cache__ === t && (n.push(zc(this, r)), r = this.__last_index__);
  let u = r ? t.slice(r) : t;
  for (; this.test(u); )
    n.push(zc(this, r)), u = u.slice(this.__last_index__), r += this.__last_index__;
  return n.length ? n : null;
};
cn.prototype.matchAtStart = function(t) {
  if (this.__text_cache__ = t, this.__index__ = -1, !t.length)
    return null;
  const n = this.re.schema_at_start.exec(t);
  if (!n)
    return null;
  const r = this.testSchemaAt(t, n[2], n[0].length);
  return r ? (this.__schema__ = n[2], this.__index__ = n.index + n[1].length, this.__last_index__ = n.index + n[0].length + r, zc(this, 0)) : null;
};
cn.prototype.tlds = function(t, n) {
  return t = Array.isArray(t) ? t : [t], n ? (this.__tlds__ = this.__tlds__.concat(t).sort().filter(function(r, u, i) {
    return r !== i[u - 1];
  }).reverse(), Ka(this), this) : (this.__tlds__ = t.slice(), this.__tlds_replaced__ = !0, Ka(this), this);
};
cn.prototype.normalize = function(t) {
  t.schema || (t.url = "http://" + t.url), t.schema === "mailto:" && !/^mailto:/i.test(t.url) && (t.url = "mailto:" + t.url);
};
cn.prototype.onCompile = function() {
};
const bu = 2147483647, kn = 36, a0 = 1, ki = 26, z7 = 38, U7 = 700, jv = 72, zv = 128, Uv = "-", q7 = /^xn--/, G7 = /[^\0-\x7F]/, W7 = /[\x2E\u3002\uFF0E\uFF61]/g, K7 = {
  overflow: "Overflow: input needs wider integers to process",
  "not-basic": "Illegal input >= 0x80 (not a basic code point)",
  "invalid-input": "Invalid input"
}, Hs = kn - a0, Ln = Math.floor, $s = String.fromCharCode;
function tr(e) {
  throw new RangeError(K7[e]);
}
function Y7(e, t) {
  const n = [];
  let r = e.length;
  for (; r--; )
    n[r] = t(e[r]);
  return n;
}
function qv(e, t) {
  const n = e.split("@");
  let r = "";
  n.length > 1 && (r = n[0] + "@", e = n[1]), e = e.replace(W7, ".");
  const u = e.split("."), i = Y7(u, t).join(".");
  return r + i;
}
function Gv(e) {
  const t = [];
  let n = 0;
  const r = e.length;
  for (; n < r; ) {
    const u = e.charCodeAt(n++);
    if (u >= 55296 && u <= 56319 && n < r) {
      const i = e.charCodeAt(n++);
      (i & 64512) == 56320 ? t.push(((u & 1023) << 10) + (i & 1023) + 65536) : (t.push(u), n--);
    } else
      t.push(u);
  }
  return t;
}
const Z7 = (e) => String.fromCodePoint(...e), X7 = function(e) {
  return e >= 48 && e < 58 ? 26 + (e - 48) : e >= 65 && e < 91 ? e - 65 : e >= 97 && e < 123 ? e - 97 : kn;
}, cp = function(e, t) {
  return e + 22 + 75 * (e < 26) - ((t != 0) << 5);
}, Wv = function(e, t, n) {
  let r = 0;
  for (e = n ? Ln(e / U7) : e >> 1, e += Ln(e / t); e > Hs * ki >> 1; r += kn)
    e = Ln(e / Hs);
  return Ln(r + (Hs + 1) * e / (e + z7));
}, Kv = function(e) {
  const t = [], n = e.length;
  let r = 0, u = zv, i = jv, a = e.lastIndexOf(Uv);
  a < 0 && (a = 0);
  for (let o = 0; o < a; ++o)
    e.charCodeAt(o) >= 128 && tr("not-basic"), t.push(e.charCodeAt(o));
  for (let o = a > 0 ? a + 1 : 0; o < n; ) {
    const s = r;
    for (let l = 1, d = kn; ; d += kn) {
      o >= n && tr("invalid-input");
      const f = X7(e.charCodeAt(o++));
      f >= kn && tr("invalid-input"), f > Ln((bu - r) / l) && tr("overflow"), r += f * l;
      const p = d <= i ? a0 : d >= i + ki ? ki : d - i;
      if (f < p)
        break;
      const h = kn - p;
      l > Ln(bu / h) && tr("overflow"), l *= h;
    }
    const c = t.length + 1;
    i = Wv(r - s, c, s == 0), Ln(r / c) > bu - u && tr("overflow"), u += Ln(r / c), r %= c, t.splice(r++, 0, u);
  }
  return String.fromCodePoint(...t);
}, Yv = function(e) {
  const t = [];
  e = Gv(e);
  const n = e.length;
  let r = zv, u = 0, i = jv;
  for (const s of e)
    s < 128 && t.push($s(s));
  const a = t.length;
  let o = a;
  for (a && t.push(Uv); o < n; ) {
    let s = bu;
    for (const l of e)
      l >= r && l < s && (s = l);
    const c = o + 1;
    s - r > Ln((bu - u) / c) && tr("overflow"), u += (s - r) * c, r = s;
    for (const l of e)
      if (l < r && ++u > bu && tr("overflow"), l === r) {
        let d = u;
        for (let f = kn; ; f += kn) {
          const p = f <= i ? a0 : f >= i + ki ? ki : f - i;
          if (d < p)
            break;
          const h = d - p, m = kn - p;
          t.push(
            $s(cp(p + h % m, 0))
          ), d = Ln(h / m);
        }
        t.push($s(cp(d, 0))), i = Wv(u, c, o === a), u = 0, ++o;
      }
    ++u, ++r;
  }
  return t.join("");
}, Q7 = function(e) {
  return qv(e, function(t) {
    return q7.test(t) ? Kv(t.slice(4).toLowerCase()) : t;
  });
}, J7 = function(e) {
  return qv(e, function(t) {
    return G7.test(t) ? "xn--" + Yv(t) : t;
  });
}, Zv = {
  /**
   * A string representing the current Punycode.js version number.
   * @memberOf punycode
   * @type String
   */
  version: "2.3.1",
  /**
   * An object of methods to convert from JavaScript's internal character
   * representation (UCS-2) to Unicode code points, and back.
   * @see <https://mathiasbynens.be/notes/javascript-encoding>
   * @memberOf punycode
   * @type Object
   */
  ucs2: {
    decode: Gv,
    encode: Z7
  },
  decode: Kv,
  encode: Yv,
  toASCII: J7,
  toUnicode: Q7
}, ek = {
  options: {
    // Enable HTML tags in source
    html: !1,
    // Use '/' to close single tags (<br />)
    xhtmlOut: !1,
    // Convert '\n' in paragraphs into <br>
    breaks: !1,
    // CSS language prefix for fenced blocks
    langPrefix: "language-",
    // autoconvert URL-like texts to links
    linkify: !1,
    // Enable some language-neutral replacements + quotes beautification
    typographer: !1,
    // Double + single quotes replacement pairs, when typographer enabled,
    // and smartquotes on. Could be either a String or an Array.
    //
    // For example, you can use '«»„“' for Russian, '„“‚‘' for German,
    // and ['«\xA0', '\xA0»', '‹\xA0', '\xA0›'] for French (including nbsp).
    quotes: "“”‘’",
    /* “”‘’ */
    // Highlighter function. Should return escaped HTML,
    // or '' if the source string is not changed and should be escaped externaly.
    // If result starts with <pre... internal wrapper is skipped.
    //
    // function (/*str, lang*/) { return ''; }
    //
    highlight: null,
    // Internal protection, recursion limit
    maxNesting: 100
  },
  components: {
    core: {},
    block: {},
    inline: {}
  }
}, tk = {
  options: {
    // Enable HTML tags in source
    html: !1,
    // Use '/' to close single tags (<br />)
    xhtmlOut: !1,
    // Convert '\n' in paragraphs into <br>
    breaks: !1,
    // CSS language prefix for fenced blocks
    langPrefix: "language-",
    // autoconvert URL-like texts to links
    linkify: !1,
    // Enable some language-neutral replacements + quotes beautification
    typographer: !1,
    // Double + single quotes replacement pairs, when typographer enabled,
    // and smartquotes on. Could be either a String or an Array.
    //
    // For example, you can use '«»„“' for Russian, '„“‚‘' for German,
    // and ['«\xA0', '\xA0»', '‹\xA0', '\xA0›'] for French (including nbsp).
    quotes: "“”‘’",
    /* “”‘’ */
    // Highlighter function. Should return escaped HTML,
    // or '' if the source string is not changed and should be escaped externaly.
    // If result starts with <pre... internal wrapper is skipped.
    //
    // function (/*str, lang*/) { return ''; }
    //
    highlight: null,
    // Internal protection, recursion limit
    maxNesting: 20
  },
  components: {
    core: {
      rules: [
        "normalize",
        "block",
        "inline",
        "text_join"
      ]
    },
    block: {
      rules: [
        "paragraph"
      ]
    },
    inline: {
      rules: [
        "text"
      ],
      rules2: [
        "balance_pairs",
        "fragments_join"
      ]
    }
  }
}, nk = {
  options: {
    // Enable HTML tags in source
    html: !0,
    // Use '/' to close single tags (<br />)
    xhtmlOut: !0,
    // Convert '\n' in paragraphs into <br>
    breaks: !1,
    // CSS language prefix for fenced blocks
    langPrefix: "language-",
    // autoconvert URL-like texts to links
    linkify: !1,
    // Enable some language-neutral replacements + quotes beautification
    typographer: !1,
    // Double + single quotes replacement pairs, when typographer enabled,
    // and smartquotes on. Could be either a String or an Array.
    //
    // For example, you can use '«»„“' for Russian, '„“‚‘' for German,
    // and ['«\xA0', '\xA0»', '‹\xA0', '\xA0›'] for French (including nbsp).
    quotes: "“”‘’",
    /* “”‘’ */
    // Highlighter function. Should return escaped HTML,
    // or '' if the source string is not changed and should be escaped externaly.
    // If result starts with <pre... internal wrapper is skipped.
    //
    // function (/*str, lang*/) { return ''; }
    //
    highlight: null,
    // Internal protection, recursion limit
    maxNesting: 20
  },
  components: {
    core: {
      rules: [
        "normalize",
        "block",
        "inline",
        "text_join"
      ]
    },
    block: {
      rules: [
        "blockquote",
        "code",
        "fence",
        "heading",
        "hr",
        "html_block",
        "lheading",
        "list",
        "reference",
        "paragraph"
      ]
    },
    inline: {
      rules: [
        "autolink",
        "backticks",
        "emphasis",
        "entity",
        "escape",
        "html_inline",
        "image",
        "link",
        "newline",
        "text"
      ],
      rules2: [
        "balance_pairs",
        "emphasis",
        "fragments_join"
      ]
    }
  }
}, rk = {
  default: ek,
  zero: tk,
  commonmark: nk
}, uk = /^(vbscript|javascript|file|data):/, ik = /^data:image\/(gif|png|jpeg|webp);/;
function ak(e) {
  const t = e.trim().toLowerCase();
  return uk.test(t) ? ik.test(t) : !0;
}
const Xv = ["http:", "https:", "mailto:"];
function ok(e) {
  const t = Xl(e, !0);
  if (t.hostname && (!t.protocol || Xv.indexOf(t.protocol) >= 0))
    try {
      t.hostname = Zv.toASCII(t.hostname);
    } catch {
    }
  return Ui(Zl(t));
}
function sk(e) {
  const t = Xl(e, !0);
  if (t.hostname && (!t.protocol || Xv.indexOf(t.protocol) >= 0))
    try {
      t.hostname = Zv.toUnicode(t.hostname);
    } catch {
    }
  return ku(Zl(t), ku.defaultChars + "%");
}
function vn(e, t) {
  if (!(this instanceof vn))
    return new vn(e, t);
  t || n0(e) || (t = e || {}, e = "default"), this.inline = new Gi(), this.block = new No(), this.core = new u0(), this.renderer = new Ru(), this.linkify = new cn(), this.validateLink = ak, this.normalizeLink = ok, this.normalizeLinkText = sk, this.utils = lA, this.helpers = Lo({}, hA), this.options = {}, this.configure(e), t && this.set(t);
}
vn.prototype.set = function(e) {
  return Lo(this.options, e), this;
};
vn.prototype.configure = function(e) {
  const t = this;
  if (n0(e)) {
    const n = e;
    if (e = rk[n], !e)
      throw new Error('Wrong `markdown-it` preset "' + n + '", check name');
  }
  if (!e)
    throw new Error("Wrong `markdown-it` preset, can't be empty");
  return e.options && t.set(e.options), e.components && Object.keys(e.components).forEach(function(n) {
    e.components[n].rules && t[n].ruler.enableOnly(e.components[n].rules), e.components[n].rules2 && t[n].ruler2.enableOnly(e.components[n].rules2);
  }), this;
};
vn.prototype.enable = function(e, t) {
  let n = [];
  Array.isArray(e) || (e = [e]), ["core", "block", "inline"].forEach(function(u) {
    n = n.concat(this[u].ruler.enable(e, !0));
  }, this), n = n.concat(this.inline.ruler2.enable(e, !0));
  const r = e.filter(function(u) {
    return n.indexOf(u) < 0;
  });
  if (r.length && !t)
    throw new Error("MarkdownIt. Failed to enable unknown rule(s): " + r);
  return this;
};
vn.prototype.disable = function(e, t) {
  let n = [];
  Array.isArray(e) || (e = [e]), ["core", "block", "inline"].forEach(function(u) {
    n = n.concat(this[u].ruler.disable(e, !0));
  }, this), n = n.concat(this.inline.ruler2.disable(e, !0));
  const r = e.filter(function(u) {
    return n.indexOf(u) < 0;
  });
  if (r.length && !t)
    throw new Error("MarkdownIt. Failed to disable unknown rule(s): " + r);
  return this;
};
vn.prototype.use = function(e) {
  const t = [this].concat(Array.prototype.slice.call(arguments, 1));
  return e.apply(e, t), this;
};
vn.prototype.parse = function(e, t) {
  if (typeof e != "string")
    throw new Error("Input data should be a String");
  const n = new this.core.State(e, this, t);
  return this.core.process(n), n.tokens;
};
vn.prototype.render = function(e, t) {
  return t = t || {}, this.renderer.render(this.parse(e, t), this.options, t);
};
vn.prototype.parseInline = function(e, t) {
  const n = new this.core.State(e, this, t);
  return n.inlineMode = !0, this.core.process(n), n.tokens;
};
vn.prototype.renderInline = function(e, t) {
  return t = t || {}, this.renderer.render(this.parseInline(e, t), this.options, t);
};
const ck = /\\([ \\!"#$%&'()*+,./:;<=>?@[\]^_`{|}~-])/g;
function lk(e, t) {
  const n = e.posMax, r = e.pos;
  if (e.src.charCodeAt(r) !== 126 || t || r + 2 >= n)
    return !1;
  e.pos = r + 1;
  let u = !1;
  for (; e.pos < n; ) {
    if (e.src.charCodeAt(e.pos) === 126) {
      u = !0;
      break;
    }
    e.md.inline.skipToken(e);
  }
  if (!u || r + 1 === e.pos)
    return e.pos = r, !1;
  const i = e.src.slice(r + 1, e.pos);
  if (i.match(/(^|[^\\])(\\\\)*\s/))
    return e.pos = r, !1;
  e.posMax = e.pos, e.pos = r + 1;
  const a = e.push("sub_open", "sub", 1);
  a.markup = "~";
  const o = e.push("text", "", 0);
  o.content = i.replace(ck, "$1");
  const s = e.push("sub_close", "sub", -1);
  return s.markup = "~", e.pos = e.posMax + 1, e.posMax = n, !0;
}
function dk(e) {
  e.inline.ruler.after("emphasis", "sub", lk);
}
const fk = /\\([ \\!"#$%&'()*+,./:;<=>?@[\]^_`{|}~-])/g;
function pk(e, t) {
  const n = e.posMax, r = e.pos;
  if (e.src.charCodeAt(r) !== 94 || t || r + 2 >= n)
    return !1;
  e.pos = r + 1;
  let u = !1;
  for (; e.pos < n; ) {
    if (e.src.charCodeAt(e.pos) === 94) {
      u = !0;
      break;
    }
    e.md.inline.skipToken(e);
  }
  if (!u || r + 1 === e.pos)
    return e.pos = r, !1;
  const i = e.src.slice(r + 1, e.pos);
  if (i.match(/(^|[^\\])(\\\\)*\s/))
    return e.pos = r, !1;
  e.posMax = e.pos, e.pos = r + 1;
  const a = e.push("sup_open", "sup", 1);
  a.markup = "^";
  const o = e.push("text", "", 0);
  o.content = i.replace(fk, "$1");
  const s = e.push("sup_close", "sup", -1);
  return s.markup = "^", e.pos = e.posMax + 1, e.posMax = n, !0;
}
function hk(e) {
  e.inline.ruler.after("emphasis", "sup", pk);
}
var yt = /* @__PURE__ */ ((e) => (e.Link = "Link", e.CTA = "CTA", e.Button = "Button", e))(yt || {}), Wi = /* @__PURE__ */ ((e) => (e.FeatureCard = "Feature_Card_CTA", e.StandardCard = "Standard_Card_CTA", e.Button = "Button_CTA", e.ContactSales = "ContactSales_CTA", e.GetTheApp = "GetTheApp_CTA", e.SignUp = "SignUp_CTA", e.StickyNavClickToCall = "Sticky_Nav_ClickToCall_CTA", e.StickyNavContactSales = "Sticky_Nav_ContactSales_Clicked", e.StickyNavSignUp = "Sticky_Nav_SignUp_Clicked", e.Card = "Card_CTA", e))(Wi || {}), Qv = /* @__PURE__ */ ((e) => (e.Button = "Button", e.ScrollTopButton = "Scroll_Top_Button", e))(Qv || {}), Ki = /* @__PURE__ */ ((e) => (e.CarouselNextButton = "Carousel_Next_Button", e.CarouselPreviousButton = "Carousel_Previous_Button", e.CarouselIndicatorButton = "Carousel_Indicator_Button", e.CarouselSlideButton = "Carousel_Slide_Button", e))(Ki || {}), Io = /* @__PURE__ */ ((e) => (e.BRC = "BRC_Link", e.ClickToCall = "ClickToCall_CTA", e.ContactSales = "ContactSales_CTA", e.Text = "Text_Link", e.TextCta = "Text_Link_CTA", e.SegmentControlTab = "Segment_Control_Tab", e))(Io || {}), mk = /* @__PURE__ */ ((e) => (e.DEVELOPMENT = "development", e.STAGING = "staging", e.PRODUCTION = "production", e.SANDBOX = "sandbox", e))(mk || {}), gk = /* @__PURE__ */ ((e) => (e.NONE = "NONE", e.GENERAL = "GENERAL", e.CONSUMER = "CONSUMER", e.BUSINESS = "BUSINESS", e))(gk || {}), di = /* @__PURE__ */ ((e) => (e.cvDataPoint = "cvDataPoint", e.cvPricingToken = "cvPricingToken", e.cvAmplitudeLink = "cvAmplitudeLink", e))(di || {}), Cr = /* @__PURE__ */ ((e) => (e.datapoint = "datapoint", e.feeDatakey = "feeDataKey", e.text = "text", e.url = "url", e.clickEventName = "clickEventName", e.target = "target", e))(Cr || {}), Uc = /* @__PURE__ */ ((e) => (e.mobile = "mobile", e.portable = "portable", e.dedicated = "dedicated", e))(Uc || {}), jr = /* @__PURE__ */ ((e) => (e.Primary = "Primary", e.Secondary = "Secondary", e.Tertiary = "Tertiary", e.Branded = "Branded", e.AppDownload = "AppDownload", e))(jr || {}), o0 = /* @__PURE__ */ ((e) => (e.campaign = "campaign", e.consumer = "consumer", e.enterprise = "enterprise", e.ppcom = "ppcom", e.smb = "smb", e.brc = "brc", e.moneyhub = "moneyhub", e.general = "general", e.fastlane = "fastlane", e))(o0 || {});
const bk = ({
  text: e,
  url: t,
  clickEventName: n,
  target: r
}) => {
  const u = r ? ` target="${r}"` : "";
  return `<a href="${t}" clickeventname="${n}"${u}>${e}</a>`;
}, vk = (e, t) => {
  switch (e) {
    case di.cvAmplitudeLink:
      return bk(t);
    default:
      return "";
  }
}, Vs = {
  [di.cvDataPoint]: Cr.datapoint,
  [di.cvPricingToken]: Cr.feeDatakey,
  [di.cvAmplitudeLink]: [
    Cr.text,
    Cr.url,
    Cr.clickEventName,
    Cr.target
  ]
}, MH = "https://www.paypal.com", PH = "https://pypd.paypal-mktg.com", RH = {
  smImage: 900,
  mdImage: 1200,
  lgImage: 1500,
  xlImage: 1800,
  xl2Image: 2100
};
function Jv(e, t) {
  return t ? e.data.target.fields[t] ?? "" : "";
}
function yk(e, t) {
  const n = {};
  return t.forEach((r) => {
    const u = Jv(e, r);
    n[r] = u;
  }), n;
}
function xk(e) {
  var u, i, a, o, s;
  const t = (s = (o = (a = (i = (u = e == null ? void 0 : e.data) == null ? void 0 : u.target) == null ? void 0 : i.sys) == null ? void 0 : a.contentType) == null ? void 0 : o.sys) == null ? void 0 : s.id;
  if (!t)
    return "";
  if (Array.isArray(Vs[t])) {
    const c = Vs[t], l = yk(e, c);
    return vk(t, l);
  }
  const r = Vs[t];
  return Jv(e, r);
}
const _k = "&quot;", Sk = /\s+(?=\S*$)/g, Ck = " ", Ek = vn({ html: !0 }).use(hk).use(dk), wk = ({ wrapTokenWithSpan: e }) => (t) => {
  const n = xk(t);
  return typeof n == "string" ? e ? `<span>${n}</span>` : n : "";
}, Tk = {
  [Ze.MARKS.BOLD]: (e) => `<b>${e}</b>`,
  [Ze.MARKS.ITALIC]: (e) => `<i>${e}</i>`,
  [Ze.MARKS.UNDERLINE]: (e) => `<u>${e}</u>`
}, ey = (e, t) => vv.documentToHtmlString(e, {
  renderNode: {
    [Ze.INLINES.EMBEDDED_ENTRY]: wk({
      wrapTokenWithSpan: t
    }),
    [Ze.BLOCKS.PARAGRAPH]: (r, u) => u(r.content)
  },
  renderMark: Tk
}).replaceAll(_k, '"'), Ak = (e = "") => Ek.render(e), kk = (e) => e.trim().indexOf(" ") === -1, Lk = (e) => e[0] === " ", s0 = (e, t = !0) => (t ? e.trimEnd() : e).replace(Sk, Ck), qc = (e) => {
  if (typeof e == "string")
    return e;
  if (Pi(e)) {
    const { dangerouslySetInnerHTML: t } = e.props;
    return qc(t ? t.__html : e.props.children);
  }
  return "";
}, Ya = (e, t = !1) => {
  if (typeof e == "string")
    return s0(e, t);
  if (Pi(e)) {
    const { dangerouslySetInnerHTML: n } = e.props;
    return n ? {
      ...e,
      props: {
        ...e.props,
        dangerouslySetInnerHTML: {
          __html: Ya(
            n.__html,
            t
          )
        }
      }
    } : {
      ...e,
      props: {
        ...e.props,
        children: Ya(
          e.props.children,
          t
        )
      }
    };
  }
  return e;
}, Dk = (e) => {
  const t = e.length, n = t - 1, r = e[n], u = qc(r);
  if (kk(u) && !Lk(u) && t > 1) {
    const a = e[n - 1];
    e[n - 1] = Ya(
      a,
      !1
    );
  } else
    e[n] = Ya(r);
  return e;
}, Nk = (e) => typeof e == "string" ? s0(e) : Array.isArray(e) ? Dk(e) : e, Ok = (e) => {
  const { children: t, dangerouslySetInnerHTML: n, ...r } = e;
  return n ? {
    ...r,
    dangerouslySetInnerHTML: {
      __html: s0(
        n.__html
      )
    }
  } : t ? {
    ...r,
    children: Nk(t)
  } : e;
};
var ty = {}, Li = {}, Bu = {}, c0 = {}, l0 = {};
Object.defineProperty(l0, "__esModule", { value: !0 });
l0.default = new Uint16Array(
  // prettier-ignore
  'ᵁ<Õıʊҝջאٵ۞ޢߖࠏ੊ઑඡ๭༉༦჊ረዡᐕᒝᓃᓟᔥ\0\0\0\0\0\0ᕫᛍᦍᰒᷝ὾⁠↰⊍⏀⏻⑂⠤⤒ⴈ⹈⿎〖㊺㘹㞬㣾㨨㩱㫠㬮ࠀEMabcfglmnoprstu\\bfms¦³¹ÈÏlig耻Æ䃆P耻&䀦cute耻Á䃁reve;䄂Āiyx}rc耻Â䃂;䐐r;쀀𝔄rave耻À䃀pha;䎑acr;䄀d;橓Āgp¡on;䄄f;쀀𝔸plyFunction;恡ing耻Å䃅Ācs¾Ãr;쀀𝒜ign;扔ilde耻Ã䃃ml耻Ä䃄ЀaceforsuåûþėĜĢħĪĀcrêòkslash;或Ŷöø;櫧ed;挆y;䐑ƀcrtąċĔause;戵noullis;愬a;䎒r;쀀𝔅pf;쀀𝔹eve;䋘còēmpeq;扎܀HOacdefhilorsuōőŖƀƞƢƵƷƺǜȕɳɸɾcy;䐧PY耻©䂩ƀcpyŝŢźute;䄆Ā;iŧŨ拒talDifferentialD;慅leys;愭ȀaeioƉƎƔƘron;䄌dil耻Ç䃇rc;䄈nint;戰ot;䄊ĀdnƧƭilla;䂸terDot;䂷òſi;䎧rcleȀDMPTǇǋǑǖot;抙inus;抖lus;投imes;抗oĀcsǢǸkwiseContourIntegral;戲eCurlyĀDQȃȏoubleQuote;思uote;怙ȀlnpuȞȨɇɕonĀ;eȥȦ户;橴ƀgitȯȶȺruent;扡nt;戯ourIntegral;戮ĀfrɌɎ;愂oduct;成nterClockwiseContourIntegral;戳oss;樯cr;쀀𝒞pĀ;Cʄʅ拓ap;才րDJSZacefiosʠʬʰʴʸˋ˗ˡ˦̳ҍĀ;oŹʥtrahd;椑cy;䐂cy;䐅cy;䐏ƀgrsʿ˄ˇger;怡r;憡hv;櫤Āayː˕ron;䄎;䐔lĀ;t˝˞戇a;䎔r;쀀𝔇Āaf˫̧Ācm˰̢riticalȀADGT̖̜̀̆cute;䂴oŴ̋̍;䋙bleAcute;䋝rave;䁠ilde;䋜ond;拄ferentialD;慆Ѱ̽\0\0\0͔͂\0Ѕf;쀀𝔻ƀ;DE͈͉͍䂨ot;惜qual;扐blèCDLRUVͣͲ΂ϏϢϸontourIntegraìȹoɴ͹\0\0ͻ»͉nArrow;懓Āeo·ΤftƀARTΐΖΡrrow;懐ightArrow;懔eåˊngĀLRΫτeftĀARγιrrow;柸ightArrow;柺ightArrow;柹ightĀATϘϞrrow;懒ee;抨pɁϩ\0\0ϯrrow;懑ownArrow;懕erticalBar;戥ǹABLRTaВЪаўѿͼrrowƀ;BUНОТ憓ar;椓pArrow;懵reve;䌑eft˒к\0ц\0ѐightVector;楐eeVector;楞ectorĀ;Bљњ憽ar;楖ightǔѧ\0ѱeeVector;楟ectorĀ;BѺѻ懁ar;楗eeĀ;A҆҇护rrow;憧ĀctҒҗr;쀀𝒟rok;䄐ࠀNTacdfglmopqstuxҽӀӄӋӞӢӧӮӵԡԯԶՒ՝ՠեG;䅊H耻Ð䃐cute耻É䃉ƀaiyӒӗӜron;䄚rc耻Ê䃊;䐭ot;䄖r;쀀𝔈rave耻È䃈ement;戈ĀapӺӾcr;䄒tyɓԆ\0\0ԒmallSquare;旻erySmallSquare;斫ĀgpԦԪon;䄘f;쀀𝔼silon;䎕uĀaiԼՉlĀ;TՂՃ橵ilde;扂librium;懌Āci՗՚r;愰m;橳a;䎗ml耻Ë䃋Āipժկsts;戃onentialE;慇ʀcfiosօֈ֍ֲ׌y;䐤r;쀀𝔉lledɓ֗\0\0֣mallSquare;旼erySmallSquare;斪Ͱֺ\0ֿ\0\0ׄf;쀀𝔽All;戀riertrf;愱cò׋؀JTabcdfgorstר׬ׯ׺؀ؒؖ؛؝أ٬ٲcy;䐃耻>䀾mmaĀ;d׷׸䎓;䏜reve;䄞ƀeiy؇،ؐdil;䄢rc;䄜;䐓ot;䄠r;쀀𝔊;拙pf;쀀𝔾eater̀EFGLSTصلَٖٛ٦qualĀ;Lؾؿ扥ess;招ullEqual;执reater;檢ess;扷lantEqual;橾ilde;扳cr;쀀𝒢;扫ЀAacfiosuڅڋږڛڞڪھۊRDcy;䐪Āctڐڔek;䋇;䁞irc;䄤r;愌lbertSpace;愋ǰگ\0ڲf;愍izontalLine;攀Āctۃۅòکrok;䄦mpńېۘownHumðįqual;扏܀EJOacdfgmnostuۺ۾܃܇܎ܚܞܡܨ݄ݸދޏޕcy;䐕lig;䄲cy;䐁cute耻Í䃍Āiyܓܘrc耻Î䃎;䐘ot;䄰r;愑rave耻Ì䃌ƀ;apܠܯܿĀcgܴܷr;䄪inaryI;慈lieóϝǴ݉\0ݢĀ;eݍݎ戬Āgrݓݘral;戫section;拂isibleĀCTݬݲomma;恣imes;恢ƀgptݿރވon;䄮f;쀀𝕀a;䎙cr;愐ilde;䄨ǫޚ\0ޞcy;䐆l耻Ï䃏ʀcfosuެ޷޼߂ߐĀiyޱ޵rc;䄴;䐙r;쀀𝔍pf;쀀𝕁ǣ߇\0ߌr;쀀𝒥rcy;䐈kcy;䐄΀HJacfosߤߨ߽߬߱ࠂࠈcy;䐥cy;䐌ppa;䎚Āey߶߻dil;䄶;䐚r;쀀𝔎pf;쀀𝕂cr;쀀𝒦րJTaceflmostࠥࠩࠬࡐࡣ঳সে্਷ੇcy;䐉耻<䀼ʀcmnpr࠷࠼ࡁࡄࡍute;䄹bda;䎛g;柪lacetrf;愒r;憞ƀaeyࡗ࡜ࡡron;䄽dil;䄻;䐛Āfsࡨ॰tԀACDFRTUVarࡾࢩࢱࣦ࣠ࣼयज़ΐ४Ānrࢃ࢏gleBracket;柨rowƀ;BR࢙࢚࢞憐ar;懤ightArrow;懆eiling;挈oǵࢷ\0ࣃbleBracket;柦nǔࣈ\0࣒eeVector;楡ectorĀ;Bࣛࣜ懃ar;楙loor;挊ightĀAV࣯ࣵrrow;憔ector;楎Āerँगeƀ;AVउऊऐ抣rrow;憤ector;楚iangleƀ;BEतथऩ抲ar;槏qual;抴pƀDTVषूौownVector;楑eeVector;楠ectorĀ;Bॖॗ憿ar;楘ectorĀ;B॥०憼ar;楒ightáΜs̀EFGLSTॾঋকঝঢভqualGreater;拚ullEqual;扦reater;扶ess;檡lantEqual;橽ilde;扲r;쀀𝔏Ā;eঽা拘ftarrow;懚idot;䄿ƀnpw৔ਖਛgȀLRlr৞৷ਂਐeftĀAR০৬rrow;柵ightArrow;柷ightArrow;柶eftĀarγਊightáοightáϊf;쀀𝕃erĀLRਢਬeftArrow;憙ightArrow;憘ƀchtਾੀੂòࡌ;憰rok;䅁;扪Ѐacefiosuਗ਼੝੠੷੼અઋ઎p;椅y;䐜Ādl੥੯iumSpace;恟lintrf;愳r;쀀𝔐nusPlus;戓pf;쀀𝕄cò੶;䎜ҀJacefostuણધભીଔଙඑ඗ඞcy;䐊cute;䅃ƀaey઴હાron;䅇dil;䅅;䐝ƀgswે૰଎ativeƀMTV૓૟૨ediumSpace;怋hiĀcn૦૘ë૙eryThiî૙tedĀGL૸ଆreaterGreateòٳessLesóੈLine;䀊r;쀀𝔑ȀBnptଢନଷ଺reak;恠BreakingSpace;䂠f;愕ڀ;CDEGHLNPRSTV୕ୖ୪୼஡௫ఄ౞಄ದ೘ൡඅ櫬Āou୛୤ngruent;扢pCap;扭oubleVerticalBar;戦ƀlqxஃஊ஛ement;戉ualĀ;Tஒஓ扠ilde;쀀≂̸ists;戄reater΀;EFGLSTஶஷ஽௉௓௘௥扯qual;扱ullEqual;쀀≧̸reater;쀀≫̸ess;批lantEqual;쀀⩾̸ilde;扵umpń௲௽ownHump;쀀≎̸qual;쀀≏̸eĀfsఊధtTriangleƀ;BEచఛడ拪ar;쀀⧏̸qual;括s̀;EGLSTవశ఼ౄోౘ扮qual;扰reater;扸ess;쀀≪̸lantEqual;쀀⩽̸ilde;扴estedĀGL౨౹reaterGreater;쀀⪢̸essLess;쀀⪡̸recedesƀ;ESಒಓಛ技qual;쀀⪯̸lantEqual;拠ĀeiಫಹverseElement;戌ghtTriangleƀ;BEೋೌ೒拫ar;쀀⧐̸qual;拭ĀquೝഌuareSuĀbp೨೹setĀ;E೰ೳ쀀⊏̸qual;拢ersetĀ;Eഃആ쀀⊐̸qual;拣ƀbcpഓതൎsetĀ;Eഛഞ쀀⊂⃒qual;抈ceedsȀ;ESTലള഻െ抁qual;쀀⪰̸lantEqual;拡ilde;쀀≿̸ersetĀ;E൘൛쀀⊃⃒qual;抉ildeȀ;EFT൮൯൵ൿ扁qual;扄ullEqual;扇ilde;扉erticalBar;戤cr;쀀𝒩ilde耻Ñ䃑;䎝܀Eacdfgmoprstuvලෂ෉෕ෛ෠෧෼ขภยา฿ไlig;䅒cute耻Ó䃓Āiy෎ීrc耻Ô䃔;䐞blac;䅐r;쀀𝔒rave耻Ò䃒ƀaei෮ෲ෶cr;䅌ga;䎩cron;䎟pf;쀀𝕆enCurlyĀDQฎบoubleQuote;怜uote;怘;橔Āclวฬr;쀀𝒪ash耻Ø䃘iŬื฼de耻Õ䃕es;樷ml耻Ö䃖erĀBP๋๠Āar๐๓r;怾acĀek๚๜;揞et;掴arenthesis;揜Ҁacfhilors๿ງຊຏຒດຝະ໼rtialD;戂y;䐟r;쀀𝔓i;䎦;䎠usMinus;䂱Āipຢອncareplanåڝf;愙Ȁ;eio຺ູ໠໤檻cedesȀ;EST່້໏໚扺qual;檯lantEqual;扼ilde;找me;怳Ādp໩໮uct;戏ortionĀ;aȥ໹l;戝Āci༁༆r;쀀𝒫;䎨ȀUfos༑༖༛༟OT耻"䀢r;쀀𝔔pf;愚cr;쀀𝒬؀BEacefhiorsu༾གྷཇའཱིྦྷྪྭ႖ႩႴႾarr;椐G耻®䂮ƀcnrཎནབute;䅔g;柫rĀ;tཛྷཝ憠l;椖ƀaeyཧཬཱron;䅘dil;䅖;䐠Ā;vླྀཹ愜erseĀEUྂྙĀlq྇ྎement;戋uilibrium;懋pEquilibrium;楯r»ཹo;䎡ghtЀACDFTUVa࿁࿫࿳ဢဨၛႇϘĀnr࿆࿒gleBracket;柩rowƀ;BL࿜࿝࿡憒ar;懥eftArrow;懄eiling;按oǵ࿹\0စbleBracket;柧nǔည\0နeeVector;楝ectorĀ;Bဝသ懂ar;楕loor;挋Āerိ၃eƀ;AVဵံြ抢rrow;憦ector;楛iangleƀ;BEၐၑၕ抳ar;槐qual;抵pƀDTVၣၮၸownVector;楏eeVector;楜ectorĀ;Bႂႃ憾ar;楔ectorĀ;B႑႒懀ar;楓Āpuႛ႞f;愝ndImplies;楰ightarrow;懛ĀchႹႼr;愛;憱leDelayed;槴ڀHOacfhimoqstuფჱჷჽᄙᄞᅑᅖᅡᅧᆵᆻᆿĀCcჩხHcy;䐩y;䐨FTcy;䐬cute;䅚ʀ;aeiyᄈᄉᄎᄓᄗ檼ron;䅠dil;䅞rc;䅜;䐡r;쀀𝔖ortȀDLRUᄪᄴᄾᅉownArrow»ОeftArrow»࢚ightArrow»࿝pArrow;憑gma;䎣allCircle;战pf;쀀𝕊ɲᅭ\0\0ᅰt;戚areȀ;ISUᅻᅼᆉᆯ斡ntersection;抓uĀbpᆏᆞsetĀ;Eᆗᆘ抏qual;抑ersetĀ;Eᆨᆩ抐qual;抒nion;抔cr;쀀𝒮ar;拆ȀbcmpᇈᇛሉላĀ;sᇍᇎ拐etĀ;Eᇍᇕqual;抆ĀchᇠህeedsȀ;ESTᇭᇮᇴᇿ扻qual;檰lantEqual;扽ilde;承Tháྌ;我ƀ;esሒሓሣ拑rsetĀ;Eሜም抃qual;抇et»ሓրHRSacfhiorsሾቄ቉ቕ቞ቱቶኟዂወዑORN耻Þ䃞ADE;愢ĀHc቎ቒcy;䐋y;䐦Ābuቚቜ;䀉;䎤ƀaeyብቪቯron;䅤dil;䅢;䐢r;쀀𝔗Āeiቻ኉ǲኀ\0ኇefore;戴a;䎘Ācn኎ኘkSpace;쀀  Space;怉ldeȀ;EFTካኬኲኼ戼qual;扃ullEqual;扅ilde;扈pf;쀀𝕋ipleDot;惛Āctዖዛr;쀀𝒯rok;䅦ૡዷጎጚጦ\0ጬጱ\0\0\0\0\0ጸጽ፷ᎅ\0᏿ᐄᐊᐐĀcrዻጁute耻Ú䃚rĀ;oጇገ憟cir;楉rǣጓ\0጖y;䐎ve;䅬Āiyጞጣrc耻Û䃛;䐣blac;䅰r;쀀𝔘rave耻Ù䃙acr;䅪Ādiፁ፩erĀBPፈ፝Āarፍፐr;䁟acĀekፗፙ;揟et;掵arenthesis;揝onĀ;P፰፱拃lus;抎Āgp፻፿on;䅲f;쀀𝕌ЀADETadps᎕ᎮᎸᏄϨᏒᏗᏳrrowƀ;BDᅐᎠᎤar;椒ownArrow;懅ownArrow;憕quilibrium;楮eeĀ;AᏋᏌ报rrow;憥ownáϳerĀLRᏞᏨeftArrow;憖ightArrow;憗iĀ;lᏹᏺ䏒on;䎥ing;䅮cr;쀀𝒰ilde;䅨ml耻Ü䃜ҀDbcdefosvᐧᐬᐰᐳᐾᒅᒊᒐᒖash;披ar;櫫y;䐒ashĀ;lᐻᐼ抩;櫦Āerᑃᑅ;拁ƀbtyᑌᑐᑺar;怖Ā;iᑏᑕcalȀBLSTᑡᑥᑪᑴar;戣ine;䁼eparator;杘ilde;所ThinSpace;怊r;쀀𝔙pf;쀀𝕍cr;쀀𝒱dash;抪ʀcefosᒧᒬᒱᒶᒼirc;䅴dge;拀r;쀀𝔚pf;쀀𝕎cr;쀀𝒲Ȁfiosᓋᓐᓒᓘr;쀀𝔛;䎞pf;쀀𝕏cr;쀀𝒳ҀAIUacfosuᓱᓵᓹᓽᔄᔏᔔᔚᔠcy;䐯cy;䐇cy;䐮cute耻Ý䃝Āiyᔉᔍrc;䅶;䐫r;쀀𝔜pf;쀀𝕐cr;쀀𝒴ml;䅸ЀHacdefosᔵᔹᔿᕋᕏᕝᕠᕤcy;䐖cute;䅹Āayᕄᕉron;䅽;䐗ot;䅻ǲᕔ\0ᕛoWidtè૙a;䎖r;愨pf;愤cr;쀀𝒵௡ᖃᖊᖐ\0ᖰᖶᖿ\0\0\0\0ᗆᗛᗫᙟ᙭\0ᚕ᚛ᚲᚹ\0ᚾcute耻á䃡reve;䄃̀;Ediuyᖜᖝᖡᖣᖨᖭ戾;쀀∾̳;房rc耻â䃢te肻´̆;䐰lig耻æ䃦Ā;r²ᖺ;쀀𝔞rave耻à䃠ĀepᗊᗖĀfpᗏᗔsym;愵èᗓha;䎱ĀapᗟcĀclᗤᗧr;䄁g;樿ɤᗰ\0\0ᘊʀ;adsvᗺᗻᗿᘁᘇ戧nd;橕;橜lope;橘;橚΀;elmrszᘘᘙᘛᘞᘿᙏᙙ戠;榤e»ᘙsdĀ;aᘥᘦ戡ѡᘰᘲᘴᘶᘸᘺᘼᘾ;榨;榩;榪;榫;榬;榭;榮;榯tĀ;vᙅᙆ戟bĀ;dᙌᙍ抾;榝Āptᙔᙗh;戢»¹arr;捼Āgpᙣᙧon;䄅f;쀀𝕒΀;Eaeiop዁ᙻᙽᚂᚄᚇᚊ;橰cir;橯;扊d;手s;䀧roxĀ;e዁ᚒñᚃing耻å䃥ƀctyᚡᚦᚨr;쀀𝒶;䀪mpĀ;e዁ᚯñʈilde耻ã䃣ml耻ä䃤Āciᛂᛈoninôɲnt;樑ࠀNabcdefiklnoprsu᛭ᛱᜰ᜼ᝃᝈ᝸᝽០៦ᠹᡐᜍ᤽᥈ᥰot;櫭Ācrᛶ᜞kȀcepsᜀᜅᜍᜓong;扌psilon;䏶rime;怵imĀ;e᜚᜛戽q;拍Ŷᜢᜦee;抽edĀ;gᜬᜭ挅e»ᜭrkĀ;t፜᜷brk;掶Āoyᜁᝁ;䐱quo;怞ʀcmprtᝓ᝛ᝡᝤᝨausĀ;eĊĉptyv;榰séᜌnoõēƀahwᝯ᝱ᝳ;䎲;愶een;扬r;쀀𝔟g΀costuvwឍឝឳេ៕៛៞ƀaiuបពរðݠrc;旯p»፱ƀdptឤឨឭot;樀lus;樁imes;樂ɱឹ\0\0ើcup;樆ar;昅riangleĀdu៍្own;施p;斳plus;樄eåᑄåᒭarow;植ƀako៭ᠦᠵĀcn៲ᠣkƀlst៺֫᠂ozenge;槫riangleȀ;dlr᠒᠓᠘᠝斴own;斾eft;旂ight;斸k;搣Ʊᠫ\0ᠳƲᠯ\0ᠱ;斒;斑4;斓ck;斈ĀeoᠾᡍĀ;qᡃᡆ쀀=⃥uiv;쀀≡⃥t;挐Ȁptwxᡙᡞᡧᡬf;쀀𝕓Ā;tᏋᡣom»Ꮜtie;拈؀DHUVbdhmptuvᢅᢖᢪᢻᣗᣛᣬ᣿ᤅᤊᤐᤡȀLRlrᢎᢐᢒᢔ;敗;敔;敖;敓ʀ;DUduᢡᢢᢤᢦᢨ敐;敦;敩;敤;敧ȀLRlrᢳᢵᢷᢹ;敝;敚;敜;教΀;HLRhlrᣊᣋᣍᣏᣑᣓᣕ救;敬;散;敠;敫;敢;敟ox;槉ȀLRlrᣤᣦᣨᣪ;敕;敒;攐;攌ʀ;DUduڽ᣷᣹᣻᣽;敥;敨;攬;攴inus;抟lus;択imes;抠ȀLRlrᤙᤛᤝ᤟;敛;敘;攘;攔΀;HLRhlrᤰᤱᤳᤵᤷ᤻᤹攂;敪;敡;敞;攼;攤;攜Āevģ᥂bar耻¦䂦Ȁceioᥑᥖᥚᥠr;쀀𝒷mi;恏mĀ;e᜚᜜lƀ;bhᥨᥩᥫ䁜;槅sub;柈Ŭᥴ᥾lĀ;e᥹᥺怢t»᥺pƀ;Eeįᦅᦇ;檮Ā;qۜۛೡᦧ\0᧨ᨑᨕᨲ\0ᨷᩐ\0\0᪴\0\0᫁\0\0ᬡᬮ᭍᭒\0᯽\0ᰌƀcpr᦭ᦲ᧝ute;䄇̀;abcdsᦿᧀᧄ᧊᧕᧙戩nd;橄rcup;橉Āau᧏᧒p;橋p;橇ot;橀;쀀∩︀Āeo᧢᧥t;恁îړȀaeiu᧰᧻ᨁᨅǰ᧵\0᧸s;橍on;䄍dil耻ç䃧rc;䄉psĀ;sᨌᨍ橌m;橐ot;䄋ƀdmnᨛᨠᨦil肻¸ƭptyv;榲t脀¢;eᨭᨮ䂢räƲr;쀀𝔠ƀceiᨽᩀᩍy;䑇ckĀ;mᩇᩈ朓ark»ᩈ;䏇r΀;Ecefms᩟᩠ᩢᩫ᪤᪪᪮旋;槃ƀ;elᩩᩪᩭ䋆q;扗eɡᩴ\0\0᪈rrowĀlr᩼᪁eft;憺ight;憻ʀRSacd᪒᪔᪖᪚᪟»ཇ;擈st;抛irc;抚ash;抝nint;樐id;櫯cir;槂ubsĀ;u᪻᪼晣it»᪼ˬ᫇᫔᫺\0ᬊonĀ;eᫍᫎ䀺Ā;qÇÆɭ᫙\0\0᫢aĀ;t᫞᫟䀬;䁀ƀ;fl᫨᫩᫫戁îᅠeĀmx᫱᫶ent»᫩eóɍǧ᫾\0ᬇĀ;dኻᬂot;橭nôɆƀfryᬐᬔᬗ;쀀𝕔oäɔ脀©;sŕᬝr;愗Āaoᬥᬩrr;憵ss;朗Ācuᬲᬷr;쀀𝒸Ābpᬼ᭄Ā;eᭁᭂ櫏;櫑Ā;eᭉᭊ櫐;櫒dot;拯΀delprvw᭠᭬᭷ᮂᮬᯔ᯹arrĀlr᭨᭪;椸;椵ɰ᭲\0\0᭵r;拞c;拟arrĀ;p᭿ᮀ憶;椽̀;bcdosᮏᮐᮖᮡᮥᮨ截rcap;橈Āauᮛᮞp;橆p;橊ot;抍r;橅;쀀∪︀Ȁalrv᮵ᮿᯞᯣrrĀ;mᮼᮽ憷;椼yƀevwᯇᯔᯘqɰᯎ\0\0ᯒreã᭳uã᭵ee;拎edge;拏en耻¤䂤earrowĀlrᯮ᯳eft»ᮀight»ᮽeäᯝĀciᰁᰇoninôǷnt;戱lcty;挭ঀAHabcdefhijlorstuwz᰸᰻᰿ᱝᱩᱵᲊᲞᲬᲷ᳻᳿ᴍᵻᶑᶫᶻ᷆᷍rò΁ar;楥Ȁglrs᱈ᱍ᱒᱔ger;怠eth;愸òᄳhĀ;vᱚᱛ怐»ऊūᱡᱧarow;椏aã̕Āayᱮᱳron;䄏;䐴ƀ;ao̲ᱼᲄĀgrʿᲁr;懊tseq;橷ƀglmᲑᲔᲘ耻°䂰ta;䎴ptyv;榱ĀirᲣᲨsht;楿;쀀𝔡arĀlrᲳᲵ»ࣜ»သʀaegsv᳂͸᳖᳜᳠mƀ;oș᳊᳔ndĀ;ș᳑uit;晦amma;䏝in;拲ƀ;io᳧᳨᳸䃷de脀÷;o᳧ᳰntimes;拇nø᳷cy;䑒cɯᴆ\0\0ᴊrn;挞op;挍ʀlptuwᴘᴝᴢᵉᵕlar;䀤f;쀀𝕕ʀ;emps̋ᴭᴷᴽᵂqĀ;d͒ᴳot;扑inus;戸lus;戔quare;抡blebarwedgåúnƀadhᄮᵝᵧownarrowóᲃarpoonĀlrᵲᵶefôᲴighôᲶŢᵿᶅkaro÷གɯᶊ\0\0ᶎrn;挟op;挌ƀcotᶘᶣᶦĀryᶝᶡ;쀀𝒹;䑕l;槶rok;䄑Ādrᶰᶴot;拱iĀ;fᶺ᠖斿Āah᷀᷃ròЩaòྦangle;榦Āci᷒ᷕy;䑟grarr;柿ऀDacdefglmnopqrstuxḁḉḙḸոḼṉṡṾấắẽỡἪἷὄ὎὚ĀDoḆᴴoôᲉĀcsḎḔute耻é䃩ter;橮ȀaioyḢḧḱḶron;䄛rĀ;cḭḮ扖耻ê䃪lon;払;䑍ot;䄗ĀDrṁṅot;扒;쀀𝔢ƀ;rsṐṑṗ檚ave耻è䃨Ā;dṜṝ檖ot;檘Ȁ;ilsṪṫṲṴ檙nters;揧;愓Ā;dṹṺ檕ot;檗ƀapsẅẉẗcr;䄓tyƀ;svẒẓẕ戅et»ẓpĀ1;ẝẤĳạả;怄;怅怃ĀgsẪẬ;䅋p;怂ĀgpẴẸon;䄙f;쀀𝕖ƀalsỄỎỒrĀ;sỊị拕l;槣us;橱iƀ;lvỚớở䎵on»ớ;䏵ȀcsuvỪỳἋἣĀioữḱrc»Ḯɩỹ\0\0ỻíՈantĀglἂἆtr»ṝess»Ṻƀaeiἒ἖Ἒls;䀽st;扟vĀ;DȵἠD;橸parsl;槥ĀDaἯἳot;打rr;楱ƀcdiἾὁỸr;愯oô͒ĀahὉὋ;䎷耻ð䃰Āmrὓὗl耻ë䃫o;悬ƀcipὡὤὧl;䀡sôծĀeoὬὴctatioîՙnentialåչৡᾒ\0ᾞ\0ᾡᾧ\0\0ῆῌ\0ΐ\0ῦῪ \0 ⁚llingdotseñṄy;䑄male;晀ƀilrᾭᾳ῁lig;耀ﬃɩᾹ\0\0᾽g;耀ﬀig;耀ﬄ;쀀𝔣lig;耀ﬁlig;쀀fjƀaltῙ῜ῡt;晭ig;耀ﬂns;斱of;䆒ǰ΅\0ῳf;쀀𝕗ĀakֿῷĀ;vῼ´拔;櫙artint;樍Āao‌⁕Ācs‑⁒α‚‰‸⁅⁈\0⁐β•‥‧‪‬\0‮耻½䂽;慓耻¼䂼;慕;慙;慛Ƴ‴\0‶;慔;慖ʴ‾⁁\0\0⁃耻¾䂾;慗;慜5;慘ƶ⁌\0⁎;慚;慝8;慞l;恄wn;挢cr;쀀𝒻ࢀEabcdefgijlnorstv₂₉₟₥₰₴⃰⃵⃺⃿℃ℒℸ̗ℾ⅒↞Ā;lٍ₇;檌ƀcmpₐₕ₝ute;䇵maĀ;dₜ᳚䎳;檆reve;䄟Āiy₪₮rc;䄝;䐳ot;䄡Ȁ;lqsؾق₽⃉ƀ;qsؾٌ⃄lanô٥Ȁ;cdl٥⃒⃥⃕c;檩otĀ;o⃜⃝檀Ā;l⃢⃣檂;檄Ā;e⃪⃭쀀⋛︀s;檔r;쀀𝔤Ā;gٳ؛mel;愷cy;䑓Ȁ;Eajٚℌℎℐ;檒;檥;檤ȀEaesℛℝ℩ℴ;扩pĀ;p℣ℤ檊rox»ℤĀ;q℮ℯ檈Ā;q℮ℛim;拧pf;쀀𝕘Āci⅃ⅆr;愊mƀ;el٫ⅎ⅐;檎;檐茀>;cdlqr׮ⅠⅪⅮⅳⅹĀciⅥⅧ;檧r;橺ot;拗Par;榕uest;橼ʀadelsↄⅪ←ٖ↛ǰ↉\0↎proø₞r;楸qĀlqؿ↖lesó₈ií٫Āen↣↭rtneqq;쀀≩︀Å↪ԀAabcefkosy⇄⇇⇱⇵⇺∘∝∯≨≽ròΠȀilmr⇐⇔⇗⇛rsðᒄf»․ilôکĀdr⇠⇤cy;䑊ƀ;cwࣴ⇫⇯ir;楈;憭ar;意irc;䄥ƀalr∁∎∓rtsĀ;u∉∊晥it»∊lip;怦con;抹r;쀀𝔥sĀew∣∩arow;椥arow;椦ʀamopr∺∾≃≞≣rr;懿tht;戻kĀlr≉≓eftarrow;憩ightarrow;憪f;쀀𝕙bar;怕ƀclt≯≴≸r;쀀𝒽asè⇴rok;䄧Ābp⊂⊇ull;恃hen»ᱛૡ⊣\0⊪\0⊸⋅⋎\0⋕⋳\0\0⋸⌢⍧⍢⍿\0⎆⎪⎴cute耻í䃭ƀ;iyݱ⊰⊵rc耻î䃮;䐸Ācx⊼⊿y;䐵cl耻¡䂡ĀfrΟ⋉;쀀𝔦rave耻ì䃬Ȁ;inoܾ⋝⋩⋮Āin⋢⋦nt;樌t;戭fin;槜ta;愩lig;䄳ƀaop⋾⌚⌝ƀcgt⌅⌈⌗r;䄫ƀelpܟ⌏⌓inåގarôܠh;䄱f;抷ed;䆵ʀ;cfotӴ⌬⌱⌽⍁are;愅inĀ;t⌸⌹戞ie;槝doô⌙ʀ;celpݗ⍌⍐⍛⍡al;抺Āgr⍕⍙eróᕣã⍍arhk;樗rod;樼Ȁcgpt⍯⍲⍶⍻y;䑑on;䄯f;쀀𝕚a;䎹uest耻¿䂿Āci⎊⎏r;쀀𝒾nʀ;EdsvӴ⎛⎝⎡ӳ;拹ot;拵Ā;v⎦⎧拴;拳Ā;iݷ⎮lde;䄩ǫ⎸\0⎼cy;䑖l耻ï䃯̀cfmosu⏌⏗⏜⏡⏧⏵Āiy⏑⏕rc;䄵;䐹r;쀀𝔧ath;䈷pf;쀀𝕛ǣ⏬\0⏱r;쀀𝒿rcy;䑘kcy;䑔Ѐacfghjos␋␖␢␧␭␱␵␻ppaĀ;v␓␔䎺;䏰Āey␛␠dil;䄷;䐺r;쀀𝔨reen;䄸cy;䑅cy;䑜pf;쀀𝕜cr;쀀𝓀஀ABEHabcdefghjlmnoprstuv⑰⒁⒆⒍⒑┎┽╚▀♎♞♥♹♽⚚⚲⛘❝❨➋⟀⠁⠒ƀart⑷⑺⑼rò৆òΕail;椛arr;椎Ā;gঔ⒋;檋ar;楢ॣ⒥\0⒪\0⒱\0\0\0\0\0⒵Ⓔ\0ⓆⓈⓍ\0⓹ute;䄺mptyv;榴raîࡌbda;䎻gƀ;dlࢎⓁⓃ;榑åࢎ;檅uo耻«䂫rЀ;bfhlpst࢙ⓞⓦⓩ⓫⓮⓱⓵Ā;f࢝ⓣs;椟s;椝ë≒p;憫l;椹im;楳l;憢ƀ;ae⓿─┄檫il;椙Ā;s┉┊檭;쀀⪭︀ƀabr┕┙┝rr;椌rk;杲Āak┢┬cĀek┨┪;䁻;䁛Āes┱┳;榋lĀdu┹┻;榏;榍Ȁaeuy╆╋╖╘ron;䄾Ādi═╔il;䄼ìࢰâ┩;䐻Ȁcqrs╣╦╭╽a;椶uoĀ;rนᝆĀdu╲╷har;楧shar;楋h;憲ʀ;fgqs▋▌উ◳◿扤tʀahlrt▘▤▷◂◨rrowĀ;t࢙□aé⓶arpoonĀdu▯▴own»њp»०eftarrows;懇ightƀahs◍◖◞rrowĀ;sࣴࢧarpoonó྘quigarro÷⇰hreetimes;拋ƀ;qs▋ও◺lanôবʀ;cdgsব☊☍☝☨c;檨otĀ;o☔☕橿Ā;r☚☛檁;檃Ā;e☢☥쀀⋚︀s;檓ʀadegs☳☹☽♉♋pproøⓆot;拖qĀgq♃♅ôউgtò⒌ôছiíলƀilr♕࣡♚sht;楼;쀀𝔩Ā;Eজ♣;檑š♩♶rĀdu▲♮Ā;l॥♳;楪lk;斄cy;䑙ʀ;achtੈ⚈⚋⚑⚖rò◁orneòᴈard;楫ri;旺Āio⚟⚤dot;䅀ustĀ;a⚬⚭掰che»⚭ȀEaes⚻⚽⛉⛔;扨pĀ;p⛃⛄檉rox»⛄Ā;q⛎⛏檇Ā;q⛎⚻im;拦Ѐabnoptwz⛩⛴⛷✚✯❁❇❐Ānr⛮⛱g;柬r;懽rëࣁgƀlmr⛿✍✔eftĀar০✇ightá৲apsto;柼ightá৽parrowĀlr✥✩efô⓭ight;憬ƀafl✶✹✽r;榅;쀀𝕝us;樭imes;樴š❋❏st;戗áፎƀ;ef❗❘᠀旊nge»❘arĀ;l❤❥䀨t;榓ʀachmt❳❶❼➅➇ròࢨorneòᶌarĀ;d྘➃;業;怎ri;抿̀achiqt➘➝ੀ➢➮➻quo;怹r;쀀𝓁mƀ;egল➪➬;檍;檏Ābu┪➳oĀ;rฟ➹;怚rok;䅂萀<;cdhilqrࠫ⟒☹⟜⟠⟥⟪⟰Āci⟗⟙;檦r;橹reå◲mes;拉arr;楶uest;橻ĀPi⟵⟹ar;榖ƀ;ef⠀भ᠛旃rĀdu⠇⠍shar;楊har;楦Āen⠗⠡rtneqq;쀀≨︀Å⠞܀Dacdefhilnopsu⡀⡅⢂⢎⢓⢠⢥⢨⣚⣢⣤ઃ⣳⤂Dot;戺Ȁclpr⡎⡒⡣⡽r耻¯䂯Āet⡗⡙;時Ā;e⡞⡟朠se»⡟Ā;sျ⡨toȀ;dluျ⡳⡷⡻owîҌefôएðᏑker;斮Āoy⢇⢌mma;権;䐼ash;怔asuredangle»ᘦr;쀀𝔪o;愧ƀcdn⢯⢴⣉ro耻µ䂵Ȁ;acdᑤ⢽⣀⣄sôᚧir;櫰ot肻·Ƶusƀ;bd⣒ᤃ⣓戒Ā;uᴼ⣘;横ţ⣞⣡p;櫛ò−ðઁĀdp⣩⣮els;抧f;쀀𝕞Āct⣸⣽r;쀀𝓂pos»ᖝƀ;lm⤉⤊⤍䎼timap;抸ఀGLRVabcdefghijlmoprstuvw⥂⥓⥾⦉⦘⧚⧩⨕⨚⩘⩝⪃⪕⪤⪨⬄⬇⭄⭿⮮ⰴⱧⱼ⳩Āgt⥇⥋;쀀⋙̸Ā;v⥐௏쀀≫⃒ƀelt⥚⥲⥶ftĀar⥡⥧rrow;懍ightarrow;懎;쀀⋘̸Ā;v⥻ే쀀≪⃒ightarrow;懏ĀDd⦎⦓ash;抯ash;抮ʀbcnpt⦣⦧⦬⦱⧌la»˞ute;䅄g;쀀∠⃒ʀ;Eiop඄⦼⧀⧅⧈;쀀⩰̸d;쀀≋̸s;䅉roø඄urĀ;a⧓⧔普lĀ;s⧓ସǳ⧟\0⧣p肻 ଷmpĀ;e௹ఀʀaeouy⧴⧾⨃⨐⨓ǰ⧹\0⧻;橃on;䅈dil;䅆ngĀ;dൾ⨊ot;쀀⩭̸p;橂;䐽ash;怓΀;Aadqsxஒ⨩⨭⨻⩁⩅⩐rr;懗rĀhr⨳⨶k;椤Ā;oᏲᏰot;쀀≐̸uiöୣĀei⩊⩎ar;椨í஘istĀ;s஠டr;쀀𝔫ȀEest௅⩦⩹⩼ƀ;qs஼⩭௡ƀ;qs஼௅⩴lanô௢ií௪Ā;rஶ⪁»ஷƀAap⪊⪍⪑rò⥱rr;憮ar;櫲ƀ;svྍ⪜ྌĀ;d⪡⪢拼;拺cy;䑚΀AEadest⪷⪺⪾⫂⫅⫶⫹rò⥦;쀀≦̸rr;憚r;急Ȁ;fqs఻⫎⫣⫯tĀar⫔⫙rro÷⫁ightarro÷⪐ƀ;qs఻⪺⫪lanôౕĀ;sౕ⫴»శiíౝĀ;rవ⫾iĀ;eచథiäඐĀpt⬌⬑f;쀀𝕟膀¬;in⬙⬚⬶䂬nȀ;Edvஉ⬤⬨⬮;쀀⋹̸ot;쀀⋵̸ǡஉ⬳⬵;拷;拶iĀ;vಸ⬼ǡಸ⭁⭃;拾;拽ƀaor⭋⭣⭩rȀ;ast୻⭕⭚⭟lleì୻l;쀀⫽⃥;쀀∂̸lint;樔ƀ;ceಒ⭰⭳uåಥĀ;cಘ⭸Ā;eಒ⭽ñಘȀAait⮈⮋⮝⮧rò⦈rrƀ;cw⮔⮕⮙憛;쀀⤳̸;쀀↝̸ghtarrow»⮕riĀ;eೋೖ΀chimpqu⮽⯍⯙⬄୸⯤⯯Ȁ;cerല⯆ഷ⯉uå൅;쀀𝓃ortɭ⬅\0\0⯖ará⭖mĀ;e൮⯟Ā;q൴൳suĀbp⯫⯭å೸åഋƀbcp⯶ⰑⰙȀ;Ees⯿ⰀഢⰄ抄;쀀⫅̸etĀ;eഛⰋqĀ;qണⰀcĀ;eലⰗñസȀ;EesⰢⰣൟⰧ抅;쀀⫆̸etĀ;e൘ⰮqĀ;qൠⰣȀgilrⰽⰿⱅⱇìௗlde耻ñ䃱çృiangleĀlrⱒⱜeftĀ;eచⱚñదightĀ;eೋⱥñ೗Ā;mⱬⱭ䎽ƀ;esⱴⱵⱹ䀣ro;愖p;怇ҀDHadgilrsⲏⲔⲙⲞⲣⲰⲶⳓⳣash;抭arr;椄p;쀀≍⃒ash;抬ĀetⲨⲬ;쀀≥⃒;쀀>⃒nfin;槞ƀAetⲽⳁⳅrr;椂;쀀≤⃒Ā;rⳊⳍ쀀<⃒ie;쀀⊴⃒ĀAtⳘⳜrr;椃rie;쀀⊵⃒im;쀀∼⃒ƀAan⳰⳴ⴂrr;懖rĀhr⳺⳽k;椣Ā;oᏧᏥear;椧ቓ᪕\0\0\0\0\0\0\0\0\0\0\0\0\0ⴭ\0ⴸⵈⵠⵥ⵲ⶄᬇ\0\0ⶍⶫ\0ⷈⷎ\0ⷜ⸙⸫⸾⹃Ācsⴱ᪗ute耻ó䃳ĀiyⴼⵅrĀ;c᪞ⵂ耻ô䃴;䐾ʀabios᪠ⵒⵗǈⵚlac;䅑v;樸old;榼lig;䅓Ācr⵩⵭ir;榿;쀀𝔬ͯ⵹\0\0⵼\0ⶂn;䋛ave耻ò䃲;槁Ābmⶈ෴ar;榵Ȁacitⶕ⶘ⶥⶨrò᪀Āir⶝ⶠr;榾oss;榻nå๒;槀ƀaeiⶱⶵⶹcr;䅍ga;䏉ƀcdnⷀⷅǍron;䎿;榶pf;쀀𝕠ƀaelⷔ⷗ǒr;榷rp;榹΀;adiosvⷪⷫⷮ⸈⸍⸐⸖戨rò᪆Ȁ;efmⷷⷸ⸂⸅橝rĀ;oⷾⷿ愴f»ⷿ耻ª䂪耻º䂺gof;抶r;橖lope;橗;橛ƀclo⸟⸡⸧ò⸁ash耻ø䃸l;折iŬⸯ⸴de耻õ䃵esĀ;aǛ⸺s;樶ml耻ö䃶bar;挽ૡ⹞\0⹽\0⺀⺝\0⺢⺹\0\0⻋ຜ\0⼓\0\0⼫⾼\0⿈rȀ;astЃ⹧⹲຅脀¶;l⹭⹮䂶leìЃɩ⹸\0\0⹻m;櫳;櫽y;䐿rʀcimpt⺋⺏⺓ᡥ⺗nt;䀥od;䀮il;怰enk;怱r;쀀𝔭ƀimo⺨⺰⺴Ā;v⺭⺮䏆;䏕maô੶ne;明ƀ;tv⺿⻀⻈䏀chfork»´;䏖Āau⻏⻟nĀck⻕⻝kĀ;h⇴⻛;愎ö⇴sҀ;abcdemst⻳⻴ᤈ⻹⻽⼄⼆⼊⼎䀫cir;樣ir;樢Āouᵀ⼂;樥;橲n肻±ຝim;樦wo;樧ƀipu⼙⼠⼥ntint;樕f;쀀𝕡nd耻£䂣Ԁ;Eaceinosu່⼿⽁⽄⽇⾁⾉⾒⽾⾶;檳p;檷uå໙Ā;c໎⽌̀;acens່⽙⽟⽦⽨⽾pproø⽃urlyeñ໙ñ໎ƀaes⽯⽶⽺pprox;檹qq;檵im;拨iíໟmeĀ;s⾈ຮ怲ƀEas⽸⾐⽺ð⽵ƀdfp໬⾙⾯ƀals⾠⾥⾪lar;挮ine;挒urf;挓Ā;t໻⾴ï໻rel;抰Āci⿀⿅r;쀀𝓅;䏈ncsp;怈̀fiopsu⿚⋢⿟⿥⿫⿱r;쀀𝔮pf;쀀𝕢rime;恗cr;쀀𝓆ƀaeo⿸〉〓tĀei⿾々rnionóڰnt;樖stĀ;e【】䀿ñἙô༔઀ABHabcdefhilmnoprstux぀けさすムㄎㄫㅇㅢㅲㆎ㈆㈕㈤㈩㉘㉮㉲㊐㊰㊷ƀartぇおがròႳòϝail;検aròᱥar;楤΀cdenqrtとふへみわゔヌĀeuねぱ;쀀∽̱te;䅕iãᅮmptyv;榳gȀ;del࿑らるろ;榒;榥å࿑uo耻»䂻rր;abcfhlpstw࿜ガクシスゼゾダッデナp;極Ā;f࿠ゴs;椠;椳s;椞ë≝ð✮l;楅im;楴l;憣;憝Āaiパフil;椚oĀ;nホボ戶aló༞ƀabrョリヮrò៥rk;杳ĀakンヽcĀekヹ・;䁽;䁝Āes㄂㄄;榌lĀduㄊㄌ;榎;榐Ȁaeuyㄗㄜㄧㄩron;䅙Ādiㄡㄥil;䅗ì࿲âヺ;䑀Ȁclqsㄴㄷㄽㅄa;椷dhar;楩uoĀ;rȎȍh;憳ƀacgㅎㅟངlȀ;ipsླྀㅘㅛႜnåႻarôྩt;断ƀilrㅩဣㅮsht;楽;쀀𝔯ĀaoㅷㆆrĀduㅽㅿ»ѻĀ;l႑ㆄ;楬Ā;vㆋㆌ䏁;䏱ƀgns㆕ㇹㇼht̀ahlrstㆤㆰ㇂㇘㇤㇮rrowĀ;t࿜ㆭaéトarpoonĀduㆻㆿowîㅾp»႒eftĀah㇊㇐rrowó࿪arpoonóՑightarrows;應quigarro÷ニhreetimes;拌g;䋚ingdotseñἲƀahm㈍㈐㈓rò࿪aòՑ;怏oustĀ;a㈞㈟掱che»㈟mid;櫮Ȁabpt㈲㈽㉀㉒Ānr㈷㈺g;柭r;懾rëဃƀafl㉇㉊㉎r;榆;쀀𝕣us;樮imes;樵Āap㉝㉧rĀ;g㉣㉤䀩t;榔olint;樒arò㇣Ȁachq㉻㊀Ⴜ㊅quo;怺r;쀀𝓇Ābu・㊊oĀ;rȔȓƀhir㊗㊛㊠reåㇸmes;拊iȀ;efl㊪ၙᠡ㊫方tri;槎luhar;楨;愞ൡ㋕㋛㋟㌬㌸㍱\0㍺㎤\0\0㏬㏰\0㐨㑈㑚㒭㒱㓊㓱\0㘖\0\0㘳cute;䅛quï➺Ԁ;Eaceinpsyᇭ㋳㋵㋿㌂㌋㌏㌟㌦㌩;檴ǰ㋺\0㋼;檸on;䅡uåᇾĀ;dᇳ㌇il;䅟rc;䅝ƀEas㌖㌘㌛;檶p;檺im;择olint;樓iíሄ;䑁otƀ;be㌴ᵇ㌵担;橦΀Aacmstx㍆㍊㍗㍛㍞㍣㍭rr;懘rĀhr㍐㍒ë∨Ā;oਸ਼਴t耻§䂧i;䀻war;椩mĀin㍩ðnuóñt;朶rĀ;o㍶⁕쀀𝔰Ȁacoy㎂㎆㎑㎠rp;景Āhy㎋㎏cy;䑉;䑈rtɭ㎙\0\0㎜iäᑤaraì⹯耻­䂭Āgm㎨㎴maƀ;fv㎱㎲㎲䏃;䏂Ѐ;deglnprካ㏅㏉㏎㏖㏞㏡㏦ot;橪Ā;q኱ኰĀ;E㏓㏔檞;檠Ā;E㏛㏜檝;檟e;扆lus;樤arr;楲aròᄽȀaeit㏸㐈㐏㐗Āls㏽㐄lsetmé㍪hp;樳parsl;槤Ādlᑣ㐔e;挣Ā;e㐜㐝檪Ā;s㐢㐣檬;쀀⪬︀ƀflp㐮㐳㑂tcy;䑌Ā;b㐸㐹䀯Ā;a㐾㐿槄r;挿f;쀀𝕤aĀdr㑍ЂesĀ;u㑔㑕晠it»㑕ƀcsu㑠㑹㒟Āau㑥㑯pĀ;sᆈ㑫;쀀⊓︀pĀ;sᆴ㑵;쀀⊔︀uĀbp㑿㒏ƀ;esᆗᆜ㒆etĀ;eᆗ㒍ñᆝƀ;esᆨᆭ㒖etĀ;eᆨ㒝ñᆮƀ;afᅻ㒦ְrť㒫ֱ»ᅼaròᅈȀcemt㒹㒾㓂㓅r;쀀𝓈tmîñiì㐕aræᆾĀar㓎㓕rĀ;f㓔ឿ昆Āan㓚㓭ightĀep㓣㓪psiloîỠhé⺯s»⡒ʀbcmnp㓻㕞ሉ㖋㖎Ҁ;Edemnprs㔎㔏㔑㔕㔞㔣㔬㔱㔶抂;櫅ot;檽Ā;dᇚ㔚ot;櫃ult;櫁ĀEe㔨㔪;櫋;把lus;檿arr;楹ƀeiu㔽㕒㕕tƀ;en㔎㕅㕋qĀ;qᇚ㔏eqĀ;q㔫㔨m;櫇Ābp㕚㕜;櫕;櫓c̀;acensᇭ㕬㕲㕹㕻㌦pproø㋺urlyeñᇾñᇳƀaes㖂㖈㌛pproø㌚qñ㌗g;晪ڀ123;Edehlmnps㖩㖬㖯ሜ㖲㖴㗀㗉㗕㗚㗟㗨㗭耻¹䂹耻²䂲耻³䂳;櫆Āos㖹㖼t;檾ub;櫘Ā;dሢ㗅ot;櫄sĀou㗏㗒l;柉b;櫗arr;楻ult;櫂ĀEe㗤㗦;櫌;抋lus;櫀ƀeiu㗴㘉㘌tƀ;enሜ㗼㘂qĀ;qሢ㖲eqĀ;q㗧㗤m;櫈Ābp㘑㘓;櫔;櫖ƀAan㘜㘠㘭rr;懙rĀhr㘦㘨ë∮Ā;oਫ਩war;椪lig耻ß䃟௡㙑㙝㙠ዎ㙳㙹\0㙾㛂\0\0\0\0\0㛛㜃\0㜉㝬\0\0\0㞇ɲ㙖\0\0㙛get;挖;䏄rë๟ƀaey㙦㙫㙰ron;䅥dil;䅣;䑂lrec;挕r;쀀𝔱Ȁeiko㚆㚝㚵㚼ǲ㚋\0㚑eĀ4fኄኁaƀ;sv㚘㚙㚛䎸ym;䏑Ācn㚢㚲kĀas㚨㚮pproø዁im»ኬsðኞĀas㚺㚮ð዁rn耻þ䃾Ǭ̟㛆⋧es膀×;bd㛏㛐㛘䃗Ā;aᤏ㛕r;樱;樰ƀeps㛡㛣㜀á⩍Ȁ;bcf҆㛬㛰㛴ot;挶ir;櫱Ā;o㛹㛼쀀𝕥rk;櫚á㍢rime;怴ƀaip㜏㜒㝤dåቈ΀adempst㜡㝍㝀㝑㝗㝜㝟ngleʀ;dlqr㜰㜱㜶㝀㝂斵own»ᶻeftĀ;e⠀㜾ñम;扜ightĀ;e㊪㝋ñၚot;旬inus;樺lus;樹b;槍ime;樻ezium;揢ƀcht㝲㝽㞁Āry㝷㝻;쀀𝓉;䑆cy;䑛rok;䅧Āio㞋㞎xô᝷headĀlr㞗㞠eftarro÷ࡏightarrow»ཝऀAHabcdfghlmoprstuw㟐㟓㟗㟤㟰㟼㠎㠜㠣㠴㡑㡝㡫㢩㣌㣒㣪㣶ròϭar;楣Ācr㟜㟢ute耻ú䃺òᅐrǣ㟪\0㟭y;䑞ve;䅭Āiy㟵㟺rc耻û䃻;䑃ƀabh㠃㠆㠋ròᎭlac;䅱aòᏃĀir㠓㠘sht;楾;쀀𝔲rave耻ù䃹š㠧㠱rĀlr㠬㠮»ॗ»ႃlk;斀Āct㠹㡍ɯ㠿\0\0㡊rnĀ;e㡅㡆挜r»㡆op;挏ri;旸Āal㡖㡚cr;䅫肻¨͉Āgp㡢㡦on;䅳f;쀀𝕦̀adhlsuᅋ㡸㡽፲㢑㢠ownáᎳarpoonĀlr㢈㢌efô㠭ighô㠯iƀ;hl㢙㢚㢜䏅»ᏺon»㢚parrows;懈ƀcit㢰㣄㣈ɯ㢶\0\0㣁rnĀ;e㢼㢽挝r»㢽op;挎ng;䅯ri;旹cr;쀀𝓊ƀdir㣙㣝㣢ot;拰lde;䅩iĀ;f㜰㣨»᠓Āam㣯㣲rò㢨l耻ü䃼angle;榧ހABDacdeflnoprsz㤜㤟㤩㤭㦵㦸㦽㧟㧤㧨㧳㧹㧽㨁㨠ròϷarĀ;v㤦㤧櫨;櫩asèϡĀnr㤲㤷grt;榜΀eknprst㓣㥆㥋㥒㥝㥤㦖appá␕othinçẖƀhir㓫⻈㥙opô⾵Ā;hᎷ㥢ïㆍĀiu㥩㥭gmá㎳Ābp㥲㦄setneqĀ;q㥽㦀쀀⊊︀;쀀⫋︀setneqĀ;q㦏㦒쀀⊋︀;쀀⫌︀Āhr㦛㦟etá㚜iangleĀlr㦪㦯eft»थight»ၑy;䐲ash»ံƀelr㧄㧒㧗ƀ;beⷪ㧋㧏ar;抻q;扚lip;拮Ābt㧜ᑨaòᑩr;쀀𝔳tré㦮suĀbp㧯㧱»ജ»൙pf;쀀𝕧roð໻tré㦴Ācu㨆㨋r;쀀𝓋Ābp㨐㨘nĀEe㦀㨖»㥾nĀEe㦒㨞»㦐igzag;榚΀cefoprs㨶㨻㩖㩛㩔㩡㩪irc;䅵Ādi㩀㩑Ābg㩅㩉ar;機eĀ;qᗺ㩏;扙erp;愘r;쀀𝔴pf;쀀𝕨Ā;eᑹ㩦atèᑹcr;쀀𝓌ૣណ㪇\0㪋\0㪐㪛\0\0㪝㪨㪫㪯\0\0㫃㫎\0㫘ៜ៟tré៑r;쀀𝔵ĀAa㪔㪗ròσrò৶;䎾ĀAa㪡㪤ròθrò৫að✓is;拻ƀdptឤ㪵㪾Āfl㪺ឩ;쀀𝕩imåឲĀAa㫇㫊ròώròਁĀcq㫒ីr;쀀𝓍Āpt៖㫜ré។Ѐacefiosu㫰㫽㬈㬌㬑㬕㬛㬡cĀuy㫶㫻te耻ý䃽;䑏Āiy㬂㬆rc;䅷;䑋n耻¥䂥r;쀀𝔶cy;䑗pf;쀀𝕪cr;쀀𝓎Ācm㬦㬩y;䑎l耻ÿ䃿Ԁacdefhiosw㭂㭈㭔㭘㭤㭩㭭㭴㭺㮀cute;䅺Āay㭍㭒ron;䅾;䐷ot;䅼Āet㭝㭡træᕟa;䎶r;쀀𝔷cy;䐶grarr;懝pf;쀀𝕫cr;쀀𝓏Ājn㮅㮇;怍j;怌'.split("").map(function(e) {
    return e.charCodeAt(0);
  })
);
var d0 = {};
Object.defineProperty(d0, "__esModule", { value: !0 });
d0.default = new Uint16Array(
  // prettier-ignore
  "Ȁaglq	\x1Bɭ\0\0p;䀦os;䀧t;䀾t;䀼uot;䀢".split("").map(function(e) {
    return e.charCodeAt(0);
  })
);
var Gc = {};
(function(e) {
  var t;
  Object.defineProperty(e, "__esModule", { value: !0 }), e.replaceCodePoint = e.fromCodePoint = void 0;
  var n = /* @__PURE__ */ new Map([
    [0, 65533],
    // C1 Unicode control character reference replacements
    [128, 8364],
    [130, 8218],
    [131, 402],
    [132, 8222],
    [133, 8230],
    [134, 8224],
    [135, 8225],
    [136, 710],
    [137, 8240],
    [138, 352],
    [139, 8249],
    [140, 338],
    [142, 381],
    [145, 8216],
    [146, 8217],
    [147, 8220],
    [148, 8221],
    [149, 8226],
    [150, 8211],
    [151, 8212],
    [152, 732],
    [153, 8482],
    [154, 353],
    [155, 8250],
    [156, 339],
    [158, 382],
    [159, 376]
  ]);
  e.fromCodePoint = // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition, node/no-unsupported-features/es-builtins
  (t = String.fromCodePoint) !== null && t !== void 0 ? t : function(i) {
    var a = "";
    return i > 65535 && (i -= 65536, a += String.fromCharCode(i >>> 10 & 1023 | 55296), i = 56320 | i & 1023), a += String.fromCharCode(i), a;
  };
  function r(i) {
    var a;
    return i >= 55296 && i <= 57343 || i > 1114111 ? 65533 : (a = n.get(i)) !== null && a !== void 0 ? a : i;
  }
  e.replaceCodePoint = r;
  function u(i) {
    return (0, e.fromCodePoint)(r(i));
  }
  e.default = u;
})(Gc);
(function(e) {
  var t = ee && ee.__createBinding || (Object.create ? function(w, D, N, O) {
    O === void 0 && (O = N);
    var H = Object.getOwnPropertyDescriptor(D, N);
    (!H || ("get" in H ? !D.__esModule : H.writable || H.configurable)) && (H = { enumerable: !0, get: function() {
      return D[N];
    } }), Object.defineProperty(w, O, H);
  } : function(w, D, N, O) {
    O === void 0 && (O = N), w[O] = D[N];
  }), n = ee && ee.__setModuleDefault || (Object.create ? function(w, D) {
    Object.defineProperty(w, "default", { enumerable: !0, value: D });
  } : function(w, D) {
    w.default = D;
  }), r = ee && ee.__importStar || function(w) {
    if (w && w.__esModule)
      return w;
    var D = {};
    if (w != null)
      for (var N in w)
        N !== "default" && Object.prototype.hasOwnProperty.call(w, N) && t(D, w, N);
    return n(D, w), D;
  }, u = ee && ee.__importDefault || function(w) {
    return w && w.__esModule ? w : { default: w };
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.decodeXML = e.decodeHTMLStrict = e.decodeHTMLAttribute = e.decodeHTML = e.determineBranch = e.EntityDecoder = e.DecodingMode = e.BinTrieFlags = e.fromCodePoint = e.replaceCodePoint = e.decodeCodePoint = e.xmlDecodeTree = e.htmlDecodeTree = void 0;
  var i = u(l0);
  e.htmlDecodeTree = i.default;
  var a = u(d0);
  e.xmlDecodeTree = a.default;
  var o = r(Gc);
  e.decodeCodePoint = o.default;
  var s = Gc;
  Object.defineProperty(e, "replaceCodePoint", { enumerable: !0, get: function() {
    return s.replaceCodePoint;
  } }), Object.defineProperty(e, "fromCodePoint", { enumerable: !0, get: function() {
    return s.fromCodePoint;
  } });
  var c;
  (function(w) {
    w[w.NUM = 35] = "NUM", w[w.SEMI = 59] = "SEMI", w[w.EQUALS = 61] = "EQUALS", w[w.ZERO = 48] = "ZERO", w[w.NINE = 57] = "NINE", w[w.LOWER_A = 97] = "LOWER_A", w[w.LOWER_F = 102] = "LOWER_F", w[w.LOWER_X = 120] = "LOWER_X", w[w.LOWER_Z = 122] = "LOWER_Z", w[w.UPPER_A = 65] = "UPPER_A", w[w.UPPER_F = 70] = "UPPER_F", w[w.UPPER_Z = 90] = "UPPER_Z";
  })(c || (c = {}));
  var l = 32, d;
  (function(w) {
    w[w.VALUE_LENGTH = 49152] = "VALUE_LENGTH", w[w.BRANCH_LENGTH = 16256] = "BRANCH_LENGTH", w[w.JUMP_TABLE = 127] = "JUMP_TABLE";
  })(d = e.BinTrieFlags || (e.BinTrieFlags = {}));
  function f(w) {
    return w >= c.ZERO && w <= c.NINE;
  }
  function p(w) {
    return w >= c.UPPER_A && w <= c.UPPER_F || w >= c.LOWER_A && w <= c.LOWER_F;
  }
  function h(w) {
    return w >= c.UPPER_A && w <= c.UPPER_Z || w >= c.LOWER_A && w <= c.LOWER_Z || f(w);
  }
  function m(w) {
    return w === c.EQUALS || h(w);
  }
  var b;
  (function(w) {
    w[w.EntityStart = 0] = "EntityStart", w[w.NumericStart = 1] = "NumericStart", w[w.NumericDecimal = 2] = "NumericDecimal", w[w.NumericHex = 3] = "NumericHex", w[w.NamedEntity = 4] = "NamedEntity";
  })(b || (b = {}));
  var x;
  (function(w) {
    w[w.Legacy = 0] = "Legacy", w[w.Strict = 1] = "Strict", w[w.Attribute = 2] = "Attribute";
  })(x = e.DecodingMode || (e.DecodingMode = {}));
  var y = (
    /** @class */
    function() {
      function w(D, N, O) {
        this.decodeTree = D, this.emitCodePoint = N, this.errors = O, this.state = b.EntityStart, this.consumed = 1, this.result = 0, this.treeIndex = 0, this.excess = 1, this.decodeMode = x.Strict;
      }
      return w.prototype.startEntity = function(D) {
        this.decodeMode = D, this.state = b.EntityStart, this.result = 0, this.treeIndex = 0, this.excess = 1, this.consumed = 1;
      }, w.prototype.write = function(D, N) {
        switch (this.state) {
          case b.EntityStart:
            return D.charCodeAt(N) === c.NUM ? (this.state = b.NumericStart, this.consumed += 1, this.stateNumericStart(D, N + 1)) : (this.state = b.NamedEntity, this.stateNamedEntity(D, N));
          case b.NumericStart:
            return this.stateNumericStart(D, N);
          case b.NumericDecimal:
            return this.stateNumericDecimal(D, N);
          case b.NumericHex:
            return this.stateNumericHex(D, N);
          case b.NamedEntity:
            return this.stateNamedEntity(D, N);
        }
      }, w.prototype.stateNumericStart = function(D, N) {
        return N >= D.length ? -1 : (D.charCodeAt(N) | l) === c.LOWER_X ? (this.state = b.NumericHex, this.consumed += 1, this.stateNumericHex(D, N + 1)) : (this.state = b.NumericDecimal, this.stateNumericDecimal(D, N));
      }, w.prototype.addToNumericResult = function(D, N, O, H) {
        if (N !== O) {
          var $ = O - N;
          this.result = this.result * Math.pow(H, $) + parseInt(D.substr(N, $), H), this.consumed += $;
        }
      }, w.prototype.stateNumericHex = function(D, N) {
        for (var O = N; N < D.length; ) {
          var H = D.charCodeAt(N);
          if (f(H) || p(H))
            N += 1;
          else
            return this.addToNumericResult(D, O, N, 16), this.emitNumericEntity(H, 3);
        }
        return this.addToNumericResult(D, O, N, 16), -1;
      }, w.prototype.stateNumericDecimal = function(D, N) {
        for (var O = N; N < D.length; ) {
          var H = D.charCodeAt(N);
          if (f(H))
            N += 1;
          else
            return this.addToNumericResult(D, O, N, 10), this.emitNumericEntity(H, 2);
        }
        return this.addToNumericResult(D, O, N, 10), -1;
      }, w.prototype.emitNumericEntity = function(D, N) {
        var O;
        if (this.consumed <= N)
          return (O = this.errors) === null || O === void 0 || O.absenceOfDigitsInNumericCharacterReference(this.consumed), 0;
        if (D === c.SEMI)
          this.consumed += 1;
        else if (this.decodeMode === x.Strict)
          return 0;
        return this.emitCodePoint((0, o.replaceCodePoint)(this.result), this.consumed), this.errors && (D !== c.SEMI && this.errors.missingSemicolonAfterCharacterReference(), this.errors.validateNumericCharacterReference(this.result)), this.consumed;
      }, w.prototype.stateNamedEntity = function(D, N) {
        for (var O = this.decodeTree, H = O[this.treeIndex], $ = (H & d.VALUE_LENGTH) >> 14; N < D.length; N++, this.excess++) {
          var j = D.charCodeAt(N);
          if (this.treeIndex = v(O, H, this.treeIndex + Math.max(1, $), j), this.treeIndex < 0)
            return this.result === 0 || // If we are parsing an attribute
            this.decodeMode === x.Attribute && // We shouldn't have consumed any characters after the entity,
            ($ === 0 || // And there should be no invalid characters.
            m(j)) ? 0 : this.emitNotTerminatedNamedEntity();
          if (H = O[this.treeIndex], $ = (H & d.VALUE_LENGTH) >> 14, $ !== 0) {
            if (j === c.SEMI)
              return this.emitNamedEntityData(this.treeIndex, $, this.consumed + this.excess);
            this.decodeMode !== x.Strict && (this.result = this.treeIndex, this.consumed += this.excess, this.excess = 0);
          }
        }
        return -1;
      }, w.prototype.emitNotTerminatedNamedEntity = function() {
        var D, N = this, O = N.result, H = N.decodeTree, $ = (H[O] & d.VALUE_LENGTH) >> 14;
        return this.emitNamedEntityData(O, $, this.consumed), (D = this.errors) === null || D === void 0 || D.missingSemicolonAfterCharacterReference(), this.consumed;
      }, w.prototype.emitNamedEntityData = function(D, N, O) {
        var H = this.decodeTree;
        return this.emitCodePoint(N === 1 ? H[D] & ~d.VALUE_LENGTH : H[D + 1], O), N === 3 && this.emitCodePoint(H[D + 2], O), O;
      }, w.prototype.end = function() {
        var D;
        switch (this.state) {
          case b.NamedEntity:
            return this.result !== 0 && (this.decodeMode !== x.Attribute || this.result === this.treeIndex) ? this.emitNotTerminatedNamedEntity() : 0;
          case b.NumericDecimal:
            return this.emitNumericEntity(0, 2);
          case b.NumericHex:
            return this.emitNumericEntity(0, 3);
          case b.NumericStart:
            return (D = this.errors) === null || D === void 0 || D.absenceOfDigitsInNumericCharacterReference(this.consumed), 0;
          case b.EntityStart:
            return 0;
        }
      }, w;
    }()
  );
  e.EntityDecoder = y;
  function g(w) {
    var D = "", N = new y(w, function(O) {
      return D += (0, o.fromCodePoint)(O);
    });
    return function(H, $) {
      for (var j = 0, z = 0; (z = H.indexOf("&", z)) >= 0; ) {
        D += H.slice(j, z), N.startEntity($);
        var M = N.write(
          H,
          // Skip the "&"
          z + 1
        );
        if (M < 0) {
          j = z + N.end();
          break;
        }
        j = z + M, z = M === 0 ? j + 1 : j;
      }
      var P = D + H.slice(j);
      return D = "", P;
    };
  }
  function v(w, D, N, O) {
    var H = (D & d.BRANCH_LENGTH) >> 7, $ = D & d.JUMP_TABLE;
    if (H === 0)
      return $ !== 0 && O === $ ? N : -1;
    if ($) {
      var j = O - $;
      return j < 0 || j >= H ? -1 : w[N + j] - 1;
    }
    for (var z = N, M = z + H - 1; z <= M; ) {
      var P = z + M >>> 1, C = w[P];
      if (C < O)
        z = P + 1;
      else if (C > O)
        M = P - 1;
      else
        return w[P + H];
    }
    return -1;
  }
  e.determineBranch = v;
  var S = g(i.default), _ = g(a.default);
  function A(w, D) {
    return D === void 0 && (D = x.Legacy), S(w, D);
  }
  e.decodeHTML = A;
  function k(w) {
    return S(w, x.Attribute);
  }
  e.decodeHTMLAttribute = k;
  function T(w) {
    return S(w, x.Strict);
  }
  e.decodeHTMLStrict = T;
  function L(w) {
    return _(w, x.Strict);
  }
  e.decodeXML = L;
})(c0);
Object.defineProperty(Bu, "__esModule", { value: !0 });
Bu.QuoteType = void 0;
var Zr = c0, ge;
(function(e) {
  e[e.Tab = 9] = "Tab", e[e.NewLine = 10] = "NewLine", e[e.FormFeed = 12] = "FormFeed", e[e.CarriageReturn = 13] = "CarriageReturn", e[e.Space = 32] = "Space", e[e.ExclamationMark = 33] = "ExclamationMark", e[e.Number = 35] = "Number", e[e.Amp = 38] = "Amp", e[e.SingleQuote = 39] = "SingleQuote", e[e.DoubleQuote = 34] = "DoubleQuote", e[e.Dash = 45] = "Dash", e[e.Slash = 47] = "Slash", e[e.Zero = 48] = "Zero", e[e.Nine = 57] = "Nine", e[e.Semi = 59] = "Semi", e[e.Lt = 60] = "Lt", e[e.Eq = 61] = "Eq", e[e.Gt = 62] = "Gt", e[e.Questionmark = 63] = "Questionmark", e[e.UpperA = 65] = "UpperA", e[e.LowerA = 97] = "LowerA", e[e.UpperF = 70] = "UpperF", e[e.LowerF = 102] = "LowerF", e[e.UpperZ = 90] = "UpperZ", e[e.LowerZ = 122] = "LowerZ", e[e.LowerX = 120] = "LowerX", e[e.OpeningSquareBracket = 91] = "OpeningSquareBracket";
})(ge || (ge = {}));
var q;
(function(e) {
  e[e.Text = 1] = "Text", e[e.BeforeTagName = 2] = "BeforeTagName", e[e.InTagName = 3] = "InTagName", e[e.InSelfClosingTag = 4] = "InSelfClosingTag", e[e.BeforeClosingTagName = 5] = "BeforeClosingTagName", e[e.InClosingTagName = 6] = "InClosingTagName", e[e.AfterClosingTagName = 7] = "AfterClosingTagName", e[e.BeforeAttributeName = 8] = "BeforeAttributeName", e[e.InAttributeName = 9] = "InAttributeName", e[e.AfterAttributeName = 10] = "AfterAttributeName", e[e.BeforeAttributeValue = 11] = "BeforeAttributeValue", e[e.InAttributeValueDq = 12] = "InAttributeValueDq", e[e.InAttributeValueSq = 13] = "InAttributeValueSq", e[e.InAttributeValueNq = 14] = "InAttributeValueNq", e[e.BeforeDeclaration = 15] = "BeforeDeclaration", e[e.InDeclaration = 16] = "InDeclaration", e[e.InProcessingInstruction = 17] = "InProcessingInstruction", e[e.BeforeComment = 18] = "BeforeComment", e[e.CDATASequence = 19] = "CDATASequence", e[e.InSpecialComment = 20] = "InSpecialComment", e[e.InCommentLike = 21] = "InCommentLike", e[e.BeforeSpecialS = 22] = "BeforeSpecialS", e[e.BeforeSpecialT = 23] = "BeforeSpecialT", e[e.SpecialStartSequence = 24] = "SpecialStartSequence", e[e.InSpecialTag = 25] = "InSpecialTag", e[e.InEntity = 26] = "InEntity";
})(q || (q = {}));
function jn(e) {
  return e === ge.Space || e === ge.NewLine || e === ge.Tab || e === ge.FormFeed || e === ge.CarriageReturn;
}
function fa(e) {
  return e === ge.Slash || e === ge.Gt || jn(e);
}
function Ik(e) {
  return e >= ge.LowerA && e <= ge.LowerZ || e >= ge.UpperA && e <= ge.UpperZ;
}
var Er;
(function(e) {
  e[e.NoValue = 0] = "NoValue", e[e.Unquoted = 1] = "Unquoted", e[e.Single = 2] = "Single", e[e.Double = 3] = "Double";
})(Er || (Bu.QuoteType = Er = {}));
var At = {
  Cdata: new Uint8Array([67, 68, 65, 84, 65, 91]),
  // CDATA[
  CdataEnd: new Uint8Array([93, 93, 62]),
  // ]]>
  CommentEnd: new Uint8Array([45, 45, 62]),
  // `-->`
  ScriptEnd: new Uint8Array([60, 47, 115, 99, 114, 105, 112, 116]),
  // `<\/script`
  StyleEnd: new Uint8Array([60, 47, 115, 116, 121, 108, 101]),
  // `</style`
  TitleEnd: new Uint8Array([60, 47, 116, 105, 116, 108, 101]),
  // `</title`
  TextareaEnd: new Uint8Array([
    60,
    47,
    116,
    101,
    120,
    116,
    97,
    114,
    101,
    97
  ])
  // `</textarea`
}, Mk = (
  /** @class */
  function() {
    function e(t, n) {
      var r = t.xmlMode, u = r === void 0 ? !1 : r, i = t.decodeEntities, a = i === void 0 ? !0 : i, o = this;
      this.cbs = n, this.state = q.Text, this.buffer = "", this.sectionStart = 0, this.index = 0, this.entityStart = 0, this.baseState = q.Text, this.isSpecial = !1, this.running = !0, this.offset = 0, this.currentSequence = void 0, this.sequenceIndex = 0, this.xmlMode = u, this.decodeEntities = a, this.entityDecoder = new Zr.EntityDecoder(u ? Zr.xmlDecodeTree : Zr.htmlDecodeTree, function(s, c) {
        return o.emitCodePoint(s, c);
      });
    }
    return e.prototype.reset = function() {
      this.state = q.Text, this.buffer = "", this.sectionStart = 0, this.index = 0, this.baseState = q.Text, this.currentSequence = void 0, this.running = !0, this.offset = 0;
    }, e.prototype.write = function(t) {
      this.offset += this.buffer.length, this.buffer = t, this.parse();
    }, e.prototype.end = function() {
      this.running && this.finish();
    }, e.prototype.pause = function() {
      this.running = !1;
    }, e.prototype.resume = function() {
      this.running = !0, this.index < this.buffer.length + this.offset && this.parse();
    }, e.prototype.stateText = function(t) {
      t === ge.Lt || !this.decodeEntities && this.fastForwardTo(ge.Lt) ? (this.index > this.sectionStart && this.cbs.ontext(this.sectionStart, this.index), this.state = q.BeforeTagName, this.sectionStart = this.index) : this.decodeEntities && t === ge.Amp && this.startEntity();
    }, e.prototype.stateSpecialStartSequence = function(t) {
      var n = this.sequenceIndex === this.currentSequence.length, r = n ? (
        // If we are at the end of the sequence, make sure the tag name has ended
        fa(t)
      ) : (
        // Otherwise, do a case-insensitive comparison
        (t | 32) === this.currentSequence[this.sequenceIndex]
      );
      if (!r)
        this.isSpecial = !1;
      else if (!n) {
        this.sequenceIndex++;
        return;
      }
      this.sequenceIndex = 0, this.state = q.InTagName, this.stateInTagName(t);
    }, e.prototype.stateInSpecialTag = function(t) {
      if (this.sequenceIndex === this.currentSequence.length) {
        if (t === ge.Gt || jn(t)) {
          var n = this.index - this.currentSequence.length;
          if (this.sectionStart < n) {
            var r = this.index;
            this.index = n, this.cbs.ontext(this.sectionStart, n), this.index = r;
          }
          this.isSpecial = !1, this.sectionStart = n + 2, this.stateInClosingTagName(t);
          return;
        }
        this.sequenceIndex = 0;
      }
      (t | 32) === this.currentSequence[this.sequenceIndex] ? this.sequenceIndex += 1 : this.sequenceIndex === 0 ? this.currentSequence === At.TitleEnd ? this.decodeEntities && t === ge.Amp && this.startEntity() : this.fastForwardTo(ge.Lt) && (this.sequenceIndex = 1) : this.sequenceIndex = +(t === ge.Lt);
    }, e.prototype.stateCDATASequence = function(t) {
      t === At.Cdata[this.sequenceIndex] ? ++this.sequenceIndex === At.Cdata.length && (this.state = q.InCommentLike, this.currentSequence = At.CdataEnd, this.sequenceIndex = 0, this.sectionStart = this.index + 1) : (this.sequenceIndex = 0, this.state = q.InDeclaration, this.stateInDeclaration(t));
    }, e.prototype.fastForwardTo = function(t) {
      for (; ++this.index < this.buffer.length + this.offset; )
        if (this.buffer.charCodeAt(this.index - this.offset) === t)
          return !0;
      return this.index = this.buffer.length + this.offset - 1, !1;
    }, e.prototype.stateInCommentLike = function(t) {
      t === this.currentSequence[this.sequenceIndex] ? ++this.sequenceIndex === this.currentSequence.length && (this.currentSequence === At.CdataEnd ? this.cbs.oncdata(this.sectionStart, this.index, 2) : this.cbs.oncomment(this.sectionStart, this.index, 2), this.sequenceIndex = 0, this.sectionStart = this.index + 1, this.state = q.Text) : this.sequenceIndex === 0 ? this.fastForwardTo(this.currentSequence[0]) && (this.sequenceIndex = 1) : t !== this.currentSequence[this.sequenceIndex - 1] && (this.sequenceIndex = 0);
    }, e.prototype.isTagStartChar = function(t) {
      return this.xmlMode ? !fa(t) : Ik(t);
    }, e.prototype.startSpecial = function(t, n) {
      this.isSpecial = !0, this.currentSequence = t, this.sequenceIndex = n, this.state = q.SpecialStartSequence;
    }, e.prototype.stateBeforeTagName = function(t) {
      if (t === ge.ExclamationMark)
        this.state = q.BeforeDeclaration, this.sectionStart = this.index + 1;
      else if (t === ge.Questionmark)
        this.state = q.InProcessingInstruction, this.sectionStart = this.index + 1;
      else if (this.isTagStartChar(t)) {
        var n = t | 32;
        this.sectionStart = this.index, this.xmlMode ? this.state = q.InTagName : n === At.ScriptEnd[2] ? this.state = q.BeforeSpecialS : n === At.TitleEnd[2] ? this.state = q.BeforeSpecialT : this.state = q.InTagName;
      } else
        t === ge.Slash ? this.state = q.BeforeClosingTagName : (this.state = q.Text, this.stateText(t));
    }, e.prototype.stateInTagName = function(t) {
      fa(t) && (this.cbs.onopentagname(this.sectionStart, this.index), this.sectionStart = -1, this.state = q.BeforeAttributeName, this.stateBeforeAttributeName(t));
    }, e.prototype.stateBeforeClosingTagName = function(t) {
      jn(t) || (t === ge.Gt ? this.state = q.Text : (this.state = this.isTagStartChar(t) ? q.InClosingTagName : q.InSpecialComment, this.sectionStart = this.index));
    }, e.prototype.stateInClosingTagName = function(t) {
      (t === ge.Gt || jn(t)) && (this.cbs.onclosetag(this.sectionStart, this.index), this.sectionStart = -1, this.state = q.AfterClosingTagName, this.stateAfterClosingTagName(t));
    }, e.prototype.stateAfterClosingTagName = function(t) {
      (t === ge.Gt || this.fastForwardTo(ge.Gt)) && (this.state = q.Text, this.sectionStart = this.index + 1);
    }, e.prototype.stateBeforeAttributeName = function(t) {
      t === ge.Gt ? (this.cbs.onopentagend(this.index), this.isSpecial ? (this.state = q.InSpecialTag, this.sequenceIndex = 0) : this.state = q.Text, this.sectionStart = this.index + 1) : t === ge.Slash ? this.state = q.InSelfClosingTag : jn(t) || (this.state = q.InAttributeName, this.sectionStart = this.index);
    }, e.prototype.stateInSelfClosingTag = function(t) {
      t === ge.Gt ? (this.cbs.onselfclosingtag(this.index), this.state = q.Text, this.sectionStart = this.index + 1, this.isSpecial = !1) : jn(t) || (this.state = q.BeforeAttributeName, this.stateBeforeAttributeName(t));
    }, e.prototype.stateInAttributeName = function(t) {
      (t === ge.Eq || fa(t)) && (this.cbs.onattribname(this.sectionStart, this.index), this.sectionStart = this.index, this.state = q.AfterAttributeName, this.stateAfterAttributeName(t));
    }, e.prototype.stateAfterAttributeName = function(t) {
      t === ge.Eq ? this.state = q.BeforeAttributeValue : t === ge.Slash || t === ge.Gt ? (this.cbs.onattribend(Er.NoValue, this.sectionStart), this.sectionStart = -1, this.state = q.BeforeAttributeName, this.stateBeforeAttributeName(t)) : jn(t) || (this.cbs.onattribend(Er.NoValue, this.sectionStart), this.state = q.InAttributeName, this.sectionStart = this.index);
    }, e.prototype.stateBeforeAttributeValue = function(t) {
      t === ge.DoubleQuote ? (this.state = q.InAttributeValueDq, this.sectionStart = this.index + 1) : t === ge.SingleQuote ? (this.state = q.InAttributeValueSq, this.sectionStart = this.index + 1) : jn(t) || (this.sectionStart = this.index, this.state = q.InAttributeValueNq, this.stateInAttributeValueNoQuotes(t));
    }, e.prototype.handleInAttributeValue = function(t, n) {
      t === n || !this.decodeEntities && this.fastForwardTo(n) ? (this.cbs.onattribdata(this.sectionStart, this.index), this.sectionStart = -1, this.cbs.onattribend(n === ge.DoubleQuote ? Er.Double : Er.Single, this.index + 1), this.state = q.BeforeAttributeName) : this.decodeEntities && t === ge.Amp && this.startEntity();
    }, e.prototype.stateInAttributeValueDoubleQuotes = function(t) {
      this.handleInAttributeValue(t, ge.DoubleQuote);
    }, e.prototype.stateInAttributeValueSingleQuotes = function(t) {
      this.handleInAttributeValue(t, ge.SingleQuote);
    }, e.prototype.stateInAttributeValueNoQuotes = function(t) {
      jn(t) || t === ge.Gt ? (this.cbs.onattribdata(this.sectionStart, this.index), this.sectionStart = -1, this.cbs.onattribend(Er.Unquoted, this.index), this.state = q.BeforeAttributeName, this.stateBeforeAttributeName(t)) : this.decodeEntities && t === ge.Amp && this.startEntity();
    }, e.prototype.stateBeforeDeclaration = function(t) {
      t === ge.OpeningSquareBracket ? (this.state = q.CDATASequence, this.sequenceIndex = 0) : this.state = t === ge.Dash ? q.BeforeComment : q.InDeclaration;
    }, e.prototype.stateInDeclaration = function(t) {
      (t === ge.Gt || this.fastForwardTo(ge.Gt)) && (this.cbs.ondeclaration(this.sectionStart, this.index), this.state = q.Text, this.sectionStart = this.index + 1);
    }, e.prototype.stateInProcessingInstruction = function(t) {
      (t === ge.Gt || this.fastForwardTo(ge.Gt)) && (this.cbs.onprocessinginstruction(this.sectionStart, this.index), this.state = q.Text, this.sectionStart = this.index + 1);
    }, e.prototype.stateBeforeComment = function(t) {
      t === ge.Dash ? (this.state = q.InCommentLike, this.currentSequence = At.CommentEnd, this.sequenceIndex = 2, this.sectionStart = this.index + 1) : this.state = q.InDeclaration;
    }, e.prototype.stateInSpecialComment = function(t) {
      (t === ge.Gt || this.fastForwardTo(ge.Gt)) && (this.cbs.oncomment(this.sectionStart, this.index, 0), this.state = q.Text, this.sectionStart = this.index + 1);
    }, e.prototype.stateBeforeSpecialS = function(t) {
      var n = t | 32;
      n === At.ScriptEnd[3] ? this.startSpecial(At.ScriptEnd, 4) : n === At.StyleEnd[3] ? this.startSpecial(At.StyleEnd, 4) : (this.state = q.InTagName, this.stateInTagName(t));
    }, e.prototype.stateBeforeSpecialT = function(t) {
      var n = t | 32;
      n === At.TitleEnd[3] ? this.startSpecial(At.TitleEnd, 4) : n === At.TextareaEnd[3] ? this.startSpecial(At.TextareaEnd, 4) : (this.state = q.InTagName, this.stateInTagName(t));
    }, e.prototype.startEntity = function() {
      this.baseState = this.state, this.state = q.InEntity, this.entityStart = this.index, this.entityDecoder.startEntity(this.xmlMode ? Zr.DecodingMode.Strict : this.baseState === q.Text || this.baseState === q.InSpecialTag ? Zr.DecodingMode.Legacy : Zr.DecodingMode.Attribute);
    }, e.prototype.stateInEntity = function() {
      var t = this.entityDecoder.write(this.buffer, this.index - this.offset);
      t >= 0 ? (this.state = this.baseState, t === 0 && (this.index = this.entityStart)) : this.index = this.offset + this.buffer.length - 1;
    }, e.prototype.cleanup = function() {
      this.running && this.sectionStart !== this.index && (this.state === q.Text || this.state === q.InSpecialTag && this.sequenceIndex === 0 ? (this.cbs.ontext(this.sectionStart, this.index), this.sectionStart = this.index) : (this.state === q.InAttributeValueDq || this.state === q.InAttributeValueSq || this.state === q.InAttributeValueNq) && (this.cbs.onattribdata(this.sectionStart, this.index), this.sectionStart = this.index));
    }, e.prototype.shouldContinue = function() {
      return this.index < this.buffer.length + this.offset && this.running;
    }, e.prototype.parse = function() {
      for (; this.shouldContinue(); ) {
        var t = this.buffer.charCodeAt(this.index - this.offset);
        switch (this.state) {
          case q.Text: {
            this.stateText(t);
            break;
          }
          case q.SpecialStartSequence: {
            this.stateSpecialStartSequence(t);
            break;
          }
          case q.InSpecialTag: {
            this.stateInSpecialTag(t);
            break;
          }
          case q.CDATASequence: {
            this.stateCDATASequence(t);
            break;
          }
          case q.InAttributeValueDq: {
            this.stateInAttributeValueDoubleQuotes(t);
            break;
          }
          case q.InAttributeName: {
            this.stateInAttributeName(t);
            break;
          }
          case q.InCommentLike: {
            this.stateInCommentLike(t);
            break;
          }
          case q.InSpecialComment: {
            this.stateInSpecialComment(t);
            break;
          }
          case q.BeforeAttributeName: {
            this.stateBeforeAttributeName(t);
            break;
          }
          case q.InTagName: {
            this.stateInTagName(t);
            break;
          }
          case q.InClosingTagName: {
            this.stateInClosingTagName(t);
            break;
          }
          case q.BeforeTagName: {
            this.stateBeforeTagName(t);
            break;
          }
          case q.AfterAttributeName: {
            this.stateAfterAttributeName(t);
            break;
          }
          case q.InAttributeValueSq: {
            this.stateInAttributeValueSingleQuotes(t);
            break;
          }
          case q.BeforeAttributeValue: {
            this.stateBeforeAttributeValue(t);
            break;
          }
          case q.BeforeClosingTagName: {
            this.stateBeforeClosingTagName(t);
            break;
          }
          case q.AfterClosingTagName: {
            this.stateAfterClosingTagName(t);
            break;
          }
          case q.BeforeSpecialS: {
            this.stateBeforeSpecialS(t);
            break;
          }
          case q.BeforeSpecialT: {
            this.stateBeforeSpecialT(t);
            break;
          }
          case q.InAttributeValueNq: {
            this.stateInAttributeValueNoQuotes(t);
            break;
          }
          case q.InSelfClosingTag: {
            this.stateInSelfClosingTag(t);
            break;
          }
          case q.InDeclaration: {
            this.stateInDeclaration(t);
            break;
          }
          case q.BeforeDeclaration: {
            this.stateBeforeDeclaration(t);
            break;
          }
          case q.BeforeComment: {
            this.stateBeforeComment(t);
            break;
          }
          case q.InProcessingInstruction: {
            this.stateInProcessingInstruction(t);
            break;
          }
          case q.InEntity: {
            this.stateInEntity();
            break;
          }
        }
        this.index++;
      }
      this.cleanup();
    }, e.prototype.finish = function() {
      this.state === q.InEntity && (this.entityDecoder.end(), this.state = this.baseState), this.handleTrailingData(), this.cbs.onend();
    }, e.prototype.handleTrailingData = function() {
      var t = this.buffer.length + this.offset;
      this.sectionStart >= t || (this.state === q.InCommentLike ? this.currentSequence === At.CdataEnd ? this.cbs.oncdata(this.sectionStart, t, 0) : this.cbs.oncomment(this.sectionStart, t, 0) : this.state === q.InTagName || this.state === q.BeforeAttributeName || this.state === q.BeforeAttributeValue || this.state === q.AfterAttributeName || this.state === q.InAttributeName || this.state === q.InAttributeValueSq || this.state === q.InAttributeValueDq || this.state === q.InAttributeValueNq || this.state === q.InClosingTagName || this.cbs.ontext(this.sectionStart, t));
    }, e.prototype.emitCodePoint = function(t, n) {
      this.baseState !== q.Text && this.baseState !== q.InSpecialTag ? (this.sectionStart < this.entityStart && this.cbs.onattribdata(this.sectionStart, this.entityStart), this.sectionStart = this.entityStart + n, this.index = this.sectionStart - 1, this.cbs.onattribentity(t)) : (this.sectionStart < this.entityStart && this.cbs.ontext(this.sectionStart, this.entityStart), this.sectionStart = this.entityStart + n, this.index = this.sectionStart - 1, this.cbs.ontextentity(t, this.sectionStart));
    }, e;
  }()
);
Bu.default = Mk;
var Pk = ee && ee.__createBinding || (Object.create ? function(e, t, n, r) {
  r === void 0 && (r = n);
  var u = Object.getOwnPropertyDescriptor(t, n);
  (!u || ("get" in u ? !t.__esModule : u.writable || u.configurable)) && (u = { enumerable: !0, get: function() {
    return t[n];
  } }), Object.defineProperty(e, r, u);
} : function(e, t, n, r) {
  r === void 0 && (r = n), e[r] = t[n];
}), Rk = ee && ee.__setModuleDefault || (Object.create ? function(e, t) {
  Object.defineProperty(e, "default", { enumerable: !0, value: t });
} : function(e, t) {
  e.default = t;
}), Bk = ee && ee.__importStar || function(e) {
  if (e && e.__esModule)
    return e;
  var t = {};
  if (e != null)
    for (var n in e)
      n !== "default" && Object.prototype.hasOwnProperty.call(e, n) && Pk(t, e, n);
  return Rk(t, e), t;
};
Object.defineProperty(Li, "__esModule", { value: !0 });
Li.Parser = void 0;
var pa = Bk(Bu), lp = c0, Xr = /* @__PURE__ */ new Set([
  "input",
  "option",
  "optgroup",
  "select",
  "button",
  "datalist",
  "textarea"
]), Ue = /* @__PURE__ */ new Set(["p"]), dp = /* @__PURE__ */ new Set(["thead", "tbody"]), fp = /* @__PURE__ */ new Set(["dd", "dt"]), pp = /* @__PURE__ */ new Set(["rt", "rp"]), Fk = /* @__PURE__ */ new Map([
  ["tr", /* @__PURE__ */ new Set(["tr", "th", "td"])],
  ["th", /* @__PURE__ */ new Set(["th"])],
  ["td", /* @__PURE__ */ new Set(["thead", "th", "td"])],
  ["body", /* @__PURE__ */ new Set(["head", "link", "script"])],
  ["li", /* @__PURE__ */ new Set(["li"])],
  ["p", Ue],
  ["h1", Ue],
  ["h2", Ue],
  ["h3", Ue],
  ["h4", Ue],
  ["h5", Ue],
  ["h6", Ue],
  ["select", Xr],
  ["input", Xr],
  ["output", Xr],
  ["button", Xr],
  ["datalist", Xr],
  ["textarea", Xr],
  ["option", /* @__PURE__ */ new Set(["option"])],
  ["optgroup", /* @__PURE__ */ new Set(["optgroup", "option"])],
  ["dd", fp],
  ["dt", fp],
  ["address", Ue],
  ["article", Ue],
  ["aside", Ue],
  ["blockquote", Ue],
  ["details", Ue],
  ["div", Ue],
  ["dl", Ue],
  ["fieldset", Ue],
  ["figcaption", Ue],
  ["figure", Ue],
  ["footer", Ue],
  ["form", Ue],
  ["header", Ue],
  ["hr", Ue],
  ["main", Ue],
  ["nav", Ue],
  ["ol", Ue],
  ["pre", Ue],
  ["section", Ue],
  ["table", Ue],
  ["ul", Ue],
  ["rt", pp],
  ["rp", pp],
  ["tbody", dp],
  ["tfoot", dp]
]), Hk = /* @__PURE__ */ new Set([
  "area",
  "base",
  "basefont",
  "br",
  "col",
  "command",
  "embed",
  "frame",
  "hr",
  "img",
  "input",
  "isindex",
  "keygen",
  "link",
  "meta",
  "param",
  "source",
  "track",
  "wbr"
]), hp = /* @__PURE__ */ new Set(["math", "svg"]), mp = /* @__PURE__ */ new Set([
  "mi",
  "mo",
  "mn",
  "ms",
  "mtext",
  "annotation-xml",
  "foreignobject",
  "desc",
  "title"
]), $k = /\s|\//, Vk = (
  /** @class */
  function() {
    function e(t, n) {
      n === void 0 && (n = {});
      var r, u, i, a, o, s;
      this.options = n, this.startIndex = 0, this.endIndex = 0, this.openTagStart = 0, this.tagname = "", this.attribname = "", this.attribvalue = "", this.attribs = null, this.stack = [], this.buffers = [], this.bufferOffset = 0, this.writeIndex = 0, this.ended = !1, this.cbs = t ?? {}, this.htmlMode = !this.options.xmlMode, this.lowerCaseTagNames = (r = n.lowerCaseTags) !== null && r !== void 0 ? r : this.htmlMode, this.lowerCaseAttributeNames = (u = n.lowerCaseAttributeNames) !== null && u !== void 0 ? u : this.htmlMode, this.recognizeSelfClosing = (i = n.recognizeSelfClosing) !== null && i !== void 0 ? i : !this.htmlMode, this.tokenizer = new ((a = n.Tokenizer) !== null && a !== void 0 ? a : pa.default)(this.options, this), this.foreignContext = [!this.htmlMode], (s = (o = this.cbs).onparserinit) === null || s === void 0 || s.call(o, this);
    }
    return e.prototype.ontext = function(t, n) {
      var r, u, i = this.getSlice(t, n);
      this.endIndex = n - 1, (u = (r = this.cbs).ontext) === null || u === void 0 || u.call(r, i), this.startIndex = n;
    }, e.prototype.ontextentity = function(t, n) {
      var r, u;
      this.endIndex = n - 1, (u = (r = this.cbs).ontext) === null || u === void 0 || u.call(r, (0, lp.fromCodePoint)(t)), this.startIndex = n;
    }, e.prototype.isVoidElement = function(t) {
      return this.htmlMode && Hk.has(t);
    }, e.prototype.onopentagname = function(t, n) {
      this.endIndex = n;
      var r = this.getSlice(t, n);
      this.lowerCaseTagNames && (r = r.toLowerCase()), this.emitOpenTag(r);
    }, e.prototype.emitOpenTag = function(t) {
      var n, r, u, i;
      this.openTagStart = this.startIndex, this.tagname = t;
      var a = this.htmlMode && Fk.get(t);
      if (a)
        for (; this.stack.length > 0 && a.has(this.stack[0]); ) {
          var o = this.stack.shift();
          (r = (n = this.cbs).onclosetag) === null || r === void 0 || r.call(n, o, !0);
        }
      this.isVoidElement(t) || (this.stack.unshift(t), this.htmlMode && (hp.has(t) ? this.foreignContext.unshift(!0) : mp.has(t) && this.foreignContext.unshift(!1))), (i = (u = this.cbs).onopentagname) === null || i === void 0 || i.call(u, t), this.cbs.onopentag && (this.attribs = {});
    }, e.prototype.endOpenTag = function(t) {
      var n, r;
      this.startIndex = this.openTagStart, this.attribs && ((r = (n = this.cbs).onopentag) === null || r === void 0 || r.call(n, this.tagname, this.attribs, t), this.attribs = null), this.cbs.onclosetag && this.isVoidElement(this.tagname) && this.cbs.onclosetag(this.tagname, !0), this.tagname = "";
    }, e.prototype.onopentagend = function(t) {
      this.endIndex = t, this.endOpenTag(!1), this.startIndex = t + 1;
    }, e.prototype.onclosetag = function(t, n) {
      var r, u, i, a, o, s, c, l;
      this.endIndex = n;
      var d = this.getSlice(t, n);
      if (this.lowerCaseTagNames && (d = d.toLowerCase()), this.htmlMode && (hp.has(d) || mp.has(d)) && this.foreignContext.shift(), this.isVoidElement(d))
        this.htmlMode && d === "br" && ((a = (i = this.cbs).onopentagname) === null || a === void 0 || a.call(i, "br"), (s = (o = this.cbs).onopentag) === null || s === void 0 || s.call(o, "br", {}, !0), (l = (c = this.cbs).onclosetag) === null || l === void 0 || l.call(c, "br", !1));
      else {
        var f = this.stack.indexOf(d);
        if (f !== -1)
          for (var p = 0; p <= f; p++) {
            var h = this.stack.shift();
            (u = (r = this.cbs).onclosetag) === null || u === void 0 || u.call(r, h, p !== f);
          }
        else
          this.htmlMode && d === "p" && (this.emitOpenTag("p"), this.closeCurrentTag(!0));
      }
      this.startIndex = n + 1;
    }, e.prototype.onselfclosingtag = function(t) {
      this.endIndex = t, this.recognizeSelfClosing || this.foreignContext[0] ? (this.closeCurrentTag(!1), this.startIndex = t + 1) : this.onopentagend(t);
    }, e.prototype.closeCurrentTag = function(t) {
      var n, r, u = this.tagname;
      this.endOpenTag(t), this.stack[0] === u && ((r = (n = this.cbs).onclosetag) === null || r === void 0 || r.call(n, u, !t), this.stack.shift());
    }, e.prototype.onattribname = function(t, n) {
      this.startIndex = t;
      var r = this.getSlice(t, n);
      this.attribname = this.lowerCaseAttributeNames ? r.toLowerCase() : r;
    }, e.prototype.onattribdata = function(t, n) {
      this.attribvalue += this.getSlice(t, n);
    }, e.prototype.onattribentity = function(t) {
      this.attribvalue += (0, lp.fromCodePoint)(t);
    }, e.prototype.onattribend = function(t, n) {
      var r, u;
      this.endIndex = n, (u = (r = this.cbs).onattribute) === null || u === void 0 || u.call(r, this.attribname, this.attribvalue, t === pa.QuoteType.Double ? '"' : t === pa.QuoteType.Single ? "'" : t === pa.QuoteType.NoValue ? void 0 : null), this.attribs && !Object.prototype.hasOwnProperty.call(this.attribs, this.attribname) && (this.attribs[this.attribname] = this.attribvalue), this.attribvalue = "";
    }, e.prototype.getInstructionName = function(t) {
      var n = t.search($k), r = n < 0 ? t : t.substr(0, n);
      return this.lowerCaseTagNames && (r = r.toLowerCase()), r;
    }, e.prototype.ondeclaration = function(t, n) {
      this.endIndex = n;
      var r = this.getSlice(t, n);
      if (this.cbs.onprocessinginstruction) {
        var u = this.getInstructionName(r);
        this.cbs.onprocessinginstruction("!".concat(u), "!".concat(r));
      }
      this.startIndex = n + 1;
    }, e.prototype.onprocessinginstruction = function(t, n) {
      this.endIndex = n;
      var r = this.getSlice(t, n);
      if (this.cbs.onprocessinginstruction) {
        var u = this.getInstructionName(r);
        this.cbs.onprocessinginstruction("?".concat(u), "?".concat(r));
      }
      this.startIndex = n + 1;
    }, e.prototype.oncomment = function(t, n, r) {
      var u, i, a, o;
      this.endIndex = n, (i = (u = this.cbs).oncomment) === null || i === void 0 || i.call(u, this.getSlice(t, n - r)), (o = (a = this.cbs).oncommentend) === null || o === void 0 || o.call(a), this.startIndex = n + 1;
    }, e.prototype.oncdata = function(t, n, r) {
      var u, i, a, o, s, c, l, d, f, p;
      this.endIndex = n;
      var h = this.getSlice(t, n - r);
      !this.htmlMode || this.options.recognizeCDATA ? ((i = (u = this.cbs).oncdatastart) === null || i === void 0 || i.call(u), (o = (a = this.cbs).ontext) === null || o === void 0 || o.call(a, h), (c = (s = this.cbs).oncdataend) === null || c === void 0 || c.call(s)) : ((d = (l = this.cbs).oncomment) === null || d === void 0 || d.call(l, "[CDATA[".concat(h, "]]")), (p = (f = this.cbs).oncommentend) === null || p === void 0 || p.call(f)), this.startIndex = n + 1;
    }, e.prototype.onend = function() {
      var t, n;
      if (this.cbs.onclosetag) {
        this.endIndex = this.startIndex;
        for (var r = 0; r < this.stack.length; r++)
          this.cbs.onclosetag(this.stack[r], !0);
      }
      (n = (t = this.cbs).onend) === null || n === void 0 || n.call(t);
    }, e.prototype.reset = function() {
      var t, n, r, u;
      (n = (t = this.cbs).onreset) === null || n === void 0 || n.call(t), this.tokenizer.reset(), this.tagname = "", this.attribname = "", this.attribs = null, this.stack.length = 0, this.startIndex = 0, this.endIndex = 0, (u = (r = this.cbs).onparserinit) === null || u === void 0 || u.call(r, this), this.buffers.length = 0, this.foreignContext.length = 0, this.foreignContext.unshift(!this.htmlMode), this.bufferOffset = 0, this.writeIndex = 0, this.ended = !1;
    }, e.prototype.parseComplete = function(t) {
      this.reset(), this.end(t);
    }, e.prototype.getSlice = function(t, n) {
      for (; t - this.bufferOffset >= this.buffers[0].length; )
        this.shiftBuffer();
      for (var r = this.buffers[0].slice(t - this.bufferOffset, n - this.bufferOffset); n - this.bufferOffset > this.buffers[0].length; )
        this.shiftBuffer(), r += this.buffers[0].slice(0, n - this.bufferOffset);
      return r;
    }, e.prototype.shiftBuffer = function() {
      this.bufferOffset += this.buffers[0].length, this.writeIndex--, this.buffers.shift();
    }, e.prototype.write = function(t) {
      var n, r;
      if (this.ended) {
        (r = (n = this.cbs).onerror) === null || r === void 0 || r.call(n, new Error(".write() after done!"));
        return;
      }
      this.buffers.push(t), this.tokenizer.running && (this.tokenizer.write(t), this.writeIndex++);
    }, e.prototype.end = function(t) {
      var n, r;
      if (this.ended) {
        (r = (n = this.cbs).onerror) === null || r === void 0 || r.call(n, new Error(".end() after done!"));
        return;
      }
      t && this.write(t), this.ended = !0, this.tokenizer.end();
    }, e.prototype.pause = function() {
      this.tokenizer.pause();
    }, e.prototype.resume = function() {
      for (this.tokenizer.resume(); this.tokenizer.running && this.writeIndex < this.buffers.length; )
        this.tokenizer.write(this.buffers[this.writeIndex++]);
      this.ended && this.tokenizer.end();
    }, e.prototype.parseChunk = function(t) {
      this.write(t);
    }, e.prototype.done = function(t) {
      this.end(t);
    }, e;
  }()
);
Li.Parser = Vk;
var Kn = {}, mr = {};
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.Doctype = e.CDATA = e.Tag = e.Style = e.Script = e.Comment = e.Directive = e.Text = e.Root = e.isTag = e.ElementType = void 0;
  var t;
  (function(r) {
    r.Root = "root", r.Text = "text", r.Directive = "directive", r.Comment = "comment", r.Script = "script", r.Style = "style", r.Tag = "tag", r.CDATA = "cdata", r.Doctype = "doctype";
  })(t = e.ElementType || (e.ElementType = {}));
  function n(r) {
    return r.type === t.Tag || r.type === t.Script || r.type === t.Style;
  }
  e.isTag = n, e.Root = t.Root, e.Text = t.Text, e.Directive = t.Directive, e.Comment = t.Comment, e.Script = t.Script, e.Style = t.Style, e.Tag = t.Tag, e.CDATA = t.CDATA, e.Doctype = t.Doctype;
})(mr);
var De = {}, gr = ee && ee.__extends || function() {
  var e = function(t, n) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, u) {
      r.__proto__ = u;
    } || function(r, u) {
      for (var i in u)
        Object.prototype.hasOwnProperty.call(u, i) && (r[i] = u[i]);
    }, e(t, n);
  };
  return function(t, n) {
    if (typeof n != "function" && n !== null)
      throw new TypeError("Class extends value " + String(n) + " is not a constructor or null");
    e(t, n);
    function r() {
      this.constructor = t;
    }
    t.prototype = n === null ? Object.create(n) : (r.prototype = n.prototype, new r());
  };
}(), fi = ee && ee.__assign || function() {
  return fi = Object.assign || function(e) {
    for (var t, n = 1, r = arguments.length; n < r; n++) {
      t = arguments[n];
      for (var u in t)
        Object.prototype.hasOwnProperty.call(t, u) && (e[u] = t[u]);
    }
    return e;
  }, fi.apply(this, arguments);
};
Object.defineProperty(De, "__esModule", { value: !0 });
De.cloneNode = De.hasChildren = De.isDocument = De.isDirective = De.isComment = De.isText = De.isCDATA = De.isTag = De.Element = De.Document = De.CDATA = De.NodeWithChildren = De.ProcessingInstruction = De.Comment = De.Text = De.DataNode = De.Node = void 0;
var Jt = mr, f0 = (
  /** @class */
  function() {
    function e() {
      this.parent = null, this.prev = null, this.next = null, this.startIndex = null, this.endIndex = null;
    }
    return Object.defineProperty(e.prototype, "parentNode", {
      // Read-write aliases for properties
      /**
       * Same as {@link parent}.
       * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
       */
      get: function() {
        return this.parent;
      },
      set: function(t) {
        this.parent = t;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "previousSibling", {
      /**
       * Same as {@link prev}.
       * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
       */
      get: function() {
        return this.prev;
      },
      set: function(t) {
        this.prev = t;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "nextSibling", {
      /**
       * Same as {@link next}.
       * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
       */
      get: function() {
        return this.next;
      },
      set: function(t) {
        this.next = t;
      },
      enumerable: !1,
      configurable: !0
    }), e.prototype.cloneNode = function(t) {
      return t === void 0 && (t = !1), p0(this, t);
    }, e;
  }()
);
De.Node = f0;
var Mo = (
  /** @class */
  function(e) {
    gr(t, e);
    function t(n) {
      var r = e.call(this) || this;
      return r.data = n, r;
    }
    return Object.defineProperty(t.prototype, "nodeValue", {
      /**
       * Same as {@link data}.
       * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
       */
      get: function() {
        return this.data;
      },
      set: function(n) {
        this.data = n;
      },
      enumerable: !1,
      configurable: !0
    }), t;
  }(f0)
);
De.DataNode = Mo;
var ny = (
  /** @class */
  function(e) {
    gr(t, e);
    function t() {
      var n = e !== null && e.apply(this, arguments) || this;
      return n.type = Jt.ElementType.Text, n;
    }
    return Object.defineProperty(t.prototype, "nodeType", {
      get: function() {
        return 3;
      },
      enumerable: !1,
      configurable: !0
    }), t;
  }(Mo)
);
De.Text = ny;
var ry = (
  /** @class */
  function(e) {
    gr(t, e);
    function t() {
      var n = e !== null && e.apply(this, arguments) || this;
      return n.type = Jt.ElementType.Comment, n;
    }
    return Object.defineProperty(t.prototype, "nodeType", {
      get: function() {
        return 8;
      },
      enumerable: !1,
      configurable: !0
    }), t;
  }(Mo)
);
De.Comment = ry;
var uy = (
  /** @class */
  function(e) {
    gr(t, e);
    function t(n, r) {
      var u = e.call(this, r) || this;
      return u.name = n, u.type = Jt.ElementType.Directive, u;
    }
    return Object.defineProperty(t.prototype, "nodeType", {
      get: function() {
        return 1;
      },
      enumerable: !1,
      configurable: !0
    }), t;
  }(Mo)
);
De.ProcessingInstruction = uy;
var Po = (
  /** @class */
  function(e) {
    gr(t, e);
    function t(n) {
      var r = e.call(this) || this;
      return r.children = n, r;
    }
    return Object.defineProperty(t.prototype, "firstChild", {
      // Aliases
      /** First child of the node. */
      get: function() {
        var n;
        return (n = this.children[0]) !== null && n !== void 0 ? n : null;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(t.prototype, "lastChild", {
      /** Last child of the node. */
      get: function() {
        return this.children.length > 0 ? this.children[this.children.length - 1] : null;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(t.prototype, "childNodes", {
      /**
       * Same as {@link children}.
       * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
       */
      get: function() {
        return this.children;
      },
      set: function(n) {
        this.children = n;
      },
      enumerable: !1,
      configurable: !0
    }), t;
  }(f0)
);
De.NodeWithChildren = Po;
var iy = (
  /** @class */
  function(e) {
    gr(t, e);
    function t() {
      var n = e !== null && e.apply(this, arguments) || this;
      return n.type = Jt.ElementType.CDATA, n;
    }
    return Object.defineProperty(t.prototype, "nodeType", {
      get: function() {
        return 4;
      },
      enumerable: !1,
      configurable: !0
    }), t;
  }(Po)
);
De.CDATA = iy;
var ay = (
  /** @class */
  function(e) {
    gr(t, e);
    function t() {
      var n = e !== null && e.apply(this, arguments) || this;
      return n.type = Jt.ElementType.Root, n;
    }
    return Object.defineProperty(t.prototype, "nodeType", {
      get: function() {
        return 9;
      },
      enumerable: !1,
      configurable: !0
    }), t;
  }(Po)
);
De.Document = ay;
var oy = (
  /** @class */
  function(e) {
    gr(t, e);
    function t(n, r, u, i) {
      u === void 0 && (u = []), i === void 0 && (i = n === "script" ? Jt.ElementType.Script : n === "style" ? Jt.ElementType.Style : Jt.ElementType.Tag);
      var a = e.call(this, u) || this;
      return a.name = n, a.attribs = r, a.type = i, a;
    }
    return Object.defineProperty(t.prototype, "nodeType", {
      get: function() {
        return 1;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(t.prototype, "tagName", {
      // DOM Level 1 aliases
      /**
       * Same as {@link name}.
       * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
       */
      get: function() {
        return this.name;
      },
      set: function(n) {
        this.name = n;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(t.prototype, "attributes", {
      get: function() {
        var n = this;
        return Object.keys(this.attribs).map(function(r) {
          var u, i;
          return {
            name: r,
            value: n.attribs[r],
            namespace: (u = n["x-attribsNamespace"]) === null || u === void 0 ? void 0 : u[r],
            prefix: (i = n["x-attribsPrefix"]) === null || i === void 0 ? void 0 : i[r]
          };
        });
      },
      enumerable: !1,
      configurable: !0
    }), t;
  }(Po)
);
De.Element = oy;
function sy(e) {
  return (0, Jt.isTag)(e);
}
De.isTag = sy;
function cy(e) {
  return e.type === Jt.ElementType.CDATA;
}
De.isCDATA = cy;
function ly(e) {
  return e.type === Jt.ElementType.Text;
}
De.isText = ly;
function dy(e) {
  return e.type === Jt.ElementType.Comment;
}
De.isComment = dy;
function fy(e) {
  return e.type === Jt.ElementType.Directive;
}
De.isDirective = fy;
function py(e) {
  return e.type === Jt.ElementType.Root;
}
De.isDocument = py;
function jk(e) {
  return Object.prototype.hasOwnProperty.call(e, "children");
}
De.hasChildren = jk;
function p0(e, t) {
  t === void 0 && (t = !1);
  var n;
  if (ly(e))
    n = new ny(e.data);
  else if (dy(e))
    n = new ry(e.data);
  else if (sy(e)) {
    var r = t ? js(e.children) : [], u = new oy(e.name, fi({}, e.attribs), r);
    r.forEach(function(s) {
      return s.parent = u;
    }), e.namespace != null && (u.namespace = e.namespace), e["x-attribsNamespace"] && (u["x-attribsNamespace"] = fi({}, e["x-attribsNamespace"])), e["x-attribsPrefix"] && (u["x-attribsPrefix"] = fi({}, e["x-attribsPrefix"])), n = u;
  } else if (cy(e)) {
    var r = t ? js(e.children) : [], i = new iy(r);
    r.forEach(function(c) {
      return c.parent = i;
    }), n = i;
  } else if (py(e)) {
    var r = t ? js(e.children) : [], a = new ay(r);
    r.forEach(function(c) {
      return c.parent = a;
    }), e["x-mode"] && (a["x-mode"] = e["x-mode"]), n = a;
  } else if (fy(e)) {
    var o = new uy(e.name, e.data);
    e["x-name"] != null && (o["x-name"] = e["x-name"], o["x-publicId"] = e["x-publicId"], o["x-systemId"] = e["x-systemId"]), n = o;
  } else
    throw new Error("Not implemented yet: ".concat(e.type));
  return n.startIndex = e.startIndex, n.endIndex = e.endIndex, e.sourceCodeLocation != null && (n.sourceCodeLocation = e.sourceCodeLocation), n;
}
De.cloneNode = p0;
function js(e) {
  for (var t = e.map(function(r) {
    return p0(r, !0);
  }), n = 1; n < t.length; n++)
    t[n].prev = t[n - 1], t[n - 1].next = t[n];
  return t;
}
(function(e) {
  var t = ee && ee.__createBinding || (Object.create ? function(o, s, c, l) {
    l === void 0 && (l = c);
    var d = Object.getOwnPropertyDescriptor(s, c);
    (!d || ("get" in d ? !s.__esModule : d.writable || d.configurable)) && (d = { enumerable: !0, get: function() {
      return s[c];
    } }), Object.defineProperty(o, l, d);
  } : function(o, s, c, l) {
    l === void 0 && (l = c), o[l] = s[c];
  }), n = ee && ee.__exportStar || function(o, s) {
    for (var c in o)
      c !== "default" && !Object.prototype.hasOwnProperty.call(s, c) && t(s, o, c);
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.DomHandler = void 0;
  var r = mr, u = De;
  n(De, e);
  var i = {
    withStartIndices: !1,
    withEndIndices: !1,
    xmlMode: !1
  }, a = (
    /** @class */
    function() {
      function o(s, c, l) {
        this.dom = [], this.root = new u.Document(this.dom), this.done = !1, this.tagStack = [this.root], this.lastNode = null, this.parser = null, typeof c == "function" && (l = c, c = i), typeof s == "object" && (c = s, s = void 0), this.callback = s ?? null, this.options = c ?? i, this.elementCB = l ?? null;
      }
      return o.prototype.onparserinit = function(s) {
        this.parser = s;
      }, o.prototype.onreset = function() {
        this.dom = [], this.root = new u.Document(this.dom), this.done = !1, this.tagStack = [this.root], this.lastNode = null, this.parser = null;
      }, o.prototype.onend = function() {
        this.done || (this.done = !0, this.parser = null, this.handleCallback(null));
      }, o.prototype.onerror = function(s) {
        this.handleCallback(s);
      }, o.prototype.onclosetag = function() {
        this.lastNode = null;
        var s = this.tagStack.pop();
        this.options.withEndIndices && (s.endIndex = this.parser.endIndex), this.elementCB && this.elementCB(s);
      }, o.prototype.onopentag = function(s, c) {
        var l = this.options.xmlMode ? r.ElementType.Tag : void 0, d = new u.Element(s, c, void 0, l);
        this.addNode(d), this.tagStack.push(d);
      }, o.prototype.ontext = function(s) {
        var c = this.lastNode;
        if (c && c.type === r.ElementType.Text)
          c.data += s, this.options.withEndIndices && (c.endIndex = this.parser.endIndex);
        else {
          var l = new u.Text(s);
          this.addNode(l), this.lastNode = l;
        }
      }, o.prototype.oncomment = function(s) {
        if (this.lastNode && this.lastNode.type === r.ElementType.Comment) {
          this.lastNode.data += s;
          return;
        }
        var c = new u.Comment(s);
        this.addNode(c), this.lastNode = c;
      }, o.prototype.oncommentend = function() {
        this.lastNode = null;
      }, o.prototype.oncdatastart = function() {
        var s = new u.Text(""), c = new u.CDATA([s]);
        this.addNode(c), s.parent = c, this.lastNode = s;
      }, o.prototype.oncdataend = function() {
        this.lastNode = null;
      }, o.prototype.onprocessinginstruction = function(s, c) {
        var l = new u.ProcessingInstruction(s, c);
        this.addNode(l);
      }, o.prototype.handleCallback = function(s) {
        if (typeof this.callback == "function")
          this.callback(s, this.dom);
        else if (s)
          throw s;
      }, o.prototype.addNode = function(s) {
        var c = this.tagStack[this.tagStack.length - 1], l = c.children[c.children.length - 1];
        this.options.withStartIndices && (s.startIndex = this.parser.startIndex), this.options.withEndIndices && (s.endIndex = this.parser.endIndex), c.children.push(s), l && (s.prev = l, l.next = s), s.parent = c, this.lastNode = null;
      }, o;
    }()
  );
  e.DomHandler = a, e.default = a;
})(Kn);
var ka = {}, rn = {}, Yi = {};
const zk = /* @__PURE__ */ fC(K9);
var Du = {};
Object.defineProperty(Du, "__esModule", { value: !0 });
Du.attributeNames = Du.elementNames = void 0;
Du.elementNames = new Map([
  "altGlyph",
  "altGlyphDef",
  "altGlyphItem",
  "animateColor",
  "animateMotion",
  "animateTransform",
  "clipPath",
  "feBlend",
  "feColorMatrix",
  "feComponentTransfer",
  "feComposite",
  "feConvolveMatrix",
  "feDiffuseLighting",
  "feDisplacementMap",
  "feDistantLight",
  "feDropShadow",
  "feFlood",
  "feFuncA",
  "feFuncB",
  "feFuncG",
  "feFuncR",
  "feGaussianBlur",
  "feImage",
  "feMerge",
  "feMergeNode",
  "feMorphology",
  "feOffset",
  "fePointLight",
  "feSpecularLighting",
  "feSpotLight",
  "feTile",
  "feTurbulence",
  "foreignObject",
  "glyphRef",
  "linearGradient",
  "radialGradient",
  "textPath"
].map(function(e) {
  return [e.toLowerCase(), e];
}));
Du.attributeNames = new Map([
  "definitionURL",
  "attributeName",
  "attributeType",
  "baseFrequency",
  "baseProfile",
  "calcMode",
  "clipPathUnits",
  "diffuseConstant",
  "edgeMode",
  "filterUnits",
  "glyphRef",
  "gradientTransform",
  "gradientUnits",
  "kernelMatrix",
  "kernelUnitLength",
  "keyPoints",
  "keySplines",
  "keyTimes",
  "lengthAdjust",
  "limitingConeAngle",
  "markerHeight",
  "markerUnits",
  "markerWidth",
  "maskContentUnits",
  "maskUnits",
  "numOctaves",
  "pathLength",
  "patternContentUnits",
  "patternTransform",
  "patternUnits",
  "pointsAtX",
  "pointsAtY",
  "pointsAtZ",
  "preserveAlpha",
  "preserveAspectRatio",
  "primitiveUnits",
  "refX",
  "refY",
  "repeatCount",
  "repeatDur",
  "requiredExtensions",
  "requiredFeatures",
  "specularConstant",
  "specularExponent",
  "spreadMethod",
  "startOffset",
  "stdDeviation",
  "stitchTiles",
  "surfaceScale",
  "systemLanguage",
  "tableValues",
  "targetX",
  "targetY",
  "textLength",
  "viewBox",
  "viewTarget",
  "xChannelSelector",
  "yChannelSelector",
  "zoomAndPan"
].map(function(e) {
  return [e.toLowerCase(), e];
}));
var fu = ee && ee.__assign || function() {
  return fu = Object.assign || function(e) {
    for (var t, n = 1, r = arguments.length; n < r; n++) {
      t = arguments[n];
      for (var u in t)
        Object.prototype.hasOwnProperty.call(t, u) && (e[u] = t[u]);
    }
    return e;
  }, fu.apply(this, arguments);
}, Uk = ee && ee.__createBinding || (Object.create ? function(e, t, n, r) {
  r === void 0 && (r = n);
  var u = Object.getOwnPropertyDescriptor(t, n);
  (!u || ("get" in u ? !t.__esModule : u.writable || u.configurable)) && (u = { enumerable: !0, get: function() {
    return t[n];
  } }), Object.defineProperty(e, r, u);
} : function(e, t, n, r) {
  r === void 0 && (r = n), e[r] = t[n];
}), qk = ee && ee.__setModuleDefault || (Object.create ? function(e, t) {
  Object.defineProperty(e, "default", { enumerable: !0, value: t });
} : function(e, t) {
  e.default = t;
}), Gk = ee && ee.__importStar || function(e) {
  if (e && e.__esModule)
    return e;
  var t = {};
  if (e != null)
    for (var n in e)
      n !== "default" && Object.prototype.hasOwnProperty.call(e, n) && Uk(t, e, n);
  return qk(t, e), t;
};
Object.defineProperty(Yi, "__esModule", { value: !0 });
Yi.render = void 0;
var Hn = Gk(mr), Za = zk, hy = Du, Wk = /* @__PURE__ */ new Set([
  "style",
  "script",
  "xmp",
  "iframe",
  "noembed",
  "noframes",
  "plaintext",
  "noscript"
]);
function Kk(e) {
  return e.replace(/"/g, "&quot;");
}
function Yk(e, t) {
  var n;
  if (e) {
    var r = ((n = t.encodeEntities) !== null && n !== void 0 ? n : t.decodeEntities) === !1 ? Kk : t.xmlMode || t.encodeEntities !== "utf8" ? Za.encodeXML : Za.escapeAttribute;
    return Object.keys(e).map(function(u) {
      var i, a, o = (i = e[u]) !== null && i !== void 0 ? i : "";
      return t.xmlMode === "foreign" && (u = (a = hy.attributeNames.get(u)) !== null && a !== void 0 ? a : u), !t.emptyAttrs && !t.xmlMode && o === "" ? u : "".concat(u, '="').concat(r(o), '"');
    }).join(" ");
  }
}
var gp = /* @__PURE__ */ new Set([
  "area",
  "base",
  "basefont",
  "br",
  "col",
  "command",
  "embed",
  "frame",
  "hr",
  "img",
  "input",
  "isindex",
  "keygen",
  "link",
  "meta",
  "param",
  "source",
  "track",
  "wbr"
]);
function Ro(e, t) {
  t === void 0 && (t = {});
  for (var n = ("length" in e) ? e : [e], r = "", u = 0; u < n.length; u++)
    r += Zk(n[u], t);
  return r;
}
Yi.render = Ro;
Yi.default = Ro;
function Zk(e, t) {
  switch (e.type) {
    case Hn.Root:
      return Ro(e.children, t);
    case Hn.Doctype:
    case Hn.Directive:
      return eL(e);
    case Hn.Comment:
      return rL(e);
    case Hn.CDATA:
      return nL(e);
    case Hn.Script:
    case Hn.Style:
    case Hn.Tag:
      return Jk(e, t);
    case Hn.Text:
      return tL(e, t);
  }
}
var Xk = /* @__PURE__ */ new Set([
  "mi",
  "mo",
  "mn",
  "ms",
  "mtext",
  "annotation-xml",
  "foreignObject",
  "desc",
  "title"
]), Qk = /* @__PURE__ */ new Set(["svg", "math"]);
function Jk(e, t) {
  var n;
  t.xmlMode === "foreign" && (e.name = (n = hy.elementNames.get(e.name)) !== null && n !== void 0 ? n : e.name, e.parent && Xk.has(e.parent.name) && (t = fu(fu({}, t), { xmlMode: !1 }))), !t.xmlMode && Qk.has(e.name) && (t = fu(fu({}, t), { xmlMode: "foreign" }));
  var r = "<".concat(e.name), u = Yk(e.attribs, t);
  return u && (r += " ".concat(u)), e.children.length === 0 && (t.xmlMode ? (
    // In XML mode or foreign mode, and user hasn't explicitly turned off self-closing tags
    t.selfClosingTags !== !1
  ) : (
    // User explicitly asked for self-closing tags, even in HTML mode
    t.selfClosingTags && gp.has(e.name)
  )) ? (t.xmlMode || (r += " "), r += "/>") : (r += ">", e.children.length > 0 && (r += Ro(e.children, t)), (t.xmlMode || !gp.has(e.name)) && (r += "</".concat(e.name, ">"))), r;
}
function eL(e) {
  return "<".concat(e.data, ">");
}
function tL(e, t) {
  var n, r = e.data || "";
  return ((n = t.encodeEntities) !== null && n !== void 0 ? n : t.decodeEntities) !== !1 && !(!t.xmlMode && e.parent && Wk.has(e.parent.name)) && (r = t.xmlMode || t.encodeEntities !== "utf8" ? (0, Za.encodeXML)(r) : (0, Za.escapeText)(r)), r;
}
function nL(e) {
  return "<![CDATA[".concat(e.children[0].data, "]]>");
}
function rL(e) {
  return "<!--".concat(e.data, "-->");
}
var uL = ee && ee.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(rn, "__esModule", { value: !0 });
rn.innerText = rn.textContent = rn.getText = rn.getInnerHTML = rn.getOuterHTML = void 0;
var Nn = Kn, iL = uL(Yi), aL = mr;
function my(e, t) {
  return (0, iL.default)(e, t);
}
rn.getOuterHTML = my;
function oL(e, t) {
  return (0, Nn.hasChildren)(e) ? e.children.map(function(n) {
    return my(n, t);
  }).join("") : "";
}
rn.getInnerHTML = oL;
function La(e) {
  return Array.isArray(e) ? e.map(La).join("") : (0, Nn.isTag)(e) ? e.name === "br" ? `
` : La(e.children) : (0, Nn.isCDATA)(e) ? La(e.children) : (0, Nn.isText)(e) ? e.data : "";
}
rn.getText = La;
function Wc(e) {
  return Array.isArray(e) ? e.map(Wc).join("") : (0, Nn.hasChildren)(e) && !(0, Nn.isComment)(e) ? Wc(e.children) : (0, Nn.isText)(e) ? e.data : "";
}
rn.textContent = Wc;
function Kc(e) {
  return Array.isArray(e) ? e.map(Kc).join("") : (0, Nn.hasChildren)(e) && (e.type === aL.ElementType.Tag || (0, Nn.isCDATA)(e)) ? Kc(e.children) : (0, Nn.isText)(e) ? e.data : "";
}
rn.innerText = Kc;
var St = {};
Object.defineProperty(St, "__esModule", { value: !0 });
St.prevElementSibling = St.nextElementSibling = St.getName = St.hasAttrib = St.getAttributeValue = St.getSiblings = St.getParent = St.getChildren = void 0;
var h0 = Kn;
function gy(e) {
  return (0, h0.hasChildren)(e) ? e.children : [];
}
St.getChildren = gy;
function by(e) {
  return e.parent || null;
}
St.getParent = by;
function sL(e) {
  var t, n, r = by(e);
  if (r != null)
    return gy(r);
  for (var u = [e], i = e.prev, a = e.next; i != null; )
    u.unshift(i), t = i, i = t.prev;
  for (; a != null; )
    u.push(a), n = a, a = n.next;
  return u;
}
St.getSiblings = sL;
function cL(e, t) {
  var n;
  return (n = e.attribs) === null || n === void 0 ? void 0 : n[t];
}
St.getAttributeValue = cL;
function lL(e, t) {
  return e.attribs != null && Object.prototype.hasOwnProperty.call(e.attribs, t) && e.attribs[t] != null;
}
St.hasAttrib = lL;
function dL(e) {
  return e.name;
}
St.getName = dL;
function fL(e) {
  for (var t, n = e.next; n !== null && !(0, h0.isTag)(n); )
    t = n, n = t.next;
  return n;
}
St.nextElementSibling = fL;
function pL(e) {
  for (var t, n = e.prev; n !== null && !(0, h0.isTag)(n); )
    t = n, n = t.prev;
  return n;
}
St.prevElementSibling = pL;
var Yt = {};
Object.defineProperty(Yt, "__esModule", { value: !0 });
Yt.prepend = Yt.prependChild = Yt.append = Yt.appendChild = Yt.replaceElement = Yt.removeElement = void 0;
function Zi(e) {
  if (e.prev && (e.prev.next = e.next), e.next && (e.next.prev = e.prev), e.parent) {
    var t = e.parent.children, n = t.lastIndexOf(e);
    n >= 0 && t.splice(n, 1);
  }
  e.next = null, e.prev = null, e.parent = null;
}
Yt.removeElement = Zi;
function hL(e, t) {
  var n = t.prev = e.prev;
  n && (n.next = t);
  var r = t.next = e.next;
  r && (r.prev = t);
  var u = t.parent = e.parent;
  if (u) {
    var i = u.children;
    i[i.lastIndexOf(e)] = t, e.parent = null;
  }
}
Yt.replaceElement = hL;
function mL(e, t) {
  if (Zi(t), t.next = null, t.parent = e, e.children.push(t) > 1) {
    var n = e.children[e.children.length - 2];
    n.next = t, t.prev = n;
  } else
    t.prev = null;
}
Yt.appendChild = mL;
function gL(e, t) {
  Zi(t);
  var n = e.parent, r = e.next;
  if (t.next = r, t.prev = e, e.next = t, t.parent = n, r) {
    if (r.prev = t, n) {
      var u = n.children;
      u.splice(u.lastIndexOf(r), 0, t);
    }
  } else
    n && n.children.push(t);
}
Yt.append = gL;
function bL(e, t) {
  if (Zi(t), t.parent = e, t.prev = null, e.children.unshift(t) !== 1) {
    var n = e.children[1];
    n.prev = t, t.next = n;
  } else
    t.next = null;
}
Yt.prependChild = bL;
function vL(e, t) {
  Zi(t);
  var n = e.parent;
  if (n) {
    var r = n.children;
    r.splice(r.indexOf(e), 0, t);
  }
  e.prev && (e.prev.next = t), t.parent = n, t.prev = e.prev, t.next = e, e.prev = t;
}
Yt.prepend = vL;
var Ft = {};
Object.defineProperty(Ft, "__esModule", { value: !0 });
Ft.findAll = Ft.existsOne = Ft.findOne = Ft.findOneChild = Ft.find = Ft.filter = void 0;
var Bo = Kn;
function yL(e, t, n, r) {
  return n === void 0 && (n = !0), r === void 0 && (r = 1 / 0), vy(e, Array.isArray(t) ? t : [t], n, r);
}
Ft.filter = yL;
function vy(e, t, n, r) {
  for (var u = [], i = [t], a = [0]; ; ) {
    if (a[0] >= i[0].length) {
      if (a.length === 1)
        return u;
      i.shift(), a.shift();
      continue;
    }
    var o = i[0][a[0]++];
    if (e(o) && (u.push(o), --r <= 0))
      return u;
    n && (0, Bo.hasChildren)(o) && o.children.length > 0 && (a.unshift(0), i.unshift(o.children));
  }
}
Ft.find = vy;
function xL(e, t) {
  return t.find(e);
}
Ft.findOneChild = xL;
function yy(e, t, n) {
  n === void 0 && (n = !0);
  for (var r = null, u = 0; u < t.length && !r; u++) {
    var i = t[u];
    if ((0, Bo.isTag)(i))
      e(i) ? r = i : n && i.children.length > 0 && (r = yy(e, i.children, !0));
    else
      continue;
  }
  return r;
}
Ft.findOne = yy;
function xy(e, t) {
  return t.some(function(n) {
    return (0, Bo.isTag)(n) && (e(n) || xy(e, n.children));
  });
}
Ft.existsOne = xy;
function _L(e, t) {
  for (var n = [], r = [t], u = [0]; ; ) {
    if (u[0] >= r[0].length) {
      if (r.length === 1)
        return n;
      r.shift(), u.shift();
      continue;
    }
    var i = r[0][u[0]++];
    (0, Bo.isTag)(i) && (e(i) && n.push(i), i.children.length > 0 && (u.unshift(0), r.unshift(i.children)));
  }
}
Ft.findAll = _L;
var un = {};
Object.defineProperty(un, "__esModule", { value: !0 });
un.getElementsByTagType = un.getElementsByTagName = un.getElementById = un.getElements = un.testElement = void 0;
var wr = Kn, Fo = Ft, Xa = {
  tag_name: function(e) {
    return typeof e == "function" ? function(t) {
      return (0, wr.isTag)(t) && e(t.name);
    } : e === "*" ? wr.isTag : function(t) {
      return (0, wr.isTag)(t) && t.name === e;
    };
  },
  tag_type: function(e) {
    return typeof e == "function" ? function(t) {
      return e(t.type);
    } : function(t) {
      return t.type === e;
    };
  },
  tag_contains: function(e) {
    return typeof e == "function" ? function(t) {
      return (0, wr.isText)(t) && e(t.data);
    } : function(t) {
      return (0, wr.isText)(t) && t.data === e;
    };
  }
};
function _y(e, t) {
  return typeof t == "function" ? function(n) {
    return (0, wr.isTag)(n) && t(n.attribs[e]);
  } : function(n) {
    return (0, wr.isTag)(n) && n.attribs[e] === t;
  };
}
function SL(e, t) {
  return function(n) {
    return e(n) || t(n);
  };
}
function Sy(e) {
  var t = Object.keys(e).map(function(n) {
    var r = e[n];
    return Object.prototype.hasOwnProperty.call(Xa, n) ? Xa[n](r) : _y(n, r);
  });
  return t.length === 0 ? null : t.reduce(SL);
}
function CL(e, t) {
  var n = Sy(e);
  return n ? n(t) : !0;
}
un.testElement = CL;
function EL(e, t, n, r) {
  r === void 0 && (r = 1 / 0);
  var u = Sy(e);
  return u ? (0, Fo.filter)(u, t, n, r) : [];
}
un.getElements = EL;
function wL(e, t, n) {
  return n === void 0 && (n = !0), Array.isArray(t) || (t = [t]), (0, Fo.findOne)(_y("id", e), t, n);
}
un.getElementById = wL;
function TL(e, t, n, r) {
  return n === void 0 && (n = !0), r === void 0 && (r = 1 / 0), (0, Fo.filter)(Xa.tag_name(e), t, n, r);
}
un.getElementsByTagName = TL;
function AL(e, t, n, r) {
  return n === void 0 && (n = !0), r === void 0 && (r = 1 / 0), (0, Fo.filter)(Xa.tag_type(e), t, n, r);
}
un.getElementsByTagType = AL;
var Cy = {};
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.uniqueSort = e.compareDocumentPosition = e.DocumentPosition = e.removeSubsets = void 0;
  var t = Kn;
  function n(a) {
    for (var o = a.length; --o >= 0; ) {
      var s = a[o];
      if (o > 0 && a.lastIndexOf(s, o - 1) >= 0) {
        a.splice(o, 1);
        continue;
      }
      for (var c = s.parent; c; c = c.parent)
        if (a.includes(c)) {
          a.splice(o, 1);
          break;
        }
    }
    return a;
  }
  e.removeSubsets = n;
  var r;
  (function(a) {
    a[a.DISCONNECTED = 1] = "DISCONNECTED", a[a.PRECEDING = 2] = "PRECEDING", a[a.FOLLOWING = 4] = "FOLLOWING", a[a.CONTAINS = 8] = "CONTAINS", a[a.CONTAINED_BY = 16] = "CONTAINED_BY";
  })(r = e.DocumentPosition || (e.DocumentPosition = {}));
  function u(a, o) {
    var s = [], c = [];
    if (a === o)
      return 0;
    for (var l = (0, t.hasChildren)(a) ? a : a.parent; l; )
      s.unshift(l), l = l.parent;
    for (l = (0, t.hasChildren)(o) ? o : o.parent; l; )
      c.unshift(l), l = l.parent;
    for (var d = Math.min(s.length, c.length), f = 0; f < d && s[f] === c[f]; )
      f++;
    if (f === 0)
      return r.DISCONNECTED;
    var p = s[f - 1], h = p.children, m = s[f], b = c[f];
    return h.indexOf(m) > h.indexOf(b) ? p === o ? r.FOLLOWING | r.CONTAINED_BY : r.FOLLOWING : p === a ? r.PRECEDING | r.CONTAINS : r.PRECEDING;
  }
  e.compareDocumentPosition = u;
  function i(a) {
    return a = a.filter(function(o, s, c) {
      return !c.includes(o, s + 1);
    }), a.sort(function(o, s) {
      var c = u(o, s);
      return c & r.PRECEDING ? -1 : c & r.FOLLOWING ? 1 : 0;
    }), a;
  }
  e.uniqueSort = i;
})(Cy);
var Ho = {};
Object.defineProperty(Ho, "__esModule", { value: !0 });
Ho.getFeed = void 0;
var kL = rn, Xi = un;
function LL(e) {
  var t = Qa(ML, e);
  return t ? t.name === "feed" ? DL(t) : NL(t) : null;
}
Ho.getFeed = LL;
function DL(e) {
  var t, n = e.children, r = {
    type: "atom",
    items: (0, Xi.getElementsByTagName)("entry", n).map(function(a) {
      var o, s = a.children, c = { media: Ey(s) };
      Wt(c, "id", "id", s), Wt(c, "title", "title", s);
      var l = (o = Qa("link", s)) === null || o === void 0 ? void 0 : o.attribs.href;
      l && (c.link = l);
      var d = ur("summary", s) || ur("content", s);
      d && (c.description = d);
      var f = ur("updated", s);
      return f && (c.pubDate = new Date(f)), c;
    })
  };
  Wt(r, "id", "id", n), Wt(r, "title", "title", n);
  var u = (t = Qa("link", n)) === null || t === void 0 ? void 0 : t.attribs.href;
  u && (r.link = u), Wt(r, "description", "subtitle", n);
  var i = ur("updated", n);
  return i && (r.updated = new Date(i)), Wt(r, "author", "email", n, !0), r;
}
function NL(e) {
  var t, n, r = (n = (t = Qa("channel", e.children)) === null || t === void 0 ? void 0 : t.children) !== null && n !== void 0 ? n : [], u = {
    type: e.name.substr(0, 3),
    id: "",
    items: (0, Xi.getElementsByTagName)("item", e.children).map(function(a) {
      var o = a.children, s = { media: Ey(o) };
      Wt(s, "id", "guid", o), Wt(s, "title", "title", o), Wt(s, "link", "link", o), Wt(s, "description", "description", o);
      var c = ur("pubDate", o) || ur("dc:date", o);
      return c && (s.pubDate = new Date(c)), s;
    })
  };
  Wt(u, "title", "title", r), Wt(u, "link", "link", r), Wt(u, "description", "description", r);
  var i = ur("lastBuildDate", r);
  return i && (u.updated = new Date(i)), Wt(u, "author", "managingEditor", r, !0), u;
}
var OL = ["url", "type", "lang"], IL = [
  "fileSize",
  "bitrate",
  "framerate",
  "samplingrate",
  "channels",
  "duration",
  "height",
  "width"
];
function Ey(e) {
  return (0, Xi.getElementsByTagName)("media:content", e).map(function(t) {
    for (var n = t.attribs, r = {
      medium: n.medium,
      isDefault: !!n.isDefault
    }, u = 0, i = OL; u < i.length; u++) {
      var a = i[u];
      n[a] && (r[a] = n[a]);
    }
    for (var o = 0, s = IL; o < s.length; o++) {
      var a = s[o];
      n[a] && (r[a] = parseInt(n[a], 10));
    }
    return n.expression && (r.expression = n.expression), r;
  });
}
function Qa(e, t) {
  return (0, Xi.getElementsByTagName)(e, t, !0, 1)[0];
}
function ur(e, t, n) {
  return n === void 0 && (n = !1), (0, kL.textContent)((0, Xi.getElementsByTagName)(e, t, n, 1)).trim();
}
function Wt(e, t, n, r, u) {
  u === void 0 && (u = !1);
  var i = ur(n, r, u);
  i && (e[t] = i);
}
function ML(e) {
  return e === "rss" || e === "feed" || e === "rdf:RDF";
}
(function(e) {
  var t = ee && ee.__createBinding || (Object.create ? function(u, i, a, o) {
    o === void 0 && (o = a);
    var s = Object.getOwnPropertyDescriptor(i, a);
    (!s || ("get" in s ? !i.__esModule : s.writable || s.configurable)) && (s = { enumerable: !0, get: function() {
      return i[a];
    } }), Object.defineProperty(u, o, s);
  } : function(u, i, a, o) {
    o === void 0 && (o = a), u[o] = i[a];
  }), n = ee && ee.__exportStar || function(u, i) {
    for (var a in u)
      a !== "default" && !Object.prototype.hasOwnProperty.call(i, a) && t(i, u, a);
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.hasChildren = e.isDocument = e.isComment = e.isText = e.isCDATA = e.isTag = void 0, n(rn, e), n(St, e), n(Yt, e), n(Ft, e), n(un, e), n(Cy, e), n(Ho, e);
  var r = Kn;
  Object.defineProperty(e, "isTag", { enumerable: !0, get: function() {
    return r.isTag;
  } }), Object.defineProperty(e, "isCDATA", { enumerable: !0, get: function() {
    return r.isCDATA;
  } }), Object.defineProperty(e, "isText", { enumerable: !0, get: function() {
    return r.isText;
  } }), Object.defineProperty(e, "isComment", { enumerable: !0, get: function() {
    return r.isComment;
  } }), Object.defineProperty(e, "isDocument", { enumerable: !0, get: function() {
    return r.isDocument;
  } }), Object.defineProperty(e, "hasChildren", { enumerable: !0, get: function() {
    return r.hasChildren;
  } });
})(ka);
(function(e) {
  var t = ee && ee.__createBinding || (Object.create ? function(y, g, v, S) {
    S === void 0 && (S = v);
    var _ = Object.getOwnPropertyDescriptor(g, v);
    (!_ || ("get" in _ ? !g.__esModule : _.writable || _.configurable)) && (_ = { enumerable: !0, get: function() {
      return g[v];
    } }), Object.defineProperty(y, S, _);
  } : function(y, g, v, S) {
    S === void 0 && (S = v), y[S] = g[v];
  }), n = ee && ee.__setModuleDefault || (Object.create ? function(y, g) {
    Object.defineProperty(y, "default", { enumerable: !0, value: g });
  } : function(y, g) {
    y.default = g;
  }), r = ee && ee.__importStar || function(y) {
    if (y && y.__esModule)
      return y;
    var g = {};
    if (y != null)
      for (var v in y)
        v !== "default" && Object.prototype.hasOwnProperty.call(y, v) && t(g, y, v);
    return n(g, y), g;
  }, u = ee && ee.__importDefault || function(y) {
    return y && y.__esModule ? y : { default: y };
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.DomUtils = e.parseFeed = e.getFeed = e.ElementType = e.QuoteType = e.Tokenizer = e.createDomStream = e.createDocumentStream = e.parseDOM = e.parseDocument = e.DefaultHandler = e.DomHandler = e.Parser = void 0;
  var i = Li, a = Li;
  Object.defineProperty(e, "Parser", { enumerable: !0, get: function() {
    return a.Parser;
  } });
  var o = Kn, s = Kn;
  Object.defineProperty(e, "DomHandler", { enumerable: !0, get: function() {
    return s.DomHandler;
  } }), Object.defineProperty(e, "DefaultHandler", { enumerable: !0, get: function() {
    return s.DomHandler;
  } });
  function c(y, g) {
    var v = new o.DomHandler(void 0, g);
    return new i.Parser(v, g).end(y), v.root;
  }
  e.parseDocument = c;
  function l(y, g) {
    return c(y, g).children;
  }
  e.parseDOM = l;
  function d(y, g, v) {
    var S = new o.DomHandler(function(_) {
      return y(_, S.root);
    }, g, v);
    return new i.Parser(S, g);
  }
  e.createDocumentStream = d;
  function f(y, g, v) {
    var S = new o.DomHandler(y, g, v);
    return new i.Parser(S, g);
  }
  e.createDomStream = f;
  var p = Bu;
  Object.defineProperty(e, "Tokenizer", { enumerable: !0, get: function() {
    return u(p).default;
  } }), Object.defineProperty(e, "QuoteType", { enumerable: !0, get: function() {
    return p.QuoteType;
  } }), e.ElementType = r(mr);
  var h = ka, m = ka;
  Object.defineProperty(e, "getFeed", { enumerable: !0, get: function() {
    return m.getFeed;
  } });
  var b = { xmlMode: !0 };
  function x(y, g) {
    return g === void 0 && (g = b), (0, h.getFeed)(l(y, g));
  }
  e.parseFeed = x, e.DomUtils = r(ka);
})(ty);
var wy = {}, Ne = {}, br = ee && ee.__extends || function() {
  var e = function(t, n) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, u) {
      r.__proto__ = u;
    } || function(r, u) {
      for (var i in u)
        Object.prototype.hasOwnProperty.call(u, i) && (r[i] = u[i]);
    }, e(t, n);
  };
  return function(t, n) {
    if (typeof n != "function" && n !== null)
      throw new TypeError("Class extends value " + String(n) + " is not a constructor or null");
    e(t, n);
    function r() {
      this.constructor = t;
    }
    t.prototype = n === null ? Object.create(n) : (r.prototype = n.prototype, new r());
  };
}(), pi = ee && ee.__assign || function() {
  return pi = Object.assign || function(e) {
    for (var t, n = 1, r = arguments.length; n < r; n++) {
      t = arguments[n];
      for (var u in t)
        Object.prototype.hasOwnProperty.call(t, u) && (e[u] = t[u]);
    }
    return e;
  }, pi.apply(this, arguments);
};
Object.defineProperty(Ne, "__esModule", { value: !0 });
Ne.cloneNode = Ne.hasChildren = Ne.isDocument = Ne.isDirective = Ne.isComment = Ne.isText = Ne.isCDATA = Ne.isTag = Ne.Element = Ne.Document = Ne.CDATA = Ne.NodeWithChildren = Ne.ProcessingInstruction = Ne.Comment = Ne.Text = Ne.DataNode = Ne.Node = void 0;
var en = mr, m0 = (
  /** @class */
  function() {
    function e() {
      this.parent = null, this.prev = null, this.next = null, this.startIndex = null, this.endIndex = null;
    }
    return Object.defineProperty(e.prototype, "parentNode", {
      // Read-write aliases for properties
      /**
       * Same as {@link parent}.
       * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
       */
      get: function() {
        return this.parent;
      },
      set: function(t) {
        this.parent = t;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "previousSibling", {
      /**
       * Same as {@link prev}.
       * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
       */
      get: function() {
        return this.prev;
      },
      set: function(t) {
        this.prev = t;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "nextSibling", {
      /**
       * Same as {@link next}.
       * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
       */
      get: function() {
        return this.next;
      },
      set: function(t) {
        this.next = t;
      },
      enumerable: !1,
      configurable: !0
    }), e.prototype.cloneNode = function(t) {
      return t === void 0 && (t = !1), g0(this, t);
    }, e;
  }()
);
Ne.Node = m0;
var $o = (
  /** @class */
  function(e) {
    br(t, e);
    function t(n) {
      var r = e.call(this) || this;
      return r.data = n, r;
    }
    return Object.defineProperty(t.prototype, "nodeValue", {
      /**
       * Same as {@link data}.
       * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
       */
      get: function() {
        return this.data;
      },
      set: function(n) {
        this.data = n;
      },
      enumerable: !1,
      configurable: !0
    }), t;
  }(m0)
);
Ne.DataNode = $o;
var Ty = (
  /** @class */
  function(e) {
    br(t, e);
    function t() {
      var n = e !== null && e.apply(this, arguments) || this;
      return n.type = en.ElementType.Text, n;
    }
    return Object.defineProperty(t.prototype, "nodeType", {
      get: function() {
        return 3;
      },
      enumerable: !1,
      configurable: !0
    }), t;
  }($o)
);
Ne.Text = Ty;
var Ay = (
  /** @class */
  function(e) {
    br(t, e);
    function t() {
      var n = e !== null && e.apply(this, arguments) || this;
      return n.type = en.ElementType.Comment, n;
    }
    return Object.defineProperty(t.prototype, "nodeType", {
      get: function() {
        return 8;
      },
      enumerable: !1,
      configurable: !0
    }), t;
  }($o)
);
Ne.Comment = Ay;
var ky = (
  /** @class */
  function(e) {
    br(t, e);
    function t(n, r) {
      var u = e.call(this, r) || this;
      return u.name = n, u.type = en.ElementType.Directive, u;
    }
    return Object.defineProperty(t.prototype, "nodeType", {
      get: function() {
        return 1;
      },
      enumerable: !1,
      configurable: !0
    }), t;
  }($o)
);
Ne.ProcessingInstruction = ky;
var Vo = (
  /** @class */
  function(e) {
    br(t, e);
    function t(n) {
      var r = e.call(this) || this;
      return r.children = n, r;
    }
    return Object.defineProperty(t.prototype, "firstChild", {
      // Aliases
      /** First child of the node. */
      get: function() {
        var n;
        return (n = this.children[0]) !== null && n !== void 0 ? n : null;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(t.prototype, "lastChild", {
      /** Last child of the node. */
      get: function() {
        return this.children.length > 0 ? this.children[this.children.length - 1] : null;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(t.prototype, "childNodes", {
      /**
       * Same as {@link children}.
       * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
       */
      get: function() {
        return this.children;
      },
      set: function(n) {
        this.children = n;
      },
      enumerable: !1,
      configurable: !0
    }), t;
  }(m0)
);
Ne.NodeWithChildren = Vo;
var Ly = (
  /** @class */
  function(e) {
    br(t, e);
    function t() {
      var n = e !== null && e.apply(this, arguments) || this;
      return n.type = en.ElementType.CDATA, n;
    }
    return Object.defineProperty(t.prototype, "nodeType", {
      get: function() {
        return 4;
      },
      enumerable: !1,
      configurable: !0
    }), t;
  }(Vo)
);
Ne.CDATA = Ly;
var Dy = (
  /** @class */
  function(e) {
    br(t, e);
    function t() {
      var n = e !== null && e.apply(this, arguments) || this;
      return n.type = en.ElementType.Root, n;
    }
    return Object.defineProperty(t.prototype, "nodeType", {
      get: function() {
        return 9;
      },
      enumerable: !1,
      configurable: !0
    }), t;
  }(Vo)
);
Ne.Document = Dy;
var Ny = (
  /** @class */
  function(e) {
    br(t, e);
    function t(n, r, u, i) {
      u === void 0 && (u = []), i === void 0 && (i = n === "script" ? en.ElementType.Script : n === "style" ? en.ElementType.Style : en.ElementType.Tag);
      var a = e.call(this, u) || this;
      return a.name = n, a.attribs = r, a.type = i, a;
    }
    return Object.defineProperty(t.prototype, "nodeType", {
      get: function() {
        return 1;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(t.prototype, "tagName", {
      // DOM Level 1 aliases
      /**
       * Same as {@link name}.
       * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
       */
      get: function() {
        return this.name;
      },
      set: function(n) {
        this.name = n;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(t.prototype, "attributes", {
      get: function() {
        var n = this;
        return Object.keys(this.attribs).map(function(r) {
          var u, i;
          return {
            name: r,
            value: n.attribs[r],
            namespace: (u = n["x-attribsNamespace"]) === null || u === void 0 ? void 0 : u[r],
            prefix: (i = n["x-attribsPrefix"]) === null || i === void 0 ? void 0 : i[r]
          };
        });
      },
      enumerable: !1,
      configurable: !0
    }), t;
  }(Vo)
);
Ne.Element = Ny;
function Oy(e) {
  return (0, en.isTag)(e);
}
Ne.isTag = Oy;
function Iy(e) {
  return e.type === en.ElementType.CDATA;
}
Ne.isCDATA = Iy;
function My(e) {
  return e.type === en.ElementType.Text;
}
Ne.isText = My;
function Py(e) {
  return e.type === en.ElementType.Comment;
}
Ne.isComment = Py;
function Ry(e) {
  return e.type === en.ElementType.Directive;
}
Ne.isDirective = Ry;
function By(e) {
  return e.type === en.ElementType.Root;
}
Ne.isDocument = By;
function PL(e) {
  return Object.prototype.hasOwnProperty.call(e, "children");
}
Ne.hasChildren = PL;
function g0(e, t) {
  t === void 0 && (t = !1);
  var n;
  if (My(e))
    n = new Ty(e.data);
  else if (Py(e))
    n = new Ay(e.data);
  else if (Oy(e)) {
    var r = t ? zs(e.children) : [], u = new Ny(e.name, pi({}, e.attribs), r);
    r.forEach(function(s) {
      return s.parent = u;
    }), e.namespace != null && (u.namespace = e.namespace), e["x-attribsNamespace"] && (u["x-attribsNamespace"] = pi({}, e["x-attribsNamespace"])), e["x-attribsPrefix"] && (u["x-attribsPrefix"] = pi({}, e["x-attribsPrefix"])), n = u;
  } else if (Iy(e)) {
    var r = t ? zs(e.children) : [], i = new Ly(r);
    r.forEach(function(c) {
      return c.parent = i;
    }), n = i;
  } else if (By(e)) {
    var r = t ? zs(e.children) : [], a = new Dy(r);
    r.forEach(function(c) {
      return c.parent = a;
    }), e["x-mode"] && (a["x-mode"] = e["x-mode"]), n = a;
  } else if (Ry(e)) {
    var o = new ky(e.name, e.data);
    e["x-name"] != null && (o["x-name"] = e["x-name"], o["x-publicId"] = e["x-publicId"], o["x-systemId"] = e["x-systemId"]), n = o;
  } else
    throw new Error("Not implemented yet: ".concat(e.type));
  return n.startIndex = e.startIndex, n.endIndex = e.endIndex, e.sourceCodeLocation != null && (n.sourceCodeLocation = e.sourceCodeLocation), n;
}
Ne.cloneNode = g0;
function zs(e) {
  for (var t = e.map(function(r) {
    return g0(r, !0);
  }), n = 1; n < t.length; n++)
    t[n].prev = t[n - 1], t[n - 1].next = t[n];
  return t;
}
(function(e) {
  var t = ee && ee.__createBinding || (Object.create ? function(o, s, c, l) {
    l === void 0 && (l = c);
    var d = Object.getOwnPropertyDescriptor(s, c);
    (!d || ("get" in d ? !s.__esModule : d.writable || d.configurable)) && (d = { enumerable: !0, get: function() {
      return s[c];
    } }), Object.defineProperty(o, l, d);
  } : function(o, s, c, l) {
    l === void 0 && (l = c), o[l] = s[c];
  }), n = ee && ee.__exportStar || function(o, s) {
    for (var c in o)
      c !== "default" && !Object.prototype.hasOwnProperty.call(s, c) && t(s, o, c);
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.DomHandler = void 0;
  var r = mr, u = Ne;
  n(Ne, e);
  var i = {
    withStartIndices: !1,
    withEndIndices: !1,
    xmlMode: !1
  }, a = (
    /** @class */
    function() {
      function o(s, c, l) {
        this.dom = [], this.root = new u.Document(this.dom), this.done = !1, this.tagStack = [this.root], this.lastNode = null, this.parser = null, typeof c == "function" && (l = c, c = i), typeof s == "object" && (c = s, s = void 0), this.callback = s ?? null, this.options = c ?? i, this.elementCB = l ?? null;
      }
      return o.prototype.onparserinit = function(s) {
        this.parser = s;
      }, o.prototype.onreset = function() {
        this.dom = [], this.root = new u.Document(this.dom), this.done = !1, this.tagStack = [this.root], this.lastNode = null, this.parser = null;
      }, o.prototype.onend = function() {
        this.done || (this.done = !0, this.parser = null, this.handleCallback(null));
      }, o.prototype.onerror = function(s) {
        this.handleCallback(s);
      }, o.prototype.onclosetag = function() {
        this.lastNode = null;
        var s = this.tagStack.pop();
        this.options.withEndIndices && (s.endIndex = this.parser.endIndex), this.elementCB && this.elementCB(s);
      }, o.prototype.onopentag = function(s, c) {
        var l = this.options.xmlMode ? r.ElementType.Tag : void 0, d = new u.Element(s, c, void 0, l);
        this.addNode(d), this.tagStack.push(d);
      }, o.prototype.ontext = function(s) {
        var c = this.lastNode;
        if (c && c.type === r.ElementType.Text)
          c.data += s, this.options.withEndIndices && (c.endIndex = this.parser.endIndex);
        else {
          var l = new u.Text(s);
          this.addNode(l), this.lastNode = l;
        }
      }, o.prototype.oncomment = function(s) {
        if (this.lastNode && this.lastNode.type === r.ElementType.Comment) {
          this.lastNode.data += s;
          return;
        }
        var c = new u.Comment(s);
        this.addNode(c), this.lastNode = c;
      }, o.prototype.oncommentend = function() {
        this.lastNode = null;
      }, o.prototype.oncdatastart = function() {
        var s = new u.Text(""), c = new u.CDATA([s]);
        this.addNode(c), s.parent = c, this.lastNode = s;
      }, o.prototype.oncdataend = function() {
        this.lastNode = null;
      }, o.prototype.onprocessinginstruction = function(s, c) {
        var l = new u.ProcessingInstruction(s, c);
        this.addNode(l);
      }, o.prototype.handleCallback = function(s) {
        if (typeof this.callback == "function")
          this.callback(s, this.dom);
        else if (s)
          throw s;
      }, o.prototype.addNode = function(s) {
        var c = this.tagStack[this.tagStack.length - 1], l = c.children[c.children.length - 1];
        this.options.withStartIndices && (s.startIndex = this.parser.startIndex), this.options.withEndIndices && (s.endIndex = this.parser.endIndex), c.children.push(s), l && (s.prev = l, l.next = s), s.parent = c, this.lastNode = null;
      }, o;
    }()
  );
  e.DomHandler = a, e.default = a;
})(wy);
function RL(e) {
  return !0;
}
var BL = {
  shouldProcessEveryNode: RL
}, FL = 1 / 0, HL = "[object Symbol]", $L = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g, VL = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g, jo = "\\ud800-\\udfff", Fy = "\\u0300-\\u036f\\ufe20-\\ufe23", Hy = "\\u20d0-\\u20f0", $y = "\\u2700-\\u27bf", Vy = "a-z\\xdf-\\xf6\\xf8-\\xff", jL = "\\xac\\xb1\\xd7\\xf7", zL = "\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf", UL = "\\u2000-\\u206f", qL = " \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000", jy = "A-Z\\xc0-\\xd6\\xd8-\\xde", zy = "\\ufe0e\\ufe0f", Uy = jL + zL + UL + qL, b0 = "['’]", GL = "[" + jo + "]", bp = "[" + Uy + "]", Ja = "[" + Fy + Hy + "]", qy = "\\d+", WL = "[" + $y + "]", Gy = "[" + Vy + "]", Wy = "[^" + jo + Uy + qy + $y + Vy + jy + "]", Yc = "\\ud83c[\\udffb-\\udfff]", KL = "(?:" + Ja + "|" + Yc + ")", Ky = "[^" + jo + "]", v0 = "(?:\\ud83c[\\udde6-\\uddff]){2}", y0 = "[\\ud800-\\udbff][\\udc00-\\udfff]", uu = "[" + jy + "]", Yy = "\\u200d", vp = "(?:" + Gy + "|" + Wy + ")", YL = "(?:" + uu + "|" + Wy + ")", yp = "(?:" + b0 + "(?:d|ll|m|re|s|t|ve))?", xp = "(?:" + b0 + "(?:D|LL|M|RE|S|T|VE))?", Zy = KL + "?", Xy = "[" + zy + "]?", ZL = "(?:" + Yy + "(?:" + [Ky, v0, y0].join("|") + ")" + Xy + Zy + ")*", Qy = Xy + Zy + ZL, XL = "(?:" + [WL, v0, y0].join("|") + ")" + Qy, QL = "(?:" + [Ky + Ja + "?", Ja, v0, y0, GL].join("|") + ")", JL = RegExp(b0, "g"), eD = RegExp(Ja, "g"), tD = RegExp(Yc + "(?=" + Yc + ")|" + QL + Qy, "g"), nD = RegExp([
  uu + "?" + Gy + "+" + yp + "(?=" + [bp, uu, "$"].join("|") + ")",
  YL + "+" + xp + "(?=" + [bp, uu + vp, "$"].join("|") + ")",
  uu + "?" + vp + "+" + yp,
  uu + "+" + xp,
  qy,
  XL
].join("|"), "g"), rD = RegExp("[" + Yy + jo + Fy + Hy + zy + "]"), uD = /[a-z][A-Z]|[A-Z]{2,}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/, iD = {
  // Latin-1 Supplement block.
  À: "A",
  Á: "A",
  Â: "A",
  Ã: "A",
  Ä: "A",
  Å: "A",
  à: "a",
  á: "a",
  â: "a",
  ã: "a",
  ä: "a",
  å: "a",
  Ç: "C",
  ç: "c",
  Ð: "D",
  ð: "d",
  È: "E",
  É: "E",
  Ê: "E",
  Ë: "E",
  è: "e",
  é: "e",
  ê: "e",
  ë: "e",
  Ì: "I",
  Í: "I",
  Î: "I",
  Ï: "I",
  ì: "i",
  í: "i",
  î: "i",
  ï: "i",
  Ñ: "N",
  ñ: "n",
  Ò: "O",
  Ó: "O",
  Ô: "O",
  Õ: "O",
  Ö: "O",
  Ø: "O",
  ò: "o",
  ó: "o",
  ô: "o",
  õ: "o",
  ö: "o",
  ø: "o",
  Ù: "U",
  Ú: "U",
  Û: "U",
  Ü: "U",
  ù: "u",
  ú: "u",
  û: "u",
  ü: "u",
  Ý: "Y",
  ý: "y",
  ÿ: "y",
  Æ: "Ae",
  æ: "ae",
  Þ: "Th",
  þ: "th",
  ß: "ss",
  // Latin Extended-A block.
  Ā: "A",
  Ă: "A",
  Ą: "A",
  ā: "a",
  ă: "a",
  ą: "a",
  Ć: "C",
  Ĉ: "C",
  Ċ: "C",
  Č: "C",
  ć: "c",
  ĉ: "c",
  ċ: "c",
  č: "c",
  Ď: "D",
  Đ: "D",
  ď: "d",
  đ: "d",
  Ē: "E",
  Ĕ: "E",
  Ė: "E",
  Ę: "E",
  Ě: "E",
  ē: "e",
  ĕ: "e",
  ė: "e",
  ę: "e",
  ě: "e",
  Ĝ: "G",
  Ğ: "G",
  Ġ: "G",
  Ģ: "G",
  ĝ: "g",
  ğ: "g",
  ġ: "g",
  ģ: "g",
  Ĥ: "H",
  Ħ: "H",
  ĥ: "h",
  ħ: "h",
  Ĩ: "I",
  Ī: "I",
  Ĭ: "I",
  Į: "I",
  İ: "I",
  ĩ: "i",
  ī: "i",
  ĭ: "i",
  į: "i",
  ı: "i",
  Ĵ: "J",
  ĵ: "j",
  Ķ: "K",
  ķ: "k",
  ĸ: "k",
  Ĺ: "L",
  Ļ: "L",
  Ľ: "L",
  Ŀ: "L",
  Ł: "L",
  ĺ: "l",
  ļ: "l",
  ľ: "l",
  ŀ: "l",
  ł: "l",
  Ń: "N",
  Ņ: "N",
  Ň: "N",
  Ŋ: "N",
  ń: "n",
  ņ: "n",
  ň: "n",
  ŋ: "n",
  Ō: "O",
  Ŏ: "O",
  Ő: "O",
  ō: "o",
  ŏ: "o",
  ő: "o",
  Ŕ: "R",
  Ŗ: "R",
  Ř: "R",
  ŕ: "r",
  ŗ: "r",
  ř: "r",
  Ś: "S",
  Ŝ: "S",
  Ş: "S",
  Š: "S",
  ś: "s",
  ŝ: "s",
  ş: "s",
  š: "s",
  Ţ: "T",
  Ť: "T",
  Ŧ: "T",
  ţ: "t",
  ť: "t",
  ŧ: "t",
  Ũ: "U",
  Ū: "U",
  Ŭ: "U",
  Ů: "U",
  Ű: "U",
  Ų: "U",
  ũ: "u",
  ū: "u",
  ŭ: "u",
  ů: "u",
  ű: "u",
  ų: "u",
  Ŵ: "W",
  ŵ: "w",
  Ŷ: "Y",
  ŷ: "y",
  Ÿ: "Y",
  Ź: "Z",
  Ż: "Z",
  Ž: "Z",
  ź: "z",
  ż: "z",
  ž: "z",
  Ĳ: "IJ",
  ĳ: "ij",
  Œ: "Oe",
  œ: "oe",
  ŉ: "'n",
  ſ: "ss"
}, aD = typeof ee == "object" && ee && ee.Object === Object && ee, oD = typeof self == "object" && self && self.Object === Object && self, sD = aD || oD || Function("return this")();
function cD(e, t, n, r) {
  var u = -1, i = e ? e.length : 0;
  for (r && i && (n = e[++u]); ++u < i; )
    n = t(n, e[u], u, e);
  return n;
}
function lD(e) {
  return e.split("");
}
function dD(e) {
  return e.match($L) || [];
}
function fD(e) {
  return function(t) {
    return e == null ? void 0 : e[t];
  };
}
var pD = fD(iD);
function Jy(e) {
  return rD.test(e);
}
function hD(e) {
  return uD.test(e);
}
function mD(e) {
  return Jy(e) ? gD(e) : lD(e);
}
function gD(e) {
  return e.match(tD) || [];
}
function bD(e) {
  return e.match(nD) || [];
}
var vD = Object.prototype, yD = vD.toString, _p = sD.Symbol, Sp = _p ? _p.prototype : void 0, Cp = Sp ? Sp.toString : void 0;
function xD(e, t, n) {
  var r = -1, u = e.length;
  t < 0 && (t = -t > u ? 0 : u + t), n = n > u ? u : n, n < 0 && (n += u), u = t > n ? 0 : n - t >>> 0, t >>>= 0;
  for (var i = Array(u); ++r < u; )
    i[r] = e[r + t];
  return i;
}
function _D(e) {
  if (typeof e == "string")
    return e;
  if (TD(e))
    return Cp ? Cp.call(e) : "";
  var t = e + "";
  return t == "0" && 1 / e == -FL ? "-0" : t;
}
function SD(e, t, n) {
  var r = e.length;
  return n = n === void 0 ? r : n, !t && n >= r ? e : xD(e, t, n);
}
function CD(e) {
  return function(t) {
    t = zo(t);
    var n = Jy(t) ? mD(t) : void 0, r = n ? n[0] : t.charAt(0), u = n ? SD(n, 1).join("") : t.slice(1);
    return r[e]() + u;
  };
}
function ED(e) {
  return function(t) {
    return cD(ND(LD(t).replace(JL, "")), e, "");
  };
}
function wD(e) {
  return !!e && typeof e == "object";
}
function TD(e) {
  return typeof e == "symbol" || wD(e) && yD.call(e) == HL;
}
function zo(e) {
  return e == null ? "" : _D(e);
}
var AD = ED(function(e, t, n) {
  return t = t.toLowerCase(), e + (n ? kD(t) : t);
});
function kD(e) {
  return DD(zo(e).toLowerCase());
}
function LD(e) {
  return e = zo(e), e && e.replace(VL, pD).replace(eD, "");
}
var DD = CD("toUpperCase");
function ND(e, t, n) {
  return e = zo(e), t = n ? void 0 : t, t === void 0 ? hD(e) ? bD(e) : dD(e) : e.match(t) || [];
}
var OD = AD;
const ID = [
  "accept",
  "acceptCharset",
  "accessKey",
  "action",
  "allowFullScreen",
  "allowTransparency",
  "alt",
  "async",
  "autoComplete",
  "autoFocus",
  "autoPlay",
  "capture",
  "cellPadding",
  "cellSpacing",
  "challenge",
  "charSet",
  "checked",
  "cite",
  "classID",
  "className",
  "colSpan",
  "cols",
  "content",
  "contentEditable",
  "contextMenu",
  "controls",
  "coords",
  "crossOrigin",
  "data",
  "dateTime",
  "default",
  "defer",
  "dir",
  "disabled",
  "download",
  "draggable",
  "encType",
  "form",
  "formAction",
  "formEncType",
  "formMethod",
  "formNoValidate",
  "formTarget",
  "frameBorder",
  "headers",
  "height",
  "hidden",
  "high",
  "href",
  "hrefLang",
  "htmlFor",
  "httpEquiv",
  "icon",
  "id",
  "inputMode",
  "integrity",
  "is",
  "keyParams",
  "keyType",
  "kind",
  "label",
  "lang",
  "list",
  "loop",
  "low",
  "manifest",
  "marginHeight",
  "marginWidth",
  "max",
  "maxLength",
  "media",
  "mediaGroup",
  "method",
  "min",
  "minLength",
  "multiple",
  "muted",
  "name",
  "noValidate",
  "nonce",
  "open",
  "optimum",
  "pattern",
  "placeholder",
  "poster",
  "preload",
  "profile",
  "radioGroup",
  "readOnly",
  "rel",
  "required",
  "reversed",
  "role",
  "rowSpan",
  "rows",
  "sandbox",
  "scope",
  "scoped",
  "scrolling",
  "seamless",
  "selected",
  "shape",
  "size",
  "sizes",
  "span",
  "spellCheck",
  "src",
  "srcDoc",
  "srcLang",
  "srcSet",
  "start",
  "step",
  "style",
  "summary",
  "tabIndex",
  "target",
  "title",
  "type",
  "useMap",
  "value",
  "width",
  "wmode",
  "wrap",
  "onClick"
], MD = [
  "autoCapitalize",
  "autoCorrect",
  "color",
  "itemProp",
  "itemScope",
  "itemType",
  "itemRef",
  "itemID",
  "security",
  "unselectable",
  "results",
  "autoSave"
], PD = [
  "accentHeight",
  "accumulate",
  "additive",
  "alignmentBaseline",
  "allowReorder",
  "alphabetic",
  "amplitude",
  "arabicForm",
  "ascent",
  "attributeName",
  "attributeType",
  "autoReverse",
  "azimuth",
  "baseFrequency",
  "baseProfile",
  "baselineShift",
  "bbox",
  "begin",
  "bias",
  "by",
  "calcMode",
  "capHeight",
  "clip",
  "clipPath",
  "clipPathUnits",
  "clipRule",
  "colorInterpolation",
  "colorInterpolationFilters",
  "colorProfile",
  "colorRendering",
  "contentScriptType",
  "contentStyleType",
  "cursor",
  "cx",
  "cy",
  "d",
  "decelerate",
  "descent",
  "diffuseConstant",
  "direction",
  "display",
  "divisor",
  "dominantBaseline",
  "dur",
  "dx",
  "dy",
  "edgeMode",
  "elevation",
  "enableBackground",
  "end",
  "exponent",
  "externalResourcesRequired",
  "fill",
  "fillOpacity",
  "fillRule",
  "filter",
  "filterRes",
  "filterUnits",
  "floodColor",
  "floodOpacity",
  "focusable",
  "fontFamily",
  "fontSize",
  "fontSizeAdjust",
  "fontStretch",
  "fontStyle",
  "fontVariant",
  "fontWeight",
  "format",
  "from",
  "fx",
  "fy",
  "g1",
  "g2",
  "glyphName",
  "glyphOrientationHorizontal",
  "glyphOrientationVertical",
  "glyphRef",
  "gradientTransform",
  "gradientUnits",
  "hanging",
  "horizAdvX",
  "horizOriginX",
  "ideographic",
  "imageRendering",
  "in",
  "in2",
  "intercept",
  "k",
  "k1",
  "k2",
  "k3",
  "k4",
  "kernelMatrix",
  "kernelUnitLength",
  "kerning",
  "keyPoints",
  "keySplines",
  "keyTimes",
  "lengthAdjust",
  "letterSpacing",
  "lightingColor",
  "limitingConeAngle",
  "local",
  "markerEnd",
  "markerHeight",
  "markerMid",
  "markerStart",
  "markerUnits",
  "markerWidth",
  "mask",
  "maskContentUnits",
  "maskUnits",
  "mathematical",
  "mode",
  "numOctaves",
  "offset",
  "opacity",
  "operator",
  "order",
  "orient",
  "orientation",
  "origin",
  "overflow",
  "overlinePosition",
  "overlineThickness",
  "paintOrder",
  "panose1",
  "pathLength",
  "patternContentUnits",
  "patternTransform",
  "patternUnits",
  "pointerEvents",
  "points",
  "pointsAtX",
  "pointsAtY",
  "pointsAtZ",
  "preserveAlpha",
  "preserveAspectRatio",
  "primitiveUnits",
  "r",
  "radius",
  "refX",
  "refY",
  "renderingIntent",
  "repeatCount",
  "repeatDur",
  "requiredExtensions",
  "requiredFeatures",
  "restart",
  "result",
  "rotate",
  "rx",
  "ry",
  "scale",
  "seed",
  "shapeRendering",
  "slope",
  "spacing",
  "specularConstant",
  "specularExponent",
  "speed",
  "spreadMethod",
  "startOffset",
  "stdDeviation",
  "stemh",
  "stemv",
  "stitchTiles",
  "stopColor",
  "stopOpacity",
  "strikethroughPosition",
  "strikethroughThickness",
  "string",
  "stroke",
  "strokeDasharray",
  "strokeDashoffset",
  "strokeLinecap",
  "strokeLinejoin",
  "strokeMiterlimit",
  "strokeOpacity",
  "strokeWidth",
  "surfaceScale",
  "systemLanguage",
  "tableValues",
  "targetX",
  "targetY",
  "textAnchor",
  "textDecoration",
  "textLength",
  "textRendering",
  "to",
  "transform",
  "u1",
  "u2",
  "underlinePosition",
  "underlineThickness",
  "unicode",
  "unicodeBidi",
  "unicodeRange",
  "unitsPerEm",
  "vAlphabetic",
  "vHanging",
  "vIdeographic",
  "vMathematical",
  "values",
  "vectorEffect",
  "version",
  "vertAdvY",
  "vertOriginX",
  "vertOriginY",
  "viewBox",
  "viewTarget",
  "visibility",
  "widths",
  "wordSpacing",
  "writingMode",
  "x",
  "x1",
  "x2",
  "xChannelSelector",
  "xHeight",
  "xlinkActuate",
  "xlinkArcrole",
  "xlinkHref",
  "xlinkRole",
  "xlinkShow",
  "xlinkTitle",
  "xlinkType",
  "xmlns",
  "xmlnsXlink",
  "xmlBase",
  "xmlLang",
  "xmlSpace",
  "y",
  "y1",
  "y2",
  "yChannelSelector",
  "z",
  "zoomAndPan"
], RD = ID.concat(MD).concat(PD).reduce(function(e, t) {
  const n = t.toLowerCase();
  return n !== t && (e[n] = t), e;
}, {});
var BD = RD;
const FD = OD, HD = Te, $D = BD;
function VD(e) {
  e = e || "";
  const t = e.split(/;(?!base64)/);
  let n, r, u, i = {};
  for (let a = 0; a < t.length; ++a)
    n = t[a].split(":"), n.length > 2 && (n[1] = n.slice(1).join(":")), r = n[0], u = n[1], typeof u == "string" && (u = u.trim()), r != null && u != null && r.length > 0 && u.length > 0 && (r = r.trim(), r.indexOf("--") !== 0 && (r = FD(r)), i[r] = u);
  return i;
}
const jD = [
  "allowFullScreen",
  "allowpaymentrequest",
  "async",
  "autoFocus",
  "autoPlay",
  "checked",
  "controls",
  "default",
  "disabled",
  "formNoValidate",
  "hidden",
  "ismap",
  "itemScope",
  "loop",
  "multiple",
  "muted",
  "nomodule",
  "noValidate",
  "open",
  "playsinline",
  "readOnly",
  "required",
  "reversed",
  "selected",
  "truespeed"
];
function zD(e, t, n, r) {
  let u = {
    key: t
  };
  const i = e.name.includes("-");
  e.attribs && (u = Object.entries(e.attribs).reduce((o, [s, c]) => (i || (s = $D[s.replace(/[-:]/, "")] || s, s === "style" ? c = VD(c) : s === "class" ? s = "className" : s === "for" ? s = "htmlFor" : s.startsWith("on") && (c = Function(c)), jD.includes(s) && (c || "") === "" && (c = s)), o[s] = c, o), u)), r = r || [];
  const a = n != null ? [n].concat(r) : r;
  return HD.createElement.apply(
    null,
    [e.name, u].concat(a)
  );
}
var e3 = {
  createElement: zD
};
const Ep = e3, UD = [
  "area",
  "base",
  "br",
  "col",
  "embed",
  "hr",
  "img",
  "input",
  "keygen",
  "link",
  "meta",
  "param",
  "source",
  "track",
  "wbr",
  "menuitem",
  "textarea"
];
function qD() {
  function e(t, n, r) {
    return t.type === "text" ? t.data : t.type === "comment" ? !1 : UD.indexOf(t.name) > -1 ? Ep.createElement(t, r) : Ep.createElement(t, r, t.data, n);
  }
  return {
    processDefaultNode: e
  };
}
var t3 = qD;
const GD = BL, WD = t3;
function KD() {
  const e = new WD();
  return {
    defaultProcessingInstructions: [{
      shouldProcessNode: GD.shouldProcessEveryNode,
      processNode: e.processDefaultNode
    }]
  };
}
var n3 = KD;
function YD() {
  return !0;
}
var r3 = {
  alwaysValid: YD
};
const ZD = ty.Parser, XD = wy.DomHandler, QD = n3, JD = r3, eN = e3;
function tN(e) {
  function t(i) {
    e = e || {}, e.decodeEntities = !0;
    const a = new XD();
    return new ZD(a, e).parseComplete(i), a.dom.filter(function(s) {
      return s.type !== "directive";
    });
  }
  function n(i, a, o, s, c) {
    if (a(i)) {
      (s || []).forEach((d) => {
        d.shouldPreprocessNode(i) && d.preprocessNode(i, c);
      });
      const l = (o || []).find((d) => d.shouldProcessNode(i));
      if (l != null) {
        const d = (i.children || []).map((f, p) => n(
          f,
          a,
          o,
          s,
          p
        )).filter((f) => f != null && f !== !1);
        return l.replaceChildren ? eN.createElement(i, c, i.data, [
          l.processNode(i, d, c)
        ]) : l.processNode(i, d, c);
      } else
        return !1;
    } else
      return !1;
  }
  function r(i, a, o, s) {
    const l = t(i).map(function(d, f) {
      return n(
        d,
        a,
        o,
        s,
        f
      );
    });
    return l.length <= 1 ? l[0] : l;
  }
  function u(i) {
    const a = new QD();
    return r(
      i,
      JD.alwaysValid,
      a.defaultProcessingInstructions
    );
  }
  return {
    parse: u,
    parseWithInstructions: r
  };
}
var nN = tN;
const rN = nN, uN = n3, iN = r3, aN = t3;
var u3 = {
  Parser: rN,
  ProcessingInstructions: uN,
  IsValidNodeDefinitions: iN,
  ProcessNodeDefinitions: aN
};
const oN = (e = "") => e.replace(/\s/g, "").toLocaleLowerCase(), i3 = (e = "") => e == null ? void 0 : e.replace(/\s/g, ""), BH = (e) => {
  var t;
  return !e || !e.content ? [] : (t = e.content[0]) == null ? void 0 : t.content.map((n) => {
    var a, o;
    const r = n, u = (a = r == null ? void 0 : r.content) == null ? void 0 : a[0], i = (o = u == null ? void 0 : u.content) == null ? void 0 : o[0];
    return i == null ? void 0 : i.value;
  });
}, x0 = (e) => e ? `-${typeof e == "object" ? ey(e, !1) : e}` : "", sN = ({
  componentName: e,
  linkText: t,
  linkType: n,
  ariaLabel: r,
  documentId: u
}) => {
  const i = r ? `-${r}` : x0(t), a = u ? `-${u}` : "";
  return `${e}-${n || "cta"}${a}${i}`;
}, cN = ({
  componentName: e,
  linkText: t,
  linkSection: n
}) => `${e}-Link-${n}${x0(t)}`, lN = ({
  componentName: e,
  linkText: t,
  linkSection: n
}) => `${e}-Button-${n}${x0(t)}`, Us = (e, t) => {
  const n = oN(t);
  return `${e}_${n}_clicked`;
}, Ht = ({
  componentName: e = "",
  linkText: t = "",
  linkType: n = jr.Primary,
  linkSection: r = "Paragraph",
  clickEvent: u,
  ariaLabel: i = "",
  mid: a,
  mabReward: o,
  documentId: s,
  serverFptiData: c = {}
}, l = o0.ppcom, d = yt.CTA) => {
  let f;
  if (d === yt.CTA) {
    const p = u ?? Wi.Button;
    f = {
      link: sN({
        componentName: e,
        linkText: t,
        linkType: n,
        ariaLabel: i,
        documentId: s
      }),
      event_name: Us(l, p),
      mid: a,
      ...c
    }, o && o.key && (f[o.key] = o.value);
  } else if (d === yt.Link) {
    const p = u ?? Io.Text;
    f = {
      link: cN({ componentName: e, linkText: t, linkSection: r }),
      event_name: Us(l, p),
      mid: a,
      ...c
    };
  } else {
    const p = u ?? Qv.Button;
    f = {
      link: lN({ componentName: e, linkText: t, linkSection: r }),
      event_name: Us(l, p),
      mid: a,
      ...c
    };
  }
  return JSON.stringify(f);
}, a3 = (e = "", t = "", n = "", r = "Started", u = o0.ppcom) => {
  const i = {
    event_name: `${u}_${t}_${r.toLowerCase()}`,
    link: `${e}-${t}-${r}-${n}`
  };
  return JSON.stringify(i);
}, dN = "open-popover-modal", fN = (e) => {
  typeof window > "u" || !e || document.dispatchEvent(
    new CustomEvent(dN, {
      detail: { modalId: e }
    })
  );
}, o3 = (e) => (t) => {
  t.preventDefault(), fN(e);
}, wp = "https://", pN = "https://www.paypal.com/", hN = (e) => !!e && e.startsWith(wp) && e.length > wp.length, mN = (e) => {
  const t = /^\//;
  return `${pN}${e.replace(t, "")}`;
}, Tp = (e) => {
  const t = typeof window < "u", n = !(e != null && e.startsWith("https://"));
  if (!t || !e || !n && !hN(e))
    return !1;
  const r = /\/+$/, { href: u, hash: i, search: a } = new URL(
    n ? mN(e) : e
  );
  return u.replace(i, "").replace(a, "").replace(r, "");
}, gN = (e) => e.charAt(0) === "/", bN = (e, t, n) => {
  const r = [
    /\/bizsignup(\/?)/,
    /\/brc(\/?)/,
    /\/business(\/?)/,
    /\/digital-wallet(\/?)/,
    /\/security(\/?)/,
    /\/enterprise(\/?)/,
    /\/for-you(\/?)/,
    /\/non-profit(\/?)/,
    /\/smarthelp(\/?)/,
    /\/fastlane(\/?)/,
    /webapps\/mpp/
  ];
  let u = t;
  if (n && r.some((i) => i.test(e))) {
    const i = n.toLowerCase() === "gb" ? "uk" : n.toLowerCase();
    u += `/${i}`;
  }
  return u += e, e = u, e;
}, Da = (e, t = "", n = "") => gN(e) && t ? bN(e, t, n) : e, vN = [
  "paypal.com",
  "pypl.com",
  "paypal-corp.com",
  "concertocard.com/application/paypal"
], Zc = "_self", s3 = "_blank", yN = [Zc, s3], xN = (e) => e.startsWith("#") || e.startsWith("/") ? !0 : vN.some(
  (r) => e.includes(r)
), c3 = (e, t, n) => {
  let { target: r, href: u } = e;
  return u = Da(u, t, n), r && yN.includes(r) || (r = xN(u) ? Zc : s3), {
    ...e,
    target: r,
    rel: r === Zc ? "" : "noopener noreferrer",
    href: u
  };
}, _N = (e, t, n, r) => {
  var y;
  const {
    analyticsCompName: u = "",
    analyticsTextSection: i = "Paragraph",
    className: a,
    kitUtilsContext: o,
    // This is only provided when we resolve our anchor tag out of a cvAmplitudeLink
    // token resolved by our INLINES.EMBEDDED_ENTRY node renderer fn
    clickEvent: s
  } = e || {}, { pageSegment: c, locality: l, baseURI: d = "" } = o || {}, f = {
    href: t
  };
  r && (f.title = r);
  const p = c3(
    f,
    d,
    l == null ? void 0 : l.country
  ), m = ((y = p == null ? void 0 : p.href) == null ? void 0 : y.startsWith("#popover-modal-")) ? {
    role: "button",
    onClick: o3(p == null ? void 0 : p.href),
    "aria-haspopup": "dialog"
  } : {}, x = Ht(
    {
      linkText: n || "",
      componentName: u,
      linkSection: i,
      clickEvent: s
    },
    c,
    yt.Link
  );
  return {
    ...p,
    ...m,
    className: U("html-text-renderer-link", a),
    "data-pa-click": x
  };
}, SN = (e) => Symbol.for("react.fragment") === e, CN = "HtmlTextRenderer", EN = u3.Parser(), wN = u3.ProcessNodeDefinitions(Te), TN = () => !0, Xc = (e, t) => ({
  replaceChildren: !1,
  shouldProcessNode: (n) => n.name === e,
  processNode: t
}), AN = (e = {}) => Object.entries(e).map(
  ([r, u]) => Xc(r, u)
), kN = ({
  as: e,
  className: t,
  customWrapper: n,
  htmlOverrides: r = {},
  analyticsCompName: u = "",
  analyticsTextSection: i = "",
  pageSegment: a,
  serverFptiData: o
}) => {
  const s = AN(r), c = Xc(
    "p",
    ({ attribs: f = {} }, p, h) => {
      let m = e || "p";
      const b = { key: `wrapper-${h}` }, x = {
        ...f,
        ...b
      };
      t && (x.className = t), n && (m = n, e && (x.as = e));
      const y = SN(n) ? b : x;
      return Te.createElement(
        m,
        y,
        p
      );
    }
  ), l = Xc(
    "a",
    ({ attribs: f = {} }, p, h) => {
      var L;
      if (f.href === "data-nosnippet" && p.length)
        return Te.createElement(
          "span",
          { "data-nosnippet": !0 },
          p
        );
      if (!(p != null && p.length))
        return null;
      const {
        environment: { host: b = "" } = {},
        requestor: { locality: { country: x = "" } = {} } = {}
      } = nt(), y = c3(f, b, x), g = "a", [v] = p, S = {
        componentName: u,
        linkSection: i,
        linkText: v,
        serverFptiData: o
      };
      !!y.clickeventname && (S.clickEvent = y.clickeventname, delete y.clickeventname), ((L = y == null ? void 0 : y.href) == null ? void 0 : L.startsWith("#popover-modal-")) && (y.role = "button", y.onClick = o3(y == null ? void 0 : y.href), y["aria-haspopup"] = "dialog");
      const k = Ht(
        S,
        a,
        yt.Link
      ), T = {
        ...y,
        className: "html-text-renderer-link",
        // These styles are imported by ContentRenderer
        key: `wrapper-${h}`,
        "data-pa-click": k
      };
      return t && (T.className = U(T.className, t)), Te.createElement(g, T, p);
    }
  );
  return [
    ...s,
    l,
    c,
    {
      // Anything else
      shouldProcessNode() {
        return !0;
      },
      processNode: wN.processDefaultNode
    }
  ];
}, l3 = ({
  className: e,
  as: t,
  customWrapper: n,
  htmlString: r,
  htmlOverrides: u,
  analyticsCompName: i = "",
  analyticsTextSection: a = "Paragraph",
  serverFptiData: o = {}
}) => {
  const { environment: { pageSegment: s = "" } = {} } = nt();
  if (!r || typeof r != "string")
    return null;
  const c = kN({
    as: t,
    className: e,
    customWrapper: n,
    htmlOverrides: u,
    analyticsCompName: i,
    analyticsTextSection: a,
    pageSegment: s,
    serverFptiData: o
  });
  return EN.parseWithInstructions(
    r,
    TN,
    c
  );
};
l3.displayName = CN;
const LN = "OldContentRenderer", _0 = ({
  as: e,
  className: t,
  content: n,
  customWrapper: r,
  htmlOverrides: u,
  wrapTokenWithSpan: i = !1,
  renderMarkdownContent: a,
  renderHtmlContent: o,
  analyticsCompName: s = "",
  analyticsTextSection: c = "",
  serverFptiData: l = {}
}) => {
  if (!n)
    return null;
  const f = typeof n == "object" ? ey(n, i) : n;
  if (a && f)
    return a({ markdownStr: f, className: t });
  const p = Ak(f);
  return o && p ? o({ htmlStr: p, className: t }) : /* @__PURE__ */ E(
    l3,
    {
      as: e,
      className: t,
      htmlString: p,
      customWrapper: r,
      htmlOverrides: u,
      analyticsCompName: s,
      analyticsTextSection: c,
      serverFptiData: l
    }
  );
};
_0.displayName = LN;
const DN = "ContentRenderer", Bt = ({
  htmlOverridesMapper: e,
  ...t
}) => {
  const { environment: { useNewContentRenderer: n = !1 } = {} } = nt();
  return n ? /* @__PURE__ */ ue(on, { children: [
    /* @__PURE__ */ E(
      ev,
      {
        ...t,
        htmlOverrides: e == null ? void 0 : e.newContentRenderer,
        processAnchorTagAttributes: _N
      }
    ),
    `
`
  ] }) : (
    // @ts-expect-error - TODO: We need to fix our ContentRenderer's typing issues
    /* @__PURE__ */ E(
      _0,
      {
        ...t,
        htmlOverrides: e == null ? void 0 : e.oldContentRenderer
      }
    )
  );
};
Bt.displayName = DN;
const NN = (e) => (e.content || []).map((n) => ({
  nodeType: Ze.BLOCKS.DOCUMENT,
  content: [n],
  data: {}
})), d3 = ({
  className: e,
  text: t,
  index: n = NaN,
  paragraphSize: r = "Caption",
  showSupScriptIndex: u = !1,
  analyticsCompName: i = "",
  analyticsTextSection: a = "",
  serverFptiData: o = {}
}) => {
  const { environment: { useNewContentRenderer: s = !1 } = {} } = nt(), c = NN(t);
  return /* @__PURE__ */ E(on, { children: c.map((l, d) => {
    const f = `MultiLineText-${n}-${d}`, h = u && d === 0;
    return /* @__PURE__ */ ue(
      Qt,
      {
        className: U(
          e,
          "multi-line-text",
          !h && "multi-line-text-wo-sup"
        ),
        size: r,
        as: "div",
        children: [
          h && /* @__PURE__ */ E("div", { className: "multi-line-text-sup", children: /* @__PURE__ */ E("sup", { children: n + 1 }) }),
          s ? /* @__PURE__ */ E(
            Bt,
            {
              as: "div",
              className: "multi-line-text-paragraph",
              content: l,
              analyticsCompName: i,
              analyticsTextSection: a,
              serverFptiData: o
            }
          ) : /* @__PURE__ */ E("div", { className: "multi-line-text-paragraph", children: /* @__PURE__ */ E(
            Bt,
            {
              customWrapper: Bg,
              content: l,
              analyticsCompName: i,
              analyticsTextSection: a,
              serverFptiData: o
            }
          ) })
        ]
      },
      f
    );
  }) });
};
const f3 = "Disclosure", ON = new ye(f3), IN = ({
  className: e,
  text: t,
  index: n,
  paragraphSize: r = "Caption",
  analyticsCompName: u = f3,
  analyticsTextSection: i = "",
  serverFptiData: a = {}
}) => {
  const o = U(e, ON.getElementClassName("item"));
  return /* @__PURE__ */ E(
    d3,
    {
      className: o,
      paragraphSize: r,
      text: t,
      index: n,
      showSupScriptIndex: !0,
      analyticsCompName: u,
      analyticsTextSection: i,
      serverFptiData: a
    }
  );
}, S0 = "Disclosure", Ap = new ye(S0), C0 = ({
  className: e,
  collection: t = [],
  paragraphSize: n = "Caption",
  paragraph: r,
  analyticsCompName: u = "Disclosure",
  analyticsTextSection: i = "",
  customWrapper: a = "div",
  componentId: o,
  isQuantumLeap: s,
  serverFptiData: c,
  ...l
}) => {
  const { foundationTheme: d, foundationColor: f } = ke(yn), p = e || "disclosure-text-color", h = "slate gradient", m = U(
    p,
    Ap.getComponentClassName(),
    d,
    f,
    {
      [Or.getThemeClassName(h)]: s
    }
  );
  return /* @__PURE__ */ ue(a, { className: m, ...l, id: o, children: [
    r && /* @__PURE__ */ E(
      d3,
      {
        text: r,
        className: U(Ap.getElementClassName("paragraph")),
        paragraphSize: n,
        analyticsCompName: u,
        analyticsTextSection: i,
        serverFptiData: c
      }
    ),
    t.map((b, x) => /* @__PURE__ */ E(
      IN,
      {
        ...b,
        index: x,
        paragraphSize: n,
        analyticsCompName: u,
        analyticsTextSection: i,
        serverFptiData: c
      },
      `item-${x + 1}`
    ))
  ] });
};
C0.displayName = S0;
const Uo = (e = {}) => /* @__PURE__ */ E(
  C0,
  {
    customWrapper: Vr,
    motionOptions: Fc,
    ...e
  }
);
Uo.displayName = S0;
const de = {
  gold: vr.sysColorFeaturedMain,
  blue_500: vr.sysColorSecondaryMain,
  blue_600: vr.sysColorPrimaryMain,
  blue_700: vr.sysColorPrimaryMainActive,
  white: vr.sysColorBackgroundSurface,
  neutral_100: vr.sysColorBackgroundMain,
  slate: vr.sysColorSystemMain
}, MN = {
  GoldOnWhite: {
    primary: de.gold,
    secondary: de.blue_600,
    overlap: de.blue_500,
    background: de.white
  },
  GoldBlue500OnWhite: {
    primary: de.gold,
    secondary: de.blue_500,
    overlap: de.blue_600,
    background: de.white
  },
  Blue500OnWhite: {
    primary: de.blue_500,
    secondary: de.gold,
    overlap: de.blue_600,
    background: de.white
  },
  Blue600OnWhite: {
    primary: de.blue_600,
    secondary: de.gold,
    overlap: de.blue_500,
    background: de.white
  },
  Blue500Blue600OnWhite: {
    primary: de.blue_500,
    secondary: de.blue_600,
    overlap: de.blue_700,
    background: de.white
  },
  Blue600Blue500OnWhite: {
    primary: de.blue_600,
    secondary: de.blue_700,
    overlap: de.blue_500,
    background: de.white
  },
  WhiteOnBlue600: {
    primary: de.white,
    secondary: de.gold,
    overlap: de.blue_500,
    background: de.blue_600
  },
  GoldOnNeutral100: {
    primary: de.gold,
    secondary: de.blue_600,
    overlap: de.blue_500,
    background: de.neutral_100
  },
  GoldBlue500OnNeutral100: {
    primary: de.gold,
    secondary: de.blue_500,
    overlap: de.blue_600,
    background: de.neutral_100
  },
  Blue500OnNeutral100: {
    primary: de.blue_500,
    secondary: de.gold,
    overlap: de.blue_600,
    background: de.neutral_100
  },
  Blue600OnNeutral100: {
    primary: de.blue_600,
    secondary: de.gold,
    overlap: de.blue_500,
    background: de.neutral_100
  },
  Blue500Blue600OnNeutral100: {
    primary: de.blue_500,
    secondary: de.blue_600,
    overlap: de.blue_700,
    background: de.neutral_100
  },
  Blue600Blue500OnNeutral100: {
    primary: de.blue_600,
    secondary: de.blue_700,
    overlap: de.blue_500,
    background: de.neutral_100
  },
  SlateOnWhite: {
    primary: de.slate,
    secondary: de.blue_600,
    overlap: de.blue_500,
    background: de.white
  }
}, p3 = {
  HeroSplit01Large: {
    graphicHeight: "100%",
    graphicOffset: "-12%",
    canUseImage: !0,
    // can have a background image
    svgSrc: "https://www.paypalobjects.com/marketing/pp-com-components/graphic-shape/regular/herosplit01largeupper.svg"
  },
  HeroSplit01Medium: {
    graphicHeight: "75%",
    graphicOffset: "-12%",
    canUseImage: !0,
    // can have a background image
    svgSrc: "https://www.paypalobjects.com/marketing/pp-com-components/graphic-shape/regular/herosplit01mediumupper.svg"
  },
  HeroSplit02LargeUpper: {
    graphicHeight: "100%",
    graphicOffset: "-12%",
    canUseImage: !0,
    // can have a background image
    svgSrc: "https://www.paypalobjects.com/marketing/pp-com-components/graphic-shape/regular/herosplit02largeupper.svg"
  },
  HeroSplit02MediumUpper: {
    graphicHeight: "75%",
    graphicOffset: "-12%",
    canUseImage: !0,
    // can have a background image
    svgSrc: "https://www.paypalobjects.com/marketing/pp-com-components/graphic-shape/regular/herosplit02mediumupper.svg"
  },
  HeroSplit01XLargeUpper: {
    graphicHeight: "100%",
    graphicOffset: "-12%",
    canUseImage: !0,
    // can have a background image
    svgSrc: "https://www.paypalobjects.com/marketing/pp-com-components/graphic-shape/regular/herosplit01xlargeupper.svg"
  },
  HeroSplit02XLargeUpper: {
    graphicHeight: "100%",
    graphicOffset: "-12%",
    canUseImage: !0,
    // can have a background image
    svgSrc: "https://www.paypalobjects.com/marketing/pp-com-components/graphic-shape/regular/herosplit02xlargeupper.svg"
  },
  /**
   * @deprecated discontinue use of this graphic version
   */
  HeroTall01: {
    graphicHeight: "100%",
    graphicOffset: "-12%",
    svgSrc: "https://www.paypalobjects.com/marketing/pp-com-components/graphic-shape/regular/herotall01.svg"
  },
  /**
   * @deprecated discontinue use of this graphic version
   */
  HeroTall02: {
    graphicHeight: "100%",
    graphicOffset: "12%",
    svgSrc: "https://www.paypalobjects.com/marketing/pp-com-components/graphic-shape/regular/herotall02.svg"
  },
  SplitRightLarge: {
    graphicHeight: "75%",
    graphicOffset: "-15.8%",
    canUseImage: !0,
    // can have a background image
    svgSrc: "https://www.paypalobjects.com/marketing/pp-com-components/graphic-shape/regular/splitrightlarge.svg"
  },
  SplitRightMedium: {
    // Note: no regular version, reusing compact for both
    canUseImage: !0,
    // can have a background image
    svgRatio: 3.66666667,
    svgSrc: "https://www.paypalobjects.com/marketing/pp-com-components/graphic-shape/regular/splitrightmedium.svg"
  },
  SplitRightSmall: {
    graphicHeight: "75%",
    graphicOffset: "-14.3%",
    canUseImage: !0,
    // can have a background image
    svgSrc: "https://www.paypalobjects.com/marketing/pp-com-components/graphic-shape/regular/splitrightsmall.svg"
  },
  SplitLeftLarge: {
    graphicHeight: "75%",
    graphicOffset: "14.3%",
    canUseImage: !0,
    // can have a background image
    svgSrc: "https://www.paypalobjects.com/marketing/pp-com-components/graphic-shape/regular/splitleftlarge.svg"
  },
  SplitLeftMedium: {
    // Note: no regular version, reusing compact for both
    canUseImage: !0,
    // can have a background image
    svgRatio: 3.66666667,
    svgSrc: "https://www.paypalobjects.com/marketing/pp-com-components/graphic-shape/regular/splitleftmedium.svg"
  },
  SplitLeftSmall: {
    graphicHeight: "75%",
    graphicOffset: "14.3%",
    canUseImage: !0,
    // can have a background image
    svgSrc: "https://www.paypalobjects.com/marketing/pp-com-components/graphic-shape/regular/splitleftsmall.svg"
  },
  GraphicLeftCurveLarge: {
    graphicHeight: "100%",
    graphicOffset: "0%",
    svgSrc: "https://www.paypalobjects.com/marketing/pp-com-components/graphic-shape/regular/leftcurvelarge.svg"
  },
  GraphicLeftCurveMedium: {
    graphicHeight: "100%",
    graphicOffset: "0%",
    svgSrc: "https://www.paypalobjects.com/marketing/pp-com-components/graphic-shape/regular/leftcurvemedium.svg"
  },
  GraphicLeftCurveSmall: {
    graphicHeight: "100%",
    graphicOffset: "0%",
    svgSrc: "https://www.paypalobjects.com/marketing/pp-com-components/graphic-shape/regular/leftcurvesmall.svg"
  },
  GraphicLeftLarge: {
    graphicHeight: "100%",
    graphicOffset: "21.45%",
    svgSrc: "https://www.paypalobjects.com/marketing/pp-com-components/graphic-shape/regular/leftlarge.svg"
  },
  GraphicLeftSmall: {
    graphicHeight: "100%",
    graphicOffset: "21.45%",
    svgSrc: "https://www.paypalobjects.com/marketing/pp-com-components/graphic-shape/regular/leftsmall.svg"
  },
  GraphicLeftMini: {
    graphicHeight: "100%",
    graphicOffset: "21.45%",
    svgSrc: "https://www.paypalobjects.com/marketing/pp-com-components/graphic-shape/regular/leftmini.svg"
  },
  GraphicOverlap01: {
    graphicHeight: "100%",
    graphicOffset: "0%",
    svgSrc: "https://www.paypalobjects.com/marketing/pp-com-components/graphic-shape/regular/overlap01.svg"
  },
  GraphicOverlap02: {
    graphicHeight: "100%",
    graphicOffset: "0%",
    svgSrc: "https://www.paypalobjects.com/marketing/pp-com-components/graphic-shape/regular/overlap02.svg"
  },
  GraphicOverlap03: {
    graphicHeight: "100%",
    graphicOffset: "0%",
    svgSrc: "https://www.paypalobjects.com/marketing/pp-com-components/graphic-shape/regular/overlap03.svg"
  },
  GraphicOverlap04: {
    graphicHeight: "100%",
    graphicOffset: "0%",
    svgSrc: "https://www.paypalobjects.com/marketing/pp-com-components/graphic-shape/regular/overlap04.svg"
  },
  GraphicOverlap05: {
    graphicHeight: "100%",
    graphicOffset: "0%",
    svgSrc: "https://www.paypalobjects.com/marketing/pp-com-components/graphic-shape/regular/overlap05.svg"
  },
  GraphicOverlap06: {
    graphicHeight: "100%",
    graphicOffset: "0%",
    svgSrc: "https://www.paypalobjects.com/marketing/pp-com-components/graphic-shape/regular/overlap06.svg"
  },
  GraphicOverlap07: {
    graphicHeight: "100%",
    graphicOffset: "0%",
    svgSrc: "https://www.paypalobjects.com/marketing/pp-com-components/graphic-shape/regular/overlap07.svg"
  },
  GraphicRightCurveLarge: {
    graphicHeight: "100%",
    graphicOffset: "-13.3%",
    svgSrc: "https://www.paypalobjects.com/marketing/pp-com-components/graphic-shape/regular/rightcurvelarge.svg"
  },
  GraphicRightCurveMini: {
    graphicHeight: "100%",
    graphicOffset: "-13.3%",
    svgSrc: "https://www.paypalobjects.com/marketing/pp-com-components/graphic-shape/regular/rightcurvemini.svg"
  },
  GraphicRightCurveSmall: {
    graphicHeight: "100%",
    graphicOffset: "-17.25%",
    svgSrc: "https://www.paypalobjects.com/marketing/pp-com-components/graphic-shape/regular/rightcurvesmall.svg"
  },
  GraphicRightLarge: {
    graphicHeight: "100%",
    graphicOffset: "-21.45%",
    svgSrc: "https://www.paypalobjects.com/marketing/pp-com-components/graphic-shape/regular/rightlarge.svg"
  },
  GraphicRightSmall: {
    graphicHeight: "100%",
    graphicOffset: "-21.45%",
    svgSrc: "https://www.paypalobjects.com/marketing/pp-com-components/graphic-shape/regular/rightsmall.svg"
  },
  /**
   * @deprecated discontinue use of this graphic version
   */
  SplitTall01: {
    graphicHeight: "100%",
    graphicOffset: "0%",
    canUseImage: !0
    // can have a background image
  },
  /**
   * @deprecated discontinue use of this graphic version
   */
  SplitTall02: {
    graphicHeight: "100%",
    graphicOffset: "0%",
    canUseImage: !0
    // can have a background image
  }
}, PN = {
  ...p3,
  GraphicLeftCurveLarge: {
    graphicHeight: "100%",
    graphicOffset: "0%",
    svgSrc: "https://www.paypalobjects.com/marketing/pp-com-components/graphic-shape/compact/leftcurvelarge.svg"
  },
  GraphicLeftCurveMedium: {
    graphicHeight: "100%",
    graphicOffset: "0%",
    svgSrc: "https://www.paypalobjects.com/marketing/pp-com-components/graphic-shape/compact/leftcurvemedium.svg"
  },
  GraphicLeftCurveSmall: {
    graphicHeight: "100%",
    graphicOffset: "0%",
    svgSrc: "https://www.paypalobjects.com/marketing/pp-com-components/graphic-shape/compact/leftcurvesmall.svg"
  },
  GraphicLeftMini: {
    graphicHeight: "100%",
    graphicOffset: "21.45%",
    svgSrc: "https://www.paypalobjects.com/marketing/pp-com-components/graphic-shape/compact/leftmini.svg"
  },
  GraphicLeftSmall: {
    graphicHeight: "100%",
    graphicOffset: "21.45%",
    svgSrc: "https://www.paypalobjects.com/marketing/pp-com-components/graphic-shape/compact/leftsmall.svg"
  },
  GraphicRightCurveMini: {
    graphicHeight: "100%",
    graphicOffset: "-13.3%",
    svgSrc: "https://www.paypalobjects.com/marketing/pp-com-components/graphic-shape/compact/rightcurvemini.svg"
  },
  GraphicRightCurveSmall: {
    graphicHeight: "100%",
    graphicOffset: "-17.25%",
    svgSrc: "https://www.paypalobjects.com/marketing/pp-com-components/graphic-shape/compact/rightcurvesmall.svg"
  },
  GraphicLeftLarge: {
    graphicHeight: "100%",
    graphicOffset: "21.45%",
    svgSrc: "https://www.paypalobjects.com/marketing/pp-com-components/graphic-shape/compact/leftlarge.svg"
  },
  HeroSplit01Large: {
    graphicHeight: "100%",
    graphicOffset: "-12%",
    canUseImage: !0,
    // can have a background image
    svgSrc: "https://www.paypalobjects.com/marketing/pp-com-components/graphic-shape/compact/herosplit01largeupper.svg"
  },
  HeroSplit01Medium: {
    graphicHeight: "75%",
    graphicOffset: "-12%",
    canUseImage: !0,
    // can have a background image
    svgSrc: "https://www.paypalobjects.com/marketing/pp-com-components/graphic-shape/compact/herosplit01mediumupper.svg"
  },
  HeroSplit02LargeUpper: {
    graphicHeight: "100%",
    graphicOffset: "-12%",
    canUseImage: !0,
    // can have a background image
    svgSrc: "https://www.paypalobjects.com/marketing/pp-com-components/graphic-shape/compact/herosplit02largeupper.svg"
  },
  HeroSplit02MediumUpper: {
    graphicHeight: "75%",
    graphicOffset: "-12%",
    canUseImage: !0,
    // can have a background image
    svgSrc: "https://www.paypalobjects.com/marketing/pp-com-components/graphic-shape/compact/herosplit02mediumupper.svg"
  },
  HeroSplit01XLargeUpper: {
    graphicHeight: "100%",
    graphicOffset: "-12%",
    canUseImage: !0,
    // can have a background image
    svgSrc: "https://www.paypalobjects.com/marketing/pp-com-components/graphic-shape/compact/herosplit01xlargeupper.svg"
  },
  HeroSplit02XLargeUpper: {
    graphicHeight: "100%",
    graphicOffset: "-12%",
    canUseImage: !0,
    // can have a background image
    svgSrc: "https://www.paypalobjects.com/marketing/pp-com-components/graphic-shape/compact/herosplit02xlargeupper.svg"
  },
  HeroTall02: {
    graphicHeight: "100%",
    graphicOffset: "12%",
    svgSrc: "https://www.paypalobjects.com/marketing/pp-com-components/graphic-shape/compact/herotall02.svg"
  },
  SplitRightLarge: {
    canUseImage: !0,
    // can have a background image
    svgRatio: 3.66666667,
    svgSrc: "https://www.paypalobjects.com/marketing/pp-com-components/graphic-shape/compact/splitrightlarge.svg"
  },
  SplitLeftLarge: {
    canUseImage: !0,
    // can have a background image
    svgRatio: 3.66666667,
    svgSrc: "https://www.paypalobjects.com/marketing/pp-com-components/graphic-shape/compact/splitleftlarge.svg"
  },
  GraphicRightLarge: {
    graphicHeight: "100%",
    graphicOffset: "-21.45%",
    svgSrc: "https://www.paypalobjects.com/marketing/pp-com-components/graphic-shape/compact/rightlarge.svg"
  },
  SplitLeftSmall: {
    canUseImage: !0,
    // can have a background image
    graphicHeight: "75%",
    graphicOffset: "14.3%",
    svgSrc: "https://www.paypalobjects.com/marketing/pp-com-components/graphic-shape/compact/splitleftsmall.svg"
  }
};
var RN = (e) => typeof e != "string" ? {} : e.split(/ ?; ?/).reduce((t, n) => {
  const [r, u] = n.split(/ ?: ?/).map((i, a) => a === 0 ? i.replace(/\s+/g, "") : i.trim());
  if (r && u) {
    const i = r.replace(/(\w)-(\w)/g, (o, s, c) => `${s}${c.toUpperCase()}`);
    let a = u.trim();
    Number.isNaN(Number(u)) || (a = Number(u)), t[r.startsWith("-") ? r : i] = a;
  }
  return t;
}, {});
function BN(e = 6) {
  const t = "0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ";
  let n = "";
  for (let r = e; r > 0; --r)
    n += t[Math.round(Math.random() * (t.length - 1))];
  return n;
}
var FN = [
  "br",
  "col",
  "colgroup",
  "dl",
  "hr",
  "iframe",
  "img",
  "input",
  "link",
  "menuitem",
  "meta",
  "ol",
  "param",
  "select",
  "table",
  "tbody",
  "tfoot",
  "thead",
  "tr",
  "ul",
  "wbr"
], kp = {
  // HTML
  "accept-charset": "acceptCharset",
  acceptcharset: "acceptCharset",
  accesskey: "accessKey",
  allowfullscreen: "allowFullScreen",
  autocapitalize: "autoCapitalize",
  autocomplete: "autoComplete",
  autocorrect: "autoCorrect",
  autofocus: "autoFocus",
  autoplay: "autoPlay",
  autosave: "autoSave",
  cellpadding: "cellPadding",
  cellspacing: "cellSpacing",
  charset: "charSet",
  class: "className",
  classid: "classID",
  classname: "className",
  colspan: "colSpan",
  contenteditable: "contentEditable",
  contextmenu: "contextMenu",
  controlslist: "controlsList",
  crossorigin: "crossOrigin",
  dangerouslysetinnerhtml: "dangerouslySetInnerHTML",
  datetime: "dateTime",
  defaultchecked: "defaultChecked",
  defaultvalue: "defaultValue",
  enctype: "encType",
  for: "htmlFor",
  formmethod: "formMethod",
  formaction: "formAction",
  formenctype: "formEncType",
  formnovalidate: "formNoValidate",
  formtarget: "formTarget",
  frameborder: "frameBorder",
  hreflang: "hrefLang",
  htmlfor: "htmlFor",
  httpequiv: "httpEquiv",
  "http-equiv": "httpEquiv",
  icon: "icon",
  innerhtml: "innerHTML",
  inputmode: "inputMode",
  itemid: "itemID",
  itemprop: "itemProp",
  itemref: "itemRef",
  itemscope: "itemScope",
  itemtype: "itemType",
  keyparams: "keyParams",
  keytype: "keyType",
  marginwidth: "marginWidth",
  marginheight: "marginHeight",
  maxlength: "maxLength",
  mediagroup: "mediaGroup",
  minlength: "minLength",
  nomodule: "noModule",
  novalidate: "noValidate",
  playsinline: "playsInline",
  radiogroup: "radioGroup",
  readonly: "readOnly",
  referrerpolicy: "referrerPolicy",
  rowspan: "rowSpan",
  spellcheck: "spellCheck",
  srcdoc: "srcDoc",
  srclang: "srcLang",
  srcset: "srcSet",
  tabindex: "tabIndex",
  typemustmatch: "typeMustMatch",
  usemap: "useMap",
  // SVG
  accentheight: "accentHeight",
  "accent-height": "accentHeight",
  alignmentbaseline: "alignmentBaseline",
  "alignment-baseline": "alignmentBaseline",
  allowreorder: "allowReorder",
  arabicform: "arabicForm",
  "arabic-form": "arabicForm",
  attributename: "attributeName",
  attributetype: "attributeType",
  autoreverse: "autoReverse",
  basefrequency: "baseFrequency",
  baselineshift: "baselineShift",
  "baseline-shift": "baselineShift",
  baseprofile: "baseProfile",
  calcmode: "calcMode",
  capheight: "capHeight",
  "cap-height": "capHeight",
  clippath: "clipPath",
  "clip-path": "clipPath",
  clippathunits: "clipPathUnits",
  cliprule: "clipRule",
  "clip-rule": "clipRule",
  colorinterpolation: "colorInterpolation",
  "color-interpolation": "colorInterpolation",
  colorinterpolationfilters: "colorInterpolationFilters",
  "color-interpolation-filters": "colorInterpolationFilters",
  colorprofile: "colorProfile",
  "color-profile": "colorProfile",
  colorrendering: "colorRendering",
  "color-rendering": "colorRendering",
  contentscripttype: "contentScriptType",
  contentstyletype: "contentStyleType",
  diffuseconstant: "diffuseConstant",
  dominantbaseline: "dominantBaseline",
  "dominant-baseline": "dominantBaseline",
  edgemode: "edgeMode",
  enablebackground: "enableBackground",
  "enable-background": "enableBackground",
  externalresourcesrequired: "externalResourcesRequired",
  fillopacity: "fillOpacity",
  "fill-opacity": "fillOpacity",
  fillrule: "fillRule",
  "fill-rule": "fillRule",
  filterres: "filterRes",
  filterunits: "filterUnits",
  floodopacity: "floodOpacity",
  "flood-opacity": "floodOpacity",
  floodcolor: "floodColor",
  "flood-color": "floodColor",
  fontfamily: "fontFamily",
  "font-family": "fontFamily",
  fontsize: "fontSize",
  "font-size": "fontSize",
  fontsizeadjust: "fontSizeAdjust",
  "font-size-adjust": "fontSizeAdjust",
  fontstretch: "fontStretch",
  "font-stretch": "fontStretch",
  fontstyle: "fontStyle",
  "font-style": "fontStyle",
  fontvariant: "fontVariant",
  "font-variant": "fontVariant",
  fontweight: "fontWeight",
  "font-weight": "fontWeight",
  glyphname: "glyphName",
  "glyph-name": "glyphName",
  glyphorientationhorizontal: "glyphOrientationHorizontal",
  "glyph-orientation-horizontal": "glyphOrientationHorizontal",
  glyphorientationvertical: "glyphOrientationVertical",
  "glyph-orientation-vertical": "glyphOrientationVertical",
  glyphref: "glyphRef",
  gradienttransform: "gradientTransform",
  gradientunits: "gradientUnits",
  horizadvx: "horizAdvX",
  "horiz-adv-x": "horizAdvX",
  horizoriginx: "horizOriginX",
  "horiz-origin-x": "horizOriginX",
  imagerendering: "imageRendering",
  "image-rendering": "imageRendering",
  kernelmatrix: "kernelMatrix",
  kernelunitlength: "kernelUnitLength",
  keypoints: "keyPoints",
  keysplines: "keySplines",
  keytimes: "keyTimes",
  lengthadjust: "lengthAdjust",
  letterspacing: "letterSpacing",
  "letter-spacing": "letterSpacing",
  lightingcolor: "lightingColor",
  "lighting-color": "lightingColor",
  limitingconeangle: "limitingConeAngle",
  markerend: "markerEnd",
  "marker-end": "markerEnd",
  markerheight: "markerHeight",
  markermid: "markerMid",
  "marker-mid": "markerMid",
  markerstart: "markerStart",
  "marker-start": "markerStart",
  markerunits: "markerUnits",
  markerwidth: "markerWidth",
  maskcontentunits: "maskContentUnits",
  maskunits: "maskUnits",
  numoctaves: "numOctaves",
  overlineposition: "overlinePosition",
  "overline-position": "overlinePosition",
  overlinethickness: "overlineThickness",
  "overline-thickness": "overlineThickness",
  paintorder: "paintOrder",
  "paint-order": "paintOrder",
  "panose-1": "panose1",
  pathlength: "pathLength",
  patterncontentunits: "patternContentUnits",
  patterntransform: "patternTransform",
  patternunits: "patternUnits",
  pointerevents: "pointerEvents",
  "pointer-events": "pointerEvents",
  pointsatx: "pointsAtX",
  pointsaty: "pointsAtY",
  pointsatz: "pointsAtZ",
  preservealpha: "preserveAlpha",
  preserveaspectratio: "preserveAspectRatio",
  primitiveunits: "primitiveUnits",
  refx: "refX",
  refy: "refY",
  renderingintent: "renderingIntent",
  "rendering-intent": "renderingIntent",
  repeatcount: "repeatCount",
  repeatdur: "repeatDur",
  requiredextensions: "requiredExtensions",
  requiredfeatures: "requiredFeatures",
  shaperendering: "shapeRendering",
  "shape-rendering": "shapeRendering",
  specularconstant: "specularConstant",
  specularexponent: "specularExponent",
  spreadmethod: "spreadMethod",
  startoffset: "startOffset",
  stddeviation: "stdDeviation",
  stitchtiles: "stitchTiles",
  stopcolor: "stopColor",
  "stop-color": "stopColor",
  stopopacity: "stopOpacity",
  "stop-opacity": "stopOpacity",
  strikethroughposition: "strikethroughPosition",
  "strikethrough-position": "strikethroughPosition",
  strikethroughthickness: "strikethroughThickness",
  "strikethrough-thickness": "strikethroughThickness",
  strokedasharray: "strokeDasharray",
  "stroke-dasharray": "strokeDasharray",
  strokedashoffset: "strokeDashoffset",
  "stroke-dashoffset": "strokeDashoffset",
  strokelinecap: "strokeLinecap",
  "stroke-linecap": "strokeLinecap",
  strokelinejoin: "strokeLinejoin",
  "stroke-linejoin": "strokeLinejoin",
  strokemiterlimit: "strokeMiterlimit",
  "stroke-miterlimit": "strokeMiterlimit",
  strokewidth: "strokeWidth",
  "stroke-width": "strokeWidth",
  strokeopacity: "strokeOpacity",
  "stroke-opacity": "strokeOpacity",
  suppresscontenteditablewarning: "suppressContentEditableWarning",
  suppresshydrationwarning: "suppressHydrationWarning",
  surfacescale: "surfaceScale",
  systemlanguage: "systemLanguage",
  tablevalues: "tableValues",
  targetx: "targetX",
  targety: "targetY",
  textanchor: "textAnchor",
  "text-anchor": "textAnchor",
  textdecoration: "textDecoration",
  "text-decoration": "textDecoration",
  textlength: "textLength",
  textrendering: "textRendering",
  "text-rendering": "textRendering",
  underlineposition: "underlinePosition",
  "underline-position": "underlinePosition",
  underlinethickness: "underlineThickness",
  "underline-thickness": "underlineThickness",
  unicodebidi: "unicodeBidi",
  "unicode-bidi": "unicodeBidi",
  unicoderange: "unicodeRange",
  "unicode-range": "unicodeRange",
  unitsperem: "unitsPerEm",
  "units-per-em": "unitsPerEm",
  unselectable: "unselectable",
  valphabetic: "vAlphabetic",
  "v-alphabetic": "vAlphabetic",
  vectoreffect: "vectorEffect",
  "vector-effect": "vectorEffect",
  vertadvy: "vertAdvY",
  "vert-adv-y": "vertAdvY",
  vertoriginx: "vertOriginX",
  "vert-origin-x": "vertOriginX",
  vertoriginy: "vertOriginY",
  "vert-origin-y": "vertOriginY",
  vhanging: "vHanging",
  "v-hanging": "vHanging",
  videographic: "vIdeographic",
  "v-ideographic": "vIdeographic",
  viewbox: "viewBox",
  viewtarget: "viewTarget",
  vmathematical: "vMathematical",
  "v-mathematical": "vMathematical",
  wordspacing: "wordSpacing",
  "word-spacing": "wordSpacing",
  writingmode: "writingMode",
  "writing-mode": "writingMode",
  xchannelselector: "xChannelSelector",
  xheight: "xHeight",
  "x-height": "xHeight",
  xlinkactuate: "xlinkActuate",
  "xlink:actuate": "xlinkActuate",
  xlinkarcrole: "xlinkArcrole",
  "xlink:arcrole": "xlinkArcrole",
  xlinkhref: "xlinkHref",
  "xlink:href": "xlinkHref",
  xlinkrole: "xlinkRole",
  "xlink:role": "xlinkRole",
  xlinkshow: "xlinkShow",
  "xlink:show": "xlinkShow",
  xlinktitle: "xlinkTitle",
  "xlink:title": "xlinkTitle",
  xlinktype: "xlinkType",
  "xlink:type": "xlinkType",
  xmlbase: "xmlBase",
  "xml:base": "xmlBase",
  xmllang: "xmlLang",
  "xml:lang": "xmlLang",
  "xml:space": "xmlSpace",
  xmlnsxlink: "xmlnsXlink",
  "xmlns:xlink": "xmlnsXlink",
  xmlspace: "xmlSpace",
  ychannelselector: "yChannelSelector",
  zoomandpan: "zoomAndPan",
  // event handlers
  onblur: "onBlur",
  onchange: "onChange",
  onclick: "onClick",
  oncontextmenu: "onContextMenu",
  ondoubleclick: "onDoubleClick",
  ondrag: "onDrag",
  ondragend: "onDragEnd",
  ondragenter: "onDragEnter",
  ondragexit: "onDragExit",
  ondragleave: "onDragLeave",
  ondragover: "onDragOver",
  ondragstart: "onDragStart",
  ondrop: "onDrop",
  onerror: "onError",
  onfocus: "onFocus",
  oninput: "onInput",
  oninvalid: "onInvalid",
  onkeydown: "onKeyDown",
  onkeypress: "onKeyPress",
  onkeyup: "onKeyUp",
  onload: "onLoad",
  onmousedown: "onMouseDown",
  onmouseenter: "onMouseEnter",
  onmouseleave: "onMouseLeave",
  onmousemove: "onMouseMove",
  onmouseout: "onMouseOut",
  onmouseover: "onMouseOver",
  onmouseup: "onMouseUp",
  onscroll: "onScroll",
  onsubmit: "onSubmit",
  ontouchcancel: "onTouchCancel",
  ontouchend: "onTouchEnd",
  ontouchmove: "onTouchMove",
  ontouchstart: "onTouchStart",
  onwheel: "onWheel"
};
function HN(e, t) {
  var i;
  const { key: n, level: r, ...u } = t;
  switch (e.nodeType) {
    case 1:
      return Y.createElement(
        VN(e.nodeName),
        $N(e, n),
        Lp(e.childNodes, r, u)
      );
    case 3: {
      const a = ((i = e.nodeValue) == null ? void 0 : i.toString()) ?? "";
      if (!u.allowWhiteSpaces && /^\s+$/.test(a) && !/[\u00A0\u202F]/.test(a))
        return null;
      if (!e.parentNode)
        return a;
      const o = e.parentNode.nodeName.toLowerCase();
      return FN.includes(o) ? (/\S/.test(a) && console.warn(
        `A textNode is not allowed inside '${o}'. Your text "${a}" will be ignored`
      ), null) : a;
    }
    case 8:
      return null;
    case 11:
      return Lp(e.childNodes, r, t);
    default:
      return null;
  }
}
function $N(e, t) {
  const n = {
    key: t
  };
  if (e instanceof Element) {
    const r = e.getAttribute("class");
    r && (n.className = r), [...e.attributes].forEach((u) => {
      switch (u.name) {
        case "class":
          break;
        case "style":
          n[u.name] = RN(u.value);
          break;
        case "allowfullscreen":
        case "allowpaymentrequest":
        case "async":
        case "autofocus":
        case "autoplay":
        case "checked":
        case "controls":
        case "default":
        case "defer":
        case "disabled":
        case "formnovalidate":
        case "hidden":
        case "ismap":
        case "itemscope":
        case "loop":
        case "multiple":
        case "muted":
        case "nomodule":
        case "novalidate":
        case "open":
        case "readonly":
        case "required":
        case "reversed":
        case "selected":
        case "typemustmatch":
          n[kp[u.name] || u.name] = !0;
          break;
        default:
          n[kp[u.name] || u.name] = u.value;
      }
    });
  }
  return n;
}
function Lp(e, t, n) {
  const r = [...e].map(
    (u, i) => eo(u, {
      ...n,
      index: i,
      level: t + 1
    })
  ).filter(Boolean);
  return r.length ? r : null;
}
function VN(e) {
  return /[a-z]+[A-Z]+[a-z]+/.test(e) ? e : e.toLowerCase();
}
function eo(e, t = {}) {
  if (!e || !(e instanceof Node))
    return null;
  const { actions: n = [], index: r = 0, level: u = 0, randomKey: i } = t;
  let a = e, o = `${u}-${r}`;
  const s = [];
  return i && u === 0 && (o = `${BN()}-${o}`), Array.isArray(n) && n.forEach((c) => {
    c.condition(a, o, u) && (typeof c.pre == "function" && (a = c.pre(a, o, u), a instanceof Node || (a = e)), typeof c.post == "function" && s.push(c.post(a, o, u)));
  }), s.length ? s : HN(a, { key: o, level: u, ...t });
}
function jN(e, t = {}) {
  if (!e || typeof e != "string")
    return null;
  const {
    includeAllNodes: n = !1,
    nodeOnly: r = !1,
    selector: u = "body > *",
    type: i = "text/html"
  } = t;
  try {
    const o = new DOMParser().parseFromString(e, i);
    if (n) {
      const { childNodes: c } = o.body;
      return r ? c : [...c].map((l) => eo(l, t));
    }
    const s = o.querySelector(u) || o.body.childNodes[0];
    if (!(s instanceof Node))
      throw new TypeError("Error parsing input");
    return r ? s : eo(s, t);
  } catch {
  }
  return null;
}
function h3(e, t = {}) {
  return typeof e == "string" ? jN(e, t) : e instanceof Node ? eo(e, t) : null;
}
var zN = Object.defineProperty, UN = (e, t, n) => t in e ? zN(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n, ha = (e, t, n) => UN(e, typeof t != "symbol" ? t + "" : t, n), Dp = "react-inlinesvg", Np = 10, ze = {
  IDLE: "idle",
  LOADING: "loading",
  LOADED: "loaded",
  FAILED: "failed",
  READY: "ready",
  UNSUPPORTED: "unsupported"
};
function Na() {
  return !!(typeof window < "u" && window.document && window.document.createElement);
}
function qN() {
  return WN() && typeof window < "u" && window !== null;
}
async function m3(e, t) {
  const n = await fetch(e, t), r = n.headers.get("content-type"), [u] = (r ?? "").split(/ ?; ?/);
  if (n.status > 299)
    throw new Error("Not found");
  if (!["image/svg+xml", "text/plain"].some((i) => u.includes(i)))
    throw new Error(`Content type isn't valid: ${u}`);
  return n.text();
}
function GN(e = 1) {
  return new Promise((t) => {
    setTimeout(t, e * 1e3);
  });
}
function WN() {
  if (!document)
    return !1;
  const e = document.createElement("div");
  e.innerHTML = "<svg />";
  const t = e.firstChild;
  return !!t && t.namespaceURI === "http://www.w3.org/2000/svg";
}
function KN(e) {
  return e[Math.floor(Math.random() * e.length)];
}
function YN(e) {
  const t = "abcdefghijklmnopqrstuvwxyz", n = "1234567890", r = `${t}${t.toUpperCase()}${n}`;
  let u = "";
  for (let i = 0; i < e; i++)
    u += KN(r);
  return u;
}
function ZN(e, ...t) {
  const n = {};
  for (const r in e)
    ({}).hasOwnProperty.call(e, r) && (t.includes(r) || (n[r] = e[r]));
  return n;
}
var XN = class {
  constructor() {
    ha(this, "cacheApi"), ha(this, "cacheStore"), ha(this, "subscribers", []), ha(this, "isReady", !1), this.cacheStore = /* @__PURE__ */ new Map();
    let e = Dp, t = !1;
    Na() && (e = window.REACT_INLINESVG_CACHE_NAME ?? Dp, t = !!window.REACT_INLINESVG_PERSISTENT_CACHE && "caches" in window), t ? caches.open(e).then((n) => {
      this.cacheApi = n;
    }).catch((n) => {
      console.error(`Failed to open cache: ${n.message}`);
    }).finally(() => {
      this.isReady = !0, this.subscribers.forEach((n) => n());
    }) : this.isReady = !0;
  }
  onReady(e) {
    this.isReady ? e() : this.subscribers.push(e);
  }
  async get(e, t) {
    var n;
    return await (this.cacheApi ? this.fetchAndAddToPersistentCache(e, t) : this.fetchAndAddToInternalCache(e, t)), ((n = this.cacheStore.get(e)) == null ? void 0 : n.content) ?? "";
  }
  set(e, t) {
    this.cacheStore.set(e, t);
  }
  isCached(e) {
    var t;
    return ((t = this.cacheStore.get(e)) == null ? void 0 : t.status) === ze.LOADED;
  }
  async fetchAndAddToInternalCache(e, t) {
    const n = this.cacheStore.get(e);
    if ((n == null ? void 0 : n.status) === ze.LOADING) {
      await this.handleLoading(e, async () => {
        this.cacheStore.set(e, { content: "", status: ze.IDLE }), await this.fetchAndAddToInternalCache(e, t);
      });
      return;
    }
    if (!(n != null && n.content)) {
      this.cacheStore.set(e, { content: "", status: ze.LOADING });
      try {
        const r = await m3(e, t);
        this.cacheStore.set(e, { content: r, status: ze.LOADED });
      } catch (r) {
        throw this.cacheStore.set(e, { content: "", status: ze.FAILED }), r;
      }
    }
  }
  async fetchAndAddToPersistentCache(e, t) {
    var u, i, a;
    const n = this.cacheStore.get(e);
    if ((n == null ? void 0 : n.status) === ze.LOADED)
      return;
    if ((n == null ? void 0 : n.status) === ze.LOADING) {
      await this.handleLoading(e, async () => {
        this.cacheStore.set(e, { content: "", status: ze.IDLE }), await this.fetchAndAddToPersistentCache(e, t);
      });
      return;
    }
    this.cacheStore.set(e, { content: "", status: ze.LOADING });
    const r = await ((u = this.cacheApi) == null ? void 0 : u.match(e));
    if (r) {
      const o = await r.text();
      this.cacheStore.set(e, { content: o, status: ze.LOADED });
      return;
    }
    try {
      await ((i = this.cacheApi) == null ? void 0 : i.add(new Request(e, t)));
      const o = await ((a = this.cacheApi) == null ? void 0 : a.match(e)), s = await (o == null ? void 0 : o.text()) ?? "";
      this.cacheStore.set(e, { content: s, status: ze.LOADED });
    } catch (o) {
      throw this.cacheStore.set(e, { content: "", status: ze.FAILED }), o;
    }
  }
  async handleLoading(e, t) {
    var r;
    let n = 0;
    for (; ((r = this.cacheStore.get(e)) == null ? void 0 : r.status) === ze.LOADING && n < Np; )
      await GN(0.1), n += 1;
    n >= Np && await t();
  }
  keys() {
    return [...this.cacheStore.keys()];
  }
  data() {
    return [...this.cacheStore.entries()].map(([e, t]) => ({ [e]: t }));
  }
  async delete(e) {
    this.cacheApi && await this.cacheApi.delete(e), this.cacheStore.delete(e);
  }
  async clear() {
    if (this.cacheApi) {
      const e = await this.cacheApi.keys();
      for (const t of e)
        await this.cacheApi.delete(t);
    }
    this.cacheStore.clear();
  }
};
function Op(e) {
  const t = Z();
  return oe(() => {
    t.current = e;
  }), t.current;
}
function QN(e) {
  const {
    baseURL: t,
    content: n,
    description: r,
    handleError: u,
    hash: i,
    preProcessor: a,
    title: o,
    uniquifyIDs: s = !1
  } = e;
  try {
    const c = JN(n, a), l = h3(c, { nodeOnly: !0 });
    if (!l || !(l instanceof SVGSVGElement))
      throw new Error("Could not convert the src to a DOM Node");
    const d = g3(l, { baseURL: t, hash: i, uniquifyIDs: s });
    if (r) {
      const f = d.querySelector("desc");
      f != null && f.parentNode && f.parentNode.removeChild(f);
      const p = document.createElementNS("http://www.w3.org/2000/svg", "desc");
      p.innerHTML = r, d.prepend(p);
    }
    if (typeof o < "u") {
      const f = d.querySelector("title");
      if (f != null && f.parentNode && f.parentNode.removeChild(f), o) {
        const p = document.createElementNS("http://www.w3.org/2000/svg", "title");
        p.innerHTML = o, d.prepend(p);
      }
    }
    return d;
  } catch (c) {
    return u(c);
  }
}
function JN(e, t) {
  return t ? t(e) : e;
}
function g3(e, t) {
  const { baseURL: n = "", hash: r, uniquifyIDs: u } = t, i = ["id", "href", "xlink:href", "xlink:role", "xlink:arcrole"], a = ["href", "xlink:href"], o = (s, c) => a.includes(s) && (c ? !c.includes("#") : !1);
  return u && [...e.children].forEach((s) => {
    var c;
    if ((c = s.attributes) != null && c.length) {
      const l = Object.values(s.attributes).map((d) => {
        const f = d, p = /url\((.*?)\)/.exec(d.value);
        return p != null && p[1] && (f.value = d.value.replace(p[0], `url(${n}${p[1]}__${r})`)), f;
      });
      i.forEach((d) => {
        const f = l.find((p) => p.name === d);
        f && !o(d, f.value) && (f.value = `${f.value}__${r}`);
      });
    }
    return s.children.length ? g3(s, t) : s;
  }), e;
}
var pu;
function eO(e) {
  const {
    cacheRequests: t = !0,
    children: n = null,
    description: r,
    fetchOptions: u,
    innerRef: i,
    loader: a = null,
    onError: o,
    onLoad: s,
    src: c,
    title: l,
    uniqueHash: d
  } = e, [f, p] = B4(
    (O, H) => ({
      ...O,
      ...H
    }),
    {
      content: "",
      element: null,
      isCached: t && pu.isCached(e.src),
      status: ze.IDLE
    }
  ), { content: h, element: m, isCached: b, status: x } = f, y = Op(e), g = Op(f), v = Z(d ?? YN(8)), S = Z(!1), _ = Z(!1), A = Ct(
    (O) => {
      S.current && (p({
        status: O.message === "Browser does not support SVG" ? ze.UNSUPPORTED : ze.FAILED
      }), o == null || o(O));
    },
    [o]
  ), k = Ct((O, H = !1) => {
    S.current && p({
      content: O,
      isCached: H,
      status: ze.LOADED
    });
  }, []), T = Ct(async () => {
    const O = await m3(c, u);
    k(O);
  }, [u, k, c]), L = Ct(() => {
    try {
      const O = QN({ ...e, handleError: A, hash: v.current, content: h }), H = h3(O);
      if (!H || !Pi(H))
        throw new Error("Could not convert the src to a React element");
      p({
        element: H,
        status: ze.READY
      });
    } catch (O) {
      A(new Error(O.message));
    }
  }, [h, A, e]), w = Ct(async () => {
    const O = /^data:image\/svg[^,]*?(;base64)?,(.*)/u.exec(c);
    let H;
    if (O ? H = O[1] ? window.atob(O[2]) : decodeURIComponent(O[2]) : c.includes("<svg") && (H = c), H) {
      k(H);
      return;
    }
    try {
      if (t) {
        const $ = await pu.get(c, u);
        k($, !0);
      } else
        await T();
    } catch ($) {
      A($);
    }
  }, [t, T, u, A, k, c]), D = Ct(async () => {
    S.current && p({
      content: "",
      element: null,
      isCached: !1,
      status: ze.LOADING
    });
  }, []);
  oe(
    () => {
      if (S.current = !0, !Na() || _.current)
        return () => {
        };
      try {
        if (x === ze.IDLE) {
          if (!qN())
            throw new Error("Browser does not support SVG");
          if (!c)
            throw new Error("Missing src");
          D();
        }
      } catch (O) {
        A(O);
      }
      return _.current = !0, () => {
        S.current = !1;
      };
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  ), oe(() => {
    if (Na() && y)
      if (y.src !== c) {
        if (!c) {
          A(new Error("Missing src"));
          return;
        }
        D();
      } else
        (y.title !== l || y.description !== r) && L();
  }, [r, L, A, D, y, c, l]), oe(() => {
    g && (g.status !== ze.LOADING && x === ze.LOADING && w(), g.status !== ze.LOADED && x === ze.LOADED && L(), g.status !== ze.READY && x === ze.READY && (s == null || s(c, b)));
  }, [w, L, b, s, g, c, x]);
  const N = ZN(
    e,
    "baseURL",
    "cacheRequests",
    "children",
    "description",
    "fetchOptions",
    "innerRef",
    "loader",
    "onError",
    "onLoad",
    "preProcessor",
    "src",
    "title",
    "uniqueHash",
    "uniquifyIDs"
  );
  return Na() ? m ? Rg(m, { ref: i, ...N }) : [ze.UNSUPPORTED, ze.FAILED].includes(x) ? n : a : a;
}
function tO(e) {
  pu || (pu = new XN());
  const { loader: t } = e, n = Z(!1), [r, u] = me(pu.isReady);
  return oe(() => {
    n.current || (pu.onReady(() => {
      u(!0);
    }), n.current = !0);
  }, []), r ? /* @__PURE__ */ Te.createElement(eO, { ...e }) : t;
}
const nO = ({ props: e }) => /* @__PURE__ */ E(tO, { ...e }) || null, rO = (e) => /* @__PURE__ */ E(
  nO,
  {
    props: {
      uniquifyIDs: !0,
      src: e
    }
  }
);
const uO = "GraphicShape", Qc = ({
  renderBackgroundImage: e,
  graphicVersion: t,
  graphicColor: n,
  ...r
}) => {
  const { foundationGrid: u } = ke(yn), i = Z(), o = (u === "compact" ? PN : p3)[t || "HeroSplit01Large"], s = MN[n || "GoldOnWhite"], c = o == null ? void 0 : o.canUseImage;
  let l = c ? "var(--color-primary)" : "var(--color-background)";
  c && e && (l = "unset");
  const d = hr(), f = n === "WhiteOnBlue600" ? "unset" : "var(--color-background)";
  return /* @__PURE__ */ W($i, { features: Iu }, /* @__PURE__ */ W(
    Rr.div,
    {
      ref: i,
      css: B`
          --graphic-offset: ${(o == null ? void 0 : o.graphicOffset) || 0};
          --graphic-height: ${(o == null ? void 0 : o.graphicHeight) || "100%"};
          --color-primary: ${s == null ? void 0 : s.primary};
          --color-secondary: ${s == null ? void 0 : s.secondary};
          --color-overlap: ${s == null ? void 0 : s.overlap};
          --color-background: ${s == null ? void 0 : s.background};
          --color-svg-background: ${l};
          --height: 100vw;
          --min-height: unset;
          --image: 100%;
          --svg-height: 72%;
          --svg-ratio: ${(o == null ? void 0 : o.svgRatio) || " 2.333"};

          @media (min-width: ${ut.md}) {
            --graphic-offset: 0%;
          }

          @media (max-width: ${nr.sm}) {
            height: var(--height);
          }

          @media (min-width: ${ut.lg}) {
            --height: 50vw;
          }

          @media (min-width: ${ut["2xl"]}) {
            --height: 60rem;
          }

          position: relative;
          overflow: hidden;
          display: flex;
          align-items: center;
          justify-content: center;
          height: var(--height);
          min-height: var(--min-height);
          backface-visibility: hidden;
          margin-top: -1px;
          margin-bottom: -1px;
          z-index: 0;

          // before and after elements cover the background color bleed
          ::before {
            position: absolute;
            top: -1px;
            background-color: ${f};
            display: block;
            width: 100%;
            height: 1.5px;
            content: '';
            z-index: 2;
            background-blend-mode: lighten;
          }
          ::after {
            position: absolute;
            bottom: -1px;
            background-color: ${f};
            display: block;
            width: 100%;
            height: 2px;
            content: '';
            z-index: 2;
            background-blend-mode: lighten;
          }

          // fine tunings of color bleed fix for some components
          &.split-graphic-background {
            ::after {
              height: 1.5px;
            }
            @media (min-width: ${ut.md}) {
              height: calc(var(--height) + 1.5px);
            }
          }
          &.section-wrapper-graphics-top,
          &.section-wrapper-graphics-bottom {
            ::before {
              height: 0;
            }
            ::after {
              height: 0;
            }
          }
        `,
      initial: {
        opacity: d ? 1 : 0
      },
      animate: {
        opacity: 1
      },
      transition: {
        delay: d ? 0 : 0.02
      },
      ...r
    },
    /* @__PURE__ */ W("div", { className: "graphic-shape-svg", "aria-hidden": !0 }, o.svgSrc && rO(o.svgSrc)),
    e && e(i)
  ));
};
Qc.displayName = uO;
const b3 = "SectionWrapperGraphics", qs = new ye(b3), v3 = ({
  graphicShapeOptions: e = {}
}) => {
  if (!e.top && !e.bottom)
    return null;
  const n = B`
    --height: 43vw;
    --min-height: unset;
    --image: 100%;
    --color-background: transparent;
    --graphic-offset: 0;
    position: absolute;
    width: 100%;
    z-index: 0;

    @media (min-width: ${ut.md}) {
      --height: 45vw;
    }

    @media (min-width: ${ut.xl}) {
      --height: 43vw;
    }
    @media (min-width: ${ut["2xl"]}) {
      --height: 61rem;

      .graphic-shape-svg {
        width: 100%;
      }
    }
  `;
  return /* @__PURE__ */ W("div", { className: qs.getElementClassName("container") }, (e == null ? void 0 : e.top) && /* @__PURE__ */ W(
    Qc,
    {
      className: qs.getElementClassName("top"),
      css: B`
            ${n}
            top: 0;
          `,
      ...e.top
    }
  ), (e == null ? void 0 : e.bottom) && /* @__PURE__ */ W(
    Qc,
    {
      className: qs.getElementClassName("bottom"),
      css: B`
            ${n}
            bottom: 0;
          `,
      ...e.bottom
    }
  ));
};
v3.displayName = b3;
const E0 = "SectionWrapper", iO = new ye(E0), y3 = ({
  children: e,
  disclosure: t,
  className: n,
  messageId: r,
  theme: u = "white",
  isThemeEnabled: i = !0,
  gridProps: a = {},
  renderBottomContent: o,
  disclosureWrapper: s,
  disclosureGridItemProps: c,
  id: l,
  rootRef: d,
  as: f = "section",
  ...p
}) => {
  const h = U(
    n,
    iO.getComponentClassName(),
    i && Or.getThemeClassName(u)
  ), m = {
    ...c,
    options: {
      topSpacing: "4vw",
      ...c == null ? void 0 : c.options
    }
  };
  return /* @__PURE__ */ ue(
    Hg,
    {
      ref: d,
      className: h,
      "data-messageid": r,
      id: l,
      as: f,
      ...p,
      ...a,
      children: [
        e,
        t && /* @__PURE__ */ E(jg, { ...m, children: /* @__PURE__ */ E(s, { ...t }) }),
        o && o()
      ]
    }
  );
}, aO = at(
  (e, t) => /* @__PURE__ */ E(Vr, { as: "section", rootRef: t, ...e })
), oO = at(
  (e, t) => /* @__PURE__ */ E(Rr.section, { ref: t, ...e })
), sO = (e) => {
  const t = {
    ...e,
    motion: e.motion ?? "default"
  };
  if (t.motion === "none")
    return {};
  if (t.motion === "custom")
    return {
      as: oO,
      ...t.motionProps
    };
  let n;
  return e.motion === "standard" ? n = e.motionOptions ?? Fc : n = Fc, {
    /* This prop be used by the Grid emotion render function to determine what root element to render */
    as: aO,
    /* This prop will be used directly by the `MotionSection`, which ends up leveraging the `Motion` component */
    motionOptions: n
  };
}, cO = ({
  graphicVersionTop: e,
  graphicColorTop: t,
  graphicVersionBottom: n,
  graphicColorBottom: r
}) => ({ graphicShapeOptions: {
  top: e && {
    graphicVersion: e,
    graphicColor: t
  },
  bottom: n && {
    graphicVersion: n,
    graphicColor: r
  }
} }), lO = (e) => {
  const t = {};
  return Object.keys(e).forEach((n) => {
    if (n.startsWith("aria-")) {
      const r = n, u = e[r];
      t[r] = u;
    }
  }), t;
}, dO = ({
  options: e = {},
  mdOptions: t = {},
  lgOptions: n = {},
  ...r
}) => {
  const u = {
    as: "section",
    options: e,
    mdOptions: t,
    lgOptions: n
  }, i = sO(r);
  return Object.assign(u, i);
}, fO = at(
  ({
    children: e,
    disclosure: t,
    className: n,
    messageId: r,
    theme: u = "white",
    isThemeEnabled: i = !0,
    disclosureGridItemProps: a,
    id: o,
    role: s,
    as: c = "section",
    ...l
  }, d) => {
    const f = lO(l), p = dO(l), h = cO(l);
    return /* @__PURE__ */ E(
      y3,
      {
        className: n,
        messageId: r,
        disclosure: t,
        theme: u,
        isThemeEnabled: i,
        gridProps: p,
        renderBottomContent: () => /* @__PURE__ */ E(v3, { ...h }),
        disclosureWrapper: Uo,
        disclosureGridItemProps: a,
        id: o,
        rootRef: d,
        role: s,
        as: c,
        ...f,
        children: e
      }
    );
  }
);
fO.displayName = E0;
const x3 = "IconButton", Gs = new ye(x3), _3 = at(
  ({
    inverse: e = !1,
    closeAriaLabel: t = "Close",
    analyticsCompName: n,
    iconClick: r,
    clickDataEvent: u,
    serverFptiData: i
  }, a) => {
    const { environment: { pageSegment: o = "" } = {} } = nt(), s = () => u || (n ? Ht(
      {
        componentName: n,
        ariaLabel: t,
        clickEvent: Wi.Button,
        serverFptiData: i
      },
      o,
      yt.CTA
    ) : ""), c = U(Gs.getElementClassName("wrapper")), l = () => {
      const d = U({
        [Gs.getElementClassName("circle-inverse")]: e
      }), f = U({
        [Gs.getElementClassName("close-incerse")]: e
      });
      return /* @__PURE__ */ ue(
        "svg",
        {
          width: "48",
          height: "48",
          viewBox: "0 0 48 48",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg",
          "aria-hidden": "true",
          children: [
            /* @__PURE__ */ E("title", { children: "button" }),
            /* @__PURE__ */ E(
              "path",
              {
                className: d,
                d: "M0 24C0 10.7452 10.7452 0 24 0C37.2548 0 48 10.7452 48 24C48 37.2548 37.2548 48 24 48C10.7452 48 0 37.2548 0 24Z",
                fill: "#001C64"
              }
            ),
            /* @__PURE__ */ E(
              "path",
              {
                className: f,
                d: "M30.5016 20.6014C30.8921 20.2109 30.8921 19.5777 30.5016 19.1872C30.1111 18.7967 29.4779 18.7967 29.0874 19.1872L24.8453 23.4293L20.6033 19.1873C20.2128 18.7968 19.5796 18.7968 19.1891 19.1873C18.7986 19.5779 18.7986 20.211 19.1891 20.6015L23.4311 24.8435L19.1879 29.0867C18.7974 29.4772 18.7974 30.1104 19.1879 30.5009C19.5784 30.8914 20.2116 30.8914 20.6021 30.5009L24.8453 26.2577L29.0886 30.501C29.4791 30.8916 30.1123 30.8916 30.5028 30.501C30.8934 30.1105 30.8934 29.4774 30.5028 29.0868L26.2595 24.8435L30.5016 20.6014Z",
                fill: "white"
              }
            )
          ]
        }
      );
    };
    return /* @__PURE__ */ E(
      "button",
      {
        "aria-label": t,
        type: "button",
        "data-pa-click": s(),
        className: c,
        onClick: r,
        ref: a,
        children: l()
      }
    );
  }
);
_3.displayName = x3;
const S3 = "Modal", Xu = new ye(S3);
var Pg;
const Qu = typeof window < "u" ? (Pg = window == null ? void 0 : window.document) == null ? void 0 : Pg.createElement("div") : null, C3 = ({
  isShowing: e,
  hide: t,
  children: n,
  ariaLabel: r,
  ariaLabelCloseBtn: u,
  clickDataEventCloseBtn: i,
  additionalElmtProps: a = {
    overlay: {},
    headerElmt: {},
    bodyElmt: {}
  },
  customWrapper: o = "div"
}) => {
  const s = Z(null), c = Z(null), l = Z(null), d = Z(null), f = {
    role: "dialog",
    "aria-modal": "true",
    "aria-hidden": !1,
    "aria-label": r
  };
  return oe(() => {
    const h = (m) => {
      m.key === "Escape" && e && t();
    };
    return window.addEventListener("keydown", h), () => window.removeEventListener("keydown", h);
  }, [e, t]), oe(() => {
    const h = (m) => {
      var b, x;
      s != null && s.current && !((b = s == null ? void 0 : s.current) != null && b.contains(m.target)) && !((x = l == null ? void 0 : l.current) != null && x.contains(m.target)) && t();
    };
    return window.addEventListener("mousedown", h), () => window.removeEventListener("mousedown", h);
  }, [t]), oe(() => {
    var h, m;
    return Qu && e && (d.current = document.activeElement, Qu.id = "portal-root", (h = document == null ? void 0 : document.body) == null || h.appendChild(Qu), (m = c.current) == null || m.focus()), e ? document.body.style.overflow = "hidden" : document.body.style.overflow = "auto", () => {
      d.current && d.current.focus();
    };
  }, [e]), e && Qu ? Y4((() => /* @__PURE__ */ ue(on, { children: [
    /* @__PURE__ */ E(
      o,
      {
        className: Xu.getElementClassName("overlay"),
        ...a == null ? void 0 : a.overlay
      }
    ),
    /* @__PURE__ */ ue(
      "div",
      {
        className: Xu.getElementClassName("modal"),
        ...f,
        children: [
          /* @__PURE__ */ E(
            o,
            {
              className: Xu.getElementClassName("header"),
              ...a == null ? void 0 : a.header,
              children: /* @__PURE__ */ E(
                _3,
                {
                  closeAriaLabel: u,
                  clickDataEvent: i,
                  inverse: !0,
                  iconClick: t,
                  ref: c
                }
              )
            }
          ),
          /* @__PURE__ */ E(
            o,
            {
              className: Xu.getElementClassName("body"),
              ...a == null ? void 0 : a.body,
              children: /* @__PURE__ */ E("div", { ref: l, children: n })
            }
          ),
          /* @__PURE__ */ E(
            "div",
            {
              ref: s,
              className: Xu.getElementClassName("footer")
            }
          )
        ]
      }
    )
  ] }))(), Qu) : null;
}, pO = {
  motionOptions: {
    motionFeel: "Expressive",
    motionIntensity: "sm",
    motionTypePreset: "appear"
  }
}, hO = {
  motionOptions: {
    motionFeel: "Expressive",
    motionIntensity: "md",
    motionTypePreset: "relativeMoveUp"
  }
}, mO = {
  motionOptions: {
    motionFeel: "Expressive",
    motionIntensity: "md",
    motionTypePreset: "relativeMoveUp"
  }
}, w0 = ({
  isShowing: e,
  hide: t,
  children: n,
  ariaLabel: r,
  ariaLabelCloseBtn: u,
  clickDataEventCloseBtn: i
}) => /* @__PURE__ */ E(
  C3,
  {
    isShowing: e,
    hide: t,
    ariaLabel: r,
    ariaLabelCloseBtn: u,
    clickDataEventCloseBtn: i,
    customWrapper: Vr,
    additionalElmtProps: {
      overlay: pO,
      body: mO,
      header: hO
    },
    children: n
  }
);
w0.displayName = S3;
const E3 = () => {
  const [e, t] = me(!1);
  function n() {
    t(!e);
  }
  return {
    isShowing: e,
    toggle: n
  };
};
var Ir = /* @__PURE__ */ ((e) => (e[e.UNSTARTED = -1] = "UNSTARTED", e[e.ENDED = 0] = "ENDED", e[e.PLAYING = 1] = "PLAYING", e[e.PAUSED = 2] = "PAUSED", e[e.BUFFERING = 3] = "BUFFERING", e[e.CUED = 5] = "CUED", e))(Ir || {}), iu = /* @__PURE__ */ ((e) => (e.playVideo = "playVideo", e.pauseVideo = "pauseVideo", e.seekTo = "seekTo", e.mute = "mute", e.unMute = "unMute", e))(iu || {});
const gO = (e) => `https://www.youtube-nocookie.com/embed/${e}?autoplay=1&rel=0&autohide=2&border=0&wmode=opaque&showinfo=0&hd=1&playsinline=1&enablejsapi=1`, Ip = new ye("YoutubeVideo"), T0 = ({
  videoId: e,
  onReady: t,
  onStateChange: n,
  className: r,
  roundedStyle: u = !1,
  /*
    TODO:
    Add this prop to the VideoFrame and EndCardCollection content models so
    it comes from ECM. This needs to be localized.
  */
  title: i = "YouTube Video Player"
}) => {
  const a = Z(null);
  function o(p, h, ...m) {
    let b;
    p === "listening" ? b = '{"event": "listening"}' : b = JSON.stringify({
      event: "command",
      func: h,
      args: m
    }), setTimeout(() => {
      var x, y;
      (y = (x = a == null ? void 0 : a.current) == null ? void 0 : x.contentWindow) == null || y.postMessage(
        b,
        "https://www.youtube-nocookie.com"
      );
    });
  }
  function s(p) {
    if (p.origin !== "https://www.youtube-nocookie.com")
      return !1;
    const h = JSON.parse(p.data);
    if (!h.info)
      return !1;
    const { playerState: m } = h.info;
    return typeof m == "number" && m > Ir.UNSTARTED && m < Ir.CUED;
  }
  function c(p) {
    if (!s(p))
      return;
    const { playerState: h } = JSON.parse(p.data).info;
    typeof t == "function" && (n == null || n(h));
  }
  const l = {
    playVideo() {
      o("command", iu.playVideo);
    },
    pauseVideo() {
      o("command", iu.pauseVideo);
    },
    seekTo: (p) => {
      o("command", iu.seekTo, p);
    },
    mute() {
      o("command", iu.mute);
    },
    unMute() {
      o("command", iu.unMute);
    }
  };
  function d() {
    o("listening"), t == null || t(l);
  }
  if (oe(() => {
    const p = a.current;
    return window.addEventListener("message", c), p == null || p.addEventListener("load", d), () => {
      window.removeEventListener("message", c), p == null || p.removeEventListener("load", d);
    };
  }, []), !e)
    return null;
  const f = U(
    r,
    Ip.getComponentClassName(),
    u && Ip.getElementClassName("rounded-dimensions")
  );
  return /* @__PURE__ */ E("div", { className: f, children: /* @__PURE__ */ E(
    "iframe",
    {
      ref: a,
      title: i,
      src: gO(e),
      allow: "autoplay; fullscreen",
      sandbox: "allow-scripts allow-same-origin allow-presentation"
    }
  ) });
};
const A0 = "InlinePlayButton", vu = new ye(A0), w3 = () => {
  const e = U(vu.getElementClassName("play-svg")), t = U(vu.getElementClassName("circle")), n = U(vu.getElementClassName("triangle"));
  return /* @__PURE__ */ ue(
    "svg",
    {
      className: e,
      viewBox: "0 0 80 81",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ E(
          "path",
          {
            className: t,
            d: "M0 40.5122C0 18.4208 17.9086 0.512207 40 0.512207V0.512207C62.0914 0.512207 80 18.4208 80 40.5122V40.5122C80 62.6036 62.0914 80.5122 40 80.5122V80.5122C17.9086 80.5122 0 62.6036 0 40.5122V40.5122Z",
            fill: "none"
          }
        ),
        /* @__PURE__ */ E(
          "path",
          {
            className: n,
            d: "M29.3164 50.4622V32.1643C29.3164 28.8916 32.9162 26.8965 35.6914 28.631L50.3297 37.7799C52.9409 39.4119 52.9409 43.2146 50.3297 44.8466L35.6914 53.9955C32.9162 55.73 29.3164 53.7349 29.3164 50.4622Z",
            fill: "none"
          }
        )
      ]
    }
  );
}, bO = () => {
  const e = U(vu.getElementClassName("replay-svg"));
  return /* @__PURE__ */ ue(
    "svg",
    {
      className: e,
      width: "41",
      height: "40",
      viewBox: "0 0 41 40",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ E("rect", { x: "0.5", width: "40", height: "40", rx: "20", fill: "white" }),
        /* @__PURE__ */ E(
          "path",
          {
            d: "M27.4295 20.997C27.5075 20.4503 27.9477 20 28.5 20C29.0523 20 29.5058 20.4494 29.4452 20.9984C28.9485 25.4991 25.1331 29 20.5 29C15.5294 29 11.5 24.9706 11.5 20C11.5 15.0294 15.5294 11 20.5 11C23.3273 11 25.85 12.3037 27.5 14.3427V12C27.5 11.4477 27.9477 11 28.5 11C29.0523 11 29.5 11.4477 29.5 12V17C29.5 17.5523 29.0523 18 28.5 18H23.5C22.9477 18 22.5 17.5523 22.5 17C22.5 16.4477 22.9477 16 23.5 16H26.2453C24.9804 14.1865 22.8787 13 20.5 13C16.634 13 13.5 16.134 13.5 20C13.5 23.866 16.634 27 20.5 27C24.0275 27 26.9456 24.3908 27.4295 20.997Z",
            fill: "#545D68"
          }
        )
      ]
    }
  );
}, T3 = ({
  className: e,
  text: t = "",
  analyticsCompName: n = A0,
  ariaLabel: r = "",
  clickEventName: u,
  mid: i,
  iconType: a = "Play",
  onClick: o,
  tabIndex: s,
  serverFptiData: c
}) => {
  const l = U(
    vu.getElementClassName("theme"),
    vu.getComponentClassName(),
    e
  ), { environment: { pageSegment: d = "" } = {} } = nt(), f = Ht(
    {
      componentName: n,
      linkText: t,
      clickEvent: u,
      ariaLabel: r,
      mid: i,
      serverFptiData: c
    },
    d,
    yt.CTA
  );
  return /* @__PURE__ */ ue(
    "button",
    {
      onClick: o,
      "aria-label": r,
      className: l,
      "data-pa-click": n && f,
      type: "button",
      tabIndex: s,
      children: [
        a === "Play" ? w3() : bO(),
        t
      ]
    }
  );
};
T3.displayName = A0;
function F(e, t) {
  return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, {
    raw: {
      value: Object.freeze(t)
    }
  }));
}
function Be() {
  return Be = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        ({}).hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Be.apply(null, arguments);
}
function vO(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function Di(e, t) {
  return Di = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, r) {
    return n.__proto__ = r, n;
  }, Di(e, t);
}
function A3(e, t) {
  e.prototype = Object.create(t.prototype), e.prototype.constructor = e, Di(e, t);
}
function Jc(e) {
  return Jc = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, Jc(e);
}
function yO(e) {
  try {
    return Function.toString.call(e).indexOf("[native code]") !== -1;
  } catch {
    return typeof e == "function";
  }
}
function k3() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (k3 = function() {
    return !!e;
  })();
}
function xO(e, t, n) {
  if (k3())
    return Reflect.construct.apply(null, arguments);
  var r = [null];
  r.push.apply(r, t);
  var u = new (e.bind.apply(e, r))();
  return n && Di(u, n.prototype), u;
}
function el(e) {
  var t = typeof Map == "function" ? /* @__PURE__ */ new Map() : void 0;
  return el = function(r) {
    if (r === null || !yO(r))
      return r;
    if (typeof r != "function")
      throw new TypeError("Super expression must either be null or a function");
    if (t !== void 0) {
      if (t.has(r))
        return t.get(r);
      t.set(r, u);
    }
    function u() {
      return xO(r, arguments, Jc(this).constructor);
    }
    return u.prototype = Object.create(r.prototype, {
      constructor: {
        value: u,
        enumerable: !1,
        writable: !0,
        configurable: !0
      }
    }), Di(u, r);
  }, el(e);
}
function Mp() {
  var e;
  return e = arguments.length - 1, e < 0 || arguments.length <= e ? void 0 : arguments[e];
}
function _O(e) {
  return -e;
}
function SO(e, t) {
  return e + t;
}
function CO(e, t) {
  return e - t;
}
function EO(e, t) {
  return e * t;
}
function wO(e, t) {
  return e / t;
}
function TO() {
  return Math.max.apply(Math, arguments);
}
function AO() {
  return Math.min.apply(Math, arguments);
}
function kO() {
  return Array.of.apply(Array, arguments);
}
var LO = {
  symbols: {
    "*": {
      infix: {
        symbol: "*",
        f: EO,
        notation: "infix",
        precedence: 4,
        rightToLeft: 0,
        argCount: 2
      },
      symbol: "*",
      regSymbol: "\\*"
    },
    "/": {
      infix: {
        symbol: "/",
        f: wO,
        notation: "infix",
        precedence: 4,
        rightToLeft: 0,
        argCount: 2
      },
      symbol: "/",
      regSymbol: "/"
    },
    "+": {
      infix: {
        symbol: "+",
        f: SO,
        notation: "infix",
        precedence: 2,
        rightToLeft: 0,
        argCount: 2
      },
      prefix: {
        symbol: "+",
        f: Mp,
        notation: "prefix",
        precedence: 3,
        rightToLeft: 0,
        argCount: 1
      },
      symbol: "+",
      regSymbol: "\\+"
    },
    "-": {
      infix: {
        symbol: "-",
        f: CO,
        notation: "infix",
        precedence: 2,
        rightToLeft: 0,
        argCount: 2
      },
      prefix: {
        symbol: "-",
        f: _O,
        notation: "prefix",
        precedence: 3,
        rightToLeft: 0,
        argCount: 1
      },
      symbol: "-",
      regSymbol: "-"
    },
    ",": {
      infix: {
        symbol: ",",
        f: kO,
        notation: "infix",
        precedence: 1,
        rightToLeft: 0,
        argCount: 2
      },
      symbol: ",",
      regSymbol: ","
    },
    "(": {
      prefix: {
        symbol: "(",
        f: Mp,
        notation: "prefix",
        precedence: 0,
        rightToLeft: 0,
        argCount: 1
      },
      symbol: "(",
      regSymbol: "\\("
    },
    ")": {
      postfix: {
        symbol: ")",
        f: void 0,
        notation: "postfix",
        precedence: 0,
        rightToLeft: 0,
        argCount: 1
      },
      symbol: ")",
      regSymbol: "\\)"
    },
    min: {
      func: {
        symbol: "min",
        f: AO,
        notation: "func",
        precedence: 0,
        rightToLeft: 0,
        argCount: 1
      },
      symbol: "min",
      regSymbol: "min\\b"
    },
    max: {
      func: {
        symbol: "max",
        f: TO,
        notation: "func",
        precedence: 0,
        rightToLeft: 0,
        argCount: 1
      },
      symbol: "max",
      regSymbol: "max\\b"
    }
  }
}, Pp = LO, Dt = /* @__PURE__ */ function(e) {
  A3(t, e);
  function t(n) {
    var r;
    return r = e.call(this, "An error occurred. See https://github.com/styled-components/polished/blob/main/src/internalHelpers/errors.md#" + n + " for more information.") || this, vO(r);
  }
  return t;
}(/* @__PURE__ */ el(Error)), Rp = /((?!\w)a|na|hc|mc|dg|me[r]?|xe|ni(?![a-zA-Z])|mm|cp|tp|xp|q(?!s)|hv|xamv|nimv|wv|sm|s(?!\D|$)|ged|darg?|nrut)/g;
function DO(e) {
  var t = {};
  return t.symbols = e ? Be({}, Pp.symbols, e.symbols) : Be({}, Pp.symbols), t;
}
function Bp(e, t) {
  var n, r = e.pop();
  return t.push(r.f.apply(r, (n = []).concat.apply(n, t.splice(-r.argCount)))), r.precedence;
}
function NO(e, t) {
  var n = DO(t), r, u = [n.symbols["("].prefix], i = [], a = new RegExp(
    // Pattern for numbers
    "\\d+(?:\\.\\d+)?|" + // ...and patterns for individual operators/function names
    Object.keys(n.symbols).map(function(b) {
      return n.symbols[b];
    }).sort(function(b, x) {
      return x.symbol.length - b.symbol.length;
    }).map(function(b) {
      return b.regSymbol;
    }).join("|") + "|(\\S)",
    "g"
  );
  a.lastIndex = 0;
  var o = !1;
  do {
    r = a.exec(e);
    var s = r || [")", void 0], c = s[0], l = s[1], d = n.symbols[c], f = d && !d.prefix && !d.func, p = !d || !d.postfix && !d.infix;
    if (l || (o ? p : f))
      throw new Dt(37, r ? r.index : e.length, e);
    if (o) {
      var h = d.postfix || d.infix;
      do {
        var m = u[u.length - 1];
        if ((h.precedence - m.precedence || m.rightToLeft) > 0)
          break;
      } while (Bp(u, i));
      o = h.notation === "postfix", h.symbol !== ")" && (u.push(h), o && Bp(u, i));
    } else if (d) {
      if (u.push(d.prefix || d.func), d.func && (r = a.exec(e), !r || r[0] !== "("))
        throw new Dt(38, r ? r.index : e.length, e);
    } else
      i.push(+c), o = !0;
  } while (r && u.length);
  if (u.length)
    throw new Dt(39, r ? r.index : e.length, e);
  if (r)
    throw new Dt(40, r ? r.index : e.length, e);
  return i.pop();
}
function Ws(e) {
  return e.split("").reverse().join("");
}
function qe(e, t) {
  var n = Ws(e), r = n.match(Rp);
  if (r && !r.every(function(i) {
    return i === r[0];
  }))
    throw new Dt(41);
  var u = Ws(n.replace(Rp, ""));
  return "" + NO(u, t) + (r ? Ws(r[0]) : "");
}
function Fp(e, t) {
  return e.substr(-t.length) === t;
}
var OO = /^([+-]?(?:\d+|\d*\.\d+))([a-z]*|%)$/;
function yu(e) {
  if (typeof e != "string")
    return e;
  var t = e.match(OO);
  return t ? parseFloat(e) : e;
}
var IO = function(t) {
  return function(n, r) {
    r === void 0 && (r = "16px");
    var u = n, i = r;
    if (typeof n == "string") {
      if (!Fp(n, "px"))
        throw new Dt(69, t, n);
      u = yu(n);
    }
    if (typeof r == "string") {
      if (!Fp(r, "px"))
        throw new Dt(70, t, r);
      i = yu(r);
    }
    if (typeof u == "string")
      throw new Dt(71, n, t);
    if (typeof i == "string")
      throw new Dt(72, r, t);
    return "" + u / i + t;
  };
}, MO = IO, PO = /^([+-]?(?:\d+|\d*\.\d+))([a-z]*|%)$/;
function L3(e) {
  if (typeof e != "string")
    return [e, ""];
  var t = e.match(PO);
  return t ? [parseFloat(e), t[2]] : [e, void 0];
}
var RO = /* @__PURE__ */ MO("rem"), Ks = RO, tl = 16;
function D3(e) {
  var t = L3(e);
  if (t[1] === "px")
    return parseFloat(e);
  if (t[1] === "%")
    return parseFloat(e) / 100 * tl;
  throw new Dt(78, t[1]);
}
function BO() {
  if (typeof document < "u" && document.documentElement !== null) {
    var e = getComputedStyle(document.documentElement).fontSize;
    return e ? D3(e) : tl;
  }
  return tl;
}
function xu(e, t) {
  var n = L3(e);
  if (n[1] !== "rem" && n[1] !== "")
    throw new Dt(77, n[1]);
  var r = t ? D3(t) : BO();
  return n[0] * r + "px";
}
function Ys(e) {
  return Math.round(e * 255);
}
function FO(e, t, n) {
  return Ys(e) + "," + Ys(t) + "," + Ys(n);
}
function Hp(e, t, n, r) {
  if (r === void 0 && (r = FO), t === 0)
    return r(n, n, n);
  var u = (e % 360 + 360) % 360 / 60, i = (1 - Math.abs(2 * n - 1)) * t, a = i * (1 - Math.abs(u % 2 - 1)), o = 0, s = 0, c = 0;
  u >= 0 && u < 1 ? (o = i, s = a) : u >= 1 && u < 2 ? (o = a, s = i) : u >= 2 && u < 3 ? (s = i, c = a) : u >= 3 && u < 4 ? (s = a, c = i) : u >= 4 && u < 5 ? (o = a, c = i) : u >= 5 && u < 6 && (o = i, c = a);
  var l = n - i / 2, d = o + l, f = s + l, p = c + l;
  return r(d, f, p);
}
var $p = {
  aliceblue: "f0f8ff",
  antiquewhite: "faebd7",
  aqua: "00ffff",
  aquamarine: "7fffd4",
  azure: "f0ffff",
  beige: "f5f5dc",
  bisque: "ffe4c4",
  black: "000",
  blanchedalmond: "ffebcd",
  blue: "0000ff",
  blueviolet: "8a2be2",
  brown: "a52a2a",
  burlywood: "deb887",
  cadetblue: "5f9ea0",
  chartreuse: "7fff00",
  chocolate: "d2691e",
  coral: "ff7f50",
  cornflowerblue: "6495ed",
  cornsilk: "fff8dc",
  crimson: "dc143c",
  cyan: "00ffff",
  darkblue: "00008b",
  darkcyan: "008b8b",
  darkgoldenrod: "b8860b",
  darkgray: "a9a9a9",
  darkgreen: "006400",
  darkgrey: "a9a9a9",
  darkkhaki: "bdb76b",
  darkmagenta: "8b008b",
  darkolivegreen: "556b2f",
  darkorange: "ff8c00",
  darkorchid: "9932cc",
  darkred: "8b0000",
  darksalmon: "e9967a",
  darkseagreen: "8fbc8f",
  darkslateblue: "483d8b",
  darkslategray: "2f4f4f",
  darkslategrey: "2f4f4f",
  darkturquoise: "00ced1",
  darkviolet: "9400d3",
  deeppink: "ff1493",
  deepskyblue: "00bfff",
  dimgray: "696969",
  dimgrey: "696969",
  dodgerblue: "1e90ff",
  firebrick: "b22222",
  floralwhite: "fffaf0",
  forestgreen: "228b22",
  fuchsia: "ff00ff",
  gainsboro: "dcdcdc",
  ghostwhite: "f8f8ff",
  gold: "ffd700",
  goldenrod: "daa520",
  gray: "808080",
  green: "008000",
  greenyellow: "adff2f",
  grey: "808080",
  honeydew: "f0fff0",
  hotpink: "ff69b4",
  indianred: "cd5c5c",
  indigo: "4b0082",
  ivory: "fffff0",
  khaki: "f0e68c",
  lavender: "e6e6fa",
  lavenderblush: "fff0f5",
  lawngreen: "7cfc00",
  lemonchiffon: "fffacd",
  lightblue: "add8e6",
  lightcoral: "f08080",
  lightcyan: "e0ffff",
  lightgoldenrodyellow: "fafad2",
  lightgray: "d3d3d3",
  lightgreen: "90ee90",
  lightgrey: "d3d3d3",
  lightpink: "ffb6c1",
  lightsalmon: "ffa07a",
  lightseagreen: "20b2aa",
  lightskyblue: "87cefa",
  lightslategray: "789",
  lightslategrey: "789",
  lightsteelblue: "b0c4de",
  lightyellow: "ffffe0",
  lime: "0f0",
  limegreen: "32cd32",
  linen: "faf0e6",
  magenta: "f0f",
  maroon: "800000",
  mediumaquamarine: "66cdaa",
  mediumblue: "0000cd",
  mediumorchid: "ba55d3",
  mediumpurple: "9370db",
  mediumseagreen: "3cb371",
  mediumslateblue: "7b68ee",
  mediumspringgreen: "00fa9a",
  mediumturquoise: "48d1cc",
  mediumvioletred: "c71585",
  midnightblue: "191970",
  mintcream: "f5fffa",
  mistyrose: "ffe4e1",
  moccasin: "ffe4b5",
  navajowhite: "ffdead",
  navy: "000080",
  oldlace: "fdf5e6",
  olive: "808000",
  olivedrab: "6b8e23",
  orange: "ffa500",
  orangered: "ff4500",
  orchid: "da70d6",
  palegoldenrod: "eee8aa",
  palegreen: "98fb98",
  paleturquoise: "afeeee",
  palevioletred: "db7093",
  papayawhip: "ffefd5",
  peachpuff: "ffdab9",
  peru: "cd853f",
  pink: "ffc0cb",
  plum: "dda0dd",
  powderblue: "b0e0e6",
  purple: "800080",
  rebeccapurple: "639",
  red: "f00",
  rosybrown: "bc8f8f",
  royalblue: "4169e1",
  saddlebrown: "8b4513",
  salmon: "fa8072",
  sandybrown: "f4a460",
  seagreen: "2e8b57",
  seashell: "fff5ee",
  sienna: "a0522d",
  silver: "c0c0c0",
  skyblue: "87ceeb",
  slateblue: "6a5acd",
  slategray: "708090",
  slategrey: "708090",
  snow: "fffafa",
  springgreen: "00ff7f",
  steelblue: "4682b4",
  tan: "d2b48c",
  teal: "008080",
  thistle: "d8bfd8",
  tomato: "ff6347",
  turquoise: "40e0d0",
  violet: "ee82ee",
  wheat: "f5deb3",
  white: "fff",
  whitesmoke: "f5f5f5",
  yellow: "ff0",
  yellowgreen: "9acd32"
};
function HO(e) {
  if (typeof e != "string")
    return e;
  var t = e.toLowerCase();
  return $p[t] ? "#" + $p[t] : e;
}
var $O = /^#[a-fA-F0-9]{6}$/, VO = /^#[a-fA-F0-9]{8}$/, jO = /^#[a-fA-F0-9]{3}$/, zO = /^#[a-fA-F0-9]{4}$/, Zs = /^rgb\(\s*(\d{1,3})\s*(?:,)?\s*(\d{1,3})\s*(?:,)?\s*(\d{1,3})\s*\)$/i, UO = /^rgb(?:a)?\(\s*(\d{1,3})\s*(?:,)?\s*(\d{1,3})\s*(?:,)?\s*(\d{1,3})\s*(?:,|\/)\s*([-+]?\d*[.]?\d+[%]?)\s*\)$/i, qO = /^hsl\(\s*(\d{0,3}[.]?[0-9]+(?:deg)?)\s*(?:,)?\s*(\d{1,3}[.]?[0-9]?)%\s*(?:,)?\s*(\d{1,3}[.]?[0-9]?)%\s*\)$/i, GO = /^hsl(?:a)?\(\s*(\d{0,3}[.]?[0-9]+(?:deg)?)\s*(?:,)?\s*(\d{1,3}[.]?[0-9]?)%\s*(?:,)?\s*(\d{1,3}[.]?[0-9]?)%\s*(?:,|\/)\s*([-+]?\d*[.]?\d+[%]?)\s*\)$/i;
function WO(e) {
  if (typeof e != "string")
    throw new Dt(3);
  var t = HO(e);
  if (t.match($O))
    return {
      red: parseInt("" + t[1] + t[2], 16),
      green: parseInt("" + t[3] + t[4], 16),
      blue: parseInt("" + t[5] + t[6], 16)
    };
  if (t.match(VO)) {
    var n = parseFloat((parseInt("" + t[7] + t[8], 16) / 255).toFixed(2));
    return {
      red: parseInt("" + t[1] + t[2], 16),
      green: parseInt("" + t[3] + t[4], 16),
      blue: parseInt("" + t[5] + t[6], 16),
      alpha: n
    };
  }
  if (t.match(jO))
    return {
      red: parseInt("" + t[1] + t[1], 16),
      green: parseInt("" + t[2] + t[2], 16),
      blue: parseInt("" + t[3] + t[3], 16)
    };
  if (t.match(zO)) {
    var r = parseFloat((parseInt("" + t[4] + t[4], 16) / 255).toFixed(2));
    return {
      red: parseInt("" + t[1] + t[1], 16),
      green: parseInt("" + t[2] + t[2], 16),
      blue: parseInt("" + t[3] + t[3], 16),
      alpha: r
    };
  }
  var u = Zs.exec(t);
  if (u)
    return {
      red: parseInt("" + u[1], 10),
      green: parseInt("" + u[2], 10),
      blue: parseInt("" + u[3], 10)
    };
  var i = UO.exec(t.substring(0, 50));
  if (i)
    return {
      red: parseInt("" + i[1], 10),
      green: parseInt("" + i[2], 10),
      blue: parseInt("" + i[3], 10),
      alpha: parseFloat("" + i[4]) > 1 ? parseFloat("" + i[4]) / 100 : parseFloat("" + i[4])
    };
  var a = qO.exec(t);
  if (a) {
    var o = parseInt("" + a[1], 10), s = parseInt("" + a[2], 10) / 100, c = parseInt("" + a[3], 10) / 100, l = "rgb(" + Hp(o, s, c) + ")", d = Zs.exec(l);
    if (!d)
      throw new Dt(4, t, l);
    return {
      red: parseInt("" + d[1], 10),
      green: parseInt("" + d[2], 10),
      blue: parseInt("" + d[3], 10)
    };
  }
  var f = GO.exec(t.substring(0, 50));
  if (f) {
    var p = parseInt("" + f[1], 10), h = parseInt("" + f[2], 10) / 100, m = parseInt("" + f[3], 10) / 100, b = "rgb(" + Hp(p, h, m) + ")", x = Zs.exec(b);
    if (!x)
      throw new Dt(4, t, b);
    return {
      red: parseInt("" + x[1], 10),
      green: parseInt("" + x[2], 10),
      blue: parseInt("" + x[3], 10),
      alpha: parseFloat("" + f[4]) > 1 ? parseFloat("" + f[4]) / 100 : parseFloat("" + f[4])
    };
  }
  throw new Dt(5);
}
var KO = function(t) {
  return t.length === 7 && t[1] === t[2] && t[3] === t[4] && t[5] === t[6] ? "#" + t[1] + t[3] + t[5] : t;
}, Vp = KO;
function Qr(e) {
  var t = e.toString(16);
  return t.length === 1 ? "0" + t : t;
}
function jp(e, t, n) {
  if (typeof e == "number" && typeof t == "number" && typeof n == "number")
    return Vp("#" + Qr(e) + Qr(t) + Qr(n));
  if (typeof e == "object" && t === void 0 && n === void 0)
    return Vp("#" + Qr(e.red) + Qr(e.green) + Qr(e.blue));
  throw new Dt(6);
}
function Xs(e, t, n, r) {
  if (typeof e == "string" && typeof t == "number") {
    var u = WO(e);
    return "rgba(" + u.red + "," + u.green + "," + u.blue + "," + t + ")";
  } else {
    if (typeof e == "number" && typeof t == "number" && typeof n == "number" && typeof r == "number")
      return r >= 1 ? jp(e, t, n) : "rgba(" + e + "," + t + "," + n + "," + r + ")";
    if (typeof e == "object" && t === void 0 && n === void 0 && r === void 0)
      return e.alpha >= 1 ? jp(e.red, e.green, e.blue) : "rgba(" + e.red + "," + e.green + "," + e.blue + "," + e.alpha + ")";
  }
  throw new Dt(7);
}
function YO(e, t) {
  if (e == null)
    return {};
  var n = {};
  for (var r in e)
    if ({}.hasOwnProperty.call(e, r)) {
      if (t.includes(r))
        continue;
      n[r] = e[r];
    }
  return n;
}
function $t(e, t) {
  if (e == null)
    return {};
  var n, r, u = YO(e, t);
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    for (r = 0; r < i.length; r++)
      n = i[r], t.includes(n) || {}.propertyIsEnumerable.call(e, n) && (u[n] = e[n]);
  }
  return u;
}
function ZO(e) {
  if (Array.isArray(e))
    return e;
}
function XO(e, t) {
  var n = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (n != null) {
    var r, u, i, a, o = [], s = !0, c = !1;
    try {
      if (i = (n = n.call(e)).next, t === 0) {
        if (Object(n) !== n)
          return;
        s = !1;
      } else
        for (; !(s = (r = i.call(n)).done) && (o.push(r.value), o.length !== t); s = !0)
          ;
    } catch (l) {
      c = !0, u = l;
    } finally {
      try {
        if (!s && n.return != null && (a = n.return(), Object(a) !== a))
          return;
      } finally {
        if (c)
          throw u;
      }
    }
    return o;
  }
}
function zp(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = Array(t); n < t; n++)
    r[n] = e[n];
  return r;
}
function QO(e, t) {
  if (e) {
    if (typeof e == "string")
      return zp(e, t);
    var n = {}.toString.call(e).slice(8, -1);
    return n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set" ? Array.from(e) : n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? zp(e, t) : void 0;
  }
}
function JO() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function an(e, t) {
  return ZO(e) || XO(e, t) || QO(e, t) || JO();
}
function eI(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function Ni(e) {
  "@babel/helpers - typeof";
  return Ni = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Ni(e);
}
function tI(e, t) {
  if (Ni(e) != "object" || !e)
    return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t || "default");
    if (Ni(r) != "object")
      return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function N3(e) {
  var t = tI(e, "string");
  return Ni(t) == "symbol" ? t : t + "";
}
function Up(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, N3(r.key), r);
  }
}
function nI(e, t, n) {
  return t && Up(e.prototype, t), n && Up(e, n), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function Ve(e, t, n) {
  return (t = N3(t)) in e ? Object.defineProperty(e, t, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = n, e;
}
var qp, Gp, Wp, Kp, Yp, Zp;
function rI(e) {
  if (!Object.keys(e).length)
    return {};
  var t = e.sysColorBackgroundSurface, n = e.sysColorStructureFocus, r = e.sysBorderThicknessEmphasis, u = e.sysColorStructureFocusOutline, i = e.sysColorErrorMain, a = e.sysColorStructureErrorOutline, o = e.sysBorderThicknessNormal, s = n, c = qe("".concat(o, " + ").concat(r)), l = u, d = qe("2 * ".concat(c));
  function f() {
    var g = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, v = g.radius, S = v === void 0 ? "inherit" : v, _ = g.width, A = _ === void 0 ? "100%" : _, k = g.height, T = k === void 0 ? "100%" : k, L = g.border, w = L === void 0 ? "none" : L, D = g.top, N = D === void 0 ? "0" : D, O = g.left, H = O === void 0 ? "0" : O, $ = g.right, j = $ === void 0 ? "0" : $, z = g.boxShadowColor, M = z === void 0 ? l : z;
    return B(qp || (qp = F([`
      content: '';
      position: absolute;
      top: `, `;
      left: `, `;
      right: `, `;
      border: `, `;
      box-shadow: 0 0 0 `, " ", `;
      border-radius: `, `;
      width: `, `;
      height: `, `;
      pointer-events: none;
    `])), N, H, j, w, d, M, S, A, T);
  }
  function p() {
    var g = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, v = g.radius, S = v === void 0 ? "inherit" : v, _ = g.width, A = _ === void 0 ? "100%" : _, k = g.height, T = k === void 0 ? "100%" : k, L = g.horizontalOffset, w = L === void 0 ? o : L, D = g.verticalOffset, N = D === void 0 ? o : D, O = g.borderColor, H = O === void 0 ? s : O, $ = g.boxShadowColor, j = $ === void 0 ? l : $, z = qe("".concat(w, " * 2")), M = qe("".concat(N, " * 2"));
    return B(Gp || (Gp = F([`
      content: '';
      position: absolute;
      top: `, `;
      left: `, `;
      border: `, " solid ", `;
      box-shadow: 0 0 0 `, " ", `;
      border-radius: `, `;
      text-indent: `, `;
      width: calc(`, " - ", `);
      height: calc(`, " - ", `);
      pointer-events: none;
    `])), N, w, c, H, d, j, S, w, A, z, T, M);
  }
  function h() {
    var g = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, v = g.radius, S = v === void 0 ? "inherit" : v, _ = g.colorInner, A = _ === void 0 ? s : _, k = g.colorOuter, T = k === void 0 ? l : k, L = qe("".concat(c, " + ").concat(d));
    return B(Wp || (Wp = F([`
      box-shadow: 0 0 0 `, " ", `,
        0 0 0 `, " ", `;
      outline: `, ` solid transparent;
      border-radius: `, `;
    `])), c, A, L, T, c, S);
  }
  var m = "calc(".concat(r, " + ").concat(r, ")"), b = B(Kp || (Kp = F([`
    outline: `, " solid ", `;
  `])), r, n), x = B(Yp || (Yp = F([`
    box-shadow: 0 0 0 `, " ", `;
    outline-offset: `, `;
    `, `;
  `])), r, t, r, b), y = B(Zp || (Zp = F([`
    box-shadow: 0 0 0 `, ` inset
      `, `;
    outline-offset: -`, `;
    `, `;
  `])), m, t, r, b);
  return {
    stateFocusBorderColorOuter: l,
    stateFocusBorderWidthOuter: d,
    stateFocusBorderColorInner: s,
    stateFocusBorderWidthInner: c,
    stateErrorFocusBorderColorInner: i,
    stateErrorFocusBorderColorOuter: a,
    focusAfter: f,
    offsetFocusAfter: p,
    focusInline: h,
    focusElement: b,
    focusOffsetElement: x,
    focusInlineElement: y
  };
}
var Xp, Qp, Jp, eh;
function O3(e) {
  if (!Object.keys(e).length)
    return {};
  var t = e.sysBorderThicknessNormal, n = e.sysBorderRadiusLg, r = e.sysColorStructureShimmer, u = e.sysColorStructureShimmerInverse, i = e.sysColorStructureSheen, a = e.sysMotionDurationLoopStandard, o = e.sysMotionEasingLoopStandard, s = "cubic-bezier(".concat(o, ")"), c = po(Xp || (Xp = F([`
        from {
            background-position: 100% 0;
        }
        to {
            background-position: -100% 0;
        }
    `]))), l = B(Qp || (Qp = F([`
    label: shimmer_base;
    background-color: `, `;
    border: `, ` solid transparent;
    background-image: linear-gradient(
      to right,
      `, ` 0%,
      `, ` 50%,
      `, ` 100%
    );
    background-position: 100% 0;
    background-size: 200%;
    animation: `, " ", `
      `, ` infinite;
  `])), r, t, r, i, r, c, a, s), d = B(Jp || (Jp = F([`
    label: inverse;
    background-color: `, `;
    background-image: linear-gradient(
      to right,
      `, ` 0%,
      `, ` 50%,
      `, ` 100%
    );
  `])), u, u, i, u);
  function f() {
    var p = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, h = p.borderRadius, m = h === void 0 ? n : h, b = p.width, x = b === void 0 ? "100%" : b, y = p.height, g = y === void 0 ? "100%" : y;
    return B(eh || (eh = F([`
      label: default;
      border-radius: `, `;
      width: `, `;
      height: `, `;
    `])), m, x, g);
  }
  return {
    base: l,
    inverse: d,
    defaults: f
  };
}
var th, nh, rh, uh, ih, ah, oh, sh, ch;
function uI(e) {
  if (!Object.keys(e).length)
    return {};
  var t = e.sysColorStructureShadow, n = e.sysColorBackgroundSurface, r = e.sysElevationHorizontalOffsetRatio, u = e.sysElevationOpacity, i = e.sysElevationVerticalOffsetRatio, a = e.sysElevationBlurCurve, o = e.sysElevationBlurSlope, s = e.sysElevationBlurBase, c = e.sysElevationBrightenFactor;
  function l(T) {
    return Ks(r * T);
  }
  function d(T) {
    return Ks(i * T - 1);
  }
  function f(T) {
    var L = Ks(T * T * a + T * o);
    return qe("".concat(L, " + ").concat(s));
  }
  var p = Xs(t, u), h = function(T) {
    return "background-image: linear-gradient(".concat(Xs(n, T * c), ", ").concat(Xs(n, T * c), ")");
  }, m = function(T) {
    return "".concat(l(T), " ").concat(d(T), " ").concat(f(T), " ").concat(p);
  }, b = function(T) {
    return B(th || (th = F([`
    box-shadow: `, `;
    `, `;
  `])), m(T), h(T));
  }, x = B(nh || (nh = F([`
    label: elevation_level1;
    `, `
  `])), b(1)), y = B(rh || (rh = F([`
    label: elevation_level2;
    `, `
  `])), b(2)), g = B(uh || (uh = F([`
    label: elevation_level3;
    `, `
  `])), b(3)), v = B(ih || (ih = F([`
    label: drop_shadow1;
    filter: drop-shadow(`, `);
  `])), m(1)), S = B(ah || (ah = F([`
    label: drop_shadow2;
    filter: drop-shadow(`, `);
  `])), m(2)), _ = B(oh || (oh = F([`
    label: drop_shadow3;
    filter: drop-shadow(`, `);
  `])), m(3)), A = B(sh || (sh = F([`
    label: fixed_elevation;
    box-shadow: 0 0 `, " ", `;
  `])), f(0.33), p), k = B(ch || (ch = F([`
    label: elevation_level3_above;
    box-shadow: `, " -", " ", " ", `;
    `, `;
    transform: translateZ(0);
  `])), l(3), d(3), f(3), p, h(3));
  return {
    level1: x,
    level2: y,
    level3: g,
    level1Horizontal: A,
    level3Above: k,
    filterLevel1: v,
    filterLevel2: S,
    filterLevel3: _
  };
}
var lh, dh, fh, ph, hh, mh, gh, bh;
function iI(e) {
  if (!Object.keys(e).length)
    return {};
  var t = e.sysSpaceSm, n = e.sysSpaceMd, r = e.sysSpaceLg, u = function(f) {
    return B(lh || (lh = F([`
    &:before {
      content: '';
      position: absolute;
      background-color: inherit;
      width: `, `;
      height: `, `;
      transform: scale(0.72) rotate(45deg);
      box-shadow: inherit;
      z-index: 0;
    }

    //hack to cover top part of rotated skewed square and get triangle shape:
    &:after {
      content: '';
      position: absolute;
      background-color: inherit;
      width: 2.5rem;
      height: `, `;
    }
  `])), f, f, r);
  }, i = function(f) {
    return B(dh || (dh = F([`
    &:before {
      top: auto;
      bottom: -`, `;
    }
    &:after {
      top: auto;
      bottom: 0;
    }
  `])), f);
  }, a = function(f) {
    return B(fh || (fh = F([`
    &:before {
      top: -`, `;
      bottom: auto;
    }
    &:after {
      top: 0;
      bottom: auto;
    }
  `])), f);
  }, o = function(f) {
    return B(ph || (ph = F([`
    &:before {
      left: calc(50% - `, ` / 2);
      right: auto;
    }
    &:after {
      left: calc(50% - 1.25rem);
      right: auto;
    }
  `])), f);
  }, s = function(f) {
    return B(hh || (hh = F([`
    &:before {
      left: `, `;
      right: auto;
    }
    &:after {
      left: `, `;
      right: auto;
    }
  `])), f, t);
  }, c = function(f) {
    return B(mh || (mh = F([`
    &:before {
      left: auto;
      right: `, `;
    }
    &:after {
      left: auto;
      right: `, `;
    }
  `])), f, t);
  }, l = function(f) {
    return B(gh || (gh = F([`
    &:before {
      top: calc(50% - `, `);
      bottom: auto;
      left: -`, `;
      right: auto;
    }
    &:after {
      transform: rotate(90deg);
      top: calc(50% - `, `);
      bottom: auto;
      left: -`, `;
      right: auto;
    }
  `])), f, f, f, n);
  }, d = function(f) {
    return B(bh || (bh = F([`
    &:before {
      top: calc(50% - `, `);
      bottom: auto;
      left: auto;
      right: -`, `;
    }
    &:after {
      transform: rotate(90deg);
      top: calc(50% - `, `);
      bottom: auto;
      left: auto;
      right: -`, `;
    }
  `])), f, f, f, n);
  };
  return {
    base: u,
    positionBottom: i,
    positionTop: a,
    positionCenter: o,
    positionShiftLeft: s,
    positionShiftRight: c,
    positionLeft: l,
    positionRight: d
  };
}
var to;
(function(e) {
  e.LEFT = "left", e.RIGHT = "right";
})(to || (to = {}));
var aI = 1060, oI = 1070, vh = 1090, sI = /\${(\w+)}/g, cI = function(e, t) {
  return e.replace(sI, function(n, r) {
    var u;
    return (u = t[r]) !== null && u !== void 0 ? u : "${".concat(r, "}");
  });
}, yh, xh, _h, Sh, Ch, Eh;
function I3(e) {
  if (!Object.keys(e).length)
    return {};
  var t = e.sysMotionTimingX1, n = e.sysMotionTimingY1, r = e.sysMotionTimingX2, u = e.sysMotionTimingY2, i = e.sysMotionEasingLoopStandard, a = e.sysMotionEasingEnterSmall, o = e.sysMotionEasingExitSmall, s = e.sysMotionEasingMoveSmall;
  return {
    ppuiEaseInOut: "cubic-bezier(".concat(t, ", ").concat(n, ", ").concat(r, ", ").concat(u, ")"),
    ppuiEaseLoopStandard: "cubic-bezier(".concat(i, ")"),
    ppuiEaseEnterSmall: "cubic-bezier(".concat(a, ")"),
    ppuiEaseExitSmall: "cubic-bezier(".concat(o, ")"),
    ppuiEaseMoveSmall: "cubic-bezier(".concat(s, ")")
  };
}
function lI(e) {
  if (!Object.keys(e).length)
    return {};
  var t = I3(e), n = t.ppuiEaseInOut, r = B(yh || (yh = F([`
    label: motion_animation;
    animation-timing-function: `, `;
  `])), n), u = B(xh || (xh = F([`
    label: motion_transition;
    transition-timing-function: `, `;
  `])), n);
  return {
    animationTiming: r,
    transitionTiming: u
  };
}
function Zn(e) {
  if (!Object.keys(e).length)
    return {};
  var t = I3(e), n = rI(e), r = O3(e), u = lI(e), i = uI(e), a = iI(e), o = B(_h || (_h = F([`
    label: screenReader;
    position: absolute;
    clip: rect(1px, 1px, 1px, 1px);
    padding: 0;
    border: 0;
    width: 1px;
    height: 1px;
    overflow: hidden;
  `]))), s = B(Sh || (Sh = F([`
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  `]))), c = function(d) {
    var f = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : e.sysSizeMediaMd, p = typeof d == "string" ? d : d.styles;
    return B(Ch || (Ch = F([`
      @media screen and (max-width: `, `) {
        `, `
      }
    `])), f, cI(p, e));
  }, l = function() {
    var d = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : to.RIGHT, f = d === to.RIGHT ? "-100%" : "100%";
    return po(Eh || (Eh = F([`
        0% {
          transform: translateX(`, `);
        }

        100% {
          transform: translateX(0);
        }
      `])), f);
  };
  return {
    variables: t,
    focusStyles: n,
    shimmerStyles: r,
    motionTimings: u,
    elevationStyles: i,
    caretStyles: a,
    mediaQuery: c,
    screenReader: o,
    ellipsis: s,
    slideTo: l
  };
}
var dI = ["as", "className", "children"], fI = function(e) {
  var t = e.as, n = t === void 0 ? "div" : t, r = e.className, u = e.children, i = $t(e, dI), a = ln(), o = $e(function() {
    return Zn(a);
  }, [a]), s = o.screenReader;
  return W(n, Be({
    css: s,
    className: r
  }, i), u);
}, pI = ["as", "isInverse", "className", "hasStyleDefaults", "children"], k0 = function(e) {
  var t, n = e.as, r = n === void 0 ? "div" : n, u = e.isInverse, i = e.className, a = e.hasStyleDefaults, o = a === void 0 ? !0 : a, s = e.children, c = $t(e, pI), l = ln(), d = $e(function() {
    return O3(l);
  }, [l]), f = [d.base, u && d.inverse, o && ((t = d.defaults) === null || t === void 0 ? void 0 : t.call(d))];
  return W(r, Be({
    css: f,
    className: i
  }, c), W(fI, {
    as: "span"
  }, s));
}, L0 = Te.createContext(null), Ke = function(e, t, n) {
  var r, u, i;
  switch (n) {
    case "contrast":
      return e != null && e.contrast ? e.contrast : t;
    case "active":
      return (r = e == null ? void 0 : e.active) !== null && r !== void 0 ? r : t;
    case "hover":
      return (u = e == null ? void 0 : e.hover) !== null && u !== void 0 ? u : t;
    case "main":
      return (i = e == null ? void 0 : e.main) !== null && i !== void 0 ? i : t;
    default:
      return t;
  }
}, qo = function() {
  return typeof window < "u";
}, hI = function() {
  return typeof navigator < "u";
}, mI = function() {
  return typeof document < "u";
}, gI = function() {
  var e;
  return qo() && "ontouchstart" in window ? !0 : !!(hI() && ((e = navigator.maxTouchPoints) !== null && e !== void 0 ? e : navigator.msMaxTouchPoints));
}, bI = function() {
  return qo() ? getComputedStyle(document.body).direction === "rtl" : !1;
}, wh = "ppui", Qs = {};
function Go() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : wh;
  Qs[e] || (Qs[e] = 0);
  var t = ++Qs[e];
  return e === wh ? "".concat(t) : "".concat(e).concat(t);
}
var Ge = /* @__PURE__ */ function() {
  function e(t) {
    eI(this, e), Ve(this, "key", void 0), this.key = t;
  }
  return nI(e, [{
    key: "IS_ARROW_LEFT",
    get: function() {
      return ["ArrowLeft", e.NAME_ARROW_LEFT, e.CODE_ARROW_LEFT].includes(this.key);
    }
  }, {
    key: "IS_ARROW_RIGHT",
    get: function() {
      return ["ArrowRight", e.NAME_ARROW_RIGHT, e.CODE_ARROW_RIGHT].includes(this.key);
    }
  }, {
    key: "IS_ARROW_UP",
    get: function() {
      return ["ArrowUp", e.NAME_ARROW_UP, e.CODE_ARROW_UP].includes(this.key);
    }
  }, {
    key: "IS_ARROW_DOWN",
    get: function() {
      return ["ArrowDown", e.NAME_ARROW_DOWN, e.CODE_ARROW_DOWN].includes(this.key);
    }
  }, {
    key: "IS_ENTER",
    get: function() {
      return [e.NAME_ENTER, e.CODE_ENTER].includes(this.key);
    }
  }, {
    key: "IS_SPACEBAR",
    get: function() {
      return [e.NAME_SPACE, e.CODE_SPACE].includes(this.key);
    }
  }, {
    key: "IS_TAB",
    get: function() {
      return [e.NAME_TAB, e.CODE_TAB].includes(this.key);
    }
  }, {
    key: "IS_ESC",
    get: function() {
      return ["Escape", e.NAME_ESC, e.CODE_ESC].includes(this.key);
    }
  }, {
    key: "IS_HOME",
    get: function() {
      return [e.NAME_HOME, e.CODE_HOME].includes(this.key);
    }
  }, {
    key: "IS_END",
    get: function() {
      return [e.NAME_END, e.CODE_END].includes(this.key);
    }
  }, {
    key: "IS_BACKSPACE",
    get: function() {
      return [e.NAME_BACKSPACE, e.CODE_BACKSPACE].includes(this.key);
    }
  }, {
    key: "IS_DELETE",
    get: function() {
      return [e.NAME_DELETE, e.CODE_DELETE].includes(this.key);
    }
  }, {
    key: "IS_SIDE_NAVIGATION",
    get: function() {
      return this.IS_ARROW_LEFT || this.IS_ARROW_RIGHT || this.IS_END || this.IS_HOME;
    }
  }, {
    key: "IS_ARROW_KEY",
    get: function() {
      return this.IS_ARROW_LEFT || this.IS_ARROW_RIGHT || this.IS_ARROW_UP || this.IS_ARROW_DOWN;
    }
  }]), e;
}();
Ve(Ge, "CODE_ARROW_UP", 38);
Ve(Ge, "CODE_ARROW_DOWN", 40);
Ve(Ge, "CODE_ARROW_LEFT", 37);
Ve(Ge, "CODE_ARROW_RIGHT", 39);
Ve(Ge, "CODE_ENTER", 13);
Ve(Ge, "CODE_SPACE", 32);
Ve(Ge, "CODE_ESC", 27);
Ve(Ge, "CODE_TAB", 9);
Ve(Ge, "CODE_CAPS_LOCK", 20);
Ve(Ge, "CODE_HOME", 36);
Ve(Ge, "CODE_END", 35);
Ve(Ge, "CODE_BACKSPACE", 8);
Ve(Ge, "CODE_DELETE", 46);
Ve(Ge, "NAME_ARROW_UP", "Up");
Ve(Ge, "NAME_ARROW_DOWN", "Down");
Ve(Ge, "NAME_ARROW_LEFT", "Left");
Ve(Ge, "NAME_ARROW_RIGHT", "Right");
Ve(Ge, "NAME_ENTER", "Enter");
Ve(Ge, "NAME_SPACE", " ");
Ve(Ge, "NAME_ESC", "Esc");
Ve(Ge, "NAME_TAB", "Tab");
Ve(Ge, "NAME_HOME", "Home");
Ve(Ge, "NAME_END", "End");
Ve(Ge, "NAME_BACKSPACE", "Backspace");
Ve(Ge, "NAME_DELETE", "Delete");
var Th, Ah, kh, Lh, Dh, Nh, Oh, Ih, Mh;
function zr(e, t) {
  if (!Object.keys(e).length)
    return {};
  var n = e.sysColorBackgroundHighContrast, r = e.sysColorBackgroundMediumContrast, u = e.sysTypographyDisplayFamily, i = e.sysTypographyDisplaySize, a = e.sysTypographyDisplayWeight, o = e.sysTypographyDisplayLineHeight, s = e.sysTypographyDisplayMaxScaleFactor, c = e.sysTypographyHeadingLgFamily, l = e.sysTypographyHeadingLgSize, d = e.sysTypographyHeadingLgWeight, f = e.sysTypographyHeadingLgLineHeight, p = e.sysTypographyHeadingLgMaxScaleFactor, h = e.sysTypographyHeadingSmFamily, m = e.sysTypographyHeadingSmSize, b = e.sysTypographyHeadingSmWeight, x = e.sysTypographyHeadingSmLineHeight, y = e.sysTypographyHeadingSmMaxScaleFactor, g = e.sysTypographyTitleStrongFamily, v = e.sysTypographyTitleStrongSize, S = e.sysTypographyTitleStrongWeight, _ = e.sysTypographyTitleStrongLineHeight, A = e.sysTypographyTitleStrongMaxScaleFactor, k = e.sysTypographyTitleFamily, T = e.sysTypographyTitleSize, L = e.sysTypographyTitleWeight, w = e.sysTypographyTitleLineHeight, D = e.sysTypographyTitleMaxScaleFactor, N = e.sysTypographyBodyStrongFamily, O = e.sysTypographyBodyStrongSize, H = e.sysTypographyBodyStrongWeight, $ = e.sysTypographyBodyStrongLineHeight, j = e.sysTypographyBodyStrongMaxScaleFactor, z = e.sysTypographyBodyFamily, M = e.sysTypographyBodySize, P = e.sysTypographyBodyWeight, C = e.sysTypographyBodyLineHeight, R = e.sysTypographyBodyMaxScaleFactor, V = e.sysTypographyCaptionFamily, I = e.sysTypographyCaptionSize, G = e.sysTypographyCaptionWeight, K = e.sysTypographyCaptionLineHeight, Q = e.sysTypographyCaptionMaxScaleFactor, ae = e.sysTypographyCaptionStrongFamily, X = e.sysTypographyCaptionStrongSize, ne = e.sysTypographyCaptionStrongWeight, fe = e.sysTypographyCaptionStrongLineHeight, he = e.sysTypographyCaptionStrongMaxScaleFactor, xe = e.sysTypographyButtonLgFamily, re = e.sysTypographyButtonLgSize, Se = e.sysTypographyButtonLgWeight, et = e.sysTypographyButtonLgLineHeight, Le = e.sysTypographyButtonLgMaxScaleFactor, rt = e.sysTypographyButtonSmFamily, we = e.sysTypographyButtonSmSize, Oe = e.sysTypographyButtonSmWeight, Ce = e.sysTypographyButtonSmLineHeight, Qe = e.sysTypographyButtonSmMaxScaleFactor, ct = e.sysTypographyFieldLabelLgFamily, mt = e.sysTypographyFieldLabelLgSize, Ot = e.sysTypographyFieldLabelLgWeight, ve = e.sysTypographyFieldLabelLgLineHeight, Nt = e.sysTypographyFieldLabelLgMaxScaleFactor, Vt = e.sysTypographyFieldLabelSmFamily, lt = e.sysTypographyFieldLabelSmSize, jt = e.sysTypographyFieldLabelSmWeight, zt = e.sysTypographyFieldLabelSmLineHeight, It = e.sysTypographyFieldLabelSmMaxScaleFactor, J = e.sysTypographyFieldValueXlFamily, te = e.sysTypographyFieldValueXlSize, Me = e.sysTypographyFieldValueXlWeight, Ye = e.sysTypographyFieldValueXlLineHeight, gt = e.sysTypographyFieldValueXlMaxScaleFactor, dt = e.sysTypographyFieldValueLgFamily, Tt = e.sysTypographyFieldValueLgSize, Mt = e.sysTypographyFieldValueLgWeight, xn = e.sysTypographyFieldValueLgLineHeight, Ut = e.sysTypographyFieldValueLgMaxScaleFactor, qt = e.sysTypographyFieldValueSmFamily, Rn = e.sysTypographyFieldValueSmSize, Bn = e.sysTypographyFieldValueSmWeight, pe = e.sysTypographyFieldValueSmLineHeight, Fe = e.sysTypographyFieldValueSmMaxScaleFactor, je = e.sysSizeMediaMd, Gt = Zn(e), Tn = Gt.shimmerStyles, qr = "16px";
  function Gr(se, ce) {
    var Ee = qe("".concat(se, "*").concat(ce)), le = xu(Ee, qr);
    return "min(".concat(se, ", ").concat(le, ")");
  }
  function ot(se, ce, Ee, le, Pe, $u, os) {
    var O4 = "".concat(Ee, ', "Helvetica Neue", Arial, sans-serif'), I4 = xu(je, qr);
    return B(Th || (Th = F([`
      label: `, `;
      color: `, `;
      font-family: `, `;
      font-size: `, `;
      line-height: `, `;
      font-weight: `, `;

      @media screen and (max-width: `, `) {
        font-size: `, `;
        line-height: `, `;
      }
    `])), se, Ke(t, ce, "contrast"), O4, le, $u, os, I4, Gr(le, Pe), Gr($u, Pe));
  }
  function Hu(se) {
    var ce = se > 4 ? 4 : se;
    return B(Ah || (Ah = F([`
      label: `, `;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      overflow: hidden;
      -webkit-line-clamp: `, `;
    `])), "line_clamp_".concat(ce), ce);
  }
  var rs = B(kh || (kh = F([`
    label: text_shimmer;
    `, `
  `])), Tn.defaults()), us = B(Lh || (Lh = F([`
    label: display;
    height: `, `;
  `])), o), is = B(Dh || (Dh = F([`
    label: heading_lg;
    height: `, `;
  `])), f), as = B(Nh || (Nh = F([`
    label: heading_sm;
    height: `, `;
  `])), x), _e = B(Oh || (Oh = F([`
    label: body;
    height: `, `;
  `])), C), Ie = B(Ih || (Ih = F([`
    label: caption;
    height: `, `;
  `])), K), xt = B(Mh || (Mh = F([`
    label: title;
    height: `, `;
  `])), w);
  return {
    body: function() {
      var se = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, ce = se.lineHeight, Ee = ce === void 0 ? C : ce, le = se.color, Pe = le === void 0 ? n : le;
      return ot("text_body", Pe, z, M, R, Ee, P);
    },
    bodyStrong: function() {
      var se = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, ce = se.lineHeight, Ee = ce === void 0 ? $ : ce, le = se.color, Pe = le === void 0 ? n : le;
      return ot("text_body_strong", Pe, N, O, j, Ee, H);
    },
    caption: function() {
      var se = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, ce = se.lineHeight, Ee = ce === void 0 ? K : ce, le = se.color, Pe = le === void 0 ? n : le;
      return ot("text_caption", Pe, V, I, Q, Ee, G);
    },
    captionStrong: function() {
      var se = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, ce = se.lineHeight, Ee = ce === void 0 ? fe : ce, le = se.color, Pe = le === void 0 ? n : le;
      return ot("text_caption_strong", Pe, ae, X, he, Ee, ne);
    },
    headingSm: function() {
      var se = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, ce = se.lineHeight, Ee = ce === void 0 ? x : ce, le = se.color, Pe = le === void 0 ? n : le;
      return ot("text_heading_sm", Pe, h, m, y, Ee, b);
    },
    headingLg: function() {
      var se = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, ce = se.lineHeight, Ee = ce === void 0 ? f : ce, le = se.color, Pe = le === void 0 ? n : le;
      return ot("text_heading_lg", Pe, c, l, p, Ee, d);
    },
    display: function() {
      var se = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, ce = se.lineHeight, Ee = ce === void 0 ? o : ce, le = se.color, Pe = le === void 0 ? n : le;
      return ot("text_display", Pe, u, i, s, Ee, a);
    },
    title: function() {
      var se = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, ce = se.lineHeight, Ee = ce === void 0 ? w : ce, le = se.color, Pe = le === void 0 ? n : le;
      return ot("text_title", Pe, k, T, D, Ee, L);
    },
    titleStrong: function() {
      var se = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, ce = se.lineHeight, Ee = ce === void 0 ? _ : ce, le = se.color, Pe = le === void 0 ? n : le, $u = se.label, os = $u === void 0 ? "text_title_strong" : $u;
      return ot(os, Pe, g, v, A, Ee, S);
    },
    buttonLg: function() {
      var se = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, ce = se.lineHeight, Ee = ce === void 0 ? et : ce, le = se.color, Pe = le === void 0 ? n : le;
      return ot("text_button_lg", Pe, xe, re, Le, Ee, Se);
    },
    buttonSm: function() {
      var se = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, ce = se.lineHeight, Ee = ce === void 0 ? Ce : ce, le = se.color, Pe = le === void 0 ? n : le;
      return ot("text_button_sm", Pe, rt, we, Qe, Ee, Oe);
    },
    fieldLabelSm: function() {
      var se = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, ce = se.lineHeight, Ee = ce === void 0 ? zt : ce, le = se.color, Pe = le === void 0 ? r : le;
      return ot("text_field_label_sm", Pe, Vt, lt, It, Ee, jt);
    },
    fieldLabelLg: function() {
      var se = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, ce = se.lineHeight, Ee = ce === void 0 ? ve : ce, le = se.color, Pe = le === void 0 ? r : le;
      return ot("text_field_label_lg", Pe, ct, mt, Nt, Ee, Ot);
    },
    fieldValueSm: function() {
      var se = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, ce = se.lineHeight, Ee = ce === void 0 ? pe : ce, le = se.color, Pe = le === void 0 ? n : le;
      return ot("text_field_value_sm", Pe, qt, Rn, Fe, Ee, Bn);
    },
    fieldValueLg: function() {
      var se = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, ce = se.lineHeight, Ee = ce === void 0 ? xn : ce, le = se.color, Pe = le === void 0 ? n : le;
      return ot("text_field_value_lg", Pe, dt, Tt, Ut, Ee, Mt);
    },
    fieldValueXl: function() {
      var se = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, ce = se.lineHeight, Ee = ce === void 0 ? Ye : ce, le = se.color, Pe = le === void 0 ? n : le;
      return ot("text_field_value_xl", Pe, J, te, gt, Ee, Me);
    },
    lineClamping: Hu,
    shimmer: rs,
    shimmerDisplay: us,
    shimmerHeadingLg: is,
    shimmerHeadingSm: as,
    shimmerBody: _e,
    shimmerCaption: Ie,
    shimmerTitle: xt
  };
}
var vI = ["as", "strong", "className", "isLoading", "isInverse", "clampAtLine", "children"], yI = function(e) {
  var t, n = e.as, r = n === void 0 ? "div" : n, u = e.strong, i = e.className, a = e.isLoading, o = e.isInverse, s = e.clampAtLine, c = e.children, l = $t(e, vI), d = ln(), f = Te.useContext(L0), p = $e(function() {
    return zr(d, f);
  }, [d, f]);
  if (a)
    return W(k0, Be({
      css: [p.shimmer, p.shimmerBody],
      className: i,
      hasStyleDefaults: !1,
      isInverse: o
    }, l, {
      "data-ppui": "true"
    }), c);
  var h = [!u && p.body, u && p.bodyStrong, s && ((t = p.lineClamping) === null || t === void 0 ? void 0 : t.call(p, s))];
  return W(r, Be({
    css: h,
    className: i,
    "data-ppui-info": "body-text_6.7.6"
  }, l), c);
}, xI = ["as", "strong", "clampAtLine", "className", "isLoading", "isInverse", "children"], _I = function(e) {
  var t, n = e.as, r = n === void 0 ? "div" : n, u = e.strong, i = e.clampAtLine, a = e.className, o = e.isLoading, s = e.isInverse, c = e.children, l = $t(e, xI), d = ln(), f = Te.useContext(L0), p = $e(function() {
    return zr(d, f);
  }, [d, f]);
  if (o)
    return W(k0, Be({
      css: [p.shimmer, p.shimmerCaption],
      className: a,
      hasStyleDefaults: !1,
      isInverse: s
    }, l, {
      "data-ppui": "true"
    }), c);
  var h = [!u && p.caption, u && p.captionStrong, i && ((t = p.lineClamping) === null || t === void 0 ? void 0 : t.call(p, i))];
  return W(r, Be({
    css: h,
    className: a,
    "data-ppui-info": "caption-text_6.7.6"
  }, l), c);
}, Ph, Rh, Bh, Fh, Hh, $h, Vh;
function SI(e) {
  if (!Object.keys(e).length)
    return {};
  var t = e.sysColorPrimaryMain, n = e.sysColorPrimaryContrast, r = e.sysSizeCircleXs, u = e.sysSizeCircleSm, i = e.sysSizeCircleMd, a = e.sysSizeCircleXl, o = e.sysBorderThicknessEmphasis, s = e.sysMotionDurationLoopStandard, c = po(Ph || (Ph = F([`
    to {
      transform: rotate(360deg);
    }
  `]))), l = Zn(e), d = l.screenReader, f = l.variables, p = f.ppuiEaseLoopStandard, h = B(Rh || (Rh = F([`
    label: loading-spinner_base;
    width: `, `;
    height: `, `;
    color: `, `;
    animation: `, " ", `
      `, ` infinite;
    border: `, ` solid currentColor;
    border-radius: 50%;
    clip-path: polygon(50% 0%, 50% 50%, 100% 50%, 100% 100%, 0 100%, 0 0);
  `])), r, r, t, c, s, p, o), m = B(Bh || (Bh = F([`
    label: size_xs;
    width: `, `;
    height: `, `;
  `])), r, r), b = B(Fh || (Fh = F([`
    label: size_md;
    width: `, `;
    height: `, `;
  `])), u, u), x = B(Hh || (Hh = F([`
    label: size_lg;
    width: `, `;
    height: `, `;
  `])), i, i), y = B($h || ($h = F([`
    label: size_xl;
    width: `, `;
    height: `, `;
  `])), a, a), g = B(Vh || (Vh = F([`
    label: inverse;
    color: `, `;
  `])), n);
  return {
    base: h,
    sizeXs: m,
    sizeMd: b,
    sizeLg: x,
    sizeXl: y,
    inverse: g,
    screenReader: d
  };
}
var CI = ["as", "className", "inverse", "size", "screenReaderText"], D0 = function(e) {
  var t = e.as, n = t === void 0 ? "p" : t, r = e.className, u = e.inverse, i = e.size, a = e.screenReaderText, o = $t(e, CI), s = ln(), c = $e(function() {
    return SI(s);
  }, [s]), l = {
    xs: c.sizeXs,
    // to be used for stateful buttons ONLY.
    sm: "",
    md: c.sizeMd,
    lg: c.sizeLg,
    xl: c.sizeXl
  }, d = [c.base, u && c.inverse, l[i]];
  return W(n, Be({
    css: d,
    className: r,
    "data-ppui-info": "loading-spinner_3.2.4"
  }, o, {
    role: "alert"
  }), W("span", {
    css: c.screenReader,
    "data-ppui": "true"
  }, a));
};
function jh(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(u) {
      return Object.getOwnPropertyDescriptor(e, u).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function EI(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? jh(Object(n), !0).forEach(function(r) {
      Ve(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : jh(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
var M3 = function(e) {
  var t = e.id, n = t === void 0 ? Go("animatee#") : t, r = e.shouldHide, u = r === void 0 ? !1 : r, i = e.onOpen, a = e.onClose, o = e.onCloseComplete, s = o === void 0 ? a : o, c = e.phaseProps, l = c === void 0 ? {
    initial: {
      isHidden: !0
    },
    showing: {
      isHidden: !1
    },
    hiding: {
      isHidden: !0
    }
  } : c, d = e.children, f = me("initial"), p = an(f, 2), h = p[0], m = p[1], b = Z({
    event: null,
    closeMethod: ""
  }), x = Z(n), y = Z(null);
  oe(function() {
  });
  var g = function() {
    y.current && (clearTimeout(y.current), y.current = null);
    var _ = b.current || {}, A = _.event, k = _.closeMethod;
    m(function(T) {
      return T !== "initial" ? (typeof s == "function" && s(A, k), "initial") : T;
    });
  };
  Gn(function() {
    !u && h === "initial" && m("showing"), u && h !== "initial" && (b.current.closeMethod = "caller", m("hiding"));
  }, [u]);
  var v = function(_) {
    _.target.dataset.animatee === x.current && (h === "hiding" ? g() : typeof i == "function" && i(_), _.stopPropagation(), _.nativeEvent.stopImmediatePropagation());
  };
  if (u && h === "initial")
    return null;
  var S = EI({
    requestClose: function(A, k) {
      b.current.event = A, b.current.closeMethod = k, m("hiding"), y.current = setTimeout(function() {
        g();
      }, 1e3);
    },
    "data-animatee": x.current
  }, l[h]);
  return /* @__PURE__ */ Te.createElement("div", {
    "data-testid": "animator",
    onTransitionEnd: v,
    onAnimationEnd: v,
    "data-ppui": "true"
  }, d(S));
}, P3 = { exports: {} }, R3 = { exports: {} };
(function(e) {
  function t(n) {
    "@babel/helpers - typeof";
    return e.exports = t = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(r) {
      return typeof r;
    } : function(r) {
      return r && typeof Symbol == "function" && r.constructor === Symbol && r !== Symbol.prototype ? "symbol" : typeof r;
    }, e.exports.__esModule = !0, e.exports.default = e.exports, t(n);
  }
  e.exports = t, e.exports.__esModule = !0, e.exports.default = e.exports;
})(R3);
var wI = R3.exports;
(function(e) {
  var t = wI.default;
  function n() {
    e.exports = n = function() {
      return u;
    }, e.exports.__esModule = !0, e.exports.default = e.exports;
    var r, u = {}, i = Object.prototype, a = i.hasOwnProperty, o = Object.defineProperty || function(M, P, C) {
      M[P] = C.value;
    }, s = typeof Symbol == "function" ? Symbol : {}, c = s.iterator || "@@iterator", l = s.asyncIterator || "@@asyncIterator", d = s.toStringTag || "@@toStringTag";
    function f(M, P, C) {
      return Object.defineProperty(M, P, {
        value: C,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }), M[P];
    }
    try {
      f({}, "");
    } catch {
      f = function(C, R, V) {
        return C[R] = V;
      };
    }
    function p(M, P, C, R) {
      var V = P && P.prototype instanceof v ? P : v, I = Object.create(V.prototype), G = new j(R || []);
      return o(I, "_invoke", {
        value: N(M, C, G)
      }), I;
    }
    function h(M, P, C) {
      try {
        return {
          type: "normal",
          arg: M.call(P, C)
        };
      } catch (R) {
        return {
          type: "throw",
          arg: R
        };
      }
    }
    u.wrap = p;
    var m = "suspendedStart", b = "suspendedYield", x = "executing", y = "completed", g = {};
    function v() {
    }
    function S() {
    }
    function _() {
    }
    var A = {};
    f(A, c, function() {
      return this;
    });
    var k = Object.getPrototypeOf, T = k && k(k(z([])));
    T && T !== i && a.call(T, c) && (A = T);
    var L = _.prototype = v.prototype = Object.create(A);
    function w(M) {
      ["next", "throw", "return"].forEach(function(P) {
        f(M, P, function(C) {
          return this._invoke(P, C);
        });
      });
    }
    function D(M, P) {
      function C(V, I, G, K) {
        var Q = h(M[V], M, I);
        if (Q.type !== "throw") {
          var ae = Q.arg, X = ae.value;
          return X && t(X) == "object" && a.call(X, "__await") ? P.resolve(X.__await).then(function(ne) {
            C("next", ne, G, K);
          }, function(ne) {
            C("throw", ne, G, K);
          }) : P.resolve(X).then(function(ne) {
            ae.value = ne, G(ae);
          }, function(ne) {
            return C("throw", ne, G, K);
          });
        }
        K(Q.arg);
      }
      var R;
      o(this, "_invoke", {
        value: function(I, G) {
          function K() {
            return new P(function(Q, ae) {
              C(I, G, Q, ae);
            });
          }
          return R = R ? R.then(K, K) : K();
        }
      });
    }
    function N(M, P, C) {
      var R = m;
      return function(V, I) {
        if (R === x)
          throw Error("Generator is already running");
        if (R === y) {
          if (V === "throw")
            throw I;
          return {
            value: r,
            done: !0
          };
        }
        for (C.method = V, C.arg = I; ; ) {
          var G = C.delegate;
          if (G) {
            var K = O(G, C);
            if (K) {
              if (K === g)
                continue;
              return K;
            }
          }
          if (C.method === "next")
            C.sent = C._sent = C.arg;
          else if (C.method === "throw") {
            if (R === m)
              throw R = y, C.arg;
            C.dispatchException(C.arg);
          } else
            C.method === "return" && C.abrupt("return", C.arg);
          R = x;
          var Q = h(M, P, C);
          if (Q.type === "normal") {
            if (R = C.done ? y : b, Q.arg === g)
              continue;
            return {
              value: Q.arg,
              done: C.done
            };
          }
          Q.type === "throw" && (R = y, C.method = "throw", C.arg = Q.arg);
        }
      };
    }
    function O(M, P) {
      var C = P.method, R = M.iterator[C];
      if (R === r)
        return P.delegate = null, C === "throw" && M.iterator.return && (P.method = "return", P.arg = r, O(M, P), P.method === "throw") || C !== "return" && (P.method = "throw", P.arg = new TypeError("The iterator does not provide a '" + C + "' method")), g;
      var V = h(R, M.iterator, P.arg);
      if (V.type === "throw")
        return P.method = "throw", P.arg = V.arg, P.delegate = null, g;
      var I = V.arg;
      return I ? I.done ? (P[M.resultName] = I.value, P.next = M.nextLoc, P.method !== "return" && (P.method = "next", P.arg = r), P.delegate = null, g) : I : (P.method = "throw", P.arg = new TypeError("iterator result is not an object"), P.delegate = null, g);
    }
    function H(M) {
      var P = {
        tryLoc: M[0]
      };
      1 in M && (P.catchLoc = M[1]), 2 in M && (P.finallyLoc = M[2], P.afterLoc = M[3]), this.tryEntries.push(P);
    }
    function $(M) {
      var P = M.completion || {};
      P.type = "normal", delete P.arg, M.completion = P;
    }
    function j(M) {
      this.tryEntries = [{
        tryLoc: "root"
      }], M.forEach(H, this), this.reset(!0);
    }
    function z(M) {
      if (M || M === "") {
        var P = M[c];
        if (P)
          return P.call(M);
        if (typeof M.next == "function")
          return M;
        if (!isNaN(M.length)) {
          var C = -1, R = function V() {
            for (; ++C < M.length; )
              if (a.call(M, C))
                return V.value = M[C], V.done = !1, V;
            return V.value = r, V.done = !0, V;
          };
          return R.next = R;
        }
      }
      throw new TypeError(t(M) + " is not iterable");
    }
    return S.prototype = _, o(L, "constructor", {
      value: _,
      configurable: !0
    }), o(_, "constructor", {
      value: S,
      configurable: !0
    }), S.displayName = f(_, d, "GeneratorFunction"), u.isGeneratorFunction = function(M) {
      var P = typeof M == "function" && M.constructor;
      return !!P && (P === S || (P.displayName || P.name) === "GeneratorFunction");
    }, u.mark = function(M) {
      return Object.setPrototypeOf ? Object.setPrototypeOf(M, _) : (M.__proto__ = _, f(M, d, "GeneratorFunction")), M.prototype = Object.create(L), M;
    }, u.awrap = function(M) {
      return {
        __await: M
      };
    }, w(D.prototype), f(D.prototype, l, function() {
      return this;
    }), u.AsyncIterator = D, u.async = function(M, P, C, R, V) {
      V === void 0 && (V = Promise);
      var I = new D(p(M, P, C, R), V);
      return u.isGeneratorFunction(P) ? I : I.next().then(function(G) {
        return G.done ? G.value : I.next();
      });
    }, w(L), f(L, d, "Generator"), f(L, c, function() {
      return this;
    }), f(L, "toString", function() {
      return "[object Generator]";
    }), u.keys = function(M) {
      var P = Object(M), C = [];
      for (var R in P)
        C.push(R);
      return C.reverse(), function V() {
        for (; C.length; ) {
          var I = C.pop();
          if (I in P)
            return V.value = I, V.done = !1, V;
        }
        return V.done = !0, V;
      };
    }, u.values = z, j.prototype = {
      constructor: j,
      reset: function(P) {
        if (this.prev = 0, this.next = 0, this.sent = this._sent = r, this.done = !1, this.delegate = null, this.method = "next", this.arg = r, this.tryEntries.forEach($), !P)
          for (var C in this)
            C.charAt(0) === "t" && a.call(this, C) && !isNaN(+C.slice(1)) && (this[C] = r);
      },
      stop: function() {
        this.done = !0;
        var P = this.tryEntries[0].completion;
        if (P.type === "throw")
          throw P.arg;
        return this.rval;
      },
      dispatchException: function(P) {
        if (this.done)
          throw P;
        var C = this;
        function R(ae, X) {
          return G.type = "throw", G.arg = P, C.next = ae, X && (C.method = "next", C.arg = r), !!X;
        }
        for (var V = this.tryEntries.length - 1; V >= 0; --V) {
          var I = this.tryEntries[V], G = I.completion;
          if (I.tryLoc === "root")
            return R("end");
          if (I.tryLoc <= this.prev) {
            var K = a.call(I, "catchLoc"), Q = a.call(I, "finallyLoc");
            if (K && Q) {
              if (this.prev < I.catchLoc)
                return R(I.catchLoc, !0);
              if (this.prev < I.finallyLoc)
                return R(I.finallyLoc);
            } else if (K) {
              if (this.prev < I.catchLoc)
                return R(I.catchLoc, !0);
            } else {
              if (!Q)
                throw Error("try statement without catch or finally");
              if (this.prev < I.finallyLoc)
                return R(I.finallyLoc);
            }
          }
        }
      },
      abrupt: function(P, C) {
        for (var R = this.tryEntries.length - 1; R >= 0; --R) {
          var V = this.tryEntries[R];
          if (V.tryLoc <= this.prev && a.call(V, "finallyLoc") && this.prev < V.finallyLoc) {
            var I = V;
            break;
          }
        }
        I && (P === "break" || P === "continue") && I.tryLoc <= C && C <= I.finallyLoc && (I = null);
        var G = I ? I.completion : {};
        return G.type = P, G.arg = C, I ? (this.method = "next", this.next = I.finallyLoc, g) : this.complete(G);
      },
      complete: function(P, C) {
        if (P.type === "throw")
          throw P.arg;
        return P.type === "break" || P.type === "continue" ? this.next = P.arg : P.type === "return" ? (this.rval = this.arg = P.arg, this.method = "return", this.next = "end") : P.type === "normal" && C && (this.next = C), g;
      },
      finish: function(P) {
        for (var C = this.tryEntries.length - 1; C >= 0; --C) {
          var R = this.tryEntries[C];
          if (R.finallyLoc === P)
            return this.complete(R.completion, R.afterLoc), $(R), g;
        }
      },
      catch: function(P) {
        for (var C = this.tryEntries.length - 1; C >= 0; --C) {
          var R = this.tryEntries[C];
          if (R.tryLoc === P) {
            var V = R.completion;
            if (V.type === "throw") {
              var I = V.arg;
              $(R);
            }
            return I;
          }
        }
        throw Error("illegal catch attempt");
      },
      delegateYield: function(P, C, R) {
        return this.delegate = {
          iterator: z(P),
          resultName: C,
          nextLoc: R
        }, this.method === "next" && (this.arg = r), g;
      }
    }, u;
  }
  e.exports = n, e.exports.__esModule = !0, e.exports.default = e.exports;
})(P3);
var TI = P3.exports, Oa = TI(), AI = Oa;
try {
  regeneratorRuntime = Oa;
} catch {
  typeof globalThis == "object" ? globalThis.regeneratorRuntime = Oa : Function("r", "regeneratorRuntime = r")(Oa);
}
const zh = /* @__PURE__ */ T2(AI);
function Uh(e, t, n, r, u, i, a) {
  try {
    var o = e[i](a), s = o.value;
  } catch (c) {
    return void n(c);
  }
  o.done ? t(s) : Promise.resolve(s).then(r, u);
}
function kI(e) {
  return function() {
    var t = this, n = arguments;
    return new Promise(function(r, u) {
      var i = e.apply(t, n);
      function a(s) {
        Uh(i, r, u, a, o, "next", s);
      }
      function o(s) {
        Uh(i, r, u, a, o, "throw", s);
      }
      a(void 0);
    });
  };
}
var Zt = function() {
  return Zt = Object.assign || function(t) {
    for (var n, r = 1, u = arguments.length; r < u; r++) {
      n = arguments[r];
      for (var i in n)
        Object.prototype.hasOwnProperty.call(n, i) && (t[i] = n[i]);
    }
    return t;
  }, Zt.apply(this, arguments);
};
function no(e, t) {
  var n = {};
  for (var r in e)
    Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var u = 0, r = Object.getOwnPropertySymbols(e); u < r.length; u++)
      t.indexOf(r[u]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[u]) && (n[r[u]] = e[r[u]]);
  return n;
}
function LI() {
  for (var e = 0, t = 0, n = arguments.length; t < n; t++)
    e += arguments[t].length;
  for (var r = Array(e), u = 0, t = 0; t < n; t++)
    for (var i = arguments[t], a = 0, o = i.length; a < o; a++, u++)
      r[u] = i[a];
  return r;
}
function DI(e, t, n) {
  if (n || arguments.length === 2)
    for (var r = 0, u = t.length, i; r < u; r++)
      (i || !(r in t)) && (i || (i = Array.prototype.slice.call(t, 0, r)), i[r] = t[r]);
  return e.concat(i || Array.prototype.slice.call(t));
}
var Ia = "right-scroll-bar-position", Ma = "width-before-scroll-bar", NI = "with-scroll-bars-hidden", OI = "--removed-body-scroll-bar-size";
function II(e, t) {
  return typeof e == "function" ? e(t) : e && (e.current = t), e;
}
function MI(e, t) {
  var n = me(function() {
    return {
      // value
      value: e,
      // last callback
      callback: t,
      // "memoized" public interface
      facade: {
        get current() {
          return n.value;
        },
        set current(r) {
          var u = n.value;
          u !== r && (n.value = r, n.callback(r, u));
        }
      }
    };
  })[0];
  return n.callback = t, n.facade;
}
function B3(e, t) {
  return MI(t || null, function(n) {
    return e.forEach(function(r) {
      return II(r, n);
    });
  });
}
function F3(e) {
  return e;
}
function H3(e, t) {
  t === void 0 && (t = F3);
  var n = [], r = !1, u = {
    read: function() {
      if (r)
        throw new Error("Sidecar: could not `read` from an `assigned` medium. `read` could be used only with `useMedium`.");
      return n.length ? n[n.length - 1] : e;
    },
    useMedium: function(i) {
      var a = t(i, r);
      return n.push(a), function() {
        n = n.filter(function(o) {
          return o !== a;
        });
      };
    },
    assignSyncMedium: function(i) {
      for (r = !0; n.length; ) {
        var a = n;
        n = [], a.forEach(i);
      }
      n = {
        push: function(o) {
          return i(o);
        },
        filter: function() {
          return n;
        }
      };
    },
    assignMedium: function(i) {
      r = !0;
      var a = [];
      if (n.length) {
        var o = n;
        n = [], o.forEach(i), a = n;
      }
      var s = function() {
        var l = a;
        a = [], l.forEach(i);
      }, c = function() {
        return Promise.resolve().then(s);
      };
      c(), n = {
        push: function(l) {
          a.push(l), c();
        },
        filter: function(l) {
          return a = a.filter(l), n;
        }
      };
    }
  };
  return u;
}
function N0(e, t) {
  return t === void 0 && (t = F3), H3(e, t);
}
function O0(e) {
  e === void 0 && (e = {});
  var t = H3(null);
  return t.options = Zt({ async: !0, ssr: !1 }, e), t;
}
var $3 = function(e) {
  var t = e.sideCar, n = no(e, ["sideCar"]);
  if (!t)
    throw new Error("Sidecar: please provide `sideCar` property to import the right car");
  var r = t.read();
  if (!r)
    throw new Error("Sidecar medium not found");
  return Y.createElement(r, Zt({}, n));
};
$3.isSideCarExport = !0;
function I0(e, t) {
  return e.useMedium(t), $3;
}
var V3 = O0(), Js = function() {
}, M0 = Y.forwardRef(function(e, t) {
  var n = Y.useRef(null), r = Y.useState({
    onScrollCapture: Js,
    onWheelCapture: Js,
    onTouchMoveCapture: Js
  }), u = r[0], i = r[1], a = e.forwardProps, o = e.children, s = e.className, c = e.removeScrollBar, l = e.enabled, d = e.shards, f = e.sideCar, p = e.noIsolation, h = e.inert, m = e.allowPinchZoom, b = e.as, x = b === void 0 ? "div" : b, y = e.gapMode, g = no(e, ["forwardProps", "children", "className", "removeScrollBar", "enabled", "shards", "sideCar", "noIsolation", "inert", "allowPinchZoom", "as", "gapMode"]), v = f, S = B3([n, t]), _ = Zt(Zt({}, g), u);
  return Y.createElement(
    Y.Fragment,
    null,
    l && Y.createElement(v, { sideCar: V3, removeScrollBar: c, shards: d, noIsolation: p, inert: h, setCallbacks: i, allowPinchZoom: !!m, lockRef: n, gapMode: y }),
    a ? Y.cloneElement(Y.Children.only(o), Zt(Zt({}, _), { ref: S })) : Y.createElement(x, Zt({}, _, { className: s, ref: S }), o)
  );
});
M0.defaultProps = {
  enabled: !0,
  removeScrollBar: !0,
  inert: !1
};
M0.classNames = {
  fullWidth: Ma,
  zeroRight: Ia
};
var j3 = { exports: {} }, PI = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED", RI = PI, BI = RI;
function z3() {
}
function U3() {
}
U3.resetWarningCache = z3;
var FI = function() {
  function e(r, u, i, a, o, s) {
    if (s !== BI) {
      var c = new Error(
        "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types"
      );
      throw c.name = "Invariant Violation", c;
    }
  }
  e.isRequired = e;
  function t() {
    return e;
  }
  var n = {
    array: e,
    bigint: e,
    bool: e,
    func: e,
    number: e,
    object: e,
    string: e,
    symbol: e,
    any: e,
    arrayOf: t,
    element: e,
    elementType: e,
    instanceOf: t,
    node: e,
    objectOf: t,
    oneOf: t,
    oneOfType: t,
    shape: t,
    exact: t,
    checkPropTypes: U3,
    resetWarningCache: z3
  };
  return n.PropTypes = n, n;
};
j3.exports = FI();
var FH = j3.exports, nl = "data-focus-lock", q3 = "data-focus-lock-disabled", HI = "data-no-focus-lock", $I = "data-autofocus-inside", VI = "data-no-autofocus", ec = {
  width: "1px",
  height: "0px",
  padding: 0,
  overflow: "hidden",
  position: "fixed",
  top: "1px",
  left: "1px"
}, G3 = N0({}, function(e) {
  var t = e.target, n = e.currentTarget;
  return {
    target: t,
    currentTarget: n
  };
}), W3 = N0(), jI = N0(), K3 = O0({
  async: !0
  // focus-lock sidecar is not required on the server
  // however, it might be required for JSDOM tests
  // ssr: true,
}), zI = [], P0 = /* @__PURE__ */ Y.forwardRef(function(t, n) {
  var r, u = Y.useState(), i = u[0], a = u[1], o = Y.useRef(), s = Y.useRef(!1), c = Y.useRef(null), l = t.children, d = t.disabled, f = t.noFocusGuards, p = t.persistentFocus, h = t.crossFrame, m = t.autoFocus;
  t.allowTextSelection;
  var b = t.group, x = t.className, y = t.whiteList, g = t.hasPositiveIndices, v = t.shards, S = v === void 0 ? zI : v, _ = t.as, A = _ === void 0 ? "div" : _, k = t.lockProps, T = k === void 0 ? {} : k, L = t.sideCar, w = t.returnFocus, D = t.focusOptions, N = t.onActivation, O = t.onDeactivation, H = Y.useState({}), $ = H[0], j = Y.useCallback(function() {
    c.current = c.current || document && document.activeElement, o.current && N && N(o.current), s.current = !0;
  }, [N]), z = Y.useCallback(function() {
    s.current = !1, O && O(o.current);
  }, [O]);
  oe(function() {
    d || (c.current = null);
  }, []);
  var M = Y.useCallback(function(Q) {
    var ae = c.current;
    if (ae && ae.focus) {
      var X = typeof w == "function" ? w(ae) : w;
      if (X) {
        var ne = typeof X == "object" ? X : void 0;
        c.current = null, Q ? Promise.resolve().then(function() {
          return ae.focus(ne);
        }) : ae.focus(ne);
      }
    }
  }, [w]), P = Y.useCallback(function(Q) {
    s.current && G3.useMedium(Q);
  }, []), C = W3.useMedium, R = Y.useCallback(function(Q) {
    o.current !== Q && (o.current = Q, a(Q));
  }, []), V = Be((r = {}, r[q3] = d && "disabled", r[nl] = b, r), T), I = f !== !0, G = I && f !== "tail", K = B3([n, R]);
  return /* @__PURE__ */ Y.createElement(Y.Fragment, null, I && [
    // nearest focus guard
    /* @__PURE__ */ Y.createElement("div", {
      key: "guard-first",
      "data-focus-guard": !0,
      tabIndex: d ? -1 : 0,
      style: ec
    }),
    // first tabbed element guard
    g ? /* @__PURE__ */ Y.createElement("div", {
      key: "guard-nearest",
      "data-focus-guard": !0,
      tabIndex: d ? -1 : 1,
      style: ec
    }) : null
  ], !d && /* @__PURE__ */ Y.createElement(L, {
    id: $,
    sideCar: K3,
    observed: i,
    disabled: d,
    persistentFocus: p,
    crossFrame: h,
    autoFocus: m,
    whiteList: y,
    shards: S,
    onActivation: j,
    onDeactivation: z,
    returnFocus: M,
    focusOptions: D
  }), /* @__PURE__ */ Y.createElement(A, Be({
    ref: K
  }, V, {
    className: x,
    onBlur: C,
    onFocus: P
  }), l), G && /* @__PURE__ */ Y.createElement("div", {
    "data-focus-guard": !0,
    tabIndex: d ? -1 : 0,
    style: ec
  }));
});
P0.propTypes = {};
P0.defaultProps = {
  children: void 0,
  disabled: !1,
  returnFocus: !1,
  focusOptions: void 0,
  noFocusGuards: !1,
  autoFocus: !0,
  persistentFocus: !1,
  crossFrame: !0,
  hasPositiveIndices: void 0,
  allowTextSelection: void 0,
  group: void 0,
  className: void 0,
  whiteList: void 0,
  shards: void 0,
  as: "div",
  lockProps: {},
  onActivation: void 0,
  onDeactivation: void 0
};
const UI = P0;
function Y3(e) {
  var t = window, n = t.setImmediate;
  typeof n < "u" ? n(e) : setTimeout(e, 1);
}
var Z3 = O0(), X3 = "data-focus-on-hidden", qI = Y.forwardRef(function(e, t) {
  var n = Y.useState(!1), r = n[0], u = n[1], i = e.children, a = e.autoFocus, o = e.shards, s = e.enabled, c = s === void 0 ? !0 : s, l = e.scrollLock, d = l === void 0 ? !0 : l, f = e.focusLock, p = f === void 0 ? !0 : f, h = e.returnFocus, m = h === void 0 ? !0 : h, b = e.inert, x = e.allowPinchZoom, y = e.sideCar, g = e.className, v = e.shouldIgnore, S = e.preventScrollOnFocus, _ = e.style, A = e.as, k = e.gapMode, T = no(e, ["children", "autoFocus", "shards", "enabled", "scrollLock", "focusLock", "returnFocus", "inert", "allowPinchZoom", "sideCar", "className", "shouldIgnore", "preventScrollOnFocus", "style", "as", "gapMode"]), L = y, w = r.onActivation, D = r.onDeactivation, N = no(r, ["onActivation", "onDeactivation"]), O = Zt(Zt({}, N), {
    as: A,
    style: _,
    sideCar: y,
    shards: o,
    allowPinchZoom: x,
    gapMode: k,
    inert: b,
    enabled: c && d
  });
  return Y.createElement(
    Y.Fragment,
    null,
    Y.createElement(UI, { ref: t, sideCar: y, disabled: !(r && c && p), returnFocus: m, autoFocus: a, shards: o, onActivation: w, onDeactivation: D, className: g, whiteList: v, lockProps: O, focusOptions: S ? { preventScroll: !0 } : void 0, as: M0 }, i),
    c && Y.createElement(L, Zt({}, T, { sideCar: Z3, setLockProps: u, shards: o }))
  );
});
function GI(e, t) {
  function n(r) {
    return r.displayName || r.name || "Component";
  }
  return function(u) {
    var i = [], a;
    function o() {
      a = e(i.map(function(c) {
        return c.props;
      })), t(a);
    }
    var s = /* @__PURE__ */ function(c) {
      A3(l, c);
      function l() {
        return c.apply(this, arguments) || this;
      }
      l.peek = function() {
        return a;
      };
      var d = l.prototype;
      return d.componentDidMount = function() {
        i.push(this), o();
      }, d.componentDidUpdate = function() {
        o();
      }, d.componentWillUnmount = function() {
        var p = i.indexOf(this);
        i.splice(p, 1), o();
      }, d.render = function() {
        return /* @__PURE__ */ Te.createElement(u, this.props);
      }, l;
    }(F4);
    return Ve(s, "displayName", "SideEffect(" + n(u) + ")"), s;
  };
}
var Pn = function(e) {
  for (var t = Array(e.length), n = 0; n < e.length; ++n)
    t[n] = e[n];
  return t;
}, ro = function(e) {
  return Array.isArray(e) ? e : [e];
}, Q3 = function(e) {
  return Array.isArray(e) ? e[0] : e;
}, WI = function(e) {
  if (e.nodeType !== Node.ELEMENT_NODE)
    return !1;
  var t = window.getComputedStyle(e, null);
  return !t || !t.getPropertyValue ? !1 : t.getPropertyValue("display") === "none" || t.getPropertyValue("visibility") === "hidden";
}, J3 = function(e) {
  return e.parentNode && e.parentNode.nodeType === Node.DOCUMENT_FRAGMENT_NODE ? (
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    e.parentNode.host
  ) : e.parentNode;
}, e6 = function(e) {
  return e === document || e && e.nodeType === Node.DOCUMENT_NODE;
}, KI = function(e, t) {
  return !e || e6(e) || !WI(e) && t(J3(e));
}, t6 = function(e, t) {
  var n = e.get(t);
  if (n !== void 0)
    return n;
  var r = KI(t, t6.bind(void 0, e));
  return e.set(t, r), r;
}, YI = function(e, t) {
  return e && !e6(e) ? QI(e) ? t(J3(e)) : !1 : !0;
}, n6 = function(e, t) {
  var n = e.get(t);
  if (n !== void 0)
    return n;
  var r = YI(t, n6.bind(void 0, e));
  return e.set(t, r), r;
}, r6 = function(e) {
  return e.dataset;
}, ZI = function(e) {
  return e.tagName === "BUTTON";
}, u6 = function(e) {
  return e.tagName === "INPUT";
}, i6 = function(e) {
  return u6(e) && e.type === "radio";
}, XI = function(e) {
  return !((u6(e) || ZI(e)) && (e.type === "hidden" || e.disabled));
}, QI = function(e) {
  var t = e.getAttribute(VI);
  return ![!0, "true", ""].includes(t);
}, R0 = function(e) {
  var t;
  return !!(e && (!((t = r6(e)) === null || t === void 0) && t.focusGuard));
}, uo = function(e) {
  return !R0(e);
}, JI = function(e) {
  return !!e;
}, eM = function(e, t) {
  var n = e.tabIndex - t.tabIndex, r = e.index - t.index;
  if (n) {
    if (!e.tabIndex)
      return 1;
    if (!t.tabIndex)
      return -1;
  }
  return n || r;
}, a6 = function(e, t, n) {
  return Pn(e).map(function(r, u) {
    return {
      node: r,
      index: u,
      tabIndex: n && r.tabIndex === -1 ? (r.dataset || {}).focusGuard ? 0 : -1 : r.tabIndex
    };
  }).filter(function(r) {
    return !t || r.tabIndex >= 0;
  }).sort(eM);
}, tM = [
  "button:enabled",
  "select:enabled",
  "textarea:enabled",
  "input:enabled",
  // elements with explicit roles will also use explicit tabindex
  // '[role="button"]',
  "a[href]",
  "area[href]",
  "summary",
  "iframe",
  "object",
  "embed",
  "audio[controls]",
  "video[controls]",
  "[tabindex]",
  "[contenteditable]",
  "[autofocus]"
], B0 = tM.join(","), nM = "".concat(B0, ", [data-focus-guard]"), o6 = function(e, t) {
  return Pn((e.shadowRoot || e).children).reduce(function(n, r) {
    return n.concat(r.matches(t ? nM : B0) ? [r] : [], o6(r));
  }, []);
}, rM = function(e, t) {
  var n;
  return e instanceof HTMLIFrameElement && (!((n = e.contentDocument) === null || n === void 0) && n.body) ? Wo([e.contentDocument.body], t) : [e];
}, Wo = function(e, t) {
  return e.reduce(function(n, r) {
    var u, i = o6(r, t), a = (u = []).concat.apply(u, i.map(function(o) {
      return rM(o, t);
    }));
    return n.concat(
      // add all tabbables inside and within shadow DOMs in DOM order
      a,
      // add if node is tabbable itself
      r.parentNode ? Pn(r.parentNode.querySelectorAll(B0)).filter(function(o) {
        return o === r;
      }) : []
    );
  }, []);
}, uM = function(e) {
  var t = e.querySelectorAll("[".concat($I, "]"));
  return Pn(t).map(function(n) {
    return Wo([n]);
  }).reduce(function(n, r) {
    return n.concat(r);
  }, []);
}, F0 = function(e, t) {
  return Pn(e).filter(function(n) {
    return t6(t, n);
  }).filter(function(n) {
    return XI(n);
  });
}, qh = function(e, t) {
  return t === void 0 && (t = /* @__PURE__ */ new Map()), Pn(e).filter(function(n) {
    return n6(t, n);
  });
}, rl = function(e, t, n) {
  return a6(F0(Wo(e, n), t), !0, n);
}, Gh = function(e, t) {
  return a6(F0(Wo(e), t), !1);
}, iM = function(e, t) {
  return F0(uM(e), t);
}, _u = function(e, t) {
  return e.shadowRoot ? _u(e.shadowRoot, t) : Object.getPrototypeOf(e).contains !== void 0 && Object.getPrototypeOf(e).contains.call(e, t) ? !0 : Pn(e.children).some(function(n) {
    var r;
    if (n instanceof HTMLIFrameElement) {
      var u = (r = n.contentDocument) === null || r === void 0 ? void 0 : r.body;
      return u ? _u(u, t) : !1;
    }
    return _u(n, t);
  });
}, aM = function(e) {
  for (var t = /* @__PURE__ */ new Set(), n = e.length, r = 0; r < n; r += 1)
    for (var u = r + 1; u < n; u += 1) {
      var i = e[r].compareDocumentPosition(e[u]);
      (i & Node.DOCUMENT_POSITION_CONTAINED_BY) > 0 && t.add(u), (i & Node.DOCUMENT_POSITION_CONTAINS) > 0 && t.add(r);
    }
  return e.filter(function(a, o) {
    return !t.has(o);
  });
}, s6 = function(e) {
  return e.parentNode ? s6(e.parentNode) : e;
}, H0 = function(e) {
  var t = ro(e);
  return t.filter(Boolean).reduce(function(n, r) {
    var u = r.getAttribute(nl);
    return n.push.apply(n, u ? aM(Pn(s6(r).querySelectorAll("[".concat(nl, '="').concat(u, '"]:not([').concat(q3, '="disabled"])')))) : [r]), n;
  }, []);
}, oM = function(e) {
  try {
    return e();
  } catch {
    return;
  }
}, Oi = function(e) {
  if (e === void 0 && (e = document), !(!e || !e.activeElement)) {
    var t = e.activeElement;
    return t.shadowRoot ? Oi(t.shadowRoot) : t instanceof HTMLIFrameElement && oM(function() {
      return t.contentWindow.document;
    }) ? Oi(t.contentWindow.document) : t;
  }
}, sM = function(e, t) {
  return e === t;
}, cM = function(e, t) {
  return !!Pn(e.querySelectorAll("iframe")).some(function(n) {
    return sM(n, t);
  });
}, c6 = function(e, t) {
  return t === void 0 && (t = Oi(Q3(e).ownerDocument)), !t || t.dataset && t.dataset.focusGuard ? !1 : H0(e).some(function(n) {
    return _u(n, t) || cM(n, t);
  });
}, lM = function(e) {
  e === void 0 && (e = document);
  var t = Oi(e);
  return t ? Pn(e.querySelectorAll("[".concat(HI, "]"))).some(function(n) {
    return _u(n, t);
  }) : !1;
}, dM = function(e, t) {
  return t.filter(i6).filter(function(n) {
    return n.name === e.name;
  }).filter(function(n) {
    return n.checked;
  })[0] || e;
}, $0 = function(e, t) {
  return i6(e) && e.name ? dM(e, t) : e;
}, fM = function(e) {
  var t = /* @__PURE__ */ new Set();
  return e.forEach(function(n) {
    return t.add($0(n, e));
  }), e.filter(function(n) {
    return t.has(n);
  });
}, Wh = function(e) {
  return e[0] && e.length > 1 ? $0(e[0], e) : e[0];
}, Kh = function(e, t) {
  return e.length > 1 ? e.indexOf($0(e[t], e)) : t;
}, l6 = "NEW_FOCUS", pM = function(e, t, n, r) {
  var u = e.length, i = e[0], a = e[u - 1], o = R0(n);
  if (!(n && e.indexOf(n) >= 0)) {
    var s = n !== void 0 ? t.indexOf(n) : -1, c = r ? t.indexOf(r) : s, l = r ? e.indexOf(r) : -1, d = s - c, f = t.indexOf(i), p = t.indexOf(a), h = fM(t), m = n !== void 0 ? h.indexOf(n) : -1, b = m - (r ? h.indexOf(r) : s), x = Kh(e, 0), y = Kh(e, u - 1);
    if (s === -1 || l === -1)
      return l6;
    if (!d && l >= 0)
      return l;
    if (s <= f && o && Math.abs(d) > 1)
      return y;
    if (s >= p && o && Math.abs(d) > 1)
      return x;
    if (d && Math.abs(b) > 1)
      return l;
    if (s <= f)
      return y;
    if (s > p)
      return x;
    if (d)
      return Math.abs(d) > 1 ? l : (u + l + d) % u;
  }
}, hM = function(e) {
  return function(t) {
    var n, r = (n = r6(t)) === null || n === void 0 ? void 0 : n.autofocus;
    return (
      // @ts-expect-error
      t.autofocus || //
      r !== void 0 && r !== "false" || //
      e.indexOf(t) >= 0
    );
  };
}, mM = function(e, t, n) {
  var r = e.map(function(i) {
    var a = i.node;
    return a;
  }), u = qh(r.filter(hM(n)));
  return u && u.length ? Wh(u) : Wh(qh(t));
}, ul = function(e, t) {
  return t === void 0 && (t = []), t.push(e), e.parentNode && ul(e.parentNode.host || e.parentNode, t), t;
}, tc = function(e, t) {
  for (var n = ul(e), r = ul(t), u = 0; u < n.length; u += 1) {
    var i = n[u];
    if (r.indexOf(i) >= 0)
      return i;
  }
  return !1;
}, d6 = function(e, t, n) {
  var r = ro(e), u = ro(t), i = r[0], a = !1;
  return u.filter(Boolean).forEach(function(o) {
    a = tc(a || o, o) || a, n.filter(Boolean).forEach(function(s) {
      var c = tc(i, s);
      c && (!a || _u(c, a) ? a = c : a = tc(c, a));
    });
  }), a;
}, gM = function(e, t) {
  return e.reduce(function(n, r) {
    return n.concat(iM(r, t));
  }, []);
}, bM = function(e, t) {
  var n = /* @__PURE__ */ new Map();
  return t.forEach(function(r) {
    return n.set(r.node, r);
  }), e.map(function(r) {
    return n.get(r);
  }).filter(JI);
}, vM = function(e, t) {
  var n = Oi(ro(e).length > 0 ? document : Q3(e).ownerDocument), r = H0(e).filter(uo), u = d6(n || e, e, r), i = /* @__PURE__ */ new Map(), a = Gh(r, i), o = rl(r, i).filter(function(p) {
    var h = p.node;
    return uo(h);
  });
  if (!(!o[0] && (o = a, !o[0]))) {
    var s = Gh([u], i).map(function(p) {
      var h = p.node;
      return h;
    }), c = bM(s, o), l = c.map(function(p) {
      var h = p.node;
      return h;
    }), d = pM(l, s, n, t);
    if (d === l6) {
      var f = mM(a, l, gM(r, i));
      if (f)
        return { node: f };
      console.warn("focus-lock: cannot find any node to move focus into");
      return;
    }
    return d === void 0 ? d : c[d];
  }
}, yM = function(e) {
  var t = H0(e).filter(uo), n = d6(e, e, t), r = /* @__PURE__ */ new Map(), u = rl([n], r, !0), i = rl(t, r).filter(function(a) {
    var o = a.node;
    return uo(o);
  }).map(function(a) {
    var o = a.node;
    return o;
  });
  return u.map(function(a) {
    var o = a.node, s = a.index;
    return {
      node: o,
      index: s,
      lockItem: i.indexOf(o) >= 0,
      guard: R0(o)
    };
  });
}, xM = function(e, t) {
  "focus" in e && e.focus(t), "contentWindow" in e && e.contentWindow && e.contentWindow.focus();
}, nc = 0, rc = !1, f6 = function(e, t, n) {
  n === void 0 && (n = {});
  var r = vM(e, t);
  if (!rc && r) {
    if (nc > 2) {
      console.error("FocusLock: focus-fighting detected. Only one focus management system could be active. See https://github.com/theKashey/focus-lock/#focus-fighting"), rc = !0, setTimeout(function() {
        rc = !1;
      }, 1);
      return;
    }
    nc++, xM(r.node, n.focusOptions), nc--;
  }
}, _M = function() {
  return document && document.activeElement === document.body;
}, SM = function() {
  return _M() || lM();
}, Su = null, hu = null, Cu = null, Ii = !1, CM = function() {
  return !0;
}, EM = function(t) {
  return (Su.whiteList || CM)(t);
}, wM = function(t, n) {
  Cu = {
    observerNode: t,
    portaledElement: n
  };
}, TM = function(t) {
  return Cu && Cu.portaledElement === t;
};
function Yh(e, t, n, r) {
  var u = null, i = e;
  do {
    var a = r[i];
    if (a.guard)
      a.node.dataset.focusAutoGuard && (u = a);
    else if (a.lockItem) {
      if (i !== e)
        return;
      u = null;
    } else
      break;
  } while ((i += n) !== t);
  u && (u.node.tabIndex = 0);
}
var AM = function(t) {
  return t && "current" in t ? t.current : t;
}, kM = function(t) {
  return t ? !!Ii : Ii === "meanwhile";
}, LM = function e(t, n, r) {
  return n && // find host equal to active element and check nested active element
  (n.host === t && (!n.activeElement || r.contains(n.activeElement)) || n.parentNode && e(t, n.parentNode, r));
}, DM = function(t, n) {
  return n.some(function(r) {
    return LM(t, r, r);
  });
}, io = function() {
  var t = !1;
  if (Su) {
    var n = Su, r = n.observed, u = n.persistentFocus, i = n.autoFocus, a = n.shards, o = n.crossFrame, s = n.focusOptions, c = r || Cu && Cu.portaledElement, l = document && document.activeElement;
    if (c) {
      var d = [c].concat(a.map(AM).filter(Boolean));
      if ((!l || EM(l)) && (u || kM(o) || !SM() || !hu && i) && (c && !// active element is "inside" working area
      (c6(d) || // check for shadow-dom contained elements
      l && DM(l, d) || TM(l)) && (document && !hu && l && !i ? (l.blur && l.blur(), document.body.focus()) : (t = f6(d, hu, {
        focusOptions: s
      }), Cu = {})), Ii = !1, hu = document && document.activeElement), document) {
        var f = document && document.activeElement, p = yM(d), h = p.map(function(m) {
          var b = m.node;
          return b;
        }).indexOf(f);
        h > -1 && (p.filter(function(m) {
          var b = m.guard, x = m.node;
          return b && x.dataset.focusAutoGuard;
        }).forEach(function(m) {
          var b = m.node;
          return b.removeAttribute("tabIndex");
        }), Yh(h, p.length, 1, p), Yh(h, -1, -1, p));
      }
    }
  }
  return t;
}, p6 = function(t) {
  io() && t && (t.stopPropagation(), t.preventDefault());
}, V0 = function() {
  return Y3(io);
}, NM = function(t) {
  var n = t.target, r = t.currentTarget;
  r.contains(n) || wM(r, n);
}, OM = function() {
  return null;
}, h6 = function() {
  Ii = "just", setTimeout(function() {
    Ii = "meanwhile";
  }, 0);
}, IM = function() {
  document.addEventListener("focusin", p6), document.addEventListener("focusout", V0), window.addEventListener("blur", h6);
}, MM = function() {
  document.removeEventListener("focusin", p6), document.removeEventListener("focusout", V0), window.removeEventListener("blur", h6);
};
function PM(e) {
  return e.filter(function(t) {
    var n = t.disabled;
    return !n;
  });
}
function RM(e) {
  var t = e.slice(-1)[0];
  t && !Su && IM();
  var n = Su, r = n && t && t.id === n.id;
  Su = t, n && !r && (n.onDeactivation(), e.filter(function(u) {
    var i = u.id;
    return i === n.id;
  }).length || n.returnFocus(!t)), t ? (hu = null, (!r || n.observed !== t.observed) && t.onActivation(), io(), Y3(io)) : (MM(), hu = null);
}
G3.assignSyncMedium(NM);
W3.assignMedium(V0);
jI.assignMedium(function(e) {
  return e({
    moveFocusInside: f6,
    focusInside: c6
  });
});
const BM = GI(PM, RM)(OM);
I0(K3, BM);
var Zh, FM = function() {
  if (Zh)
    return Zh;
  if (typeof __webpack_nonce__ < "u")
    return __webpack_nonce__;
};
function HM() {
  if (!document)
    return null;
  var e = document.createElement("style");
  e.type = "text/css";
  var t = FM();
  return t && e.setAttribute("nonce", t), e;
}
function $M(e, t) {
  e.styleSheet ? e.styleSheet.cssText = t : e.appendChild(document.createTextNode(t));
}
function VM(e) {
  var t = document.head || document.getElementsByTagName("head")[0];
  t.appendChild(e);
}
var jM = function() {
  var e = 0, t = null;
  return {
    add: function(n) {
      e == 0 && (t = HM()) && ($M(t, n), VM(t)), e++;
    },
    remove: function() {
      e--, !e && t && (t.parentNode && t.parentNode.removeChild(t), t = null);
    }
  };
}, zM = function() {
  var e = jM();
  return function(t, n) {
    Y.useEffect(function() {
      return e.add(t), function() {
        e.remove();
      };
    }, [t && n]);
  };
}, j0 = function() {
  var e = zM(), t = function(n) {
    var r = n.styles, u = n.dynamic;
    return e(r, u), null;
  };
  return t;
}, UM = {
  left: 0,
  top: 0,
  right: 0,
  gap: 0
}, uc = function(e) {
  return parseInt(e || "", 10) || 0;
}, qM = function(e) {
  var t = window.getComputedStyle(document.body), n = t[e === "padding" ? "paddingLeft" : "marginLeft"], r = t[e === "padding" ? "paddingTop" : "marginTop"], u = t[e === "padding" ? "paddingRight" : "marginRight"];
  return [uc(n), uc(r), uc(u)];
}, GM = function(e) {
  if (e === void 0 && (e = "margin"), typeof window > "u")
    return UM;
  var t = qM(e), n = document.documentElement.clientWidth, r = window.innerWidth;
  return {
    left: t[0],
    top: t[1],
    right: t[2],
    gap: Math.max(0, r - n + t[2] - t[0])
  };
}, WM = j0(), KM = function(e, t, n, r) {
  var u = e.left, i = e.top, a = e.right, o = e.gap;
  return n === void 0 && (n = "margin"), `
  .`.concat(NI, ` {
   overflow: hidden `).concat(r, `;
   padding-right: `).concat(o, "px ").concat(r, `;
  }
  body {
    overflow: hidden `).concat(r, `;
    overscroll-behavior: contain;
    `).concat([
    t && "position: relative ".concat(r, ";"),
    n === "margin" && `
    padding-left: `.concat(u, `px;
    padding-top: `).concat(i, `px;
    padding-right: `).concat(a, `px;
    margin-left:0;
    margin-top:0;
    margin-right: `).concat(o, "px ").concat(r, `;
    `),
    n === "padding" && "padding-right: ".concat(o, "px ").concat(r, ";")
  ].filter(Boolean).join(""), `
  }
  
  .`).concat(Ia, ` {
    right: `).concat(o, "px ").concat(r, `;
  }
  
  .`).concat(Ma, ` {
    margin-right: `).concat(o, "px ").concat(r, `;
  }
  
  .`).concat(Ia, " .").concat(Ia, ` {
    right: 0 `).concat(r, `;
  }
  
  .`).concat(Ma, " .").concat(Ma, ` {
    margin-right: 0 `).concat(r, `;
  }
  
  body {
    `).concat(OI, ": ").concat(o, `px;
  }
`);
}, YM = function(e) {
  var t = e.noRelative, n = e.noImportant, r = e.gapMode, u = r === void 0 ? "margin" : r, i = Y.useMemo(function() {
    return GM(u);
  }, [u]);
  return Y.createElement(WM, { styles: KM(i, !t, u, n ? "" : "!important") });
}, il = !1;
if (typeof window < "u")
  try {
    var ma = Object.defineProperty({}, "passive", {
      get: function() {
        return il = !0, !0;
      }
    });
    window.addEventListener("test", ma, ma), window.removeEventListener("test", ma, ma);
  } catch {
    il = !1;
  }
var Jr = il ? { passive: !1 } : !1, ZM = function(e) {
  return e.tagName === "TEXTAREA";
}, m6 = function(e, t) {
  var n = window.getComputedStyle(e);
  return (
    // not-not-scrollable
    n[t] !== "hidden" && // contains scroll inside self
    !(n.overflowY === n.overflowX && !ZM(e) && n[t] === "visible")
  );
}, XM = function(e) {
  return m6(e, "overflowY");
}, QM = function(e) {
  return m6(e, "overflowX");
}, Xh = function(e, t) {
  var n = t.ownerDocument, r = t;
  do {
    typeof ShadowRoot < "u" && r instanceof ShadowRoot && (r = r.host);
    var u = g6(e, r);
    if (u) {
      var i = b6(e, r), a = i[1], o = i[2];
      if (a > o)
        return !0;
    }
    r = r.parentNode;
  } while (r && r !== n.body);
  return !1;
}, JM = function(e) {
  var t = e.scrollTop, n = e.scrollHeight, r = e.clientHeight;
  return [
    t,
    n,
    r
  ];
}, eP = function(e) {
  var t = e.scrollLeft, n = e.scrollWidth, r = e.clientWidth;
  return [
    t,
    n,
    r
  ];
}, g6 = function(e, t) {
  return e === "v" ? XM(t) : QM(t);
}, b6 = function(e, t) {
  return e === "v" ? JM(t) : eP(t);
}, tP = function(e, t) {
  return e === "h" && t === "rtl" ? -1 : 1;
}, nP = function(e, t, n, r, u) {
  var i = tP(e, window.getComputedStyle(t).direction), a = i * r, o = n.target, s = t.contains(o), c = !1, l = a > 0, d = 0, f = 0;
  do {
    var p = b6(e, o), h = p[0], m = p[1], b = p[2], x = m - b - i * h;
    (h || x) && g6(e, o) && (d += x, f += h), o = o.parentNode;
  } while (
    // portaled content
    !s && o !== document.body || // self content
    s && (t.contains(o) || t === o)
  );
  return (l && (u && d === 0 || !u && a > d) || !l && (u && f === 0 || !u && -a > f)) && (c = !0), c;
}, ga = function(e) {
  return "changedTouches" in e ? [e.changedTouches[0].clientX, e.changedTouches[0].clientY] : [0, 0];
}, Qh = function(e) {
  return [e.deltaX, e.deltaY];
}, Jh = function(e) {
  return e && "current" in e ? e.current : e;
}, rP = function(e, t) {
  return e[0] === t[0] && e[1] === t[1];
}, uP = function(e) {
  return `
  .block-interactivity-`.concat(e, ` {pointer-events: none;}
  .allow-interactivity-`).concat(e, ` {pointer-events: all;}
`);
}, iP = 0, eu = [];
function aP(e) {
  var t = Y.useRef([]), n = Y.useRef([0, 0]), r = Y.useRef(), u = Y.useState(iP++)[0], i = Y.useState(j0)[0], a = Y.useRef(e);
  Y.useEffect(function() {
    a.current = e;
  }, [e]), Y.useEffect(function() {
    if (e.inert) {
      document.body.classList.add("block-interactivity-".concat(u));
      var m = DI([e.lockRef.current], (e.shards || []).map(Jh), !0).filter(Boolean);
      return m.forEach(function(b) {
        return b.classList.add("allow-interactivity-".concat(u));
      }), function() {
        document.body.classList.remove("block-interactivity-".concat(u)), m.forEach(function(b) {
          return b.classList.remove("allow-interactivity-".concat(u));
        });
      };
    }
  }, [e.inert, e.lockRef.current, e.shards]);
  var o = Y.useCallback(function(m, b) {
    if ("touches" in m && m.touches.length === 2)
      return !a.current.allowPinchZoom;
    var x = ga(m), y = n.current, g = "deltaX" in m ? m.deltaX : y[0] - x[0], v = "deltaY" in m ? m.deltaY : y[1] - x[1], S, _ = m.target, A = Math.abs(g) > Math.abs(v) ? "h" : "v";
    if ("touches" in m && A === "h" && _.type === "range")
      return !1;
    var k = Xh(A, _);
    if (!k)
      return !0;
    if (k ? S = A : (S = A === "v" ? "h" : "v", k = Xh(A, _)), !k)
      return !1;
    if (!r.current && "changedTouches" in m && (g || v) && (r.current = S), !S)
      return !0;
    var T = r.current || S;
    return nP(T, b, m, T === "h" ? g : v, !0);
  }, []), s = Y.useCallback(function(m) {
    var b = m;
    if (!(!eu.length || eu[eu.length - 1] !== i)) {
      var x = "deltaY" in b ? Qh(b) : ga(b), y = t.current.filter(function(S) {
        return S.name === b.type && S.target === b.target && rP(S.delta, x);
      })[0];
      if (y && y.should) {
        b.cancelable && b.preventDefault();
        return;
      }
      if (!y) {
        var g = (a.current.shards || []).map(Jh).filter(Boolean).filter(function(S) {
          return S.contains(b.target);
        }), v = g.length > 0 ? o(b, g[0]) : !a.current.noIsolation;
        v && b.cancelable && b.preventDefault();
      }
    }
  }, []), c = Y.useCallback(function(m, b, x, y) {
    var g = { name: m, delta: b, target: x, should: y };
    t.current.push(g), setTimeout(function() {
      t.current = t.current.filter(function(v) {
        return v !== g;
      });
    }, 1);
  }, []), l = Y.useCallback(function(m) {
    n.current = ga(m), r.current = void 0;
  }, []), d = Y.useCallback(function(m) {
    c(m.type, Qh(m), m.target, o(m, e.lockRef.current));
  }, []), f = Y.useCallback(function(m) {
    c(m.type, ga(m), m.target, o(m, e.lockRef.current));
  }, []);
  Y.useEffect(function() {
    return eu.push(i), e.setCallbacks({
      onScrollCapture: d,
      onWheelCapture: d,
      onTouchMoveCapture: f
    }), document.addEventListener("wheel", s, Jr), document.addEventListener("touchmove", s, Jr), document.addEventListener("touchstart", l, Jr), function() {
      eu = eu.filter(function(m) {
        return m !== i;
      }), document.removeEventListener("wheel", s, Jr), document.removeEventListener("touchmove", s, Jr), document.removeEventListener("touchstart", l, Jr);
    };
  }, []);
  var p = e.removeScrollBar, h = e.inert;
  return Y.createElement(
    Y.Fragment,
    null,
    h ? Y.createElement(i, { styles: uP(u) }) : null,
    p ? Y.createElement(YM, { gapMode: e.gapMode }) : null
  );
}
I0(V3, aP);
var oP = function(e) {
  if (typeof document > "u")
    return null;
  var t = Array.isArray(e) ? e[0] : e;
  return t.ownerDocument.body;
}, tu = /* @__PURE__ */ new WeakMap(), ba = /* @__PURE__ */ new WeakMap(), va = {}, ic = 0, v6 = function(e) {
  return e && (e.host || v6(e.parentNode));
}, sP = function(e, t) {
  return t.map(function(n) {
    if (e.contains(n))
      return n;
    var r = v6(n);
    return r && e.contains(r) ? r : (console.error("aria-hidden", n, "in not contained inside", e, ". Doing nothing"), null);
  }).filter(function(n) {
    return !!n;
  });
}, cP = function(e, t, n, r) {
  var u = sP(t, Array.isArray(e) ? e : [e]);
  va[n] || (va[n] = /* @__PURE__ */ new WeakMap());
  var i = va[n], a = [], o = /* @__PURE__ */ new Set(), s = new Set(u), c = function(d) {
    !d || o.has(d) || (o.add(d), c(d.parentNode));
  };
  u.forEach(c);
  var l = function(d) {
    !d || s.has(d) || Array.prototype.forEach.call(d.children, function(f) {
      if (o.has(f))
        l(f);
      else {
        var p = f.getAttribute(r), h = p !== null && p !== "false", m = (tu.get(f) || 0) + 1, b = (i.get(f) || 0) + 1;
        tu.set(f, m), i.set(f, b), a.push(f), m === 1 && h && ba.set(f, !0), b === 1 && f.setAttribute(n, "true"), h || f.setAttribute(r, "true");
      }
    });
  };
  return l(t), o.clear(), ic++, function() {
    a.forEach(function(d) {
      var f = tu.get(d) - 1, p = i.get(d) - 1;
      tu.set(d, f), i.set(d, p), f || (ba.has(d) || d.removeAttribute(r), ba.delete(d)), p || d.removeAttribute(n);
    }), ic--, ic || (tu = /* @__PURE__ */ new WeakMap(), tu = /* @__PURE__ */ new WeakMap(), ba = /* @__PURE__ */ new WeakMap(), va = {});
  };
}, lP = function(e, t, n) {
  n === void 0 && (n = "data-aria-hidden");
  var r = Array.from(Array.isArray(e) ? e : [e]), u = t || oP(e);
  return u ? (r.push.apply(r, Array.from(u.querySelectorAll("[aria-live]"))), cP(r, u, n, "aria-hidden")) : function() {
    return null;
  };
}, dP = j0(), fP = `
 [` + X3 + `] {
   pointer-events: none !important;
 }
`, pP = function() {
  return Y.createElement(dP, { styles: fP });
}, em = function(e) {
  return "current" in e ? e.current : e;
};
function hP(e) {
  var t = e.setLockProps, n = e.onEscapeKey, r = e.onClickOutside, u = e.shards, i = e.onActivation, a = e.onDeactivation, o = e.noIsolation, s = me(void 0), c = s[0], l = s[1], d = Z(null), f = Z(0);
  return Y.useEffect(function() {
    var p = function(x) {
      x.defaultPrevented || (x.code === "Escape" || x.key === "Escape" || x.keyCode === 27) && n && n(x);
    }, h = function(x) {
      x.defaultPrevented || x.target === d.current || x instanceof MouseEvent && x.button !== 0 || u && u.map(em).some(function(y) {
        return y && y.contains(x.target) || y === x.target;
      }) || r && r(x);
    }, m = function(x) {
      h(x), f.current = x.touches.length;
    }, b = function(x) {
      f.current = x.touches.length;
    };
    if (c)
      return document.addEventListener("keydown", p), document.addEventListener("mousedown", h), document.addEventListener("touchstart", m), document.addEventListener("touchend", b), function() {
        document.removeEventListener("keydown", p), document.removeEventListener("mousedown", h), document.removeEventListener("touchstart", m), document.removeEventListener("touchend", b);
      };
  }, [c, r, n]), oe(function() {
    if (c)
      return i && i(c), function() {
        a && a();
      };
  }, [!!c]), oe(function() {
    var p = function() {
      return null;
    }, h = !1, m = function(x) {
      o || (p = lP(LI([x], (u || []).map(em)), document.body, X3)), l(function() {
        return x;
      });
    }, b = function() {
      p(), h || l(null);
    };
    return t({
      onMouseDown: function(x) {
        d.current = x.target;
      },
      onTouchStart: function(x) {
        d.current = x.target;
      },
      onActivation: m,
      onDeactivation: b
    }), function() {
      h = !0, t(!1);
    };
  }, []), Y.createElement(pP, null);
}
const mP = I0(Z3, hP);
var gP = function(e) {
  return Y.createElement(mP, Zt({}, e));
}, y6 = Y.forwardRef(function(e, t) {
  return Y.createElement(qI, Zt({}, e, { ref: t, sideCar: gP }));
}), tm, nm, rm, um, im, am, om, sm, cm, lm, dm, fm, pm, hm, mm, gm, bm, vm, ym, xm;
function bP(e, t) {
  if (!Object.keys(e).length)
    return {};
  var n = e.sysSpaceSm, r = e.sysSpaceLg, u = e.sysSpaceMd, i = e.sysSizeIconSm, a = e.sysSizeTapTargetXs, o = e.sysSizeTapTargetSm, s = e.sysSizeCircleLg, c = e.sysBorderRadiusInteractive, l = e.sysColorOverlayMain, d = e.sysColorOverlayContrast, f = e.sysColorOverlayMainHover, p = e.sysColorOverlayMainActive, h = e.sysColorPrimaryMain, m = e.sysColorPrimaryContrast, b = e.sysColorPrimaryMainHover, x = e.sysColorPrimaryMainActive, y = e.sysColorPrimaryContrastActive, g = e.sysColorPrimaryContrastHover, v = e.sysColorTertiaryMain, S = e.sysColorTertiaryContrast, _ = e.sysColorTertiaryMainHover, A = e.sysColorTertiaryMainActive, k = e.sysColorBackgroundMediumContrast, T = e.sysColorBackgroundHighContrast, L = e.sysColorBackgroundSurfaceActive, w = e.sysColorBackgroundSurfaceHover, D = e.sysColorSuccessMain, N = e.sysColorSuccessContrast, O = Zn(e), H = O.screenReader, $ = O.focusStyles, j = O.shimmerStyles, z = zr(e), M = z.caption, P = $.focusOffsetElement, C = j.defaults, R = qe("".concat(o, " - ").concat(a)), V = qe("".concat(i, ` + 2 *
  `).concat(u)), I = B(tm || (tm = F([`
    label: icon-button_base;
    position: relative;
    cursor: pointer;
    border-radius: `, `;
    padding: `, `;
    border: none;
    background-color: transparent;
    text-decoration: none;
    display: inline-flex;
    &:focus {
      `, `;
    }
  `])), c, u, P), G = B(nm || (nm = F([`
    label: icon-button_container;
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: `, ` 0;
    width: `, `;
    word-wrap: break-word;
    `, `
    border: none;
    background-color: transparent;

    &:focus,
    &:hover {
      cursor: pointer;
      -webkit-text-stroke-width: `, `;
    }

    &:focus {
      outline: none;
      & div:first-of-type {
        `, `;
      }
      span:last-of-type {
        text-decoration: underline;
      }
    }

    &:hover {
      span:last-of-type {
        text-decoration: underline;
      }
    }

    &:hover > div:first-of-type {
      background: `, `;
    }
  `])), u, "6rem", M({
    color: Ke(t, T, "contrast")
  }), "0.0421875rem", P, _), K = B(rm || (rm = F([`
    label: processing_container;
    &:hover {
      cursor: default;
    }
  `]))), Q = B(um || (um = F([`
    label: success_container;
    &:hover {
      cursor: default;
    }
    &:hover > div:first-of-type {
      background-color: `, `;
    }
  `])), Ke(t, D, "main")), ae = B(im || (im = F([`
    label: primary;
    color: `, `;
    background: `, `;
    &:hover {
      background: `, `;
    }
    &:active {
      background: `, `;
    }
  `])), Ke(t, m, "contrast"), Ke(t, h, "main"), Ke(t, b, "hover"), Ke(t, x, "active")), X = B(am || (am = F([`
    label: inverse;
    color: `, `;
  `])), Ke(t, m, "contrast")), ne = B(om || (om = F([`
    label: size_sm;
    padding: `, `;
    &:before {
      content: '';
      position: absolute;
      border-radius: `, `;
      top: -`, `;
      right: -`, `;
      bottom: -`, `;
      left: -`, `;
    }
  `])), n, c, qe("".concat(R, " / 2")), qe("".concat(R, " / 2")), qe("".concat(R, " / 2")), qe("".concat(R, " / 2"))), fe = B(sm || (sm = F([`
    label: size_xl;
    `, `
    padding: `, `;
  `])), ne, r), he = B(cm || (cm = F([`
    label: secondary;
    color: `, `;
    background: `, `;
    &:active {
      background: `, `;
    }
    &:hover {
      background: `, `;
    }
  `])), Ke(t, S, "contrast"), Ke(t, v, "main"), Ke(t, A, "active"), Ke(t, _, "hover")), xe = B(lm || (lm = F([`
    label: secondary_inverse;
    background: `, `;
    color: `, `;
    &:hover {
      background: `, `;
    }
    &:active {
      background: `, `;
    }
  `])), Ke(t, m, "contrast"), Ke(t, h, "main"), Ke(t, g, "hover"), Ke(t, y, "active")), re = B(dm || (dm = F([`
    label: tertiary;
    color: `, `;
    &:hover {
      background: `, `;
    }
    &:active {
      background: `, `;
    }
  `])), Ke(t, k, "contrast"), Ke(t, w, "hover"), Ke(t, L, "active")), Se = B(fm || (fm = F([`
    label: tertiary_inverse;
    color: `, `;
    background: `, `;
    &:hover {
      background: `, `;
    }
    &:active {
      background: `, `;
    }
  `])), Ke(t, d, "contrast"), Ke(t, l, "main"), Ke(t, f, "hover"), Ke(t, p, "active")), et = B(pm || (pm = F([`
    label: icon;
    pointer-events: none;
  `]))), Le = B(hm || (hm = F([`
    label: shimmer;
    `, `
  `])), C({
    borderRadius: c,
    width: V,
    height: V
  })), rt = B(mm || (mm = F([`
    label: shimmer_size_sm;
    width: `, `;
    height: `, `;
    &:before {
      display: none; //tap-target is not needed in shimmer state
    }
  `])), a, a), we = B(gm || (gm = F([`
    label: shimmer_size_xl;
    width: `, `;
    height: `, `;
    &:before {
      display: none; //tap-target is not needed in shimmer state
    }
  `])), s, s), Oe = B(bm || (bm = F([`
    label: loading_spinner;
    margin: 0;
  `]))), Ce = B(vm || (vm = F([`
    label: processing_state;
    pointer-events: none;
  `]))), Qe = B(ym || (ym = F([`
    label: success_state;
    pointer-events: none;
    background-color: `, `;
    color: `, `;
    &:hover {
      background: `, `;
      cursor: default;
    }
    &:active {
      background: `, `;
    }
  `])), Ke(t, D, "main"), Ke(t, N, "contrast"), Ke(t, D, "main"), Ke(t, D, "main")), ct = B(xm || (xm = F([`
    label: icon-button_label;
    display: block;
    text-align: center;
    padding: `, " ", " 0 ", `;
    width: inherit;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
  `])), n, n, n);
  return {
    base: I,
    container: G,
    successContainer: Q,
    processingContainer: K,
    primary: ae,
    inverse: X,
    sizeSm: ne,
    sizeXl: fe,
    secondary: he,
    secondaryInverse: xe,
    tertiary: re,
    tertiaryInverse: Se,
    screenReader: H,
    icon: et,
    shimmer: Le,
    shimmerSizeSm: rt,
    shimmerSizeXl: we,
    loadingSpinner: Oe,
    processingState: Ce,
    successState: Qe,
    label: ct
  };
}
var vP = ["as", "iconName", "svgIconComponent", "className", "label", "iconClassName", "children", "buttonType", "btnState", "screenReaderText", "inverse", "size", "isLoading"];
function _m(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(u) {
      return Object.getOwnPropertyDescriptor(e, u).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function Sm(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? _m(Object(n), !0).forEach(function(r) {
      Ve(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : _m(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
var x6 = at(function(e, t) {
  var n = e.as, r = e.iconName, u = e.svgIconComponent, i = e.className, a = e.label, o = e.iconClassName, s = e.children, c = e.buttonType, l = c === void 0 ? "primary" : c, d = e.btnState, f = d === void 0 ? "initial" : d, p = e.screenReaderText, h = e.inverse, m = e.size, b = e.isLoading, x = $t(e, vP), y = ln(), g = Te.useContext(L0), v = $e(function() {
    return bP(y, g);
  }, [y, g]);
  if (b) {
    var S = {
      sm: v.shimmerSizeSm,
      xl: v.shimmerSizeXl
    }, _ = [v.shimmer, S[m]];
    return W(k0, Be({
      css: _,
      className: i,
      isInverse: h,
      hasStyleDefaults: !1
    }, x, {
      "data-ppui": "true"
    }), s);
  }
  var A = m === "xl" ? "md" : "sm", k = {
    sm: v.sizeSm,
    xl: v.sizeXl
  }, T = [v.base, k[m], l === "primary" && v.primary, l === "secondary" && v.secondary, l === "tertiary" && v.tertiary, h && v.inverse, l === "secondary" && h && v.secondaryInverse, l === "tertiary" && h && v.tertiaryInverse, f === "success" && v.successState, f === "processing" && v.processingState], L = [v.base, m === "sm" ? "" : k[m], v.secondary, f === "success" && v.successState, f === "processing" && v.processingState], w = n || "button";
  a && (w = "div");
  var D = w === "button" ? "button" : null, N = u ? W(u, {
    css: v.icon,
    className: o,
    name: r,
    size: A,
    "aria-hidden": "true",
    "data-ppui": "true"
  }) : null, O = a ? {} : Sm({}, x), H = Sm({
    className: i,
    css: a ? L : T,
    ref: t,
    type: D,
    disabled: f && f !== "initial"
  }, O), $ = W(w, Be({
    "data-ppui-info": "icon-button_3.6.9__7.46.0"
  }, H), f !== "initial" ? function() {
    var z = {
      css: v.icon
    }, M = W(ml, Be({
      size: A
    }, z, {
      "data-ppui": "true"
    }));
    if (f === "processing") {
      var P = {
        css: [v.icon, v.loadingSpinner],
        inverse: a ? !1 : l === "primary" || l === "tertiary" && h
      };
      M = W(D0, Be({
        size: A
      }, P, {
        "data-ppui": "true"
      }));
    }
    return W(Te.Fragment, null, M, W("span", {
      css: v.screenReader,
      role: "status",
      "data-ppui": "true"
    }, p || f));
  }() : W(Te.Fragment, null, N, !a && W("span", {
    css: v.screenReader,
    "data-ppui": "true"
  }, s)));
  return a ? W(Te.Fragment, null, function() {
    var z = n ?? "button";
    return W(z, Be({
      css: [v.container, f === "success" && v.successContainer, f === "processing" && v.processingContainer],
      className: i,
      tabIndex: 0
    }, x, {
      "data-ppui": "true"
    }), $, W("span", {
      css: v.label,
      "data-ppui": "true"
    }, a));
  }()) : W(Te.Fragment, null, $);
}), Cm, Em, wm, Tm, Am, km, Lm, Dm, Nm, Om, Im, Mm, Pm, Rm, Bm, Fm, Hm, $m, Vm, jm, zm, Um, qm, Gm, Wm, Km, Ym, Zm, Xm, Qm, Jm, e1, t1, n1, r1, u1, i1, a1, o1, s1, c1, l1, d1, f1, p1, h1;
function _6(e) {
  if (!Object.keys(e).length)
    return {};
  var t = e.sysSpaceLg, n = e.sysTypographyDisplaySize, r = e.sysSizeIconLg, u = e.sysSizeTapTargetDefault, i = e.sysSpaceXl, a = e.sysSpaceSm, o = e.sysSizeMediaMd, s = e.sysSizeMediaSm, c = e.sysColorBackgroundSurface, l = e.sysSizeMediaLg, d = e.sysMotionDurationDepart, f = e.sysSpaceMd, p = e.sysSpaceXs, h = e.sysMotionDurationArrive, m = e.sysSizeIconSm, b = e.sysSizeIconMd, x = e.sysColorOverlayMainHover, y = e.sysSizeIndicatorMd, g = e.sysSizeIconXl, v = e.sysSpaceJumbo, S = e.sysSizeMediaXl, _ = e.sysColorBackgroundMediumContrast, A = e.sysBorderRadiusLg, k = e.sysSizeIndicatorSm, T = Zn(e), L = T.elevationStyles, w = T.variables, D = T.screenReader, N = w.ppuiEaseInOut, O = zr(e), H = O.body, $ = qe("8 * ".concat(t)), j = n, z = r, M = "75%", P = qe("".concat(S, " * 0.75")), C = qe("".concat(i, " * 2")), R = qe("".concat(t, " * 2")), V = qe("".concat(r, " + (2 * ").concat(p, ")")), I = qe("".concat(g, " + (2 * ").concat(p, ")")), G = "100vw", K = m + f * 2, Q = A, ae = function() {
    var Hu = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "center";
    return B(Cm || (Cm = F([`
    label: container_center;
    display: flex;
    align-items: `, `;
    justify-content: space-around;
  `])), Hu);
  }, X = B(Em || (Em = F([`
    label: container_middle;
    `, `;
    width: `, `;
    max-width: `, `;

    @media screen and (max-width: `, `) {
      width: calc(100% - `, `);
    }

    @media screen and (max-width: `, `) {
      width: calc(100% - `, `);
    }
  `])), ae(), M, P, o, C, s, R), ne = B(wm || (wm = F([`
    label: container_bottom;
    `, `;
    width: `, `;

    @media screen and (max-width: `, `) {
      width: `, `;
    }
    @media screen and (max-width: `, `) {
      width: `, `;
    }
  `])), ae("flex-end"), o, l, s, o, G), fe = B(Tm || (Tm = F([`
    label: base;
    background-color: `, `;
    display: grid;
    grid-template-rows: auto 1fr auto;
    position: relative;
    flex-basis: 100%;
  `])), c), he = B(Am || (Am = F([`
    label: modal_no_container;
    width: `, `;
    max-width: `, `;
  `])), M, P), xe = B(km || (km = F([`
    label: modal_dialog;
    min-height: `, `;
    border-radius: `, `;
    max-height: `, `;
    `, `;
    opacity: 0;
    will-change: opacity;
    transition: opacity `, " ", `;
  `])), $, Q, "75dvh", L.level3, d, N), re = B(Lm || (Lm = F([`
    label: modal_top_border;
    border-top-left-radius: `, `;
    border-top-right-radius: `, `;
  `])), Q, Q), Se = B(Dm || (Dm = F([`
    label: modal_sheet;
    height: 100dvh;
    width: auto;
    `, `;
    will-change: transform;
    transition: transform `, " ", `,
      height `, " ", `;
    transform: translateZ(0) translateY(100%);

    @media screen and (max-width: `, `) {
      width: `, `;
      height: auto;
      min-height: `, `;
      max-height: `, `; /* Fallback for browsers that do not support Custom Properties */
      `, `
    }
  `])), L.level3, d, N, d, N, o, G, u, "90dvh", re), et = B(Nm || (Nm = F([`
    label: modal_sheet_show;
    transform: translateZ(0) translateY(0);
  `]))), Le = B(Om || (Om = F([`
    label: modal_backdrop;
    position: fixed;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    z-index: `, `;
    visibility: hidden;
    opacity: 0;
    will-change: opacity;
    transition: opacity `, ` ease-in-out,
      visibility `, " ", `;
    background-color: `, `;
    `, `;
    box-shadow: none;

    &[aria-hidden='false'] {
      transition-duration: `, `;
    }

    &[aria-hidden='true'] {
      transition-duration: `, `;
    }
  `])), vh, d, d, d, x, ae("center"), h, h), rt = B(Im || (Im = F([`
    label: modal_backdrop_show;
    visibility: visible;
    opacity: 1;
    transition: opacity `, ` ease-in-out;
  `])), d), we = B(Mm || (Mm = F([`
    label: modal_backdrop_show_dialog;
    opacity: 1;
    transition: opacity `, ` ease-in-out
      `, `;
  `])), d, d), Oe = B(Pm || (Pm = F([`
    label: scrim;
    position: fixed;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    z-index: `, `;
    visibility: hidden;
    transition: visibility `, " ", `;
    `, `;

    &::before {
      content: ' ';
      position: absolute;
      top: 0;
      left: 0;
      bottom: 0;
      right: 0;
      opacity: 0;
      will-change: opacity;
      transition: opacity `, ` ease-in-out;
      background-color: `, `;
    }
  `])), vh, d, d, ae("flex-end"), d, x), Ce = B(Rm || (Rm = F([`
    label: scrim_show;
    visibility: visible;
    transition: none; /* visibility should not be animated when coming in */

    &::before {
      opacity: 1;
      transition-duration: `, `;
    }
  `])), h), Qe = B(Bm || (Bm = F([`
    label: show_gripper;
    &::before {
      content: ' ';
      position: absolute;
      top: `, `;
      left: 0;
      right: 0;
      margin: auto;
      width: `, `;
      height: `, `;
      background-color: `, `;
      border-radius: `, `;
      display: none;
      @media screen and (max-width: `, `) {
        display: block;
      }
    }
  `])), a, u, k, _, Q, o), ct = B(Fm || (Fm = F([`
    label: modal_contents;
    flex: 1 1 auto;
    overflow: auto;

    position: relative;
    border-radius: inherit;
    `, `;

    @media screen and (max-width: `, `) {
      padding: 0 `, " ", `;
    }
  `])), H(), o, i, i), mt = B(Hm || (Hm = F([`
    label: modal_content_with_header;
    @media screen and (max-width: `, `) {
      border-radius: 0;
    }
  `])), o), Ot = B($m || ($m = F([`
    label: modal_content_sheet;
    padding: 0 `, `;

    @media screen and (max-width: `, `) {
      padding: 0 `, `;
    }
    @media screen and (max-width: `, `) {
      padding: 0 `, " ", `;
    }
  `])), "8.5rem", l, "5rem", o, t, t), ve = B(Vm || (Vm = F([`
    label: modal_content_dialog;
    max-height: `, `;
    padding: 0 `, `;
  `])), "70dvh", v), Nt = B(jm || (jm = F([`
    label: modal_content_no_padding;
    padding: 0;
    @media screen and (max-width: `, `) {
      padding: 0;
    }
  `])), l), Vt = B(zm || (zm = F([`
    label: modal_content_dialog_no_padding;
    @media screen and (max-width: `, `) {
      padding: 0 `, " ", `;
    }
  `])), s, t, i), lt = B(Um || (Um = F([`
    label: modal_content_center;
    text-align: center;
  `]))), jt = B(qm || (qm = F([`
    label: modal_header;
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
    position: relative;
    flex: 0 0 auto;
    z-index: 1;
    min-height: `, `;
    padding: `, `;
  `])), j, f), zt = B(Gm || (Gm = F([`
    label: modal_header_sheet;
    min-height: `, `;

    @media screen and (max-width: `, `) {
      min-height: `, `;
      `, `
    }
  `])), I, o, V, re), It = B(Wm || (Wm = F([`
    label: modal_header_sheet_action;
    min-height: `, `;
    padding: `, `;
    margin: 0;

    @media screen and (max-width: `, `) {
      min-height: `, `;
      padding: `, `;
      margin: 0;
    }
  `])), I, f, o, V, a), J = B(Km || (Km = F([`
    label: modal_header_scrolled;
    `, `
  `])), L.level3), te = B(Ym || (Ym = F([`
    label: modal_header_action;
    flex: 0 0 `, `;
    flex-basis: `, `;
  `])), z, K), Me = B(Zm || (Zm = F([`
    label: modal_header_title;
    flex: 1 1 3rem;
    margin: `, `;
    text-align: center;
    `, `;
  `])), a, H()), Ye = B(Xm || (Xm = F([`
    label: modal_header_close;
    flex: 0 0 `, `;
    text-align: right;
    flex-basis: `, `;
  `])), z, K), gt = B(Qm || (Qm = F([`
    label: modal_header_work_area;
    flex: 0 0 100%;
    padding: `, " ", `;
  `])), a, t), dt = B(Jm || (Jm = F([`
    label: modal_header_logo;
    display: flex;
    flex: 1 1 3rem;
    justify-content: center;
    margin-top: `, `;
  `])), a), Tt = B(e1 || (e1 = F([`
    label: modal_header_logo_image;
    width: `, `;
    height: `, `;
  `])), b, b), Mt = B(t1 || (t1 = F([`
    label: modal_content_close;
    position: absolute;
    right: `, `;
    top: `, `;
    z-index: 2;

    [dir='rtl'] & {
      left: `, `;
      right: auto;

      @media screen and (min-width: `, `) {
        left: `, `;
      }
    }

    @media screen and (min-width: `, `) {
      right: `, `;
      top: `, `;
    }
  `])), p, p, p, o, y, o, y, f), xn = B(n1 || (n1 = F([`
    label: modal_footer;
    min-height: `, `;
    padding: `, `;
    position: relative;
    flex: 1 0 auto;
  `])), j, t), Ut = B(r1 || (r1 = F([`
    label: modal_footer_scrolled;
    `, `
    border-bottom-left-radius: inherit;
    border-bottom-right-radius: inherit;
  `])), L.level3Above), qt = B(u1 || (u1 = F([`
    label: modal_footer_align_center;
    text-align: center;
  `]))), Rn = B(i1 || (i1 = F([`
    label: modal_footer_align_right;
    text-align: right;
  `]))), Bn = B(a1 || (a1 = F([`
    label: modal_sheet_height_90;
    @media screen and (max-width: `, `) {
      height: 90dvh;
      `, `
    }
  `])), o, re), pe = B(o1 || (o1 = F([`
    label: modal_sheet_height_100;
    @media screen and (max-width: `, `) {
      height: 100dvh;
      max-height: 100dvh;
      border-top-left-radius: 0;
      border-top-right-radius: 0;
    }
  `])), o), Fe = B(s1 || (s1 = F([`
    label: sheet_right_side;
    @media screen and (min-width: `, `) {
      justify-content: flex-end;
    }
  `])), o), je = B(c1 || (c1 = F([`
    @media screen and (min-width: `, `) {
      width: `, `;
    }
  `])), o, "35.5rem"), Gt = B(l1 || (l1 = F([`
    label: container;
    @media screen and (min-width: `, `) {
      will-change: transform;
      transition: transform `, `;
      bottom: inherit;

      &[aria-hidden='false'] {
        transform: translateZ(0) translateX(0);
      }
    }
  `])), o, d), Tn = B(d1 || (d1 = F([`
    label: container_right;
    `, `
    @media screen and (min-width: `, `) {
      transform: translateZ(0) translateX(100%);
    }
  `])), Gt, o), qr = B(f1 || (f1 = F([`
    label: container_left;
    `, `
    @media screen and (min-width: `, `) {
      transform: translateZ(0) translateX(-100%);
    }
  `])), Gt, o), Gr = B(p1 || (p1 = F([`
    label: drawer_container;
    @media screen and (min-width: `, `) {
      padding-left: `, `;
      padding-right: `, `;
    }
  `])), o, qe("".concat(i, " * 2")), qe("".concat(i, " * 2"))), ot = B(h1 || (h1 = F([`
    label: modal_sheet_height_50;
    @media screen and (max-width: `, `) {
      height: 50dvh; /* Fallback for browsers that do not support Custom Properties */
      `, `
    }
  `])), o, re);
  return {
    base: fe,
    modalContents: ct,
    modalContentsCenter: lt,
    modalContentsNoPadding: Nt,
    modalHeader: jt,
    modalHeaderScrolled: J,
    modalHeaderClose: Ye,
    modalHeaderAction: te,
    modalHeaderTitle: Me,
    modalHeaderLogo: dt,
    modalHeaderLogoImage: Tt,
    modalFooter: xn,
    modalFooterScrolled: Ut,
    modalFooterAlignCenter: qt,
    modalFooterAlignRight: Rn,
    screenReader: D,
    modalTopBorder: re,
    // Dialog specific styles
    modalDialog: xe,
    modalBackdrop: Le,
    modalBackdropShow: rt,
    modalBackdropShowDialog: we,
    modalContentsClose: Mt,
    modalContentsDialog: ve,
    containerMiddle: X,
    modalContentDialogPadding: Vt,
    // Sheet Specific
    modalSheet: Se,
    modalSheetShow: et,
    modalSheetHeight100: pe,
    modalSheetHeight90: Bn,
    modalSheetHeight50: ot,
    modalNoContainer: he,
    modalHeaderSheet: zt,
    modalHeaderSheetAction: It,
    modalHeaderWorkArea: gt,
    modalContentsSheet: Ot,
    modalContentWithHeader: mt,
    scrim: Oe,
    scrimShow: Ce,
    showGripper: Qe,
    containerBottom: ne,
    justifyRight: Fe,
    containerRightWidth: je,
    containerRight: Tn,
    containerLeft: qr,
    drawerContainer: Gr
  };
}
var yP = ["requestClose", "onBeforeClose", "className", "isHidden", "center", "noPadding", "closeButtonLabel", "noCloseButton", "closeButtonProps", "hideTitle", "showLogo", "mobileFixedHeight", "showGripper", "title", "id", "action", "headerContents", "footerContents", "footerAlign", "children", "returnFocusToTrigger", "headerClassName", "containerClassName", "contentContainerRef", "wrapperClassName", "footerClassName", "skipFormFocus", "contentScrollTop", "onContentScroll", "showDrawer"], xP = function() {
  return !0;
}, _P = function(e) {
  var t = e.requestClose, n = e.onBeforeClose, r = n === void 0 ? xP : n, u = e.className, i = e.isHidden, a = e.center, o = e.noPadding, s = e.closeButtonLabel, c = s === void 0 ? "close sheet" : s, l = e.noCloseButton, d = e.closeButtonProps, f = d === void 0 ? {} : d, p = e.hideTitle, h = e.showLogo, m = e.mobileFixedHeight, b = e.showGripper, x = b === void 0 ? !1 : b, y = e.title, g = e.id, v = e.action, S = e.headerContents, _ = e.footerContents, A = e.footerAlign, k = e.children, T = e.returnFocusToTrigger, L = T === void 0 ? !0 : T, w = e.headerClassName, D = e.containerClassName, N = e.contentContainerRef, O = e.wrapperClassName, H = e.footerClassName, $ = e.skipFormFocus, j = e.contentScrollTop, z = j === void 0 ? 0 : j, M = e.onContentScroll, P = e.showDrawer, C = P === void 0 ? !1 : P, R = $t(e, yP), V = me(!1), I = an(V, 2), G = I[0], K = I[1], Q = me(!1), ae = an(Q, 2), X = ae[0], ne = ae[1], fe = me(0.5), he = an(fe, 2), xe = he[0], re = he[1], Se = Z(), et = Z(), Le = Z(), rt = Z(), we = N || rt, Oe = Z(), Ce = bI(), Qe, ct, mt = m === "dynamic" || x, Ot = ln(), ve = $e(function() {
    return _6(Ot);
  }, [Ot]), Nt = Ot.sysSizeMediaMd, Vt = yu(xu(Nt, "16px")), lt = qo() ? window && window.innerWidth < Vt : !1, jt = h && !lt, zt = g ?? Go(), It = !!v || !l || !p || !!S || jt, J = function() {
    if (we && we.current) {
      var _e = we.current, Ie = _e.scrollTop !== 0;
      if (Ie !== G && K(Ie), _) {
        var xt = _e.scrollTop + _e.offsetHeight !== _e.scrollHeight;
        xt !== X && ne(xt);
      }
    }
  }, te = function() {
    var _e = Se.current;
    if (_e) {
      var Ie = window.innerHeight * 0.9;
      m === "100" ? _e.style.height = "".concat(window.innerHeight) : m === "90" ? _e.style.height = "".concat(Ie, "px") : m === "50" ? _e.style.height = "".concat(window.innerHeight * 0.5, "px") : _e.style.maxHeight = "".concat(Ie, "px");
    }
  }, Me = function() {
    var _e = Se.current;
    _e && (_e.style.height = "".concat(window.innerHeight * xe, "px"), _e.style.maxHeight = "fit-content");
  }, Ye = /* @__PURE__ */ function() {
    var _e = kI(/* @__PURE__ */ zh.mark(function Ie() {
      return zh.wrap(function(xt) {
        for (; ; )
          switch (xt.prev = xt.next) {
            case 0:
              re(0.9);
            case 1:
            case "end":
              return xt.stop();
          }
      }, Ie);
    }));
    return function() {
      return _e.apply(this, arguments);
    };
  }(), gt = function() {
    re(0.5);
  }, dt = function() {
    var _e = we && we.current;
    xe === 0.5 && (_e.style.overflow = "hidden"), xe === 0.9 && (_e.style.overflow = "scroll");
  };
  oe(function() {
    if (!i) {
      var _e;
      J(), (_e = window) === null || _e === void 0 || _e.setTimeout(function() {
        var Ie = !1;
        if (Oe && Oe.current) {
          var xt = Oe.current.querySelector("input");
          xt && (xt.focus(), Ie = !0);
        }
        if (!Ie && !$ && we && we.current) {
          var se = we.current.querySelectorAll("a, button, textarea, input, select");
          se.length > 0 && (se[0].focus(), Ie = !0);
        }
        if (!Ie && It)
          if (v && Le && Le.current) {
            var ce = Le.current.querySelectorAll("a, button, select");
            ce.length > 0 && ce[0].focus();
          } else {
            var Ee = et.current;
            Ee && Ee.focus();
          }
      }, 500), gI() && window.innerHeight && (window.addEventListener("resize", te, !1), mt ? (Me(), dt()) : te());
    }
    return function() {
      window.removeEventListener("resize", te, !1);
    };
  }, [i, xe]), oe(function() {
    if (!i && we.current) {
      var _e = we.current;
      _e.scrollTop = z;
    }
  }, [z, i]);
  var Tt = [ve.scrim, !i && ve.scrimShow, C && ve.justifyRight], Mt = [ve.base, ve.modalNoContainer, ve.modalSheet, m === "100" && ve.modalSheetHeight100, m === "90" && ve.modalSheetHeight90, m === "50" && ve.modalSheetHeight50, mt && ve.modalSheetHeight50, !i && ve.modalSheetShow, C && !Ce && ve.containerRight, C && Ce && ve.containerLeft], xn = [ve.modalContents, ve.modalContentsSheet, a && ve.modalContentsCenter, o && ve.modalContentsNoPadding, It && ve.modalContentWithHeader, C && ve.drawerContainer], Ut = i ? "true" : "false", qt = function(_e, Ie) {
    var xt = r(Ie);
    xt && (t(_e, Ie), Qe = null, ct = null);
  }, Rn = l ? null : W(x6, Be({
    svgIconComponent: Fg,
    onClick: function(Ie) {
      qt(Ie, "closeButton");
    },
    ref: et,
    buttonType: "tertiary"
  }, f, {
    "data-ppui": "true"
  }), c), Bn = function(_e, Ie) {
    var xt = _e.changedTouches[0], se = xt.pageX, ce = xt.pageY, Ee = Qe - se, le = ct - ce;
    Math.abs(le) > Math.abs(Ee) && (le < 0 && (!Ie || Ie.scrollTop === 0) && (mt ? (gt(), (le < -150 || xe === 0.5) && qt(_e, "swipeDown")) : qt(_e, "swipeDown")), le > 0 && mt && Ye()), Qe = null, ct = null;
  }, pe = function(_e) {
    _e.preventDefault();
  }, Fe = function(_e) {
    if (!ct && !Qe) {
      var Ie = _e.changedTouches[0];
      ct = Ie.pageY, Qe = Ie.pageX;
    }
  }, je = "header_".concat(zt), Gt = {
    role: "dialog",
    className: O,
    "aria-modal": "true",
    "aria-hidden": Ut
  };
  jt || p ? Gt["aria-label"] = y : Gt["aria-labelledby"] = je;
  var Tn = v ? W("div", {
    css: [ve.modalHeaderClose],
    "data-ppui": "true"
  }) : null, qr = Rn ? W("div", {
    css: [ve.modalHeaderAction],
    "data-ppui": "true"
  }) : null, Gr = Rn ? W("div", {
    css: [ve.modalHeaderClose],
    "data-ppui": "true"
  }, Rn) : Tn, ot = v ? W("div", {
    css: [ve.modalHeaderAction],
    ref: Le,
    "data-ppui": "true"
  }, v) : qr, Hu = [jt ? ve.modalHeaderLogo : ve.modalHeaderTitle], rs = W("div", {
    css: Hu,
    id: je,
    "aria-live": "assertive",
    "data-ppui": "true"
  }, function() {
    return jt ? W("img", {
      src: "https://www.paypalobjects.com/paypal-ui/logos/svg/paypal-mark-color.svg",
      alt: "paypal-logo",
      css: ve.modalHeaderLogoImage,
      "data-ppui": "true"
    }) : p ? null : y;
  }()), us = S ? W("div", {
    css: ve.modalHeaderWorkArea,
    ref: Oe,
    "data-ppui": "true"
  }, S) : null, is = It ? W("header", {
    className: w,
    css: [ve.modalHeader, ve.modalHeaderSheet, G && ve.modalHeaderScrolled, ot && ve.modalHeaderSheetAction, x && ve.showGripper],
    onTouchStart: Fe,
    onTouchMove: pe,
    onTouchEnd: function(Ie) {
      Bn(Ie, null);
    },
    "data-ppui": "true"
  }, ot, rs, Gr, us) : null, as = _ ? W("footer", {
    className: H,
    css: [
      ve.modalFooter,
      /* istanbul ignore next */
      X && ve.modalFooterScrolled,
      A === "center" && ve.modalFooterAlignCenter,
      A === "right" && ve.modalFooterAlignRight
    ],
    "data-ppui": "true"
  }, _) : null;
  return W("div", Be({}, Gt, {
    css: Tt,
    "data-ppui-info": "sheet_3.16.1__7.46.1"
  }), W(y6, {
    enabled: !i,
    onEscapeKey: function(Ie) {
      Ie.preventDefault(), qt(Ie, "ESC");
    },
    onClickOutside: function(Ie) {
      qt(Ie, "backdropClick");
    },
    returnFocus: L,
    css: [ve.containerBottom, C && ve.containerRightWidth],
    "data-ppui": "true"
  }, W("article", Be({
    css: Mt,
    className: D
  }, R, {
    ref: Se,
    "aria-hidden": Ut,
    "data-ppui": "true"
  }), is, W("section", {
    css: xn,
    className: u,
    onScroll: function() {
      if (we && we.current) {
        var Ie = we.current;
        M && M(Ie.scrollTop);
      }
      J();
    },
    ref: we,
    onTouchStart: Fe,
    onTouchMove: pe,
    onTouchEnd: function(Ie) {
      var xt = we && we.current;
      mt && Bn(Ie, xt);
    },
    "data-ppui": "true"
  }, k), as)));
}, SP = ["isOpen", "onOpen", "onClose", "onCloseComplete", "containerRef"], CP = function(e) {
  var t = e.isOpen, n = e.onOpen, r = e.onClose, u = e.onCloseComplete, i = u === void 0 ? r : u, a = e.containerRef, o = $t(e, SP), s = me(!1), c = an(s, 2), l = c[0], d = c[1];
  oe(function() {
    d(!0);
  }, []);
  var f = /* @__PURE__ */ Te.createElement(M3, {
    shouldHide: !t,
    onOpen: n,
    onCloseComplete: i,
    "data-ppui": "true"
  }, function(m) {
    return /* @__PURE__ */ Te.createElement(_P, Be({}, m, o, {
      "data-ppui": "true"
    }));
  }), p = a && a.current;
  return l && gl.createPortal(f, p || document.body);
}, EP = ["isFullView", "showInverseCloseButton", "requestClose", "className", "headerClassName", "footerClassName", "containerClassName", "isHidden", "center", "hideTitle", "closeButtonLabel", "closeButtonProps", "closeOnBackgroundClick", "onBeforeClose", "contentContainerRef", "title", "id", "action", "footerContents", "footerAlign", "children", "skipFormFocus", "showTitleInHeader"], wP = function() {
  return !0;
}, TP = function(e) {
  var t = e.isFullView, n = e.showInverseCloseButton, r = e.requestClose, u = e.className, i = e.headerClassName, a = e.footerClassName, o = e.containerClassName, s = e.isHidden, c = e.center, l = e.hideTitle, d = l === void 0 ? t : l, f = e.closeButtonLabel, p = f === void 0 ? "Close Dialog" : f, h = e.closeButtonProps, m = h === void 0 ? {} : h, b = e.closeOnBackgroundClick, x = e.onBeforeClose, y = x === void 0 ? wP : x, g = e.contentContainerRef, v = e.title, S = e.id, _ = e.action, A = e.footerContents, k = e.footerAlign, T = e.children, L = e.skipFormFocus, w = e.showTitleInHeader, D = w === void 0 ? !1 : w, N = $t(e, EP), O = me(!1), H = an(O, 2), $ = H[0], j = H[1], z = me(!1), M = an(z, 2), P = M[0], C = M[1], R = Z(), V = g || R, I = Z(), G = Z(), K = S || Go(), Q = function() {
    if (V && V.current) {
      var Oe = V.current, Ce = Oe.scrollTop !== 0;
      if (Ce !== $ && j(Ce), A) {
        var Qe = Math.ceil(Oe.scrollTop + Oe.getBoundingClientRect().height) < Oe.scrollHeight;
        Qe !== P && C(Qe);
      }
    }
  };
  oe(function() {
    s || (Q(), window && window.setTimeout && window.setTimeout(function() {
      var Oe = !1;
      if (!Oe && !L && V && V.current) {
        var Ce = V.current.querySelectorAll("a, button, textarea, input, select");
        Ce.length > 0 && (Ce[0].focus(), Oe = !0);
      }
      if (!Oe && (_ || !d))
        if (_ && G && G.current) {
          var Qe = G.current.querySelectorAll("a, button, select");
          Qe.length > 0 && Qe[0].focus();
        } else {
          var ct = I.current;
          ct && ct.focus();
        }
    }, 100));
  }, [s]);
  var ae = ln(), X = $e(function() {
    return _6(ae);
  }, [ae]), ne = [X.modalBackdrop, !s && X.modalBackdropShow], fe = [X.modalContents, X.modalContentsDialog, c && X.modalContentsCenter, t && X.modalContentsNoPadding, !t && X.modalContentDialogPadding], he = function(Oe, Ce) {
    var Qe = y(Ce);
    Qe && r(Oe, Ce);
  }, xe = "header_".concat(K), re = null, Se = {
    role: "dialog",
    "aria-modal": "true",
    "aria-hidden": s ? "true" : "false"
  };
  d || D ? (Se["aria-label"] = v, D && !t && (re = W("span", {
    id: xe,
    "aria-live": "assertive",
    "data-ppui": "true"
  }, v))) : (Se["aria-labelledby"] = xe, re = W("h2", {
    id: xe,
    "aria-live": "assertive",
    "data-ppui": "true"
  }, v));
  var et = t ? X.modalContentsClose : X.modalHeaderClose, Le = W("div", {
    css: et,
    "data-ppui": "true"
  }, W(x6, Be({
    buttonType: "tertiary",
    svgIconComponent: Fg,
    inverse: n,
    ref: I,
    onClick: function(Ce) {
      he(Ce, "closeButton");
    }
  }, m, {
    "data-ppui": "true"
  }), p)), rt = A ? W("footer", {
    className: a,
    css: [
      X.modalFooter,
      /* istanbul ignore next */
      P && X.modalFooterScrolled,
      k === "center" && X.modalFooterAlignCenter,
      k === "right" && X.modalFooterAlignRight
    ],
    "data-ppui": "true"
  }, A) : null, we = W("header", {
    className: i,
    css: [
      X.modalHeader,
      /* istanbul ignore next */
      $ && X.modalHeaderScrolled,
      X.modalTopBorder
    ],
    "data-ppui": "true"
  }, W("div", {
    css: X.modalHeaderAction,
    ref: G,
    "data-ppui": "true"
  }, _), W("div", {
    css: X.modalHeaderTitle,
    "data-ppui": "true"
  }, D && re), Le);
  return W("div", Be({}, Se, {
    css: ne,
    "data-ppui-info": "dialog_3.16.1__7.46.1"
  }), W(y6, {
    enabled: !s,
    onEscapeKey: function(Ce) {
      Ce.preventDefault(), he(Ce, "ESC");
    },
    onClickOutside: function(Ce) {
      b && he(Ce, "backdropClick");
    },
    css: X.containerMiddle,
    "data-ppui": "true"
  }, W("article", Be({
    css: [X.base, X.modalDialog, !s && X.modalBackdropShowDialog],
    className: o
  }, N, {
    "data-ppui": "true"
  }), t ? Le : we, W("section", {
    className: u,
    css: fe,
    onScroll: function() {
      return Q();
    },
    ref: V,
    "data-ppui": "true"
  }, !D && re, T), rt)));
}, AP = ["isOpen", "onOpen", "onClose", "onCloseComplete", "containerRef"], HH = function(e) {
  var t = e.isOpen, n = e.onOpen, r = e.onClose, u = e.onCloseComplete, i = u === void 0 ? r : u, a = e.containerRef, o = $t(e, AP), s = me(!1), c = an(s, 2), l = c[0], d = c[1];
  oe(function() {
    d(!0);
  }, []);
  var f = /* @__PURE__ */ Te.createElement(M3, {
    shouldHide: !t,
    onOpen: n,
    onCloseComplete: i,
    "data-ppui": "true"
  }, function(m) {
    return /* @__PURE__ */ Te.createElement(TP, Be({}, m, o, {
      "data-ppui": "true"
    }));
  }), p = a && a.current;
  return l && gl.createPortal(f, p || document.body);
}, m1, g1, b1, v1, y1, x1, _1, S1;
function C1(e) {
  if (!Object.keys(e).length)
    return console.warn("Missing Emotion theme. Use ThemeProvider from @emotion/react to pass a valid theme from pp-react."), {};
  var t = e.sysColorBackgroundSurface, n = e.sysColorBackgroundSurfaceHover, r = e.sysColorBackgroundSurfaceActive, u = e.sysColorBackgroundMediumContrast, i = e.sysBorderRadiusSm, a = e.sysBorderRadiusLg, o = e.sysSpaceXs, s = e.sysSpaceSm, c = e.sysSpaceMd, l = e.sysSpaceLg, d = e.sysBorderThicknessNormal, f = e.sysBorderThicknessFocusOutline, p = e.sysSizeMediaMd, h = Zn(e), m = h.elevationStyles, b = h.focusStyles, x = zr(e), y = x.body, g = x.caption, v = "8rem";
  function S() {
    var N = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, O = N.borderRadius, H = O === void 0 ? a : O, $ = N.backgroundColor, j = $ === void 0 ? t : $, z = N.marginTop, M = z === void 0 ? o : z, P = N.maxHeight, C = P === void 0 ? "30rem" : P, R = N.minWidth, V = R === void 0 ? v : R, I = N.outline, G = I === void 0 ? d : I;
    return B(m1 || (m1 = F([`
      label: menu_container;
      border-radius: `, `;
      min-width: `, `;
      max-height: `, `;
      overflow-y: auto;
      overflow-x: hidden;
      position: absolute;
      margin-top: `, `;
      `, `;
      background-color: `, `;
      outline: `, ` solid transparent; // for HCM View
      z-index: `, `;
    `])), H, V, C, M, m.level3, j, G, aI);
  }
  function _() {
    var N = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, O = N.paddingBottom, H = O === void 0 ? "2.125rem" : O, $ = N.paddingTop, j = $ === void 0 ? s : $, z = N.desktopPaddingBottom, M = z === void 0 ? s : z, P = N.desktopPaddingTop, C = P === void 0 ? s : P;
    return B(g1 || (g1 = F([`
      label: list;
      list-style: none;
      margin: 0;
      padding: `, " 0 ", ` 0;
      background-color: transparent;
      @media (min-width: `, `) {
        padding-bottom: `, `;
        padding-top: `, `;
      }
    `])), j, H, p, M, C);
  }
  function A() {
    var N = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, O = N.paddingTop, H = O === void 0 ? c : O, $ = N.paddingRight, j = $ === void 0 ? l : $, z = N.paddingBottom, M = z === void 0 ? c : z, P = N.paddingLeft, C = P === void 0 ? l : P, R = N.desktopPaddingBottom, V = R === void 0 ? s : R, I = N.desktopPaddingTop, G = I === void 0 ? s : I, K = N.hoverBgColor, Q = K === void 0 ? n : K, ae = N.activeBgColor, X = ae === void 0 ? r : ae;
    return B(b1 || (b1 = F([`
      label: list_item;
      padding: `, " ", " ", " ", `;
      outline: none;
      position: relative;
      display: flex;
      align-items: center;
      cursor: pointer;

      @media (min-width: `, `) {
        padding-bottom: `, `;
        padding-top: `, `;
      }

      &:hover {
        background-color: `, `;
      }

      &:active {
        background-color: `, `;
      }
    `])), H, j, M, C, p, V, G, Q, X);
  }
  function k() {
    var N = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, O = N.marginRightLeft, H = O === void 0 ? c : O;
    return B(v1 || (v1 = F([`
      label: thumbnail;
      display: flex;
      align-items: center;
      margin-right: `, `;
      min-height: auto;
      [dir='rtl'] & {
        margin-right: 0;
        margin-left: `, `;
      }
      pointer-events: none;
    `])), H, H);
  }
  function T() {
    return B(y1 || (y1 = F([`
      label: item_text;
      margin: 0; /* overwrite default margin */
      pointer-events: none;
      `, `;
    `])), y());
  }
  function L() {
    var N = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, O = N.paddingTop, H = O === void 0 ? o : O;
    return B(x1 || (x1 = F([`
      label: secondary_text;
      display: -webkit-box;
      padding-top: `, `;
      pointer-events: none;
      `, `;
    `])), H, g({
      color: u
    }));
  }
  function w() {
    return B(_1 || (_1 = F([`
      label: loading_container;
      display: flex;
      height: 100%;
      align-items: center;
      justify-content: center;
    `])));
  }
  function D() {
    var N = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, O = N.horizontalOffset, H = O === void 0 ? f : O, $ = N.radius, j = $ === void 0 ? i : $;
    return B(S1 || (S1 = F([`
      label: keyboard_active;
      &:focus {
        &:after {
          `, `
          z-index: 1; // to keep focus indicator on top of hover
        }
      }
    `])), b.offsetFocusAfter({
      horizontalOffset: H,
      radius: j,
      verticalOffset: "0rem"
    }));
  }
  return {
    menuContainer: S,
    menuList: _,
    menuListItem: A,
    menuItemThumbnail: k,
    menuItemText: T,
    menuSecondaryText: L,
    menuLoadingContainer: w,
    menuKeyboardActive: D,
    menuListWidthMin: v,
    menuListWidthMax: "67.5rem"
  };
}
var E1, w1, T1, A1, k1, L1;
function S6(e) {
  if (!Object.keys(e).length)
    return console.warn("Missing Emotion theme. Use ThemeProvider from @emotion/react to pass a valid theme from pp-react."), {};
  var t = e.sysSpaceSm, n = e.sysSpaceLg, r = e.sysSizeCircleSm, u = e.sysSizeIconSm, i = e.sysColorBackgroundSurfaceHover, a = C1(e), o = a.menuContainer, s = a.menuList, c = a.menuListItem, l = a.menuItemThumbnail, d = a.menuItemText, f = a.menuSecondaryText, p = a.menuLoadingContainer, h = a.menuKeyboardActive, m = qe("".concat(u, " + ").concat(t)), b = B(E1 || (E1 = F([`
    `, `;
  `])), s({
    paddingTop: 0
  })), x = B(w1 || (w1 = F([`
    `, `;
    margin-right: `, `;

    [dir='rtl'] & {
      margin-right: 0;
      margin-left: `, `;
    }
  `])), d(), m, m), y = B(T1 || (T1 = F([`
    label: selected_icon;
    position: absolute;
    top: 50%;
    right: `, `;
    transform: translateY(-50%);

    [dir='rtl'] & {
      left: `, `;
      right: auto;
    }
  `])), n, n), g = B(A1 || (A1 = F([`
    label: thumbnail_image;
    width: `, `;
  `])), r), v = B(k1 || (k1 = F([`
    label: hilite;
    background-color: `, `;
  `])), i), S = B(L1 || (L1 = F([`
    label: unselectable;
    pointer-events: none;
  `])));
  return {
    menuContainer: o,
    menuList: s,
    menuListItem: c,
    menuItemText: d,
    menuSecondaryText: f,
    menuItemThumbnail: l,
    menuLoadingContainer: p,
    menuKeyboardActive: h,
    selectionMenuList: b,
    selectionMenuItemText: x,
    selectedIcon: y,
    itemThumbnailImage: g,
    itemHilite: v,
    unselectable: S,
    menuListStyles: C1
  };
}
var kP = ["menuName", "primaryText", "primaryTextLineClamp", "secondaryText", "secondaryTextLineClamp", "decoration", "id", "value", "isFocused", "isHilite", "isSelected", "onItemClick", "className", "unselectable", "isLoadingOptions", "isMobile", "keyboardActive"], LP = ["name", "value", "className", "containerClassName", "itemClassName", "mobileHeaderClassName", "sheetClassName", "sheetWrapperClassName", "id", "initialItemFocus", "isOpen", "ignoreKeyboard", "mobileTitle", "mobileHeaderContents", "outsideClickCheck", "onOpen", "onClose", "onSelection", "options", "returnFocusToTrigger", "selectedIndex", "activeItem", "triggerElementId", "triggerElementRef", "rtl", "isLoadingOptions", "searchEnabled", "mobileFixedHeight"], DP = 310, NP = function(e) {
  var t = e.menuName, n = e.primaryText, r = e.primaryTextLineClamp, u = e.secondaryText, i = e.secondaryTextLineClamp, a = e.decoration, o = e.id, s = e.value, c = e.isFocused, l = e.isHilite, d = e.isSelected, f = e.onItemClick, p = e.className, h = e.unselectable;
  e.isLoadingOptions;
  var m = e.isMobile, b = e.keyboardActive, x = $t(e, kP), y = Z(null), g = o || "".concat(t, "_item_").concat(s), v = ln(), S = $e(function() {
    return S6(v);
  }, [v]), _ = [S.menuListItem, b && S.menuKeyboardActive, h && S.unselectable, l && S.itemHilite], A = function(T) {
    var L, w = T == null || (L = T.parentElement) === null || L === void 0 ? void 0 : L.parentElement;
    if (w) {
      var D = w.getBoundingClientRect(), N = T.getBoundingClientRect();
      (N.bottom > D.bottom || N.top < D.top) && T.scrollIntoView({
        block: "nearest",
        behavior: "smooth"
      });
    }
  };
  oe(function() {
    if (y && y.current) {
      var T = y.current;
      c && T.focus(), (c || l) && A(T);
    }
  }, [l, c]), oe(function() {
    setTimeout(function() {
      if (y && y.current && m) {
        var T = y.current;
        c && A(T);
      }
    }, DP);
  }, []);
  var k = a && W("div", {
    css: S.menuItemThumbnail,
    "data-ppui": "true"
  }, a);
  return W("li", Be({
    css: _,
    className: p,
    id: g,
    role: "option",
    "aria-selected": d,
    tabIndex: -1,
    "data-value": s,
    ref: y,
    onClick: f
  }, x, {
    "data-ppui": "true"
  }), k, W("p", {
    css: S.selectionMenuItemText,
    "data-ppui": "true"
  }, W(yI, {
    strong: d,
    as: "span",
    clampAtLine: r,
    "data-ppui": "true"
  }, n), u && W(_I, {
    css: S.menuSecondaryText,
    as: "span",
    clampAtLine: i,
    "data-ppui": "true"
  }, u), d && W(ml, {
    size: "sm",
    css: S.selectedIcon,
    color: "SelectedMain",
    "data-ppui": "true"
  })));
}, OP = function(e, t) {
  return e.findIndex(function(n) {
    return t === n.value || t === n.primaryText;
  });
};
function IP(e) {
  var t = Te.useState(e), n = an(t, 2), r = n[0], u = n[1], i = Te.useRef(r);
  return [i, function(o) {
    i.current = o, u(o);
  }];
}
var $H = function(e) {
  var t, n = e.name, r = n === void 0 ? "smenu" : n, u = e.value, i = e.className, a = e.containerClassName, o = e.itemClassName, s = e.mobileHeaderClassName, c = e.sheetClassName, l = e.sheetWrapperClassName, d = e.id, f = d === void 0 ? Go("selectionMenu_") : d, p = e.initialItemFocus, h = p === void 0 ? !0 : p, m = e.isOpen, b = e.ignoreKeyboard, x = e.mobileTitle, y = e.mobileHeaderContents, g = e.outsideClickCheck, v = e.onOpen, S = e.onClose, _ = e.onSelection, A = e.options, k = e.returnFocusToTrigger, T = k === void 0 ? !0 : k, L = e.selectedIndex, w = L === void 0 ? 0 : L, D = e.activeItem, N = D === void 0 ? -1 : D, O = e.triggerElementId, H = e.triggerElementRef, $ = e.rtl, j = $ === void 0 ? !1 : $, z = e.isLoadingOptions, M = z === void 0 ? !1 : z, P = e.searchEnabled, C = P === void 0 ? !1 : P, R = e.mobileFixedHeight, V = $t(e, LP), I = Z(), G = Z(), K = Z(), Q = Z(""), ae, X = A && A.length, ne = IP(h ? w : -1), fe = an(ne, 2), he = fe[0], xe = fe[1], re = me(!0), Se = an(re, 2), et = Se[0], Le = Se[1], rt = ln(), we = $e(function() {
    return S6(rt);
  }, [rt]), Oe = ((t = we.menuListStyles) === null || t === void 0 ? void 0 : t.call(we, rt)) || {}, Ce = Oe.menuListWidthMin, Qe = Oe.menuListWidthMax, ct = rt.sysSizeMediaMd, mt = yu(xu(Ce, "16px")), Ot = yu(xu(Qe, "16px")), ve = "".concat(yu(xu(ct, "16px"))), Nt = qo() ? window.innerWidth < parseInt(ve, 10) : !1, Vt = function(pe) {
    return (
      /* istanbul ignore next */
      pe && pe.current ? pe.current : null
    );
  }, lt = function() {
    var Fe = Vt(H);
    return Fe || (O && mI() ? document.getElementById(O) : null);
  }(), jt = function() {
    var pe = lt == null ? void 0 : lt.getBoundingClientRect().width;
    if (M) {
      var Fe = Vt(K);
      Fe.style.width = pe ? "".concat(pe, "px") : "".concat(Ot, "px");
    } else {
      var je = Vt(G), Gt = je && je.getBoundingClientRect().width;
      pe > mt && pe > Gt && (je.style.width = "".concat(pe, "px"));
    }
  }, zt = function(pe) {
    xe(pe);
  }, It = function(pe) {
    var Fe = Math.min(Math.max(he.current + pe, 0), A.length - 1);
    zt(Fe);
  }, J = function(pe) {
    var Fe = Vt(I), je = lt == null ? void 0 : lt.contains(pe.target);
    (!g || g(pe)) && !je && Fe && !Fe.contains(pe.target) && S(pe, "backdropClick");
  }, te = function(pe) {
    var Fe = pe.target, je = OP(A, Fe.dataset.value);
    zt(je), _(je);
  }, Me = function() {
    var pe = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], Fe = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
    return pe.findIndex(function(je) {
      return je.primaryText.toLowerCase().startsWith(Fe.toLowerCase());
    });
  }, Ye = function(pe) {
    pe.preventDefault();
    var Fe = he.current, je = new Ge(pe.key || pe.keyCode);
    if (je.IS_ARROW_UP)
      Le(!0), It(-1);
    else if (je.IS_ARROW_DOWN)
      Le(!0), It(1);
    else if (je.IS_ENTER)
      _(Fe);
    else if (je.IS_TAB || je.IS_ESC) {
      var Gt = je.IS_TAB ? Ge.NAME_TAB : Ge.NAME_ESC;
      typeof S == "function" && !Nt && S(pe, Gt), lt == null || lt.focus();
    } else if (C && pe.key.length === 1) {
      clearTimeout(ae), Q.current = Q.current + pe.key, ae = setTimeout(function() {
        Q.current = "";
      }, 700);
      var Tn = Me(A, Q.current);
      Tn >= 0 && (Le(!0), zt(Tn));
    }
  }, gt = function(pe) {
    Ye(pe);
  }, dt = function(Fe, je) {
    return Fe !== void 0 ? Fe : w !== void 0 && w >= 0 && A && A[w] && A[w].value !== void 0 ? A[w].value : je;
  }(u), Tt = function(pe) {
    return pe && typeof pe == "string" ? W("img", {
      css: we.itemThumbnailImage,
      src: pe,
      role: "none",
      "data-ppui": "true"
    }) : pe;
  }, Mt = b ? -1 : he.current, xn = m && X && A.map(function(pe, Fe) {
    var je = pe.hasOwnProperty("value") ? pe.value : pe.primaryText, Gt = !pe.unselectable && (dt === void 0 ? w === Fe : je === dt), Tn = Tt(pe.decoration || pe.imgSrc);
    return W(NP, Be({
      menuName: r
    }, pe, {
      value: je,
      isSelected: Gt,
      isFocused: Mt === Fe,
      isHilite: N === Fe,
      className: o,
      decoration: Tn,
      key: "smenu_".concat(Fe),
      isMobile: Nt,
      keyboardActive: et,
      onItemClick: te,
      "data-ppui": "true"
    }));
  });
  Gn(function() {
    return m && (document.addEventListener("click", J), b || document.body.addEventListener("keydown", gt), Nt ? Le(!1) : (jt(), Le(h), Mt < 0 && zt(0)), typeof v == "function" && v(Nt)), function() {
      document.removeEventListener("click", J), b || document.body.removeEventListener("keydown", gt), Le(!1);
    };
  }, [m, M]);
  var Ut = j ? "rtl" : null, qt = W("ul", Be({
    css: we.selectionMenuList,
    className: i,
    id: f,
    tabIndex: 0,
    role: "listbox",
    "aria-hidden": !m,
    ref: G,
    dir: Ut
  }, V, {
    "data-ppui": "true"
  }), xn), Rn = W("div", {
    ref: K,
    css: we.menuLoadingContainer,
    "data-ppui": "true"
  }, W(D0, {
    screenReaderText: "loading",
    size: "md",
    "data-ppui": "true"
  })), Bn = M ? Rn : qt;
  return function() {
    if (Nt) {
      var Fe = y ? "90" : void 0;
      return W(CP, {
        isOpen: m,
        onCloseComplete: S,
        title: x,
        headerClassName: s,
        headerContents: y,
        noPadding: !0,
        noCloseButton: !1,
        mobileFixedHeight: R || Fe,
        className: c,
        wrapperClassName: l,
        returnFocusToTrigger: T,
        "data-ppui": "true"
      }, Bn);
    }
    return m && W("div", {
      ref: I,
      css: we.menuContainer,
      className: a,
      "data-ppui-info": "selection-menu_3.8.2"
    }, Bn);
  }();
}, D1, N1, O1, I1, M1, P1, R1, B1, F1, H1, $1, V1, j1, z1, U1, q1, G1, W1, K1, Y1, Z1;
function MP(e) {
  if (!Object.keys(e).length)
    return console.warn("Missing Emotion theme. Use ThemeProvider from @emotion/react to pass a valid theme from pp-react."), {};
  var t = e.sysSpaceSm, n = e.sysSpaceMd, r = e.sysSpaceLg, u = e.sysSpaceJumbo, i = e.sysBorderThicknessEmphasis, a = e.sysBorderThicknessNormal, o = e.sysSizeIndicatorMd, s = e.sysMotionDurationAction, c = e.sysColorPrimaryMain, l = e.sysColorPrimaryContrast, d = e.sysColorPrimaryMainHover, f = e.sysColorPrimaryMainActive, p = e.sysColorPrimaryContrastHover, h = e.sysColorPrimaryContrastActive, m = e.sysColorOverlayContrast, b = e.sysColorOverlayMainHover, x = e.sysColorOverlayMainActive, y = e.sysColorFeaturedMain, g = e.sysColorFeaturedMainHover, v = e.sysColorFeaturedMainActive, S = e.sysColorFeaturedContrast, _ = e.sysColorSecondaryMain, A = e.sysColorSuccessMain, k = e.sysMotionDurationHover, T = e.sysSizeMediaMd, L = e.sysSizeMediaSm, w = "-".concat(i), D = Zn(e), N = D.screenReader, O = D.focusStyles, H = zr(e), $ = H.buttonLg, j = H.buttonSm, z = O.offsetFocusAfter, M = B(D1 || (D1 = F([`
    label: button_base;
    position: relative;
    border-radius: 1000px;
    color: `, `;
    cursor: pointer;
    display: inline-block;
    min-width: `, `;
    text-align: center;
    text-decoration: none;
    transition: color `, ` ease,
      background-color `, ` ease,
      border-color `, ` ease,
      box-shadow `, ` ease;
    border: `, " solid ", `;
    `, `;
    background-color: `, `;
    padding: `, `
      `, `;

    &:hover,
    &:active,
    &:visited {
      color: `, `;
    }

    &:hover {
      text-decoration: none;
      background-color: `, `;
      border-color: `, `;
    }

    &:active {
      outline: none;
      background-color: `, `;
      border-color: `, `;
    }

    &:focus {
      outline: none;
      &:after {
        `, `
      }
    }

    [dir='rtl'] &:focus:after {
      left: 0;
      right: `, `;
    }
  `])), l, "6rem", s, s, s, s, i, c, $({
    color: l
  }), c, qe("".concat(n, " - ").concat(i)), qe("".concat(u, " - ").concat(i)), l, d, d, f, f, z({
    horizontalOffset: w,
    verticalOffset: w
  }), w), P = B(N1 || (N1 = F([`
    label: inverse;
    background-color: `, `;
    border-color: `, `;
    color: `, `;

    &:hover,
    &:active,
    &:visited {
      color: `, `;
    }

    &:hover {
      background: `, `;
      border-color: `, `;
    }

    &:active {
      background: `, `;
      border-color: `, `;
    }

    [dir='rtl'] &:focus:after {
      left: 0;
      right: `, `;
    }
  `])), l, l, c, c, p, p, h, h, w), C = B(O1 || (O1 = F([`
    label: secondary;
    background: transparent;
    border-color: `, `;
    color: `, `;
    box-shadow: 0 0 0 `, ` transparent inset;

    &:visited {
      color: `, `;
    }

    &:hover {
      background: transparent;
      color: `, `;
      border-color: `, `;
      box-shadow: none;
    }

    &:active {
      background: transparent;
      color: `, `;
      border-color: `, `;
      box-shadow: none;
    }
  `])), c, c, a, c, d, d, f, f), R = B(I1 || (I1 = F([`
    label: secondary_inverse;
    border-color: `, `;
    color: `, `;
    background-color: transparent;

    &:visited {
      color: `, `;
    }

    &:hover {
      background: `, `;
      color: `, `;
      border-color: `, `;
      box-shadow: none;
    }

    &:active {
      background: `, `;
      color: `, `;
      border-color: `, `;
      box-shadow: none;
    }
  `])), m, m, m, b, m, m, x, m, m), V = B(M1 || (M1 = F([`
    label: branded;
    background: `, `;
    border-color: `, `;
    color: `, `;

    &:hover,
    &:active,
    &:visited {
      color: `, `;
    }

    &:hover {
      background: `, `;
      border-color: `, `;
    }

    &:active {
      background: `, `;
      border-color: `, `;
    }
  `])), y, y, S, S, g, g, v, v), I = B(P1 || (P1 = F([`
    label: tertiary;
    position: relative;
    cursor: pointer;
    display: inline-block;
    background: transparent;
    border: none;
    `, `
    padding: `, " ", `;

    &:hover,
    &:active {
      color: `, `;
      background: transparent;
    }

    &:hover,
    &:focus {
      text-decoration: underline;
    }

    &:active {
      text-decoration: none;
    }

    &:focus {
      outline: none;
      color: `, `;
      &:after {
        `, `
      }
    }
  `])), $({
    color: _
  }), n, t, _, _, z({
    radius: "0.25rem",
    horizontalOffset: "0rem",
    verticalOffset: "0rem"
  })), G = B(R1 || (R1 = F([`
    label: icon;
    vertical-align: top;
    margin-inline-end: `, `;
    margin-inline-start: 0;
  `])), t), K = B(B1 || (B1 = F([`
    label: affordance;
    margin-inline-start: `, `;
    margin-inline-end: 0;
    vertical-align: top;
    position: relative;
    pointer-events: none;
  `])), t), Q = B(F1 || (F1 = F([`
    label: menu-wrap;
    position: relative;
  `]))), ae = B(H1 || (H1 = F([`
    label: size_sm;
    `, `
    min-width: `, `;
    padding: `, `
      `, `;
  `])), j({
    color: l
  }), "3.75rem", qe("".concat(o, " - ").concat(i)), qe("".concat(r, " - ").concat(i))), X = B($1 || ($1 = F([`
    label: success_state;
    border-color: `, `;
    background-color: `, `;
    pointer-events: none;
  `])), A, A), ne = B(V1 || (V1 = F([`
    label: processing_state;
    color: transparent;
    pointer-events: none;

    &:hover,
    &:active,
    &:visited {
      color: transparent;
    }
  `]))), fe = po(j1 || (j1 = F([`
    0% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  `]))), he = B(z1 || (z1 = F([`
    label: overlay;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    border-radius: inherit;
    text-align: center;
    opacity: 0;
    animation: `, " ", ` ease-in forwards;
    display: flex;
    justify-content: center;
    align-items: center;
    padding-right: 0;
  `])), fe, k), xe = B(U1 || (U1 = F([`
    label: success_state_overlay;
    background-color: `, `;
  `])), A), re = B(q1 || (q1 = F([`
    label: success_state_icon;
    line-height: `, `;
    color: `, `;
  `])), 2, l), Se = B(G1 || (G1 = F([`
    label: success_state_icon_sm;
    line-height: `, `;
  `])), 1.6), et = B(W1 || (W1 = F([`
    label: button_group;
    display: inline-grid;
    grid-template-columns: 1fr 1fr;
    gap: `, `;
    padding: `, " ", `;
  `])), r, n, r), Le = B(K1 || (K1 = F([`
    label: solo;
    grid-template-columns: 1fr;
  `]))), rt = B(Y1 || (Y1 = F([`
    label: btn_full_width;
    @media (max-width: `, `) {
      width: 100%;
    }
  `])), T), we = B(Z1 || (Z1 = F([`
    label: btn_group_full_width;
    @media (max-width: `, `) {
      grid-template-columns: none;
      width: 100%;
    }
  `])), L);
  return {
    base: M,
    secondary: C,
    inverse: P,
    secondaryInverse: R,
    branded: V,
    tertiary: I,
    icon: G,
    affordance: K,
    menuWrapper: Q,
    sizeSm: ae,
    successState: X,
    processingState: ne,
    screenReader: N,
    overlay: he,
    successStateOverlay: xe,
    successStateIcon: re,
    successStateIconSm: Se,
    buttonGroup: et,
    buttonGroupSolo: Le,
    btnFullWidth: rt,
    btnGroupFullWidth: we
  };
}
var PP = ["isMenu", "isOpen", "isSmall"], RP = ["size", "inverse", "secondary", "branded", "tertiary", "isMenu", "isOpen", "btnState", "screenReaderText", "className", "children", "as", "iconComponent", "fullWidthOnMobile"];
function X1(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(u) {
      return Object.getOwnPropertyDescriptor(e, u).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function BP(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? X1(Object(n), !0).forEach(function(r) {
      Ve(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : X1(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
var FP = function(e) {
  var t = e.isMenu, n = e.isOpen, r = e.isSmall, u = $t(e, PP);
  if (!t)
    return null;
  var i = n ? V4 : j4;
  return W(i, Be({}, u, {
    size: r ? "xs" : "sm",
    "data-ppui": "true"
  }));
}, HP = at(function(e, t) {
  var n = e.size, r = e.inverse, u = e.secondary, i = e.branded, a = e.tertiary, o = e.isMenu, s = e.isOpen, c = e.btnState, l = c === void 0 ? "initial" : c, d = e.screenReaderText, f = e.className, p = e.children, h = e.as, m = e.iconComponent, b = e.fullWidthOnMobile, x = b === void 0 ? !0 : b, y = $t(e, RP), g = ln(), v = $e(function() {
    return MP(g);
  }, [g]), S = {};
  l === "processing" && (S.as = "span", n === "sm" && (S.size = "xs"), (u && r || !u && !r) && (S.inverse = !0));
  var _;
  i ? _ = [v.base, v.branded] : a ? _ = [v.tertiary] : _ = [v.base, x && v.btnFullWidth, n === "sm" && v.sizeSm, r && v.inverse, u && v.secondary, u && r && v.secondaryInverse, l === "success" && v.successState, l === "processing" && v.processingState];
  var A = BP({}, y);
  return s !== void 0 && (A["aria-expanded"] = s), W(h || "button", Be({
    css: _,
    className: f,
    disabled: l && l !== "initial",
    ref: t,
    "data-ppui-info": "buttons_7.4.0"
  }, A), function() {
    var T;
    l !== "initial" && (T = d || l);
    var L = n === "sm" ? "sm" : "md", w = [v.successStateIcon, n === "sm" && v.successStateIconSm], D = W(ml, {
      css: w,
      size: L,
      "data-ppui": "true"
    }), N = null;
    if (m) {
      var O = n === "sm" ? "xs" : "sm";
      N = W(m, {
        css: v.icon,
        size: O,
        "data-ppui": "true"
      });
    }
    var H = [v.overlay, l === "success" && v.successStateOverlay], $ = l !== "initial" ? W("span", {
      css: H,
      "data-ppui": "true"
    }, l === "success" && D, l === "processing" && W(D0, Be({}, S, {
      "data-ppui": "true"
    }))) : null, j = T ? W("span", {
      role: "status",
      css: v.screenReader,
      "data-ppui": "true"
    }, p, " ", T) : null;
    return W(Te.Fragment, null, N, p, W(FP, {
      isMenu: o,
      isOpen: s,
      isSmall: n === "sm",
      css: v.affordance,
      "data-ppui": "true"
    }), $, j);
  }());
});
const C6 = (e, t = "", n = "", r = "", u = "") => !n || !e || ![Uc.mobile, Uc.portable].includes(
  e
) ? Da(t, r, u) : Da(n, r, u), $P = {
  download: z4,
  play: U4,
  refresh: q4
}, VP = (e) => e && $P[e] || null;
const E6 = "Button", Q1 = new ye(E6), Ko = ({
  ariaLabel: e,
  className: t,
  children: n,
  target: r,
  text: u,
  type: i = jr.Primary,
  analyticsCompName: a = "",
  segment: o,
  clickEventName: s,
  url: c,
  mobileUrl: l = "",
  size: d = "Large",
  onClick: f,
  onFocus: p,
  as: h = "a",
  mid: m,
  mabReward: b,
  icon: x,
  enableDocumentIdInstrumentation: y = !1,
  documentId: g,
  tabIndex: v,
  serverFptiData: S
}) => {
  const _ = U(
    t,
    Q1.getPropsValueClassName("type", i),
    Q1.getPropsValueClassName("size", d)
  ), {
    environment: { host: A = "", pageSegment: k = "" } = {},
    requestor: {
      clientInfo: { clientType: T = void 0 } = {},
      locality: { country: L = "" } = {}
    } = {}
  } = nt(), w = o ?? k, D = C6(T, c, l, A, L), N = Ht(
    {
      componentName: a,
      linkText: u,
      linkType: i,
      clickEvent: s,
      ariaLabel: e,
      mid: m,
      mabReward: b,
      documentId: y ? g : void 0,
      serverFptiData: S
    },
    w,
    yt.CTA
  ), O = {
    Small: "sm",
    Large: "lg",
    Dynamic: "lg"
  }, H = D ? { href: D } : {}, $ = VP(x);
  return /* @__PURE__ */ E(
    HP,
    {
      as: h,
      "aria-label": e,
      className: _,
      target: r,
      secondary: i === "Secondary",
      branded: i === "Branded",
      tertiary: i === "Tertiary",
      "data-pa-click": a && N,
      size: O[d],
      onClick: f,
      onFocus: p,
      fullWidthOnMobile: !1,
      ...H,
      iconComponent: $,
      tabIndex: v,
      children: u || n
    }
  );
};
Ko.displayName = E6;
const jP = {
  Play: "play",
  Replay: "refresh"
}, zP = "PrimaryPlayButton", w6 = ({
  className: e,
  text: t = "",
  analyticsCompName: n,
  ariaLabel: r = "",
  clickEventName: u,
  mid: i,
  iconType: a = "Play",
  onClick: o,
  tabIndex: s
}) => /* @__PURE__ */ E(
  Ko,
  {
    as: "button",
    onClick: o,
    className: e,
    "aria-label": r,
    icon: jP[a],
    text: t,
    type: jr.Primary,
    size: "Dynamic",
    buttonStyle: "ppreact",
    clickEventName: u,
    mid: i,
    analyticsCompName: n,
    tabIndex: s
  }
);
w6.displayName = zP;
const z0 = "InlinePlayButton", T6 = ({
  className: e,
  text: t = "",
  youTubeId: n,
  analyticsCompName: r = z0,
  ariaLabel: u = "",
  clickEventName: i,
  mid: a,
  modalWrapper: o,
  iconType: s = "Play",
  onClick: c,
  type: l = "InlinePlay",
  buttonStyle: d,
  tabIndex: f,
  serverFptiData: p
}) => {
  const { isShowing: h, toggle: m } = E3();
  if (!n)
    return null;
  const b = () => s === "Play" && /* @__PURE__ */ E(o, { isShowing: h, hide: m, children: /* @__PURE__ */ E(T0, { roundedStyle: !0, videoId: n }) });
  return l === "InlinePlay" ? /* @__PURE__ */ ue(on, { children: [
    /* @__PURE__ */ E(
      T3,
      {
        className: e,
        text: t,
        analyticsCompName: r,
        ariaLabel: u,
        clickEventName: i,
        mid: a,
        iconType: s,
        onClick: c || m,
        buttonStyle: d,
        tabIndex: f,
        serverFptiData: p
      }
    ),
    b()
  ] }) : l === "PrimaryPlay" ? /* @__PURE__ */ ue(on, { children: [
    /* @__PURE__ */ E(
      w6,
      {
        onClick: c || m,
        className: e,
        ariaLabel: u,
        iconType: s,
        text: t,
        clickEventName: i,
        mid: a,
        analyticsCompName: r,
        tabIndex: f
      }
    ),
    b()
  ] }) : null;
};
T6.displayName = z0;
const U0 = (e = {}) => /* @__PURE__ */ E(T6, { ...e, modalWrapper: w0 });
U0.displayName = z0;
var J1, eg, tg;
function UP(e) {
  if (!Object.keys(e).length)
    return console.warn("Missing Emotion theme. Use ThemeProvider from @emotion/react to pass a valid theme from pp-react."), {};
  var t = Zn(e), n = t.screenReader, r = "2.5rem", u = B(J1 || (J1 = F([`
    label: appbadge_base;
    line-height: 0;
  `]))), i = B(eg || (eg = F([`
    label: ios;
    height: `, `;
    width: `, `;
    vertical-align: bottom;
  `])), r, "7.5rem"), a = B(tg || (tg = F([`
    label: android;
    height: `, `;
    width: `, `;
    vertical-align: bottom;
  `])), r, "8.4375rem");
  return {
    base: u,
    ios: i,
    android: a,
    screenReader: n
  };
}
var qP = ["url", "platform", "locale", "className", "imageClassName", "cdnHost", "children"], GP = "en-US", WP = function(e, t) {
  var n = e.toString().replace("-", "_");
  return {
    locale: n,
    ios: "https://".concat(t, "/appbadges/badges/").concat(n, "/ios.svg"),
    ios_white: "https://".concat(t, "/appbadges/badges/").concat(n, "/ios_white.svg"),
    android: "https://".concat(t, "/appbadges/badges/").concat(n, "/android-no-padding.svg")
  };
}, KP = function(e) {
  var t = e.url, n = e.platform, r = e.locale, u = r === void 0 ? GP : r, i = e.className, a = e.imageClassName, o = e.cdnHost, s = o === void 0 ? "www.paypalobjects.com" : o, c = e.children, l = $t(e, qP);
  t || console.warn("Required prop `url` is missing.");
  var d = ln(), f = $e(function() {
    return UP(d);
  }, [d]), p = n === "android" ? f.android : f.ios, h = $e(function() {
    return WP(u, s);
  }, [u]), m = h[n];
  return W("a", Be({
    href: t,
    css: f.base,
    className: i,
    "data-ppui-info": "appbadge_2.2.3"
  }, l), W("span", {
    css: f.screenReader,
    "data-ppui": "true"
  }, c), W("img", {
    alt: n,
    css: p,
    className: a,
    src: m,
    "aria-hidden": "true",
    "data-ppui": "true"
  }));
}, ri = /* @__PURE__ */ ((e) => (e.ios = "ios", e.android = "android", e))(ri || {});
const YP = "AppstoreButton", ZP = new ye(YP), XP = ({
  url: e = "",
  ariaLabel: t = "",
  className: n = "",
  target: r = "_self",
  analyticsCompName: u = "",
  platform: i,
  serverFptiData: a,
  ...o
}) => {
  const {
    environment: { pageSegment: s = "" } = {},
    requestor: { clientInfo: { clientLocale: c = "en_US" } = {} } = {}
  } = nt(), { buttonStyle: l, ...d } = o, f = c, p = U(ZP.getComponentClassName(), n), h = (m, b, x, y) => {
    const g = Ht(
      {
        componentName: u,
        linkText: m,
        linkType: jr.AppDownload,
        clickEvent: Wi.GetTheApp,
        serverFptiData: y
      },
      s,
      yt.CTA
    );
    return /* @__PURE__ */ E(
      KP,
      {
        platform: x,
        url: b,
        locale: f,
        className: p,
        target: r,
        "aria-label": m,
        "data-pa-click": u && g,
        ...d,
        children: m
      }
    );
  };
  return i === ri.android ? h(
    t,
    e,
    ri.android,
    a
  ) : i === ri.ios ? h(t, e, ri.ios, a) : null;
};
const QP = "ArrowIcon", nu = new ye(QP), JP = ({ size: e = "Large", className: t = "" }) => {
  const n = U(
    nu.getComponentClassName(),
    nu.getElementClassName("theme"),
    nu.getPropsValueClassName("size", e),
    t
  ), r = U(nu.getElementClassName("stroke"));
  return /* @__PURE__ */ ue("span", { className: n, children: [
    " ",
    /* @__PURE__ */ ue(
      "svg",
      {
        className: nu.getElementClassName("arrow"),
        width: "28",
        height: "17",
        viewBox: "0 0 28 17",
        fill: "none",
        preserveAspectRatio: "xMinYMin meet",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true",
        children: [
          /* @__PURE__ */ E(
            "path",
            {
              className: r,
              d: "M26 8.01221H1",
              strokeWidth: "2",
              strokeLinecap: "round",
              strokeLinejoin: "round"
            }
          ),
          /* @__PURE__ */ E(
            "path",
            {
              className: r,
              d: "M19.5 1.01221L26.5 8.01221L19.5 15.0122",
              strokeWidth: "2",
              strokeLinecap: "round",
              strokeLinejoin: "round"
            }
          )
        ]
      }
    ),
    /* @__PURE__ */ E("span", { className: nu.getElementClassName("circle") })
  ] });
};
const A6 = "InlineButton", ac = new ye(A6), k6 = (e, t, n) => {
  if (!t)
    return e;
  const u = e.trim().split(" "), i = u[u.length - 1];
  return /* @__PURE__ */ ue(on, { children: [
    `${u.slice(0, -1).join(" ")} `,
    /* @__PURE__ */ ue("span", { className: "text-with-arrow", children: [
      i,
      " ",
      /* @__PURE__ */ E(JP, { size: n })
    ] })
  ] });
}, eR = ({
  className: e,
  size: t = "Large",
  text: n = "",
  ariaLabel: r = "",
  url: u = "",
  mobileUrl: i = "",
  target: a = "_self",
  analyticsCompName: o = "",
  clickEventName: s = Wi.Button,
  mid: c,
  showArrowIcon: l = !0,
  mabReward: d,
  tabIndex: f,
  serverFptiData: p
}) => {
  const {
    environment: { host: h = "", pageSegment: m = "" } = {},
    requestor: {
      clientInfo: { clientType: b = void 0 } = {},
      locality: { country: x = "" } = {}
    } = {}
  } = nt(), g = {
    href: C6(b, u, i, h, x),
    target: a,
    tabIndex: f
  };
  if (r && (g["aria-label"] = r), o) {
    const v = Ht(
      {
        componentName: o,
        linkText: n,
        clickEvent: s,
        ariaLabel: r,
        mid: c,
        mabReward: d,
        serverFptiData: p
      },
      m,
      yt.CTA
    );
    g["data-pa-click"] = v;
  }
  return /* @__PURE__ */ E("a", { className: e, ...g, children: k6(n, l, t) });
}, q0 = (e) => {
  const {
    className: t,
    size: n = "Large",
    text: r = "",
    type: u = "link",
    showArrowIcon: i = !0
  } = e, a = U(
    ac.getElementClassName("theme"),
    ac.getComponentClassName(),
    ac.getPropsValueClassName("size", n),
    t,
    "arrow-icon-active-hover",
    i ? "" : "inline-button-without-arrow"
  );
  if (u === "span")
    return /* @__PURE__ */ E("span", { className: a, children: k6(r, i, n) });
  const o = {
    ...e,
    /* We want to overwrite the "className" prop as we already used it */
    className: a
  };
  return /* @__PURE__ */ E(eR, { ...o });
};
q0.displayName = A6;
const G0 = "Button-Group", ui = new ye(G0), tR = ({
  disclosureType: e,
  analyticsCompName: t,
  disclosureWrapper: n
}) => e ? /* @__PURE__ */ E(
  n,
  {
    ...e,
    className: ui.getElementClassName("legalText"),
    paragraphSize: "Caption",
    analyticsCompName: t,
    analyticsTextSection: "legalText"
  }
) : null, L6 = ({
  button: e = [],
  className: t = "",
  alignment: n = "Start",
  legalPosition: r = "Bottom",
  disclosureType: u,
  analyticsCompName: i = "",
  disclosureWrapper: a,
  inlinePlayButtonWrapper: o,
  enableDocumentIdInstrumentation: s,
  isFocusable: c = !0,
  ...l
}) => {
  const d = U(
    ui.getComponentClassName(),
    ui.getPropsValueClassName("align", n),
    ui.getPropsValueClassName("legalPosition", r),
    t
  ), f = ui.getPropsValueClassName(
    "alignment",
    n
  ), p = tR({
    disclosureType: u,
    analyticsCompName: i,
    disclosureWrapper: a
  }), h = c ? {} : { tabIndex: -1 };
  return /* @__PURE__ */ ue("div", { className: d, children: [
    r === "Top" && p,
    /* @__PURE__ */ E("div", { className: f, children: e.map((m, b) => {
      switch (m.buttonStyle) {
        case "inline":
          return /* @__PURE__ */ E(
            q0,
            {
              analyticsCompName: i,
              ...h,
              ...m,
              ...l
            },
            `item-${b + 1}`
          );
        case "ppreact":
          return /* @__PURE__ */ E(
            Ko,
            {
              analyticsCompName: i,
              enableDocumentIdInstrumentation: s,
              ...h,
              ...m,
              ...l
            },
            `item-${b + 1}`
          );
        case "inlinePlay":
          return /* @__PURE__ */ E(
            o,
            {
              analyticsCompName: i,
              ...h,
              ...m,
              ...l
            },
            `item-${b + 1}`
          );
        case "appstore":
          return /* @__PURE__ */ E(
            XP,
            {
              analyticsCompName: i,
              ...l,
              ariaLabel: m.ariaLabel,
              url: m.url,
              target: m.target,
              platform: m.platform
            },
            `item-${b + 1}`
          );
        default:
          return null;
      }
    }) }),
    r === "Bottom" && p
  ] });
};
L6.displayName = G0;
const W0 = (e = {}) => /* @__PURE__ */ E(
  L6,
  {
    disclosureWrapper: Uo,
    inlinePlayButtonWrapper: U0,
    ...e
  }
);
W0.displayName = G0;
(function() {
  if (typeof window != "object")
    return;
  if ("IntersectionObserver" in window && "IntersectionObserverEntry" in window && "intersectionRatio" in window.IntersectionObserverEntry.prototype) {
    "isIntersecting" in window.IntersectionObserverEntry.prototype || Object.defineProperty(
      window.IntersectionObserverEntry.prototype,
      "isIntersecting",
      {
        get: function() {
          return this.intersectionRatio > 0;
        }
      }
    );
    return;
  }
  function e(g) {
    try {
      return g.defaultView && g.defaultView.frameElement || null;
    } catch {
      return null;
    }
  }
  var t = function(g) {
    for (var v = g, S = e(v); S; )
      v = S.ownerDocument, S = e(v);
    return v;
  }(window.document), n = [], r = null, u = null;
  function i(g) {
    this.time = g.time, this.target = g.target, this.rootBounds = h(g.rootBounds), this.boundingClientRect = h(g.boundingClientRect), this.intersectionRect = h(g.intersectionRect || p()), this.isIntersecting = !!g.intersectionRect;
    var v = this.boundingClientRect, S = v.width * v.height, _ = this.intersectionRect, A = _.width * _.height;
    S ? this.intersectionRatio = Number((A / S).toFixed(4)) : this.intersectionRatio = this.isIntersecting ? 1 : 0;
  }
  function a(g, v) {
    var S = v || {};
    if (typeof g != "function")
      throw new Error("callback must be a function");
    if (S.root && S.root.nodeType != 1 && S.root.nodeType != 9)
      throw new Error("root must be a Document or Element");
    this._checkForIntersections = s(
      this._checkForIntersections.bind(this),
      this.THROTTLE_TIMEOUT
    ), this._callback = g, this._observationTargets = [], this._queuedEntries = [], this._rootMarginValues = this._parseRootMargin(S.rootMargin), this.thresholds = this._initThresholds(S.threshold), this.root = S.root || null, this.rootMargin = this._rootMarginValues.map(function(_) {
      return _.value + _.unit;
    }).join(" "), this._monitoringDocuments = [], this._monitoringUnsubscribes = [];
  }
  a.prototype.THROTTLE_TIMEOUT = 100, a.prototype.POLL_INTERVAL = null, a.prototype.USE_MUTATION_OBSERVER = !0, a._setupCrossOriginUpdater = function() {
    return r || (r = function(g, v) {
      !g || !v ? u = p() : u = m(g, v), n.forEach(function(S) {
        S._checkForIntersections();
      });
    }), r;
  }, a._resetCrossOriginUpdater = function() {
    r = null, u = null;
  }, a.prototype.observe = function(g) {
    var v = this._observationTargets.some(function(S) {
      return S.element == g;
    });
    if (!v) {
      if (!(g && g.nodeType == 1))
        throw new Error("target must be an Element");
      this._registerInstance(), this._observationTargets.push({ element: g, entry: null }), this._monitorIntersections(g.ownerDocument), this._checkForIntersections();
    }
  }, a.prototype.unobserve = function(g) {
    this._observationTargets = this._observationTargets.filter(function(v) {
      return v.element != g;
    }), this._unmonitorIntersections(g.ownerDocument), this._observationTargets.length == 0 && this._unregisterInstance();
  }, a.prototype.disconnect = function() {
    this._observationTargets = [], this._unmonitorAllIntersections(), this._unregisterInstance();
  }, a.prototype.takeRecords = function() {
    var g = this._queuedEntries.slice();
    return this._queuedEntries = [], g;
  }, a.prototype._initThresholds = function(g) {
    var v = g || [0];
    return Array.isArray(v) || (v = [v]), v.sort().filter(function(S, _, A) {
      if (typeof S != "number" || isNaN(S) || S < 0 || S > 1)
        throw new Error("threshold must be a number between 0 and 1 inclusively");
      return S !== A[_ - 1];
    });
  }, a.prototype._parseRootMargin = function(g) {
    var v = g || "0px", S = v.split(/\s+/).map(function(_) {
      var A = /^(-?\d*\.?\d+)(px|%)$/.exec(_);
      if (!A)
        throw new Error("rootMargin must be specified in pixels or percent");
      return { value: parseFloat(A[1]), unit: A[2] };
    });
    return S[1] = S[1] || S[0], S[2] = S[2] || S[0], S[3] = S[3] || S[1], S;
  }, a.prototype._monitorIntersections = function(g) {
    var v = g.defaultView;
    if (v && this._monitoringDocuments.indexOf(g) == -1) {
      var S = this._checkForIntersections, _ = null, A = null;
      this.POLL_INTERVAL ? _ = v.setInterval(S, this.POLL_INTERVAL) : (c(v, "resize", S, !0), c(g, "scroll", S, !0), this.USE_MUTATION_OBSERVER && "MutationObserver" in v && (A = new v.MutationObserver(S), A.observe(g, {
        attributes: !0,
        childList: !0,
        characterData: !0,
        subtree: !0
      }))), this._monitoringDocuments.push(g), this._monitoringUnsubscribes.push(function() {
        var L = g.defaultView;
        L && (_ && L.clearInterval(_), l(L, "resize", S, !0)), l(g, "scroll", S, !0), A && A.disconnect();
      });
      var k = this.root && (this.root.ownerDocument || this.root) || t;
      if (g != k) {
        var T = e(g);
        T && this._monitorIntersections(T.ownerDocument);
      }
    }
  }, a.prototype._unmonitorIntersections = function(g) {
    var v = this._monitoringDocuments.indexOf(g);
    if (v != -1) {
      var S = this.root && (this.root.ownerDocument || this.root) || t, _ = this._observationTargets.some(function(T) {
        var L = T.element.ownerDocument;
        if (L == g)
          return !0;
        for (; L && L != S; ) {
          var w = e(L);
          if (L = w && w.ownerDocument, L == g)
            return !0;
        }
        return !1;
      });
      if (!_) {
        var A = this._monitoringUnsubscribes[v];
        if (this._monitoringDocuments.splice(v, 1), this._monitoringUnsubscribes.splice(v, 1), A(), g != S) {
          var k = e(g);
          k && this._unmonitorIntersections(k.ownerDocument);
        }
      }
    }
  }, a.prototype._unmonitorAllIntersections = function() {
    var g = this._monitoringUnsubscribes.slice(0);
    this._monitoringDocuments.length = 0, this._monitoringUnsubscribes.length = 0;
    for (var v = 0; v < g.length; v++)
      g[v]();
  }, a.prototype._checkForIntersections = function() {
    if (!(!this.root && r && !u)) {
      var g = this._rootIsInDom(), v = g ? this._getRootRect() : p();
      this._observationTargets.forEach(function(S) {
        var _ = S.element, A = f(_), k = this._rootContainsTarget(_), T = S.entry, L = g && k && this._computeTargetAndRootIntersection(_, A, v), w = null;
        this._rootContainsTarget(_) ? (!r || this.root) && (w = v) : w = p();
        var D = S.entry = new i({
          time: o(),
          target: _,
          boundingClientRect: A,
          rootBounds: w,
          intersectionRect: L
        });
        T ? g && k ? this._hasCrossedThreshold(T, D) && this._queuedEntries.push(D) : T && T.isIntersecting && this._queuedEntries.push(D) : this._queuedEntries.push(D);
      }, this), this._queuedEntries.length && this._callback(this.takeRecords(), this);
    }
  }, a.prototype._computeTargetAndRootIntersection = function(g, v, S) {
    if (window.getComputedStyle(g).display != "none") {
      for (var _ = v, A = x(g), k = !1; !k && A; ) {
        var T = null, L = A.nodeType == 1 ? window.getComputedStyle(A) : {};
        if (L.display == "none")
          return null;
        if (A == this.root || A.nodeType == /* DOCUMENT */
        9)
          if (k = !0, A == this.root || A == t)
            r && !this.root ? !u || u.width == 0 && u.height == 0 ? (A = null, T = null, _ = null) : T = u : T = S;
          else {
            var w = x(A), D = w && f(w), N = w && this._computeTargetAndRootIntersection(w, D, S);
            D && N ? (A = w, T = m(D, N)) : (A = null, _ = null);
          }
        else {
          var O = A.ownerDocument;
          A != O.body && A != O.documentElement && L.overflow != "visible" && (T = f(A));
        }
        if (T && (_ = d(T, _)), !_)
          break;
        A = A && x(A);
      }
      return _;
    }
  }, a.prototype._getRootRect = function() {
    var g;
    if (this.root && !y(this.root))
      g = f(this.root);
    else {
      var v = y(this.root) ? this.root : t, S = v.documentElement, _ = v.body;
      g = {
        top: 0,
        left: 0,
        right: S.clientWidth || _.clientWidth,
        width: S.clientWidth || _.clientWidth,
        bottom: S.clientHeight || _.clientHeight,
        height: S.clientHeight || _.clientHeight
      };
    }
    return this._expandRectByRootMargin(g);
  }, a.prototype._expandRectByRootMargin = function(g) {
    var v = this._rootMarginValues.map(function(_, A) {
      return _.unit == "px" ? _.value : _.value * (A % 2 ? g.width : g.height) / 100;
    }), S = {
      top: g.top - v[0],
      right: g.right + v[1],
      bottom: g.bottom + v[2],
      left: g.left - v[3]
    };
    return S.width = S.right - S.left, S.height = S.bottom - S.top, S;
  }, a.prototype._hasCrossedThreshold = function(g, v) {
    var S = g && g.isIntersecting ? g.intersectionRatio || 0 : -1, _ = v.isIntersecting ? v.intersectionRatio || 0 : -1;
    if (S !== _)
      for (var A = 0; A < this.thresholds.length; A++) {
        var k = this.thresholds[A];
        if (k == S || k == _ || k < S != k < _)
          return !0;
      }
  }, a.prototype._rootIsInDom = function() {
    return !this.root || b(t, this.root);
  }, a.prototype._rootContainsTarget = function(g) {
    var v = this.root && (this.root.ownerDocument || this.root) || t;
    return b(v, g) && (!this.root || v == g.ownerDocument);
  }, a.prototype._registerInstance = function() {
    n.indexOf(this) < 0 && n.push(this);
  }, a.prototype._unregisterInstance = function() {
    var g = n.indexOf(this);
    g != -1 && n.splice(g, 1);
  };
  function o() {
    return window.performance && performance.now && performance.now();
  }
  function s(g, v) {
    var S = null;
    return function() {
      S || (S = setTimeout(function() {
        g(), S = null;
      }, v));
    };
  }
  function c(g, v, S, _) {
    typeof g.addEventListener == "function" ? g.addEventListener(v, S, _ || !1) : typeof g.attachEvent == "function" && g.attachEvent("on" + v, S);
  }
  function l(g, v, S, _) {
    typeof g.removeEventListener == "function" ? g.removeEventListener(v, S, _ || !1) : typeof g.detachEvent == "function" && g.detachEvent("on" + v, S);
  }
  function d(g, v) {
    var S = Math.max(g.top, v.top), _ = Math.min(g.bottom, v.bottom), A = Math.max(g.left, v.left), k = Math.min(g.right, v.right), T = k - A, L = _ - S;
    return T >= 0 && L >= 0 && {
      top: S,
      bottom: _,
      left: A,
      right: k,
      width: T,
      height: L
    } || null;
  }
  function f(g) {
    var v;
    try {
      v = g.getBoundingClientRect();
    } catch {
    }
    return v ? (v.width && v.height || (v = {
      top: v.top,
      right: v.right,
      bottom: v.bottom,
      left: v.left,
      width: v.right - v.left,
      height: v.bottom - v.top
    }), v) : p();
  }
  function p() {
    return {
      top: 0,
      bottom: 0,
      left: 0,
      right: 0,
      width: 0,
      height: 0
    };
  }
  function h(g) {
    return !g || "x" in g ? g : {
      top: g.top,
      y: g.top,
      bottom: g.bottom,
      left: g.left,
      x: g.left,
      right: g.right,
      width: g.width,
      height: g.height
    };
  }
  function m(g, v) {
    var S = v.top - g.top, _ = v.left - g.left;
    return {
      top: S,
      left: _,
      height: v.height,
      width: v.width,
      bottom: S + v.height,
      right: _ + v.width
    };
  }
  function b(g, v) {
    for (var S = v; S; ) {
      if (S == g)
        return !0;
      S = x(S);
    }
    return !1;
  }
  function x(g) {
    var v = g.parentNode;
    return g.nodeType == /* DOCUMENT */
    9 && g != t ? e(g) : (v && v.assignedSlot && (v = v.assignedSlot.parentNode), v && v.nodeType == 11 && v.host ? v.host : v);
  }
  function y(g) {
    return g && g.nodeType === 9;
  }
  window.IntersectionObserver = a, window.IntersectionObserverEntry = i;
})();
const D6 = {
  minHeight: "18.75rem",
  minWidth: "auto"
}, K0 = ({
  rootMargin: e = "700px 0px"
}) => ({
  rootMargin: e,
  triggerOnce: !0,
  threshold: 0
}), N6 = ({
  children: e,
  className: t,
  containerDimensions: n = D6,
  motionOptions: r,
  isAnimated: u,
  rootMargin: i
}) => {
  const { inView: a, ref: o } = zi(K0({ rootMargin: i }));
  return /* @__PURE__ */ E(
    Vr,
    {
      motionOptions: r || gv,
      className: t,
      rootRef: o,
      style: n,
      isAnimated: u,
      children: a && e
    }
  );
}, O6 = () => {
  const { foundationConfig: e } = ke(yn);
  return e;
}, nR = ({
  src: e,
  qual: t,
  format: n,
  width: r,
  serverImgConfigs: u
}) => {
  const i = e.split("?")[0];
  let a = `?quality=${t.toString()}&width=${r.toString()}`;
  return n && (a = `${a}&format=${n}`), u && Object.entries(u).forEach(([o, s]) => {
    a = `${a}&${o}=${s}`;
  }), `${i}${a}`;
}, Y0 = ({
  src: e,
  qual: t = "50",
  width: n = 1e3,
  format: r,
  stripQueryParams: u = !1,
  serverImgConfigs: i = {}
}) => {
  if (!e)
    return;
  if (e.endsWith(".svg"))
    return e;
  try {
    if (u)
      return nR({
        src: e,
        qual: t,
        width: n,
        format: r,
        serverImgConfigs: i
      });
    const o = new URL(e);
    return o.searchParams.set("quality", t.toString()), o.searchParams.set("width", n.toString()), r && o.searchParams.set("format", r.toString()), i && Object.entries(i).forEach(([s, c]) => {
      o.searchParams.set(s, c);
    }), o.toString();
  } catch {
    return e;
  }
}, rR = ({
  src: e,
  maxWidth: t,
  qual: n,
  format: r,
  stripQueryParams: u,
  serverImgConfigs: i
}) => {
  const o = t || 1200, s = [];
  for (let c = 300; c < o; c += 300)
    s.push(
      `${Y0({
        src: e,
        qual: n,
        width: c,
        format: r,
        stripQueryParams: u,
        serverImgConfigs: i
      })} ${c}w`
    );
  return s;
}, hi = ({
  src: e,
  maxWidth: t,
  format: n,
  qual: r = 75,
  stripQueryParams: u,
  serverImgConfigs: i
}) => {
  if (!e)
    return {};
  const a = Y0({
    src: e,
    qual: r,
    width: 300,
    format: n,
    stripQueryParams: u,
    serverImgConfigs: i
  }), o = rR({
    src: e,
    maxWidth: t,
    qual: r,
    format: n,
    stripQueryParams: u,
    serverImgConfigs: i
  }).join();
  return {
    ...(() => n ? {} : {
      src: a
    })(),
    srcSet: o
  };
}, uR = (e, {
  dataPaClick: t,
  analyticsCompName: n,
  imageAltText: r
}, u) => t || (n ? Ht(
  {
    componentName: n,
    linkText: r,
    linkSection: "Image",
    serverFptiData: u
  },
  e,
  yt.Link
) : ""), iR = () => {
  const e = `(max-width: ${nr.sm})`, t = `(min-width: ${ut.md}) and (max-width: ${nr.md})`, n = `(min-width: ${ut.lg})`;
  return {
    mobileMedia: e,
    tabletMedia: t,
    desktopMedia: n
  };
}, aR = ({
  baseImage: e,
  mdImage: t,
  desktopImage: n,
  viewportType: r
}) => {
  switch (r) {
    case "xs":
    case "sm":
      return e;
    case "md":
      return t || e;
    default:
      return n || t || e;
  }
}, oR = ({
  baseImage: e,
  mdImage: t,
  desktopImage: n,
  viewportTypes: r
}) => r.map(
  (u) => aR({
    baseImage: e,
    mdImage: t,
    desktopImage: n,
    viewportType: u
  })
), ng = ({
  stripQueryParams: e,
  baseImage: t,
  mdImage: n,
  desktopImage: r,
  maxWidth: u,
  quality: i,
  serverImgConfigs: a,
  format: o
}) => ({
  base: hi({
    stripQueryParams: e,
    src: t,
    maxWidth: u,
    format: o,
    qual: i,
    serverImgConfigs: a
  }),
  tablet: hi({
    stripQueryParams: e,
    src: n,
    maxWidth: u,
    format: o,
    qual: i,
    serverImgConfigs: a
  }),
  desktop: hi({
    stripQueryParams: e,
    src: r,
    maxWidth: u,
    format: o,
    qual: i,
    serverImgConfigs: a
  })
}), sR = ({
  stripQueryParams: e,
  baseImage: t,
  mdImage: n,
  maxWidth: r,
  quality: u,
  serverImgConfigs: i
}) => {
  const a = hi({
    stripQueryParams: e,
    src: n || t,
    maxWidth: r,
    qual: u,
    serverImgConfigs: i
  });
  return {
    imageBaseSrc: hi({
      stripQueryParams: e,
      src: t,
      maxWidth: r,
      qual: u,
      serverImgConfigs: i
    }),
    imageMobileSrc: a
  };
}, rg = {
  webp: "webp",
  avif: "avif"
}, cR = ({
  baseImage: e,
  mdImage: t,
  desktopImage: n,
  maxWidth: r,
  quality: u,
  loading: i,
  fetchPriority: a,
  stripQueryParams: o,
  verticalAlign: s,
  isImageDecorative: c = !1,
  imageAltText: l,
  ariaHidden: d,
  ariaDescribedBy: f,
  classNameGen: p,
  serverImgConfigs: h
}) => {
  const m = U({
    [p.getElementClassName("img-v-align-top")]: s === "top",
    [p.getElementClassName("img-v-align-bottom")]: s === "bottom"
  }), { mobileMedia: b, tabletMedia: x, desktopMedia: y } = iR(), [g, v, S] = oR({
    baseImage: e,
    mdImage: t,
    desktopImage: n,
    viewportTypes: ["sm", "md", "lg"]
  }), _ = ng({
    stripQueryParams: o,
    baseImage: g,
    mdImage: v,
    desktopImage: S,
    maxWidth: r,
    quality: u,
    serverImgConfigs: h,
    format: rg.webp
  }), A = ng({
    stripQueryParams: o,
    baseImage: g,
    mdImage: v,
    desktopImage: S,
    maxWidth: r,
    quality: u,
    serverImgConfigs: h,
    format: rg.avif
  }), T = {
    ...sR({
      stripQueryParams: o,
      baseImage: e,
      mdImage: t,
      maxWidth: r,
      quality: u,
      serverImgConfigs: h
    }).imageBaseSrc
  };
  return i === "lazy" && (T.loading = "lazy", T.decoding = "async"), a === "high" && (T.fetchpriority = "high"), /* @__PURE__ */ ue(on, { children: [
    /* @__PURE__ */ E("source", { type: "image/webp", media: b, ..._.base }),
    /* @__PURE__ */ E("source", { type: "image/webp", media: x, ..._.tablet }),
    /* @__PURE__ */ E("source", { type: "image/webp", media: y, ..._.desktop }),
    /* @__PURE__ */ E("source", { type: "image/avif", media: b, ...A.base }),
    /* @__PURE__ */ E("source", { type: "image/avif", media: x, ...A.tablet }),
    /* @__PURE__ */ E("source", { type: "image/avif", media: y, ...A.desktop }),
    /* @__PURE__ */ E(
      "img",
      {
        alt: c ? "" : l,
        "aria-hidden": d,
        "aria-describedby": f,
        className: m || void 0,
        ...T
      }
    )
  ] });
};
const I6 = "ImageFrame", oc = new ye(I6), lR = ({
  className: e,
  imageAltText: t = "",
  loading: n = "lazy",
  fetchPriority: r = "auto",
  baseImage: u = "",
  mdImage: i = "",
  desktopImage: a = "",
  dimensions: o = {
    minHeight: "12.5rem",
    minWidth: "auto"
  },
  imageLink: s,
  target: c = "_self",
  analyticsCompName: l = "",
  ariaHidden: d = !1,
  ariaDescribedBy: f,
  maxSrcSetWidth: p = 1e3,
  customWrapper: h,
  lazyLoadWrapper: m,
  lazyLoadRootMargin: b,
  imageServerKnobs: x = {},
  dataPaClick: y,
  verticalAlign: g = "center",
  imageLinkAttrs: v,
  stripQueryParams: S = !1,
  rootRef: _,
  pictureRef: A,
  isImageDecorative: k = !1,
  customPicture: T,
  ...L
}) => {
  const { environment: { pageSegment: w = "" } = {} } = nt(), { mediaFrame: D } = O6(), N = L.roundedCorners ?? D.roundedCorners, O = U(
    e,
    oc.getComponentClassName(),
    oc.getPropsValueClassName("roundedCorners", N)
  ), {
    quality: H = 75,
    maxWidth: $ = p,
    serverImgConfigs: j = {},
    intersectionRootMargin: z
  } = x, M = /* @__PURE__ */ E(
    cR,
    {
      baseImage: u,
      mdImage: i,
      desktopImage: a,
      maxWidth: $,
      quality: H,
      loading: n,
      fetchPriority: r,
      stripQueryParams: S,
      verticalAlign: g,
      isImageDecorative: k,
      imageAltText: t,
      ariaHidden: d,
      ariaDescribedBy: f,
      classNameGen: oc,
      serverImgConfigs: j
    }
  ), C = s ? /* @__PURE__ */ E(
    "a",
    {
      ...c === "_blank" ? { rel: "noopener" } : {},
      className: O,
      href: s,
      "data-pa-click": uR(w, {
        dataPaClick: y,
        analyticsCompName: l,
        imageAltText: t
      }),
      target: c,
      ...v,
      children: M
    }
  ) : M, V = /* @__PURE__ */ E(T ?? "picture", { ref: A, children: C });
  if (n === "lazy")
    return /* @__PURE__ */ E(
      m,
      {
        className: O,
        containerDimensions: o,
        rootRef: _,
        rootMargin: z || b,
        ...L,
        children: V
      }
    );
  const I = {
    className: O,
    style: o,
    ref: _,
    ...L
  }, G = h || "div";
  return Te.createElement(G, I, V);
}, Yo = at(({ motionOptions: e, isAnimated: t = !0, ...n }, r) => {
  const i = {
    ...e || gv,
    scrollTriggerOptions: {
      triggerOnce: !0
    }
  };
  return /* @__PURE__ */ E(
    lR,
    {
      ...n,
      rootRef: r,
      customWrapper: Vr,
      lazyLoadWrapper: N6,
      motionOptions: i,
      isAnimated: t
    }
  );
});
Yo.displayName = I6;
const kr = ({
  size: e
}) => function({ children: n, ...r }) {
  const u = {
    ...r,
    size: e
  };
  return /* @__PURE__ */ E(Qt, { ...u, children: n });
}, VH = (e) => ({
  oldContentRenderer: {
    li: (t, n) => /* @__PURE__ */ E(Qt, { size: e, as: "li", children: n })
  },
  newContentRenderer: {
    li: (t, { children: n, ...r }) => /* @__PURE__ */ E(Qt, { size: e, as: "li", ...r, children: n })
  }
}), dR = (e) => ((e == null ? void 0 : e.content) || []).map((n) => ({
  nodeType: Ze.BLOCKS.DOCUMENT,
  content: [n],
  data: {}
})), fR = (e) => typeof e == "string" ? [e] : dR(e), pR = (e, t, n, r) => {
  const { customWrapper: u = kr({ size: n }), ...i } = r ?? {};
  return /* @__PURE__ */ E(
    Bt,
    {
      content: e,
      customWrapper: u,
      ...i
    },
    `multiline-line-${t}`
  );
}, hR = ({
  content: e,
  lineProps: t,
  size: n = "Body"
}) => {
  const r = fR(e);
  return /* @__PURE__ */ E(on, { children: r.map((u, i) => pR(u, i, n, t)) });
};
const M6 = "HeadingText", mR = new ye(M6), sc = {
  "Display 0": "Display 0",
  "Display 1": "Display 1",
  "Display 2": "Display 2",
  "Display 3": "Display 3",
  "Headline 1": "Headline 1",
  "Headline 2": "Headline 2",
  "Headline 3": "Headline 3",
  "Headline 4": "Headline 4",
  "Headline 5": "Headline 5",
  "Headline 6": "Headline 6",
  "Headline 7": "Headline 7",
  Title: "Title"
}, dr = ({
  level: e = 1,
  as: t,
  size: n = "Headline 1",
  className: r,
  children: u,
  ...i
}) => {
  const a = t || `h${e}`, o = mR.getPropsValueClassName(
    "size",
    n
  ), s = U(r, o);
  return Te.createElement(
    a,
    { className: s, ...i },
    u
  );
};
dr.displayName = M6;
const P6 = ({ size: e }, t = !1) => function(r) {
  let u = r;
  t && (u = Ok(u));
  const i = {
    ...u,
    size: e
  };
  return Te.createElement(dr, i);
};
class R6 extends Date {
  constructor() {
    super(), this.setTime(arguments.length === 0 ? (
      // Enables Sinon's fake timers that override the constructor
      Date.now()
    ) : arguments.length === 1 ? typeof arguments[0] == "string" ? +new Date(arguments[0]) : arguments[0] : Date.UTC(...arguments));
  }
  getTimezoneOffset() {
    return 0;
  }
}
const ug = /^(get|set)(?!UTC)/;
Object.getOwnPropertyNames(Date.prototype).forEach((e) => {
  if (ug.test(e)) {
    const t = Date.prototype[e.replace(ug, "$1UTC")];
    t && (R6.prototype[e] = t);
  }
});
class gR extends R6 {
  toString() {
    const t = this.toDateString(), n = this.toTimeString();
    return `${t} ${n}`;
  }
  toDateString() {
    const t = bR.format(this), n = vR.format(this), r = this.getFullYear();
    return `${t} ${n} ${r}`;
  }
  toTimeString() {
    return `${yR.format(this)} GMT+0000 (Coordinated Universal Time)`;
  }
  toLocaleString(t, n) {
    return Date.prototype.toLocaleString.call(this, t, {
      timeZone: "UTC",
      ...n
    });
  }
  toLocaleDateString(t, n) {
    return Date.prototype.toLocaleDateString.call(this, t, {
      timeZone: "UTC",
      ...n
    });
  }
  toLocaleTimeString(t, n) {
    return Date.prototype.toLocaleTimeString.call(this, t, {
      timeZone: "UTC",
      ...n
    });
  }
}
var bR = new Intl.DateTimeFormat("en-US", {
  weekday: "short",
  timeZone: "UTC"
}), vR = new Intl.DateTimeFormat("en-US", {
  month: "short",
  day: "numeric",
  timeZone: "UTC"
}), yR = new Intl.DateTimeFormat("en-GB", {
  hour12: !1,
  hour: "numeric",
  minute: "numeric",
  second: "numeric",
  timeZone: "UTC"
});
const jH = (e, t = !1) => {
  const n = new gR(e), r = n.getMonth(), u = String(n.getDate()).padStart(2, "0"), i = n.getFullYear(), o = `${[
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December"
  ][r]} ${u}`;
  return t ? o : `${o}, ${i}`;
}, zH = (e = "") => {
  if (!e)
    return !1;
  const n = new Date(e).getTime();
  return !Number.isNaN(n);
}, UH = (e) => (e ? new Date(e) : /* @__PURE__ */ new Date()).toISOString().split("T")[0];
var ig, ag, og, sg, cg, lg, dg, fg, pg;
function xR(e) {
  if (!Object.keys(e).length)
    return console.warn("Missing Emotion theme. Use ThemeProvider from @emotion/react to pass a valid theme from pp-react."), {};
  var t = e.sysBorderRadiusInteractive, n = e.sysBorderRadiusSm, r = e.sysColorBackgroundHighContrast, u = e.sysColorBackgroundSurface, i = e.sysColorPrimaryMainActive, a = e.sysColorPrimaryMain, o = e.sysSizeIconSm, s = e.sysSizePointerWidthLg, c = e.sysSizeTapTargetSm, l = e.sysSpaceLg, d = e.sysSpaceSm, f = e.sysSpaceXs, p = zr(e), h = p.body, m = Zn(e), b = m.elevationStyles, x = m.caretStyles, y = m.focusStyles, g = m.screenReader, v = y.stateFocusBorderColorInner, S = y.stateFocusBorderWidthInner, _ = y.stateFocusBorderWidthOuter, A = G4(e), k = A.base, T = A.sizeXs, L = "18rem", w = qe("".concat(s, "/2")), D = B(ig || (ig = F([`
    label: tooltip_base;
    `, `;
    visibility: hidden;
    opacity: 0;
    max-width: `, `;
    word-wrap: break-word;
    padding: `, `;
    position: absolute;
    border-radius: `, `;
    background-color: `, `;
    z-index: `, `;

    `, `
    `, `
    `, `
    `, `


    &[aria-hidden='false'] {
      visibility: visible;
      opacity: 1;
    }

    &.pp_react_tooltip--position_left {
      label: position_left;
      `, `
    }

    &.pp_react_tooltip--position_right {
      label: position_right;
      `, `
    }

    &.pp_react_tooltip--position_bottom {
      label: position_bottom;
      `, `
    }

    &.pp_react_tooltip--tip_left {
      label: tip_position_left;
      `, `
    }

    &.pp_react_tooltip--tip_right {
      label: tip_position_right;
      `, `
    }
  `])), h({
    color: r
  }), L, l, n, u, oI, b.level3, x.base(s), x.positionBottom(w), x.positionCenter(s), x.positionRight(w), x.positionLeft(w), x.positionTop(w), x.positionShiftLeft(s), x.positionShiftRight(s)), N = B(ag || (ag = F([`
    label: tooltip-icon;
    `, `;
    `, `;
    width: `, `;
    height: `, `;
    padding: 0;
    display: inline-flex;
    justify-content: center;
    align-items: center;
    color: `, `;
    cursor: pointer;
    border: 0;
    background-color: transparent;
    position: relative;

    &:hover,
    &:active {
      color: `, `;
      outline: none;
    }

    &:focus:after {
      `, `;
      transform: translateX(50%) translateX(`, `) translateY(50%)
        translateY(`, `);
    }
  `])), k, T, c, c, a, i, y.focusAfter({
    radius: t,
    width: o,
    height: o,
    border: "".concat(S, " solid ").concat(v),
    top: "-".concat(_),
    left: "-".concat(_)
  }), f, f), O = B(og || (og = F([`
    label: image;
    display: flex;
    img {
      max-width: `, `;
    }
  `])), qe("".concat(L, " - 2 * ").concat(l))), H = function(C) {
    return B(sg || (sg = F([`
    justify-content: `, `;
    padding-top: `, `;
  `])), C, d);
  }, $ = function(C) {
    return B(cg || (cg = F([`
    justify-content: `, `;
    padding-bottom: `, `;
  `])), C, d);
  }, j = B(lg || (lg = F([`
    label: image_top_left;
    `, `
  `])), $("flex-start")), z = B(dg || (dg = F([`
    label: image_top_center;
    `, `
  `])), $("center")), M = B(fg || (fg = F([`
    label: image_bottom_left;
    `, `
  `])), H("flex-start")), P = B(pg || (pg = F([`
    label: image_bottom_center;
    `, `
  `])), H("center"));
  return {
    base: D,
    icon: N,
    screenReader: g,
    image: O,
    imageTopLeft: j,
    imageTopCenter: z,
    imageBottomLeft: M,
    imageBottomCenter: P
  };
}
var bt, Ju, B6 = function(e) {
  var t = e.name, n = t === void 0 ? "Tooltip" : t, r = e.description, u = r === void 0 ? "tooltip" : r, i = e.screenReaderText, a = i === void 0 ? n : i, o = e.position, s = e.verifiedIcon, c = e.windowId, l = e.className, d = e.triggerClassName, f = e.tooltipClassName, p = e.containerRef, h = e.onOpen, m = e.onClose, b = e.imageElement, x = e.imagePosition, y = x === void 0 ? "top-left" : x, g = Z(), v = Z(), S = Z(), _ = ln(), A = $e(function() {
    return xR(_);
  }, [_]), k = typeof window < "u" && "ontouchstart" in window || typeof navigator < "u" && (navigator.maxTouchPoints || navigator.msMaxTouchPoints), T = function() {
  }, L, w, D, N, O, H, $, j, z, M, P, C, R, V, I, G, K = me({
    isOpen: !1,
    currentEvent: null
  }), Q = an(K, 2), ae = Q[0], X = Q[1], ne = ae.isOpen, fe = ae.currentEvent, he = function(J) {
    return (
      /* istanbul ignore next */
      J && J.current ? J.current : null
    );
  }, xe = function(J, te) {
    var Me, Ye, gt = he(p), dt = gt ? [J - ((Me = w) === null || Me === void 0 ? void 0 : Me.top) - N + gt.scrollTop, te - ((Ye = w) === null || Ye === void 0 ? void 0 : Ye.left) - D + gt.scrollLeft] : [J, te], Tt = an(dt, 2), Mt = Tt[0], xn = Tt[1];
    bt.style.top = "".concat(Mt, "px"), bt.style.left = "".concat(xn, "px"), bt.style.maxWidth = "".concat(M, "px");
  }, re = function() {
    var J = c ? document.getElementById(c) : "";
    if (J) {
      var te = J.getBoundingClientRect();
      return {
        windowEl: J,
        top: te.top,
        right: te.right,
        bottom: te.bottom,
        left: te.left
      };
    }
    return {
      windowEl: window,
      top: 0,
      right: window.innerWidth || document.documentElement.clientWidth,
      bottom: window.innerHeight || document.documentElement.clientHeight,
      left: 0
    };
  }, Se = function() {
    var J = z.left - O / 2 + $ / 2 + D, te = z.top - H - I + N + P;
    xe(te, J);
  }, et = function(J, te) {
    var Me = J + N + H + j + I * 2 - P * 2;
    xe(Me, te);
  }, Le = function() {
    var J = $ / 2 - G / 2, te = z.left - O + J - I + D, Me = z.top - H / 2 + j / 2 + N;
    bt.classList.add("pp_react_tooltip--position_left"), xe(Me, te);
  }, rt = function() {
    var J = $ / 2 + G / 2, te = z.left + J + I + D, Me = z.top - H / 2 + j / 2 + N;
    bt.classList.add("pp_react_tooltip--position_right"), xe(Me, te);
  }, we = (
    /* istanbul ignore next */
    function() {
      Se();
      var J = bt.getBoundingClientRect();
      if ((J.top < L.top || J.top < 0) && (et(J.top, J.left), bt.classList.add("pp_react_tooltip--position_bottom"), J = bt.getBoundingClientRect()), !(J.left < L.left && J.left + M > L.right)) {
        var te = V + C / 2, Me = J.top + N, Ye = J.left + D;
        J.left < L.left && (Ye = Ye + O / 2 - te, bt.classList.add("pp_react_tooltip--tip_left")), J.left + M > L.right && (Ye = Ye - O / 2 + te, bt.classList.add("pp_react_tooltip--tip_right")), xe(Me, Ye);
      }
    }
  ), Oe = function(J) {
    J.stopPropagation(), X({
      isOpen: !0,
      currentEvent: J.type
    }), h && h(J, n);
  }, Ce = function(J) {
    var te = document.activeElement;
    if (!(J.type === "resize" && k && te && (te.tagName === "INPUT" || te.tagName === "TEXTAREA")) && (X({
      isOpen: !1,
      currentEvent: null
    }), m && m(n), L && L.windowEl)) {
      var Me = L, Ye = Me.windowEl;
      Ye.removeEventListener("scroll", Ce), Ye.removeEventListener("mousewheel", Ce);
    }
  }, Qe = function() {
    var J = getComputedStyle(bt, "style").maxWidth, te = parseInt(J.split("px")[0], 10), Me = L.left, Ye = L.right, gt = Ju.getBoundingClientRect().left, dt = gt - Me + P, Tt = Ye - gt - P - G, Mt = te / 2;
    if (dt > Mt && Tt > Mt)
      M = te;
    else if (
      // If both sides are less than half the maxwidth,
      // then tooltip bubble will be position center,
      // so use smaller side x 2 as max width since it's centered
      dt < Mt && Tt < Mt
    ) {
      var xn = dt < Tt ? dt : Tt;
      M = xn * 2;
    } else {
      var Ut = dt > Tt ? dt : Tt;
      o ? Ut = Ut - I - G : Ut += V + C / 2 - G, M = Ut > te ? te : Ut;
    }
    bt.style.maxWidth = "".concat(M, "px");
    var qt = bt.getBoundingClientRect().width;
    O = M < qt ? M : qt, H = bt.offsetHeight;
  }, ct = function() {
    bt = he(S), Ju = he(v), z = Ju.getBoundingClientRect();
    var J = he(p);
    w = J && J.getBoundingClientRect(), L = re(), O = bt.offsetWidth, H = bt.offsetHeight, $ = Ju.offsetWidth, j = Ju.offsetHeight, D = window.scrollX || window.pageXOffset, N = window.scrollY || window.pageYOffset;
    var te = window && window.getComputedStyle(document.body).getPropertyValue("font-size") || "16px", Me = parseInt(te.split("px")[0], 10);
    C = 1.125 * Me, R = 0.75 * Me, V = 1 * Me, I = R + 0.25 * Me;
    var Ye = $;
    G = 1.5 * Me, P = Ye / 2 - G / 2, Qe();
    var gt = L, dt = gt.windowEl;
    switch (dt.addEventListener("scroll", Ce), dt.addEventListener("mousewheel", Ce), o) {
      case "left":
        Le();
        break;
      case "right":
        rt();
        break;
      default:
        we();
    }
  }, mt = function(J) {
    var te = he(g);
    ne && te && !te.contains(J.target) && (J.stopPropagation(), Ce(J));
  }, Ot = function(J) {
    var te = J.key || J.keyCode;
    switch (te) {
      case "Tab":
      case 27:
      case "Escape":
      case "Esc":
      case 9:
        Ce(J);
        break;
    }
  };
  Gn(function() {
    return ne ? (ct(), document.addEventListener("mousedown", mt), document.addEventListener("keydown", Ot), window.addEventListener("resize", Ce)) : (document.removeEventListener("mousedown", mt), document.removeEventListener("keydown", Ot), window.removeEventListener("resize", Ce)), function() {
      document.removeEventListener("mousedown", mt), document.removeEventListener("keydown", Ot), window.removeEventListener("resize", Ce);
    };
  });
  var ve = function(J) {
    bt && J.relatedTarget !== bt && (J.stopPropagation(), Ce(J));
  }, Nt = "image" + function(te) {
    return te.replace(new RegExp(/[-_]+/, "g"), " ").replace(new RegExp(/[^\w\s]/, "g"), "").replace(new RegExp(/\s+(.)(\w*)/, "g"), function(Me, Ye, gt) {
      return "".concat(Ye.toUpperCase() + gt.toLowerCase());
    }).replace(new RegExp(/\w/), function(Me) {
      return Me.toUpperCase();
    });
  }(y), Vt = [
    A.image,
    //@ts-ignore
    A[Nt]
  ], lt = W("span", {
    css: Vt,
    "data-ppui": "true"
  }, b), jt = ne && gl.createPortal(W("div", {
    ref: S,
    css: A.base,
    className: f,
    id: n,
    role: "tooltip",
    "aria-hidden": !ne,
    onMouseLeave: fe === "focus" ? T : Ce,
    "data-ppui": "true"
  }, b && (y === "top-center" || y === "top-left") && lt, u, b && (y === "bottom-center" || y === "bottom-left") && lt), he(p) || document.body), zt = s ? W4 : K4, It = function(J) {
    var te = he(g);
    te.contains(J.target) || Ce(J);
  };
  return W("span", {
    ref: g,
    className: l,
    "data-ppui-info": "tooltip_4.3.0"
  }, W(Te.Fragment, null, W("button", Be({
    type: "button",
    ref: v,
    css: A.icon
  }, ne ? {
    "aria-describedby": n
  } : {}, {
    onMouseEnter: fe === "focus" ? T : Oe,
    onMouseLeave: fe === "focus" ? T : ve,
    onTouchEnd: function(te) {
      te.preventDefault(), ne ? (Ce(te), document.removeEventListener("touchstart", It)) : (Oe(te), document.addEventListener("touchstart", It));
    },
    onMouseDown: function(te) {
      return te.preventDefault();
    },
    onFocus: k ? T : Oe,
    className: d,
    "data-ppui": "true"
  }), W(zt, {
    size: "sm",
    "aria-hidden": "true",
    "data-ppui": "true"
  }), W("span", {
    css: A.screenReader,
    "data-ppui": "true"
  }, a)), jt));
};
const Z0 = "Number Group", mu = new ye(Z0), F6 = "Headline 1", hg = ({
  number: e,
  prefix: t = "",
  suffix: n = "",
  analyticsCompName: r = "Number",
  size: u = F6,
  affixSize: i
}) => /* @__PURE__ */ ue("strong", { className: mu.getElementClassName("number"), children: [
  t && /* @__PURE__ */ E(
    dr,
    {
      as: "span",
      size: i ?? u,
      className: mu.getElementClassName("numberSuffix"),
      children: t
    }
  ),
  /* @__PURE__ */ E(
    Bt,
    {
      as: "span",
      content: e,
      className: mu.getElementClassName("numberValue"),
      customWrapper: P6({ size: u }),
      analyticsCompName: r,
      analyticsTextSection: "number"
    }
  ),
  n && /* @__PURE__ */ E(
    dr,
    {
      as: "span",
      size: i ?? u,
      className: mu.getElementClassName("numberPrefix"),
      children: n
    }
  )
] }), al = ({
  size: e = F6,
  number1: t,
  number2: n,
  delimiter: r = "",
  className: u,
  analyticsCompName: i = Z0,
  affixSize: a
}) => {
  const o = U(mu.getComponentClassName(), u), s = r && n;
  return /* @__PURE__ */ ue("div", { className: o, children: [
    /* @__PURE__ */ E(
      hg,
      {
        ...t,
        analyticsCompName: i,
        size: e,
        affixSize: a
      }
    ),
    s && /* @__PURE__ */ E(
      dr,
      {
        as: "span",
        size: "Headline 6",
        className: mu.getElementClassName("delimiter"),
        children: r
      }
    ),
    s && /* @__PURE__ */ E(
      hg,
      {
        ...n,
        analyticsCompName: i,
        size: e,
        affixSize: a
      }
    )
  ] });
};
al.displayName = Z0;
var H6 = {};
(function(e) {
  var t = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof ee < "u" ? ee : typeof self < "u" ? self : {}, n = {}, r = {};
  Object.defineProperty(r, "__esModule", { value: !0 }), r.BLOCKS = void 0;
  var u;
  (function(_) {
    _.DOCUMENT = "document", _.PARAGRAPH = "paragraph", _.HEADING_1 = "heading-1", _.HEADING_2 = "heading-2", _.HEADING_3 = "heading-3", _.HEADING_4 = "heading-4", _.HEADING_5 = "heading-5", _.HEADING_6 = "heading-6", _.OL_LIST = "ordered-list", _.UL_LIST = "unordered-list", _.LIST_ITEM = "list-item", _.HR = "hr", _.QUOTE = "blockquote", _.EMBEDDED_ENTRY = "embedded-entry-block", _.EMBEDDED_ASSET = "embedded-asset-block", _.EMBEDDED_RESOURCE = "embedded-resource-block", _.TABLE = "table", _.TABLE_ROW = "table-row", _.TABLE_CELL = "table-cell", _.TABLE_HEADER_CELL = "table-header-cell";
  })(u || (r.BLOCKS = u = {}));
  var i = {};
  Object.defineProperty(i, "__esModule", { value: !0 }), i.INLINES = void 0;
  var a;
  (function(_) {
    _.HYPERLINK = "hyperlink", _.ENTRY_HYPERLINK = "entry-hyperlink", _.ASSET_HYPERLINK = "asset-hyperlink", _.RESOURCE_HYPERLINK = "resource-hyperlink", _.EMBEDDED_ENTRY = "embedded-entry-inline", _.EMBEDDED_RESOURCE = "embedded-resource-inline";
  })(a || (i.INLINES = a = {}));
  var o = {};
  Object.defineProperty(o, "__esModule", { value: !0 }), o.MARKS = void 0;
  var s;
  (function(_) {
    _.BOLD = "bold", _.ITALIC = "italic", _.UNDERLINE = "underline", _.CODE = "code", _.SUPERSCRIPT = "superscript", _.SUBSCRIPT = "subscript", _.STRIKETHROUGH = "strikethrough";
  })(s || (o.MARKS = s = {}));
  var c = {};
  (function(_) {
    var A = t && t.__spreadArray || function(D, N, O) {
      if (O || arguments.length === 2)
        for (var H = 0, $ = N.length, j; H < $; H++)
          (j || !(H in N)) && (j || (j = Array.prototype.slice.call(N, 0, H)), j[H] = N[H]);
      return D.concat(j || Array.prototype.slice.call(N));
    }, k;
    Object.defineProperty(_, "__esModule", { value: !0 }), _.V1_MARKS = _.V1_NODE_TYPES = _.TEXT_CONTAINERS = _.HEADINGS = _.CONTAINERS = _.VOID_BLOCKS = _.TABLE_BLOCKS = _.LIST_ITEM_BLOCKS = _.TOP_LEVEL_BLOCKS = void 0;
    var T = r, L = i, w = o;
    _.TOP_LEVEL_BLOCKS = [
      T.BLOCKS.PARAGRAPH,
      T.BLOCKS.HEADING_1,
      T.BLOCKS.HEADING_2,
      T.BLOCKS.HEADING_3,
      T.BLOCKS.HEADING_4,
      T.BLOCKS.HEADING_5,
      T.BLOCKS.HEADING_6,
      T.BLOCKS.OL_LIST,
      T.BLOCKS.UL_LIST,
      T.BLOCKS.HR,
      T.BLOCKS.QUOTE,
      T.BLOCKS.EMBEDDED_ENTRY,
      T.BLOCKS.EMBEDDED_ASSET,
      T.BLOCKS.EMBEDDED_RESOURCE,
      T.BLOCKS.TABLE
    ], _.LIST_ITEM_BLOCKS = [
      T.BLOCKS.PARAGRAPH,
      T.BLOCKS.HEADING_1,
      T.BLOCKS.HEADING_2,
      T.BLOCKS.HEADING_3,
      T.BLOCKS.HEADING_4,
      T.BLOCKS.HEADING_5,
      T.BLOCKS.HEADING_6,
      T.BLOCKS.OL_LIST,
      T.BLOCKS.UL_LIST,
      T.BLOCKS.HR,
      T.BLOCKS.QUOTE,
      T.BLOCKS.EMBEDDED_ENTRY,
      T.BLOCKS.EMBEDDED_ASSET,
      T.BLOCKS.EMBEDDED_RESOURCE
    ], _.TABLE_BLOCKS = [
      T.BLOCKS.TABLE,
      T.BLOCKS.TABLE_ROW,
      T.BLOCKS.TABLE_CELL,
      T.BLOCKS.TABLE_HEADER_CELL
    ], _.VOID_BLOCKS = [
      T.BLOCKS.HR,
      T.BLOCKS.EMBEDDED_ENTRY,
      T.BLOCKS.EMBEDDED_ASSET,
      T.BLOCKS.EMBEDDED_RESOURCE
    ], _.CONTAINERS = (k = {}, k[T.BLOCKS.OL_LIST] = [T.BLOCKS.LIST_ITEM], k[T.BLOCKS.UL_LIST] = [T.BLOCKS.LIST_ITEM], k[T.BLOCKS.LIST_ITEM] = _.LIST_ITEM_BLOCKS, k[T.BLOCKS.QUOTE] = [T.BLOCKS.PARAGRAPH], k[T.BLOCKS.TABLE] = [T.BLOCKS.TABLE_ROW], k[T.BLOCKS.TABLE_ROW] = [T.BLOCKS.TABLE_CELL, T.BLOCKS.TABLE_HEADER_CELL], k[T.BLOCKS.TABLE_CELL] = [T.BLOCKS.PARAGRAPH], k[T.BLOCKS.TABLE_HEADER_CELL] = [T.BLOCKS.PARAGRAPH], k), _.HEADINGS = [
      T.BLOCKS.HEADING_1,
      T.BLOCKS.HEADING_2,
      T.BLOCKS.HEADING_3,
      T.BLOCKS.HEADING_4,
      T.BLOCKS.HEADING_5,
      T.BLOCKS.HEADING_6
    ], _.TEXT_CONTAINERS = A([T.BLOCKS.PARAGRAPH], _.HEADINGS, !0), _.V1_NODE_TYPES = [
      T.BLOCKS.DOCUMENT,
      T.BLOCKS.PARAGRAPH,
      T.BLOCKS.HEADING_1,
      T.BLOCKS.HEADING_2,
      T.BLOCKS.HEADING_3,
      T.BLOCKS.HEADING_4,
      T.BLOCKS.HEADING_5,
      T.BLOCKS.HEADING_6,
      T.BLOCKS.OL_LIST,
      T.BLOCKS.UL_LIST,
      T.BLOCKS.LIST_ITEM,
      T.BLOCKS.HR,
      T.BLOCKS.QUOTE,
      T.BLOCKS.EMBEDDED_ENTRY,
      T.BLOCKS.EMBEDDED_ASSET,
      L.INLINES.HYPERLINK,
      L.INLINES.ENTRY_HYPERLINK,
      L.INLINES.ASSET_HYPERLINK,
      L.INLINES.EMBEDDED_ENTRY,
      "text"
    ], _.V1_MARKS = [w.MARKS.BOLD, w.MARKS.CODE, w.MARKS.ITALIC, w.MARKS.UNDERLINE];
  })(c);
  var l = {};
  Object.defineProperty(l, "__esModule", { value: !0 });
  var d = {};
  Object.defineProperty(d, "__esModule", { value: !0 });
  var f = {};
  Object.defineProperty(f, "__esModule", { value: !0 }), f.EMPTY_DOCUMENT = void 0;
  var p = r;
  f.EMPTY_DOCUMENT = {
    nodeType: p.BLOCKS.DOCUMENT,
    data: {},
    content: [
      {
        nodeType: p.BLOCKS.PARAGRAPH,
        data: {},
        content: [
          {
            nodeType: "text",
            value: "",
            marks: [],
            data: {}
          }
        ]
      }
    ]
  };
  var h = {};
  Object.defineProperty(h, "__esModule", { value: !0 }), h.isText = h.isBlock = h.isInline = void 0;
  var m = r, b = i;
  function x(_, A) {
    for (var k = 0, T = Object.keys(_); k < T.length; k++) {
      var L = T[k];
      if (A === _[L])
        return !0;
    }
    return !1;
  }
  function y(_) {
    return x(b.INLINES, _.nodeType);
  }
  h.isInline = y;
  function g(_) {
    return x(m.BLOCKS, _.nodeType);
  }
  h.isBlock = g;
  function v(_) {
    return _.nodeType === "text";
  }
  h.isText = v, function(_) {
    var A = t && t.__createBinding || (Object.create ? function($, j, z, M) {
      M === void 0 && (M = z);
      var P = Object.getOwnPropertyDescriptor(j, z);
      (!P || ("get" in P ? !j.__esModule : P.writable || P.configurable)) && (P = { enumerable: !0, get: function() {
        return j[z];
      } }), Object.defineProperty($, M, P);
    } : function($, j, z, M) {
      M === void 0 && (M = z), $[M] = j[z];
    }), k = t && t.__setModuleDefault || (Object.create ? function($, j) {
      Object.defineProperty($, "default", { enumerable: !0, value: j });
    } : function($, j) {
      $.default = j;
    }), T = t && t.__exportStar || function($, j) {
      for (var z in $)
        z !== "default" && !Object.prototype.hasOwnProperty.call(j, z) && A(j, $, z);
    }, L = t && t.__importStar || function($) {
      if ($ && $.__esModule)
        return $;
      var j = {};
      if ($ != null)
        for (var z in $)
          z !== "default" && Object.prototype.hasOwnProperty.call($, z) && A(j, $, z);
      return k(j, $), j;
    };
    Object.defineProperty(_, "__esModule", { value: !0 }), _.helpers = _.EMPTY_DOCUMENT = _.MARKS = _.INLINES = _.BLOCKS = void 0;
    var w = r;
    Object.defineProperty(_, "BLOCKS", { enumerable: !0, get: function() {
      return w.BLOCKS;
    } });
    var D = i;
    Object.defineProperty(_, "INLINES", { enumerable: !0, get: function() {
      return D.INLINES;
    } });
    var N = o;
    Object.defineProperty(_, "MARKS", { enumerable: !0, get: function() {
      return N.MARKS;
    } }), T(c, _), T(l, _), T(d, _);
    var O = f;
    Object.defineProperty(_, "EMPTY_DOCUMENT", { enumerable: !0, get: function() {
      return O.EMPTY_DOCUMENT;
    } });
    var H = L(h);
    _.helpers = H;
  }(n);
  function S(_, A) {
    return A === void 0 && (A = " "), !_ || !_.content || !Array.isArray(_.content) ? "" : _.content.reduce(function(k, T, L) {
      var w;
      if (n.helpers.isText(T))
        w = T.value;
      else if ((n.helpers.isBlock(T) || n.helpers.isInline(T)) && (w = S(T, A), !w.length))
        return k;
      var D = _.content[L + 1], N = D && n.helpers.isBlock(D), O = N ? A : "";
      return k + w + O;
    }, "");
  }
  e.documentToPlainTextString = S;
})(H6);
const X0 = (e) => e ? typeof e == "string" ? e : H6.documentToPlainTextString(e) : "", $6 = (e) => !!X0(e), V6 = () => typeof window !== void 0, _R = () => {
  if (!V6())
    return { focusedEl: null };
  const e = document.activeElement || document.body;
  return { focusedEl: e !== document.body ? e : null };
}, SR = (e) => Object.keys(e).length > 0, CR = (e, t) => Object.entries(t).some(([, n]) => n.node.contains(e)), ER = (e) => Object.entries(e).reduce(
  (n, [, r]) => (r.isSticky && (n += r.height), n),
  0
), wR = (e) => ({ registerStickyEl: ({
  type: u,
  cssSelector: i,
  height: a,
  isSticky: o
}) => {
  if (!V6())
    return !1;
  const s = document.querySelector(i);
  return e.current = {
    ...e.current,
    [u]: { node: s, height: a, isSticky: o }
  }, !0;
}, updateStickyElHeight: ({ type: u, height: i }) => e.current[u] ? (e.current[u] = {
  ...e.current[u],
  height: i
}, !0) : !1, updateStickyElStatus: ({ type: u, isSticky: i }) => e.current[u] ? (e.current[u] = {
  ...e.current[u],
  isSticky: i
}, !0) : !1 }), TR = () => {
  const e = Z({}), { registerStickyEl: t, updateStickyElHeight: n, updateStickyElStatus: r } = $e(() => wR(e), []);
  return oe(() => {
    const u = () => {
      const { focusedEl: a } = _R(), o = e.current;
      if (!a || !SR(o) || CR(a, o))
        return;
      const { top: s } = a.getBoundingClientRect(), c = ER(o);
      if (!(s < c))
        return;
      const d = s - c;
      window.scrollBy(0, d);
    }, i = typeof document < "u" ? document : window;
    return i.addEventListener("focus", u, !0), () => {
      i.removeEventListener("focus", u, !0);
    };
  }, []), { registerStickyEl: t, updateStickyElHeight: n, updateStickyElStatus: r };
}, AR = Yn({
  /**
   * Registers a sticky element in the context. Call it only once when the component loads, preferably in a useEffect
   * */
  registerStickyEl: () => {
  },
  /**
   * Update the sticky element height in the context. Height can be set in the context using registerStickyEl on component load.
   * So, use updateStickyElHeight if the component height is dynamic (e.g. changes with window resize)
   */
  updateStickyElHeight: () => {
  },
  /**
   * Update the status of sticky element in the context - whether it is currently sticky or not in the page
   */
  updateStickyElStatus: () => {
  }
}), kR = ({ children: e }) => {
  const { registerStickyEl: t, updateStickyElHeight: n, updateStickyElStatus: r } = TR(), u = $e(() => ({ registerStickyEl: t, updateStickyElHeight: n, updateStickyElStatus: r }), [t, n, r]);
  return /* @__PURE__ */ E(AR.Provider, { value: u, children: e });
}, qH = "ParentProvider", GH = ({
  children: e,
  ...t
}) => {
  var u, i, a, o, s, c, l, d, f, p, h;
  const n = X4(
    (i = (u = t == null ? void 0 : t.cmsEngineContext) == null ? void 0 : u.environment) == null ? void 0 : i.theme
  ), r = {
    initialViewport: (s = (o = (a = t == null ? void 0 : t.cmsEngineContext) == null ? void 0 : a.requestor) == null ? void 0 : o.clientInfo) == null ? void 0 : s.initialViewPort,
    pageSegment: (l = (c = t == null ? void 0 : t.cmsEngineContext) == null ? void 0 : c.environment) == null ? void 0 : l.pageSegment,
    baseURI: (f = (d = t == null ? void 0 : t.cmsEngineContext) == null ? void 0 : d.environment) == null ? void 0 : f.baseNolocaleUri,
    locality: (h = (p = t == null ? void 0 : t.cmsEngineContext) == null ? void 0 : p.requestor) == null ? void 0 : h.locality
  };
  return /* @__PURE__ */ E(
    JT,
    {
      cmsEngineContext: { ...t == null ? void 0 : t.cmsEngineContext },
      componentKitContext: { ...t == null ? void 0 : t.componentKitContext },
      children: /* @__PURE__ */ E(yn.Provider, { value: n, children: /* @__PURE__ */ E(Q2, { value: r, children: /* @__PURE__ */ E(kR, { children: e }) }) })
    }
  );
}, LR = ({
  mediaQueryTypeKeys: e,
  mediaQueryMap: t,
  setViewportTypeObj: n
}) => e.map((u) => [t[u], (o) => {
  o.matches && n((s) => ({
    ...s,
    viewportType: u
  }));
}]), Fu = () => {
  const { requestor: { clientInfo: { initialViewPort: e = "sm" } = {} } = {} } = nt(), [t, n] = me({
    viewportType: e,
    isViewportTypeMismatch: null
  });
  return oe(() => {
    const r = {
      xs: window.matchMedia(`(max-width: ${nr.xs})`),
      sm: window.matchMedia(
        `(min-width: ${ut.sm}) and (max-width: ${nr.sm})`
      ),
      md: window.matchMedia(
        `(min-width: ${ut.md}) and (max-width: ${nr.md})`
      ),
      lg: window.matchMedia(
        `(min-width: ${ut.lg}) and (max-width: ${nr.lg})`
      ),
      xl: window.matchMedia(
        `(min-width: ${ut.xl}) and (max-width: ${nr.xl})`
      ),
      "2xl": window.matchMedia(`(min-width: ${ut["2xl"]})`)
    }, u = Object.keys(r), i = LR({
      mediaQueryTypeKeys: u,
      mediaQueryMap: r,
      setViewportTypeObj: n
    });
    i.forEach(([s, c]) => {
      s.addEventListener ? s.addEventListener("change", c) : s.addListener(c);
    });
    const a = u.find((s) => r[s].matches), o = t.viewportType !== a;
    return n({
      viewportType: a || "sm",
      isViewportTypeMismatch: o
    }), () => {
      i.forEach(([s, c]) => {
        s.removeEventListener ? s.removeEventListener("change", c) : s.removeListener(c);
      });
    };
  }, [t.viewportType]), t;
}, DR = {
  "Below XL": ["xs", "sm", "md", "lg"],
  "Below LG": ["xs", "sm", "md"],
  "Below MD": ["xs", "sm"]
}, Ur = (e) => {
  const { viewportType: t } = Fu();
  return e.map((r) => r === "All Viewports" ? !0 : r === "None" || r === void 0 ? !1 : DR[r].includes(t));
}, NR = (e) => {
  if (e === sc["Headline 7"])
    return sc.Title;
  const t = Object.keys(sc), n = t.indexOf(e);
  return n === -1 ? e : t[n + 2];
}, OR = "DataItemProperty", j6 = new ye(OR), z6 = ({ wrapper: e, children: t }) => /* @__PURE__ */ E(e || Bg, { children: t }), mg = ({
  section: e,
  content: t,
  wrapper: n,
  textSize: r,
  analyticsCompName: u
}) => $6(t) ? /* @__PURE__ */ E(z6, { wrapper: n, children: /* @__PURE__ */ E(
  Bt,
  {
    as: "div",
    className: j6.getElementClassName("content"),
    content: t,
    customWrapper: kr({ size: r ?? "Body" }),
    analyticsCompName: u,
    analyticsTextSection: e
  }
) }) : null;
const cc = ({
  section: e,
  content: t,
  wrapper: n,
  textSize: r,
  analyticsCompName: u,
  ...i
}) => !i.shouldEqualizeHeight && !$6(t) ? null : /* @__PURE__ */ ue(z6, { wrapper: n, children: [
  i.shouldEqualizeHeight && /* @__PURE__ */ E(
    mg,
    {
      section: e,
      content: i.contentEq,
      wrapper: ({ children: a }) => /* @__PURE__ */ E(
        "span",
        {
          className: j6.getElementClassName("content-equalizer"),
          "aria-hidden": !0,
          children: a
        }
      ),
      textSize: r,
      analyticsCompName: u
    }
  ),
  /* @__PURE__ */ E(
    mg,
    {
      section: e,
      content: t,
      textSize: r,
      analyticsCompName: u
    }
  )
] }), IR = "DataItemProvider", U6 = Yn({
  someSiblingsHaveTitle: !1,
  longestTitle: {
    text: ""
  }
}), q6 = ({
  children: e,
  siblingDataItems: t
}) => {
  const n = t.some(
    (i) => !!i.title
  ), r = t.reduce(
    (i, a) => {
      if (!a.title)
        return i;
      const o = X0(a.title), s = o.length;
      return s > i.text.length ? { content: a.title, text: o, length: s } : i;
    },
    { content: void 0, text: "" }
  ), u = $e(
    () => ({
      longestTitle: r,
      someSiblingsHaveTitle: n
    }),
    [r, n]
  );
  return /* @__PURE__ */ E(U6.Provider, { value: u, children: e });
};
q6.displayName = IR;
const MR = () => ke(U6);
const Q0 = "DataItem", kt = new ye(Q0), G6 = ({
  className: e,
  numberGroup: t,
  title: n,
  caption: r,
  text: u,
  textSize: i = "Body",
  topBorder: a = !0,
  bottomBorder: o = !1,
  tooltip: s = "",
  topSpacer: c = !0,
  bottomSpacer: l = !0,
  indent: d = "Flexible",
  alignment: f = "Start",
  actionGroup: p,
  analyticsCompName: h = Q0,
  dataType: m = "Pricing"
}) => {
  const { someSiblingsHaveTitle: b, longestTitle: x } = MR(), [y] = Ur(["Below LG"]), g = U(
    kt.getComponentClassName(),
    kt.getElementClassName(d),
    kt.getElementClassName(f),
    kt.getElementClassName(`${m}-variant`),
    {
      [kt.getElementClassName("borderTop")]: a,
      [kt.getElementClassName("borderBottom")]: o,
      [kt.getElementClassName("topSpacer")]: c,
      [kt.getElementClassName("bottomSpacer")]: l
    },
    e
  ), S = X0(n) === x.text, _ = m === "Metric", k = b && (!n || !S) && (_ ? f === "Center" && y || d === "Column" && !y : !0), T = _ && t ? NR(t.size) : t == null ? void 0 : t.size;
  return /* @__PURE__ */ ue("div", { className: g, children: [
    /* @__PURE__ */ E("div", { className: kt.getElementClassName("wrapper-number-group"), children: t && _ && /* @__PURE__ */ E(
      al,
      {
        ...t,
        analyticsCompName: h,
        className: kt.getElementClassName("metricNumberGroup"),
        affixSize: T
      }
    ) }),
    /* @__PURE__ */ ue("div", { className: kt.getElementClassName("content"), children: [
      /* @__PURE__ */ ue("div", { className: kt.getElementClassName("group"), children: [
        /* @__PURE__ */ E(
          cc,
          {
            section: "title",
            shouldEqualizeHeight: k,
            content: n,
            contentEq: x.content,
            wrapper: ({ children: L }) => /* @__PURE__ */ E(
              "div",
              {
                className: U(kt.getElementClassName("title"), {
                  "hide-spacing": !r
                }),
                children: L
              }
            ),
            textSize: i === "Body" ? "Body Bold" : "Caption Bold",
            analyticsCompName: h
          }
        ),
        t && /* @__PURE__ */ E(
          al,
          {
            ...t,
            analyticsCompName: h,
            className: U(kt.getElementClassName("numberGroup"), {
              "hide-spacing": !r
            }),
            affixSize: T
          }
        ),
        /* @__PURE__ */ E(
          cc,
          {
            section: "caption",
            shouldEqualizeHeight: !1,
            content: r,
            wrapper: ({ children: L }) => /* @__PURE__ */ E("div", { className: kt.getElementClassName("caption"), children: L }),
            textSize: i,
            analyticsCompName: h
          }
        )
      ] }),
      u && /* @__PURE__ */ ue(
        "div",
        {
          className: U(kt.getElementClassName("text"), {
            "hide-spacing": !n && !r
          }),
          children: [
            /* @__PURE__ */ E(
              cc,
              {
                section: "text",
                shouldEqualizeHeight: !1,
                content: u,
                textSize: i,
                analyticsCompName: h
              }
            ),
            s && /* @__PURE__ */ E(
              B6,
              {
                description: s,
                theme: "v3",
                className: kt.getElementClassName("tooltipIcon"),
                tooltipClassName: "tooltip",
                imagePosition: "bottom-left"
              }
            )
          ]
        }
      )
    ] }),
    p && /* @__PURE__ */ E(q0, { ...p, analyticsCompName: h })
  ] });
};
G6.displayName = Q0;
function PR(e, t = 300) {
  let n = 0;
  return (...r) => {
    let u;
    return clearTimeout(n), n = setTimeout(() => {
      u = e(...r);
    }, t), u;
  };
}
const Zo = () => typeof window < "u", WH = () => {
  if (!Zo() || !window.laDataLayer)
    return {};
  const { url: e = "", leadGenParam: t = "", tsrc: n = "" } = window.laDataLayer, r = ["/enterprise", "braintree"].some(
    (i) => n.includes(i)
  );
  return e.includes("/enterprise/contact-sales") && t === "" && r ? { leadGenParam: "utm_source=braintree", url: e, tsrc: n } : { leadGenParam: t, url: e, tsrc: n };
}, KH = (e) => {
  var t, n, r, u;
  return !Zo() || !window.PAYPAL ? {} : (u = (r = (n = (t = window.PAYPAL) == null ? void 0 : t.analytics) == null ? void 0 : n.instance) == null ? void 0 : r.record) == null ? void 0 : u.call(r, e);
}, YH = () => {
  if (!Zo() || !window.fpti)
    return {};
  const { page: e, pgrp: t, comp: n, ccpg: r, rsta: u } = window.fpti;
  return {
    page: e,
    pgrp: t,
    comp: n,
    ccpg: r,
    rsta: u
  };
}, ZH = () => {
  if (!Zo() || !document.cookie)
    return "";
  const e = /(?:^|;\s*)gclid=([^;]*)/.exec(document.cookie);
  return !e || !e[1] ? "" : e[1];
};
var ao = /* @__PURE__ */ ((e) => (e.Green = "Green", e.Purple = "Purple", e.Grey = "Grey", e.Gold = "Gold", e.Blue = "Blue", e.Black = "Black", e.White = "White", e.Yellow200 = "Yellow200", e.Yellow300 = "Yellow300", e))(ao || {}), Pa = /* @__PURE__ */ ((e) => (e.Checkmark = "Checkmark", e.Dash = "Dash", e))(Pa || {});
const RR = "Checkmark", gg = new ye(RR), W6 = ({ color: e = "Gold", ariaLabel: t, fontSize: n = "Body" }) => {
  const r = U(
    gg.getComponentClassName(),
    e,
    gg.getPropsValueClassName("size", n)
  );
  return /* @__PURE__ */ ue(
    "svg",
    {
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      className: r,
      "aria-label": t,
      children: [
        /* @__PURE__ */ E("circle", { cx: "12", cy: "12", r: "12", fill: "#EDEDED" }),
        /* @__PURE__ */ E(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M16.6551 8.51722C17.0724 8.878 17.1174 9.50779 16.7556 9.92389L11.5533 15.907C11.3634 16.1255 11.0877 16.251 10.7978 16.251C10.5078 16.251 10.2321 16.1255 10.0422 15.907L7.24446 12.6892C6.88267 12.2731 6.92765 11.6433 7.34493 11.2825C7.76222 10.9218 8.39378 10.9666 8.75557 11.3827L10.7978 13.7316L15.2445 8.61739C15.6063 8.20129 16.2378 8.15644 16.6551 8.51722Z",
            fill: "#515354"
          }
        )
      ]
    }
  );
}, BR = ({ ariaLabel: e }) => /* @__PURE__ */ E(
  "svg",
  {
    width: "21",
    height: "2",
    viewBox: "0 0 21 2",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: "dash",
    "aria-label": e,
    children: /* @__PURE__ */ E("path", { d: "M2 2L18.0578 1.99976", strokeWidth: "21", strokeLinecap: "round" })
  }
), K6 = "FeatureList", Mi = new ye(K6), FR = (e, t) => t ? {
  ...e,
  content: [
    {
      ...e.content[0],
      content: [...e.content[0].content.slice(0, t)]
    }
  ]
} : e, HR = (e) => {
  const t = Ou.toArray(e);
  let n = "";
  return t.forEach((r) => {
    if (typeof r == "string")
      n += r;
    else if (typeof r == "object" && Pi(r) && r.type === "a") {
      const u = r.props.children || "", i = r.props.href || "";
      n += `<a href="${i}">${u}</a>`;
    }
  }), n;
}, bg = ({ checkmarkColor: e, fontSize: t = "Body", children: n }) => /* @__PURE__ */ ue("li", { className: Mi.getElementClassName("item"), children: [
  /* @__PURE__ */ E(
    "span",
    {
      className: Mi.getElementClassName("item-bullet"),
      "aria-hidden": !0,
      children: /* @__PURE__ */ E(
        W6,
        {
          color: e,
          fontSize: t,
          ariaLabel: "checkmark-icon"
        }
      )
    }
  ),
  n
] }), $R = ({
  ulClassName: e,
  analyticsCompName: t,
  checkmarkColor: n,
  fontSize: r
}) => ({
  oldContentRenderer: {
    ul: (u, i) => /* @__PURE__ */ E("ul", { className: e, children: i }),
    li: (u, i, a) => /* @__PURE__ */ E(
      bg,
      {
        checkmarkColor: n,
        fontSize: r,
        children: /* @__PURE__ */ E(
          _0,
          {
            as: "p",
            customWrapper: kr({ size: r }),
            className: Mi.getElementClassName("item-text"),
            content: HR(i),
            analyticsCompName: t,
            analyticsTextSection: "listItemParagraph"
          }
        )
      },
      `feature-${a + 1}`
    )
  },
  newContentRenderer: {
    ul: (u, { children: i }) => /* @__PURE__ */ E("ul", { className: e, children: i }),
    li: (u, { children: i, ...a }) => /* @__PURE__ */ E(bg, { checkmarkColor: n, fontSize: r, children: /* @__PURE__ */ E(
      Qt,
      {
        as: "p",
        size: r,
        className: Mi.getElementClassName("item-text"),
        ...a,
        children: i
      }
    ) })
  }
});
const Y6 = ({
  list: e,
  checkmarkColor: t,
  className: n = "",
  analyticsCompName: r,
  maxItems: u,
  fontSize: i
}) => {
  const { environment: { theme: a = "" } = {} } = nt(), o = a === "quantumLeap" ? ao.Blue : ao.Gold, s = FR(e, u), c = $R({
    ulClassName: U(Mi.getComponentClassName(), n),
    analyticsCompName: r,
    checkmarkColor: t ?? o,
    fontSize: i
  });
  return /* @__PURE__ */ E(
    Bt,
    {
      content: s,
      htmlOverridesMapper: c,
      analyticsCompName: r,
      analyticsTextSection: "listItemParagraph"
    }
  );
};
Y6.displayName = K6;
const Z6 = "ScreenReaderContent", VR = new ye(Z6), jR = ({
  as: e = "div",
  className: t,
  children: n,
  ...r
}) => {
  const u = U(VR.getComponentClassName(), t);
  return /* @__PURE__ */ E(e, { className: u, ...r, children: n });
};
jR.displayName = Z6;
const zR = (e) => {
  const [t, n] = me({
    width: 0,
    height: 600
  });
  return oe(() => {
    if (e.current) {
      const r = new ResizeObserver(
        (u) => {
          u.forEach((i) => {
            const { width: a, height: o } = i.contentRect;
            n({ width: a, height: o });
          });
        }
      );
      return r.observe(e.current), () => {
        r.disconnect();
      };
    }
  }, [e]), t;
}, UR = ({
  onDraw: e,
  keyframes: t,
  scrollYProgress: n,
  springConfig: r,
  canvasParentRef: u
}) => {
  const i = Z(null);
  let a = sr(0);
  n && (a = n);
  const o = v5(n, r);
  r && (a = o);
  const { width: s, height: c } = zR(u), l = Ct(() => {
    const f = i.current || {};
    f.width = s ?? 0, f.height = c ?? 0;
  }, [c, s]), d = Ct(
    (f) => {
      var h;
      const p = (m, b = 0, x = t.length - 1) => Math.min(Math.max(m, b), x);
      if (t.length > 0) {
        const m = p(Math.round(t.length * f));
        e(
          t[m],
          (h = i.current) == null ? void 0 : h.getContext("2d")
        );
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [t]
  );
  return Gn(() => {
    l(), d((a == null ? void 0 : a.get()) || 0);
    const f = () => {
      l(), d((a == null ? void 0 : a.get()) || 0);
    };
    return window.addEventListener("resize", f), () => {
      window.removeEventListener("resize", f);
    };
  }, [a, d, l, t]), Gn(() => {
    t.length > 0 && (t[0].onload = () => {
      var f;
      e(
        t[0],
        (f = i.current) == null ? void 0 : f.getContext("2d")
      );
    });
  }, [t]), xi(
    a,
    "change",
    (f) => d(f || 0)
  ), [i];
}, qR = "image-sequence-canvas-container", GR = (e) => {
  const t = new Image();
  return t.src = e, t;
}, WR = (e, t) => {
  const { canvas: n } = t, r = n.width / e.width, u = n.height / e.height, i = Math.max(r, u), a = (n.width - e.width * i) / 2, o = (n.height - e.height * i) / 2;
  t.clearRect(0, 0, n.width, n.height), t.imageSmoothingEnabled = !0, t.imageSmoothingQuality = "high", t.drawImage(
    e,
    0,
    0,
    e.width,
    e.height,
    a,
    o,
    e.width * i,
    e.height * i
  );
}, KR = (e = "", t = 0) => {
  const n = new RegExp(`(.+)(\\d{${t}})\\.([^\\/]+)`), r = e.match(n);
  if (r) {
    const [u, i, a] = r.slice(1);
    return {
      baseUrl: u,
      numbers: i,
      imageExtFormat: a
    };
  }
  return {
    baseUrl: e,
    numbers: "00000",
    imageExtFormat: "png"
  };
}, YR = ({
  url: e = "",
  width: t = 300,
  totalFrames: n = 0,
  padStart: r = 0,
  reducedMotionFrame: u = "first",
  isMotionDisabled: i = !1
}) => {
  const a = KR(e, r), { baseUrl: o = "", imageExtFormat: s = "" } = a, c = i ? 1 : n;
  return [...new Array(c)].map((l, d) => {
    let f = d;
    i && (f = u === "first" ? 0 : n - 1);
    const p = Y0({
      src: `${o}${f.toString().padStart(r, "0")}.${s}`,
      qual: 75,
      width: t,
      format: "webp"
    }), h = GR(p);
    return d === 0 && (h.loading = "eager", h.fetchPriority = "high"), new Promise((m, b) => {
      h.onload = () => m(h), h.onerror = () => b(h);
    });
  });
};
const X6 = "ImageSequence", vg = new ye(X6), Q6 = ({
  scrollYProgress: e,
  className: t,
  motionStyle: n = {},
  padStart: r = 5,
  mdImage: u = "",
  tabletImage: i = "",
  baseImage: a = "",
  frameCount: o = 0,
  rootMarginIntersectionObserver: s = "800px 0px",
  springConfig: c,
  disableMotion: l = !1,
  imageAltText: d = "",
  reducedMotionFrame: f = "first",
  loading: p = "lazy",
  isImageDecorative: h = !1,
  imageServerKnobs: m = {},
  ...b
}) => {
  const x = $4(vg.getComponentClassName(), t), { viewportType: y } = Fu(), [g, v] = Ur([
    "Below MD",
    "Below LG"
  ]), S = y === "md", _ = !v, k = hr() || l, { inView: T, ref: L } = zi(
    K0({
      rootMargin: (
        // If intersectionRootMargin is provided from the server, it takes precedence
        // as it means this component is placed near to the top of the page
        (m == null ? void 0 : m.intersectionRootMargin) || s
      )
    })
  ), w = Z(null), [D, N] = me([]), [O, H] = me([]), [$, j] = me([]), z = (V = "", I = 300) => ({
    url: V,
    width: I,
    totalFrames: o,
    padStart: r,
    reducedMotionFrame: f,
    isMotionDisabled: k
  }), M = async (V, I = "", G = 1200) => {
    const K = YR(z(I, G)), [Q] = K, ae = K.slice(1, K.length);
    try {
      const X = await Q;
      V([X]);
      try {
        const ne = await Promise.all(ae);
        V([X, ...ne]);
      } catch {
        V([X]);
      }
    } catch {
      V([]);
    }
  };
  oe(() => {
    (T || p === "eager") && (g && $.length === 0 && M(j, a, 1200), S && O.length === 0 && M(H, i || a, 1500), _ && D.length === 0 && M(N, u || a, 1800));
  }, [g, T, S, p]);
  const P = () => g ? $ : S ? O : D, C = Ct(
    (V) => {
      w.current = V, L(V);
    },
    [L]
  ), [R] = UR({
    onDraw: WR,
    keyframes: P(),
    scrollYProgress: e,
    springConfig: c,
    canvasParentRef: w
  });
  return /* @__PURE__ */ E(
    Rr.div,
    {
      className: x,
      role: "img",
      style: n,
      ref: C,
      id: qR,
      "aria-label": d,
      "aria-hidden": h,
      ...b,
      children: /* @__PURE__ */ E(
        "canvas",
        {
          ref: R,
          className: vg.getElementClassName("canvas")
        }
      )
    }
  );
};
Q6.displayName = X6;
const J6 = "MediaControl", ft = new ye(J6), ol = at(
  ({
    className: e,
    playing: t,
    size: n = "Large",
    inverse: r = !1,
    outline: u = !1,
    videoId: i = "",
    analyticsCompName: a,
    analyticsVideoText: o = "video",
    playAriaLabel: s = "Play video",
    pauseAriaLabel: c = "Pause video",
    hasAriaPopup: l = !1,
    mediaClick: d
  }, f) => {
    const { environment: { pageSegment: p = "" } = {} } = nt(), h = t ? c : s, m = t ? "Started" : "Stopped", b = r && u, x = a3(
      a ? `${a}-media` : "media",
      o,
      i,
      m,
      p
    ), y = U(
      e,
      ft.getElementClassName("wrapper"),
      {
        [ft.getElementClassName("wrapper-inverse")]: r,
        [ft.getElementClassName("wrapper-outline")]: u
      },
      ft.getPropsValueClassName("wrapperSize", n)
    ), g = () => {
      const T = U(
        ft.getElementClassName("play-svg"),
        ft.getPropsValueClassName("playSvg", n)
      ), L = U(ft.getElementClassName("circle"), {
        [ft.getElementClassName("circle-inverse")]: r
      }), w = U({
        [ft.getElementClassName("triangle-inverse")]: r
      });
      return /* @__PURE__ */ ue(
        "svg",
        {
          className: T,
          viewBox: "0 0 80 81",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg",
          children: [
            /* @__PURE__ */ E(
              "path",
              {
                className: L,
                d: "M0 40.5122C0 18.4208 17.9086 0.512207 40 0.512207V0.512207C62.0914 0.512207 80 18.4208 80 40.5122V40.5122C80 62.6036 62.0914 80.5122 40 80.5122V80.5122C17.9086 80.5122 0 62.6036 0 40.5122V40.5122Z",
                fill: "#003087"
              }
            ),
            /* @__PURE__ */ E(
              "path",
              {
                className: w,
                d: "M29.3164 50.4622V32.1643C29.3164 28.8916 32.9162 26.8965 35.6914 28.631L50.3297 37.7799C52.9409 39.4119 52.9409 43.2146 50.3297 44.8466L35.6914 53.9955C32.9162 55.73 29.3164 53.7349 29.3164 50.4622Z",
                fill: "white"
              }
            )
          ]
        }
      );
    }, v = () => {
      const T = U(
        ft.getElementClassName("play-svg"),
        ft.getPropsValueClassName("playSvg", n)
      ), L = U(ft.getElementClassName("circle"), {
        [ft.getElementClassName("circle-inverse")]: r
      }), w = U({
        [ft.getElementClassName("triangle-inverse")]: r
      });
      return /* @__PURE__ */ ue(
        "svg",
        {
          className: T,
          viewBox: "0 0 80 81",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg",
          children: [
            /* @__PURE__ */ E(
              "path",
              {
                className: L,
                d: "M0 40.5122C0 18.4208 17.9086 0.512207 40 0.512207C62.0914 0.512207 80 18.4208 80 40.5122C80 62.6036 62.0914 80.5122 40 80.5122C17.9086 80.5122 0 62.6036 0 40.5122Z",
                fill: "#003087"
              }
            ),
            /* @__PURE__ */ E(
              "path",
              {
                className: w,
                d: "M35.191 27.9797H35.5115C37.0161 27.9797 38.2359 29.1073 38.2359 30.4983V52.1279C38.2359 53.5188 37.0161 54.6464 35.5115 54.6464H35.191C33.6864 54.6464 32.4666 53.5188 32.4666 52.1279V30.4983C32.4666 29.1073 33.6864 27.9797 35.191 27.9797ZM46.0884 27.9797H46.4089C47.9136 27.9797 49.1333 29.1073 49.1333 30.4983V52.1279C49.1333 53.5188 47.9136 54.6464 46.4089 54.6464H46.0884C44.5838 54.6464 43.3641 53.5188 43.3641 52.1279V30.4983C43.3641 29.1073 44.5838 27.9797 46.0884 27.9797Z",
                fill: "white"
              }
            )
          ]
        }
      );
    }, A = t ? (() => {
      const T = U(
        ft.getElementClassName("play-svg-outline"),
        {
          [ft.getElementClassName("play-svg-outline-inverse")]: b
        },
        ft.getPropsValueClassName("playSvg", n)
      );
      return /* @__PURE__ */ ue(
        "svg",
        {
          className: T,
          viewBox: "0 0 80 80",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg",
          children: [
            /* @__PURE__ */ E(
              "path",
              {
                d: "M35.191 27.4675H35.5115C37.0161 27.4675 38.2359 28.5951 38.2359 29.986V51.6157C38.2359 53.0066 37.0161 54.1342 35.5115 54.1342H35.191C33.6864 54.1342 32.4666 53.0066 32.4666 51.6157V29.986C32.4666 28.5951 33.6864 27.4675 35.191 27.4675ZM46.0884 27.4675H46.4089C47.9136 27.4675 49.1333 28.5951 49.1333 29.986V51.6157C49.1333 53.0066 47.9136 54.1342 46.4089 54.1342H46.0884C44.5838 54.1342 43.3641 53.0066 43.3641 51.6157V29.986C43.3641 28.5951 44.5838 27.4675 46.0884 27.4675Z",
                fill: "#001435"
              }
            ),
            /* @__PURE__ */ E(
              "path",
              {
                d: "M40 78C19.0132 78 2 60.9868 2 40H-2C-2 63.196 16.804 82 40 82V78ZM78 40C78 60.9868 60.9868 78 40 78V82C63.196 82 82 63.196 82 40H78ZM40 2C60.9868 2 78 19.0132 78 40H82C82 16.804 63.196 -2 40 -2V2ZM40 -2C16.804 -2 -2 16.804 -2 40H2C2 19.0132 19.0132 2 40 2V-2Z",
                fill: "#001435"
              }
            )
          ]
        }
      );
    })() : (() => {
      const T = U(
        ft.getElementClassName("play-svg-outline"),
        {
          [ft.getElementClassName("play-svg-outline-inverse")]: b
        },
        ft.getPropsValueClassName("playSvg", n)
      );
      return /* @__PURE__ */ ue(
        "svg",
        {
          className: T,
          viewBox: "0 0 80 80",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg",
          children: [
            /* @__PURE__ */ E(
              "path",
              {
                d: "M40 78C19.0132 78 2 60.9868 2 40H-2C-2 63.196 16.804 82 40 82V78ZM78 40C78 60.9868 60.9868 78 40 78V82C63.196 82 82 63.196 82 40H78ZM40 2C60.9868 2 78 19.0132 78 40H82C82 16.804 63.196 -2 40 -2V2ZM40 -2C16.804 -2 -2 16.804 -2 40H2C2 19.0132 19.0132 2 40 2V-2Z",
                fill: "#001435"
              }
            ),
            /* @__PURE__ */ E(
              "path",
              {
                d: "M29.3164 49.95V31.6521C29.3164 28.3794 32.9162 26.3843 35.6914 28.1188L50.3297 37.2677C52.9409 38.8997 52.9409 42.7024 50.3297 44.3344L35.6914 53.4833C32.9162 55.2178 29.3164 53.2227 29.3164 49.95Z",
                fill: "#001435"
              }
            )
          ]
        }
      );
    })(), k = t ? v() : g();
    return /* @__PURE__ */ E(
      "button",
      {
        ref: f,
        "aria-label": h,
        "aria-haspopup": l,
        type: "button",
        "data-pa-click": a && x,
        className: y,
        onClick: d,
        children: u ? A : k
      }
    );
  }
);
ol.displayName = J6;
const sl = (e) => {
  const t = localStorage.getItem(e);
  return t !== null ? JSON.parse(t) : {};
}, e4 = (e, t = "pp-com-youtubeData") => {
  localStorage.setItem(t, JSON.stringify(e));
}, J0 = () => typeof window < "u", XH = (e, t) => {
  if (!(!e || !J0()))
    try {
      localStorage.setItem(e, JSON.stringify(t));
    } catch (n) {
      console.error(`Failed to set local storage (key: ${e}):`, n);
    }
}, QH = (e) => {
  if (!e || !J0())
    return null;
  try {
    const t = localStorage.getItem(e);
    if (!t)
      return null;
    try {
      return JSON.parse(t);
    } catch {
      return t;
    }
  } catch (t) {
    return console.error(`Failed to get local storage (key: ${e}):`, t), null;
  }
}, JH = (e) => {
  if (!(!e || !J0()))
    try {
      localStorage.removeItem(e);
    } catch (t) {
      console.error(`Failed to remove local storage (key: ${e}):`, t);
    }
}, yg = (e = []) => e.map(({ src: n, type: r }) => /* @__PURE__ */ E("source", { src: n, type: r }, n)), ZR = (e = "pp-com-youtubeData") => {
  const t = sl(e);
  let n = {};
  Object.keys(t).length && (Object.keys(t).forEach((r) => {
    const u = (/* @__PURE__ */ new Date()).getTime() > t[r], i = { [r]: t[r] };
    u || (n = { ...n, ...i });
  }), e4(n, e));
}, XR = () => /* @__PURE__ */ E(
  "svg",
  {
    width: "19",
    height: "18",
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ E(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M8.18958 11.4746L13.7066 4.28484C14.0428 3.84668 14.6706 3.76404 15.1087 4.10026C15.5469 4.43647 15.6295 5.06422 15.2933 5.50237L9.07272 13.609C8.70169 14.0926 7.98811 14.1346 7.56292 13.6979L4.21323 10.2578C3.82794 9.86208 3.83637 9.22897 4.23206 8.84369C4.62775 8.4584 5.26086 8.46683 5.64615 8.86252L8.18958 11.4746Z",
        fill: "#545D68"
      }
    )
  }
);
const ed = "VideoCard", $n = new ye(ed), t4 = ({
  className: e = "",
  analyticsCompName: t = ed,
  title: n,
  posterImage: r,
  videoPlayedLabel: u = "",
  duration: i,
  youTubeId: a,
  ariaLabel: o,
  videoPlayed: s = !1,
  playYouTubeVideo: c,
  serverFptiData: l
}) => {
  const { environment: { pageSegment: d = "" } = {} } = nt(), f = U(
    $n.getComponentClassName(),
    Or.getThemeClassName("white"),
    e
  ), p = U($n.getElementClassName("wrapper")), h = Ht(
    {
      componentName: t,
      linkText: n,
      linkType: jr.Tertiary,
      ariaLabel: o,
      serverFptiData: l
    },
    d,
    yt.CTA
  ), { viewportType: m } = Fu(), b = ["xs", "sm", "md", "lg"].includes(m);
  if (!a)
    return null;
  const x = () => s ? `${o} ${u.toLowerCase()}.` : o, y = (g) => /* @__PURE__ */ ue("div", { className: $n.getElementClassName("thumbnail"), children: [
    s && /* @__PURE__ */ E("div", { className: $n.getElementClassName("overlay") }),
    /* @__PURE__ */ E(
      Yo,
      {
        ariaHidden: !0,
        ...g,
        dimensions: {
          minHeight: "auto",
          minWidth: "auto"
        },
        isAnimated: !1
      }
    ),
    w3()
  ] });
  return /* @__PURE__ */ E(
    Vr,
    {
      as: "button",
      type: "button",
      "aria-label": x(),
      onClick: () => c(a),
      "data-pa-click": t && h,
      className: f,
      motionOptions: p9,
      isAnimated: !1,
      children: /* @__PURE__ */ E("div", { className: p, children: /* @__PURE__ */ ue("div", { className: $n.getElementClassName("container"), children: [
        y(r),
        /* @__PURE__ */ ue("div", { className: $n.getElementClassName("content"), children: [
          b ? /* @__PURE__ */ E(
            Qt,
            {
              as: "h6",
              size: "Body Bold",
              className: $n.getElementClassName("text"),
              children: n
            }
          ) : /* @__PURE__ */ E(
            dr,
            {
              as: "h6",
              size: "Headline 6",
              className: $n.getElementClassName("text"),
              children: n
            }
          ),
          /* @__PURE__ */ ue("div", { className: $n.getElementClassName("info"), children: [
            s && /* @__PURE__ */ ue(Qt, { size: "Caption", as: "span", children: [
              XR(),
              u
            ] }),
            i && /* @__PURE__ */ E(Qt, { size: "Caption", as: "p", children: i })
          ] })
        ] })
      ] }) })
    }
  );
};
t4.displayName = ed;
const n4 = "EndCardCollection", ei = new ye(n4), r4 = ({
  className: e = "",
  headline: t,
  replayButton: n,
  returnButton: r,
  collection: u,
  youTubeId: i,
  playedVideosExpiry: a = 30,
  hideModal: o
}) => {
  const s = "pp-com-youtubeData", { foundationTheme: c, foundationColor: l } = ke(yn), d = U(
    e,
    ei.getComponentClassName(),
    c,
    l
  ), f = U(
    ei.getElementClassName("redirect-links"),
    Or.getThemeClassName("blue 600")
  ), [p, h] = me(""), m = Z(i), b = Z(), { viewportType: x } = Fu(), y = ["xs", "sm", "md"].includes(x), g = Object.keys(sl(s));
  oe(() => {
    ZR(s);
  }, []);
  const v = (A) => {
    m.current = A;
    const k = (/* @__PURE__ */ new Date()).setDate(
      (/* @__PURE__ */ new Date()).getDate() + a
    ), T = { [A]: k }, w = { ...sl(s), ...T };
    e4(w, s), h("");
  }, S = (A) => /* @__PURE__ */ E(
    T0,
    {
      roundedStyle: !0,
      videoId: A,
      onReady: (k) => {
        b.current = k;
      },
      onStateChange: (k) => {
        (k === Ir.UNSTARTED || k === Ir.ENDED) && v(A);
      }
    }
  ), _ = () => /* @__PURE__ */ ue("div", { className: f, children: [
    n && /* @__PURE__ */ E(
      U0,
      {
        ...n,
        iconType: "Replay",
        className: ei.getElementClassName("replay"),
        onClick: () => h(m.current)
      }
    ),
    r && /* @__PURE__ */ E(
      Ko,
      {
        as: "button",
        ...r,
        onClick: () => o && o()
      }
    )
  ] });
  return p ? S(p) : /* @__PURE__ */ ue("div", { className: d, children: [
    !y && _(),
    /* @__PURE__ */ ue("div", { className: ei.getElementClassName("main-content"), children: [
      t && /* @__PURE__ */ E(
        dr,
        {
          className: ei.getElementClassName("header"),
          as: "h6",
          size: "Title",
          children: t
        }
      ),
      u && u.map((A, k) => /* @__PURE__ */ E(
        t4,
        {
          ...A,
          playYouTubeVideo: h,
          videoPlayed: g.includes(A.youTubeId)
        },
        `card-${k + 1}`
      ))
    ] }),
    y && _()
  ] });
};
r4.displayName = n4;
const u4 = (e) => typeof e == "function", QR = (e) => (...t) => {
  u4(e) && e(...t);
}, JR = ({
  isReducedMotion: e,
  autoplay: t,
  videoName: n
}) => {
  const r = Z(null), [u, i] = me(!1), [a, o] = me(!1), [s, c] = me(!1), l = (m) => {
    r.current && (m === "play" ? (r.current.play(), c(!0)) : m === "pause" && (r.current.pause(), c(!1)));
  }, d = Ct((m) => {
    m !== null && (r.current = m, i(!0), m.duration && o(!0));
  }, []), f = r == null ? void 0 : r.current, p = (f == null ? void 0 : f.duration) || 0, h = p && p > 5;
  return oe(() => {
    var b, x;
    if (!u || !a || !n)
      return;
    e && h || !t ? (c(!1), (b = r == null ? void 0 : r.current) == null || b.pause()) : (c(!0), (x = r == null ? void 0 : r.current) == null || x.play());
  }, [
    e,
    h,
    t,
    u,
    a,
    n
  ]), {
    videoRef: r,
    videoLoadRef: d,
    isLargeDuration: h,
    handleInlineVideoState: l,
    inlineVideoPlaying: s,
    setInlineVideoPlaying: c,
    hasVideoLoaded: u,
    setHasVideoLoaded: i,
    isVideoDurationAvailable: a,
    setIsVideoDurationAvailable: o
  };
}, ya = {
  unknown: "unknown",
  ended: "ended"
}, eB = ({
  autoplay: e,
  loop: t,
  videoName: n
}) => {
  const [r, u] = me(ya.unknown), [i, a] = me(
    n
  ), { inView: o, ref: s } = zi({
    threshold: 0.5,
    triggerOnce: !1
  }), c = () => {
    u(ya.ended);
  }, d = (() => e ? t ? o : (i && i !== n && (a(n), u(ya.unknown)), r !== ya.ended ? o : !1) : !!e)();
  return {
    videoRef: s,
    customAutoplay: d,
    handleEnded: c
  };
}, tB = ({
  baseVideoCollection: e,
  mdVideoCollection: t,
  imageUrlMobile: n,
  imageUrlDesktop: r,
  altTextMobile: u,
  altTextDesktop: i
}) => {
  var p, h;
  const { viewportType: a } = Fu(), o = ["xs", "sm"].includes(a);
  let s = [], c = "";
  if (!!t || !!e) {
    s = yg(o ? e : t || e);
    const m = (h = (p = s[0]) == null ? void 0 : p.props) == null ? void 0 : h.src;
    c = m == null ? void 0 : m.substring(m.lastIndexOf("/") + 1).replace(/\..+$/, "");
  }
  return {
    viewportType: a,
    videoName: c,
    videoContent: s,
    altTextLabel: o ? u : i,
    posterImageUrl: o ? n : r
  };
};
const i4 = "InlineVideo", nB = new ye(i4), a4 = at(
  ({
    className: e,
    onEnded: t,
    onPlaying: n,
    onLoadedMetadata: r,
    autoPlay: u = !1,
    loop: i = !0,
    posterImageUrl: a,
    ariaLabel: o,
    quality: s = 50,
    serverImgQs: c = "",
    preload: l,
    customVideoComponent: d,
    children: f,
    ...p
  }, h) => {
    const m = d ?? "video", b = U(e, nB.getComponentClassName()), x = {};
    return o && (x["aria-label"] = o), a && (x.poster = `${a}?quality=${s}${c}`), /* @__PURE__ */ ue(
      m,
      {
        className: b,
        playsInline: !0,
        muted: !0,
        onEnded: t,
        onPlaying: n,
        onLoadedMetadata: r,
        ref: h,
        autoPlay: u,
        loop: i,
        preload: l,
        ...x,
        ...p,
        children: [
          f,
          /* @__PURE__ */ E("track", { kind: "captions" })
        ]
      }
    );
  }
);
a4.displayName = i4;
const o4 = "InlineVideoOverlay", rB = new ye(o4), s4 = ({
  className: e
}) => {
  const t = U(e, rB.getComponentClassName());
  return /* @__PURE__ */ E("div", { className: t });
};
s4.displayName = o4;
const Xo = "VideoFrame", Vn = new ye(Xo), c4 = ({
  youTubeId: e,
  loading: t = "lazy",
  baseVideoCollection: n,
  // Mobile Video
  mdVideoCollection: r,
  // Desktop Video
  ariaLabelCloseButton: u,
  mediaControl: i,
  imageUrlDesktop: a,
  altTextDesktop: o,
  imageUrlMobile: s,
  altTextMobile: c,
  dimensions: l = {
    minHeight: "auto",
    minWidth: "auto"
  },
  autoplay: d = !0,
  loop: f = !0,
  inverse: p = !0,
  buttonStyle: h = "Outline",
  buttonText: m = "Watch the film",
  className: b,
  lazyLoadProps: x = {},
  lazyLoadWrapper: y,
  modalWrapper: g,
  overlay: v = !1,
  isReducedMotion: S = !1,
  endCardCollection: _,
  imageServerKnobs: A = {},
  modalAriaLabel: k,
  analyticsCompName: T = Xo,
  rootRef: L,
  onLoadedMetadata: w,
  preload: D,
  disableMediaControl: N = !1,
  customVideoComponent: O,
  ...H
}) => {
  const $ = Z(), { foundationTheme: j } = ke(yn), { mediaFrame: z } = O6(), { environment: { pageSegment: M = "" } = {} } = nt(), P = H.roundedCorners ?? z.roundedCorners, { isShowing: C, toggle: R } = E3(), [V, I] = me(!1), [G, K] = me(!1), { videoName: Q, videoContent: ae, altTextLabel: X, posterImageUrl: ne } = tB({
    baseVideoCollection: n,
    mdVideoCollection: r,
    imageUrlMobile: s,
    imageUrlDesktop: a,
    altTextMobile: c,
    altTextDesktop: o
  }), {
    videoRef: fe,
    customAutoplay: he,
    handleEnded: xe
  } = eB({
    autoplay: d,
    loop: f,
    videoName: Q
  }), {
    inlineVideoPlaying: re,
    setInlineVideoPlaying: Se,
    isLargeDuration: et,
    handleInlineVideoState: Le,
    videoLoadRef: rt,
    setIsVideoDurationAvailable: we
  } = JR({
    isReducedMotion: S,
    autoplay: he,
    videoName: Q
  }), Oe = !!r || !!n, {
    quality: Ce = 50,
    serverImgConfigs: Qe = {},
    intersectionRootMargin: ct
  } = A;
  let mt = "";
  Object.entries(Qe).forEach(([te, Me]) => {
    mt += `&${te}=${Me}`;
  });
  const Ot = a3(
    T ? `${T}-modal` : "modal",
    "component",
    "video",
    "Closed",
    M
  ), ve = () => V && _ ? /* @__PURE__ */ E(
    r4,
    {
      hideModal: R,
      youTubeId: e || "",
      ..._
    }
  ) : /* @__PURE__ */ E(
    T0,
    {
      roundedStyle: !0,
      videoId: e,
      onReady: (te) => {
        $.current = te;
      },
      onStateChange: (te) => {
        (te === Ir.UNSTARTED || te === Ir.ENDED) && I(!0);
      }
    }
  ), Nt = U(
    b,
    Vn.getComponentClassName(),
    Vn.getPropsValueClassName("roundedCorners", P)
  ), Vt = U(
    Vn.getElementClassName("controls-container"),
    {
      [Vn.getElementClassName("video-duration")]: et
    }
  ), lt = U(Vn.getElementClassName("body-text"), {
    [Vn.getElementClassName("button-text-inverse")]: p
  }), jt = Ct(
    (te) => {
      rt(te), fe(te), typeof L == "function" ? L(te) : L && "current" in L && (L.current = te);
    },
    [rt, fe, L]
  ), zt = () => {
    Se(!1), xe();
  }, It = () => {
    we(!0), u4(w) && w();
  }, J = /* @__PURE__ */ ue(on, { children: [
    /* @__PURE__ */ ue(
      "div",
      {
        className: U(
          Vn.getElementClassName("wrapper"),
          j,
          Vn.getPropsValueClassName(
            "wrapper-media-control-disable",
            N
          )
        ),
        onClick: () => {
          Le(re ? "pause" : "play");
        },
        role: "none",
        children: [
          v && /* @__PURE__ */ E(s4, {}),
          Oe && /* @__PURE__ */ E(
            a4,
            {
              ref: jt,
              onEnded: zt,
              onPlaying: () => Se(!0),
              onLoadedMetadata: It,
              autoPlay: !1,
              posterImageUrl: ne,
              loop: f,
              ariaLabel: X,
              serverImgQs: mt,
              preload: D,
              customVideoComponent: O,
              children: ae
            },
            Q
          ),
          !Oe && /* @__PURE__ */ E(
            "img",
            {
              alt: X,
              src: ne && `${ne}?quality=${Ce}${mt}`
            }
          ),
          e && /* @__PURE__ */ ue(
            "div",
            {
              className: Vn.getElementClassName(
                "mainControlsContainer"
              ),
              children: [
                /* @__PURE__ */ E(
                  ol,
                  {
                    playAriaLabel: i == null ? void 0 : i.playAriaLabel,
                    hasAriaPopup: !0,
                    size: "X-Large",
                    videoId: e,
                    inverse: p,
                    playing: G,
                    outline: !1,
                    mediaClick: () => {
                      Le("pause"), K(!G), R();
                    },
                    analyticsCompName: T
                  }
                ),
                /* @__PURE__ */ E(Qt, { className: lt, children: m })
              ]
            }
          ),
          Oe && !N && /* @__PURE__ */ E("div", { className: Vt, children: /* @__PURE__ */ E(
            ol,
            {
              mediaClick: () => {
                Le(re ? "pause" : "play");
              },
              videoId: Q,
              size: "Small",
              inverse: p,
              playing: re,
              outline: h === "Outline",
              playAriaLabel: i == null ? void 0 : i.playAriaLabel,
              pauseAriaLabel: i == null ? void 0 : i.pauseAriaLabel,
              analyticsCompName: T
            }
          ) })
        ]
      }
    ),
    /* @__PURE__ */ E(
      g,
      {
        isShowing: C,
        ariaLabel: k,
        hide: () => {
          R(), I(!1), K(!G);
        },
        ariaLabelCloseBtn: u,
        clickDataEventCloseBtn: Ot,
        children: ve()
      }
    )
  ] });
  if (t === "lazy") {
    const te = {
      className: Nt,
      containerDimensions: l,
      ...x,
      rootMargin: ct
    };
    return /* @__PURE__ */ E(y, { ...te, children: J });
  }
  return /* @__PURE__ */ E("div", { className: Nt, children: J });
};
c4.displayName = Xo;
const td = at(
  ({ motionOptions: e, ...t }, n) => {
    const r = hr();
    return /* @__PURE__ */ E(
      c4,
      {
        ...t,
        lazyLoadWrapper: N6,
        modalWrapper: w0,
        lazyLoadProps: {
          motionOptions: e
        },
        isReducedMotion: r,
        rootRef: n
      }
    );
  }
);
td.displayName = Xo;
const uB = ({
  isBelowMD: e,
  isBelowLG: t,
  mediaRatio: n,
  baseMediaRatio: r,
  mdMediaRatio: u
}) => e && r ? r : t && u ? u : n, iB = ({
  mediaRatio: e,
  baseMediaRatio: t,
  mdMediaRatio: n
}) => {
  const [r, u] = Ur(["Below MD", "Below LG"]);
  return uB({
    isBelowMD: r,
    isBelowLG: u,
    mediaRatio: e,
    baseMediaRatio: t,
    mdMediaRatio: n
  });
}, aB = {
  "media-frame-template-pill-shape": "_media-frame-template-pill-shape_582ut_1",
  "media-frame-template-media-ratio-1-1": "_media-frame-template-media-ratio-1-1_582ut_38",
  "media-frame-template-media-ratio-3-4": "_media-frame-template-media-ratio-3-4_582ut_47",
  "media-frame-template-media-ratio-4-3": "_media-frame-template-media-ratio-4-3_582ut_56",
  "media-frame-template-media-ratio-12-5": "_media-frame-template-media-ratio-12-5_582ut_65",
  "media-frame-template-media-ratio-16-9": "_media-frame-template-media-ratio-16-9_582ut_74"
}, oB = "MediaFrameTemplate", xg = new ye(oB, aB), sB = ({
  type: e,
  imageFramerWrapper: t,
  videoFrameWrapper: n,
  imageSequenceWrapper: r,
  roundedCorners: u,
  maxSrcSetWidth: i,
  mediaShape: a = "default",
  mediaRatio: o,
  baseMediaRatio: s,
  mdMediaRatio: c,
  className: l,
  rootRef: d,
  ...f
}) => {
  const p = iB({
    mediaRatio: o,
    baseMediaRatio: s,
    mdMediaRatio: c
  }), h = a === "pill-shape", m = h ? !1 : u, b = h ? void 0 : p, x = U(l, {
    [xg.getElementClassName("pill-shape")]: h,
    [xg.getPropsValueClassName(
      "media-ratio",
      b
    )]: b
  });
  if (e === "Image") {
    const { image: y, ...g } = f;
    return /* @__PURE__ */ E(
      t,
      {
        roundedCorners: m,
        maxSrcSetWidth: i,
        ...y,
        ...g,
        className: x,
        ref: d
      }
    );
  }
  if (e === "Video") {
    const { video: y, ...g } = f;
    return /* @__PURE__ */ E(
      n,
      {
        roundedCorners: m,
        ...y,
        ...g,
        className: x,
        ref: d
      }
    );
  }
  if (e === "ImageSequence") {
    const { imageSequence: y, ...g } = f;
    return /* @__PURE__ */ E(r, { ...y, ...g, className: x });
  }
  return null;
}, cB = "MediaFrame", nd = (e = {}) => /* @__PURE__ */ E(
  sB,
  {
    ...e,
    imageFramerWrapper: Yo,
    videoFrameWrapper: td,
    imageSequenceWrapper: Q6
  }
);
nd.displayName = cB;
const lB = "ChevronDownIcon", dB = new ye(lB), fB = ({
  ariaLabel: e = "",
  className: t = ""
}) => {
  const n = U(dB.getComponentClassName(), t);
  return /* @__PURE__ */ E(
    "svg",
    {
      width: "18",
      height: "18",
      viewBox: "0 0 18 18",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      "aria-hidden": !0,
      "aria-label": e,
      className: n,
      children: /* @__PURE__ */ E(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M4.29191 5.99309C4.68244 5.60257 5.3156 5.60256 5.70613 5.99309L8.9993 9.28624L12.2926 5.99308C12.6831 5.60256 13.3163 5.60257 13.7068 5.9931C14.0973 6.38363 14.0973 7.0168 13.7068 7.40732L9.71346 11.4005C9.31902 11.7949 8.67954 11.7949 8.28512 11.4005L4.29192 7.4073C3.90139 7.01678 3.90139 6.38362 4.29191 5.99309Z",
          fill: "currentColor"
        }
      )
    }
  );
}, pB = "ChevronUpIcon", hB = new ye(pB), mB = ({
  ariaLabel: e = "",
  className: t = ""
}) => {
  const n = U(hB.getComponentClassName(), t);
  return /* @__PURE__ */ E(
    "svg",
    {
      width: "18",
      height: "18",
      viewBox: "0 0 18 18",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      "aria-hidden": !0,
      "aria-label": e,
      className: n,
      children: /* @__PURE__ */ E(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M13.7081 11.4073C13.3176 11.7978 12.6844 11.7978 12.2939 11.4073L9.0007 8.11415L5.7074 11.4073C5.31687 11.7978 4.68371 11.7978 4.29319 11.4073C3.90267 11.0168 3.90268 10.3836 4.29322 9.99307L8.28654 5.9999C8.68098 5.60548 9.32046 5.6055 9.71488 5.99991L13.7081 9.99309C14.0986 10.3836 14.0986 11.0168 13.7081 11.4073Z",
          fill: "currentColor"
        }
      )
    }
  );
};
const gB = {
  "Chevron Up": mB,
  "Chevron Down": fB
}, l4 = "TruncateButton", bB = new ye(l4), d4 = ({
  text: e,
  iconType: t,
  className: n,
  ...r
}) => {
  const u = t ? gB[t] : null, i = U(bB.getComponentClassName(), n);
  return /* @__PURE__ */ ue("button", { type: "button", className: i, ...r, children: [
    /* @__PURE__ */ E(Qt, { as: "span", size: "Body Bold", children: e }),
    u && /* @__PURE__ */ E("span", { children: /* @__PURE__ */ E(u, {}) })
  ] });
};
d4.displayName = l4;
const _g = () => {
  let e = 16;
  if (typeof window < "u") {
    const n = document.getElementsByClassName("grid");
    if (n.length > 0) {
      const [r] = n, a = (getComputedStyle(r).getPropertyValue("column-gap") || "16").slice(0, -2);
      e = Number(a);
    }
  }
  return e;
};
var An = /* @__PURE__ */ ((e) => (e.left = "left", e.right = "right", e))(An || {});
const lc = (e) => {
  const t = { x: 0, y: 0 };
  return t.x = e instanceof MouseEvent ? e.clientX : e.changedTouches[0].clientX, t.y = e instanceof MouseEvent ? e.clientY : e.changedTouches[0].clientY, t;
}, vB = (e) => {
  var t;
  return e.current && ((t = e == null ? void 0 : e.current) == null ? void 0 : t.offsetWidth) / 3 || typeof window < "u" && window.innerWidth / 3;
}, yB = 150, xB = 500, Sg = "carousel-dragging-disables-on-click", _B = ({
  touchArea: e,
  threshold: t = vB(e),
  restraint: n = yB,
  allowedTime: r = xB,
  disableMouseDrag: u = !1,
  onTouchEnd: i,
  onTouchMove: a,
  onTouchStart: o
}) => {
  let s = 0, c = 0, l = 0, d = !1;
  const f = Z(t);
  f.current = t;
  const p = (b) => {
    d = !0;
    const x = lc(b);
    s = x.x, c = x.y, l = performance.now(), o && o();
  }, h = (b) => {
    var x, y;
    if (e.current && d && a) {
      const g = lc(b), v = g.x - s, S = g.y - c;
      if (v !== 0 && Math.abs(S) <= n && Math.abs(v) > Math.abs(S)) {
        const _ = (x = e.current) == null ? void 0 : x.children;
        for (let k = 0; k <= (_ == null ? void 0 : _.length); k += 1)
          (y = _[k]) == null || y.classList.add(Sg);
        const A = v < 0 ? "left" : "right";
        a(A, { x: Math.abs(v), y: 0 });
      }
    }
  }, m = (b) => {
    var S, _;
    const x = lc(b), y = x.x - s, g = x.y - c, v = performance.now() - l;
    if (e.current) {
      if (d && y !== 0 && i) {
        const A = (S = e.current) == null ? void 0 : S.children;
        for (let L = 0; L <= (A == null ? void 0 : A.length); L += 1)
          (_ = A[L]) == null || _.classList.remove(Sg);
        const k = y < 0 ? "left" : "right", T = (Math.abs(y) >= f.current || v <= r) && Math.abs(g) <= n;
        i(k, T);
      }
      d = !1;
    }
  };
  oe(() => {
    if (!e.current)
      return;
    const b = e.current;
    return b.addEventListener("touchstart", p, {
      passive: !0
    }), b.addEventListener("touchmove", h, {
      passive: !0
    }), b.addEventListener("touchend", m, {
      passive: !0
    }), u || (b.addEventListener("mousedown", p), b.addEventListener("mousemove", h), b.addEventListener("mouseup", m), b.addEventListener("mouseleave", m)), () => {
      b.removeEventListener("touchstart", p), b.removeEventListener("touchmove", h), b.removeEventListener("touchend", m), u || (b.removeEventListener("mousedown", p), b.removeEventListener("mousemove", h), b.removeEventListener("mouseup", m), b.removeEventListener("mouseleave", m));
    };
  }, [
    u,
    m,
    h,
    p,
    e
  ]);
}, xa = (e) => e.getBoundingClientRect(), rd = (e, t, n) => !e || !t || !n ? "" : e.replace("${item}", `${t}`).replace("${totalItems}", `${n}`), SB = (e) => {
  const {
    trackContainerRef: t,
    trackRef: n,
    isDocDirectionRTL: r,
    allSlides: u,
    hasNextSlide: i,
    hasPrevSlide: a,
    nextSlideIdx: o,
    transitionState: s,
    slidesPerPage: c,
    spacerWidth: l,
    singleSlideWidth: d,
    hasScaleAnimation: f,
    scaleAnimationConfig: p
  } = e;
  let h;
  const m = (L, w) => {
    if (L < 1 || L > w)
      return -1;
    let D = (L - 1) * c.current;
    return D + c.current >= u.current.length && (D = u.current.length - c.current), D;
  }, b = () => {
    const { current: L } = d, w = L && L > 0, { current: D } = t;
    if (!w || !D)
      return c.current;
    const N = D.getBoundingClientRect().width, O = _g(), H = Math.floor(N / L), $ = Math.floor(
      (N - (H - 1) * O) / L
    );
    return $ > 0 ? $ : 1;
  }, x = () => {
    const L = Math.ceil(
      u.current.length / c.current
    );
    return [Math.floor(o.current / c.current) + 1, L];
  }, y = () => {
    if (h && cancelAnimationFrame(h), n.current) {
      const L = n.current;
      L.style.transitionDuration = "0ms";
    }
  }, g = (L, w = 0) => {
    y();
    const D = () => {
      const N = n.current;
      N && (N.style.transitionDuration = `${w}ms`, N.style.transform = `translateX(${L}px)`, s.current === "inProgress" && requestAnimationFrame(D));
    };
    h = requestAnimationFrame(D);
  }, v = ({
    trackBox: L,
    moveByDistance: w,
    isSlidingToLastPage: D
  }) => {
    const { current: N } = p;
    return !r.current && f.current && (Math.abs(w) > Math.abs(L.left) ? "right" : "left") === "right" && !D ? w * ((N == null ? void 0 : N.scaleFactor) ?? 1) : w;
  };
  return {
    translateTrack: g,
    cancelAnimation: y,
    getNewPageValues: x,
    getNextSlideIdx: m,
    slideTo: ({ slideIdx: L, animationDuration: w = 0 }) => {
      const { current: D } = u, { current: N } = n, { current: O } = t, { current: H } = c, $ = D[L], j = xa(N), z = xa($);
      let M = r.current ? j.right - z.right : z.left - j.left;
      const P = L + H === D.length;
      P && (M = N.offsetWidth - O.offsetWidth), r.current || (M = -M);
      const C = v({
        trackBox: j,
        moveByDistance: M,
        isSlidingToLastPage: P
      });
      g(C, w);
    },
    resizeCarouselTrack: () => {
      const { current: L } = u, { current: w } = t, { current: D } = c, { current: N } = l, { current: O } = d, H = w && w.offsetWidth ? w.offsetWidth : 0, $ = _g(), j = O > 0, z = $ * (D - 1), P = `${(j ? O : (H - (z + N)) / D) / 16}rem`;
      w == null || w.style.setProperty("--slide-width", P), w == null || w.style.setProperty("--track-width", `${H}px`), L.forEach((C, R) => {
        const V = C;
        V.style.width = P, R > 0 && (V.style.marginInlineStart = `${$ / 16}rem`);
      });
    },
    getTrackTranslateX: () => {
      const L = xa(n.current), w = xa(t.current);
      return r.current ? L.right - w.right : L.left - w.left;
    },
    getVisibleSlideIndices: (L) => Array(c.current).fill(null).map((D, N) => {
      let O = (L - 1) * c.current;
      return u.current.length > 0 && O + c.current >= u.current.length && (O = u.current.length - c.current), O + N;
    }),
    doesSlideExist: (L) => {
      let w = !1;
      return r.current ? w = L === An.left && !a.current || L === An.right && !i.current : w = L === An.right && !a.current || L === An.left && !i.current, !w;
    },
    calcSlidesPerView: b
  };
};
const Qo = "Carousel", CB = ({
  className: e,
  ariaLabel: t,
  pageLabel: n,
  currentPage: r,
  totalPages: u,
  backgroundColor: i,
  disableCarousel: a = !1,
  children: o,
  ...s
}) => {
  const c = i3(i), l = U(
    "carousel",
    c,
    { "carousel-disabled": a },
    e
  ), d = n && rd(n, r, u);
  return /* @__PURE__ */ ue(
    "div",
    {
      "aria-label": t,
      role: "region",
      className: l,
      ...s,
      children: [
        o ? /* @__PURE__ */ E("div", { children: o }) : null,
        /* @__PURE__ */ E("span", { className: "carousel-notification", "aria-live": "polite", "aria-atomic": !0, children: d })
      ]
    }
  );
}, f4 = Te.forwardRef(({ className: e, children: t, hideOverflow: n, ...r }, u) => {
  const [i] = Ur(["Below MD"]), a = U(
    "carousel-track-container",
    e,
    {
      "hide-overflow": n && !i
    }
  );
  return /* @__PURE__ */ E("div", { className: a, ref: u, ...r, children: t });
});
f4.displayName = "CarouselTrackContainer";
const p4 = Te.forwardRef(
  ({ className: e, backgroundColor: t = "white", children: n, ...r }, u) => {
    const i = i3(t), a = U("carousel-track", i, e);
    return /* @__PURE__ */ E(
      "div",
      {
        role: "presentation",
        className: a,
        ref: u,
        ...r,
        children: n
      }
    );
  }
);
p4.displayName = "CarouselTrack";
const EB = ({
  className: e,
  slideLabel: t,
  isVisibleSlide: n,
  slideIdx: r,
  totalSlides: u,
  children: i,
  serverFptiData: a,
  ...o
}) => {
  const s = U("carousel-slide", e), { environment: { pageSegment: c = "" } = {} } = nt(), l = Ht(
    {
      componentName: Qo,
      linkText: "",
      clickEvent: Ki.CarouselSlideButton,
      serverFptiData: a
    },
    c,
    yt.CTA
  ), d = rd(
    t,
    r + 1,
    u
  );
  return /* @__PURE__ */ E(
    "div",
    {
      role: "group",
      "aria-roledescription": "slide",
      "aria-label": d,
      "aria-hidden": !n,
      className: s,
      "data-pa-click": l,
      ...o,
      children: i
    }
  );
}, wB = ({
  className: e,
  ariaLabel: t,
  hasNextSlide: n,
  onClick: r,
  children: u,
  alwaysVisible: i,
  serverFptiData: a,
  ...o
}) => {
  const s = U(
    "carousel-button",
    "next-button",
    e,
    {
      "always-visible": i
    }
  ), { environment: { pageSegment: c = "" } = {} } = nt(), l = Ht(
    {
      componentName: Qo,
      linkText: "",
      clickEvent: Ki.CarouselNextButton,
      serverFptiData: a
    },
    c,
    yt.CTA
  );
  return n ? /* @__PURE__ */ E(
    "button",
    {
      "aria-label": t,
      "aria-disabled": !n,
      className: s,
      "data-pa-click": l,
      onClick: r,
      type: "button",
      ...o,
      children: u
    }
  ) : null;
}, TB = ({
  className: e,
  ariaLabel: t,
  hasPrevSlide: n,
  onClick: r,
  children: u,
  alwaysVisible: i,
  serverFptiData: a,
  ...o
}) => {
  const s = U(
    "carousel-button",
    "previous-button",
    e,
    {
      "always-visible": i
    }
  ), { environment: { pageSegment: c = "" } = {} } = nt(), l = Ht(
    {
      componentName: Qo,
      linkText: "",
      clickEvent: Ki.CarouselPreviousButton,
      serverFptiData: a
    },
    c,
    yt.CTA
  );
  return n ? /* @__PURE__ */ E(
    "button",
    {
      "aria-label": t,
      "aria-disabled": !n,
      "data-pa-click": l,
      className: s,
      disabled: !n,
      onClick: r,
      type: "button",
      ...o,
      children: u
    }
  ) : null;
}, Cg = ({
  ariaLabel: e,
  className: t,
  btnClass: n,
  totalPages: r,
  currentPage: u,
  slideToPage: i,
  renderPaginationContent: a,
  items: o,
  serverFptiData: s,
  ...c
}) => {
  const l = U("page-nav-container", t), { environment: { pageSegment: d = "" } = {} } = nt(), f = Ht(
    {
      componentName: Qo,
      linkText: "",
      clickEvent: Ki.CarouselIndicatorButton,
      serverFptiData: s
    },
    d,
    yt.CTA
  ), p = (h, m) => {
    (h.key === "Enter" || h.key === "NumpadEnter") && i(m + 1);
  };
  return /* @__PURE__ */ E("div", { className: l, ...c, children: Array(r).fill("").map((h, m) => {
    const b = m + 1 === u, x = U(
      "carousel-indicator",
      {
        activeButton: b
      },
      n
    ), y = rd(
      e,
      m + 1,
      r
    ), g = o == null ? void 0 : o[m];
    return /* @__PURE__ */ E(
      "button",
      {
        "aria-label": y,
        "aria-current": b,
        "aria-disabled": b,
        "data-pa-click": f,
        className: x,
        onMouseDown: () => i(m + 1),
        onKeyDown: (v) => p(v, m),
        type: "button",
        children: a ? a(g) : /* @__PURE__ */ E("span", {})
      },
      `pageNavBtn-${m + 1}`
    );
  }) });
}, Eg = ({ direction: e = "right" }) => /* @__PURE__ */ ue(
  "svg",
  {
    width: "56",
    height: "56",
    viewBox: "0 0 56 56",
    xmlns: "http://www.w3.org/2000/svg",
    className: "arrow-icon",
    style: {
      transform: `scaleX(${e === "left" ? -1 : 1})`,
      display: "block"
    },
    children: [
      /* @__PURE__ */ E("rect", { width: "56", height: "56", rx: "40" }),
      /* @__PURE__ */ E(
        "path",
        {
          id: "Color",
          d: "M24.2441 14.6195L16.3691 22.4946C16.2049 22.6587 15.9822 22.751 15.75 22.751C15.5178 22.751 15.2951 22.6587 15.1309 22.4946C14.9668 22.3304 14.8745 22.1077 14.8745 21.8755C14.8745 21.6433 14.9668 21.4206 15.1309 21.2564L21.513 14.8755L4.375 14.8755C4.14294 14.8755 3.92038 14.7833 3.75628 14.6192C3.59219 14.4551 3.5 14.2326 3.5 14.0005C3.5 13.7684 3.59219 13.5459 3.75628 13.3818C3.92038 13.2177 4.14294 13.1255 4.375 13.1255L21.513 13.1255L15.1309 6.74455C14.9668 6.58036 14.8745 6.35768 14.8745 6.12549C14.8745 5.89329 14.9668 5.67061 15.1309 5.50642C15.2951 5.34224 15.5178 5.25 15.75 5.25C15.9822 5.25 16.2049 5.34224 16.3691 5.50642L24.2441 13.3814C24.3254 13.4627 24.39 13.5592 24.434 13.6654C24.478 13.7716 24.5007 13.8855 24.5007 14.0005C24.5007 14.1155 24.478 14.2293 24.434 14.3356C24.39 14.4418 24.3254 14.5383 24.2441 14.6195Z",
          fill: "black",
          transform: "translate(14, 14)"
        }
      )
    ]
  }
), wg = {}, Tg = Object.keys(ut).reverse().concat(["xs"]), Ag = (e) => {
  const [t, n] = me(wg), { viewportType: r } = Fu();
  return oe(() => {
    const i = Tg.slice(
      Tg.indexOf(r)
    ).find(
      (o) => !!e[o]
    ), a = i && e[i];
    n(a || wg);
  }, [r]), t;
}, AB = (e, t) => {
  const n = Z(null);
  oe(() => {
    if (!e.current)
      return;
    n.current && n.current.unobserve(e.current), n.current = new ResizeObserver(t), n.current.observe(e.current);
    const r = n.current, u = e.current;
    return () => r && r.unobserve(u);
  }, []);
}, kB = 1 / 30, LB = 500, DB = 150, cl = 1, ll = 30, dl = 0, kg = {
  xs: { scaleFactor: 1 },
  lg: { scaleFactor: 0.9 }
}, NB = ({
  trackContainerRef: e,
  trackRef: t,
  totalSlides: n,
  slideWidth: r,
  slidesPerView: u,
  spaceBetween: i,
  spacerSize: a,
  breakpoints: o,
  scaleAnimation: s = !1,
  swipeOptions: c = {}
}) => {
  const [l, d] = me(1), [f, p] = me(
    Math.ceil(n / u)
  ), [h, m] = me(null), b = Z([]), x = Z(!0), y = Z(!1), g = Z("end"), v = Z(r), S = Z(u), _ = Z(i), A = Z(a), k = Z(0), T = Z(0), L = Z(!1), w = Z(s), D = Z(
    kg.xs
  ), { environment: { isRTL: N = !1 } = {} } = nt();
  L.current = N;
  const {
    slideTo: O,
    resizeCarouselTrack: H,
    getNextSlideIdx: $,
    translateTrack: j,
    cancelAnimation: z,
    getNewPageValues: M,
    getTrackTranslateX: P,
    getVisibleSlideIndices: C,
    doesSlideExist: R,
    calcSlidesPerView: V
  } = $e(
    () => SB({
      trackContainerRef: e,
      trackRef: t,
      isDocDirectionRTL: L,
      allSlides: b,
      hasNextSlide: x,
      hasPrevSlide: y,
      nextSlideIdx: k,
      transitionState: g,
      slidesPerPage: S,
      gutterWidth: _,
      spacerWidth: A,
      singleSlideWidth: v,
      hasScaleAnimation: w,
      scaleAnimationConfig: D
    }),
    []
  ), I = () => {
    x.current && d((re) => re + 1);
  }, G = () => {
    y.current && d((re) => re - 1);
  }, K = (re) => {
    re !== l && d(re);
  };
  oe(() => {
    if (!t.current || !e.current)
      return;
    const re = t.current;
    if (b.current = Array.from(re.children), b.current.length <= 0)
      return;
    S.current = V(), p(Math.ceil(b.current.length / S.current)), d(1);
    const Se = () => {
      g.current = "inProgress";
    }, et = () => {
      g.current = "end";
    }, Le = () => {
      g.current = "end", z();
    };
    return re.addEventListener("transitionstart", Se), re.addEventListener("transitioncancel", et), re.addEventListener("transitionend", Le), () => {
      re.removeEventListener("transitionend", Se), re.removeEventListener("transitioncancel", et), re.removeEventListener("transitionend", Le);
    };
  }, []), oe(() => {
    b.current.length <= 0 || (k.current = $(l, f), k.current >= 0 && O({
      slideIdx: k.current,
      animationDuration: LB
    }));
  }, [l]), _B({
    touchArea: e,
    onTouchStart: () => {
      T.current = P();
    },
    onTouchMove: (re, Se) => {
      const et = R(re) ? 1 : kB;
      let Le = Se && Se.x * et;
      re === An.left && (Le = -Le);
      const we = T.current + Le;
      j(we);
    },
    onTouchEnd: (re, Se) => {
      if (![
        An.left,
        An.right
      ].includes(re))
        return;
      const Le = () => O({
        slideIdx: k.current,
        animationDuration: DB
      });
      return !Se || Se && !R(re) ? Le() : re === An.left && !L.current || re === An.right && L.current ? I() : G();
    },
    ...c
  });
  const ne = Ag(o), fe = Ag(
    kg
  );
  oe(() => {
    S.current = (ne == null ? void 0 : ne.slidesPerView) || u, _.current = (ne == null ? void 0 : ne.spaceBetween) || i, A.current = (ne == null ? void 0 : ne.spacerSize) || a, v.current = (ne == null ? void 0 : ne.slideWidth) || r, S.current < 1 && (S.current = cl), _.current < 0 && (_.current = ll), A.current < 0 && (A.current = dl), S.current = V(), H();
    const [re = 1, Se = 1] = M();
    d(re), p(Se);
  }, [ne, u, i, a, r]), oe(() => {
    D.current = fe;
  }, [fe]), AB(e, (re) => {
    m(re[0].contentRect.width);
  }), oe(() => {
    if (b.current.length <= 0)
      return;
    S.current = V(), H();
    const [re = 1, Se = 1] = M();
    d(re), p(Se), O({ slideIdx: k.current });
  }, [h]), oe(() => {
    if (!t.current)
      return;
    const re = t.current;
    b.current = Array.from(re.children), !(b.current.length <= 0) && (S.current = V(), H(), p(Math.ceil(b.current.length / S.current)), d(1));
  }, [n, t]), x.current = l >= 1 && l < f, y.current = l > 1 && l <= f;
  const xe = C(l);
  return {
    totalPages: f,
    hasPrevSlide: y.current,
    hasNextSlide: x.current,
    slideToNextPage: I,
    slideToPrevPage: G,
    slideToPage: K,
    currentPage: l,
    visibleSlides: xe
  };
}, OB = "Carousel", IB = 1, MB = ({
  items: e = [],
  renderItem: t,
  carouselDetails: n,
  slidesPerView: r = cl,
  spaceBetween: u = ll,
  spacerSize: i = dl,
  slideWidth: a,
  swipeOptions: o = {},
  classes: s = {},
  breakpoints: c = {},
  backgroundColor: l = "white",
  renderPaginationContent: d,
  hideOverflow: f = !1,
  paginationPlacement: p = "bottom",
  onCarouselPageChange: h,
  slideProps: m,
  scaleAnimation: b = !1
}) => {
  const x = Z(null), y = Z(null), g = a || 0, v = r < 1 ? cl : r, S = u < 0 ? ll : u, _ = i < 0 ? dl : i, A = b && r === IB, k = U(s.container, {
    "scale-animation": A
  }), {
    totalPages: T,
    currentPage: L,
    hasNextSlide: w,
    hasPrevSlide: D,
    slideToNextPage: N,
    slideToPrevPage: O,
    slideToPage: H,
    visibleSlides: $
  } = NB({
    trackContainerRef: x,
    trackRef: y,
    totalSlides: e.length,
    slideWidth: g,
    slidesPerView: v,
    spaceBetween: S,
    spacerSize: _,
    breakpoints: c,
    scaleAnimation: b,
    swipeOptions: o
  }), j = D || w;
  return oe(() => {
    typeof h == "function" && h(L);
  }, [L]), /* @__PURE__ */ ue(
    CB,
    {
      ariaLabel: n == null ? void 0 : n.ariaLabel,
      pageLabel: n == null ? void 0 : n.pageLabel,
      currentPage: L,
      totalPages: T,
      className: k,
      backgroundColor: l,
      disableCarousel: !j,
      children: [
        p === "top" && /* @__PURE__ */ E(
          Cg,
          {
            ariaLabel: n == null ? void 0 : n.pageNavButtonLabel,
            className: s.navContainer,
            btnClass: s.navBtn ?? "",
            totalPages: T,
            currentPage: L,
            slideToPage: H,
            items: e,
            renderPaginationContent: d
          }
        ),
        /* @__PURE__ */ ue(
          f4,
          {
            className: s.trackContainer,
            hideOverflow: f,
            ref: x,
            children: [
              /* @__PURE__ */ E(
                p4,
                {
                  className: s.track,
                  backgroundColor: l,
                  ref: y,
                  children: e.length > 0 && e.map((z, M) => {
                    const P = U(s.slide, {
                      inactive: L - 1 !== M && A
                    }), C = $.includes(M);
                    return /* @__PURE__ */ E(
                      EB,
                      {
                        slideLabel: n == null ? void 0 : n.slideLabel,
                        slideIdx: M,
                        totalSlides: e.length,
                        className: P,
                        isVisibleSlide: C,
                        ...m,
                        children: t == null ? void 0 : t({
                          itemProps: z,
                          carouselState: { slideIdx: M, isVisibleSlide: C }
                        })
                      },
                      `CarouselSlide-${M + 1}`
                    );
                  })
                }
              ),
              p === "bottom" && /* @__PURE__ */ E(
                Cg,
                {
                  ariaLabel: n == null ? void 0 : n.pageNavButtonLabel,
                  className: s.navContainer,
                  btnClass: s.navBtn ?? "",
                  totalPages: T,
                  currentPage: L,
                  slideToPage: H
                }
              )
            ]
          }
        ),
        /* @__PURE__ */ E(
          TB,
          {
            ariaLabel: n == null ? void 0 : n.prevButtonLabel,
            className: s.prevBtn,
            hasPrevSlide: D,
            onClick: O,
            alwaysVisible: f,
            children: /* @__PURE__ */ E(Eg, { direction: "left" })
          }
        ),
        /* @__PURE__ */ E(
          wB,
          {
            ariaLabel: n == null ? void 0 : n.nextButtonLabel,
            className: s.nextBtn,
            hasNextSlide: w,
            onClick: N,
            alwaysVisible: f,
            children: /* @__PURE__ */ E(Eg, {})
          }
        )
      ]
    }
  );
};
MB.displayName = OB;
const e$ = ({
  children: e
}) => /* @__PURE__ */ E($i, { features: Iu, strict: !0, children: e }), Jo = () => typeof window < "u", h4 = (e, t) => {
  if (!(!e || !Jo()))
    try {
      sessionStorage.setItem(e, JSON.stringify(t));
    } catch (n) {
      console.error(`Failed to set session storage (key: ${e}):`, n);
    }
}, m4 = (e) => {
  if (!e || !Jo())
    return null;
  try {
    const t = sessionStorage.getItem(e);
    return t ? JSON.parse(t) : null;
  } catch (t) {
    return console.error(`Failed to get session storage (key: ${e}):`, t), null;
  }
}, PB = (e) => {
  if (!(!e || !Jo()))
    try {
      sessionStorage.removeItem(e);
    } catch (t) {
      console.error(`Failed to remove session storage (key: ${e}):`, t);
    }
}, RB = () => {
  if (!Jo())
    return !1;
  const e = m4("session_url"), t = window.location.href;
  return t === e ? !1 : (h4("session_url", t), !0);
}, g4 = (e, t = !1) => {
  const n = Z(e);
  oe(() => {
    const r = n.current;
    return t || window.addEventListener("beforeunload", r), () => {
      t || window.removeEventListener("beforeunload", r);
    };
  }, [n, t]), oe(() => {
    const r = e;
    return t && window.addEventListener("beforeunload", r), () => {
      t && window.removeEventListener("beforeunload", r);
    };
  }, [e, t]);
}, fl = "section_transitions", BB = {
  "ppe-palette": {
    white: "#ffffff",
    black: "#000000",
    "neutral 100": "#F5F7FA",
    "neutral 200": "#EDF0F2",
    "neutral 300": "#E6E7E8",
    "blue 400": "#60CDFF",
    "blue 500": "#008fff",
    "blue 600": "#002991"
  },
  "fastlane-palette": {
    "brand featured": "#00d7fb",
    "neutral 100": "#F4F3F8",
    white: "#ffffff",
    black: "#000000"
  }
}, FB = (e, t) => {
  var n;
  return ((n = BB[t]) == null ? void 0 : n[e]) ?? "#ffffff";
}, HB = (e, t) => `${Cn(e.toLowerCase())}-${t}`, $B = (e, t) => !e || e.length === 0 ? !1 : !!e.find((n) => n.sectionId === t), VB = (e) => {
  const t = [];
  return e ? (PB(fl), t) : m4(fl) || t;
}, jB = (e) => {
  const t = e.map((n) => ({
    ...n,
    scrollYProgress: n.scrollYProgress.get()
  }));
  h4(fl, t);
}, es = (e, t) => t.findIndex((n) => n.sectionId === e), zB = (e, t) => {
  const n = es(e, t);
  if (!(n > -1))
    return 0;
  const u = n + 1, i = t[u];
  return i == null ? void 0 : i.scrollYProgress;
}, UB = (e, t, n) => {
  const r = es(e, t);
  return r > -1 ? t[r].scrollYProgress : n;
}, qB = (e, t) => {
  if (!t || t.length === 0)
    return 0;
  const n = es(e, t);
  if (!(n > -1))
    return 0;
  const u = n + 1, i = t[u];
  return i && i.scrollYProgress || 0;
}, GB = (e, t) => {
  if (!t || t.length === 0)
    return 0;
  const n = es(e, t), r = t[n];
  return r && r.scrollYProgress || 0;
}, t$ = {
  isDisabled: !1
}, WB = {
  body: {},
  sections: {},
  disableTransitions: !0
}, ts = Yn(WB), n$ = ({ children: e }) => {
  const [t, n] = me(
    []
  ), r = $e(() => RB(), []), u = VB(r), i = sr("#fff"), a = $e(
    () => ({
      sections: {
        scrollProgress: t,
        setScrollProgress: n
      },
      body: {
        backgroundColor: i
      },
      disableTransitions: !1,
      scrollProgressSessionData: u
    }),
    [t, i, u]
  ), o = Ct(
    () => jB(t),
    [t]
  );
  return g4(o, !0), /* @__PURE__ */ E(ts.Provider, { value: a, children: /* @__PURE__ */ E($i, { features: Iu, strict: !0, children: e }) });
}, ud = () => {
  const { sections: e, disableTransitions: t } = ke(ts);
  return { sections: e, disableTransitions: t };
}, b4 = () => {
  const { scrollProgressSessionData: e } = ke(ts);
  return e;
}, r$ = (e, t, n = ["start end", "start start"]) => {
  const {
    sections: { scrollProgress: r, setScrollProgress: u },
    disableTransitions: i
  } = ud(), a = $e(() => HB(e, t), [e, t]), o = $B(
    r,
    a
  ), s = Z(null), { scrollYProgress: c } = qa({
    target: s,
    offset: n,
    layoutEffect: !0
  });
  return oe(() => {
    u && !o && H4(() => {
      u((l) => [
        ...l,
        { componentOrderIdx: t, sectionId: a, scrollYProgress: c }
      ].sort(
        (p, h) => p.componentOrderIdx - h.componentOrderIdx
      ));
    });
  }, [
    c,
    a,
    u,
    t,
    o
  ]), { ref: s, sectionId: a, disableTransitions: i };
}, u$ = (e) => {
  const {
    sections: { scrollProgress: t = [] }
  } = ud(), n = b4(), r = zB(e, t), u = qB(
    e,
    n
  ), i = sr(u || 0), [a, o] = me(
    i
  );
  return oe(() => {
    r && o(r);
  }, [r]), { scrollProgress: a };
}, KB = () => {
  const { body: e, disableTransitions: t } = ke(ts);
  return { body: e, disableTransitions: t };
}, i$ = (e, t, n, r, u = !1) => {
  const { foundationColor: i } = ke(yn), {
    body: { backgroundColor: a }
  } = KB(), {
    sections: { scrollProgress: o = [] }
  } = ud(), s = b4(), c = sr(0), l = u ? UB(r, o, c) : c, f = GB(r, s) >= 1, p = n.map(
    (x) => FB(x, i)
  ), h = p[0], m = Ua(
    e,
    t,
    p
  );
  xi(l, "change", (x) => {
    u && x > 0.5 && a.set(h);
  }), f && a.set(m.get()), xi(m, "change", (x) => {
    a == null || a.set(x);
  });
  const b = Ua(
    e,
    (x) => x > 0 ? "transparent" : h
  );
  return {
    sectionStyles: u ? { backgroundColor: b } : {}
  };
}, a$ = (e) => e, o$ = ({
  as: e,
  rootRef: t,
  children: n,
  ...r
}) => {
  const u = hr(), i = e || "div";
  if (u)
    return /* @__PURE__ */ E(i, { ref: t, ...r, children: n });
  const a = Rr[e || "div"];
  return /* @__PURE__ */ E(a, { ref: t, ...r, children: n });
}, id = (e, t) => {
  let n = !1;
  return (...r) => {
    n || (n = !0, e.apply({}, r), setTimeout(() => {
      n = !1;
    }, t));
  };
}, s$ = ({
  children: e,
  className: t,
  containerDimensions: n = D6,
  rootRef: r,
  rootMargin: u
}) => {
  const { inView: i, ref: a } = zi(
    K0({ rootMargin: u })
  ), o = Ct(
    (s) => {
      const c = r && "current" in r;
      typeof r == "function" ? r(s) : c && (r.current = s), a(s);
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [a]
  );
  return /* @__PURE__ */ E("div", { ref: o, className: t, style: n, children: i && e });
}, c$ = (e, t) => {
  const [n, r] = me(""), u = Z(), [i] = Ur(["Below MD"]), a = "overlap-curtain-effect", o = "2.5rem";
  Gn(() => {
    var c;
    const s = (c = t.current) == null ? void 0 : c.nextElementSibling;
    if (s) {
      const [l] = s.getElementsByTagName("section");
      u.current = l || s, r(getComputedStyle(u.current).paddingTop);
    }
  }, [t, u]), Gn(() => {
    var s;
    if (u.current && e === "curtain") {
      const c = (s = t.current) == null ? void 0 : s.classList;
      i ? c != null && c.contains(a) && (c == null || c.remove(a), u.current.style.paddingTop = n) : (c == null || c.add(a), u.current.style.paddingTop = `calc(${n} + ${o})`);
    }
  }, [i, u, n]);
}, l$ = (e = 150, t = "throttle") => {
  const n = $e(() => t === "throttle" ? id : PR, [t]), [r, u] = me({
    width: 0,
    height: 0
  });
  return oe(() => {
    if (typeof window > "u")
      return;
    const i = () => setTimeout(() => {
      u({
        width: window.innerWidth,
        height: window.innerHeight
      });
    });
    i();
    const a = n(
      i,
      e
    );
    return window.addEventListener("resize", a), () => {
      window.removeEventListener("resize", a);
    };
  }, [n, e]), r;
}, d$ = (...e) => {
  const t = Z(!0), [n, r] = me(null), u = w2(...e);
  return oe(() => {
    if (t.current) {
      t.current = !1;
      return;
    }
    r(u);
  }, [u]), n;
}, f$ = (e) => {
  const t = Z(e);
  oe(() => {
    const n = id(t.current, 200);
    return window.addEventListener("scroll", n), () => {
      window.removeEventListener("scroll", n);
    };
  }, [t]);
};
var v4 = function() {
  if (typeof Map < "u")
    return Map;
  function e(t, n) {
    var r = -1;
    return t.some(function(u, i) {
      return u[0] === n ? (r = i, !0) : !1;
    }), r;
  }
  return (
    /** @class */
    function() {
      function t() {
        this.__entries__ = [];
      }
      return Object.defineProperty(t.prototype, "size", {
        /**
         * @returns {boolean}
         */
        get: function() {
          return this.__entries__.length;
        },
        enumerable: !0,
        configurable: !0
      }), t.prototype.get = function(n) {
        var r = e(this.__entries__, n), u = this.__entries__[r];
        return u && u[1];
      }, t.prototype.set = function(n, r) {
        var u = e(this.__entries__, n);
        ~u ? this.__entries__[u][1] = r : this.__entries__.push([n, r]);
      }, t.prototype.delete = function(n) {
        var r = this.__entries__, u = e(r, n);
        ~u && r.splice(u, 1);
      }, t.prototype.has = function(n) {
        return !!~e(this.__entries__, n);
      }, t.prototype.clear = function() {
        this.__entries__.splice(0);
      }, t.prototype.forEach = function(n, r) {
        r === void 0 && (r = null);
        for (var u = 0, i = this.__entries__; u < i.length; u++) {
          var a = i[u];
          n.call(r, a[1], a[0]);
        }
      }, t;
    }()
  );
}(), pl = typeof window < "u" && typeof document < "u" && window.document === document, oo = function() {
  return typeof global < "u" && global.Math === Math ? global : typeof self < "u" && self.Math === Math ? self : typeof window < "u" && window.Math === Math ? window : Function("return this")();
}(), YB = function() {
  return typeof requestAnimationFrame == "function" ? requestAnimationFrame.bind(oo) : function(e) {
    return setTimeout(function() {
      return e(Date.now());
    }, 1e3 / 60);
  };
}(), ZB = 2;
function XB(e, t) {
  var n = !1, r = !1, u = 0;
  function i() {
    n && (n = !1, e()), r && o();
  }
  function a() {
    YB(i);
  }
  function o() {
    var s = Date.now();
    if (n) {
      if (s - u < ZB)
        return;
      r = !0;
    } else
      n = !0, r = !1, setTimeout(a, t);
    u = s;
  }
  return o;
}
var QB = 20, JB = ["top", "right", "bottom", "left", "width", "height", "size", "weight"], eF = typeof MutationObserver < "u", tF = (
  /** @class */
  function() {
    function e() {
      this.connected_ = !1, this.mutationEventsAdded_ = !1, this.mutationsObserver_ = null, this.observers_ = [], this.onTransitionEnd_ = this.onTransitionEnd_.bind(this), this.refresh = XB(this.refresh.bind(this), QB);
    }
    return e.prototype.addObserver = function(t) {
      ~this.observers_.indexOf(t) || this.observers_.push(t), this.connected_ || this.connect_();
    }, e.prototype.removeObserver = function(t) {
      var n = this.observers_, r = n.indexOf(t);
      ~r && n.splice(r, 1), !n.length && this.connected_ && this.disconnect_();
    }, e.prototype.refresh = function() {
      var t = this.updateObservers_();
      t && this.refresh();
    }, e.prototype.updateObservers_ = function() {
      var t = this.observers_.filter(function(n) {
        return n.gatherActive(), n.hasActive();
      });
      return t.forEach(function(n) {
        return n.broadcastActive();
      }), t.length > 0;
    }, e.prototype.connect_ = function() {
      !pl || this.connected_ || (document.addEventListener("transitionend", this.onTransitionEnd_), window.addEventListener("resize", this.refresh), eF ? (this.mutationsObserver_ = new MutationObserver(this.refresh), this.mutationsObserver_.observe(document, {
        attributes: !0,
        childList: !0,
        characterData: !0,
        subtree: !0
      })) : (document.addEventListener("DOMSubtreeModified", this.refresh), this.mutationEventsAdded_ = !0), this.connected_ = !0);
    }, e.prototype.disconnect_ = function() {
      !pl || !this.connected_ || (document.removeEventListener("transitionend", this.onTransitionEnd_), window.removeEventListener("resize", this.refresh), this.mutationsObserver_ && this.mutationsObserver_.disconnect(), this.mutationEventsAdded_ && document.removeEventListener("DOMSubtreeModified", this.refresh), this.mutationsObserver_ = null, this.mutationEventsAdded_ = !1, this.connected_ = !1);
    }, e.prototype.onTransitionEnd_ = function(t) {
      var n = t.propertyName, r = n === void 0 ? "" : n, u = JB.some(function(i) {
        return !!~r.indexOf(i);
      });
      u && this.refresh();
    }, e.getInstance = function() {
      return this.instance_ || (this.instance_ = new e()), this.instance_;
    }, e.instance_ = null, e;
  }()
), y4 = function(e, t) {
  for (var n = 0, r = Object.keys(t); n < r.length; n++) {
    var u = r[n];
    Object.defineProperty(e, u, {
      value: t[u],
      enumerable: !1,
      writable: !1,
      configurable: !0
    });
  }
  return e;
}, Nu = function(e) {
  var t = e && e.ownerDocument && e.ownerDocument.defaultView;
  return t || oo;
}, x4 = ns(0, 0, 0, 0);
function so(e) {
  return parseFloat(e) || 0;
}
function Lg(e) {
  for (var t = [], n = 1; n < arguments.length; n++)
    t[n - 1] = arguments[n];
  return t.reduce(function(r, u) {
    var i = e["border-" + u + "-width"];
    return r + so(i);
  }, 0);
}
function nF(e) {
  for (var t = ["top", "right", "bottom", "left"], n = {}, r = 0, u = t; r < u.length; r++) {
    var i = u[r], a = e["padding-" + i];
    n[i] = so(a);
  }
  return n;
}
function rF(e) {
  var t = e.getBBox();
  return ns(0, 0, t.width, t.height);
}
function uF(e) {
  var t = e.clientWidth, n = e.clientHeight;
  if (!t && !n)
    return x4;
  var r = Nu(e).getComputedStyle(e), u = nF(r), i = u.left + u.right, a = u.top + u.bottom, o = so(r.width), s = so(r.height);
  if (r.boxSizing === "border-box" && (Math.round(o + i) !== t && (o -= Lg(r, "left", "right") + i), Math.round(s + a) !== n && (s -= Lg(r, "top", "bottom") + a)), !aF(e)) {
    var c = Math.round(o + i) - t, l = Math.round(s + a) - n;
    Math.abs(c) !== 1 && (o -= c), Math.abs(l) !== 1 && (s -= l);
  }
  return ns(u.left, u.top, o, s);
}
var iF = function() {
  return typeof SVGGraphicsElement < "u" ? function(e) {
    return e instanceof Nu(e).SVGGraphicsElement;
  } : function(e) {
    return e instanceof Nu(e).SVGElement && typeof e.getBBox == "function";
  };
}();
function aF(e) {
  return e === Nu(e).document.documentElement;
}
function oF(e) {
  return pl ? iF(e) ? rF(e) : uF(e) : x4;
}
function sF(e) {
  var t = e.x, n = e.y, r = e.width, u = e.height, i = typeof DOMRectReadOnly < "u" ? DOMRectReadOnly : Object, a = Object.create(i.prototype);
  return y4(a, {
    x: t,
    y: n,
    width: r,
    height: u,
    top: n,
    right: t + r,
    bottom: u + n,
    left: t
  }), a;
}
function ns(e, t, n, r) {
  return { x: e, y: t, width: n, height: r };
}
var cF = (
  /** @class */
  function() {
    function e(t) {
      this.broadcastWidth = 0, this.broadcastHeight = 0, this.contentRect_ = ns(0, 0, 0, 0), this.target = t;
    }
    return e.prototype.isActive = function() {
      var t = oF(this.target);
      return this.contentRect_ = t, t.width !== this.broadcastWidth || t.height !== this.broadcastHeight;
    }, e.prototype.broadcastRect = function() {
      var t = this.contentRect_;
      return this.broadcastWidth = t.width, this.broadcastHeight = t.height, t;
    }, e;
  }()
), lF = (
  /** @class */
  function() {
    function e(t, n) {
      var r = sF(n);
      y4(this, { target: t, contentRect: r });
    }
    return e;
  }()
), dF = (
  /** @class */
  function() {
    function e(t, n, r) {
      if (this.activeObservations_ = [], this.observations_ = new v4(), typeof t != "function")
        throw new TypeError("The callback provided as parameter 1 is not a function.");
      this.callback_ = t, this.controller_ = n, this.callbackCtx_ = r;
    }
    return e.prototype.observe = function(t) {
      if (!arguments.length)
        throw new TypeError("1 argument required, but only 0 present.");
      if (!(typeof Element > "u" || !(Element instanceof Object))) {
        if (!(t instanceof Nu(t).Element))
          throw new TypeError('parameter 1 is not of type "Element".');
        var n = this.observations_;
        n.has(t) || (n.set(t, new cF(t)), this.controller_.addObserver(this), this.controller_.refresh());
      }
    }, e.prototype.unobserve = function(t) {
      if (!arguments.length)
        throw new TypeError("1 argument required, but only 0 present.");
      if (!(typeof Element > "u" || !(Element instanceof Object))) {
        if (!(t instanceof Nu(t).Element))
          throw new TypeError('parameter 1 is not of type "Element".');
        var n = this.observations_;
        n.has(t) && (n.delete(t), n.size || this.controller_.removeObserver(this));
      }
    }, e.prototype.disconnect = function() {
      this.clearActive(), this.observations_.clear(), this.controller_.removeObserver(this);
    }, e.prototype.gatherActive = function() {
      var t = this;
      this.clearActive(), this.observations_.forEach(function(n) {
        n.isActive() && t.activeObservations_.push(n);
      });
    }, e.prototype.broadcastActive = function() {
      if (this.hasActive()) {
        var t = this.callbackCtx_, n = this.activeObservations_.map(function(r) {
          return new lF(r.target, r.broadcastRect());
        });
        this.callback_.call(t, n, t), this.clearActive();
      }
    }, e.prototype.clearActive = function() {
      this.activeObservations_.splice(0);
    }, e.prototype.hasActive = function() {
      return this.activeObservations_.length > 0;
    }, e;
  }()
), _4 = typeof WeakMap < "u" ? /* @__PURE__ */ new WeakMap() : new v4(), S4 = (
  /** @class */
  function() {
    function e(t) {
      if (!(this instanceof e))
        throw new TypeError("Cannot call a class as a function.");
      if (!arguments.length)
        throw new TypeError("1 argument required, but only 0 present.");
      var n = tF.getInstance(), r = new dF(t, n, this);
      _4.set(this, r);
    }
    return e;
  }()
);
[
  "observe",
  "unobserve",
  "disconnect"
].forEach(function(e) {
  S4.prototype[e] = function() {
    var t;
    return (t = _4.get(this))[e].apply(t, arguments);
  };
});
var fF = function() {
  return typeof oo.ResizeObserver < "u" ? oo.ResizeObserver : S4;
}();
const p$ = (e, t) => {
  const n = Z(null);
  oe(() => {
    const u = e && "current" in e ? e.current : e;
    if (!u)
      return;
    n.current && n.current.unobserve(u);
    const i = window.ResizeObserver || fF;
    n.current = new i(t), n.current.observe(u);
    const a = n.current, o = u;
    return () => a && a.unobserve(o);
  }, [e, t]);
};
const C4 = "ImageParallaxFrame", _a = new ye(C4), pF = ({
  baseImage: e,
  mdImage: t,
  parallaxFactor: n = 1,
  enableScale: r = !1,
  maxSrcSetWidth: u = 4e3,
  imageAltText: i = "",
  verticalAlign: a,
  ariaHidden: o = !1,
  loading: s = "lazy",
  fetchPriority: c = "auto",
  disableParallax: l = !1,
  imageServerKnobs: d = {},
  mediaRatio: f,
  ...p
}) => {
  const h = Z(null), { scrollYProgress: m } = qa({
    target: h,
    offset: ["start end", "end start"]
  }), b = !hr(), x = `${n * -5}%`, y = 1 + n / 20, g = `${n * 5 + 110}%`, v = Ua(
    m,
    [0, 1],
    [x, "0%"]
  ), S = Ua(
    m,
    [0, 1],
    [1, y]
  ), _ = b ? v : 0, A = r && b ? S : 1, k = U(
    _a.getComponentClassName(),
    _a.getElementClassName("outer"),
    {
      [_a.getPropsValueClassName(
        "media-ratio",
        f
      )]: f
    }
  ), T = l ? {} : {
    y: _,
    scale: A,
    height: g
  }, L = {
    baseImage: e || "",
    mdImage: t,
    dimensions: { minHeight: "100%", minWidth: "100%" },
    imageAltText: i,
    verticalAlign: a,
    maxSrcSetWidth: u,
    ariaHidden: o,
    loading: s,
    fetchPriority: c,
    imageServerKnobs: d
  };
  return /* @__PURE__ */ E($i, { features: Iu, children: /* @__PURE__ */ E("div", { ref: h, className: k, ...p, children: /* @__PURE__ */ E(
    Rr.div,
    {
      style: T,
      className: _a.getElementClassName("inner"),
      children: /* @__PURE__ */ E(
        nd,
        {
          type: "Image",
          image: L,
          mediaRatio: f,
          motionOptions: {
            motionFeel: "Expressive",
            motionTypePreset: "scaleDown",
            motionIntensity: "xs"
          },
          roundedCorners: !1
        }
      )
    }
  ) }) });
};
pF.displayName = C4;
const hF = Object.keys(b9), mF = (e) => hF.includes(e), h$ = ({ size: e = "Body", children: t, ...n }) => {
  if (mF(e)) {
    const u = { size: e, ...n };
    return /* @__PURE__ */ E(Qt, { ...u, children: t });
  }
  const r = { size: e, ...n };
  return /* @__PURE__ */ E(dr, { ...r, children: t });
}, m$ = (e) => {
  if (!(typeof window < "u"))
    return !1;
  const n = window.location.href, r = Tp(e), u = Tp(n);
  return r === u;
}, g$ = (e) => {
  const t = Z();
  return t.current || (t.current = QR(e)), t.current;
}, gF = 16, b$ = (e) => {
  let t = gF;
  if (typeof window < "u") {
    const r = document.querySelector("html"), i = +getComputedStyle(r).fontSize.split("px")[0];
    i > 0 && (t = i);
  }
  return e * t;
}, bF = {
  "segment-control-group": "_segment-control-group_55zyk_1"
}, vF = {
  "segment-control-group": "_segment-control-group_1ipda_1"
}, yF = (e) => {
  switch (e) {
    case "ppe":
      return vF;
    default:
      return bF;
  }
}, xF = {
  "segment-control-tab": "_segment-control-tab_1ihe1_1",
  "segment-control-tab-is-active": "_segment-control-tab-is-active_1ihe1_51",
  "segment-control-tab-text": "_segment-control-tab-text_1ihe1_71",
  "focus-visible": "_focus-visible_1ihe1_1",
  "segment-control-tab-theme-secondary": "_segment-control-tab-theme-secondary_1ihe1_88"
}, _F = {
  "segment-control-tab": "_segment-control-tab_f61ar_1",
  "segment-control-tab-index-0": "_segment-control-tab-index-0_f61ar_16",
  "segment-control-tab-index-1": "_segment-control-tab-index-1_f61ar_19",
  "segment-control-tab-text": "_segment-control-tab-text_f61ar_22",
  "segment-control-tab-is-active": "_segment-control-tab-is-active_f61ar_25"
}, SF = (e) => {
  switch (e) {
    case "ppe":
      return "Body Bold";
    default:
      return "Body";
  }
}, CF = (e) => {
  switch (e) {
    case "ppe":
      return _F;
    default:
      return xF;
  }
}, Dg = "SegmentControlTab", EF = ({ children: e }) => /* @__PURE__ */ E("li", { children: e }), wF = ({
  text: e,
  as: t = "a",
  isTabActive: n = !1,
  className: r = "",
  analyticsCompName: u = Dg,
  theme: i = "Secondary",
  index: a,
  serverFptiData: o,
  ...s
}) => {
  const { foundationTheme: c } = ke(yn), l = new ye(
    Dg,
    CF(c)
  ), { environment: { pageSegment: d = "" } = {} } = nt(), f = t === "button" ? "button" : "a", p = SF(c), h = U(
    l.getComponentClassName(),
    {
      [l.getPropsValueClassName("is-active", n)]: n
    },
    i === "Secondary" && l.getPropsValueClassName("theme", i),
    r,
    a && l.getPropsValueClassName("index", a.toString())
  ), m = Ht(
    {
      componentName: u,
      linkText: e,
      linkSection: "",
      clickEvent: Io.SegmentControlTab,
      serverFptiData: o
    },
    d,
    yt.Link
  );
  return /* @__PURE__ */ E(EF, { children: /* @__PURE__ */ E(
    f,
    {
      ...s,
      "aria-current": n ? "page" : !1,
      "data-text": e,
      "data-pa-click": m,
      className: h,
      children: /* @__PURE__ */ E(
        Qt,
        {
          as: "span",
          size: p,
          className: l.getElementClassName("text"),
          children: e
        }
      )
    }
  ) });
}, Ng = "SegmentControlGroup", TF = ({ children: e, ariaLabel: t, ...n }) => /* @__PURE__ */ E("nav", { ...n, "aria-label": t, children: /* @__PURE__ */ E("ul", { children: e }) }), v$ = ({
  selectedTabText: e,
  tabItems: t,
  analyticsCompName: n = Ng,
  className: r = "",
  style: u = {},
  ariaLabel: i = "",
  theme: a
}) => {
  const { foundationTheme: o } = ke(yn), s = new ye(
    Ng,
    yF(o)
  ), c = U(
    s.getComponentClassName(),
    r,
    a === "Secondary" && s.getPropsValueClassName("theme", a)
  );
  return /* @__PURE__ */ E(TF, { style: u, className: c, ariaLabel: i, children: t.map(({ text: l, ...d }, f) => /* @__PURE__ */ E(
    wF,
    {
      text: l,
      isTabActive: e === l,
      analyticsCompName: n,
      theme: a,
      index: f,
      ...d
    },
    `segment-control-tab-${l}-${f + 1}`
  )) });
}, AF = {
  "video-scrubbing-background": "_video-scrubbing-background_1g8kj_1",
  "video-scrubbing-background-video-container": "_video-scrubbing-background-video-container_1g8kj_8",
  "video-scrubbing-background-image-container": "_video-scrubbing-background-image-container_1g8kj_18"
}, E4 = "VideoScrubbingBackground", dc = new ye(E4, AF), kF = Rr.div, Og = 30, LF = ({
  scrollYProgress: e = mn(0),
  backgroundAnimation: t = {},
  reduceMotion: n,
  className: r,
  motionStyle: u = {},
  maxSrcSetWidth: i
}) => {
  const a = Z(null), [o] = Ur(["Below MD"]), s = U(dc.getComponentClassName(), r), {
    altTextDesktop: c = "",
    altTextMobile: l = "",
    imageUrlMobile: d = "",
    imageUrlDesktop: f = ""
  } = t, p = o ? l : c, h = (b, x) => {
    const y = b * Og;
    return Math.floor(y * x) / Og;
  };
  xi(e, "change", (b) => {
    const x = a.current;
    x && x.duration && (x.currentTime = h(x.duration, b));
  });
  const m = () => {
    if (a.current) {
      const b = e.get(), x = a.current.duration ?? 0, y = h(x, b);
      a.current.currentTime = y;
    }
  };
  return n ? /* @__PURE__ */ E(
    Yo,
    {
      className: dc.getElementClassName("image-container"),
      baseImage: d,
      mdImage: f,
      imageAltText: p,
      maxSrcSetWidth: i,
      roundedCorners: !1
    }
  ) : /* @__PURE__ */ E(
    kF,
    {
      className: s,
      role: "img",
      "aria-label": p,
      style: u,
      children: /* @__PURE__ */ E(
        td,
        {
          className: dc.getElementClassName("video-container"),
          ref: a,
          onLoadedMetadata: m,
          preload: "auto",
          disableMediaControl: !0,
          autoplay: !1,
          ...t,
          roundedCorners: !1
        }
      )
    }
  );
};
LF.displayName = E4;
const DF = (e) => {
  const t = Z(e);
  oe(() => {
    const n = t.current, r = (u) => {
      u.persisted && n();
    };
    return window.addEventListener("pageshow", r), () => {
      window.removeEventListener("pageshow", r);
    };
  }, [t]);
}, y$ = ({
  duration: e = 1,
  delay: t = 0,
  reduceMotion: n = !1
} = {}) => {
  const [r, u] = me(!1), i = {
    duration: e,
    delay: t,
    ease: "easeInOut"
  }, a = {
    initial: {
      opacity: 1,
      y: 0
    },
    exit: {
      opacity: 0,
      // TODO: Replace clamp with css variable but --grid-fluid-clamp-value--sm is not available at root
      y: "clamp(0.5rem, -0.29999999999999993rem + 1.25vw, 1.2rem)"
      // '2vw' corresponsds to var(--grid-fluid-clamp-value--sm)
    }
  };
  g4(() => {
    u(!0);
  }), DF(() => {
    u(!1);
  });
  const o = {
    opacity: r ? a.exit.opacity : a.initial.opacity,
    transform: r ? `translateY(${a.exit.y})` : `translateY(${a.initial.y})`,
    transition: `all ${i.duration}s ${Cn(i.ease)} ${i.delay}s`
  };
  return {
    style: n ? {} : o,
    aboutToExit: r,
    variant: a,
    transition: i
  };
}, NF = (e, t = "auto", n = "auto") => (e == null ? void 0 : e.type) === "Image" ? {
  ...e,
  image: {
    ...e == null ? void 0 : e.image,
    dimensions: { minWidth: t, minHeight: n }
  }
} : (e == null ? void 0 : e.type) === "Video" ? {
  ...e,
  video: {
    ...e == null ? void 0 : e.video,
    dimensions: { minWidth: t, minHeight: n }
  }
} : null, x$ = () => {
  const [e, t] = me("");
  return Gn(() => {
    let n = 0;
    function r() {
      const i = window.scrollY, a = i < n;
      n = i, t(a ? "up" : "down");
    }
    const u = id(r, 150);
    return window.addEventListener("scroll", u, !1), () => {
      window.removeEventListener("scroll", u, !1);
    };
  }, []), e;
};
const OF = 4, ad = "PricingCardItem", Je = new ye(ad), w4 = ({
  className: e,
  productName: t = "",
  productNameTag: n = "h3",
  productNameSize: r = "Title",
  subheading: u,
  paragraph: i = "",
  analyticsCompName: a = ad,
  disclosureType: o,
  list: s,
  actionGroup: c,
  mediaFrame: l,
  pricingCardFeatures: d,
  secondaryPricing: f,
  pricingCardItemHeadline: p = "",
  cardSize: h = "3col",
  theme: m = "neutral 100"
}) => {
  const b = U(
    e,
    Je.getElementClassName("wrapper"),
    Je.getElementClassName("no-media"),
    Je.getPropsValueClassName("spacing", h),
    Je.getElementClassName(h),
    m ? Or.getThemeClassName(m) : ""
  ), x = U(
    e,
    Je.getElementClassName("wrapper"),
    Je.getElementClassName("media"),
    Je.getElementClassName(h),
    m ? Or.getThemeClassName(m) : ""
  ), y = l && NF(l), g = () => t ? /* @__PURE__ */ E(
    Bt,
    {
      as: n,
      className: Je.getElementClassName(
        `${y ? "image-" : ""}product-name`
      ),
      content: t,
      customWrapper: P6({ size: r }),
      analyticsCompName: a,
      analyticsTextSection: "product-name"
    }
  ) : null, v = () => p ? /* @__PURE__ */ E(
    Bt,
    {
      content: p,
      customWrapper: kr({ size: "Body Large" }),
      className: Je.getElementClassName(
        `${y ? "image-" : ""}pricing-header`
      )
    }
  ) : null, S = () => s ? /* @__PURE__ */ E("div", { className: Je.getElementClassName("dataGridItem"), children: /* @__PURE__ */ E(q6, { siblingDataItems: s, children: s.map(
    ({
      title: j,
      numberGroup: z,
      caption: M,
      text: P,
      topBorder: C,
      bottomBorder: R,
      topSpacer: V,
      bottomSpacer: I,
      indent: G,
      alignment: K,
      tooltip: Q
    }, ae) => {
      const X = `item-${ae}+1`;
      return /* @__PURE__ */ E(
        G6,
        {
          title: j,
          numberGroup: z,
          caption: M,
          text: P,
          topBorder: C,
          bottomBorder: R,
          className: Je.getElementClassName("dataItem"),
          topSpacer: V,
          bottomSpacer: I,
          indent: G,
          alignment: K,
          tooltip: Q
        },
        X
      );
    }
  ) }) }) : null, _ = () => d ? /* @__PURE__ */ E(
    Y6,
    {
      analyticsCompName: a,
      ...d,
      maxItems: OF
    }
  ) : null, A = (j) => {
    if (!j)
      return null;
    const { prefix: z, number: M, suffix: P } = j.number1;
    return /* @__PURE__ */ ue(
      Qt,
      {
        size: "Body Large",
        as: "span",
        className: Je.getElementClassName("secondaryNumberGroup"),
        children: [
          z && /* @__PURE__ */ E(Bt, { as: "span", content: z }),
          M && /* @__PURE__ */ E(Bt, { as: "span", content: M }),
          P && /* @__PURE__ */ E(Bt, { as: "span", content: P })
        ]
      }
    );
  }, k = (j, z) => {
    if (!j)
      return null;
    const M = `secondary-item-${z + 1}`, { numberGroup: P, text: C } = j;
    return /* @__PURE__ */ ue(
      "div",
      {
        className: Je.getElementClassName("secondaryPricingItem"),
        children: [
          A(P),
          C && /* @__PURE__ */ E(
            Bt,
            {
              content: C,
              as: "span",
              customWrapper: kr({ size: "Body" })
            }
          )
        ]
      },
      M
    );
  }, T = () => f ? /* @__PURE__ */ E("div", { className: Je.getElementClassName("secondaryPricing"), children: f == null ? void 0 : f.map(
    (j, z) => k(j, z)
  ) }) : null, L = () => u ? /* @__PURE__ */ E(
    Bt,
    {
      as: "p",
      className: Je.getElementClassName("subheading"),
      content: u,
      customWrapper: kr({ size: "Body" }),
      analyticsCompName: a,
      analyticsTextSection: "subheading"
    }
  ) : null, w = () => i ? /* @__PURE__ */ E(
    Bt,
    {
      as: "p",
      className: Je.getElementClassName("paragraph"),
      content: i,
      customWrapper: kr({ size: "Caption" }),
      analyticsCompName: a,
      analyticsTextSection: "paragraph"
    }
  ) : null, D = () => c ? /* @__PURE__ */ E(W0, { ...c, analyticsCompName: a }) : null, N = () => o ? /* @__PURE__ */ E(
    Uo,
    {
      ...o,
      analyticsCompName: a,
      analyticsTextSection: "disclosure"
    }
  ) : null, O = () => y ? /* @__PURE__ */ E(
    nd,
    {
      className: Je.getElementClassName("image"),
      maxSrcSetWidth: 1280,
      ...y,
      motionOptions: {
        motionTypePreset: "appear",
        motionIntensity: "lg"
      },
      analyticsCompName: a,
      roundedCorners: !1
    }
  ) : null;
  return l ? (() => /* @__PURE__ */ ue("div", { className: x, children: [
    O(),
    /* @__PURE__ */ ue(
      "div",
      {
        className: Je.getPropsValueClassName("spacing", h),
        children: [
          /* @__PURE__ */ ue("div", { className: Je.getElementClassName("productInfo"), children: [
            g(),
            L(),
            w()
          ] }),
          /* @__PURE__ */ E("div", { className: Je.getElementClassName("pricingHeader"), children: v() }),
          /* @__PURE__ */ E("div", { className: Je.getElementClassName("dataGroup"), children: S() }),
          /* @__PURE__ */ E("div", { className: Je.getElementClassName("featureList"), children: _() }),
          /* @__PURE__ */ E(
            "div",
            {
              className: Je.getElementClassName(
                "secondaryPricingGroup"
              ),
              children: T()
            }
          ),
          /* @__PURE__ */ ue("div", { className: Je.getElementClassName("actionGroup"), children: [
            D(),
            N()
          ] })
        ]
      }
    )
  ] }))() : (() => /* @__PURE__ */ ue("div", { className: b, children: [
    g(),
    v(),
    S(),
    _(),
    T(),
    L(),
    w(),
    /* @__PURE__ */ ue("div", { className: Je.getElementClassName("actionGroup"), children: [
      D(),
      N()
    ] })
  ] }))();
};
w4.displayName = ad;
var Kt = /* @__PURE__ */ ((e) => (e.Text = "Text", e.Symbol = "Symbol", e.PricingCardItem = "Pricing Card Item", e.ButtonGroup = "Button Group", e.HeaderWithImage = "Header with Image", e))(Kt || {}), Sn = /* @__PURE__ */ ((e) => (e.Data = "Data", e.Header = "Header", e))(Sn || {}), Eu = /* @__PURE__ */ ((e) => (e.row = "row", e.col = "col", e.colgroup = "colgroup", e))(Eu || {}), gn = /* @__PURE__ */ ((e) => (e.Data = "Data", e.Header = "Header", e))(gn || {});
const IF = "Table", Xn = new ye(IF), T4 = Te.forwardRef(
  ({
    rowIdx: e,
    rowType: t,
    cell: n,
    className: r = "",
    idx: u,
    tabIndex: i,
    handleOnBlur: a,
    children: o,
    scope: s,
    additionalEmptyCells: c,
    colspan: l
  }, d) => {
    const f = n.type;
    if (![
      Sn.Header,
      Sn.Data
    ].includes(f))
      return null;
    if (t === gn.Header || f === Sn.Header) {
      const m = !n.content.text, b = U(
        Xn.getElementClassName("cell"),
        {
          [Xn.getElementClassName("alignStart")]: t === gn.Data && f === Sn.Header || u === 0,
          [Xn.getElementClassName("cell-empty-header")]: m
        },
        r,
        "body-text-size-body"
      ), y = typeof c == "number" && c > 1 && Array.from({ length: c - 1 }, (v, S) => /* @__PURE__ */ E(
        "td",
        {
          "aria-hidden": !0,
          className: b
        },
        `colgroup-cell-${S}+1`
      )), g = f === Sn.Data || m ? "td" : "th";
      return /* @__PURE__ */ ue(on, { children: [
        /* @__PURE__ */ E(
          g,
          {
            scope: m ? void 0 : s,
            className: b,
            "aria-hidden": e > 0 && n.isRepeatingHeader,
            ref: d,
            tabIndex: i,
            onBlur: a,
            colSpan: l,
            rowSpan: n.rowSpan,
            children: o
          }
        ),
        y
      ] });
    }
    const h = U(
      Xn.getElementClassName("cell"),
      {
        [Xn.getElementClassName("alignStart")]: n.content.type === Kt.Text,
        [Xn.getElementClassName("alignStart")]: n.content.type === Kt.PricingCardItem,
        [Xn.getElementClassName("placeCenterWhenMobile")]: n.content.type === Kt.Symbol,
        [Xn.getElementClassName("cta")]: n.content.type === Kt.ButtonGroup
      },
      r
    );
    return /* @__PURE__ */ E("td", { className: h, rowSpan: n.rowSpan, children: o });
  }
);
T4.displayName = "TableCell";
const MF = ({
  children: e,
  ...t
}) => /* @__PURE__ */ E("span", { ...t, children: e }), A4 = "Table", co = new ye(A4), PF = (e) => [Pa.Checkmark, ao, Pa.Dash].includes(
  e.type
) ? e.type === Pa.Checkmark ? /* @__PURE__ */ E(W6, { color: e.color, ariaLabel: e.ariaLabel }) : /* @__PURE__ */ E(BR, { ariaLabel: e.ariaLabel }) : null, RF = (e) => {
  var t;
  return ((t = e.content) == null ? void 0 : t.length) > 1;
}, BF = ({
  content: e,
  size: t,
  analyticsCompName: n
}) => {
  const r = e == null ? void 0 : e.text;
  if (!r)
    return null;
  const i = typeof r == "object" && RF(r);
  return /* @__PURE__ */ E(
    hR,
    {
      content: r,
      size: t,
      lineProps: {
        customWrapper: i ? void 0 : MF,
        className: U({
          [co.getElementClassName("itemParagraph")]: i,
          [co.getElementClassName("cellContentText")]: !i
        }),
        analyticsCompName: n
      }
    }
  );
}, FF = ({
  tooltip: e,
  children: t
}) => /* @__PURE__ */ ue("div", { className: co.getElementClassName("cellContentWrapper"), children: [
  t,
  /* @__PURE__ */ E(
    B6,
    {
      description: e,
      theme: "v3",
      className: co.getElementClassName("tooltipIcon"),
      tooltipClassName: "tooltip"
    }
  )
] }), HF = ({
  content: e,
  tooltip: t,
  analyticsCompName: n = A4
}) => {
  if (![
    Kt.Text,
    Kt.Symbol,
    Kt.PricingCardItem,
    Kt.ButtonGroup
  ].includes(e == null ? void 0 : e.type))
    return null;
  if (e.type === Kt.Text) {
    const u = BF({ content: e, analyticsCompName: n });
    return t ? /* @__PURE__ */ E(FF, { tooltip: t, children: /* @__PURE__ */ E("div", { children: u }) }) : u;
  }
  return e.type === Kt.PricingCardItem ? /* @__PURE__ */ E(
    w4,
    {
      ...e == null ? void 0 : e.pricingCardItem,
      analyticsCompName: n,
      theme: null
    }
  ) : e.type === Kt.ButtonGroup ? /* @__PURE__ */ E(
    W0,
    {
      ...e == null ? void 0 : e.cta,
      className: Or.getThemeClassName("neutral 100"),
      analyticsCompName: n
    }
  ) : e.type === Kt.Symbol ? PF(e.symbol) : null;
}, $F = "Table", ru = new ye($F), k4 = ({
  row: e,
  multilineRowPosition: t,
  applyRowBackgroundColor: n,
  classes: r = {},
  children: u,
  isExpanded: i,
  isHiddenRow: a,
  isInert: o
}) => {
  const { isAboveTheFold: s } = ke(Yl), c = hr(), l = s || c, d = e.type;
  if (![gn.Data, gn.Header].includes(
    d
  ))
    return null;
  const p = U(
    ru.getElementClassName("headerRow"),
    r.headerRow
  ), h = U(
    ru.getElementClassName("dataRow"),
    r.dataRow,
    {
      [ru.getPropsValueClassName(
        "row-multiline",
        t
      )]: ["start", "mid", "end"].includes(t),
      [ru.getElementClassName("data-row-with-bg")]: n
    }
  ), m = ru.getElementClassName("btnRow"), b = {
    hidden: {
      display: "none"
    },
    initial: {
      opacity: 0
    },
    animate: {
      opacity: l ? 1 : [0, 1, 1]
    }
  }, x = {
    duration: Lt.constants.Functional.multiplier.appear * 10,
    ease: Lt.constants.Functional.ease
  }, y = U(ru.getElementClassName("row"), {
    [p]: d === gn.Header,
    [h]: d === gn.Data,
    [m]: e.cells.find(
      (g) => g.content.type === Kt.ButtonGroup
    )
  });
  return /* @__PURE__ */ E(
    Vr,
    {
      as: "tr",
      className: y,
      isAnimated: !a,
      variants: b,
      transition: x,
      animate: !i && a ? "hidden" : "animate",
      inert: o ? "" : void 0,
      children: u
    }
  );
};
k4.displayName = "TableRow";
const VF = "Table", jF = new ye(VF), zF = (e) => {
  const { innerProps: t } = e;
  return /* @__PURE__ */ E(HF, { ...t });
}, UF = (e) => {
  const { innerProps: t } = e;
  return /* @__PURE__ */ E(d4, { ...t });
}, qF = (e) => {
  const { innerProps: t } = e;
  return /* @__PURE__ */ E(k4, { ...t });
}, GF = at((e, t) => {
  const { innerProps: n } = e;
  return /* @__PURE__ */ E(T4, { ref: t, ...n });
}), WF = (e) => {
  const {
    row: t,
    cell: n,
    analyticsCompName: r,
    components: u,
    scope: i,
    isWithinMainCategoryHeader: a
  } = e, o = (u == null ? void 0 : u.TableCellContent) ?? zF, s = {
    content: n.content,
    tooltip: n == null ? void 0 : n.tooltip,
    analyticsCompName: r
  }, c = i === Eu.colgroup;
  return /* @__PURE__ */ E(
    o,
    {
      innerProps: s,
      data: {
        rowType: t.type,
        cellType: n.type,
        isWithinColGroupRow: c,
        isWithinMainCategoryHeader: a
      }
    }
  );
}, KF = (e) => {
  const { truncateButtonProps: t, components: n, pageSegment: r } = e, {
    isExpanded: u,
    truncateButton: i,
    numberOfHiddenRows: a = 0,
    analyticsCompName: o,
    handleToggleView: s,
    serverFptiData: c
  } = t, l = (n == null ? void 0 : n.TruncateButton) ?? UF, d = () => {
    if (u || !i || !i.ariaTextMore)
      return "";
    const x = i.ariaTextMore, y = a.toString();
    return x.replace("${rowsCount}", y);
  }, p = (() => i ? u ? i.lessTextLabel : i.moreTextLabel : "")(), h = (x) => o && Ht(
    {
      componentName: o,
      linkText: x,
      linkType: jr.Tertiary,
      clickEvent: Io.Text,
      serverFptiData: c
    },
    r,
    yt.CTA
  ), m = U(
    jF.getElementClassName("expand-button")
  ), b = {
    "aria-label": d(),
    "aria-expanded": u,
    text: p,
    iconType: u ? "Chevron Up" : "Chevron Down",
    onClick: s,
    className: m,
    "data-pa-click": h(p)
  };
  return /* @__PURE__ */ E(
    l,
    {
      data: {
        truncateButtonProps: t
      },
      innerProps: b
    }
  );
}, YF = ({ components: e, shouldTruncateTable: t, isLastVisibleRow: n, ...r }) => {
  const u = (e == null ? void 0 : e.TableRow) ?? qF;
  return /* @__PURE__ */ E(
    u,
    {
      innerProps: r,
      data: {
        shouldTruncateTable: t,
        isLastVisibleRow: n
      }
    }
  );
}, ZF = at(
  ({
    numberOfVisibleRows: e,
    components: t,
    hiddenFirstCellTabIndex: n,
    isLastVisibleRow: r,
    numberOfColumns: u,
    ...i
  }, a) => {
    const o = (t == null ? void 0 : t.TableCell) ?? GF, s = !(t != null && t.TableCell);
    let c;
    const l = {
      ...i
    };
    if (s) {
      const d = e === i.rowIdx, f = i.idx === 0;
      d && f && (c = a, l.tabIndex = n);
    } else
      c = a;
    return /* @__PURE__ */ E(
      o,
      {
        ref: c,
        innerProps: l,
        data: {
          hiddenFirstCellTabIndex: n,
          isLastVisibleRow: r,
          numberOfColumns: u
        }
      }
    );
  }
), XF = (e, t, n) => {
  if (!(e !== gn.Header && t !== Sn.Header)) {
    if (e === gn.Header && t === Sn.Header)
      return Eu.col;
    if (e === gn.Data && t === Sn.Header && n === 1)
      return Eu.colgroup;
    if (t !== Sn.Data)
      return Eu.row;
  }
}, Ig = (e, t, n) => e === gn.Data && t === Sn.Header && n === 1, QF = (e) => e === Eu.colgroup, JF = (e) => {
  const t = e.cells.find((n) => n.rowSpan && n.rowSpan > 1);
  return t && t.rowSpan;
}, { toggleRowBgColor: eH, resetRowBgColorTracker: tH } = (() => {
  let e = !1;
  return { toggleRowBgColor: () => {
    const r = e;
    return e = !e, r;
  }, resetRowBgColorTracker: () => {
    e = !1;
  } };
})(), nH = (() => {
  let e = 0, t = 0, n = !1, r = "none", u = !0;
  return (a, o) => {
    const s = o + 1, c = JF(a);
    return a.type === gn.Header ? tH() : n || (u = eH()), c && c > 1 && !n && (n = !0, e = s, t = s + c - 1), n ? s === e ? r = "start" : s > e && s < t ? r = "mid" : s === t && (r = "end", e = 0, t = 0, n = !1) : r = "none", { multilineRowPosition: r, applyRowBackground: u };
  };
})(), rH = "Table", fc = new ye(rH), L4 = Te.forwardRef(
  (e, t) => {
    const {
      numberOfColumns: n,
      className: r = "",
      caption: u,
      children: i,
      shouldTruncateTable: a = !1,
      components: o
    } = e, s = U(
      fc.getElementClassName("table"),
      fc.getElementClassName(`column-count-${n}`),
      r
    ), c = {
      "--table-column-count": n
    }, { environment: { pageSegment: l = "" } = {} } = nt();
    return /* @__PURE__ */ ue(
      "div",
      {
        className: fc.getElementClassName("tableWrapper"),
        ref: t,
        children: [
          /* @__PURE__ */ ue("table", { className: s, style: c, children: [
            /* @__PURE__ */ E("caption", { className: "caption", children: u }),
            /* @__PURE__ */ E("tbody", { children: i })
          ] }),
          a && KF({
            components: o,
            truncateButtonProps: e,
            pageSegment: l
          })
        ]
      }
    );
  }
);
L4.displayName = "TableBody";
const D4 = "Table", uH = new ye(D4), _$ = ({
  numberOfColumns: e,
  rows: t = [],
  caption: n,
  classes: r = {},
  analyticsCompName: u = D4,
  rowNumber: i = 5,
  truncateButton: a,
  components: o
}) => {
  const { foundationTheme: s } = ke(yn), [c, l] = me(!1), [d, f] = me(0), p = Z(null), h = () => {
    l(!c);
    const y = p && p.current;
    c || setTimeout(() => {
      f(0), y == null || y.focus();
    });
  }, m = () => {
    f(-1);
  }, b = t.length > i, x = i - 1;
  return /* @__PURE__ */ E(
    L4,
    {
      numberOfColumns: e,
      caption: n,
      className: U(
        uH.getElementClassName("bnpl-table"),
        s,
        r.table
      ),
      shouldTruncateTable: b,
      isExpanded: c,
      truncateButton: a,
      numberOfHiddenRows: t.length - i,
      handleToggleView: h,
      analyticsCompName: u,
      components: o,
      numberOfVisibleRows: i,
      children: t.map((y, g) => {
        const { multilineRowPosition: v, applyRowBackground: S } = nH(y, g);
        return /* @__PURE__ */ E(
          YF,
          {
            row: y,
            multilineRowPosition: v,
            applyRowBackgroundColor: S,
            classes: {
              headerRow: r == null ? void 0 : r.headerRow,
              dataRow: r == null ? void 0 : r.dataRow
            },
            isExpanded: c,
            isHiddenRow: g >= i,
            shouldTruncateTable: b,
            isLastVisibleRow: x === g,
            components: o,
            children: y.cells.slice(0, e).map((_, A) => {
              const k = XF(
                y.type,
                _.type,
                y.cells.length
              ), T = QF(k) ? e : void 0, L = t[g + 1], w = Ig(
                y.type,
                _.type,
                y.cells.length
              ), D = L && L.cells[0] && Ig(
                L.type,
                L.cells[0].type,
                L.cells.length
              ), N = w && D;
              return /* @__PURE__ */ E(
                ZF,
                {
                  ref: p,
                  rowIdx: g,
                  rowType: y.type,
                  idx: A,
                  cell: _,
                  className: r.cell,
                  handleOnBlur: m,
                  scope: k,
                  additionalEmptyCells: T,
                  components: o,
                  hiddenFirstCellTabIndex: d,
                  numberOfVisibleRows: i,
                  isLastVisibleRow: x === g,
                  numberOfColumns: e,
                  children: WF({
                    row: y,
                    cell: _,
                    analyticsCompName: u,
                    components: o,
                    scope: k,
                    isWithinMainCategoryHeader: N
                  })
                },
                `cell-${A + 1}`
              );
            })
          },
          `row-${g + 1}`
        );
      })
    }
  );
}, iH = "31.25rem", S$ = (e = iH) => {
  const [t, n] = me(!1);
  return oe(() => {
    const r = window.matchMedia(`(max-height: ${e})`), u = (i) => {
      n(i.matches);
    };
    return r.addEventListener("change", u), () => {
      r.removeEventListener("change", u);
    };
  }, [e]), t;
}, C$ = (e, t = {}) => {
  const { viewportHeightOffset: n = 0 } = t, [r, u] = me(n);
  oe(() => {
    u(n);
  }, [n]);
  const i = w2(e, {
    once: !0,
    margin: "700px 0px 700px 0px"
  }), { scrollYProgress: a } = qa({
    target: i ? e : void 0,
    offset: [`start ${r}px`, "end end"]
  }), { scrollYProgress: o } = qa({
    target: i ? e : void 0,
    offset: ["start end", `end ${r}px`]
  });
  return {
    elScrollProgressInner: a,
    elScrollProgressOuter: o,
    isElementNearViewport: i
  };
}, E$ = (...e) => (t) => {
  e.forEach((n) => {
    typeof n == "function" ? n(t) : n && (n.current = t);
  });
}, w$ = (e, t) => {
  const n = sr("relative"), r = sr(0), u = hr(), [i] = Ur(["Below LG"]), a = () => {
    var h;
    const c = typeof window !== void 0, l = (h = e.current) == null ? void 0 : h.offsetHeight;
    if (u || !c || !l) {
      n.set("relative"), r.set(0);
      return;
    }
    const d = window.innerHeight, f = 48, p = -1 * (l - d + (i ? f : 0));
    n.set("sticky"), r.set(p);
  }, o = () => {
    n.set("relative"), r.set(0);
  };
  return xi(t, "change", (c) => {
    c === 1 ? o() : a();
  }), { stickyStyles: {
    position: n,
    top: r
  } };
}, aH = "MinimalModal", oH = ({
  children: e,
  ...t
}) => /* @__PURE__ */ E(C3, { ...t, children: e });
oH.displayName = aH;
const sH = "MinimalDisclosure", N4 = (e = {}) => /* @__PURE__ */ E(C0, { ...e });
N4.displayName = sH;
const cH = at(
  ({
    children: e,
    disclosure: t,
    className: n,
    messageId: r,
    disclosureGridItemProps: u,
    theme: i = "white",
    isThemeEnabled: a = !0,
    as: o,
    ...s
  }, c) => /* @__PURE__ */ E(
    y3,
    {
      className: n,
      messageId: r,
      disclosure: t,
      theme: i,
      isThemeEnabled: a,
      gridProps: s,
      disclosureWrapper: N4,
      disclosureGridItemProps: u,
      rootRef: c,
      as: o,
      children: e
    }
  )
);
cH.displayName = E0;
const lH = "FeeTable", ht = new ye(lH), T$ = (e, t, n, r) => {
  const u = [
    ht.getElementClassName("row"),
    ht.getElementClassName("dataRow"),
    t % 2 !== 0 && ht.getElementClassName("dataRowWithBg")
  ];
  return e && (u.push(ht.getElementClassName("mutliline")), r === 0 ? u.push(ht.getElementClassName("mutlilineStart")) : r === n - 1 && u.push(ht.getElementClassName("mutlilineEnd"))), U(...u);
}, A$ = (e, t, n, r, u, i) => {
  const a = e === 0 && u === 0, o = e === 0 && u === i - 1, s = (e === t - 1 || r === t) && u === 0, c = (e === t - 1 || r === t) && u === i - 1;
  return U(ht.getElementClassName("cell"), {
    [ht.getElementClassName("alignCenter")]: r > 1,
    [ht.getElementClassName("cellBorderRadiusStartStart")]: a,
    [ht.getElementClassName("cellBorderRadiusEndStart")]: s,
    [ht.getElementClassName("cellBorderRadiusStartEnd")]: o,
    [ht.getElementClassName("cellBorderRadiusEndEnd")]: c,
    [ht.getElementClassName("cellBorderInlineEnd")]: u !== i - 1,
    [ht.getElementClassName("cellBorderBlockEnd")]: n + r !== t
  });
}, k$ = (e, t) => U(ht.getElementClassName("cell"), {
  [ht.getElementClassName("cellBorderRadiusStartStart")]: e === 0,
  [ht.getElementClassName("cellBorderRadiusEndStart")]: e === 0,
  [ht.getElementClassName("cellBorderRadiusStartEnd")]: e === t - 1,
  [ht.getElementClassName("cellBorderRadiusEndEnd")]: e === t - 1,
  [ht.getElementClassName("cellBorderInlineEnd")]: e !== t - 1
}), L$ = (e) => {
  var t;
  return ((t = e.content) == null ? void 0 : t.length) > 1;
}, D$ = (e) => e == null ? void 0 : e.reduce((t, n) => t + (n.rowSpan || 1), 0);
const Mg = "pre-hydrated", dH = "hydrated", N$ = (e) => (oe(() => {
  (() => {
    var n, r;
    (n = e.current) == null || n.classList.remove(Mg), (r = e.current) == null || r.classList.add(dH);
  })();
}, [e]), Mg);
export {
  Yl as $,
  SH as A,
  L6 as B,
  ye as C,
  HH as D,
  Wi as E,
  yn as F,
  jg as G,
  Uo as H,
  lR as I,
  _H as J,
  C6 as K,
  JP as L,
  s$ as M,
  jR as N,
  jr as O,
  Io as P,
  Ur as Q,
  gn as R,
  fO as S,
  Or as T,
  _$ as U,
  c4 as V,
  Kt as W,
  w4 as X,
  d4 as Y,
  Y6 as Z,
  BH as _,
  oH as a,
  BF as a$,
  Rr as a0,
  Lt as a1,
  Qc as a2,
  ut as a3,
  Da as a4,
  dr as a5,
  p9 as a6,
  IH as a7,
  c$ as a8,
  P6 as a9,
  v5 as aA,
  wH as aB,
  o$ as aC,
  r$ as aD,
  a$ as aE,
  w2 as aF,
  S$ as aG,
  W0 as aH,
  VH as aI,
  m$ as aJ,
  fB as aK,
  h$ as aL,
  AR as aM,
  xb as aN,
  gv as aO,
  TH as aP,
  xi as aQ,
  G6 as aR,
  a9 as aS,
  kH as aT,
  S2 as aU,
  u$ as aV,
  i$ as aW,
  t$ as aX,
  H6 as aY,
  d$ as aZ,
  Sn as a_,
  MB as aa,
  mk as ab,
  MH as ac,
  gk as ad,
  PH as ae,
  l$ as af,
  $6 as ag,
  ao as ah,
  Hg as ai,
  RH as aj,
  qa as ak,
  sr as al,
  Ua as am,
  e$ as an,
  p$ as ao,
  N6 as ap,
  ht as aq,
  lH as ar,
  L$ as as,
  hR as at,
  MF as au,
  T$ as av,
  k$ as aw,
  D$ as ax,
  A$ as ay,
  NF as az,
  sB as b,
  AH as b$,
  FF as b0,
  HF as b1,
  k4 as b2,
  T4 as b3,
  o0 as b4,
  f$ as b5,
  td as b6,
  sc as b7,
  jH as b8,
  zH as b9,
  C$ as bA,
  w$ as bB,
  E$ as bC,
  Ve as bD,
  xu as bE,
  an as bF,
  T2 as bG,
  ee as bH,
  FH as bI,
  ZH as bJ,
  WH as bK,
  L0 as bL,
  k0 as bM,
  Ke as bN,
  Go as bO,
  _I as bP,
  yI as bQ,
  $H as bR,
  Ge as bS,
  CP as bT,
  aI as bU,
  D0 as bV,
  g$ as bW,
  QR as bX,
  x6 as bY,
  cH as bZ,
  q6 as b_,
  UH as ba,
  nr as bb,
  y$ as bc,
  LF as bd,
  v$ as be,
  zR as bf,
  CH as bg,
  PR as bh,
  Uc as bi,
  x$ as bj,
  _3 as bk,
  QH as bl,
  JH as bm,
  XH as bn,
  Fc as bo,
  $t as bp,
  Be as bq,
  zr as br,
  Zn as bs,
  F as bt,
  qe as bu,
  Ks as bv,
  KH as bw,
  YH as bx,
  b$ as by,
  u4 as bz,
  T6 as c,
  zb as c0,
  Hi as c1,
  wt as c2,
  $i as c3,
  EH as c4,
  n$ as c5,
  KB as c6,
  N$ as c7,
  NH as c8,
  OH as c9,
  qH as ca,
  GH as cb,
  DH as cc,
  z0 as d,
  N4 as e,
  Bt as f,
  kr as g,
  q0 as h,
  Vr as i,
  _n as j,
  Rt as k,
  dN as l,
  pF as m,
  Cn as n,
  Qt as o,
  nd as p,
  Yo as q,
  Ko as r,
  nt as s,
  hr as t,
  Fu as u,
  Ht as v,
  yt as w,
  Qv as x,
  HP as y,
  id as z
};
//# sourceMappingURL=helpers-458d7e27.js.map
